// fix for W-4019705
var global = window; // add requires for external dependencies

var lodash = require('lodash/core');

var perfect_scrollbar = require('perfect-scrollbar');

var es6_promise = require('es6-promise');

var luxon = require('luxon');

var lodash_debounce = require('lodash/debounce'); // unused variable introduced to avoid a closure compiler bug triggered by luxon code
// if this definition is removed the closure compiler will crash in core


var months = null; // the output of the closure compiler

var EclairNG = function (lodash, luxon, debounce, es6Promise, Ps) {
  'use strict';

  var lodash__default = 'default' in lodash ? lodash['default'] : lodash;
  debounce = debounce && debounce.hasOwnProperty('default') ? debounce['default'] : debounce;
  Ps = Ps && Ps.hasOwnProperty('default') ? Ps['default'] : Ps;

  var DelegateInterface = function DelegateInterface() {};

  DelegateInterface.prototype.ready = function ready() {
    throw new Error("Not implemented.");
  }; // create a native renderer
  //
  // @param chart {Chart}: chart object
  // @param config {Object} config map passed to the chart
  // @param isLegend {Boolean} true if the renderer if for a legend widget
  // @return {Renderer} a native chart renderer, which conforms to the renderer API (see RendererInterface.js)


  DelegateInterface.prototype.getRenderer = function getRenderer(ref) {
    var chart = ref.chart;
    var config = ref.config;
    var isLegend = ref.isLegend;
    throw new Error("Not implemented.");
  }; // Load a json file (synchronous)
  // @return {Promise} a promise which gets resolved with the content of the file


  DelegateInterface.prototype.require = function require(fileName) {
    throw new Error("Not implemented.");
  }; //--------------------------------------------------------------------------------
  // font sizing
  //--------------------------------------------------------------------------------
  // compute width of text in pixels
  //
  // @param txt {String} text
  // @param size {Int, optional, default value 12} font size
  // @return {Number} width of text in pixels


  DelegateInterface.prototype.getTextWidth = function getTextWidth(txt, size) {
    if (size == null) {
      size = constants.FONT.SIZE;
    }

    throw new Error("Not implemented.");
  }; // Figure out if a text fits withing a certain width.
  //
  // @param txt {String} text
  // @param size {Int} size of text
  // @param maxWidth {Int} maximum width available to render the text
  // @return {String}:
  //   - if the text fits, it should return the original text.
  //   - otherwise, it returns the truncated text after having applied a truncation algorithm


  DelegateInterface.prototype.getTruncatedText = function getTruncatedText(txt, maxWidth, size) {
    if (size == null) {
      size = constants.FONT.SIZE;
    }

    throw new Error("Not implemented.");
  }; // return font size supported by native platform
  //
  // @param size {Int} font size requested
  // @return {Int} size supported by the native platform


  DelegateInterface.prototype.getRealFontSize = function getRealFontSize(size) {
    throw new Error("Not implemented.");
  }; //  __________________________________________________________
  // /|\            #                              /|\
  //  |             #                               |
  //  |             #                               |ascender
  //  |             #                               |
  //  |             #                       _______\|/__________
  //  |             #      ##### ##### #####
  //  |full (==1)   #      #   # #   # #   #
  //  |             #      #   # #   # #   #
  //  |             #      #   # #   # #   #
  //  |             ###### ##### ##### ##### ___________________
  //  |                                #          /|\
  //  |                                #           |
  //  |                                #           |descender
  //  |                                #           |
  // \|/_______________________________#__________\|/___________
  //
  // Specify the ascender and descender size in percentage of the entire font size
  // (assuming the full height is 1)
  //
  // @return {Object} with 2 keys: SIZE_ASCENDER, SIZE_DESCENDER


  DelegateInterface.prototype.fontInfo = function fontInfo() {
    throw new Error("Not implemented.");
  }; //
  //@flow-ignore


  var utils = {
    singleton: function singleton(classDef, init) {
      var instance = null;

      classDef.getInstance = function () {
        if (!instance) {
          instance = new classDef();

          if (init) {
            instance = init(instance);
          }
        }

        return instance;
      };

      return classDef;
    },
    mixin: function mixin(mixins, parent) {
      mixins.forEach(function (m) {
        return lodash__default.extend(parent.prototype, m);
      });
      return parent;
    }
  };
  var singleton = utils.singleton;
  var mixin = utils.mixin; // 
  //@flow-ignore
  //@flow-ignore

  var dataUtils = {
    /**
     *  Utils for manipulating data structures
     *  @author alice.chen, patrice
     */
    debounce: debounce,

    /**
     * Builds a map used as a set for the given values
     */
    setFromValues: function setFromValues(values) {
      if (!values) {
        return {};
      }

      var map = {};
      values.forEach(function (value) {
        return map[value] = value;
      });
      return map;
    },

    /**
     * intersection implementation that only works for primtive types such as string, number, etc ..
     * not objects
    */
    intersection: function intersection(listA, listB) {
      if (listA == null || listB == null) {
        return [];
      }

      var setA = this.setFromValues(listA);
      return listB.filter(function (value) {
        return setA[value] != null;
      });
    },

    /**
     * Returns a deep copy of json obj
     *
     * note: it only copies what's defined in JSON specs, not including undefined, so
     * deepCopy({a: undefined}) -> {}. Also a Date obj will turn into string.
     *
     * @param obj {Object} obj to be copied
     */
    deepCopy: function deepCopy(obj) {
      return obj ? JSON.parse(JSON.stringify(obj)) : obj;
    },

    /**
     * Check if two json objects are *equivalent*
     *
     * it's not lodash.isEqual, in terms that deepEqual({a: undefined}, {}) - true
     *
     */
    deepEqual: function deepEqual(obj, otherObj) {
      if (obj === otherObj) {
        return true;
      }

      return JSON.stringify(obj) === JSON.stringify(otherObj);
    },
    // Returns array of fields, convert single field to array
    //
    // @param fields {Array/Object} array of fields or a single field
    ensureArray: function ensureArray(fields) {
      if (!lodash__default.isArray(fields)) {
        return [fields];
      } else {
        return fields;
      }
    },

    /**
     * Deep version of lodash.extend. Its different from lodash.merge
     * in merging undefined value
     *
     * lodash.merge({a: 1}, {a: undefined}); // {}
     * extendDeep({a: 1}, {a: undefined}); // {a: 1}
     *
     * Create this version of extendDeep because it comes in handy
     * when we try to modify partial of config in tests, we can both
     * override a property and delete a property in one shot.
     */
    extendDeep: function extendDeep(obj) {
      var this$1 = this;
      var extendObjs = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        extendObjs[len] = arguments[len + 1];
      }

      extendObjs.forEach(function (extendObj) {
        for (var key in extendObj) {
          var extendVal = extendObj[key];
          var objVal = obj[key];

          if (this$1.isPlainObject(objVal) && this$1.isPlainObject(extendVal)) {
            this$1.extendDeep(objVal, extendVal);
          } else {
            obj[key] = extendVal;
          }
        }
      });
      return obj;
    },

    /**
     * Below are replacement methods for methods that are in lodash but not in lodash/core to keep our EclairNG.js small.
     */
    defaultsDeep: function defaultsDeep(config, defaultConfig) {
      var this$1 = this;
      lodash__default.keys(defaultConfig).forEach(function (key) {
        var configValue = config[key];
        var defaultConfigValue = defaultConfig[key];

        if (!lodash__default.has(config, key) || configValue === undefined) {
          config[key] = defaultConfigValue;
        } else if (this$1.isPlainObject(configValue) && this$1.isPlainObject(defaultConfigValue)) {
          this$1.defaultsDeep(configValue, defaultConfigValue);
        } else if (lodash__default.isArray(configValue) && lodash__default.isArray(defaultConfigValue)) {
          configValue.forEach(function (configValueInstance, i) {
            if (this$1.isPlainObject(configValueInstance) && this$1.isPlainObject(defaultConfigValue[i])) {
              this$1.defaultsDeep(configValueInstance, defaultConfigValue[i]);
            }
          });
        }
      });
      return config;
    },

    /**
     * Constructs and returns a new string which contains the specified number of copies of the string
     * on which it was called, concatenated together
     * IE 11 hasn't implement string repeat
     * @param  {number} count number of repeating string
     * @return {string}
     */
    repeat: function repeat(str, count) {
      return String.prototype.repeat ? str.repeat(count) : Array(count + 1).join(str);
    },
    isPlainObject: function isPlainObject(obj) {
      return lodash__default.isObject(obj) && !lodash__default.isArray(obj) && !lodash__default.isString(obj);
    },
    camelCase: function camelCase(str) {
      return str.replace(/\W+(.)/g, function (match, chr) {
        return chr.toUpperCase();
      });
    },
    difference: function difference(arr0, arr1) {
      var map = arr0.reduce(function (m, el) {
        m[el] = true;
        return m;
      }, {});
      arr1.forEach(function (el) {
        if (map[el]) {
          delete map[el];
        }
      });
      return Object.keys(map);
    },

    /**
     * Finding the difference between two sets (order not guarantee)
     * ex. setA [1, 2, 3], setB [3, 2, 4]
     * difference(setA, setB) // [1, 4]
     */
    notIntersect: function notIntersect(setA, setB) {
      var diff = [];
      lodash__default.keys(setA).forEach(function (it) {
        if (setB[it] == null) {
          diff.push(setA[it]);
        }
      });
      lodash__default.keys(setB).forEach(function (it) {
        if (setA[it] == null) {
          diff.push(setB[it]);
        }
      });
      return diff;
    },

    /**
     *  Replacement for lodash/uniq
     */
    uniq: function uniq(arr, keyFct) {
      if (!lodash__default.isArray(arr)) {
        return arr;
      } else {
        keyFct = keyFct || function (val) {
          return val;
        };

        var map = {};
        var res = [];
        arr.forEach(function (val) {
          // @flow-ignore
          var key = keyFct(val);

          if (map[key] === undefined) {
            map[key] = true;
            res.push(val);
          }
        });
        return res;
      }
    },

    /**
     *  Replacement for lodash/zip
     */
    zip: function zip() {
      var arrays = [],
          len = arguments.length;

      while (len--) {
        arrays[len] = arguments[len];
      }

      return arrays[0].map(function (ele, i) {
        return arrays.map(function (arr) {
          return arr[i];
        });
      });
    },

    /**
     *  Replacement for lodash/partition
     */
    partition: function partition(arr, predicate) {
      var truthy = [];
      var nonTruthy = [];
      arr.forEach(function (ele) {
        return predicate(ele) ? truthy.push(ele) : nonTruthy.push(ele);
      });
      return [truthy, nonTruthy];
    },

    /**
     *  Replacement for lodash/findIndex
     */
    findIndex: function findIndex(arr, predicate) {
      for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i])) {
          return i;
        }
      }

      return -1;
    },

    /**
     *  Replacement for lodash/countBy
     */
    countBy: function countBy(arr) {
      var res = {};
      arr.forEach(function (ele) {
        var count = res[ele];

        if (count !== undefined) {
          res[ele] = count + 1;
        } else {
          res[ele] = 1;
        }
      });
      return res;
    },

    /**
     *  Replacement for lodash/groupBy
     */
    groupBy: function groupBy(arr, keyFct) {
      var groups = {};
      arr.forEach(function (ele) {
        var key = keyFct(ele);
        var group = groups[key];

        if (!group) {
          group = groups[key] = [];
        }

        group.push(ele);
      });
      return groups;
    },

    /**
     *  Replacement for lodash/includes
     */
    includes: function includes(arr, value) {
      return arr.indexOf(value) !== -1;
    },

    /**
     *  Creates a range array with the given bounds
     *  eg:
     *
     *  Exclusive ranges:
     *     range(0, 2) => [0, 1]
     *     range(2, 0) => [1, 0]
     *
     *  Inclusive ranges:
     *     range(0, 2, true) => [0, 1, 2]
     *     range(2, 0, true) => [2, 1, 0]
     */
    range: function range(left, right, inclusive) {
      if (inclusive === void 0) inclusive = false;
      var range = [];
      var ascending = left < right;
      var end = !inclusive ? right : ascending ? right + 1 : right - 1;

      for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
      }

      return range;
    },

    /**
     *  Replacement for lodash/flow
     */
    flow: function flow(fcts) {
      return function () {
        var args = arguments;
        var res = undefined;

        for (var i = 0; i < fcts.length; i++) {
          res = fcts[i].apply(null, args);
          args = [res];
        }

        return res;
      };
    },

    /**
     * Given a sorted list of number, find the closest index to the target
     * ex. closestIndex([1, 5, 7, 8, 12], 4) = 1
     * @param list
     * @param target
     * @return the index of the closest item
     */
    closestIndex: function closestIndex(list, target) {
      if (!list.length) {
        return -1;
      }

      var h = 0,
          t = list.length - 1;

      while (h <= t) {
        var mid = h + (t - h >>> 1);
        var m = list[mid];

        if (m === target) {
          return mid;
        } else if (m < target) {
          h = mid + 1;
        } else {
          t = mid - 1;
        }
      }

      return t === -1 ? h : h === list.length ? t : Math.abs(target - list[t]) < Math.abs(target - list[h]) ? t : h;
    },

    /**
     * K-combinations (copied from https://gist.github.com/axelpale/3118596)
     *
     * Get k-sized combinations of elements in a set.
     *
     * Usage:
     *   k_combinations(set, k)
     *
     * Parameters:
     *   set: Array of objects of any type. They are treated as unique.
     *   k: size of combinations to search for.
     *
     * Return:
     *   Array of found combinations, size of a combination is k.
     *
     * Examples:
     *
     *   k_combinations([1, 2, 3], 1)
     *   -> [[1], [2], [3]]
     *
     *   k_combinations([1, 2, 3], 2)
     *   -> [[1,2], [1,3], [2, 3]
     *
     *   k_combinations([1, 2, 3], 3)
     *   -> [[1, 2, 3]]
     *
     *   k_combinations([1, 2, 3], 4)
     *   -> []
     *
     *   k_combinations([1, 2, 3], 0)
     *   -> []
     *
     *   k_combinations([1, 2, 3], -1)
     *   -> []
     *
     *   k_combinations([], 0)
     *   -> []
     */
    k_combinations: function k_combinations(set, k) {
      var this$1 = this;
      var i, j, combs, head, tailcombs; // There is no way to take e.g. sets of 5 elements from
      // a set of 4.

      if (k > set.length || k <= 0) {
        return [];
      } // K-sized set has only one K-sized subset.


      if (k == set.length) {
        return [set];
      } // There is N 1-sized subsets in a N-sized set.


      if (k == 1) {
        combs = [];

        for (i = 0; i < set.length; i++) {
          combs.push([set[i]]);
        }

        return combs;
      } // Assert {1 < k < set.length}
      // Algorithm description:
      // To get k-combinations of a set, we want to join each element
      // with all (k-1)-combinations of the other elements. The set of
      // these k-sized sets would be the desired result. However, as we
      // represent sets with lists, we need to take duplicates into
      // account. To avoid producing duplicates and also unnecessary
      // computing, we use the following approach: each element i
      // divides the list into three: the preceding elements, the
      // current element i, and the subsequent elements. For the first
      // element, the list of preceding elements is empty. For element i,
      // we compute the (k-1)-computations of the subsequent elements,
      // join each with the element i, and store the joined to the set of
      // computed k-combinations. We do not need to take the preceding
      // elements into account, because they have already been the i:th
      // element so they are already computed and stored. When the length
      // of the subsequent list drops below (k-1), we cannot find any
      // (k-1)-combs, hence the upper limit for the iteration:


      combs = [];

      for (i = 0; i < set.length - k + 1; i++) {
        // head is a list that includes only our current element.
        head = set.slice(i, i + 1); // We take smaller combinations from the subsequent elements

        tailcombs = this$1.k_combinations(set.slice(i + 1), k - 1); // For each (k-1)-combination we join it with the current
        // and store it to the set of k-combinations.

        for (j = 0; j < tailcombs.length; j++) {
          combs.push(head.concat(tailcombs[j]));
        }
      }

      return combs;
    },

    /**
     * Find the difference of two list of object identified with the key.
     * ex. differenceWithKey( [{key: 1}, {key: 2}], [{key: 1}, {key: 3}] ) = [{key: 2}]
     */
    differenceWithKey: function differenceWithKey(list1, list2) {
      if (!list2.length) {
        return list1;
      }

      var remainsKeySet = list2.reduce(function (map, it) {
        map[it.key] = true;
        return map;
      }, {});
      return list1.filter(function (it) {
        return !remainsKeySet.hasOwnProperty(it.key);
      });
    }
  }; //

  /**
   * Events exposed by the Chart object
   *
   * @see Chart
   */

  var ChartEvents = function ChartEvents() {};

  ChartEvents.RENDER_BEGIN = "renderBegin";
  ChartEvents.RENDER_END = "renderEnd";
  ChartEvents.RENDER_SKIPPED = "renderSkipped";
  ChartEvents.SELECTION_CHANGED = "selectionChanged";
  ChartEvents.SORT = "sort";
  ChartEvents.MOUSE_CLICK = "mouseClick";
  ChartEvents.MOUSE_LEAVE = "mouseLeave";
  ChartEvents.MOUSE_ENTER_HOTSPOT = "mouseEnterHotSpot";
  ChartEvents.MOUSE_LEAVE_HOTSPOT = "mouseLeaveHotSpot";
  ChartEvents.MOUSE_ENTER_SHAPE = "mouseEnterShape";
  ChartEvents.MOUSE_LEAVE_SHAPE = "mouseLeaveShape";
  ChartEvents.LEGEND_MOUSE_CLICK = "legend::mouseClick";
  ChartEvents.LEGEND_MOUSE_ENTER_HOTSPOT = "legend::mouseEnterHotSpot";
  ChartEvents.LEGEND_MOUSE_LEAVE_HOTSPOT = "legend::mouseLeaveHotSpot";
  ChartEvents.KEY_DOWN = "keyDown";
  ChartEvents.KEY_UP = "keyUp";
  ChartEvents.ERROR = "error"; //
  //@flow-ignore

  /**
   * Public API for Chart
   *
   */

  var Chart = function Chart(chart) {
    this._chart = chart;
  };
  /**
  	 * Removes the chart from the DOM
  	 */


  Chart.prototype.remove = function remove() {
    this._chart.remove();

    return this;
  };
  /**
  	 * Check whether the chart as been removed
  	 */


  Chart.prototype.isRemoved = function isRemoved() {
    return this._chart.isRemoved();
  };
  /**
  	 * Resizes the chart
  	 *
  	 * @param width the new width
  	 * @param height the new height
  	 * @param duration the duration of the resize animation in ms
  	 */


  Chart.prototype.resize = function resize(width, height, duration) {
    this._chart.resize(width, height, duration);
  };
  /**
  	 * Renders a chart
  	 *
  	 * @param moduleName the name of the chart module
  	 * @param config the chart's config
  	 * @param rows the chart's data rows
  	 * @param rowsMetadata the metadata for the rows
  	 * @param options the options
  	 * @param force whether to force a render even if nothing has changed
  	 * @return a Promise that resolves to the chart instance when the render is completed
  	 *
  	 * @example
   	 *chart.render("wave-charts/modules/sfdc-pie-chart", config, rows, rowsMetadata);
  	 */


  Chart.prototype.render = function render(moduleName, config, rows, rowsMetadata, options, force) {
    var this$1 = this;
    return this._chart.render(moduleName, config, rows, rowsMetadata, options, force).then(function () {
      return this$1;
    });
  };
  /**
  	 * Checks if the chart is in the client's viewport
  	 */


  Chart.prototype.isInViewport = function isInViewport() {
    return this._chart.isInViewport();
  };
  /**
  	 * This method allows you to force a chart out of the viewport
  	 * This enables the chart to not participate in the viewport monitoring sequence anymore
  	 * (say if you want to hide the chart, but not fully remove it, so you can bring it back quickly if needed)
  	 *
  	 * @param forceOutOfViewport true: the chart is considered to be out of the viewport (the chart won't render anymore), false: the regular (real) viewport is used (the chart renders if it is inside the visible window...)
  	 */


  Chart.prototype.forceOutOfViewport = function forceOutOfViewport(outOfViewport) {
    this._chart.forceOutOfViewport(outOfViewport);

    return this;
  };
  /**
  	 * Programmatically set the chart's selection(s)
  	 *
  	 * @param rows the rows to select
  	 * @param options
  	 * @param options.skipRender whether to skip rendering
  	 *
  	 * @example
  	 *  // clear all selections
  	 *chart.setSelection([]);
  	 *
  	 *  // select the "CA" row
   	 *chart.setSelection([{Region: "CA", profit: 10}]);
  	 */


  Chart.prototype.setSelection = function setSelection(rows, options) {
    this._chart.setSelection(rows, options);

    return this;
  };
  /**
  	 * Get the chart's selection
  
  	 * @return the selected rows
  	 */


  Chart.prototype.getSelection = function getSelection() {
    return this._chart.getSelection();
  };
  /**
  	 * Sets Chart annotations
  	 *
  	 * @example
  	 *chart.setAnnotations([{
  	 *    row: {Region: "CA", numOpps: 10},
  	 *	measure: "numOpps",
  	 *	properties: {
  	 *		backgroundColor: "#193f61"
  	 *		borderColor: "#193f61"
  	 *		column: ["Region", "sumAmount"]
  	 *		defaultShow: true
  	 *		isBlinking: false
  	 *		text: {}
  	 *	}
  	 *  });
  	 */


  Chart.prototype.setAnnotations = function setAnnotations(annotations) {
    this._chart.setAnnotations(annotations);

    return this;
  };
  /**
  	 * Get the annotations for the Chart
  	 *
  	 * @return the chart's annotations
  	 */


  Chart.prototype.getAnnotations = function getAnnotations() {
    return this._chart.getAnnotations();
  };
  /**
  	 * Registers a callback for an event on the chart
  	 */


  Chart.prototype.on = function on(event, callback) {
    var adapter = callbackAdapter(callback);
    callback.__adapter = adapter;

    this._chart.on(event, adapter);

    return this;
  };
  /**
  	 * Unregisters a callback for an event
  	 */


  Chart.prototype.off = function off(event, callback) {
    this._chart.off(event, callback ? callback.__adapter : null);

    return this;
  };

  Chart.prototype.startMouseInteraction = function startMouseInteraction() {
    this._chart.startMouseInteraction();

    return this;
  };

  Chart.prototype.stopMouseInteraction = function stopMouseInteraction() {
    this._chart.stopMouseInteraction();

    return this;
  };

  Chart.prototype.hideTooltip = function hideTooltip() {
    this._chart.hideTooltip();

    return this;
  };
  /**
  	 * Get the chart events
  	 */


  Chart.prototype.getEvents = function getEvents() {
    return ChartEvents;
  };
  /**
  	 * Used to access Chart functionality that has not yet been released
  	 * as part of the public api.
  	 *
  	 * @private
  	 */


  Chart.prototype.__getPrivateApi = function __getPrivateApi() {
    return this._chart;
  };
  /**
   * Adapts internal objects passed as event callback parameters so that they conform
   * to the public api
   *
   * @private
   */


  function callbackAdapter(callback) {
    return function (params) {
      if (lodash__default.isArray(params)) {
        callback(params);
        return;
      }

      params = lodash__default.extend({}, params);

      if (params.shape) {
        // only expose {key, data: {column, row}} for shape
        var info = params.shape.getInfo();
        params.shape = {
          key: params.shape.key,
          type: params.shape.getType()
        };

        if (info) {
          params.shape.data = dataUtils.deepCopy(info.data);
        }
      }

      if (params.hotSpot) {
        // only expose box: {x, y, w, h, rotation} for hotspot
        params.hotSpot = {
          box: lodash__default.pick(params.hotSpot.getInfo().box.toAABB(), ["x", "y", "w", "h", "rotation"])
        };
      }

      callback(params);
    };
  }

  var constants$1 = {
    // delimiter between dim values when creating a unique shape key based on groups
    // for instance, the shape for (carrier:UA, month:01) will have the key "UA||01"
    SHAPE_KEY_SEPARATOR: "||",
    // key to store extra internal fields on a row
    ROW_INTERNAL_KEY: "$$ROW_INTERNAL",
    // key for the series column in the rows
    SERIES_KEY: "__series__",
    // constant to specify null
    NULL_KEY: "$$null",
    // constant for the percentage info stored in row internal
    PERCENTAGE_INFO_KEY: "__%__",
    TIME_GRANULARITY: {
      MILLISECOND: "millisecond",
      SECOND: "second",
      MINUTE: "minute",
      HOUR: "hour",
      DAY: "day",
      WEEK: "week",
      SFDC_WEEK: "sfdcWeek",
      MONTH: "month",
      QUARTER: "quarter",
      YEAR: "year",
      WEEKYEAR: "weekYear"
    },
    COLUMN_TYPE: {
      DIMENSION: "dimension",
      MEASURE: "measure",
      TIME: "time",
      GEO: "geo"
    },
    TEXTURE: {
      FIT: {
        COVER: "cover",
        CONTAIN: "contain",
        FILL: "fill"
      }
    },
    ICON: {
      SIZE: 30,
      // icon size (assuming the icon fits in a square box)
      TEXT_PADDING: 4 // distance between the text and the icon

    },
    GEOMAP_TYPE: {
      CHOROPLETH: "choropleth",
      BUBBLE: "bubble",
      CLUSTER: "cluster",
      LATLNG: "latlng",
      HEATMAP: "heatmap"
    },
    MAPSOURCE_TYPE: {
      GEOJSON: "geojson",
      PRESET_BOUNDARIES: "preset_boundaries",
      GEOJSON_POINTS: "geojson_points",
      LATLNG: "Latlng"
    },
    CHART_LAYOUT: {
      COLOR_TYPE: {
        BINS: "bins",
        CATEGORICAL: "categorical",
        GRADIENT: "gradient",
        CONSTANT: "constant"
      },
      RADIUS_TYPE: {
        SQRT: "sqrt"
      },
      AXIS_TYPE: {
        NUMERIC: "numeric",
        TIME: "time",
        CATEGORICAL: "categorical"
      },
      CONSTANT: "constant"
    },
    CELL: {
      IGNORED_PATTERN: new RegExp('^\\*.*')
    },
    FORMAT: {
      PERCENT: {
        AXIS: ["#%", 1],
        // for normalizing the axis ticks
        MEASURE: ["#.##%", 1] // for normalizing the measure value (inside a bar or in the tooltip)

      }
    },
    SCALE: {
      LINEAR: "linear",
      SQRT: "sqrt"
    },
    SELECTMODE: {
      SINGLE: "single",
      SINGLE_REQUIRED: "singlerequired",
      MULTI: "multi",
      MULTI_REQUIRED: "multirequired",
      RANGE: 'range',
      NONE: "none"
    },
    VALUETYPE: {
      COMPACT_NUMBER: "compactNumber",
      NUMBER: "number",
      PERCENT: "percent",
      NONE: "none"
    },
    CENTER_VALUE_TYPE: {
      NONE: "none",
      NUMBER: "number",
      COMPACT_NUMBER: "compactNumber",
      TEXT: "text"
    },
    SELECT_ACTION: {
      SELECT: "select",
      SELECT_EXCLUSIVE: "selectExclusive",
      UNSELECT: "unselect",
      RESET: "reset"
    },
    SELECT_STATE: {
      NONE: 0,
      TRUE: 1,
      FALSE: 2
    },
    HOVER_STATE: {
      NONE: 0,
      TRUE: 1,
      FALSE: 2
    },
    AUTOFIT_MODE: {
      FIT: "fit",
      KEEP_LABELS: "keepLabels",
      SCROLL: "scroll"
    },
    AXIS_MODE: {
      SYNC: "sync",
      DUAL: "dual",
      MULTI: "multi"
    },
    CELL_RENDERER_TYPE: {
      DIMENSION: "dimension",
      TIME: "time",
      MEASURE: "measure",
      TITLE: "title"
    },
    CHART_MODE: {
      CLUSTER: "cluster",
      STACK: "stack"
    },
    MARK_TYPE: {
      BAR: "bar",
      LINE: "line",
      DOT: "dot"
    },
    MISSING_VALUE: {
      CONNECT: "connect",
      DISCONNECT: "disconnect",
      CUMULATIVE: "cumulative",
      CUMULATIVE_UNTIL_LAST_DATA: "cumulativeUntilLastData"
    },
    ROWS_LAYOUT: {
      TABULAR: "tabular"
    },
    TITLE: {
      DEFAULT_FONT_SIZE: 14,
      DEFAULT_SUBTITLE_FONT_SIZE: 11,
      DEFAULT_ALIGN: "left",
      PADDING_BETWEEN_SUBTITLE: 12,
      PADDING_BOTTOM: 16
    },
    MIN_FONT_SIZE: 10,
    TEXT_SIZE: 12,
    PADDING: 5,
    CELL_PADDING: 5,
    SPACER: 1,
    MARK: {
      LINE: {
        LINE_WIDTH: 2,
        POINT_RADIUS: 3,
        LABEL_SIZE: 26,
        TIME_POINT_RADIUS: 3,
        MIN_LINE_WIDTH: 1,
        MIN_POINT_RADIUS: 0,
        MIN_LABEL_SIZE: 10,
        FILL_AREA_OPACITY: 0.1
      },
      BAR: {
        SIZE: 25,
        SPACER: 1,
        MIN_SIZE: 1,
        MIN_SPACER: 0,
        MAX_WIDTH: 110,
        TEXT_PADDING: 2,
        TEXT_SIZE: 12
      },
      POINT: {
        RADIUS: 8,
        MIN_RADIUS: 2,
        MAX_RADIUS: 45,
        MIN_RATIO: 0.1,
        MAX_RATIO: 10
      },
      DOT: {
        OPACITY_POS_VALUE: 0.7,
        OPACITY_NEG_VALUE: 0.1
      },
      PIE: {
        INNER_RADIUS_PERCENT: 70
      },
      POLAR_GAUGE: {
        INNER_RADIUS_PERCENT: 80,
        TRACK_OPACITY: 0.5
      },
      SPARKLINE: {
        LABEL_WIDTH: 50
      },
      GAUGE: {
        INNER_RADIUS_PERCENT: 90,
        ANGLE: 180,
        MIN_ANGLE: 90,
        MAX_ANGLE: 270,
        MIN_LABEL_SIZE: 5
      }
    },
    AXIS: {
      NUM: {
        TICKMARK: {
          HORI_DISTANCE: 100,
          VERTI_DISTANCE: 50,
          MIN_DISTANCE: 40
        },
        TICKLABEL: {
          PADDING: 5
        },
        TITLE: {
          HEIGHT: 20
        },
        X: {
          HEIGHT: 20
        },
        Y: {
          WIDTH: 40,
          PADDING: 10
        }
      },
      LABELS: {
        MIN_COLUMN_SIZE: 30,
        PADDING: {
          WIDE: 5,
          SMALL: 2
        },
        LAYOUT: {
          NORMAL: "normal",
          ORTHOGONAL: "orthogonal",
          SLANTED: "slanted",
          HIDDEN: "hidden"
        },
        TEXT: {
          SIZE: 12,
          HALIGN: "right"
        },
        TITLE: {
          HEIGHT: 20,
          SEPARATOR: " > ",
          PADDING: {
            HORIZONTAL: 2,
            VERTICAL: 4
          }
        }
      },
      TIME: {
        TITLE: {
          HEIGHT: 20
        },
        FORMATS: {
          millisecond: 'SSS',
          second: 'ss',
          minute: 'mm',
          hour: 'h a',
          day: 'dd',
          week: "'W'W",
          sfdcWeek: 'sfdcWeek',
          month: 'MMM',
          quarter: "'Q'q",
          year: 'yyyy',
          weekYear: 'kkkk'
        }
      }
    },
    TRELLIS: {
      HEADER: {
        HEIGHT: 40,
        WIDTH: 40,
        WRAP: 27
      },
      DEFAULT_SIZE: [200, 200],
      CELL_PADDING: 30,
      CELL_PADDING_WRAP: 25,
      CHARTS_PER_LINE: 3,
      MAX_NUM_CELLS: 100
    },
    SMALL_MULTIPLE: {
      CELL_PADDING: 20
    },
    TREEMAP: {
      CELL_PADDING: 5
    },
    ORDER: {
      ASC: "asc",
      DESC: "desc"
    },
    LEGEND: {
      MIN_PADDING: 0,
      VPAD: 5,
      HPAD: 5,
      PADDING: 10,
      POSITION: "right-top",
      TEXT: {
        // text used in header
        SIZE: 12
      }
    },
    SORT: {
      TYPE: {
        ROWS: "rows",
        VALUES: "values"
      },
      ORDER: {
        ASC: "asc",
        DESC: "desc"
      }
    },
    GRADIENT_LEGEND: {
      GRADIENT: {
        WIDTH: 12,
        MIN_WIDTH: 12,
        MIN_RATIO: 2
      },
      TEXT: {
        PADDING: 5
      }
    },
    COLOR_LEGEND: {
      SWATCH: {
        PADDING: 10,
        SIZE: 12
      }
    },
    RADIAL_LEGEND: {
      MIN_RADIUS: 13,
      BORDER: {
        WIDTH: 1
      },
      TEXT: {
        SIZE: 12,
        PADDING: 12
      }
    },
    HOTSPOT: {
      COLOR: "#ffffff",
      HOVER_COLOR: "#ffffff",
      BG_COLOR: "#6b7273",
      HOVER_BG_COLOR: "#6b7273"
    },
    ANIM_DURATION: {
      // the following durations can be set in the chart constructor
      DEFAULT: 1000,
      // duration when tweening from one set of values to another
      RESIZE_DEBOUNCE: 100,
      // debounce duration for resize
      // the following durations can not be changed
      CROSSHAIR: 50,
      HOVER: 0,
      // duration before showing the hover effect
      TAB: 1,
      // duration to render the tab effect
      ONDEMAND_RENDER: 100,
      // active polling for ondemand rendering
      IMAGE_LOADING_REDRAW: 100 // debounce time for when a view needs to redraw after an image used by this view has finished loading

    },
    TOOLTIP: {
      LINE_TYPE: {
        // each tooltip line will have a specific type
        MEASURE: "measure",
        DIMENSION: "dimension",
        PERCENT: "percent"
      },
      DELAY: {
        SHOW: 300,
        // duration before showing a tooltip
        HIDE: 100 // duration before hiding a tooltip (this gives us a chance to move to a different shape without clearing the toopltip)

      }
    },
    CANVAS: {
      NO_EVENT_DURATION: 500
    },
    COLOR_TYPE: {
      SIMPLE_COLOR: "simpleColor",
      LINEAR_GRADIENT: "linearGradient"
    },
    ACCESSIBILITY: {
      TYPE: {
        CAPTION: "caption",
        DATA: "captionData"
      },
      CELL_TYPE: {
        DIMENSION: "dimension",
        MEASURE: "measure"
      },
      CAPTION_KEY: {
        TITLE: "Title",
        SUBTITLE: "Subtitle",
        DIMENSION_AXIS_TITLE: "Dimension Axis Title",
        MEASURE_AXIS_TITLE: "Measure Axis Title",
        THEME_NAME: "Theme Name",
        REFERENCE_LINE: "Reference Line",
        ERROR: "Error",
        MAP_NAME: "Map Name",
        BREAKPOINTS: "Gauge Break Points",
        TOTAL: "Total"
      },
      ID_SEPARATOR: "$%.",
      INACTIVE_WAIT: 500 // Wait for 'INACTIVE_WAIT' ms to disable the accessibility features

    },
    PATCH: {
      INSERT: "insert",
      UPDATE: "update",
      REMOVE: "remove"
    },
    BRUSH: {
      CONTROL_POINT_LAYOUT: {
        HORIZONTAL: 'horizontal',
        VERTICAL: 'vertical'
      },
      CONTROL_POINT_SIZE: 7,
      LAYER_TYPE: {
        DEFAULT: 'default',
        TIME: 'time'
      }
    },
    CURSOR_TYPE: {
      DEFAULT: 'default',
      EW_RESIZE: 'ew-resize',
      NS_RESIZE: 'ns-resize',
      MOVE: 'move',
      POINTER: 'pointer'
    },
    OPTIMIZATION: {
      MEASURE_LABEL_SIZE: 10
    },
    DECORATION_LAYER_TYPE: {
      CROSSHAIR: 'crosshair',
      DISCRETE_CROSSHAIR: 'discreetCrosshair',
      TIME_CROSSHAIR: 'timeCrosshair'
    },
    INTERACTION_DELEGATE_TYPE: {
      ANNOTATION: 'annotation',
      BRUSH: 'brush',
      CENTER: 'center',
      CROSSHAIR: 'crosshair',
      CURSOR: 'cursor',
      CUSTOM: 'custom',
      DISCRETE_CROSSHAIR: 'discreteCrosshair',
      EVENT: 'event',
      HIGHLIGHT: 'highlight',
      RANGE: 'range',
      SELECTION: 'selection',
      TIME_CROSSHAIR: 'timeCrosshair',
      TOOLTIP: 'tooltip'
    },
    INTERACTION_TYPE: {
      ANNOTATION: 'annotation',
      COMMON: 'common',
      DIMENSION_CROSSHAIR: 'dimensionCrosshair',
      CUSTOM: 'custom',
      HIGHLIGHT: 'highlight',
      RANGE_SELECTION: 'rangeSelection',
      SELECTION: 'selection',
      SINGLE_SELECTION: 'singleSelection',
      TAB: 'tab',
      TIME_CROSSHAIR: 'timeCrosshair',
      MULTI_SELECTION: 'multiSelection'
    },
    TRANSFORM: {
      ROTATE: 'rotate',
      FLIP_X: 'flipX',
      FLIP_Y: 'flipY'
    },
    SCORER_TYPE: {
      TRELLIS: "trellis",
      COLOR: "color",
      AXIS: "axis",
      CONTEXT: "context",
      POPULARITY: "popularity"
    },
    FEATURE_NAME: {
      TRELLIS: "trellis",
      CATEGORICAL_COLOR: "categorical_color",
      GRADIENT_COLOR: "gradient_color",
      BIN_COLOR: "bin_color",
      X_TIME_AXIS: "x_time_axis",
      Y_TIME_AXIS: "y_time_axis",
      X_DIMENSION_AXIS: "x_dimension_axis",
      X_MEASURE_AXIS: "x_measure_axis",
      Y_DIMENSION_AXIS: "y_dimension_axis",
      Y_MEASURE_AXIS: "y_measure_axis",
      MULTI_METRIC: "multi_metric",
      SINGLE_METRIC: "single_metric",
      GEO_DATA: "geo_data",
      LAT_LNG: "lat_lng",
      FLOW_DIAGRAM: "flow_diagram",
      POPULARITY: "popularity"
    },
    UPDATE_STATE: {
      UPDATED: "updated",
      MODIFIED: "modified"
    },
    KEYBOARD_KEY: {
      TAB: "Tab",
      ENTER: "Enter",
      SHIFT: "Shift"
    },
    RENDER_STATUS: {
      OK: "ok",
      SKIPPED: "skipped"
    },
    RENDER_TYPE: {
      UPDATE: "update",
      INTERACTION: "interaction"
    },
    EVENT_NAME: ChartEvents,
    UNDOCUMENTED_EVENTS: {
      LEGACY_SELECTION_CHANGED: "legacySelectionChanged",
      PERF_READY: "perfReady",
      MOUSE_UP: "mouseUp",
      MOUSE_DOWN: "mouseDown",
      MOUSE_MOVE: "mouseMove"
    }
  }; //-ignore

  /*::(x: BaseNode<*,*>) => (x: IBaseNode<*,*,*>)*/

  var BaseNode = function BaseNode(key) {
    this.key = key;
    this._parent = null;
    this._children = [];
    this._childByKey = {};
    this._updateState = constants$1.UPDATE_STATE.MODIFIED;
  };

  BaseNode.prototype.getKey = function getKey() {
    return this.key;
  };
  /**
  	 * Update current key
  	 *
  	 * @param {string} key the new key to update to
  	 */


  BaseNode.prototype._updateKey = function _updateKey(key) {
    var oldKey = this.key;
    var parent = this.getParent();

    if (parent) {
      if (parent.getChildByKey(key)) {
        console.warn("key: " + key + " already exist among parent: " + parent.getKey() + "'s children, can not update key");
        return this;
      } else {
        parent.onChildKeyChange(oldKey, key);
      }
    }

    this.key = key;
    return this;
  };

  BaseNode.prototype.setUpdateState = function setUpdateState(state) {
    this._updateState = state;
    return this;
  };

  BaseNode.prototype.getUpdateState = function getUpdateState() {
    return this._updateState;
  };

  BaseNode.prototype.markAsModified = function markAsModified() {
    this.setUpdateState(constants$1.UPDATE_STATE.MODIFIED);
    var parent = this.getParent();

    if (parent) {
      parent.markAsModified(constants$1.UPDATE_STATE.MODIFIED);
    }

    return this;
  }; //--------------------------------------------------------------------------------
  // parent management
  //--------------------------------------------------------------------------------


  BaseNode.prototype.appendTo = function appendTo(parent) {
    if (parent) {
      parent.append(this);
    }

    return this;
  };

  BaseNode.prototype.prependTo = function prependTo(parent) {
    if (parent) {
      parent.prepend(this);
    }

    return this;
  };

  BaseNode.prototype.removeFromParent = function removeFromParent() {
    if (this._parent) {
      this._parent.remove(this);
    }

    return this;
  };

  BaseNode.prototype._setParent = function _setParent(_parent) {
    this._parent = _parent;
    return this;
  };

  BaseNode.prototype.getParent = function getParent() {
    return this._parent;
  };

  BaseNode.prototype.onChildKeyChange = function onChildKeyChange(oldKey, newKey) {
    var child = this._childByKey[oldKey];

    if (child) {
      delete this._childByKey[oldKey];
      this._childByKey[newKey] = child;
    }

    return this;
  }; //--------------------------------------------------------------------------------
  // child management
  //--------------------------------------------------------------------------------


  BaseNode.prototype.appendAll = function appendAll(children) {
    var this$1 = this;

    if (!children) {
      return this;
    }

    children.forEach(function (c) {
      this$1.append(c);
    });
    return this;
  }; // @perf-optimized


  BaseNode.prototype.append = function append(child) {
    if (!child) {
      return this;
    }

    this.markAsModified();
    var key = child.getKey();
    var thisChildByKey = this._childByKey;

    if (thisChildByKey[key]) {
      console.warn("key: " + child.getKey() + " already exist among parent: " + this.key + "'s children, can not append");
    } else {
      child.removeFromParent();

      this._children.push(child);

      child._setParent(this);

      thisChildByKey[key] = child;
    }

    return this;
  };

  BaseNode.prototype.prependAll = function prependAll(children) {
    var this$1 = this;

    if (!children) {
      return this;
    }

    this.markAsModified();
    children.forEach(function (c) {
      this$1.prepend(c);
    });
    return this;
  };

  BaseNode.prototype.prepend = function prepend(child) {
    if (!child) {
      return this;
    }

    this.markAsModified();

    if (this._childByKey[child.getKey()]) {
      console.warn("key: " + child.getKey() + " already exist among parent: " + this.key + "'s children, can not prepend");
    } else {
      child.removeFromParent();

      this._children.unshift(child);

      child._setParent(this);

      this._childByKey[child.getKey()] = child;
    }

    return this;
  };

  BaseNode.prototype.remove = function remove(child) {
    if (!child) {
      return this;
    }

    this.markAsModified();
    var key = child.getKey();
    var index = dataUtils.findIndex(this._children, function (row) {
      return row['key'] === key;
    });

    if (index > -1) {
      child._setParent(null);

      this._children.splice(index, 1);

      delete this._childByKey[key];
    }

    return this;
  };

  BaseNode.prototype.removeAll = function removeAll() {
    this.markAsModified();

    this._children.forEach(function (child) {
      return child._setParent(undefined);
    });

    this._children = [];
    this._childByKey = {};
    return this;
  };

  BaseNode.prototype._setChildren = function _setChildren(children) {
    var this$1 = this;
    var keyMap = children.reduce(function (map, child) {
      child._parent = this$1;
      map[child.key] = child;
      return map;
    }, {});
    this._childByKey = keyMap;
    this._children = children;
    return this;
  };

  BaseNode.prototype.getChildren = function getChildren() {
    return this._children;
  };

  BaseNode.prototype.getChildByKey = function getChildByKey(key) {
    return this._childByKey[key];
  }; // reverse children order


  BaseNode.prototype.reverse = function reverse() {
    this._children.reverse();

    return this;
  };

  BaseNode.prototype._sortChildren = function _sortChildren() {
    if (this._childSorter) {
      this._children = lodash__default.sortBy(this._children, this._childSorter);
    }

    this._children.forEach(function (child) {
      if (typeof child._sortChildren === "function") {
        child._sortChildren();
      }
    });

    return this;
  };

  BaseNode.prototype._sortByKeys = function _sortByKeys(sortedKeys) {
    var this$1 = this;
    this._children = [];
    sortedKeys.forEach(function (key) {
      var child = this$1._childByKey[key];
      child && this$1._children.push(child);
    });
    return this;
  }; // Does a recursive traversal (depth first) of all the nodes involved in the parent/child graph
  // and executes the callback function on each node.
  //
  // @param callback {Function(node)} function to call on each node


  BaseNode.prototype.traverse = function traverse(callback) {
    callback(this);

    this._children.forEach(function (child) {
      return child.traverse(callback);
    });

    return this;
  }; // Update all the children of the current node.
  // It will traverse all the chidlren (in order) and call the updateFct on each child.
  // It allows you to also update the key of each child. It will relink all the children properly.
  //
  // @param {Function(child<Node>, index<Int>):<void>} updateFct a function called on every child


  BaseNode.prototype.updateChildren = function updateChildren(updateFct) {
    var childByKey = {};

    this._children.forEach(function (child, i) {
      updateFct(child, i);
      childByKey[child.getKey()] = child;
    });

    this._childByKey = childByKey;
    return this;
  }; //
  //@flow-ignore


  var flatten$1 = lodash__default.flatten;
  var isArray = lodash__default.isArray;
  /**
   * Apply an operation to a node or an array of nodes
   * @param {*} node
   * @param {*} operation
   */

  function apply(node, operation) {
    if (!node) {
      return null;
    } else if (isArray(node)) {
      return node.map(operation);
    } else {
      return operation(node);
    }
  }

  var utils$2 = {
    /**
     * Get the list of children of a given node. If the node is a ShapeGroup, join with its children
     * @param {*} node
     */
    _getFlattenChildren: function _getFlattenChildren(node) {
      var children = node && node.getChildren();

      if (!children) {
        return [];
      }

      return flatten$1(children.map(function (child) {
        return child.getType() === 'ShapeGroup' ? child.getChildren() : child;
      }));
    },

    /**
     * Update the render model with a new scene
     * @param {*} modelNode
     * @param {*} sceneNode
     * @param {*} ctx
     * @param {*} patcher
     */
    update: function update(modelNode, sceneNode, ctx, patcher, viewport) {
      var this$1 = this;

      if (!modelNode && !sceneNode) {
        return [];
      } //------------------------------------------------------------
      // Get the total offset (including scroll) of the curren node
      //------------------------------------------------------------


      var offsetX = 0,
          offsetY = 0;

      if (sceneNode && sceneNode.isGroup()) {
        var assign;
        assign = sceneNode.totalTranslation(true, true), offsetX = assign[0], offsetY = assign[1];
      } else {
        offsetX = ctx.offsetX;
        offsetY = ctx.offsetY;
      } //------------------------------------------------------------
      // recursively traverse all the children and get the models
      //------------------------------------------------------------


      var remains = this._getFlattenChildren(sceneNode);

      var removes = dataUtils.differenceWithKey(modelNode && modelNode.getChildren() || [], remains);
      var nonRemovedChildren = remains.map(function (child) {
        var modelChild = modelNode && modelNode.getChildByKey(child.key);
        ctx.oldParent = modelNode;
        ctx.newParent = sceneNode;
        ctx.offsetX = offsetX;
        ctx.offsetY = offsetY;
        return this$1.update(modelChild, child, ctx, patcher, viewport);
      }).filter(function (x) {
        return x;
      });
      var removedChildren = removes.map(function (child) {
        ctx.oldParent = modelNode;
        ctx.newParent = sceneNode;
        ctx.offsetX = offsetX;
        ctx.offsetY = offsetY;
        return this$1.update(child, null, ctx, patcher, viewport);
      }).filter(function (x) {
        return x;
      }); //------------------------------------------------------------
      // test the visibility with the viewport
      //------------------------------------------------------------

      var childModels = flatten$1(removedChildren.concat(nonRemovedChildren));
      var hasChildren = childModels.length > 0;
      var isSceneNodeVisible = sceneNode && sceneNode.isGroup() ? true : this._isNodeVisible(sceneNode, viewport, offsetX, offsetY);
      var node;

      if (isSceneNodeVisible && !modelNode) {
        // If the node is Visible and was not visible
        node = apply(sceneNode.toModel(null, false, !hasChildren), function (model) {
          return patcher.insert(model, ctx);
        });
      } else if (!isSceneNodeVisible && modelNode) {
        // If the node was visible and is not visible
        node = patcher.remove(modelNode, ctx);
      } else if (!isSceneNodeVisible && !modelNode) {
        // If the node is not visible and was not visible
        node = null;
      } else {
        // If the node is visible and was visible
        node = sceneNode.getUpdateState() === constants$1.UPDATE_STATE.MODIFIED ? apply(sceneNode.toModel(null, false, !hasChildren), function (model) {
          return patcher.update(modelNode, model);
        }) : modelNode;
      }

      apply(sceneNode, function (n) {
        return n.setUpdateState(constants$1.UPDATE_STATE.UPDATED);
      });
      return isArray(node) ? node : node ? node._setChildren(childModels) : null;
    },
    _isNodeVisible: function _isNodeVisible(sceneNode, viewport, offsetX, offsetY) {
      if (sceneNode) {
        if (!sceneNode.isVisible()) {
          return false;
        } else if (viewport) {
          var bbox = sceneNode.boundingBox();

          if (bbox) {
            return viewport.intersect(bbox.x + offsetX, bbox.y + offsetY, bbox.w, bbox.h);
          }
        } else {
          return true;
        }
      }

      return false;
    },
    // take a model and an array of keys and return the deeply nested node
    // @param model {BaseNode}
    // @param fullKeys {Array<String>}
    getModelNode: function getModelNode(model, fullKeys) {
      if (model) {
        var currentModel = model;
        fullKeys.forEach(function (key) {
          if (currentModel) {
            currentModel = currentModel.getChildByKey(key);

            if (!currentModel) {
              console.debug("utils:getModelNode: can't find child with key", key, "fullkey", fullKeys);
              currentModel = null;
            }
          }
        });
        return currentModel;
      }

      return model;
    }
  }; //

  /*::(x: NodeModel<*>) => (x: INodeModel<*>)*/

  var NodeModel = function (BaseNod____1) {
    function NodeModel(props, tweens) {
      BaseNod____1.call(this, props.key);
      this.props = props;
      this.tweens = tweens;
    }

    if (BaseNod____1) NodeModel.__proto__ = BaseNod____1;
    NodeModel.prototype = Object.create(BaseNod____1 && BaseNod____1.prototype);
    NodeModel.prototype.constructor = NodeModel;

    NodeModel.getPatcher = function getPatcher() {
      return this._patcher;
    }; // Takes two NodeModel, diff and patch the first node in comparison to the second
    //
    // @param model0 {Object} node update from
    // @param model1 {Object} node update to


    NodeModel.update = function update(model0, model1, viewport, options) {
      var ref = options || {};
      var disableMorphing = ref.disableMorphing;
      if (disableMorphing === void 0) disableMorphing = false;
      var models = utils$2.update(model0, model1, {
        disableMorphing: disableMorphing,
        oldParent: null,
        newParent: null,
        offsetX: 0,
        offsetY: 0
      }, this.getPatcher(), viewport);
      return Array.isArray(models) ? models[0] : models;
    };

    NodeModel.prototype.hasAnimatePathInfo = function hasAnimatePathInfo() {
      //@flow-ignore
      return (this.props.animate_points_x && this.props.animate_points_y) != null;
    };

    NodeModel.prototype.getProps = function getProps() {
      return this.props;
    };

    NodeModel.prototype.getStartValue = function getStartValue(prop) {
      return this._getValue(prop, true);
    };

    NodeModel.prototype.getEndValue = function getEndValue(prop) {
      return this._getValue(prop, false);
    };

    NodeModel.prototype._getValue = function _getValue(prop, isStart) {
      if (isStart === void 0) isStart = true;
      var propValue = this.props[prop];
      var tween = this.tweens && this.tweens[prop];

      if (tween) {
        if (isStart) {
          return tween[0];
        } else {
          return tween[1];
        }
      } else {
        return propValue;
      }
    };

    NodeModel.prototype.tween = function tween(startProps, endProps) {
      return this;
    };

    NodeModel.prototype.tweenInsert = function tweenInsert(ctx) {
      return this;
    };

    NodeModel.prototype.tweenRemove = function tweenRemove(ctx) {
      return this;
    };

    NodeModel.prototype.tweenUpdate = function tweenUpdate(model1) {
      return this;
    }; // Returns a deep copy of the current node without parent
    //
    // @param withChildren {Boolean} if to clone children as well


    NodeModel.prototype.clone = function clone() {
      return this.constructor.fromJson(this.toJson(), false);
    };

    NodeModel.prototype.toJson = function toJson() {
      return {
        key: this.key,
        props: this.props
      };
    };

    NodeModel.fromJson = function fromJson(json, deepCopy) {
      if (deepCopy === void 0) deepCopy = true;

      if (deepCopy) {
        json = dataUtils.deepCopy(json);
      }

      var node = new this(json.props);
      return node;
    };

    return NodeModel;
  }(BaseNode);

  NodeModel._patcher = {
    remove: function remove(modelNode, ctx) {
      return modelNode.tweenRemove(ctx);
    },
    insert: function insert(modelNode, ctx) {
      return modelNode.tweenInsert(ctx);
    },
    update: function update(modelNode0, modelNode1, ctx) {
      return modelNode0.tweenUpdate(modelNode1);
    }
  };
  var DIST_TOLERANCE = 0.1;

  var LinearScale = function LinearScale() {
    this.scale = this.scale.bind(this);
    this._domain = [0, 1]; // [x0, x1]

    this._range = [0, 1]; // [y0, y1]

    this._dx = 1;
    this._dy = 1;
    this._kx = 1; // 1 / (x1 - x0)

    this._ky = 1; // (x1 - x0) / (y1 - y0)

    this._step = 0;
  };

  LinearScale.prototype.create = function create() {
    return new LinearScale();
  };

  LinearScale.prototype.scale = function scale(x) {
    x = (x - this._domain[0]) * this._kx;
    return this._range[0] + this._dy * x;
  };

  LinearScale.prototype.invert = function invert(y) {
    return (y - this._range[0]) * this._ky + this._domain[0];
  };

  LinearScale.prototype.domain = function domain(domain$1) {
    if (domain$1 == null) {
      return this._domain;
    }

    this._domain = domain$1;
    this._domain[0] = +this._domain[0];
    this._domain[1] = +this._domain[1];
    this._dx = this._domain[1] - this._domain[0];
    this._kx = this._dx ? 1 / this._dx : 0;
    this._ky = this._dy ? this._dx / this._dy : 0;
    return this;
  };

  LinearScale.prototype.range = function range(range$1) {
    if (range$1 == null) {
      return this._range;
    }

    this._range = range$1;
    this._dy = this._range[1] - this._range[0];
    this._ky = this._dy ? this._dx / this._dy : 0;
    return this;
  };

  LinearScale.prototype.step = function step(step$1) {
    if (step$1 == null) {
      return this._step;
    }

    this._step = step$1;
    return this;
  }; // given a start and stop and the number of ticks we would like to divide the span
  //  we try to find the step interval that is closest to the ends and tries to respect the count.
  // but since we try to choose a pretty number eg 10, 20 etc instead of 12, 13 etc, the count will not be exact but more of a reference


  LinearScale.prototype._tickStep = function _tickStep(start, stop, count, force, toNice) {
    if (force === void 0) force = true;
    if (toNice === void 0) toNice = true;
    var step = this._step;

    if (force || !step) {
      var span = stop - start;
      step = Math.pow(10, Math.floor(Math.log(span / count) / Math.LN10)); // if the span is 60, and count is 2,
      // roundStep would be 30 and step would be 50 (since step tries to favor steps with factor of 2, 5, 10)

      var err = count / (span / step);
      var roundStep = step * Math.round(span / step / count);

      if (err < .15) {
        step *= 10;
      } else if (err <= 0.35) {
        step *= 5;
      } else if (err < 0.75) {
        step *= 2;
      }

      var roundOverflow, factorOverflow, roundTicks;

      if (toNice) {
        roundOverflow = Math.ceil(stop / roundStep) * roundStep - Math.floor(start / roundStep) * roundStep - span;
        roundTicks = (roundOverflow + span) / roundStep;
        factorOverflow = Math.ceil(stop / step) * step - Math.floor(start / step) * step - span;
      } else {
        roundOverflow = span - Math.floor(stop / roundStep) * roundStep + Math.ceil(start / roundStep) * roundStep;
        roundTicks = (span - roundOverflow) / roundStep;
        factorOverflow = span - Math.floor(stop / step) * step + Math.ceil(start / step) * step;
      } // now that we have the 2 steps, we try to evaluate which of the 2 is more efficient and reduce extra expansion of domain


      if (roundOverflow <= factorOverflow && roundTicks - count < 3) {
        step = roundStep;
      }
    }

    return step;
  };

  LinearScale.prototype._tickRange = function _tickRange(start, stop, step) {
    if (arguments.length === 1) {
      stop = start;
      start = 0;
    }

    if (step === undefined) {
      step = 1;
    }

    var i = -1;
    var j;
    var ticks = [];

    if (step < 0) {
      while ((j = start + step * ++i) > stop) {
        ticks.push(j);
      }
    } else {
      while ((j = start + step * ++i) < stop) {
        ticks.push(j);
      }
    }

    return ticks;
  };

  LinearScale.prototype.ticks = function ticks(count, force) {
    if (force === void 0) force = false;
    count = Math.max(count, 2);
    var start = Math.min(this._domain[0], this._domain[1]);
    var stop = Math.max(this._domain[0], this._domain[1]);

    var step = this._tickStep(start, stop, count, force, false);

    var ticks = this._tickRange(Math.ceil(start / step) * step, Math.floor(stop / step) * step + step * .5, step);

    var lastTick = ticks[ticks.length - 1]; // consider a case where domain is [0, 99.999999999].
    // in this case, the step calculated is 20, but since 100 > domain[1], it is not included
    // now this is not desirable as its a mathematical error so we try to force 100.

    if (lastTick != null) {
      var _stop = lastTick + step;

      if (Math.abs(this.scale(_stop) - this.scale(stop)) < 0.0000001) {
        ticks.push(_stop);
      }
    }

    return ticks;
  }; // expands the domain so that it is equally divisible by x number of ticks.
  // eg: if domain is [15, 75] and count is 7
  // domain will be expanded to [10, 80] with step of 10.
  // Note: count is only a reference number, it will try to respect the count,
  // but the resulting count maybe a little off since we try to get a round step which might cause the count to increase or decrease


  LinearScale.prototype.nice = function nice(count) {
    var start = Math.min(this._domain[0], this._domain[1]);
    var stop = Math.max(this._domain[0], this._domain[1]);
    count = Math.max(count, 2);
    var step = this._step;

    if (step) {
      return this;
    }

    var domain = this.domain();
    step = this._tickStep(start, stop, count);

    if (step) {
      step = this._tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, count);

      var _start = Math.floor(start / step) * step;

      var _stop = Math.ceil(stop / step) * step;

      var testScale = new LinearScale().domain([_start, _stop]).range(this.range()); // if we are adding a whole step for a shape that wont even be visible big enough, lets reduce the domain.
      // if the shape is taking less than 10% of the step distance, then more white space is visble and the domain increase looks unnecessary
      // eg. the domain is [15, 71], the expanded domain becomes [10, 80].
      // but if the step of (70 - 80) was expanded only for a shape that took just < 2px i.e wasnt event visible,
      // it would feel as if its a waste of space, so we reduce the step and force the domain to be [10, 71].

      var tolerance = testScale.scale(step) * DIST_TOLERANCE;

      if (testScale.scale(_start + step) - testScale.scale(start) <= tolerance) {
        _start = start;
      }

      if (testScale.scale(stop) - testScale.scale(_stop - step) <= tolerance) {
        _stop = stop;
      }

      this.domain([_start, _stop]);
      this.step(step);
    }

    return this;
  }; // returns a new scale with the same domain, but range offset by dr


  LinearScale.prototype.offset = function offset(dr) {
    var range = this.range();
    var domain = this.domain();

    if (!range || !domain) {
      return;
    }

    return this.create().domain(domain).range([range[0] + dr, range[1] + dr]).step(this._step);
  }; // returns an equivalent scale(keeping dy/dx), but always scale 0 to 0 by
  // adjusting range
  // e.g.
  // domain: [-10, 10 ] range: [0, 20] => domain: [-10, 10] range: [-10, 10]
  // domain: [ 10, 20 ] range: [0, 20] => domain: [10 , 20] range: [20 , 40]


  LinearScale.prototype.adjustZero = function adjustZero() {
    var zeroOffset = this.scale(0);
    return this.offset(-zeroOffset);
  }; // returns an equivalent scale(keeping dy/dx), but always range[0] to 0 by
  // adjusting range
  // e.g.
  // domain: [-10, 10 ] range: [-10, 10] => domain: [-10, 10] range: [0, 20]
  // domain: [ 10, 20 ] range: [20, 40] => domain: [10 , 20] range: [0 , 20]


  LinearScale.prototype.adjustRangeZero = function adjustRangeZero() {
    var rangeOffset = this.range()[0];
    return this.offset(-rangeOffset);
  }; // returns an equivalent scale(keeping dy/dx) with new range
  // e.g.
  // domain: [0, 10 ] range: [0, 20]
  // adjustRange([0, 30]) => domain: [0, 15] range: [0, 30]


  LinearScale.prototype.adjustRange = function adjustRange(range) {
    if (!range) {
      return this;
    }

    var domain = [this.invert(range[0]), this.invert(range[1])];
    return this.create().domain(domain).range(range).step(this._step);
  };

  LinearScale.prototype.flip = function flip() {
    var range = this.range();
    var domain = this.domain();

    if (!range || !domain) {
      return;
    }

    return this.create().domain([domain[1], domain[0]]).range([-range[1], -range[0]]).step(this._step);
  };

  LinearScale.prototype.toJson = function toJson() {
    return {
      type: "LinearScale",
      domain: this._domain,
      range: this._range
    };
  };

  var OrdinalScale = function OrdinalScale() {
    this.scale = this.scale.bind(this);
    this._domain = [];
    this._index = {};
    this._range = [];
    this._subdivisionInterval = null;
  };

  OrdinalScale.prototype._computeSubdivision = function _computeSubdivision() {
    var this$1 = this;

    if (!this._subdivisionInterval || !this._domain) {
      return;
    }

    var bandSize = this._domain.length < 1 ? 0 : (this._subdivisionInterval[1] - this._subdivisionInterval[0]) / this._domain.length;
    return this._range = this._domain.map(function (item, index) {
      return this$1._subdivisionInterval[0] + index * bandSize;
    });
  };

  OrdinalScale.prototype.scale = function scale(x) {
    var i;

    if (this._index.hasOwnProperty(x)) {
      i = this._index[x];
    } else {
      i = this._index[x] = this._domain.push(x) - 1;
    }

    if (typeof this._range === "function") {
      return this._range(x, i);
    } else if (this._tickScale) {
      return this._tickScale.scale(i);
    } else {
      return this._range[i % this._range.length];
    }
  }; // Find the closest item in domain with a given range value


  OrdinalScale.prototype.invert = function invert(x) {
    return this._domain[dataUtils.closestIndex(this._range, x)];
  };

  OrdinalScale.prototype.domain = function domain(domain$1) {
    var this$1 = this;

    if (domain$1 == null) {
      return this._domain;
    }

    this._domain = domain$1;
    this._index = {};
    var i = 0;

    this._domain.forEach(function (x) {
      if (!this$1._index.hasOwnProperty(x)) {
        this$1._index[x] = i++;
      }
    });

    this._computeSubdivision();

    return this;
  }; // Returns an new scale where tick is determined by applying the provided offset to each tick of current scale's range.
  // Assuming a range of 5 indices [0, 30, 40, 60, 100]
  // @param offset {Number/String} percent or pixel value to offset points from the tick marks, examples:
  //     0 will put the values at [0, 30, 40, 60, 100]
  //     -7 will put the value at [-7, 23, 33, 53, 93]
  //     "50%" will put the values at [15, 35, 50, 80, 120] -- Note that the percent offset is calculated as
  //          the percentage of the distance to the next tick, except for the final tick which is calculated
  //          based on the distance from the previous tick, i.e. 50% of (100 - 60) is 20, added to 100 to make 120.


  OrdinalScale.prototype.offset = function offset(offset$1) {
    var this$1 = this;
    var band, shift;
    var result;

    if (!this._domain || !this._range) {
      return [];
    }

    if (offset$1 == null) {
      return this._range;
    }

    var percent = lodash__default.isString(offset$1) && offset$1.charAt(offset$1.length - 1) === "%" ? parseFloat(offset$1, 10) / 100 : null;
    var newRange = dataUtils.range(0, this._range.length).map(function (i) {
      return shift = percent != null ? band = i === this$1._range.length - 1 ? (this$1._range[i] - this$1._range[i - 1]) * percent : (this$1._range[i + 1] - this$1._range[i]) * percent : offset$1, this$1._range[i] + shift;
    });
    return result = new OrdinalScale().domain(this._domain).range(newRange);
  };

  OrdinalScale.prototype.range = function range(range$1) {
    if (range$1 == null) {
      return this._range;
    }

    this._subdivisionInterval = null;
    this._range = range$1;
    return this;
  }; // Sets the scale's range to equally spaced ticks subdiving the provided [start, stop] values.
  // Assuming 5 indices mapped on to the interval of [0, 100] the subdivisions will occur at [0, 20, 40, 60, 80]
  // @param interval {Array} 2 element array specifying the interval to subdivide.


  OrdinalScale.prototype.subdivide = function subdivide(interval) {
    if (interval == null) {
      return this._subdivisionInterval;
    }

    this._subdivisionInterval = interval;

    this._computeSubdivision();

    return this;
  };

  OrdinalScale.prototype.toJson = function toJson() {
    return {
      type: "OrdinalScale",
      domain: this._domain,
      range: this._range
    };
  };

  var ConstantScale = function ConstantScale() {
    this.scale = this.scale.bind(this);
  };

  ConstantScale.prototype.range = function range(range$1) {
    if (range$1 == null) {
      return this._range;
    }

    this._range = range$1;
    return this;
  };

  ConstantScale.prototype.scale = function scale() {
    return this._range;
  };

  ConstantScale.prototype.toJson = function toJson() {
    return {
      type: "ConstantScale",
      range: this._range
    };
  }; // Copied over from WaveUI/Client


  var StringHelper$1 = {
    // escape backslashes and apostrophes
    escape: function escape(str) {
      return str.replace(/('|\\)/g, "\\$1");
    },
    // return a string which is comprised of str repeated n times
    repeat: function repeat(str, n) {
      return new Array(n + 1).join(str);
    },
    leftPad: function leftPad(val, size, ch) {
      if (ch == null) {
        ch = " ";
      }

      var result = val.toString();

      while (result.length < size) {
        result = ch + result;
      }

      return result;
    },
    reverse: function reverse(str) {
      var i;
      var result = "";

      if (i = str.length) {
        while (i--) {
          result += str.charAt(i);
        }
      }

      return result;
    }
  };
  var NumberHelper = {
    round: function round(n, decimals) {
      var neg, result;

      if (neg = n < 0) {
        n = -n;
      }

      if (decimals === 0) {
        result = Math.round(n);
      } else if (decimals > 0) {
        var p = Math.pow(10, decimals);
        result = Math.round(n * p) / p;
      }

      if (neg && result !== 0) {
        result = -result;
      } // avoid converting 0 to -0


      return result;
    },
    // convert a number into a string without using scientific notation
    // (unlike default toString method for very large or small numbers)
    toStandardFormString: function toStandardFormString(n) {
      var e, neg;
      var str = n.toString();

      if (neg = str.charAt(0) === "-") {
        str = str.substring(1);
        n = -n;
      }

      if (Math.abs(n) < 1.0 && (e = parseInt(str.split('e-')[1]))) {
        n *= Math.pow(10, e - 1);
        n = this.round(n, 15); // avoid floating point errors (i.e. 0.0999... instead of 0.1)

        str = "0." + StringHelper$1.repeat("0", e - 1) + n.toString().substring(2);
      } else if ((e = parseInt(str.split("+")[1])) > 20) {
        e -= 20;
        n /= Math.pow(10, e);
        str = n + StringHelper$1.repeat("0", e);
      }

      if (neg) {
        str = "-" + str;
      }

      return str;
    }
  };
  var Helpers = {
    StringHelper: StringHelper$1,
    NumberHelper: NumberHelper
  };
  /*
  Color utils
  
  A 'color' can have multiple representations (type):
  - RGB: a simple string: "#f00"
  - GRADIENT: an object {type: "gradient", low: "#f00", high: "#ff0"}
  
  All the methods in this class will properly deal with either type of color.
  The rest of code should not have to worry about what a color 'object' is.
  
  For instance, if you call toGrayScale({type: "gradient", low: "#f00", high: "#ff0"}),
  you will get a gray scale of the gradient itself, something like: {type: "gradient", low: "#900", high: "#990"}
  */

  var StringHelper = Helpers.StringHelper;
  var Colors = {
    TYPE: {
      RGB: 0,
      GRADIENT: 1
    },
    //		IMG: 2
    type: function type(color) {
      if ((color != null ? color.type : undefined) === "gradient") {
        return this.TYPE.GRADIENT;
      } //		return this.TYPE.IMG if color?.type is "img"


      return this.TYPE.RGB;
    },
    // Return a dimmer version of a color
    // It simply mutliplies each r,g,b component by the ratio
    dimColor: function dimColor(color, ratio, mixColor) {
      if (color === null || color === undefined || color === "transparent") {
        return color;
      }

      switch (this.type(color)) {
        case this.TYPE.GRADIENT:
          var low = color.low;
          var high = color.high;
          return {
            type: "gradient",
            low: this.dimColor(low, ratio, mixColor),
            high: this.dimColor(high, ratio, mixColor)
          };

        case this.TYPE.RGB:
          var rgb = this.rgb(color);
          rgb.r = Math.round(rgb.r * ratio);
          rgb.g = Math.round(rgb.g * ratio);
          rgb.b = Math.round(rgb.b * ratio);

          if (mixColor) {
            var mixRgb = this.rgb(mixColor);
            rgb.r += mixRgb.r;
            rgb.g += mixRgb.g;
            rgb.b += mixRgb.b;
          }

          if (rgb.r > 255) {
            rgb.r = 255;
          }

          if (rgb.g > 255) {
            rgb.g = 255;
          }

          if (rgb.b > 255) {
            rgb.b = 255;
          }

          return rgb.toString();
      }
    },
    // compute the h s l components of an rgb color
    // @return {Object} hsl
    //                  {h}: hue, between 0 and 360
    //                  {s}: saturation, between 0 and 1
    //                  {l}: lightness, between 0 and 1
    rgbToHsl: function rgbToHsl(r, g, b) {
      var h, s;
      r /= 255;
      g /= 255;
      b /= 255;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        h = function () {
          switch (max) {
            case r:
              return (g - b) / d + (g < b ? 6 : 0);

            case g:
              return (b - r) / d + 2;

            case b:
              return (r - g) / d + 4;
          }
        }();

        h *= 360 / 6;
      }

      return {
        h: h,
        s: s,
        l: l
      };
    },
    // using the luminosity algorithm described here:
    //   http://www.johndcook.com/blog/2009/08/24/algorithms-convert-color-grayscale/
    toGrayscale: function toGrayscale(color) {
      switch (this.type(color)) {
        case this.TYPE.GRADIENT:
          var low = color.low;
          var high = color.high;
          return {
            type: "gradient",
            low: this.toGrayscale(low),
            high: this.toGrayscale(high)
          };

        case this.TYPE.RGB:
          var rgb = this.rgb(color);
          var grey = Math.round(0.2 * 255 + 0.8 * (rgb.r * 0.21 + rgb.g * 0.71 + rgb.b * 0.07));
          return this.rgbToHex(grey, grey, grey);
      }
    },
    rgbToHex: function rgbToHex(r, g, b) {
      var hr = StringHelper.leftPad(r.toString(16), 2, "0");
      var hg = StringHelper.leftPad(g.toString(16), 2, "0");
      var hb = StringHelper.leftPad(b.toString(16), 2, "0");
      return "#" + hr + hg + hb;
    },
    rgb: function rgb(color) {
      if (color) {
        var b, b0, g, g0, matches, r, r0;

        switch (this.type(color)) {
          case this.TYPE.GRADIENT:
            var low = color.low;
            var high = color.high;
            return {
              type: "gradient",
              low: this.rgb(low),
              high: this.rgb(high)
            };

          case this.TYPE.RGB:
            if (color[0] === "#") {
              if (color.length === 4) {
                // format: #rgb
                var c;
                r0 = (c = color[1]) + c;
                g0 = (c = color[2]) + c;
                b0 = (c = color[3]) + c;
              } else if (color.length === 7) {
                // format: #rrggbb
                r0 = color.slice(1, 3);
                g0 = color.slice(3, 5);
                b0 = color.slice(5, 7);
              } else {
                console.error("rgb, unknown color", color);
                return;
              }

              r = parseInt(r0, 16);
              g = parseInt(g0, 16);
              b = parseInt(b0, 16);
            } else if (matches = color.replace(new RegExp(" ", "g"), "").match(/rgb\((\d+),(\d+),(\d+)\)/)) {
              // format: rgb(r, g, b)
              var _0;

              var assign;
              assign = matches, _0 = assign[0], r0 = assign[1], g0 = assign[2], b0 = assign[3];
              r = parseInt(r0, 10);
              g = parseInt(g0, 10);
              b = parseInt(b0, 10);
            } else {
              console.error("rgb, unknown color", color);
              return;
            }

            return {
              r: r,
              g: g,
              b: b,
              toString: function toString() {
                return Colors.rgbToHex(this.r, this.g, this.b);
              }
            };
        }
      } else {
        console.error("rgb, unknown color", color);
        return;
      }
    }
  };
  /**
   * Source http://stackoverflow.com/questions/20215440/parse-css-gradient-rule-with-javascript-regex
   */

  /**
   * Utility combine multiple regular expressions.
   *
   * @param {RegExp[]|string[]} regexpList List of regular expressions or strings.
   * @param {string} flags Normal RegExp flags.
   */

  var combineRegExp = function combineRegExp(regexpList, flags) {
    var i,
        source = '';

    for (i = 0; i < regexpList.length; i++) {
      if (typeof regexpList[i] === 'string') {
        source += regexpList[i];
      } else {
        source += regexpList[i].source;
      }
    }

    return new RegExp(source, flags);
  };

  var gradientLikeRegex = new RegExp(".*gradient\\s*\\(((?:\\([^\\)]*\\)|[^\\)\\(]*)*)\\)");
  /**
   * Generate the required regular expressions once.
   *
   * Regular Expressions are easier to manage this way and can be well described.
   *
   * @return {object} Object containing regular expressions.
   */

  var generateRegExp = function generateRegExp() {
    // Note any variables with "Capture" in name include capturing bracket set(s).
    var searchFlags = 'gi',
        // ignore case for angles, "rgb" etc
    rAngle = new RegExp("(?:[+-]?\\d*\\.?\\d+)(?:deg|grad|rad|turn)"),
        // Angle +ive, -ive and angle types
    rSideCornerCapture = new RegExp("to\\s+((?:(?:left|right|top|bottom)(?:\\s+(?:left|right))?))"),
        // optional 2nd part
    rComma = new RegExp("\\s*,\\s*"),
        // Allow space around comma.
    rColorHex = new RegExp("\\#(?:[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})"),
        // 3 or 6 character form
    rDigits3 = new RegExp("\\(\\s*(?:[0-9]{1,3}\\s*,\\s*){2}[0-9]{1,3}\\s*\\)"),
        // "(1, 2, 3)"
    rDigits4 = new RegExp("\\(\\s*(?:[0-9]{1,3}\\s*,\\s*){3}[0-9|\\.]+\\s*\\)"),
        // "(1, 2, 3, 4)"
    rValue = new RegExp("(?:[+-]?\\d*\\.?\\d+)(?:%|[a-z]+)?"),
        // ".9", "-5px", "100%".
    rKeyword = new RegExp("[_A-Za-z-][_A-Za-z0-9-]*"),
        // "red", "transparent", "border-collapse".
    rColor = combineRegExp(['(?:', rColorHex, '|', '(?:rgb|hsl)', rDigits3, '|', '(?:rgba|hsla)', rDigits4, '|', rKeyword, ')'], ''),
        rColorStop = combineRegExp([rColor, '(?:\\s+', rValue, ')?'], ''),
        // Single Color Stop, optional value.
    rColorStopList = combineRegExp(['(?:', rColorStop, rComma, ')*', rColorStop], ''),
        // List of color stops min 1.
    rLineCapture = combineRegExp(['(?:(', rAngle, ')|', rSideCornerCapture, ')'], ''),
        // Angle or SideCorner
    rGradientSearch = combineRegExp(['(', rLineCapture, ')', rComma, '(', rColorStopList, ')'], searchFlags),
        // Capture 1:"line", 2:"angle" (optional), 3:"side corner" (optional) and 4:"stop list".
    rColorStopSearch = combineRegExp(['\\s*(', rColor, ')', '(?:\\s+', '(', rValue, '))?', '(?:', rComma, '\\s*)?'], searchFlags); // Capture 1:"color" and 2:"position" (optional).

    return {
      gradientSearch: rGradientSearch,
      colorStopSearch: rColorStopSearch
    };
  };
  /**
   * Actually parse the input gradient parameters string into an object for reusability.
   *
   *
   * note Really this only supports the standard syntax not historical versions, see MDN for details
   *       https://developer.mozilla.org/en-US/docs/Web/CSS/linear-gradient
   *
   * @param regExpLib
   * @param {string} input Input string in the form "to right bottom, #FF0 0%, red 20px, rgb(0, 0, 255) 100%"
   * @returns {object|undefined} Object containing break down of input string including array of stop points.
   */


  function parseGradient(input) {
    var result, matchGradient, matchColorStop, stopResult;
    var rGradientEnclosedInBrackets = gradientLikeRegex; // Captures inside brackets - max one additional inner set.

    var match = rGradientEnclosedInBrackets.exec(input);

    if (match) {
      regExpLib.gradientSearch.lastIndex = 0;
      matchGradient = regExpLib.gradientSearch.exec(input);

      if (matchGradient !== null) {
        result = {
          original: matchGradient[0],
          colorStopList: []
        }; // Line (Angle or Side-Corner).

        if (!!matchGradient[1]) {
          result.line = matchGradient[1];
        } // Angle or undefined if side-corner.


        if (!!matchGradient[2]) {
          result.angle = matchGradient[2];
        } // Side-corner or undefined if angle.


        if (!!matchGradient[3]) {
          result.sideCorner = matchGradient[3];
        } // Loop though all the color-stops.


        regExpLib.colorStopSearch.lastIndex = 0;
        matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);

        while (matchColorStop !== null) {
          stopResult = {
            color: matchColorStop[1]
          }; // Position (optional).

          if (!!matchColorStop[2]) {
            stopResult.position = matchColorStop[2];
          }

          result.colorStopList.push(stopResult); // Continue searching from previous position.

          matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);
        }
      }
    } // Can be undefined if match not found.


    return result;
  }

  function isGradientColor(str) {
    return str.match(gradientLikeRegex);
  }

  var regExpLib = generateRegExp(); //
  //@flow-ignore

  var COLOR_TYPE$1 = constants$1.COLOR_TYPE;
  var rgbToHex = Colors.rgbToHex;
  var rgbToHsl = Colors.rgbToHsl;
  /*::(x: Color) => (x: IColor)*/

  var Color = function Color(colorSetting) {
    if (typeof colorSetting === 'string') {
      this._colorRGBA = this._round(Color.fromStringToColor(colorSetting));
    } else {
      this._colorRGBA = this._round(colorSetting);
    }
  };

  Color.prototype._round = function _round(color) {
    return {
      r: Math.round(color.r),
      g: Math.round(color.g),
      b: Math.round(color.b),
      a: color.a != null ? color.a : 1
    };
  };
  /**
  	 * fromStringToColor takes a color string and will try all the conversion (rgb, rgba, hex) until it finds a proper one.
  	 * If not, it will throw an exception in the end
  	 */


  Color.fromStringToColor = function fromStringToColor(colorStr) {
    var rgbaColor;
    lodash__default.find([Color.fromHex, Color.fromRGBString, Color.fromRGBAString], function (convert) {
      rgbaColor = convert(colorStr);
      return rgbaColor;
    });
    return rgbaColor || {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  };
  /**
  	 * fromHex takes a hex string which can be in either #rgb or #rgba format and returns a RGBA color object.
  	 * If the color string is not a valid format, it will return an undefined.
  	 * Since hex string does not have an alpha channel, the a channel will be default as 1.
  	 * @param hexStr
  	 */


  Color.fromHex = function fromHex(hexStr) {
    var hex = hexStr.toLowerCase();
    var matches = hex.match(Color.HexFormat),
        colorRGBA;

    if ((hex.length === 4 || hex.length === 7) && matches) {
      var r, g, b;

      if (hex.length === 4) {
        // #rgb
        r = hex[1] + hex[1];
        g = hex[2] + hex[2];
        b = hex[3] + hex[3];
      } else if (hex.length === 7) {
        // #rrggbb
        r = hex[1] + hex[2];
        g = hex[3] + hex[4];
        b = hex[5] + hex[6];
      }

      colorRGBA = {
        r: parseInt(r, 16),
        g: parseInt(g, 16),
        b: parseInt(b, 16),
        a: 1
      };
    }

    return colorRGBA;
  };
  /**
  	 * fromRGBString takes a rgb string (ex. rgb(255,128,1)) and returns a RGBA color object.
  	 * If the color string is not a valid format, it will return an undefined.
  	 * Since rgb string does not have an alpha channel, the a channel will be default as 1.
  	 */


  Color.fromRGBString = function fromRGBString(RGB) {
    var rgb = RGB.toLowerCase();
    var matches = rgb.match(Color.RGBFormat),
        colorRGBA;

    if (matches) {
      colorRGBA = {
        r: Math.min(255, parseInt(matches[1])),
        g: Math.min(255, parseInt(matches[2])),
        b: Math.min(255, parseInt(matches[3])),
        a: 1
      };
    }

    return colorRGBA;
  };
  /**
  	 * fromRGBAString takes a rgb string (ex. rgba(255,128,1,0.2)) and returns a RGBA color object.
  	 * If the color string is not a valid format, it will return an undefined.
  	 */


  Color.fromRGBAString = function fromRGBAString(RGBA) {
    var rgb = RGBA.toLowerCase();
    var matches = rgb.match(Color.RGBAFormat),
        colorRGBA;

    if (matches) {
      colorRGBA = {
        r: Math.min(255, parseInt(matches[1])),
        g: Math.min(255, parseInt(matches[2])),
        b: Math.min(255, parseInt(matches[3])),
        a: Math.min(1, parseFloat(matches[4]))
      };
    }

    return colorRGBA;
  };

  Color.prototype._linearInterpolate = function _linearInterpolate(start, end, progress) {
    return start * (1 - progress) + end * progress;
  };

  Color.prototype._toColorWithSimpleColor = function _toColorWithSimpleColor(color, progress) {
    var ref = color.toRGBA();
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return new Color({
      r: this._linearInterpolate(this._colorRGBA.r, r, progress),
      g: this._linearInterpolate(this._colorRGBA.g, g, progress),
      b: this._linearInterpolate(this._colorRGBA.b, b, progress),
      a: this._linearInterpolate(this._colorRGBA.a, a, progress)
    });
  };

  Color.prototype._toColorWithLinearGradient = function _toColorWithLinearGradient(color, progress) {
    return color.toColor(this, 1 - progress);
  };

  Color.prototype._mixColorWithSimpleColor = function _mixColorWithSimpleColor(color) {
    var ref = color.toRGBA();
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return new Color({
      r: Math.min(255, this._colorRGBA.r + r),
      g: Math.min(255, this._colorRGBA.g + g),
      b: Math.min(255, this._colorRGBA.b + b),
      a: Math.min(1, this._colorRGBA.a + a)
    });
  };

  Color.prototype._mixColorWithLinearGradient = function _mixColorWithLinearGradient(color) {
    return color.mixColor(this);
  };

  Color.prototype._isEqualToSimpleColor = function _isEqualToSimpleColor(color) {
    var ref = color.toRGBA();
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    var ref$1 = this._colorRGBA;
    var tr = ref$1.r;
    var tg = ref$1.g;
    var tb = ref$1.b;
    var ta = ref$1.a;
    return r === tr && g === tg && b === tb && a === ta;
  };

  Color.prototype._isEqualToLinearGradientColor = function _isEqualToLinearGradientColor(color) {
    return color.isEqual(this);
  }; //------------------------------------
  //            Interface
  //------------------------------------


  Color.prototype.getType = function getType() {
    return COLOR_TYPE$1.SIMPLE_COLOR;
  };

  Color.prototype.toColor = function toColor(color, progress) {
    if (progress === void 0) progress = 1;
    var func = this._toColorWithSimpleColor;

    switch (color.getType()) {
      case COLOR_TYPE$1.LINEAR_GRADIENT:
        func = this._toColorWithLinearGradient;
        break;
    } //We already did a type down-case here while flow doesn't know about it
    //@flow-ignore


    return func.call(this, color, progress);
  };

  Color.prototype.toGreyscale = function toGreyscale() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    var grey = Math.round(0.2 * 255 + 0.8 * (r * 0.21 + g * 0.71 + b * 0.07));
    return new Color({
      r: grey,
      g: grey,
      b: grey,
      a: a
    });
  };

  Color.prototype.dimColor = function dimColor(ratio) {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    var nr = Math.min(255, Math.round(r * ratio));
    var ng = Math.min(255, Math.round(g * ratio));
    var nb = Math.min(255, Math.round(b * ratio));
    return new Color({
      r: nr,
      g: ng,
      b: nb,
      a: a
    });
  };

  Color.prototype.adjustOpacity = function adjustOpacity(ratio) {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    var na = Math.max(0, Math.min(1, a * ratio));
    return new Color({
      r: r,
      g: g,
      b: b,
      a: na
    });
  };

  Color.prototype.toOpaque = function toOpaque() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return new Color({
      r: r,
      g: g,
      b: b,
      a: 1
    });
  };

  Color.prototype.mixColor = function mixColor(color) {
    var func = this._mixColorWithSimpleColor;

    switch (color.getType()) {
      case COLOR_TYPE$1.LINEAR_GRADIENT:
        func = this._mixColorWithLinearGradient;
        break;
    } //We already did a type down-case here while flow doesn't know about it
    //@flow-ignore


    return func.call(this, color);
  };

  Color.prototype.toHighContrast = function toHighContrast(lightColor, darkColor) {
    // threshold at which we switch from light to dark text color at the end of the bar
    // using the YIQ color space as explained in https://24ways.org/2010/calculating-color-contrast/
    var ref = this.toRGB();
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : lightColor;
  };

  Color.prototype.isEqual = function isEqual(color) {
    if (!color) {
      return false;
    }

    if (color.getType() === COLOR_TYPE$1.SIMPLE_COLOR) {
      //We already did a type down-case here while flow doesn't know about it
      //@flow-ignore
      return this._isEqualToSimpleColor(color);
    } else {
      return this._isEqualToLinearGradientColor(color);
    }
  };

  Color.prototype.reverse = function reverse() {
    return this;
  }; //------------------------------------
  //            Conversion
  //------------------------------------


  Color.prototype.toHex = function toHex() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return rgbToHex(r, g, b);
  };

  Color.prototype.toRGB = function toRGB() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return {
      r: r,
      g: g,
      b: b
    };
  };

  Color.prototype.toRGBString = function toRGBString() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  Color.prototype.toHSLA = function toHSLA() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return lodash__default.extend(rgbToHsl(r, g, b), {
      a: a
    });
  };

  Color.prototype.toHSL = function toHSL() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return rgbToHsl(r, g, b);
  };

  Color.prototype.toRGBA = function toRGBA() {
    return this._colorRGBA;
  };

  Color.prototype.toRGBAString = function toRGBAString() {
    var ref = this._colorRGBA;
    var r = ref.r;
    var g = ref.g;
    var b = ref.b;
    var a = ref.a;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
  };

  Color.prototype.toString = function toString() {
    return this.toRGBAString();
  };

  Color.prototype.toJSON = function toJSON() {
    return this.toRGBAString();
  };

  Color.RGBFormat = /rgb\(([\d| ]+),([\d| ]+),([\d| ]+)\)/;
  Color.RGBAFormat = /rgba\(([\d| ]+),([\d| ]+),([\d| ]+),([\d(\.\d*)?| ]+)\)/;
  Color.HSLFormat = /hsl\((\d+),(\d+),(\d+)\)/;
  Color.HexFormat = /^#([0-9|a-f|A-F])*$/; //@fix-flow

  var COLOR_TYPE = constants$1.COLOR_TYPE;
  /*::(x: LinearGradient) => (x: IColor)*/

  var LinearGradient = function LinearGradient(colorSetting) {
    if (colorSetting && typeof colorSetting === 'object' && colorSetting.low && colorSetting.high && !Array.isArray(colorSetting)) {
      var low = colorSetting.low;
      var high = colorSetting.high;
      this._colorStops = [[low, 0], [high, 1]];
      this._direction = 0;
    } else if (typeof colorSetting === "string") {
      var info = LinearGradient.fromStringToColor(colorSetting);
      this._colorStops = info[0];
      this._direction = info[1];
    } else {
      this._colorStops = colorSetting[0];
      this._direction = colorSetting[1];
    }
  };
  /**
  	 * fromStringToColor takes a color string and will return the color stops as well as the direction in degrees
  	 * If the string is not valid, it will return a default color
  	 */


  LinearGradient.fromStringToColor = function fromStringToColor(colorStr) {
    var gradientInfo = parseGradient(colorStr),
        direction,
        colorStops;

    if (gradientInfo) {
      direction = LinearGradient._parseDirection(gradientInfo.line) || 0;
      colorStops = LinearGradient._setDefaultColorSteps(gradientInfo.colorStopList.map(LinearGradient._parseColorStop));
    } else {
      colorStops = [[new Color({
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }), 0]];
      direction = 0;
    }

    return [colorStops, direction].filter(function (x) {
      return x != null;
    });
  };
  /**
  	 * Parse the direction string. It can be either in string enum (to right, to bottom right) or in degrees (90deg)
  	 * @param direction
  	 * @returns {number} direction in degrees. (started from to right => 0 degree)
  	 * @private
  	 */


  LinearGradient._parseDirection = function _parseDirection(direction) {
    var dir = LinearGradient.DirectionMap[direction];
    return dir == null ? parseInt(direction) : dir;
  };
  /**
  	 * Parse the string to get color stops
  	 * @param colorStopInfo
  	 * @param isFirst This is the first color stop
  	 * @param isLast This is the last color stop
  	 * @private
  	 */


  LinearGradient._parseColorStop = function _parseColorStop(colorStopInfo) {
    return [new Color(colorStopInfo.color), colorStopInfo.position == null ? null : parseFloat(colorStopInfo.position) / 100];
  };

  LinearGradient._setDefaultColorSteps = function _setDefaultColorSteps(colorStops) {
    var nStops = colorStops.length;
    var step = 1 / (nStops - 1);

    for (var i = 0; i < nStops; ++i) {
      var stop = colorStops[i];

      if (i === 0) {
        stop[1] = 0;
      } else if (i === nStops - 1) {
        stop[1] = 1;
      } else {
        stop[1] = stop[1] == null ? step * i : stop[1];
      }
    }

    return colorStops;
  };

  LinearGradient.prototype._toColorWithSimpleColor = function _toColorWithSimpleColor(color, progress) {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].toColor(color, progress), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype._toColorWithLinearGradient = function _toColorWithLinearGradient(color, progress) {
    var colorStopsX = this._colorStops,
        colorStopsY = color.getColorStops();

    var unionSteps = LinearGradient._unionSteps(colorStopsX.map(function (s) {
      return s[1];
    }), colorStopsY.map(function (s) {
      return s[1];
    }));

    var uColorStopsX = LinearGradient._interpolateMissingStops(colorStopsX, unionSteps);

    var uColorStopsY = LinearGradient._interpolateMissingStops(colorStopsY, unionSteps);

    var mixedColorStops = [];

    for (var i = 0; i < unionSteps.length; ++i) {
      var colorX = uColorStopsX[i][0];
      var colorY = uColorStopsY[i][0];
      mixedColorStops.push([colorX.toColor(colorY, progress), unionSteps[i]]);
    }

    return new LinearGradient([mixedColorStops, LinearGradient._interpolate(0, this._direction, 1, color.getDirection(), progress)]);
  };

  LinearGradient.prototype._mixColorWithSimpleColor = function _mixColorWithSimpleColor(color) {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].mixColor(color), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype._mixColorWithLinearGradient = function _mixColorWithLinearGradient(color) {
    var colorStopsX = color.getColorStops(),
        colorStopsY = this._colorStops;

    var unionSteps = LinearGradient._unionSteps(colorStopsX.map(function (s) {
      return s[1];
    }), colorStopsY.map(function (s) {
      return s[1];
    }));

    var uColorStopsX = LinearGradient._interpolateMissingStops(colorStopsX, unionSteps);

    var uColorStopsY = LinearGradient._interpolateMissingStops(colorStopsY, unionSteps);

    var mixedColorStops = [];

    for (var i = 0; i < unionSteps.length; ++i) {
      var colorX = uColorStopsX[i][0];
      var colorY = uColorStopsY[i][0];
      mixedColorStops.push([colorX.mixColor(colorY), unionSteps[i]]);
    }

    return new LinearGradient([mixedColorStops, this._direction]);
  };

  LinearGradient._unionSteps = function _unionSteps(stepsX, stepsY) {
    var nX = stepsX.length,
        nY = stepsY.length,
        px = 0,
        py = 0,
        steps = [];

    while (px < nX || py < nY) {
      var sX = stepsX[px],
          sY = stepsY[py];

      if (px === nX) {
        // no more from x steps
        px++;
      } else if (py === nY) {
        // no more from y steps
        py++;
      } else {
        if (sX < sY) {
          px++;
          steps.push(sX);
        } else if (sX > sY) {
          py++;
          steps.push(sY);
        } else {
          px++;
          py++;
          steps.push(sX);
        }
      }
    }

    return steps;
  };

  LinearGradient._interpolateMissingStops = function _interpolateMissingStops(stops, allSteps) {
    var len = stops.length,
        nSteps = allSteps.length,
        newStops = [];

    if (nSteps <= len) {
      return stops;
    }

    var p = 0,
        q = 0;

    while (q < nSteps) {
      var stopStep = p === len ? 1 : stops[p][1],
          step = allSteps[q];

      if (stopStep === step) {
        // this stop was in the stop list already
        newStops.push([(p === len ? stops[p - 1] : stops[p])[0], step]);
        p++;
        q++;
      } else {
        var start = stops[p - 1];
        var end = stops[p];
        newStops.push([LinearGradient._interpolateColor(start[1], start[0], end[1], end[0], step), step]);
        q++;
      }
    }

    return newStops;
  };

  LinearGradient._interpolateColor = function _interpolateColor(start, startColor, end, endColor, target) {
    var starts = startColor.toRGBA();
    var ends = endColor.toRGBA();
    return new Color({
      r: LinearGradient._interpolate(start, starts.r, end, ends.r, target),
      g: LinearGradient._interpolate(start, starts.g, end, ends.g, target),
      b: LinearGradient._interpolate(start, starts.b, end, ends.b, target),
      a: LinearGradient._interpolate(start, starts.a, end, ends.a, target)
    });
  };

  LinearGradient._interpolate = function _interpolate(start, startVal, end, endVal, target) {
    if (start === end || end == null) {
      return startVal;
    }

    endVal = endVal || 0;
    return (target - start) * (endVal - startVal) / (end - start) + startVal;
  };

  LinearGradient.prototype._getGradientObject = function _getGradientObject(context, region) {
    var x0 = region.x0;
    var y0 = region.y0;
    var x1 = region.x1;
    var y1 = region.y1;
    var gradientObj,
        colorStops = this._colorStops;

    if (x1 > 0) {
      gradientObj = context.createLinearGradient(x0, y0, x1, y1);
    } else {
      gradientObj = context.createLinearGradient(x0, y0, -x1, y1);
      colorStops = colorStops.reverse();
    }

    colorStops.forEach(function (colorStop) {
      return gradientObj.addColorStop(colorStop[1], colorStop[0].toRGBAString());
    });
    return gradientObj;
  };

  LinearGradient.prototype._isEqualToSimpleColor = function _isEqualToSimpleColor(color) {
    return this.getColorStops().reduce(function (equal, x) {
      return equal && x[0].isEqual(color);
    }, true);
  };

  LinearGradient.prototype._isEqualToLinearGradientColor = function _isEqualToLinearGradientColor(color) {
    // TODO: consider direction
    var colorStopsX = color.getColorStops(),
        colorStopsY = this._colorStops;

    var unionSteps = LinearGradient._unionSteps(colorStopsX.map(function (s) {
      return s[1];
    }), colorStopsY.map(function (s) {
      return s[1];
    }));

    var uColorStopsX = LinearGradient._interpolateMissingStops(colorStopsX, unionSteps);

    var uColorStopsY = LinearGradient._interpolateMissingStops(colorStopsY, unionSteps);

    for (var i = 0; i < unionSteps.length; ++i) {
      var ref = uColorStopsX[i];
      var xc = ref[0];
      var xs = ref[1];
      var ref$1 = uColorStopsY[i];
      var yc = ref$1[0];
      var ys = ref$1[1];

      if (!xc.isEqual(yc)) {
        return false;
      }
    }

    return true;
  }; //------------------------------------
  //            Interface
  //------------------------------------

  /**
  	 *  Creates a palette of LinearGradient colors from a gradient, such the ordered colors that constitute
  	 *  the palette form a gradient that correspond to the input gradient
  	 *  @param numColors the number of colors to generate
  	 *  @param asGradients return the colors as gradients if true, otherwise just the left color
  	 *  @return an array of gradient colors
  	 */


  LinearGradient.prototype.getPaletteColors = function getPaletteColors(numColors, asGradients) {
    if (asGradients === void 0) asGradients = true;
    var colorStops = this.getColorStops();
    var direction = this.getDirection();
    var high = colorStops[0][0];
    var low = colorStops[colorStops.length - 1][0];
    var i;
    var colors = [];

    for (i = 0; i < numColors; i++) {
      var left = LinearGradient._interpolateColor(0, high, 1, low, i / numColors);

      var right = LinearGradient._interpolateColor(0, high, 1, low, (i + 1) / numColors);

      if (asGradients) {
        colors.push(new LinearGradient([[[left, 0], [right, 1]], direction]));
      } else {
        colors.push(left);
      }
    }

    return colors;
  };

  LinearGradient.prototype.getType = function getType() {
    return COLOR_TYPE.LINEAR_GRADIENT;
  };

  LinearGradient.prototype.toColor = function toColor(color, progress) {
    if (progress === void 0) progress = 1;
    var func = this._toColorWithSimpleColor;

    switch (color.getType()) {
      case COLOR_TYPE.LINEAR_GRADIENT:
        func = this._toColorWithLinearGradient;
        break;
    } //-ignore


    return func.call(this, color, progress);
  };

  LinearGradient.prototype.toGreyscale = function toGreyscale() {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].toGreyscale(), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype.dimColor = function dimColor(ratio) {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].dimColor(ratio), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype.adjustOpacity = function adjustOpacity(ratio) {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].adjustOpacity(ratio), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype.toOpaque = function toOpaque() {
    return new LinearGradient([this._colorStops.map(function (colorStop) {
      return [colorStop[0].toOpaque(), colorStop[1]];
    }), this._direction]);
  };

  LinearGradient.prototype.mixColor = function mixColor(color) {
    var func = this._mixColorWithSimpleColor;

    switch (color.getType()) {
      case COLOR_TYPE.LINEAR_GRADIENT:
        func = this._mixColorWithLinearGradient;
        break;
    } //@flow-ignore


    return func.call(this, color);
  };

  LinearGradient.prototype.getColorStops = function getColorStops() {
    return this._colorStops;
  };

  LinearGradient.prototype.getDirection = function getDirection() {
    return this._direction;
  };

  LinearGradient.prototype.toHighContrast = function toHighContrast(lightColor, darlColor) {
    var n = this._colorStops.length;
    return this._colorStops[n - 1][0].toHighContrast(lightColor, darlColor);
  };

  LinearGradient.prototype.toRepresentativeColor = function toRepresentativeColor() {
    return this._colorStops[0][0];
  }; // get the middle color of the gradient


  LinearGradient.prototype.interpolate = function interpolate() {
    var colorStops = this._colorStops;
    var high = colorStops[0][0];
    var low = colorStops[colorStops.length - 1][0];
    return LinearGradient._interpolateColor(0, high, 1, low, 0.5);
  };

  LinearGradient.prototype.isEqual = function isEqual(color) {
    if (!color) {
      return false;
    } else if (color.getType() === COLOR_TYPE.SIMPLE_COLOR) {
      //We already did a type down-case here while flow doesn't know about it
      //@flow-ignore
      return this._isEqualToSimpleColor(color);
    } else {
      //We already did a type down-case here while flow doesn't know about it
      //@flow-ignore
      return this._isEqualToLinearGradientColor(color);
    }
  };

  LinearGradient.prototype.reverse = function reverse() {
    return new LinearGradient([[[this._colorStops[1][0], 0], [this._colorStops[0][0], 1]], this._direction]);
  }; //------------------------------------
  //            Conversion
  //------------------------------------


  LinearGradient.prototype.toHex = function toHex() {
    return this.toRepresentativeColor().toHex();
  };

  LinearGradient.prototype.toRGB = function toRGB() {
    return this.toRepresentativeColor().toRGB();
  };

  LinearGradient.prototype.toRGBString = function toRGBString() {
    return this.toRepresentativeColor().toRGBString();
  };

  LinearGradient.prototype.toRGBA = function toRGBA() {
    return this.toRepresentativeColor().toRGBA();
  };

  LinearGradient.prototype.toRGBAString = function toRGBAString() {
    return this.toRepresentativeColor().toRGBAString();
  };

  LinearGradient.prototype._stringify = function _stringify() {
    return "linear-gradient(" + this._direction + "deg, " + this._colorStops.map(function (colorStop) {
      return colorStop[0].toString() + " " + colorStop[1] * 100 + "%";
    }).join(",") + ")";
  };

  LinearGradient.prototype.toString = function toString() {
    return this._stringify();
  };

  LinearGradient.prototype.toJSON = function toJSON() {
    return this._stringify();
  };

  LinearGradient.DirectionMap = {};
  [['to right', 0], ['tp bottom right', 45], ['to bottom', 90], ['to bottom left', 135], ['to left', 180], ['to top left', 225], ['to top', 270], ['to top right', 315]].forEach(function (ref) {
    var k = ref[0];
    var v = ref[1];
    return LinearGradient.DirectionMap[k] = v;
  }); //

  /**
   * The idea of ColorFactory is to abstract color generation. If the client has a string whether it is a simple color or
   * a gradient color, ColorFactory can always generate a IColor instance. Therefore, the client will not have to worry
   * about the creation of colors.
   *
   * @author yi.chen
   */
  //@flow-ignore

  var COLOR_TYPE$2 = constants$1.COLOR_TYPE;
  var instance$2 = null;

  var ColorFactory = function ColorFactory() {};

  ColorFactory.prototype.getColor = function getColor(colorString) {
    if (colorString && Array.isArray(colorString)) {
      var n = colorString.length;
      var colorStops = colorString.map(function (cs, i) {
        return [new Color(cs), i / (n - 1)];
      });
      return new LinearGradient([colorStops, 0]);
    } else {
      return lodash__default.isString(colorString) && isGradientColor(colorString) ? new LinearGradient(colorString) : new Color(colorString);
    }
  };

  ColorFactory.prototype.isColor = function isColor(obj) {
    return obj && obj.getType && (obj.getType() === COLOR_TYPE$2.SIMPLE_COLOR || obj.getType() === COLOR_TYPE$2.LINEAR_GRADIENT);
  };

  var ColorFactory$1 = {
    getInstance: function getInstance() {
      if (instance$2 == null) {
        instance$2 = new ColorFactory();
      }

      return instance$2;
    }
  };
  var ref = ColorFactory$1.getInstance();
  var getColor = ref.getColor;

  var GradientScale = function GradientScale() {
    this.scale = this.scale.bind(this);
    this._domain = [0, 1];
    this._dx = [this._domain[1] - this._domain[0]];
    this._range = new LinearGradient({
      low: getColor("#000000"),
      high: getColor("#ffffff")
    });
    this._rangeRGB = [Colors.rgb("#000000"), Colors.rgb("#ffffff")];
  };

  GradientScale.prototype.domain = function domain(domain$1) {
    var this$1 = this; // x

    if (domain$1 == null) {
      return this._domain;
    }

    this._domain = domain$1;
    this._dx = [];

    if (this._domain.length > 0) {
      for (var i = 0, end = this._domain.length - 1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
        this$1._dx.push(this$1._domain[i + 1] - this$1._domain[i] || this$1._domain[i] - this$1._domain[i - 1] || 1);
      }
    }

    return this;
  };

  GradientScale.prototype.range = function range(gradientColor) {
    // y
    if (gradientColor == null) {
      return this._range;
    }

    this._range = gradientColor;
    return this;
  };

  GradientScale.prototype.scale = function scale(x) {
    var colorStops = this._range.getColorStops();

    if (x <= this._domain[0]) {
      return colorStops[0][0];
    }

    if (x >= lodash__default.last(this._domain)) {
      return lodash__default.last(colorStops)[0];
    }

    var right = 0;

    while (x > this._domain[right]) {
      right++;
    }

    var left = right - 1;
    var ratio = (x - this._domain[left]) / this._dx[left];
    return colorStops[left][0].toColor(colorStops[right][0], ratio);
  };

  GradientScale.prototype.toJson = function toJson() {
    return {
      type: "GradientScale",
      domain: this._domain,
      range: this._range.toJSON()
    };
  };

  var LogScale = function (LinearScal____1) {
    function LogScale() {
      LinearScal____1.call(this);
      this.scale = this.scale.bind(this);
      this._dom0 = this._domain;
      this._dir = true;
      var assign;
      assign = LogScale.pos_lp, this.__log = assign[0], this.__pow = assign[1];
    }

    if (LinearScal____1) LogScale.__proto__ = LinearScal____1;
    LogScale.prototype = Object.create(LinearScal____1 && LinearScal____1.prototype);
    LogScale.prototype.constructor = LogScale;

    LogScale.initClass = function initClass() {
      this.pos_lp = [function (x) {
        return Math.log(x) / Math.LN10;
      }, function (x) {
        return Math.pow(10, x);
      }];
      this.neg_lp = [function (x) {
        return -Math.log(-x) / Math.LN10;
      }, function (x) {
        return -Math.pow(10, -x);
      }];
    };

    LogScale.pow = function pow(e) {
      // We do not want the power of the exponent to flip our sign, so negative numbers should be mapped to negatives
      return function (x) {
        return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
      };
    };

    LogScale.prototype.scale = function scale(x) {
      return LinearScal____1.prototype.scale.call(this, this.__log(x));
    };

    LogScale.prototype.invert = function invert(y) {
      return this.__pow(LinearScal____1.prototype.invert.call(this, y));
    };

    LogScale.prototype.domain = function domain(d) {
      if (d == null) {
        return this._dom0;
      }

      this._dom0 = d;

      if ((d[0] || d[1]) < 0) {
        this._dir = false;
        var assign;
        assign = LogScale.neg_lp, this.__log = assign[0], this.__pow = assign[1];
      } else {
        this._dir = true;
        var assign$1;
        assign$1 = LogScale.pos_lp, this.__log = assign$1[0], this.__pow = assign$1[1];
      }

      return LinearScal____1.prototype.domain.call(this, d.map(this.__log));
    };

    LogScale.prototype.ticks = function ticks() {
      var this$1 = this;
      var ticks = [];

      if (this._domain.every(isFinite)) {
        var k;
        var i = Math.floor(this._domain[0]);
        var j = Math.ceil(this._domain[1]);

        var u = this.__pow(this._domain[0]);

        var v = this.__pow(this._domain[1]);

        if (this._dir) {
          ticks.push(this.__pow(i));

          while (i++ < j) {
            k = 10;

            while (--k) {
              ticks.push(this$1.__pow(i) * k);
            }
          }
        } else {
          while (i < j) {
            k = 0;

            while (k++ < 10) {
              ticks.push(this$1.__pow(i++) * k);
            }
          }

          ticks.push(this.__pow(i));
        }

        i = 0;

        while (ticks[i] < u) {
          i++;
        }

        j = ticks.length;

        while (ticks[j - 1] > v) {
          j--;
        }

        return ticks.slice(i, j);
      } else {
        return ticks;
      }
    };

    LogScale.prototype.toJson = function toJson() {
      return {
        type: "LogScale",
        domain: this._dom0,
        range: this._range
      };
    };

    return LogScale;
  }(LinearScale);

  LogScale.initClass();

  var PowScale = function (LinearScal____1) {
    function PowScale() {
      LinearScal____1.call(this);
      this.scale = this.scale.bind(this);
      this._exp = 1;
      this.__powp = Number;
      this.__powb = this.__powp;
      this._dom0 = this._domain;
    }

    if (LinearScal____1) PowScale.__proto__ = LinearScal____1;
    PowScale.prototype = Object.create(LinearScal____1 && LinearScal____1.prototype);
    PowScale.prototype.constructor = PowScale;

    PowScale.pow = function pow(e) {
      // We do not want the power of the exponent to flip our sign, so negative numbers should be mapped to negatives
      return function (x) {
        return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
      };
    };

    PowScale.prototype.scale = function scale(x) {
      return LinearScal____1.prototype.scale.call(this, this.__powp(x));
    };

    PowScale.prototype.invert = function invert(y) {
      return this.__powb(LinearScal____1.prototype.invert.call(this, y));
    };

    PowScale.prototype.domain = function domain(d) {
      if (d == null) {
        return this._dom0;
      }

      this._dom0 = d;
      this.__powp = PowScale.pow(this._exp);
      this.__powb = PowScale.pow(1 / this._exp);
      return LinearScal____1.prototype.domain.call(this, d.map(this.__powp));
    };

    PowScale.prototype.exponent = function exponent(x) {
      this._exp = x;
      return this.domain(this._dom0);
    };

    PowScale.prototype.ticks = function ticks(m, force) {
      if (force === void 0) force = false;
      var l = new LinearScal____1();
      l.domain(this._dom0).step(this.step());
      return l.ticks(m, force);
    };

    PowScale.prototype.toJson = function toJson() {
      return {
        type: "PowScale",
        exp: this._exp,
        domain: this._dom0,
        range: this._range
      };
    };

    return PowScale;
  }(LinearScale);

  var SqrtScale = function (PowScal____1) {
    function SqrtScale() {
      PowScal____1.apply(this, arguments);
      this.exponent(0.5);
    }

    if (PowScal____1) SqrtScale.__proto__ = PowScal____1;
    SqrtScale.prototype = Object.create(PowScal____1 && PowScal____1.prototype);
    SqrtScale.prototype.constructor = SqrtScale;

    SqrtScale.prototype.create = function create() {
      return new SqrtScale();
    };

    SqrtScale.prototype.toJson = function toJson() {
      return {
        type: "SqrtScale",
        domain: this._dom0,
        range: this._range
      };
    };

    return SqrtScale;
  }(PowScale); //
  // generic scale class
  //


  var scales = {
    linear: function linear() {
      return new LinearScale();
    },
    ordinal: function ordinal() {
      return new OrdinalScale();
    },
    constant: function constant() {
      return new ConstantScale();
    },
    gradient: function gradient() {
      return new GradientScale();
    },
    log: function log() {
      return new LogScale();
    },
    pow: function pow(exponent) {
      return new PowScale().exponent(exponent);
    },
    sqrt: function sqrt() {
      return new SqrtScale();
    },
    fromJson: function fromJson(jsonScale) {
      var baseScale;

      switch (jsonScale.type) {
        case "ConstantScale":
          baseScale = new ConstantScale();
          break;

        case "LinearScale":
          baseScale = new LinearScale();
          break;

        case "OrdinalScale":
          baseScale = new OrdinalScale();
          break;

        case "GradientScale":
          baseScale = new GradientScale();
          break;

        case "LogScale":
          baseScale = new LogScale();
          break;

        case "PowScale":
          baseScale = new PowScale().exponent(jsonScale.exp);
          break;

        case "SqrtScale":
          baseScale = new SqrtScale();
          break;

        default:
          throw new Error("invalid scale " + jsonScale.type);
      }

      for (var k in jsonScale) {
        var v = jsonScale[k];

        if (!dataUtils.includes(["type", "exp"], k)) {
          baseScale[k](v);
        }
      }

      return baseScale;
    },
    // Transpose a scaled value (v, scaled using s0) using another scale (s1)
    //
    // This allows you to take a value scaled in a coordinate system and to transpose it into another
    // coordinate system.
    transpose: function transpose(v, s1, s0) {
      var left;
      return (left = s1.scale(typeof s0.invert === 'function' ? s0.invert(v) : undefined)) != null ? left : v;
    }
  }; //
  //@flow-ignore

  var nodeModelFactory;
  var TWEENABLE_PROPERTIES = ["tx", "ty", "viewport", "position", "background", "scrollOffset", "viewport"];
  var UNCHANGEABLE_PROPERTIES = ["scales"];
  /*::(x: GroupModel<*>) => (x: INodeModel<*>)*/

  var GroupModel = function (NodeMode____1) {
    function GroupModel() {
      NodeMode____1.apply(this, arguments);
    }

    if (NodeMode____1) GroupModel.__proto__ = NodeMode____1;
    GroupModel.prototype = Object.create(NodeMode____1 && NodeMode____1.prototype);
    GroupModel.prototype.constructor = GroupModel;

    GroupModel.setNodeModelFactoryImpl = function setNodeModelFactoryImpl(nodeModelFactoryImpl) {
      nodeModelFactory = nodeModelFactoryImpl;
    };

    GroupModel.prototype.tweenUpdate = function tweenUpdate(model1) {
      // add tweening effect
      return this.tween(null, model1.getProps());
    }; // compute tweens for cell transition


    GroupModel.prototype.tween = function tween(startProps, endProps) {
      var this$1 = this;

      if (!endProps) {
        endProps = {};
      }

      var tweens = {};

      for (var prop in this$1.props) {
        var v0 = this$1.props[prop];

        if (UNCHANGEABLE_PROPERTIES.indexOf(prop) < 0) {
          var v1 = endProps[prop];

          if (!lodash__default.isEqual(v0, v1)) {
            if (TWEENABLE_PROPERTIES.indexOf(prop) > -1) {
              if (v0 !== v1) {
                tweens[prop] = [v0, v1];
              }
            } else {
              this$1.props[prop] = v1;
            }
          }
        }
      }

      if (!lodash__default.isEmpty(tweens)) {
        this.tweens = tweens;
      }

      return this;
    };

    GroupModel.prototype.clone = function clone(withChildren) {
      if (withChildren === void 0) withChildren = true;
      return nodeModelFactory.fromJson(this.toJson(withChildren), false);
    };

    GroupModel.prototype.toJson = function toJson(withChildren) {
      if (withChildren === void 0) withChildren = true;
      var json = NodeMode____1.prototype.toJson.call(this);

      if (withChildren) {
        json.children = this.getChildren().map(function (child) {
          return child.toJson(true);
        });
      }

      if (json.props.scales || json.props.scrollOffset) {
        json.props = lodash__default.clone(json.props);
      }

      if (json.props && json.props.scales) {
        // in the base super.toJson, json.props has just been 'assigned', not
        // copied over, so modifying json.props.scales will modify the original
        // value. Let's make a shallow copy field to make sure the original
        // value stays intact
        var s = json.props.scales;
        json.props.scales = {};

        for (var name in s) {
          if (json.props) {
            json.props.scales[name] = s[name].toJson();
          }
        }
      }

      return json;
    };

    GroupModel.fromJson = function fromJson(json, deepCopy) {
      if (deepCopy === void 0) deepCopy = true;

      if (deepCopy) {
        json = dataUtils.deepCopy(json);
      }

      var node = NodeMode____1.fromJson.call(this, json, false);

      if (json.children) {
        json.children.forEach(function (childJson) {
          node.append(nodeModelFactory.fromJson(childJson, false));
        });
      }

      var scalesJson = json.props.scales;

      if (scalesJson) {
        var nodeScales = {};

        if (!deepCopy) {
          scalesJson = dataUtils.deepCopy(scalesJson);
        }

        for (var name in scalesJson) {
          nodeScales[name] = scales.fromJson(scalesJson[name]);
        }

        node.props.scales = nodeScales;
      }

      return node;
    };

    return GroupModel;
  }(NodeModel); //
  // StaticArraySet
  // A *very* simple class (for now) which give you an O(1) find operation on an array.
  // It basically simply creates a set object (a hashmap with each key mapped to true)
  // for each element of the initial Array
  // It is currently only working properly for static arrays, passed at constructor time.
  // If you add/remove an element from the array, you currently have to remove it from the
  // set as well.
  // To access the array behind the arraySet, use: arraySet.array
  // To access the set behind the arraySet, use: arraySet.set
  //
  // @author didier


  var StaticArraySet = function StaticArraySet(array) {
    var this$1 = this;
    this.array = array || [];
    this.set = {};
    this.array.forEach(function (v) {
      return this$1.set[v] = true;
    });
  };

  StaticArraySet.prototype.add = function add(value) {
    this.array.push(value);
    this.set[value] = true;
    return this;
  };

  var Padding = function Padding(param) {
    if (param == null) {
      param = {};
    }

    var top = param.top;
    var right = param.right;
    var bottom = param.bottom;
    var left = param.left;
    this.top = this._sanitizePad(top);
    this.right = this._sanitizePad(right);
    this.bottom = this._sanitizePad(bottom);
    this.left = this._sanitizePad(left);
  }; // Rotate padding locations
  //
  // @param options {Object} isCW, is rotation clock-wise, as opposed to counter-clock-wise


  Padding.prototype.rotate = function rotate(param) {
    if (param == null) {
      param = {};
    }

    var isCW = param.isCW;

    if (isCW == null) {
      isCW = false;
    }

    if (isCW) {
      var assign;
      assign = [this.top, this.right, this.bottom, this.left], this.right = assign[0], this.bottom = assign[1], this.left = assign[2], this.top = assign[3];
    } else {
      var assign$1;
      assign$1 = [this.top, this.right, this.bottom, this.left], this.left = assign$1[0], this.top = assign$1[1], this.right = assign$1[2], this.bottom = assign$1[3];
    }

    return this;
  }; // FlipX padding when sceneNode flipX


  Padding.prototype.flipX = function flipX() {
    var assign;
    assign = [this.left, this.right], this.right = assign[0], this.left = assign[1];
    return this;
  }; // FlipY padding when sceneNode flipX


  Padding.prototype.flipY = function flipY() {
    var assign;
    assign = [this.top, this.bottom], this.bottom = assign[0], this.top = assign[1];
    return this;
  }; // Sanitize padding value
  //
  // @param n {Number} padding value


  Padding.prototype._sanitizePad = function _sanitizePad(n) {
    if (lodash__default.isNumber(n) && lodash__default.isFinite(n)) {
      return Math.max(n, 0);
    } else {
      return 0;
    }
  }; //-----------------------------------------------------------------------------------------
  // to/from
  //-----------------------------------------------------------------------------------------


  Padding.prototype.toJson = function toJson() {
    return {
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left
    };
  };

  Padding.fromJson = function fromJson(json) {
    return new Padding(json);
  }; // weak
  //@flow-ignore


  var ref$1 = ColorFactory$1.getInstance();
  var getColor$1 = ref$1.getColor;
  /*::(x: Theme) => (x: ITheme)*/

  var Theme = function Theme(themeData) {
    this._themeName = themeData.name;
    this._theme = this._convertColor(dataUtils.deepCopy(themeData.properties));
    return this;
  };

  Theme.prototype._convertColor = function _convertColor(obj) {
    var this$1 = this;

    if (Array.isArray(obj)) {
      return obj.map(getColor$1);
    } else if (obj && typeof obj !== "object" && typeof obj != "number") {
      return getColor$1(obj);
    } else {
      lodash__default.keys(obj).map(function (key) {
        var val = obj[key];
        obj[key] = this$1._convertColor(val);
      });
      return obj;
    }
  };

  Theme.prototype.getName = function getName() {
    return this._themeName;
  };

  Theme.prototype.toObject = function toObject() {
    return JSON.parse(JSON.stringify(this._theme));
  };

  Theme.prototype.toJSON = function toJSON() {
    return this._theme;
  }; //----------------------------------------------
  //                 Background
  //----------------------------------------------


  Theme.prototype.getBackgroundColor = function getBackgroundColor() {
    return this._theme.BACKGROUND_COLOR;
  }; //----------------------------------------------
  //                Axis
  //----------------------------------------------


  Theme.prototype.getAxisTitleTextBackgroundColor = function getAxisTitleTextBackgroundColor() {
    return this._theme.AXIS.TITLE.TEXT.BACKGROUND;
  }; //----------------------------------------------
  //                Measure Axis
  //----------------------------------------------


  Theme.prototype.getMeasureAxisLineColor = function getMeasureAxisLineColor() {
    return this._theme.AXIS.NUMBER.AXIS_LINE;
  };

  Theme.prototype.getMeasureAxisGridLineColor = function getMeasureAxisGridLineColor() {
    return this._theme.AXIS.NUMBER.GRID_LINE;
  };

  Theme.prototype.getMeasureAxisMinorGridLineColor = function getMeasureAxisMinorGridLineColor() {
    return this._theme.AXIS.NUMBER.MINOR_GRID_LINE;
  };

  Theme.prototype.getMeasureAxisTickMarkColor = function getMeasureAxisTickMarkColor() {
    return this._theme.AXIS.NUMBER.TICK_MARK;
  };

  Theme.prototype.getMeasureAxisTickLabelColor = function getMeasureAxisTickLabelColor() {
    return this._theme.AXIS.NUMBER.TICK_LABEL;
  };

  Theme.prototype.getMeasureAxisTitleColor = function getMeasureAxisTitleColor() {
    return this._theme.AXIS.NUMBER.TITLE;
  }; //----------------------------------------------
  //              Dimension Axis
  //----------------------------------------------


  Theme.prototype.getDimensionAxisTextColor = function getDimensionAxisTextColor() {
    return this._theme.AXIS.LABEL.TEXT.COLOR;
  };

  Theme.prototype.getDimensionAxisTextBGColor = function getDimensionAxisTextBGColor() {
    return this._theme.AXIS.LABEL.TEXT.BACKGROUND;
  };

  Theme.prototype.getDimensionAxisTextHoverColor = function getDimensionAxisTextHoverColor() {
    return this._theme.AXIS.LABEL.TEXT.HOVER;
  };

  Theme.prototype.getDimensionAxisSeparatorColor = function getDimensionAxisSeparatorColor() {
    return this._theme.AXIS.LABEL.SEPARATOR_LINE;
  };

  Theme.prototype.getDimensionAxisTitleColor = function getDimensionAxisTitleColor() {
    return this._theme.AXIS.LABEL.TITLE;
  }; //----------------------------------------------
  //              Time Axis
  //----------------------------------------------


  Theme.prototype.getTimeAxisLineColor = function getTimeAxisLineColor() {
    return this._theme.AXIS.TIME.AXIS_LINE;
  };

  Theme.prototype.getTimeAxisGridLineColor = function getTimeAxisGridLineColor() {
    return this._theme.AXIS.TIME.GRID_LINE;
  };

  Theme.prototype.getTimeAxisTickMarkColor = function getTimeAxisTickMarkColor() {
    return this._theme.AXIS.TIME.TICK_MARK;
  };

  Theme.prototype.getTimeAxisTickLabelColor = function getTimeAxisTickLabelColor() {
    return this._theme.AXIS.TIME.TICK_LABEL;
  };

  Theme.prototype.getTimeAxisTitleColor = function getTimeAxisTitleColor() {
    return this._theme.AXIS.TIME.TITLE;
  }; //----------------------------------------------
  //              Tooltip
  //----------------------------------------------


  Theme.prototype.getToolTipBackgroundColor = function getToolTipBackgroundColor() {
    return this._theme.TOOLTIP.BACKGROUND_COLOR;
  };

  Theme.prototype.getToolTipTruncationBackgroundColor = function getToolTipTruncationBackgroundColor() {
    return this._theme.TOOLTIP.TRUNCATION_BACKGROUND_COLOR;
  };

  Theme.prototype.getToolTipLabelColor = function getToolTipLabelColor() {
    return this._theme.TOOLTIP.LABEL_COLOR;
  };

  Theme.prototype.getToolTipValueColor = function getToolTipValueColor() {
    return this._theme.TOOLTIP.VALUE_COLOR;
  }; //----------------------------------------------
  //                Legend
  //----------------------------------------------


  Theme.prototype.getLegendBGColor = function getLegendBGColor() {
    return this._theme.LEGEND.BACKGROUND;
  };

  Theme.prototype.getLegendBorderColor = function getLegendBorderColor() {
    return this._theme.LEGEND.BORDER;
  };

  Theme.prototype.getLegendTextColor = function getLegendTextColor() {
    return this._theme.LEGEND.TEXT.COLOR;
  };

  Theme.prototype.getLegendTextBGColor = function getLegendTextBGColor() {
    return this._theme.LEGEND.TEXT.BACKGROUND;
  };

  Theme.prototype.getLegendTextHoverColor = function getLegendTextHoverColor() {
    return this._theme.LEGEND.TEXT.HOVER;
  };

  Theme.prototype.getLegendHeaderColor = function getLegendHeaderColor() {
    return this._theme.LEGEND.HEADER;
  };

  Theme.prototype.getLegendHeaderLineColor = function getLegendHeaderLineColor() {
    return this._theme.LEGEND.HEADER_LINE;
  }; //----------------------------------------------
  //              Gradient Legend
  //----------------------------------------------


  Theme.prototype.getGradientLegendColor = function getGradientLegendColor() {
    return this._theme.GRADIENT_COLORS[0];
  };

  Theme.prototype.getGradientLegendTextColor = function getGradientLegendTextColor() {
    return this._theme.GRADIENT_LEGEND.TEXT;
  }; //----------------------------------------------
  //               Radial Legend
  //----------------------------------------------


  Theme.prototype.getRadialLegendBGColor = function getRadialLegendBGColor() {
    return this._theme.RADIAL_LEGEND.BACKGROUND;
  };

  Theme.prototype.getRadialLegendBorderColor = function getRadialLegendBorderColor() {
    return this._theme.RADIAL_LEGEND.BORDER;
  };

  Theme.prototype.getRadialLegendTextColor = function getRadialLegendTextColor() {
    return this._theme.RADIAL_LEGEND.TEXT;
  }; //----------------------------------------------
  //                 Hotspot
  //----------------------------------------------


  Theme.prototype.getHotspotColors = function getHotspotColors() {
    return {
      color: this.getHotspotColor(),
      bgColor: this.getHotspotBGColor(),
      hoverColor: this.getHotspotHoverColor(),
      hoverBgColor: this.getHotspotHoverBGColor()
    };
  };

  Theme.prototype.getHotspotColor = function getHotspotColor() {
    return this._theme.HOTSPOT.COLOR;
  };

  Theme.prototype.getHotspotBGColor = function getHotspotBGColor() {
    return this._theme.HOTSPOT.BACKGROUND;
  };

  Theme.prototype.getHotspotHoverColor = function getHotspotHoverColor() {
    return this._theme.HOTSPOT.HOVER;
  };

  Theme.prototype.getHotspotHoverBGColor = function getHotspotHoverBGColor() {
    return this._theme.HOTSPOT.HOVER_BACKGROUND;
  }; //----------------------------------------------
  //            Conditional Color
  //----------------------------------------------


  Theme.prototype.getPositiveColor = function getPositiveColor() {
    return this._theme.CONDITIONAL_COLOR.POSITIVE;
  };

  Theme.prototype.getNegativeColor = function getNegativeColor() {
    return this._theme.CONDITIONAL_COLOR.NEGATIVE;
  };

  Theme.prototype.getTextColorOnDark = function getTextColorOnDark() {
    return this._theme.CONDITIONAL_COLOR.TEXT_COLOR_DARK;
  };

  Theme.prototype.getTextColorOnLight = function getTextColorOnLight() {
    return this._theme.CONDITIONAL_COLOR.TEXT_COLOR_LIGHT;
  }; //----------------------------------------------
  //                Title Color
  //----------------------------------------------


  Theme.prototype.getChartTitleColor = function getChartTitleColor() {
    return this._theme.TITLE.COLOR;
  };

  Theme.prototype.getChartSubtitleColor = function getChartSubtitleColor() {
    return this._theme.TITLE.SUBTITLE_COLOR;
  }; //----------------------------------------------
  //                Mark Color
  //----------------------------------------------


  Theme.prototype.getLineFillAreaColor = function getLineFillAreaColor() {
    return this._theme.MARK.LINE.FILL_AREA;
  };

  Theme.prototype.getPolarGaugeMarkColor = function getPolarGaugeMarkColor() {
    return this._theme.MARK.POLAR_GAUGE.TRACK;
  };

  Theme.prototype.getSparkLineMarkLineColor = function getSparkLineMarkLineColor() {
    return this._theme.MARK.SPARK_LINE.COLOR_LINE;
  };

  Theme.prototype.getSparkLineMarkHighColor = function getSparkLineMarkHighColor() {
    return this._theme.MARK.SPARK_LINE.COLOR_HIGH;
  };

  Theme.prototype.getSparkLineMarkLowColor = function getSparkLineMarkLowColor() {
    return this._theme.MARK.SPARK_LINE.COLOR_LOW;
  };

  Theme.prototype.getMapMarkEmptyColor = function getMapMarkEmptyColor() {
    return this._theme.MARK.MAP.COLOR_EMPTY;
  };

  Theme.prototype.getMapMarkStrokeColor = function getMapMarkStrokeColor() {
    return this._theme.MARK.MAP.COLOR_STROKE;
  };

  Theme.prototype.getMapMarkLineColor = function getMapMarkLineColor() {
    return this._theme.MARK.MAP.COLOR_LINE;
  };

  Theme.prototype.getGaugeNeedleColor = function getGaugeNeedleColor() {
    return this._theme.MARK.GAUGE.NEEDLE;
  }; //----------------------------------------------
  //                 Trellis
  //----------------------------------------------


  Theme.prototype.getTrellisGridLineColor = function getTrellisGridLineColor() {
    return this._theme.TRELLIS.GRID_LINE;
  };

  Theme.prototype.getTrellisHeaderTextColor = function getTrellisHeaderTextColor() {
    return this._theme.TRELLIS.HEADER_TEXT;
  };

  Theme.prototype.getTrellisHeaderLineColor = function getTrellisHeaderLineColor() {
    return this._theme.TRELLIS.HEADER_LINE;
  }; //----------------------------------------------
  //               Empty Chart
  //----------------------------------------------


  Theme.prototype.getEmptyChartTextColor = function getEmptyChartTextColor() {
    return this._theme.EMPTY_CHART.TEXT;
  }; //----------------------------------------------
  //                 Palette
  //----------------------------------------------


  Theme.prototype.getPrimaryGradientColors = function getPrimaryGradientColors() {
    return this._theme.GRADIENT_COLORS[0];
  };

  Theme.prototype.getGradientColors = function getGradientColors() {
    return this._theme.GRADIENT_COLORS;
  };

  Theme.prototype.getFlatBandColors = function getFlatBandColors() {
    return this._theme.BAND_COLORS.FLAT;
  };

  Theme.prototype.getGradientBandColors = function getGradientBandColors() {
    return this._theme.BAND_COLORS.GRADIENT;
  };

  Theme.prototype.getPaletteColors = function getPaletteColors() {
    return this._theme.PALETTE;
  };

  Theme.prototype.getBinDefaultColor = function getBinDefaultColor() {
    return this._theme.BINS.DEFAULT_COLOR;
  }; //----------------------------------------------
  //                  Brush
  //----------------------------------------------


  Theme.prototype.getBrushStrokeColor = function getBrushStrokeColor() {
    return this._theme.BRUSH.STROKE;
  };

  Theme.prototype.getBrushFillColor = function getBrushFillColor() {
    return this._theme.BRUSH.FILL;
  };

  Theme.prototype.getBrushTextColor = function getBrushTextColor() {
    return this._theme.BRUSH.TEXT;
  }; //----------------------------------------------
  //                Reference Line
  //----------------------------------------------


  Theme.prototype.getReferenceLineColor = function getReferenceLineColor() {
    return this._theme.REFERENCE_LINE.LINE_STROKE;
  }; //----------------------------------------------
  //                Icons
  //----------------------------------------------


  Theme.prototype.getIconFillColor = function getIconFillColor() {
    return this._theme.ICON.FILL;
  }; //----------------------------------------------
  //                Crosshair
  //----------------------------------------------


  Theme.prototype.getCrosshairFillColor = function getCrosshairFillColor() {
    return this._theme.CROSSHAIR.FILL;
  };

  Theme.prototype.getCrosshairStrokeColor = function getCrosshairStrokeColor() {
    return this._theme.CROSSHAIR.STROKE;
  }; //-ignore


  var _delegate;

  var _scriptEvaluatorFct;

  var inst;

  function safeValue(value) {
    if (_scriptEvaluatorFct) {
      return _scriptEvaluatorFct("return " + JSON.stringify(value) + ";");
    } else {
      return value;
    }
  }
  /**
   *  Delegate proxy class that passes safe arguments/returns safe values to/from
   *  the proxied' Delegate's instance methods
   */


  var SecureDelegate = function SecureDelegate() {};

  SecureDelegate.init = function init(ref) {
    var delegate = ref.delegate;
    var scriptEvaluatorFct = ref.scriptEvaluatorFct;
    _delegate = delegate;
    _scriptEvaluatorFct = scriptEvaluatorFct;
    inst = new SecureDelegate();
  };

  SecureDelegate.getInstance = function getInstance() {
    return inst;
  };

  SecureDelegate.prototype.getTextWidth = function getTextWidth(txt, size) {
    return safeValue(_delegate.getTextWidth(safeValue(txt), safeValue(size)));
  };

  SecureDelegate.prototype.getTruncatedText = function getTruncatedText(txt, maxWidth, size) {
    return safeValue(_delegate.getTruncatedText(safeValue(txt), safeValue(maxWidth), safeValue(size)));
  };

  SecureDelegate.prototype.getRealFontSize = function getRealFontSize(size) {
    return safeValue(_delegate.getRealFontSize(safeValue(size)));
  };

  SecureDelegate.prototype.fontInfo = function fontInfo() {
    return safeValue(_delegate.fontInfo());
  };

  SecureDelegate.prototype.require = function require(url) {
    return new es6Promise.Promise(function (resolve, reject) {
      _delegate.require(safeValue(url)).then(function (value) {
        resolve(safeValue(value));
      });
    });
  };

  var _Perf;

  var inst$1;

  var _scriptEvaluatorFct$1;

  function safeValue$1(value) {
    if (_scriptEvaluatorFct$1) {
      return _scriptEvaluatorFct$1("return " + JSON.stringify(value) + ";");
    } else {
      return value;
    }
  }

  var SecurePerf = function SecurePerf() {};

  SecurePerf.init = function init(ref) {
    var Perf = ref.Perf;
    var scriptEvaluatorFct = ref.scriptEvaluatorFct;
    _Perf = Perf;
    _scriptEvaluatorFct$1 = scriptEvaluatorFct;
    inst$1 = new SecurePerf();
  };

  SecurePerf.getInstance = function getInstance() {
    return inst$1;
  };

  SecurePerf.prototype.mark = function mark(mark$1) {
    _Perf.getInstance().mark(safeValue$1(mark$1));
  };

  SecurePerf.prototype.endMark = function endMark(mark) {
    _Perf.getInstance().mark(safeValue$1(mark));
  };

  var WaveChartRuntime = function WaveChartRuntime() {};

  WaveChartRuntime.prototype.getDelegate = function getDelegate() {
    return SecureDelegate.getInstance();
  };

  WaveChartRuntime.prototype.getPerf = function getPerf() {
    return SecurePerf.getInstance();
  };

  var WaveChartsRuntime = new WaveChartRuntime();
  var name$1 = "default";
  var properties$1 = {
    "BACKGROUND_COLOR": "rgba(255,255,255,0)",
    "AXIS": {
      "NUMBER": {
        "AXIS_LINE": "rgba(201,199,197,0.9)",
        "GRID_LINE": "rgba(201,199,197,0.5)",
        "MINOR_GRID_LINE": "rgba(217,215,213,0.3)",
        "TICK_MARK": "rgba(201,199,197, 0.9)",
        "TICK_LABEL": "#b8b7b6",
        "TITLE": "#888"
      },
      "TITLE": {
        "TEXT": {
          "BACKGROUND": "#f4f6f9"
        }
      },
      "LABEL": {
        "TEXT": {
          "COLOR": "#333333",
          "BACKGROUND": "#E6EAF5",
          "HOVER": "#17324D"
        },
        "SEPARATOR_LINE": "#c9c7c5",
        "TITLE": "#888"
      },
      "TIME": {
        "AXIS_LINE": "rgba(201,199,197,0.9)",
        "GRID_LINE": "rgba(217,215,213,0.3)",
        "TITLE": "#888",
        "TICK_MARK": "#c9c7c5",
        "TICK_LABEL": "#b8b7b6"
      }
    },
    "TOOLTIP": {
      "BACKGROUND_COLOR": "#16325C",
      "TRUNCATION_BACKGROUND_COLOR": "rgba(255, 255, 194, 1)",
      "LABEL_COLOR": "#9faab5",
      "VALUE_COLOR": "#fff"
    },
    "LEGEND": {
      "BACKGROUND": "rgba(255,255,255,0.8)",
      "BORDER": "#c9c7c5",
      "TEXT": {
        "COLOR": "#333333",
        "BACKGROUND": "#E6EAF5",
        "HOVER": "#17324D"
      },
      "HEADER": "#333333",
      "HEADER_LINE": "#c9c7c5"
    },
    "GRADIENT_LEGEND": {
      "TEXT": "#444"
    },
    "RADIAL_LEGEND": {
      "BACKGROUND": "rgba(244,246,249,0.7)",
      "BORDER": "#a8b7c7",
      "TEXT": "#000"
    },
    "HOTSPOT": {
      "COLOR": "#17324D",
      "BACKGROUND": "#E6EAF5",
      "HOVER": "#ffffff",
      "HOVER_BACKGROUND": "rgba(107,114,115,1)"
    },
    "CONDITIONAL_COLOR": {
      "POSITIVE": "#60b17d",
      "NEGATIVE": "#c23934",
      "TEXT_COLOR_DARK": "#000",
      "TEXT_COLOR_LIGHT": "#fff"
    },
    "TITLE": {
      "COLOR": "#17324D",
      "SUBTITLE_COLOR": "#777"
    },
    "MARK": {
      "LINE": {
        "FILL_AREA": "rgba(255,255,255,0.1)"
      },
      "POLAR_GAUGE": {
        "TRACK": "rgba(204,221,238,1)"
      },
      "SPARK_LINE": {
        "COLOR_LINE": "#888",
        "COLOR_HIGH": "#0f0",
        "COLOR_LOW": "#f00"
      },
      "MAP": {
        "COLOR_EMPTY": "#e0e5ee",
        "COLOR_STROKE": "#fff",
        "COLOR_LINE": "#a8b7c7"
      },
      "GAUGE": {
        "NEEDLE": "#17324D"
      }
    },
    "TRELLIS": {
      "GRID_LINE": "#ddd",
      "HEADER_TEXT": "#000",
      "HEADER_LINE": "#000"
    },
    "EMPTY_CHART": {
      "TEXT": "#54698d"
    },
    "GRADIENT_COLORS": ["linear-gradient(to bottom, #e2f4fc, #009ddf)"],
    "BAND_COLORS": {
      "FLAT": ["#DC3912", "#FF9900", "#109618"],
      "GRADIENT": ["linear-gradient(to bottom, #f95, #f07)", "linear-gradient(to bottom, #fd4, #4e0)", "linear-gradient(to bottom, #0fc, #40f)"]
    },
    "PALETTE": ["#16325C", "#00A1E0", "#76DED9", "#08A69E", "#E2CE7D", "#E69F00", "#C23934", "#FFB75D", "#60B17D", "#00716B", "#94E3B1", "#009E73", "#93C9F8", "#3A93BA", "#0070D2", "#ABDCF4", "#8073F7", "#7B399C", "#CC79A7", "#E2B1FA", "#AF5CD8"],
    "REFERENCE_LINE": {
      "LINE_STROKE": "#8932ed"
    },
    "BINS": {
      "DEFAULT_COLOR": "#A9A9A9"
    },
    "BRUSH": {
      "STROKE": "rgba(150, 150, 150, 0.5)",
      "FILL": "rgba(200, 200, 200, 0.3)",
      "TEXT": "rgba(0, 0, 0, 0.8)"
    },
    "ICON": {
      "FILL": "rgba(0, 0, 0, 0.1)"
    },
    "CROSSHAIR": {
      "STROKE": "rgba(255, 255, 255, 1)",
      "FILL": "rgba(23,128,240,1)"
    }
  };
  var DefaultTheme = {
    name: name$1,
    properties: properties$1
  }; // 

  /**
   * ThemeFactory is for registering new themes or retrieving theme with a theme name. When doing registration, the client
   * associate a theme name with a url where the actual theme data can be fetched. When that particular theme is used for
   * some chart, the theme data will then be fetched and cached for next time.
   *
   * @author yi.chen
   */
  // @flow-ignore
  //@flow-ignore

  var instance$4 = null;

  var ThemeDataFactory = function ThemeDataFactory() {
    var this$1 = this;
    this._themeCache = {}; // Register default themes

    ThemeDataFactory.defaultThemes.forEach(function (theme) {
      return this$1.registerData(theme);
    });
  };

  ThemeDataFactory.getInstance = function getInstance() {
    if (!instance$4) {
      instance$4 = new ThemeDataFactory();
    }

    return instance$4;
  };

  ThemeDataFactory.prototype.fetchByConfig = function fetchByConfig(themeConfig) {
    var base = themeConfig.base;
    var properties = themeConfig.properties;
    var themeData = this.fetchByName(base);
    return properties ? dataUtils.defaultsDeep(dataUtils.deepCopy({
      properties: properties
    }), themeData) : themeData;
  };
  /**
  	 * FetchByName will go fetch the theme data with the name given.
  	 * @param themeName
  	 * @returns {*}
  	 */


  ThemeDataFactory.prototype.fetchByName = function fetchByName(themeName) {
    return this._buildTheme(themeName);
  };

  ThemeDataFactory.prototype.getAllThemeNames = function getAllThemeNames() {
    return lodash__default.keys(this._themeCache);
  };

  ThemeDataFactory.prototype.getDefaultThemeData = function getDefaultThemeData() {
    return DefaultTheme;
  };

  ThemeDataFactory.prototype.registerData = function registerData(themeInfo) {
    var name = themeInfo.name;
    var data = themeInfo.data;
    this._themeCache[name] = data;
  };

  ThemeDataFactory.prototype._buildTheme = function _buildTheme(themeName) {
    var theme = this._getTheme(themeName);

    if (theme) {
      var base = theme.base;
      var baseTheme = base ? this._buildTheme(base) : this.getDefaultThemeData();
      return dataUtils.defaultsDeep(dataUtils.deepCopy(theme), baseTheme);
    } else {
      return this.getDefaultThemeData();
    }
  };

  ThemeDataFactory.prototype._getTheme = function _getTheme(themeName) {
    var localThemeData = this._themeCache[themeName]; // TODO: localThemeData ? Promise.resolve(localThemeData) : this._fetchTheme(themeName);

    return localThemeData;
  };

  ThemeDataFactory.prototype._fetchTheme = function _fetchTheme(url) {
    var Delegate = WaveChartsRuntime.getDelegate();
    return Delegate.require(url);
  };

  ThemeDataFactory.defaultThemes = [{
    name: DefaultTheme.name,
    data: DefaultTheme
  }]; //

  var themeDataFactory$1 = ThemeDataFactory.getInstance();
  var instance$3 = null;

  var ThemeFactory = function ThemeFactory() {};

  ThemeFactory.getInstance = function getInstance() {
    if (!instance$3) {
      instance$3 = new ThemeFactory();
    }

    return instance$3;
  };

  ThemeFactory.prototype.fetchByName = function fetchByName(themeName) {
    var themeData = themeDataFactory$1.fetchByName(themeName);
    return new Theme(themeData);
  };

  ThemeFactory.prototype.fetchByConfig = function fetchByConfig(chartConfig) {
    var config = chartConfig || {
      base: "default",
      properties: null
    };
    var themeData = themeDataFactory$1.fetchByConfig(config);
    return new Theme(themeData);
  };

  ThemeFactory.prototype.getDefaultTheme = function getDefaultTheme() {
    return new Theme(themeDataFactory$1.getDefaultThemeData());
  };

  var counter = {};
  var counter$1 = {
    init: function init(name) {
      if (!(name in counter)) {
        counter[name] = 0;
      }

      return {
        next: function next() {
          return counter[name]++;
        },
        reset: function reset() {
          return counter[name] = 0;
        }
      };
    },
    counter: counter
  }; //
  //@flow-ignore

  var themeFactory = ThemeFactory.getInstance();
  var nodeCounter = counter$1.init('Node');
  /*::(x: Node<*,*,*>) => (x: INode<*,*,*,*>)*/

  var Node$1 = function (BaseNod____1) {
    function Node(props, silent) {
      if (!props) {
        props = {
          key: "$autogen_" + nodeCounter.next()
        };
      } else if (props.key == null) {
        props.key = "$autogen_" + nodeCounter.next();
      }

      BaseNod____1.call(this, props.key); //@flow-ignore

      this._props = {
        //@flow-ignore
        key: undefined,
        accessibility: undefined,
        zIndex: undefined
      };

      this._setDefaultProps();

      this.set(props, silent);
    }

    if (BaseNod____1) Node.__proto__ = BaseNod____1;
    Node.prototype = Object.create(BaseNod____1 && BaseNod____1.prototype);
    Node.prototype.constructor = Node; // Override to set default properties for a secific scene node type

    Node.prototype._setDefaultProps = function _setDefaultProps() {};
    /**
     * Callback when any change is observed on sensitive properties during set. It
     * will be invoked with diffOptions containing all changes. e.g. of diffOptions
     * format:
     * {
     *     a: [ newValue, oldValue],
     *     b: [ newValue, oldValue]
     * }
     * a and b are properties which values have been changed by set.
     */


    Node.prototype._onChange = function _onChange(diffOptions) {
      var diff = diffOptions.key;

      if (diff) {
        this._updateKey(diff[0]);
      }

      return;
    };
    /**
     * Map property values
     *
     * During set process, provide a way to map the original value to another value,
     * which will be eventually used in set. example usage,
     * - materialize color value(hex string to Color obj)
     * - materialize padding
     * - sanitize angle number
     */


    Node.prototype._mapValue = function _mapValue(prop, value) {
      return value;
    };
    /**
     * Get node type
     */


    Node.prototype.getType = function getType() {
      return this.constructor.type;
    };

    Node.prototype._setProp = function _setProp(prop, value, silent) {
      var obj;

      if (!this._props.hasOwnProperty(prop)) {
        return this;
      }

      this.markAsModified();

      if (silent) {
        this._props[prop] = this._mapValue(prop, value);
      } else {
        var sensitivePropSet = this.constructor._sensitiveProps && this.constructor._sensitiveProps.set;

        if (prop === "key" || sensitivePropSet && sensitivePropSet.hasOwnProperty(prop)) {
          var oldValue = this._props[prop];

          var newValue = this._mapValue(prop, value);

          this._props[prop] = newValue;

          if (oldValue !== newValue) {
            this._onChange((obj = {}, obj[prop] = [newValue, oldValue], obj));
          }
        } else {
          this._props[prop] = this._mapValue(prop, value);
        }
      }

      return this;
    }; // @perf-optimized


    Node.prototype._setProps = function _setProps(props, silent) {
      var this$1 = this;
      var propNames = lodash__default.keys(props);
      var thisProps = this._props;
      this.markAsModified();

      if (!silent) {
        var sensitivePropSet = this.constructor._sensitiveProps && this.constructor._sensitiveProps.set;
        var diffOptions;

        for (var i = 0; i < propNames.length; i++) {
          var prop = propNames[i];

          if (thisProps.hasOwnProperty(prop)) {
            var value = props[prop];

            if (prop === "key" || sensitivePropSet && sensitivePropSet.hasOwnProperty(prop)) {
              var oldValue = thisProps[prop];

              var newValue = this$1._mapValue(prop, value);

              thisProps[prop] = newValue;

              if (oldValue !== newValue) {
                if (!diffOptions) {
                  diffOptions = {};
                }

                diffOptions[prop] = [newValue, oldValue];
              }
            } else {
              thisProps[prop] = this$1._mapValue(prop, value);
            }
          }
        }

        if (diffOptions) {
          this._onChange(diffOptions);
        }
      } else {
        for (var i$1 = 0; i$1 < propNames.length; i$1++) {
          var prop$1 = propNames[i$1];

          if (thisProps.hasOwnProperty(prop$1)) {
            thisProps[prop$1] = this$1._mapValue(prop$1, props[prop$1]);
          }
        }
      }

      return this;
    };
    /**
     * Properties setter
     */


    Node.prototype.set = function set(props, value, silent) {
      if (typeof props === "string") {
        this._setProp(props, value, silent);
      } else {
        this._setProps(props, value);
      }

      return this;
    };
    /**
     * Properties getter
     */


    Node.prototype.get = function get(prop) {
      if (!prop) {
        return this._props;
      } else {
        return this._props[prop];
      }
    };

    Node.prototype.isGroup = function isGroup() {
      return false;
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------


    Node.prototype.getParentBackgroundColor = function getParentBackgroundColor() {
      var parent = this.getParent();
      return parent ? parent.getParentBackgroundColor() : themeFactory.getDefaultTheme().getBackgroundColor();
    }; // origin translation


    Node.prototype.translation = function translation() {
      return [0, 0];
    };

    Node.prototype.boundingBox = function boundingBox() {};

    Node.prototype.domainBox = function domainBox() {};

    Node.prototype.isVisible = function isVisible() {
      return true;
    }; //-----------------------------------------------------------------------------------------
    // transforms
    //-----------------------------------------------------------------------------------------


    Node.prototype.rotate = function rotate() {
      return this;
    };

    Node.prototype.flipY = function flipY() {
      return this;
    };

    Node.prototype.flipX = function flipX() {
      return this;
    };

    Node.prototype.offsetX = function offsetX(dx) {
      return this;
    };

    Node.prototype.offsetY = function offsetY(dy) {
      return this;
    };

    Node.prototype.center = function center(dx, dy) {
      return this;
    };

    Node.prototype.offsetAngle = function offsetAngle(alpha) {
      return this;
    };

    Node.prototype.totalTranslation = function totalTranslation(withScrollX, withScrollY) {
      if (withScrollX === void 0) withScrollX = false;
      if (withScrollY === void 0) withScrollY = false;
      var parent = this.getParent();
      var ref = parent ? parent.totalTranslation(withScrollX, withScrollY) : [0, 0];
      var parentX = ref[0];
      var parentY = ref[1];
      var ref$1 = this.translation();
      var x = ref$1[0];
      var y = ref$1[1];
      return [x + parentX, y + parentY];
    }; //--------------------------------------------
    // find
    //--------------------------------------------
    // Recusive find on all the nodes involved in the parent/child graph.
    // It returns an array
    // @param criteria {Map} map of criteria to apply to each node. The map is a set of name/value pairs,
    //        where the name maps to the name of a field in the node and the value is one of:
    //        - a regular expression: this will match any string value matching the regular expression
    //        - a function: the function will be passed the field value and should return whether the field matches
    //        - anything else: an exact match is required here (using lodash.isEqual)
    // @return {[IBaseNode]} return the array of basenodes matching the criteria
    //
    // An object matches the criteria if it matches *every* field-level critera
    //
    // Ex:
    // - scene.find({key: "rect1"})
    // -> this matches any node with the key 'rect1'
    //
    // - scene.find({key: /^rect/})
    // -> this matches any node where the key starts with 'rect' (so, 'rect', 'rect1', 'rect2', 'rect-xyz',...)
    //
    // - scene.find({amount: function(amount) { return amount > 100 && amount < 500 }})
    // -> this matches any node where the field 'amount' is between 100 and 500
    //
    // - scene.find({type: "Rect", key: /^r/})
    // -> this matches all the rectangle shapes with a key starting with 'r'


    Node.prototype.find = function fin____1(criteria) {
      var matches = [];

      var isMatch = function isMatch(obj) {
        for (var k in criteria) {
          var v = criteria[k];
          var objField = obj._props[k];
          var fieldMatch = k === "type" ? obj.getType() === v : lodash__default.isRegExp(v) ? lodash__default.isString(objField) && objField.match(v) : lodash__default.isFunction(v) ? v(objField) : lodash__default.isEqual(v, objField);

          if (!fieldMatch) {
            return false;
          }
        }

        return true;
      };

      this.traverse(function (obj) {
        if (isMatch(obj)) {
          matches.push(obj);
        }

        return obj;
      });
      return matches;
    };

    Node.prototype.toJson = function toJson(withChildren) {
      if (withChildren === void 0) withChildren = true;
      return {
        type: this.getType(),
        props: lodash__default.clone(this._props)
      };
    };

    return Node;
  }(BaseNode); //-ignore


  lodash__default.extend(Node$1.prototype, {
    // the node's original zIndex, when not in an interaction
    _originalZIndex: undefined,
    isUnderCursor: function isUnderCursor(x, y) {
      return false;
    },
    findShapeUnderPos: function findShapeUnderPos(x, y) {},
    isInArea: function isInArea(x, y, w, h) {
      return false;
    },
    findShapesInArea: function findShapesInArea(x, y, w, h) {
      return [];
    },
    //-----------------------------------------------------------------------------------------
    // renderer model
    //-----------------------------------------------------------------------------------------
    getModelProps: function getModelProps() {
      return {};
    },
    // convert to an isomorphic node model, which keeps the same
    // structure of the current node and all its descendants, but
    // each node is transformed. toModel is called recursively
    // on all descendants
    toModel: function toModel(modelClass, recursion) {
      this._roundFields();

      var props = this.getModelProps();

      if (!modelClass) {
        modelClass = NodeModel;
      }

      var nodeModel = new modelClass(props);
      return nodeModel;
    },
    clone: function clone() {
      return this.constructor.fromJson(this.toJson(), false);
    },

    /**
     * Round property values
     */
    _roundFields: function _roundFields() {
      var this$1 = this;

      if (this.constructor._roundProps) {
        this.constructor._roundProps.array.forEach(function (prop) {
          var val = this$1._props[prop];

          if (val != null) {
            this$1._props[prop] = Math.round(val);
          }
        });
      }
    }
  }); //-----------------------------------------------------------------------------------------
  //serialize/materialize
  //-----------------------------------------------------------------------------------------

  Node$1.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;

    if (deepCopy) {
      json = dataUtils.deepCopy(json);
    } // silent: true, does not trigger _set


    var node = new this(json.props, true);
    return node;
  }; //


  var geometryUtils = {
    /** Rotate point [x1, y1] by an angle pivot at (x, y)
     *
     * e.g.
     *  rotate([x1, y1], { x: x, y: y, angle: a}) -> [x2, y2]
     *
     *  (0, 0)
     *  +--------------
     *  |   (x, y)
     *  |    + ---------- * (x1, y1)
     *  |      ⟍) a
     *  |        ⟍
     *  |          ⟍
     *  |            ⟍
     *  |              * (x2, y2)
     *
     * @param origin {[number, number]} [x, y] point to rotate
     * @param rotation {Object} { x, y, angle } rotation definition
     * */
    rotate: function rotate(origin, rotation) {
      if (rotation) {
        var x = rotation.x;
        var y = rotation.y;
        var angle = rotation.angle;
        var x1 = origin[0];
        var y1 = origin[1];

        if (!angle) {
          return [x1, y1];
        } else {
          var dx = x1 - x;
          var dy = y1 - y;
          var cos = Math.cos(angle);
          var sin = Math.sin(angle);
          return [x + cos * dx - sin * dy, y + sin * dx + cos * dy];
        }
      }

      return origin;
    },
    // @return {[x, y]} coordinates of centroid of a set of points.
    // It is a more intelligent way of determining the center point
    // of a polygon (works on concave polygons)
    centroid: function centroid(points) {
      var area = this.area(points);

      if (area === 0) {
        return [0, 0];
      } else {
        var length = points.length;
        var x = 0;
        var y = 0;
        var i = 0;
        var j = length - 1;

        while (i < length) {
          var point1 = points[i];
          var point2 = points[j];
          var f = point1[0] * point2[1] - point2[0] * point1[1];
          x += (point1[0] + point2[0]) * f;
          y += (point1[1] + point2[1]) * f;
          j = i;
          i += 1;
        }

        area *= 6;
        return [x / area, y / area];
      }
    },
    // @return {Number} area of a set of points.
    // Note that this used the extended definition of 'area' for concave polygons
    // (meaning the area could be negative or even null for some shapes)
    area: function area(points) {
      var length = points.length;
      var area = 0;
      var i = 0;
      var j = length - 1;

      while (i < length) {
        var point1 = points[i];
        var point2 = points[j];
        area += point1[0] * point2[1];
        area -= point1[1] * point2[0];
        j = i;
        i += 1;
      }

      area /= 2;
      return area;
    },
    multiPolygonCentroid: function multiPolygonCentroid(coordinates) {
      var this$1 = this;
      var maxArea = -Infinity;
      var maxPoly = coordinates[0]; // let's first find the 'largest' polygon

      coordinates.forEach(function (poly) {
        var area = Math.abs(this$1.area(poly[0]));

        if (area > maxArea) {
          maxArea = area;
          return maxPoly = poly;
        }
      });
      return this.centroid(maxPoly[0]);
    }
  };
  var deepCopy = dataUtils.deepCopy;
  var rotate = geometryUtils.rotate;

  var Box = function Box(boxProperties) {
    var assign;
    assign = this._convertToXYWH(boxProperties), this.x = assign.x, this.y = assign.y, this.w = assign.w, this.h = assign.h, this.rotation = assign.rotation; // Always sanitize box

    this._sanitize();
  }; // Center coordinate of the box


  Box.initClass = function initClass() {
    /*
    Box
    	Represents a rectangular area on a Cartesian coordinate system in two dimensions
    	- (x, y) is the top left coordinate of box
    - w, h are width and height, always positive
    - rotation { x, y, angle } defines the rotating pivot(x, y) and angle(radian) of the box
    	e.g.
    1) no rotation
    box { x, y, w, h }
    	            w
    	 (x, y) +_______
    	        |       |
    	        |       | h
    	        |  box  |
    	        |       |
    	         -------
    2) rotation pivot at box's top-left point
    box {x, y, w, h, rotation: { x, y, angle: a }}
    		(x, y)
    	 _______+_____
    |      ⟋⟍)a  |
    |    ⟋    ⟍  |
    |  ⟋      w ⟍|
    |⟋   box    ⟋|
    |⟍        ⟋  |
    |  ⟍   h⟋    | <- box.toAABB()
    |____⟍⟋______|
    
    @author alice.chen
    */
    this.prototype.x = 0;
    this.prototype.y = 0;
    this.prototype.w = 0;
    this.prototype.h = 0;
    this.prototype.rotation = null;
  }; // Compute the smallest bounding box of all boxes
  //
  // @param boxes {Array} array of boxes


  Box.boundingBox = function boundingBox(boxes) {
    var h, w, x, y;
    boxes = lodash__default.filter(boxes, lodash__default.identity);

    if (boxes.length === 0) {
      return null;
    }

    var x0 = Infinity;
    var y0 = Infinity;
    var x1 = -Infinity;
    var y1 = -Infinity;
    boxes.forEach(function (box) {
      var assign;
      assign = box, x = assign.x, y = assign.y, w = assign.w, h = assign.h;

      if (x < x0) {
        x0 = x;
      }

      if (y < y0) {
        y0 = y;
      }

      if (x + w > x1) {
        x1 = x + w;
      }

      if (y + h > y1) {
        y1 = y + h;
      }
    });
    return new Box({
      x: x0,
      y: y0,
      w: x1 - x0,
      h: y1 - y0
    });
  }; // figure out the scaling factor between two rectangle
  // it will to fit the innerRect into the outerRect
  // by figuring out which dimension is the limiting one
  //
  // @params innerRect {[w, h]} the inner rect
  // @params outerRect {[w, h]} the outer rect
  // @return scaleFactor {Number} scale multiplier by which to scale the innerRect


  Box.scaleFactorToFit = function scaleFactorToFit(innerRect, outerRect) {
    var innerW = innerRect[0];
    var innerH = innerRect[1];
    var outerW = outerRect[0];
    var outerH = outerRect[1];
    var outerRatio = outerW / outerH;
    var innerRatio = innerW / innerH;

    if (outerRatio > innerRatio) {
      // height is limiting factor
      return outerH / innerH;
    } else {
      // width is limiting factor
      return outerW / innerW;
    }
  };

  Box.prototype.getCenter = function getCenter() {
    return [this.x + this.w / 2, this.y + this.h / 2];
  }; // Returns a box relative to current box
  // @param {String} position "top|bottom|left|right" relative to current box
  // @param {Number} size of the new box


  Box.prototype.getRelativeBox = function getRelativeBox(position, size) {
    size = this._sanitizeNumber(size);
    var offset = size / 2;
    var ref = this.getCenter();
    var xCenter = ref[0];
    var yCenter = ref[1];
    var x, y;

    switch (position) {
      case "top":
        var assign;
        assign = [xCenter - offset, this.y], x = assign[0], y = assign[1];
        break;

      case "bottom":
        var assign$1;
        assign$1 = [xCenter - offset, this.y + this.h - size], x = assign$1[0], y = assign$1[1];
        break;

      case "left":
        var assign$2;
        assign$2 = [this.x, yCenter - offset], x = assign$2[0], y = assign$2[1];
        break;

      default:
        //default to "right"
        var assign$3;
        assign$3 = [this.x + this.w - size, yCenter - offset], x = assign$3[0], y = assign$3[1];
        break;
    }

    return new Box({
      x: x,
      y: y,
      w: size,
      h: size,
      rotation: this.rotation
    });
  }; // allow you to create boxes with different formats:
  // - x, y, w, h
  // - top, left, bottom, right
  // - x0, y0, x1, y1
  //
  // This function will convert everything to x, y, w, h
  //
  // @params boxProperties {Object} an object of one of the following formats:
  //   - {x, y, w, h, rotation}
  //   - {top, left, bottom, right, rotation}
  //   - {x0, y0, x1, y1, rotation}
  // @return {Object} {x, y, w, h, rotation}


  Box.prototype._convertToXYWH = function _convertToXYWH(boxProperties) {
    var rotation;

    if (boxProperties.left != null) {
      var bottom, left, right, top;
      var assign;
      assign = boxProperties, left = assign.left, right = assign.right, top = assign.top, bottom = assign.bottom, rotation = assign.rotation;
      return {
        x: left,
        y: top,
        w: right - left,
        h: bottom - top,
        rotation: rotation
      };
    } else if (boxProperties.x0 != null) {
      var x0, x1, y0, y1;
      var assign$1;
      assign$1 = boxProperties, x0 = assign$1.x0, y0 = assign$1.y0, x1 = assign$1.x1, y1 = assign$1.y1, rotation = assign$1.rotation;
      return {
        x: x0,
        y: y0,
        w: x1 - x0,
        h: y1 - y0,
        rotation: rotation
      };
    } else {
      return boxProperties;
    }
  }; // Convert a number to 2 decimal digits


  Box.prototype._toFixed2 = function _toFixed2(n) {
    // Math.round(n)
    return Math.round(n * 100) / 100;
  };

  Box.prototype.clone = function clone() {
    return new Box(this.toJson());
  }; // Convert to array representation [x, y, w, h] with 2 decimal digits


  Box.prototype.toArray = function toArray() {
    return [this._toFixed2(this.x), this._toFixed2(this.y), this._toFixed2(this.w), this._toFixed2(this.h)];
  };

  Box.prototype.toJson = function toJson() {
    if (this.hasRotation()) {
      return {
        x: this.x,
        y: this.y,
        w: this.w,
        h: this.h,
        rotation: deepCopy(this.rotation)
      };
    } else {
      return {
        x: this.x,
        y: this.y,
        w: this.w,
        h: this.h
      };
    }
  }; // Returns the coordinates of box's four vertices


  Box.prototype.toVertices = function toVertices(withRotation) {
    var this$1 = this;

    if (withRotation == null) {
      withRotation = true;
    }

    var vertices = [[this.x, this.y], [this.x + this.w, this.y], [this.x, this.y + this.h], [this.x + this.w, this.y + this.h]];

    if (this.hasRotation() && withRotation) {
      vertices = vertices.map(function (p) {
        return rotate(p, this$1.rotation);
      });
    }

    return vertices;
  }; // Returns the AABB(axis-aligned bounding box) of current box


  Box.prototype.toAABB = function toAABB() {
    if (this.hasRotation()) {
      var vertices = this.toVertices();
      var xMin = vertices[0][0];
      var xMax = vertices[0][0];
      var yMin = vertices[0][1];
      var yMax = vertices[0][1];

      for (var i = 1; i < 4; ++i) {
        var ref = vertices[i];
        var x = ref[0];
        var y = ref[1];

        if (x < xMin) {
          xMin = x;
        }

        if (x > xMax) {
          xMax = x;
        }

        if (y < yMin) {
          yMin = y;
        }

        if (y > yMax) {
          yMax = y;
        }
      }

      return new Box({
        x: xMin,
        y: yMin,
        w: xMax - xMin,
        h: yMax - yMin
      });
    } else {
      return this;
    }
  }; // Detect if box contains (x, y) coordinate
  //
  // @param x {Number} x coordinate
  // @param y {Number} y coordinate
  // @return {Boolean}


  Box.prototype.contains = function contains(x, y) {
    if (this.hasRotation()) {
      var assign;
      assign = rotate([x, y], {
        x: this.rotation.x,
        y: this.rotation.y,
        angle: -this.rotation.angle
      }), x = assign[0], y = assign[1];
    }

    return x >= this.x && x <= this.x + this.w && y >= this.y && y <= this.y + this.h;
  };

  Box.prototype.hasRotation = function hasRotation() {
    return this.rotation != null ? this.rotation.angle : undefined;
  }; // Offset box by tx on x dimension, ty on y dimension
  //
  // @param tx {Number} offset x
  // @param ty {Number} offset y


  Box.prototype.offset = function offset(tx, ty) {
    this.x += tx;
    this.y += ty;

    if (this.hasRotation()) {
      this.rotation.x += tx;
      this.rotation.y += ty;
    }

    return this;
  }; // Add padding(positive) to box
  //
  // @param padding {Object} { top, right, bottom, left } on each location


  Box.prototype.padBy = function padBy(param) {
    if (param == null) {
      param = {};
    }

    var top = param.top;
    var right = param.right;
    var bottom = param.bottom;
    var left = param.left;

    if (top) {
      this._padTop(top);
    }

    if (right) {
      this._padRight(right);
    }

    if (bottom) {
      this._padBottom(bottom);
    }

    if (left) {
      this._padLeft(left);
    }

    return this;
  }; // Add padding(positive) to box on all four locations
  //
  // @param v {Number} padding


  Box.prototype.padAll = function padAll(v) {
    if (!v) {
      return this;
    }

    this._padTop(v);

    this._padRight(v);

    this._padBottom(v);

    return this._padLeft(v);
  }; // Add top padding(positive) to box
  //
  // @param v {Number} padding


  Box.prototype._padTop = function _padTop(v) {
    if (v == null) {
      v = 0;
    }

    this.h += v;
    this.y -= v;
    return this;
  }; // Add bottom padding(positive) to box
  //
  // @param v {Number} padding


  Box.prototype._padBottom = function _padBottom(v) {
    if (v == null) {
      v = 0;
    }

    this.h += v;
    return this;
  }; // Add left padding(positive) to box
  //
  // @param v {Number} padding


  Box.prototype._padLeft = function _padLeft(v) {
    if (v == null) {
      v = 0;
    }

    this.w += v;
    this.x -= v;
    return this;
  }; // Add right padding(positive) to box
  //
  // @param v {Number} padding


  Box.prototype._padRight = function _padRight(v) {
    if (v == null) {
      v = 0;
    }

    this.w += v;
    return this;
  }; // Sanitize property value
  //
  // @param {Number} n property value


  Box.prototype._sanitizeNumber = function _sanitizeNumber(n) {
    if (lodash__default.isNumber(n)) {
      return n;
    } else {
      return 0;
    }
  }; // Ensure box has numbers for x, y, w, h
  // Ensure box has positive w and h


  Box.prototype._sanitize = function _sanitize() {
    this.x = this._sanitizeNumber(this.x);
    this.y = this._sanitizeNumber(this.y);
    this.w = this._sanitizeNumber(this.w);
    this.h = this._sanitizeNumber(this.h);

    if (this.w < 0) {
      this.x += this.w;
      this.w = -this.w;
    }

    if (this.h < 0) {
      this.y += this.h;
      this.h = -this.h;
    }

    return this;
  }; // Given two boxes, determine if they intersects
  // @param {Box} box the target box


  Box.prototype.intersect = function intersect(box, boxY, boxW, boxH) {
    if (typeof box !== 'object') {
      return this._intersect1D(this.x, this.w, box, boxW) && this._intersect1D(this.y, this.h, boxY, boxH);
    } else {
      return this._intersect1D(this.x, this.w, box.x, box.w) && this._intersect1D(this.y, this.h, box.y, box.h);
    }
  };

  Box.prototype._intersect1D = function _intersect1D(x0, l0, x1, l1) {
    if (l0 < 0) {
      x0 = x0 + l0 + 1;
      l0 = -l0;
    }

    if (l1 < 0) {
      x1 = x1 + l1 + 1;
      l1 = -l1;
    }

    return this._intersect1DNormalized(x0, l0, x1, l1);
  };

  Box.prototype._intersect1DNormalized = function _intersect1DNormalized(x0, l0, x1, l1) {
    var r0 = x0 + l0 - 1;
    var r1 = x1 + l1 - 1;
    var noIntersect = r0 < x1 || r1 < x0;
    return !noIntersect;
  };

  Box.prototype.intersectLine = function intersectLine(x0, y0, x1, y1) {
    var this$1 = this;
    var ref = this;
    var x = ref.x;
    var y = ref.y;
    var w = ref.w;
    var h = ref.h;
    var vertices = [[x, y], [x + w - 1, y], [x + w - 1, y + h - 1], [x, y + h - 1]];
    var isSameSide = true;
    var isAbove = 1;

    for (var i = 0; i < 4; i++) {
      var intersection = this$1._isAboveLine(x0, y0, x1, y1, vertices[i][0], vertices[i][1]);

      if (intersection === 0) {
        // a vertex is on the line
        return true;
      } else if (i === 0) {
        isAbove = +(intersection > 0);
      } else if (isAbove ^ +(intersection > 0) === 1) {
        isSameSide = false;
        break;
      }
    }

    if (!isSameSide) {
      var lx = w >= 0 ? x : x + w + 1;
      var rx = w >= 0 ? x + w - 1 : x;
      var ty = h >= 0 ? y : y + h + 1;
      var by = h >= 0 ? y + h - 1 : y;
      return !(x0 < lx && x1 < lx || x0 > rx && x1 > rx || y0 < ty && y1 < ty || y0 > by && y1 > by);
    } else {
      return false;
    }
  };

  Box.prototype._isAboveLine = function _isAboveLine(x0, y0, x1, y1, x, y) {
    return (y1 - y0) * x + (x0 - x1) * y + (x1 * y0 - x0 * y1);
  }; // Given another box, determine if there is an intersection
  // If so, return the overflow of each side of the base box ex. {left: x0 - x1, bottom: (y0 + h1) - (y1 + h1) }
  // If not, return null
  //          (x0, y0) w1
  //             -----------
  //   	       |           |
  //            |           |  h1
  // (x1, y1) -----         |
  //         | w2  |--------
  //         |     | h2
  //          -----
  // @param {Box} box the target box


  Box.prototype.overflow = function overflow(box) {
    var xDir = this._overflow1D(this.x, this.w, box.x, box.w);

    var yDir = this._overflow1D(this.y, this.h, box.y, box.h);

    if (this.intersect(box) && (xDir || yDir)) {
      return {
        left: xDir && xDir.left,
        right: xDir && xDir.right,
        top: yDir && yDir.left,
        bottom: yDir && yDir.right
      };
    } else {
      return null;
    }
  };

  Box.prototype._overflow1D = function _overflow1D(x0, l0, x1, l1) {
    var r0 = x0 + l0 - 1;
    var r1 = x1 + l1 - 1;
    var noOverflow = r0 < x1 || r1 < x0 || x1 > x0 && r1 < r0;

    if (noOverflow) {
      return null;
    }

    return {
      left: x1 <= x0 ? x1 - x0 : null,
      right: r1 >= r0 ? r1 - r0 : null
    };
  };

  Box.initClass();
  var boxUtils = {
    boundingBox: function boundingBox(nodes, withTranslation) {
      return Box.boundingBox(nodes.map(function (node) {
        return node.boundingBox(withTranslation);
      }));
    },
    domainBox: function domainBox(nodes) {
      return Box.boundingBox(nodes.map(function (node) {
        return node.domainBox();
      }));
    }
  };
  var layoutShapesUtils = {
    applyLayout: function applyLayout(objs, params) {
      var bb, i, obj;
      var spacer, reverse;

      switch (params.type) {
        case "vbox":
          var assign;
          assign = params, spacer = assign.spacer, reverse = assign.reverse;

          if (spacer == null) {
            spacer = 0;
          }

          var newY = 0;

          for (i = 0; i < objs.length; i++) {
            obj = objs[i];
            bb = obj.boundingBox(true);

            if (!bb) {
              continue;
            }

            if (i === 0) {
              newY = bb.y;

              if (reverse) {
                continue;
              }
            }

            if (reverse) {
              newY -= bb.h + spacer;
            } // bottom to top


            obj.offsetY(newY - bb.y);

            if (!reverse) {
              newY += bb.h + spacer;
            }
          } // top to bottom


          break;

        case "hbox":
          var assign$1;
          assign$1 = params, spacer = assign$1.spacer, reverse = assign$1.reverse;

          if (spacer == null) {
            spacer = 0;
          }

          var newX = 0;

          for (i = 0; i < objs.length; i++) {
            obj = objs[i];
            bb = obj.boundingBox(true);

            if (!bb) {
              continue;
            }

            if (i === 0) {
              newX = bb.x;

              if (reverse) {
                continue;
              }
            }

            if (reverse) {
              newX -= bb.w + spacer;
            } // right to left


            obj.offsetX(newX - bb.x);

            if (!reverse) {
              newX += bb.w + spacer;
            }
          } // left to right


          break;

        case "stackX":
          var separatePosNeg = params.separatePosNeg;
          var cumulativeProp = params.cumulativeProp;
          this.applyStackLayout(objs, separatePosNeg, cumulativeProp, function (shape, totalOffset) {
            return shape.offsetX(totalOffset);
          });
          break;

        case "stackY":
          var assign$2;
          assign$2 = params, separatePosNeg = assign$2.separatePosNeg, cumulativeProp = assign$2.cumulativeProp;
          this.applyStackLayout(objs, separatePosNeg, cumulativeProp, function (shape, totalOffset) {
            return shape.offsetY(totalOffset);
          });
          break;

        case "stackAngle":
          var assign$3;
          assign$3 = params, separatePosNeg = assign$3.separatePosNeg;
          this.applyStackLayout(objs, separatePosNeg, "angle", function (shape, totalOffset) {
            return shape.offsetAngle(totalOffset);
          });
          break;

        case "normalizeX":
          var measureProp = params.measureProp; // let's first compute the value range of the stack

          var maxPositive = 0;
          var minNegative = 0;
          objs.forEach(function (obj) {
            var value = obj.get("w");

            if (value > 0) {
              maxPositive += value;
            } else {
              minNegative += value;
            }
          });
          var fullRange = maxPositive - minNegative;
          var multiplier = fullRange ? 100 / fullRange : 0; // now, let's normalize the width

          objs.forEach(function (obj) {
            var percent = obj.get("w") * multiplier;
            obj.set({
              w: percent
            });
          });
          this.applyLayout(objs, {
            type: "stackX",
            cumulativeProp: "w"
          });
          break;
      }
    },
    applyStackLayout: function applyStackLayout(objs, separatePosNeg, prop, offsetFct) {
      if (separatePosNeg == null) {
        separatePosNeg = true;
      }

      var positive = separatePosNeg ? objs.filter(function (obj) {
        return obj.get(prop) >= 0;
      }) : objs;
      var negative = separatePosNeg ? objs.filter(function (obj) {
        return obj.get(prop) < 0;
      }) : [];

      var stack = function stack(objs, prop, offsetFct) {
        var p0 = 0;
        return objs.map(function (obj) {
          var delta = obj.get(prop);
          offsetFct(obj, p0);
          p0 += delta;
          return p0;
        });
      };

      stack(positive, prop, offsetFct);
      return stack(negative, prop, offsetFct);
    }
  }; //
  //@flow-ignore

  /*::(x: Group<*,*,*>) => (x: IGroup<*,*,*,*>)*/

  var Group$1 = function (Node) {
    function Group() {
      Node.apply(this, arguments);
    }

    if (Node) Group.__proto__ = Node;
    Group.prototype = Object.create(Node && Node.prototype);
    Group.prototype.constructor = Group;

    Group.prototype.isGroup = function isGroup() {
      return true;
    };
    /**
     * Group level nodes, which are not leaf and can
     * contain child scene nodes, e.g. layer, cell, shapeGroup, they
     * all represent a logical grouping of shapes
     *
     * @author alice.chen
     */


    Group.prototype._setDefaultProps = function _setDefaultProps() {
      Node.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.zIndex = 0;
      props.transforms = {};
      props.skipTransforms = false;
    }; //-----------------------------------------------------------------------------------------
    // iteration
    //-----------------------------------------------------------------------------------------


    Group.prototype.forEach = function forEach(fct) {
      this.getChildren().forEach(fct);
      return this;
    };

    Group.prototype.map = function map(fct) {
      return this.getChildren().map(fct);
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------
    // returns the boundingBox of all children
    //
    // @param withTranslation {Boolean} if boundingBox includes translation on current group


    Group.prototype.boundingBox = function boundingBox(withTranslation) {
      if (withTranslation === void 0) withTranslation = false;
      var children = this.getChildren();
      var bb = boxUtils.boundingBox(children, true);

      if (bb && withTranslation) {
        bb.offset.apply(bb, this.translation());
      }

      return bb;
    }; // origin translation


    Group.prototype.translation = function translation() {
      return [0, 0];
    }; // returns the domainBox of all children


    Group.prototype.domainBox = function domainBox() {
      return boxUtils.domainBox(this.getChildren());
    };

    Group.prototype.toScenePosition = function toScenePosition(x, y, includeScroll) {
      if (includeScroll === void 0) includeScroll = true;
      return [x, y];
    };

    Group.prototype.toLocalPosition = function toLocalPosition(x, y, includeScroll) {
      if (includeScroll === void 0) includeScroll = true;
      return [x, y];
    }; // apply layout on all children
    // - cell -> layers
    // - layer -> shapes


    Group.prototype.applyLayout = function applyLayout(params) {
      layoutShapesUtils.applyLayout(this.getChildren(), params);
      return this;
    };

    Group.prototype.toJson = function toJson(withChildren) {
      if (withChildren === void 0) withChildren = true;
      var json = Node.prototype.toJson.call(this);

      if (withChildren) {
        json.children = this.getChildren().map(function (child) {
          return child.toJson(true);
        });
      }

      return json;
    };

    return Group;
  }(Node$1); //
  //@flow-ignore


  var NodeFactory = null;

  var __super__$2 = Object.getPrototypeOf(Group$1.prototype);

  lodash__default.extend(Group$1.prototype, {
    // is cursor under current group
    // - for cell, look at the boundry since no shape should go out of cell
    // - for layer and scene, always true
    isUnderCursor: function isUnderCursor(x, y) {
      return true;
    },
    isInArea: function isInArea(x, y, w, h) {
      return true;
    },
    isUnderLine: function isUnderLine(x0, y0, x1, y1) {
      return true;
    },
    // Find shape to interact which is under (x, y)
    //
    // @param {Number} x coordinate
    // @param {Number} y coordinate
    // @return {Shape}
    findShapeUnderPos: function findShapeUnderPos(x, y) {
      // note:
      // - we need to do everything in reverse drawing order
      var children = this.getChildren();
      var sortedChildren = lodash__default.sortBy(children, function (shape) {
        return shape.get("zIndex") || 0;
      });

      for (var i = sortedChildren.length - 1; i >= 0; i--) {
        var child = sortedChildren[i];

        if (child.get("skipInFind")) {
          continue;
        }

        var ref = child.translation();
        var tx = ref[0];
        var ty = ref[1];

        if (!child.isUnderCursor(x - tx, y - ty)) {
          continue;
        }

        var shape = child.findShapeUnderPos(x - tx, y - ty);

        if (shape) {
          return shape;
        }
      }

      return null;
    },
    findShapesInArea: function findShapesInArea(x, y, w, h) {
      var children = this.getChildren();
      var shapes = [];

      for (var i = children.length - 1; i >= 0; i--) {
        var child = children[i];

        if (child.get("skipInFind")) {
          continue;
        }

        var ref = child.translation();
        var tx = ref[0];
        var ty = ref[1];

        if (!child.isInArea(x - tx, y - ty, w, h)) {
          continue;
        }

        shapes = shapes.concat(child.findShapesInArea(x - tx, y - ty, w, h));
      }

      return shapes;
    },
    findShapeUnderLine: function findShapeUnderLine(x0, y0, x1, y1) {
      var children = this.getChildren();
      var shapes = [];

      for (var i = children.length - 1; i >= 0; i--) {
        var child = children[i];

        if (child.get("skipInFind")) {
          continue;
        }

        var ref = child.translation();
        var tx = ref[0];
        var ty = ref[1];

        if (!child.isUnderLine(x0 - tx, y0 - ty, x1 - tx, y1 - ty)) {
          continue;
        }

        shapes = shapes.concat(child.findShapeUnderLine(x0 - tx, y0 - ty, x1 - tx, y1 - ty));
      }

      return shapes;
    },
    //--------------------------------------------------------------------------------
    // transforms
    //--------------------------------------------------------------------------------
    rotate: function rotate() {
      if (this.get("skipTransforms")) {
        return this;
      }

      this.getChildren().forEach(function (child) {
        return child.rotate();
      });
      return this;
    },
    flipY: function flipY() {
      if (this.get("skipTransforms")) {
        return this;
      }

      this.getChildren().forEach(function (child) {
        return child.flipY();
      });
      return this;
    },
    flipX: function flipX() {
      if (this.get("skipTransforms")) {
        return this;
      }

      this.getChildren().forEach(function (child) {
        return child.flipX();
      });
      return this;
    },
    // move each member in group on x coordinate by dx
    offsetX: function offsetX(dx) {
      this.getChildren().forEach(function (child) {
        return child.offsetX(dx);
      });
      return this;
    },
    // move each member in group on y coordinate by dy
    offsetY: function offsetY(dy) {
      this.getChildren().forEach(function (child) {
        return child.offsetY(dy);
      });
      return this;
    },
    center: function center(dx, dy) {
      if (this.get("skipTransforms")) {
        return this;
      }

      this.getChildren().forEach(function (child) {
        if (!child.get("skipTransforms")) {
          if (dx) {
            child.offsetX(dx);
          }

          if (dy) {
            child.offsetY(dy);
          }
        }
      });
      return this;
    },
    // move each member in group on polar coordinate by alpha
    offsetAngle: function offsetAngle(alpha) {
      this.getChildren().forEach(function (child) {
        return child.offsetAngle(alpha);
      });
      return this;
    },
    //
    //Group
    //
    applyTransforms: function applyTransforms(transforms) {
      if (transforms) {
        if (transforms.rotate) {
          this.rotate();
        }

        if (transforms.flipX) {
          this.flipX();
        }

        if (transforms.flipY) {
          this.flipY();
        }

        if (transforms.center && this.center) {
          this.center();
        }
      }

      return this;
    },
    postProcess: function postProcess() {
      this.applyTransforms(this._props.transforms);
      return this;
    },
    // convert to an isomorphic node model, which keeps the same
    // structure of the current node and all its descendants, but
    // each node is transformed. toModel is called recursively
    // on all descendants
    toModel: function toModel(modelClass, recursion, prune) {
      if (recursion === void 0) recursion = false;
      if (prune === void 0) prune = true;

      if (prune && !this.getChildren().length) {
        return null;
      }

      var model = __super__$2.toModel.call(this, modelClass || GroupModel); // sort the children when building the model so that the zIndex is respected


      if (recursion) {
        this.getChildren().forEach(function (child) {
          var childModel = child.toModel();

          if (Array.isArray(childModel)) {
            model.appendAll(childModel);
          } else {
            model.append(childModel);
          }
        });
      }

      return model;
    }
  });

  Group$1.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;

    if (deepCopy) {
      json = dataUtils.deepCopy(json);
    }

    var node = __super__$2.constructor.fromJson.call(this, json, false);

    if (json.children) {
      json.children.forEach(function (childJson) {
        //@flow-ignore
        node.append(NodeFactory.fromJson(childJson, false));
      });
    }

    return node;
  };

  Group$1.setNodeFactoryImpl = function (nodeFactoryImpl) {
    NodeFactory = nodeFactoryImpl;
  };

  var mathUtils = {
    getMinMax: function getMinMax(arr) {
      return [lodash__default.min(arr), lodash__default.max(arr)];
    },
    sum: function sum(arr) {
      return lodash__default.reduce(arr, function (acc, n) {
        return acc + n;
      }, 0);
    },
    avg: function avg(arr) {
      return this.sum(arr) / arr.length;
    },
    sortNumbers: function sortNumbers(arr) {
      return arr.slice().sort(function (a, b) {
        return a - b;
      });
    },
    round2d: function round2d(n) {
      return Math.round(n * 100) / 100;
    },
    isInRange: function isInRange(x, start, end, tolerance) {
      if (tolerance === void 0) tolerance = 0;
      var max = Math.max(start, end);
      var min = Math.min(start, end);
      return min - tolerance <= x && x <= max + tolerance;
    },

    /**
     * Calculate the closest round number above n, which is N * (power of 10)
     * e.g. 245 -> 300, 999 -> 1000, 6182 -> 7000
     * @param  {number} n number to round
     * @return {number}
     */
    roundUp: function roundUp(n) {
      var pow10 = Math.pow(10, Math.floor(Math.log(Math.abs(n)) / Math.LN10));
      return Math.ceil(n / pow10) * pow10;
    },
    // Returns a function which is a linear interpolation of an array of given points
    // e.g.
    // f = interpolate([a1, a2])
    // f(n, true)
    //      ^ y
    //      |         *-----------
    //      |        / a2
    //      |       /
    //      |      /
    //      |     /
    // -----|----*
    //      |     a1
    // -----|-----------------------> x
    //      |
    //      |
    //
    // f(n, false)
    //      ^ y        /
    //      |         *
    //      |        / a2
    //      |       /
    //      |      /
    //      |     /
    //      |    *
    //      |   / a1
    // -----|--/--------------------> x
    //      | /
    //      |/
    //
    // @param points {Array} points to define interpolation function
    // @return {Function} value - number to map, clamp - clamp the result and both ends
    interpolate: function interpolate() {
      var points = [],
          len = arguments.length;

      while (len--) {
        points[len] = arguments[len];
      }

      var i, p0;

      if (points.length < 2) {
        return function () {
          return points[0] && points[0][1] ? points[0][1] : 0;
        };
      }

      points.sort(function (p0, p1) {
        return p0[0] - p1[0];
      });
      var n = points.length;
      var a = [];

      for (i = 0; i < n - 1; i++) {
        p0 = points[i];
        var p1 = points[i + 1];
        var x0 = p0[0];
        var y0 = p0[1];
        var x1 = p1[0];
        var y1 = p1[1];
        a.push((y1 - y0) / (x1 - x0));
      }

      a.push(a[n - 2]);
      return function (value, clamp) {
        if (clamp == null) {
          clamp = false;
        }

        if (clamp) {
          if (value >= points[n - 1][0]) {
            return points[n - 1][1];
          } else if (value <= points[0][0]) {
            return points[0][1];
          }
        }

        for (i = 0; i < points.length; i++) {
          p0 = points[i];

          if (p0[0] >= value) {
            break;
          }
        }

        if (i) {
          i--;
        }

        return a[i] * (value - points[i][0]) + points[i][1];
      };
    }
  };

  var OrderedMap = function OrderedMap() {
    this.reset();
  };

  OrderedMap.prototype.reset = function reset() {
    this._keys = [];
    return this._valueMap = {};
  }; // Remove from map by key
  //
  // @param {String} key of the value to remove
  //
  // @return the value which got removed from map


  OrderedMap.prototype.remove = function remove(key) {
    if (!this._valueMap.hasOwnProperty(key)) {
      return undefined;
    }

    var index = this._keys.indexOf(key);

    this._keys.splice(index, 1);

    var value = this._valueMap[key];
    delete this._valueMap[key];
    return value;
  }; // Add a key value pair to map
  //
  // if value is not specified, its equivalent to @remove(key)
  //
  // @param {Any} key to add
  // @param {Any} value to add
  //
  // @return the value which got added to map


  OrderedMap.prototype.put = function put(key, value) {
    if (value === undefined) {
      this.remove(key);
    } else {
      if (!this._valueMap.hasOwnProperty(key)) {
        this._keys.push(key);
      }

      this._valueMap[key] = value;
    }

    return value;
  }; // Get the value by key
  //
  // @param {Any} key to get value by
  //
  // @return value for key


  OrderedMap.prototype.get = function get(key) {
    return this._valueMap[key];
  }; // Get all keys in map in the order of addition
  //
  // @return {Array} array of keys


  OrderedMap.prototype.getKeys = function getKeys() {
    return this._keys;
  }; // Get all values in map in the order of addition
  //
  // @return {Array} array of values


  OrderedMap.prototype.getValues = function getValues() {
    var this$1 = this;
    return this._keys.map(function (key) {
      return this$1._valueMap[key];
    });
  }; // Get size of map
  //
  // @return {Number} number of elements


  OrderedMap.prototype.size = function size() {
    return this._keys.length;
  }; // Sort keys


  OrderedMap.prototype.sortKeys = function sortKeys() {
    return this._keys.sort();
  }; // Sort keys with compare fct
  // @param {Function} fct a compare function which takes two **values**(not keys)


  OrderedMap.prototype.sortBy = function sortBy(fct) {
    var this$1 = this;
    this._keys = this._keys.sort(function (k0, k1) {
      return fct(this$1.get(k0), this$1.get(k1));
    });
    return this;
  };

  var NestedRowsNode = function (OrderedMa____1) {
    function NestedRowsNode(key, displayKey) {
      OrderedMa____1.call(this);
      this._key = key;
      this._displayKey = displayKey;
    }

    if (OrderedMa____1) NestedRowsNode.__proto__ = OrderedMa____1;
    NestedRowsNode.prototype = Object.create(OrderedMa____1 && OrderedMa____1.prototype);
    NestedRowsNode.prototype.constructor = NestedRowsNode;

    NestedRowsNode.prototype.getKey = function getKey() {
      return this._key;
    };

    NestedRowsNode.prototype.getDisplayKey = function getDisplayKey() {
      return this._displayKey;
    };

    NestedRowsNode.prototype.setIsLeaf = function setIsLeaf(isLeaf) {
      this._isLeaf = isLeaf;
      return this;
    };

    NestedRowsNode.prototype.isLeaf = function isLeaf() {
      return this._isLeaf;
    };

    NestedRowsNode.prototype.setBaseRows = function setBaseRows(rows) {
      this._baseRows = rows;
      return this;
    };

    NestedRowsNode.prototype.getBaseRows = function getBaseRows() {
      return this._baseRows;
    };

    NestedRowsNode.prototype.setLayout = function setLayout(_layout) {
      this._layout = _layout;
      return this;
    };

    NestedRowsNode.prototype.getLayout = function getLayout() {
      return this._layout;
    }; // Set a rollup value on a column


    NestedRowsNode.prototype.setRollupValue = function setRollupValue(column, value) {
      if (this._rollupInfo == null) {
        this._rollupInfo = {};
      }

      this._rollupInfo[column.getName()] = value;
      return this;
    }; // Retrieve a rollup value on a column


    NestedRowsNode.prototype.getRollupValue = function getRollupValue(column) {
      return this._rollupInfo != null ? this._rollupInfo[column.getName()] : undefined;
    };

    return NestedRowsNode;
  }(OrderedMap); //
  //@flow-ignore


  var SortingEnum = function SortingEnum(ordinal, value, sortChar) {
    this.ordinal = ordinal;
    this.value = value;
    this.sortChar = sortChar;
  };

  SortingEnum.values = function values() {
    return [SortingEnum.DESC, SortingEnum.ASC, SortingEnum.NONE];
  };

  SortingEnum.fromOrdinal = function fromOrdinal(ordinal) {
    return SortingEnum.values()[ordinal];
  };

  SortingEnum.fromValue = function fromValue(value) {
    return lodash__default.find(SortingEnum.values(), {
      value: value
    });
  };

  SortingEnum.DESC = new SortingEnum(0, "desc", "\u2193");
  SortingEnum.ASC = new SortingEnum(1, "asc", "\u2191");
  SortingEnum.NONE = new SortingEnum(2, "none", null);
  var BASE_ROW_KEY = "";

  var NestedRows = function NestedRows(rows, columns, options) {
    if (options == null) {
      options = {};
    }

    this._columns = columns;
    this._root = new NestedRowsNode(BASE_ROW_KEY);
    var forceHierarchy = options.forceHierarchy;
    var sortHierarchy = options.sortHierarchy;
    var hasHierarchy = options.hasHierarchy;
    var summarize = options.summarize;

    if (forceHierarchy) {
      // force a hierarchy
      this._hasHierarchy = true;

      this._nestRows(this._root, rows, columns, {
        forceHierarchy: forceHierarchy,
        sortHierarchy: sortHierarchy
      });
    } else if (hasHierarchy != null) {
      // already knows whether rows have hierarchy
      this._hasHierarchy = hasHierarchy;

      this._nestRows(this._root, rows, columns, {
        hasHierarchy: hasHierarchy,
        summarize: summarize
      });
    } else {
      // do not know whether rows have hierarchy, try with assume they do, this._nestRows will return false if
      // assumption is broken in the process of nesting. Then we re-nest if there is no hierarchy.
      var actuallyHasHierarchy = this._nestRows(this._root, rows, columns, {
        hasHierarchy: true,
        summarize: summarize
      });

      this._hasHierarchy = actuallyHasHierarchy;

      if (!actuallyHasHierarchy) {
        this._root.reset();

        this._nestRows(this._root, rows, columns, {
          hasHierarchy: false,
          summarize: summarize
        });
      }
    }
  };

  NestedRows.prototype._nestRows = function _nestRows(node, rows, columns, options) {
    var this$1 = this;
    var forceHierarchy = options.forceHierarchy;
    var hasHierarchy = options.hasHierarchy;
    var sortHierarchy = options.sortHierarchy;
    var summarize = options.summarize;
    hasHierarchy = forceHierarchy || hasHierarchy;

    if (!columns.length) {
      node.setIsLeaf(true).setBaseRows(rows);
      return true;
    }

    var isLast = columns.length === 1;

    if (isLast && !forceHierarchy && hasHierarchy) {
      hasHierarchy = false;
    }

    var column = columns[0];
    var valueFct = valueFctUtils.getValueFct({
      field: column
    });
    var valuesFct = valueFctUtils.getValueFct({
      field: columns
    });
    var keyMap = {};
    var keyFct = hasHierarchy ? valueFct : summarize ? valuesFct : function (row, i) {
      var key = valueFct(row);

      if (keyMap[key] != null) {
        return key + "-" + i;
      } else {
        keyMap[key] = key;
        return key;
      }
    };
    var displayKeyFct = valueFct;
    var lastKey;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var key = keyFct(row, i);
      var subRows = node.get(key);

      if (subRows) {
        if (forceHierarchy || lastKey === key || !hasHierarchy) {
          subRows.push(row);
        } else if (hasHierarchy) {
          return false;
        }
      } else {
        node.put(key, [row]);
      }

      lastKey = key;
    }

    if (forceHierarchy && sortHierarchy) {
      node.sortKeys();
    }

    var keys = node.getKeys();

    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key$1 = keys[i$1];
      var subRows$1 = node.get(key$1);
      var displayKey = displayKeyFct(subRows$1[0]);
      var subNode = new NestedRowsNode(key$1, displayKey);
      node.put(key$1, subNode);

      if (!this$1._nestRows(subNode, subRows$1, columns.slice(1), options)) {
        return false;
      }
    }

    return true;
  };
  /**
  	 * Return number of leaf NestedRowsNode
  	 * @return {Number}
  	 */


  NestedRows.prototype.numLeafRows = function numLeafRows() {
    var count = 0;
    this.traverse(function (key, colIndex, rowInfo, rowKeys, displayRowKeys, row) {
      if (row.isLeaf()) {
        count++;
      }
    });
    return count;
  };
  /**
  	 * Assign layout for root node
  	 * @param {object} layout { y, h, spacer }
  	 */


  NestedRows.prototype.setLayout = function setLayout(layout) {
    this._root.setLayout(layout);

    return this;
  };

  NestedRows.prototype.getLayout = function getLayout() {
    return this._root.getLayout();
  };

  NestedRows.prototype.hasHierarchy = function hasHierarchy() {
    return this._hasHierarchy;
  }; // Depth-first traversal of the hierarchical rows structure
  //
  // @param {Function} callback to be invoked at each row during traversal
  //                   callback(key, depth, rowInfo, rowKeys, parent)
  //                   key - current row key
  //                   depth - current depth
  //                   rowInfo - row info { index, isLast }
  //                   rowKeys - cumulative row keys
  //                   displayRowKeys - cumulative display row keys
  //                   row - current NestedRowsNode
  //                   parent - parent NestedRowsNode
  // @param {Number} depth of traversal


  NestedRows.prototype.traverse = function traverse(callback, depth) {
    if (depth == null) {
      depth = this._columns.length - 1;
    }

    if (this._root.isLeaf()) {
      callback(BASE_ROW_KEY, -1, {
        index: 0,
        isLast: true
      }, [BASE_ROW_KEY], [BASE_ROW_KEY], this._root);
    } else {
      this._traverse(this._root, callback, depth, 0);
    }
  }; // @param {Function} callback to be invoked at each row during traversal
  // @param {Number} depth of traversal
  // @param {Array} base rowKeys of traversal path


  NestedRows.prototype._traverse = function _traverse(node, callback, depth, currentDepth, baseKeys, baseDisplayKeys) {
    var this$1 = this;
    if (baseKeys === void 0) baseKeys = [];
    if (baseDisplayKeys === void 0) baseDisplayKeys = [];

    if (currentDepth > depth || node.isLeaf()) {
      return;
    }

    var keys = node.getKeys();
    var numChildren = keys.length;
    keys.forEach(function (key, rowIndex) {
      var subNode = node.get(key);
      var displayKey = subNode.getDisplayKey();
      var rowInfo = {
        index: rowIndex,
        isLast: rowIndex === numChildren - 1
      };
      var rowKeys = baseKeys.concat([key]);
      var displayKeys = baseDisplayKeys.concat([displayKey]);
      callback(displayKey != null ? displayKey : key, currentDepth, rowInfo, rowKeys, displayKeys, subNode, node);

      this$1._traverse(subNode, callback, depth, currentDepth + 1, rowKeys, displayKeys);
    });
  }; // Rollup values from a column of each base row all the way to top. A rollup aggregate
  // function is applied among values of the same level during rolling up.
  // e.g.
  //
  //RegionYear   Value
  //US      2000   10
  //US      2001   10
  //AP      2001   10
  //AP      2002   10
  //AP      2003   10
  //AP      2004   10
  //
  // nest by Region + Year, roll up by Value, roll up fct is sum
  //
  //US (20)
  //	   - 2000(10)
  //	   - 2001(10)
  //AP (40)
  //	   - 2001(10)
  //      - 2002(10)
  //      - 2003(10)
  //      - 2004(10)
  //
  // TODO see if percentage data tooltip can leverage rollup
  // @param {Object} a column to roll up by
  // @param {Function} roll up function, a reduction function for an array of values


  NestedRows.prototype.rollup = function rollup(column, rollupFct) {
    if (column == null) {
      return this;
    }

    var valueFct = valueFctUtils.getValueFct({
      field: column
    });

    this._rollup(this._root, column, valueFct, rollupFct);

    return this;
  };

  NestedRows.prototype._rollup = function _rollup(node, column, valueFct, rollupFct) {
    var this$1 = this;

    if (node.isLeaf()) {
      var baseRows = node.getBaseRows();
      node.setRollupValue(column, rollupFct(baseRows.map(valueFct)));
    } else {
      var keys = node.getKeys();
      var values = keys.map(function (key) {
        var subNode = node.get(key);

        this$1._rollup(subNode, column, valueFct, rollupFct);

        return subNode.getRollupValue(column);
      });
      node.setRollupValue(column, rollupFct(values));
    }
  }; // Sort all child rows recursively based on the rollup value on a column


  NestedRows.prototype.sortByRollup = function sortByRollup(column, order) {
    if (order == null) {
      order = SortingEnum.ASC;
    } else {
      order = SortingEnum.fromValue(order);
    }

    this._sortByRollup(this._root, column, order);
  };

  NestedRows.prototype._sortByRollup = function _sortByRollup(node, column, order) {
    var this$1 = this;

    if (order == SortingEnum.NONE) {
      return;
    }

    if (node.isLeaf()) {
      return;
    }

    var keys = node.getKeys();

    if (keys.length > 1) {
      node.sortBy(function (r0, r1) {
        var v = r0.getRollupValue(column) - r1.getRollupValue(column);
        return order === SortingEnum.ASC ? v : -v;
      });
    }

    node.getKeys().forEach(function (key) {
      this$1._sortByRollup(node.get(key), column, order);
    });
  };

  var TabularRows = function TabularRows(rows, columns, keyFct, options) {
    if (columns === void 0) columns = [];
    if (options === void 0) options = {};
    this.getCategories = this.getCategories.bind(this);
    this._columns = columns;
    this._keyFct = keyFct;
    this._spacerOnEdge = options.spacerOnEdge;
    delete options.spacerOnEdge;
    this._nestedRows = new NestedRows(rows, columns, options);
    this._rowHeight = 0;
  };

  TabularRows.prototype.getLayout = function getLayout() {
    return this._nestedRows.getLayout();
  };

  TabularRows.prototype.getFields = function getFields() {
    return this._columns;
  };

  TabularRows.prototype.hasHierarchy = function hasHierarchy() {
    return this._nestedRows.hasHierarchy();
  };

  TabularRows.prototype.numBaseRows = function numBaseRows() {
    return this._nestedRows.numLeafRows();
  };

  TabularRows.prototype.numColumns = function numColumns() {
    return this._columns.length;
  };

  TabularRows.prototype.getRowHeight = function getRowHeight() {
    return this._rowHeight;
  }; // Depth-first traversal of the tabular rows structure
  //
  // @param {Function} callback to be invoked at each row during traversal
  //                   callback(key, field, columnInfo , rowInfo, rowKeys)
  //                   key - current row key
  //                   field - field for current column
  //                   columnInfo - { index, isLast, layout }
  //                   rowInfo - { index, isLast, layout }
  //                   rowKeys - cumulative row keys
  //                   displayRowKeys - cumulative display row keys
  //                   row - nestedRowNode
  //                   columns - all columns for columns before current one, including current column field
  // @param {Number} numColumns to traverse


  TabularRows.prototype.traverse = function traverse(callback, numColumns) {
    var this$1 = this;

    if (numColumns == null) {
      numColumns = this.numColumns();
    }

    return this._nestedRows.traverse(function (key, colIndex, rowInfo, rowKeys, displayRowKeys, row, column) {
      var columnInfo = {
        index: colIndex,
        isLast: colIndex === this$1.numColumns() - 1,
        layout: column != null ? column.getLayout() : undefined
      };
      rowInfo.layout = row.getLayout();
      return callback(key, this$1._columns[colIndex], columnInfo, rowInfo, rowKeys, displayRowKeys, row, this$1._columns.slice(0, colIndex + 1));
    }, numColumns - 1);
  }; // Sort nested rows on a rollup value with a certain order


  TabularRows.prototype.sortByRollup = function sortByRollup(column, order) {
    this._nestedRows.sortByRollup(column, order);

    return this;
  }; // Rollup values from a field of each base row all the way to top. A rollup aggregate
  // function is applied among values of the same level during rolling up.
  // e.g.
  //
  //RegionYear   Value
  //US      2000   10
  //US      2001   10
  //AP      2001   10
  //AP      2002   10
  //AP      2003   10
  //AP      2004   10
  //
  // nest by Region + Year, roll up by Value, roll up fct is sum
  //
  //US (20)
  //	   - 2000(10)
  //	   - 2001(10)
  //AP (40)
  //	   - 2001(10)
  //      - 2002(10)
  //      - 2003(10)
  //      - 2004(10)
  //
  // TODO see if percentage data tooltip can leverage rollup
  // @param {Object} a field to roll up by
  // @param {Function} roll up function, a reduction function for an array of values


  TabularRows.prototype.rollup = function rollup(column, rollupFct) {
    this._nestedRows.rollup(column, rollupFct);

    return this;
  }; // Assign and calaulate layout for tabularRows recursively. layout is represented by
  // { y, h, spacer }
  //
  // @param {Object} layout
  //                 {Number} rowHeight - row height for base row
  //                 {Array<Number>} spacers - spacing between rows for each column.
  //                 e.g. [s1, s2] - spacing for column1 and column2


  TabularRows.prototype.setLayout = function setLayout(ref) {
    var rowHeight = ref.rowHeight;
    var spacers = ref.spacers;
    this._rowHeight = rowHeight;

    if (this._nestedRows.hasHierarchy()) {
      if (spacers == null) {
        spacers = [constants$1.SPACER, constants$1.SPACER * 5];
      }
    } else {
      spacers = [spacers[0]];
    } // sanitize spacers by using the last spacer for all levels not defining a spacer


    var lastSpacer = lodash__default.last(spacers);
    var numColumns = this.numColumns();

    if (numColumns) {
      while (spacers.length < numColumns) {
        spacers.push(lastSpacer);
      }

      spacers = spacers.slice(0, numColumns).reverse();
    } else {
      spacers = [lastSpacer];
    }

    return this._updateLayout(rowHeight, spacers);
  }; // @param {Number} rowHeight - row height for base row
  // @param {Array<Number>} spacers - spacing between rows for each column.


  TabularRows.prototype._updateLayout = function _updateLayout(rowHeight, spacers) {
    // recursively calculate layout
    var traverseUpdateLayout = function traverseUpdateLayout(node, depth, y) {
      var spacer = spacers[depth];
      var end = y;

      if (node.isLeaf()) {
        end += rowHeight;
      } else {
        var keys = node.getKeys();
        keys.forEach(function (key) {
          var subNode = node.get(key);
          traverseUpdateLayout(subNode, depth + 1, end);
          end += subNode.getLayout().h + spacer;
        });
        end -= spacer;
      }

      var h = end - y;
      return node.setLayout({
        spacer: spacer,
        y: y,
        h: h
      });
    };

    var start = this._spacerOnEdge ? spacers[0] : 0;
    traverseUpdateLayout(this._nestedRows._root, 0, start);

    if (this._spacerOnEdge) {
      var layout = this._nestedRows.getLayout();

      this._nestedRows.setLayout({
        h: layout.h + 2 * spacers[0],
        y: 0,
        spacer: layout.spacer
      });
    }

    return this;
  };
  /**
  	 * Get the ordinal scale represents the layout positioning for all base rows or any nestedRowNode
  	 *
  	 * If columnIndex is not defined, scale will include mapping from all base rowKeys to a position.
  	 * If columnIndex is defined, scale will only include mapping from nestedRowsNode's keys in that column
  	 * to it's position.
  	 *
  	 * @param  {Number} columnIndex
  	 * @return {Scale}
  	 */


  TabularRows.prototype.getScale = function getScale(columnIndex) {
    var forBaseRows = columnIndex == undefined;
    var domain = [];
    var range = [];
    var keyFct = this._keyFct;
    this.traverse(function (key, column, columnInfo, rowInfo, rowKeys, displayRowKeys, nestedRowsNode) {
      var value = rowInfo.layout.y + rowInfo.layout.h / 2;

      if (forBaseRows) {
        if (nestedRowsNode.isLeaf()) {
          nestedRowsNode.getBaseRows().forEach(function (row) {
            domain.push(keyFct(row));
            range.push(value);
          });
        }
      } else if (columnInfo.index === columnIndex) {
        domain.push(displayRowKeys.length === 1 ? displayRowKeys[0] : valueFctUtils.joinValues(displayRowKeys));
        range.push(value);
      }
    });
    return scales.ordinal().domain(domain).range(range);
  };
  /**
  	 * Get the categories describing the order of nodes or base rows
  	 *
  	 * If columnIndex is not defined, categories will include mapping from all base rowKeys to an index.
  	 * If columnIndex is defined, scale will only include mapping from nestedRowsNode's keys in that column.
  	 *
  	 * @param  {Number} columnIndex
  	 * @return {Object}
  	 */


  TabularRows.prototype.getCategories = function getCategories(columnIndex) {
    var forBaseRows = columnIndex == undefined;
    var categoryMap = {};
    var index = 0;
    var keyFct = this._keyFct;
    this.traverse(function (key, column, columnInfo, rowInfo, rowKeys, displayRowKeys, nestedRowsNode) {
      if (forBaseRows) {
        if (nestedRowsNode.isLeaf()) {
          nestedRowsNode.getBaseRows().forEach(function (row) {
            categoryMap[keyFct(row)] = index;
          });
          index++;
        }
      } else if (columnInfo.index === columnIndex) {
        var category = displayRowKeys.length === 1 ? displayRowKeys[0] : valueFctUtils.joinValues(displayRowKeys);
        categoryMap[category] = index;
        index++;
      }
    });
    return categoryMap;
  }; // log params to control different levels of logging


  var log = {
    showLocalizedLabels: false // show localized labls with special ⎡ delimiters ⎦

  };
  var labels = {
    "wave-charts": {
      insufficientSpace: "Insufficient space to render chart data",
      waterfallTotal: "End",
      noData: "No data to display",
      noValues: "No valid data to display",
      measure: "Measure",
      total: "Total",
      range: "{0} to {1}",
      percentTooltip: "{0} of {1}",
      percentTooltipWithGroup: "{0} of {1} for {2}",
      enableTabNavigation: "Enable Tab Navigation for This Chart",
      tabNavigationEnabled: "Tab Navigation Enabled",
      enableDataTable: "Enable table equivalent for screen reader users",
      other: "Other",
      invalidGeoJSON: "Invalid GeoJSON",
      invalidMap: "Invalid Map",
      nullLabel: " - ",
      // context scorer
      contextGeo: "data with geo information",
      contextTime: "data with time information",
      contextLatlng: "data with lat lng information",
      contextFlowHighCard: "not suitable to visualize high cardinality data column with flow diagram",
      contextFlowLowCard: "visualize low cardinality data column with flow diagram",
      // axis scorer
      axisDimNoColumn: "dimension axis has no data column",
      axisXDimOneColumn: "x dimension axis has 1 data column",
      axisYDimOneColumn: "y dimension axis has 1 data column",
      axisXDim2Columns: "x dimension axis has 2 data column",
      axisYDim2Columns: " dimension axis has 2 data column",
      axisDimMaxColumn: "dimension axis has more than {0} columns",
      axisMeaNoColumns: "measure axis has no data column",
      axisMeaMaxColumn: "measure axis has more than {0} columns",
      axisTimeNoColumn: "time axis has no data column",
      axisMvM: "measure axis vs measure axis",
      axisDvD: "dimension axis vs dimension axis",
      axisMvDMultiMetric: "can use another chart type for visualizing single measure",
      axisMultiMetricManyMeasure: "visualize more than {0} metrics",
      axisMultiMetricFewMeasure: "not suitable to visualize fewer than {0} metrics",
      axisSingleMetricSingleMeasure: "visualize exactly one metric",
      axisSingleMetricFewMeasure: "not suitable to visualizemore than one metric",
      axisRedundancy: "x, y axis representing duplicate data columns",
      // color scorer
      colorHighCardinality: "not suitable to visualize high cardinality data column with categorical color",
      colorLowCardinality: "visualize low cardinality data column with categorical color",
      // trellis scorer
      trellisHighCardinality: "not suitable to visualize high cardinality data column with trellis",
      // uncommon chart
      popularChart: "is popular",
      unpopularChart: "is only suitable for specific use case",
      // gauge
      low: "Low",
      medium: "Medium",
      high: "High",
      // Map types
      US_States: "US States",
      World_Countries: "World Countries",
      Americas: "Americas",
      North_America: "North America",
      South_America: "South America",
      Central_America: "Central America",
      Caribbean: "Caribbean",
      Europe: "Europe",
      Eastern_Europe: "Eastern Europe",
      Northern_Europe: "Northern Europe",
      Southern_Europe: "Southern Europe",
      Western_Europe: "Western Europe",
      Central_Europe: "Central Europe",
      Scandanavia: "Scandanavia",
      Asia: "Asia",
      South_Asia: "South Asia",
      South_East_Asia: "South East Asia",
      East_Asia: "East Asia",
      Australasia: "Australasia",
      Africa: "Africa",
      East_Africa: "East Africa",
      Middle_Africa: "Middle Africa",
      North_Africa: "North Africa",
      Southern_Africa: "Southern Africa",
      Western_Africa: "Western Africa",
      EMEA: "EMEA",
      APAC: "APAC",
      'World(zoomable)': "World Countries(zoomable)",
      'US_States(zoomable)': "US States(zoomable)"
    }
  };
  var LOC = {
    _labels: labels,
    setCustomLabels: function setCustomLabels(customLabels) {
      this._labels = dataUtils.extendDeep(this._labels, customLabels || {});
    },
    getLabel: function getLabel(section, name, args, overrides) {
      var label;

      if (name) {
        if (overrides && overrides[section] && overrides[section][name]) {
          label = overrides[section][name];
        }

        if (label == null) {
          var sectionMap = this._labels[section];
          label = sectionMap ? sectionMap[name] : null;
        }

        if (label != null) {
          var iterable = args || [];

          for (var i = 0; i < iterable.length; i++) {
            var arg = iterable[i];
            var regexp = new RegExp("\\{" + i + "\\}", 'g');
            label = label.replace(regexp, function () {
              return arg;
            });
          }
        } else {
          console.error("invalid label: " + JSON.stringify(arguments));
        }
      }

      label = label || "";
      return log.showLocalizedLabels ? "⎡" + label + "⎦" : label;
    }
  };
  var NUM_WEEKS_IN_YEAR = 53;
  var DAY_IN_MILLISECONDS = 86400000;
  var FORMAT_SEPARATOR = " - ";
  var SFDC_WEEK_FORMAT = "sfdcWeek";
  var SFDC_YEAR_WEEK_FORMAT = "sfdcYearWeek";
  var WEEK_1_EPOCH$1 = luxon.DateTime.fromFormat("2016-01", "kkkk-WW").valueOf();
  var YEAR_2017_EPOCH = 1483228800000;

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }
  /**
   * Wave's definition of week of year is different from ISO week or locale week
   * definition so we need to capture the special parsing formatting rules here
   *
   * @author alice.chen
   */


  var sfdcWeek = {
    isDiscreteTimeFormat: function isDiscreteTimeFormat(format) {
      return format === SFDC_WEEK_FORMAT;
    },
    isSfdcWeekFormat: function isSfdcWeekFormat(format) {
      return format === SFDC_WEEK_FORMAT || format === SFDC_YEAR_WEEK_FORMAT;
    },

    /**
     * Returns a formatter for axis tick on sfdcWeek granularity
     *
     * @param  {Number} firstDayOfWeek
     * @return {Function}
     */
    _getTickFormatter: function _getTickFormatter(format, isDiscrete, firstDayOfWeek) {
      var this$1 = this;
      return function (epochTime) {
        if (isDiscrete && epochTime >= YEAR_2017_EPOCH) {
          return undefined;
        } else {
          return 'W' + this$1._parseYearWeek(epochTime, firstDayOfWeek)[1];
        }
      };
    },
    getFormatter: function getFormatter(format, firstDayOfWeek) {
      var this$1 = this;

      if (format === SFDC_WEEK_FORMAT) {
        return function (epochTime) {
          return pad2(this$1._parseYearWeek(epochTime, firstDayOfWeek)[1]);
        };
      } else {
        return function (epochTime) {
          var ref = this$1._parseYearWeek(epochTime, firstDayOfWeek);

          var year = ref[0];
          var week = ref[1];
          return "" + year + FORMAT_SEPARATOR + pad2(week);
        };
      }
    },
    getParser: function getParser(format, firstDayOfWeek, dataSeparator) {
      var this$1 = this;

      if (format === SFDC_WEEK_FORMAT) {
        // discrete week only
        return function (timeInput) {
          return this$1._getYearWeekEpoch(2016, parseInt(timeInput, 10), firstDayOfWeek);
        };
      } else {
        return function (timeInput) {
          var ref = timeInput.split(dataSeparator);
          var year = ref[0];
          var week = ref[1];
          return this$1._getYearWeekEpoch(year, week, firstDayOfWeek);
        };
      }
    },
    startOf: function startOf(t, firstDayOfWeek) {
      var ref = this._parseYearWeek(t, firstDayOfWeek);

      var year = ref[0];
      var week = ref[1];

      var start = this._getYearWeekEpoch(year, week, firstDayOfWeek);

      return luxon.DateTime.fromMillis(start);
    },
    offset: function offset(t, n, firstDayOfWeek) {
      var ref = this._parseYearWeek(t, firstDayOfWeek);

      var year = ref[0];
      var week = ref[1];
      week += n;
      var dy = Math.floor((week - 1) / NUM_WEEKS_IN_YEAR);
      year += dy;
      week = week - dy * NUM_WEEKS_IN_YEAR;
      return luxon.DateTime.fromMillis(this._getYearWeekEpoch(year, week, firstDayOfWeek));
    },
    diff: function diff(min, max, firstDayOfWeek) {
      var ref = this._parseYearWeek(min, firstDayOfWeek);

      var year0 = ref[0];
      var week0 = ref[1];

      var ref$1 = this._parseYearWeek(max, firstDayOfWeek);

      var year1 = ref$1[0];
      var week1 = ref$1[1];
      return (year1 - year0) * NUM_WEEKS_IN_YEAR + week1 - week0;
    },
    // Calculate and return the week number of year from a given date
    // All weeks start on Sunday and end on Saturday (unless firstDay
    // is passed in). Jan 1 is always counted as Week 1
    // ie.,
    //   Sun 12/28/2014 ~ Wed 12/31/2014 -> Week 53
    //   Thr 1/1/2015 ~ Sat 1/3/2015 -> Week 1
    //   Sun 1/4/2015 ~ Sat 1/10/2015 -> Week 2
    //  Copied from WaveUI/WaveCommon/src/chrome/date/DateUtils.coffee  weekOfYear
    _parseYearWeek: function _parseYearWeek(epochTime, firstDay) {
      if (firstDay == null) {
        firstDay = 0;
      }

      var date = luxon.DateTime.fromMillis(epochTime);
      var year = date.year;
      var janFirstDate = luxon.DateTime.fromObject({
        year: year
      });
      var janFirstDay = janFirstDate.weekday;
      var offset = firstDay === -1 || janFirstDay === firstDay ? 0 : firstDay < janFirstDay ? janFirstDay - firstDay : 7 - (firstDay - janFirstDay);
      var week = Math.ceil(((date.valueOf() - janFirstDate.valueOf()) / DAY_IN_MILLISECONDS + offset + 1) / 7);
      return [year, week];
    },
    // Calculate the first day of the week from a given week of year
    // All weeks start on Sunday and end on Saturday (unless firstDay
    // is passed in).  Jan 1 is always the first day of Week 1.
    // ie.,
    //   2014 Week 53 -> Sun 12/28/2014
    //   2015 Week 1 -> Thr 1/1/2015
    //   2015 Week 2 -> Sun 1/4/2015
    //  Copied from WaveUI/WaveCommon/src/chrome/date/DateUtils.coffee  firstDayOfWeek
    _getYearWeekEpoch: function _getYearWeekEpoch(year, week, firstDay) {
      if (firstDay == null) {
        firstDay = 0;
      }

      year = parseInt(year);
      week = parseInt(week);

      if (isNaN(week) || 1 > week || week > 53) {
        return null;
      } // invalid week


      var date = new Date(Date.UTC(year, 0, 1));

      if (week === 1) {
        // with date.getTime(), luxon will return the last of the previous year
        // so simply return the datetime of 1st january, which will force it to 1st week
        return luxon.DateTime.fromObject({
          year: year
        }).valueOf();
      } // Jan 1 is always the first day of week 1


      var utcDay = date.getUTCDay();
      var offset = firstDay === -1 || utcDay === firstDay ? 7 : firstDay < utcDay ? 7 - (utcDay - firstDay) : firstDay - utcDay;

      if (week > 2) {
        offset += (week - 2) * 7;
      }

      date.setUTCDate(date.getUTCDate() + offset);
      return date.getTime();
    }
  };
  var QUARTER_FORMAT = "quarter";
  var YEAR_QUARTER_FORMAT = "yearQuarter";
  var DURATION_GRANULARITY = "months";
  /**
   * Luxon doesnt support quarter expect during formmatting
   * so convert to months before any DateTime conversion, and then convert back to quarters
   * 1 quarter = 3 months
   *
   * @author ytibrewal
   */

  var quarterTime = {
    isQuarterFormat: function isQuarterFormat(format) {
      return format === QUARTER_FORMAT || format === YEAR_QUARTER_FORMAT;
    },
    isDiscreteTimeFormat: function isDiscreteTimeFormat(format) {
      return format == QUARTER_FORMAT;
    },
    getParser: function getParser(format, dataSeparator) {
      var this$1 = this;

      if (format === QUARTER_FORMAT) {
        return function (timeInput) {
          return luxon.DateTime.fromObject({
            month: this$1.convertQuarterToMonth(timeInput)
          }).valueOf();
        };
      } else {
        return function (timeInput) {
          var ref = timeInput.split(dataSeparator);
          var yearInput = ref[0];
          var quarterInput = ref[1];
          return luxon.DateTime.fromObject({
            month: this$1.convertQuarterToMonth(quarterInput * 1),
            year: yearInput * 1
          }).valueOf();
        };
      }
    },
    diff: function diff(min, max) {
      return this.convertMonthToQuarter(luxon.DateTime.fromMillis(max).diff(luxon.DateTime.fromMillis(min), DURATION_GRANULARITY).toObject()[DURATION_GRANULARITY] || 0);
    },
    duration: function duration(n, granularity) {
      var obj;
      return luxon.Duration.fromObject((obj = {}, obj[DURATION_GRANULARITY] = this.convertQuarterToMonth(n) + 2, obj));
    },
    offset: function offset(t, n) {
      var obj;
      return luxon.DateTime.fromMillis(t).plus((obj = {}, obj[DURATION_GRANULARITY] = this.getOffsetInMonths(n), obj));
    },
    getOffsetInMonths: function getOffsetInMonths(quarter) {
      return quarter * 3;
    },
    convertQuarterToMonth: function convertQuarterToMonth(quarter) {
      return 3 * quarter - 2;
    },
    convertMonthToQuarter: function convertMonthToQuarter(months) {
      return Math.ceil(months / 3);
    }
  };
  var Delegate = null;
  var GRANULARITY = constants$1.TIME_GRANULARITY; // special format for sfdc week
  // date format which indicates the grouping is by a discrete(single) date
  // dimension(month), rather than continuous compound(year-month-day)

  var DISCRETE_MONTH_FORMATS = ["M", "MM", "MMM", "MMMM"];
  var DISCRETE_DAY_FORMATS = ["d", "dd"];
  var DISCRETE_WEEK_FORMATS = ["W", "WW"];
  var DISCRETE_TIME_FORMATS = DISCRETE_MONTH_FORMATS.concat(DISCRETE_DAY_FORMATS).concat(DISCRETE_WEEK_FORMATS); // milliseconds in a day

  var DAY_DURATION = 86400000; // milliseconds in a week

  var WEEK_DURATION = 604800000; // For discrete time granularity, normalize time relative to 2016-1-1

  var DAY_1_EPOCH = luxon.DateTime.fromISO("2016-01-01").valueOf();
  var WEEK_1_EPOCH = luxon.DateTime.fromFormat("2016-01", "kkkk-WW").valueOf(); // estimate of label size

  var LABEL_HEIGHT = null;
  var DISTANCE_LABEL_RATIO = 1.1; // ratio of distance between ticks over label width
  // a constant epoch to return when parsing null/undefined date

  var CONSTANT_EPOCH = luxon.DateTime.fromISO("1988-07-08").valueOf();
  var GRANULARITY_INFO = {};
  GRANULARITY_INFO[GRANULARITY.MILLISECOND] = {
    steps: [1, 100, 500],
    parentGranularity: GRANULARITY.SECOND,
    durationGranuarilty: "milliseconds"
  };
  GRANULARITY_INFO[GRANULARITY.SECOND] = {
    steps: [1],
    parentGranularity: GRANULARITY.MINUTE,
    durationGranuarilty: "seconds"
  };
  GRANULARITY_INFO[GRANULARITY.MINUTE] = {
    steps: [1, 2, 5, 10, 15, 30],
    parentGranularity: GRANULARITY.HOUR,
    durationGranuarilty: "minutes"
  };
  GRANULARITY_INFO[GRANULARITY.HOUR] = {
    steps: [1, 2, 3, 4, 6, 8, 12],
    parentGranularity: GRANULARITY.DAY,
    durationGranuarilty: "hours"
  };
  GRANULARITY_INFO[GRANULARITY.DAY] = {
    steps: [1, 2, 3, 4, 10, 14],
    parentGranularity: GRANULARITY.MONTH,
    durationGranuarilty: "days"
  };
  GRANULARITY_INFO[GRANULARITY.WEEK] = {
    steps: [1, 2, 13, 25],
    parentGranularity: GRANULARITY.WEEKYEAR,
    durationGranuarilty: "weeks"
  };
  GRANULARITY_INFO[GRANULARITY.SFDC_WEEK] = {
    steps: [1, 2, 13, 25],
    parentGranularity: GRANULARITY.YEAR,
    durationGranuarilty: "weeks"
  };
  GRANULARITY_INFO[GRANULARITY.MONTH] = {
    steps: [1, 2, 3, 4, 6],
    parentGranularity: GRANULARITY.YEAR,
    durationGranuarilty: "months"
  };
  GRANULARITY_INFO[GRANULARITY.QUARTER] = {
    steps: [1, 2],
    parentGranularity: GRANULARITY.YEAR,
    durationGranuarilty: "months"
  };
  GRANULARITY_INFO[GRANULARITY.YEAR] = {
    durationGranuarilty: "years"
  };
  GRANULARITY_INFO[GRANULARITY.WEEKYEAR] = {
    durationGranuarilty: "years"
  };
  var SAMPLES = ["1988-01-02T01:00:00.001", "1992-02-04T03:05:05.100", "1994-03-06T05:10:10.200", "2000-04-08T07:15:15.300", "2005-05-10T09:20:20.400", "2006-06-12T11:25:25.500", "2007-07-14T13:30:30.600", "2008-08-16T15:35:35.700", "2009-09-20T17:40:40.800", "2010-10-24T19:45:45.900", "2011-11-26T21:50:50.920", "2012-12-30T23:55:55.999"];
  /**
   * Returns the time parser specifically for discrete time granularity
   *
   * When time data granularity is discrete, instead of continuous, e.g.
   * day, month, instead of year-month, year-month-day, we need to parse
   * the time differently and normalize it to an epoch which later can be
   * formatted and scaled.
   *
   * for quarter, month, simply parse time as DateTime.fromFormat("02", "MM"), which parse to
   * current year, Feb, because every year has the same number of months and quarters.
   *
   * for week(including sfdcWeek), day, parse to the week, day relative to 2016-01-01. e.g. day 10
   * will be parsed as 2016-01-10, week 34 parsed as 2016 w34. Because 2016 has
   * 53 weeks and Jan has 31 days, which will accomodate all discrete values
   *
   * @param  {String} format
   */

  function getDiscreteTimeParser(format) {
    var parser;

    if (DISCRETE_DAY_FORMATS.indexOf(format) > -1) {
      parser = function parser(timeInput) {
        return luxon.DateTime.fromMillis(DAY_1_EPOCH + (parseInt(timeInput, 10) - 1) * DAY_DURATION).startOf("day").valueOf();
      };
    } else if (DISCRETE_WEEK_FORMATS.indexOf(format) > -1) {
      parser = function parser(timeInput) {
        return luxon.DateTime.fromMillis(WEEK_1_EPOCH + (parseInt(timeInput, 10) - 1) * WEEK_DURATION).startOf("week").valueOf();
      };
    } else {
      return getDefaultTimeParser(format);
    }

    return wrapParser(parser, format);
  }
  /**
   * Wrap time parser to handle cases when time is already parsed as epoch, or
   * time input is undefined
   *
   * @param  {Function} parser to wrap
   * @return {Function}
   */


  function wrapParser(parser, format) {
    return function (timeInput) {
      if (timeInput == null || timeInput === "") {
        return undefined;
      }

      return format == null && lodash__default.isNumber(timeInput) ? timeInput : parser(timeInput + "");
    };
  }
  /**
   * Default time parser
   *
   * Returns a function which parse a time string into epoch according to format
   * @param  {String} format
   * @return {Function}
   */


  function getDefaultTimeParser(format) {
    return wrapParser(function (timeInput) {
      return luxon.DateTime.fromFormat(timeInput, format).valueOf();
    }, format);
  }

  function _getLabelHeight() {
    if (Delegate == null) {
      Delegate = WaveChartsRuntime.getDelegate();
    }

    if (LABEL_HEIGHT == null) {
      var LABEL_TEXT_HEIGHT = Delegate.getRealFontSize(constants$1.AXIS.LABELS.TEXT.SIZE);
      LABEL_HEIGHT = LABEL_TEXT_HEIGHT + constants$1.AXIS.LABELS.PADDING.SMALL * 2;
    }

    return LABEL_HEIGHT;
  }

  var time = {
    isDiscreteTimeFormat: function isDiscreteTimeFormat(format) {
      return sfdcWeek.isDiscreteTimeFormat(format) || quarterTime.isDiscreteTimeFormat(format) || DISCRETE_TIME_FORMATS.indexOf(format) > -1;
    },
    // given a format returns a formatter, a function which converts a unix time in
    // milliseconds(integer value representing the number of milliseconds since
    // the Unix Epoch (Jan 1 1970 12AM UTC)) to a string representation of the time
    // in local timezone
    //
    // @param format {String} time format
    // @return {Function}
    getFormatter: function getFormatter(format, firstDayOfWeek) {
      if (sfdcWeek.isSfdcWeekFormat(format)) {
        return sfdcWeek.getFormatter(format, firstDayOfWeek);
      } else {
        return function (epochTime) {
          return luxon.DateTime.fromMillis(epochTime).toFormat(format);
        };
      }
    },
    // given a format returns a parser, a function which converts a string to unix time
    // in milliseconds.
    //
    // @param format {String} time format for parsing
    getParser: function getParser(format, firstDayOfWeek, dataSeparator) {
      if (sfdcWeek.isSfdcWeekFormat(format)) {
        return wrapParser(sfdcWeek.getParser(format, firstDayOfWeek, dataSeparator), format);
      } else if (quarterTime.isQuarterFormat(format)) {
        return wrapParser(quarterTime.getParser(format, dataSeparator), format);
      } else if (this.isDiscreteTimeFormat(format)) {
        return getDiscreteTimeParser(format);
      } else {
        return getDefaultTimeParser(format);
      }
    },
    getConstantEpoch: function getConstantEpoch() {
      return CONSTANT_EPOCH;
    },
    getCategories: function getCategories(scale, granularity, firstDayOfWeek) {
      var this$1 = this;

      if (granularity == null) {
        granularity = GRANULARITY.MONTH;
      }

      var domain = scale.domain(); // protect against a time range with more than 2000 grain units
      // at this point, returning the full categories is too expensive and
      // since it's not possible to really tell connect/disconnect between points
      // just return empty categories and we will connect through

      if (this.diff(domain[0], domain[1], granularity, firstDayOfWeek) > 2000) {
        return undefined;
      }

      var categoriesMap = {};

      if (domain[0] === domain[1]) {
        categoriesMap[domain[0]] = 0;
        return categoriesMap;
      }

      var category = this.startOf(domain[0], granularity, firstDayOfWeek);
      var i = 0;
      var end = luxon.DateTime.fromMillis(domain[1]);

      while (category <= end) {
        categoriesMap[category.valueOf()] = i++;
        category = this$1.offset(category.valueOf(), 1, granularity, firstDayOfWeek);
      }

      return categoriesMap;
    },

    /**
     * Helper function to check if tick is too close to either previous or next
     * parent tick. If distance is smaller than minDistance, return true and axis
     * will skip drawing the tick to avoid overlapping. This could happen when in
     * some granularities, number of child units are different. So when draw a tick
     * for every several child unit, the last unit within one parent unit could be
     * very close to the next parent start.
     *
     * @param  {DateTime} tick
     * @param  {DateTime} parentStart
     * @param  {String} parentGranularity
     * @param  {Number} minDistance
     * @param  {Scale} scale
     * @return {Boolean}
     */
    _tooCloseToParentTick: function _tooCloseToParentTick(tick, parentStart, parentGranularity, minDistance, scale, firstDayOfWeek) {
      var current = tick.valueOf();
      var parent = parentStart.valueOf();

      if (scale.scale(current) - scale.scale(parent) < minDistance) {
        // too close to the previous parent tick
        return true;
      } else {
        // too close to the next parent tick
        var nextParent = this.offset(parent, 1, parentGranularity, firstDayOfWeek).valueOf();
        return scale.scale(nextParent) - scale.scale(current) < minDistance;
      }
    },

    /**
     * Returns a formatter for axis tick
     *
     * @param  {Object} formats tokens keyed by granularity
     * @param  {String} granularity
     * @param  {Number} firstDayOfWeek
     * @return {Function}
     */
    _getTickFormatter: function _getTickFormatter(formats, granularity, isDiscrete, firstDayOfWeek) {
      var format = formats[granularity];

      if (sfdcWeek.isSfdcWeekFormat(format)) {
        return sfdcWeek._getTickFormatter(format, isDiscrete, firstDayOfWeek);
      } else {
        return function (epochTime) {
          return luxon.DateTime.fromMillis(epochTime).toFormat(format);
        };
      }
    },
    // calculate ticks for a linear time scale, returns an array of ticks, each tick
    // contains time (unix time in milliseconds), and label text.
    // - ticks will be placed evenly within the range of the time scale passed
    // - ticks granularity and distribution depends on the following strategy:
    //    - first we will try to show label for every unit, if doesn’t fit on the screen, try to show label
    //      for several units (skipping labels) within each parentGranularity. If they still don’t fit,
    //      go up one level of granularity until find a suitable granularity.
    //    - for granularities other than day/year. draw labels for ticks, when the tick is the start of the
    //      parentGranularity, show label in the format of parentGranularity, otherwise in current granularity.
    //      *for day, since not every month has the same number of days, always show ticks in equal interval of days,
    //       but show month when the tick is the first tick within the month
    //      *for year, just show all tick labels in year format.
    //
    // @param scale {Object} a linear scale which maps a time period(unix milliseconds) to a numeric range
    // @param granularity {String} minimum granularity to display ticks
    // @param formats {Object} formats for each time granularity
    // @param isX {Boolean} whether ticks are for horizontal X axis
    // @param isDiscrete {Boolean} discrete time granulairty vs continuous time
    ticks: function ticks(scale, granularity, formats, isX, isDiscrete, firstDayOfWeek) {
      var this$1 = this;
      var granularityWidth, minDistance, parentGranularity, steps, durationGranuarilty;
      var domain = scale.domain();
      var start = luxon.DateTime.fromMillis(domain[0]);
      var end = luxon.DateTime.fromMillis(domain[1]);

      if (isDiscrete) {
        parentGranularity = GRANULARITY_INFO[granularity].parentGranularity;

        if (parentGranularity) {
          // when date granularity is discrete, we don't want to show rolled up parent
          // tick, e.g. for Jan, still display Jan, not 2017
          formats[parentGranularity] = formats[granularity];
        }
      }

      if (start.hasSame(end, GRANULARITY.MILLISECOND)) {
        return [{
          time: start.valueOf(),
          text: this._getTickFormatter(formats, granularity, isDiscrete, firstDayOfWeek)(start)
        }];
      } // max width of labels on each time granularity level
      // - if y axis, width is fixed label height depending on font size


      var widths = this.estimateWidth(formats, isX ? null : _getLabelHeight());
      var millisecondsDuration = GRANULARITY_INFO[GRANULARITY.MILLISECOND].durationGranuarilty;

      while (true) {
        var assign;
        assign = GRANULARITY_INFO[granularity], parentGranularity = assign.parentGranularity, steps = assign.steps, durationGranuarilty = assign.durationGranuarilty;

        if (!parentGranularity) {
          break;
        }

        granularityWidth = scale.scale(this$1.duration(1, granularity).as(millisecondsDuration)) - scale.scale(0); // parentGranularity tick label will show, consider both

        minDistance = Math.max(widths[granularity], widths[parentGranularity]) * DISTANCE_LABEL_RATIO;

        if (minDistance < granularityWidth * lodash__default.last(steps)) {
          break;
        }

        granularity = parentGranularity;
      }

      if (!parentGranularity) {
        // granularity is GRANULARITY.YEAR or GRANULARITY.WEEKYEAR
        // - duration of weekYear is not supported by DateTime, use GRANULARITY.YEAR instead
        parentGranularity = granularity;
        granularityWidth = scale.scale(this.duration(1, GRANULARITY.YEAR).as(millisecondsDuration)) - scale.scale(0);
        minDistance = widths[granularity] * DISTANCE_LABEL_RATIO;
      } // calculate number of step for each label


      var step;

      if (steps) {
        for (var i = 0; i < steps.length; i++) {
          step = steps[i];

          if (granularityWidth * step > minDistance) {
            break;
          }
        }
      } else {
        // infer step
        step = Math.ceil(minDistance / granularityWidth);
      } // - true: search for all parentGranularity granularities containing current domain and
      //   draw ticks within each parentGranularity (always show tick for start of parentGranularity)
      // - false: first tick is the start of current domain and draw tick every number of
      //   steps. when each parentGranularity do not have fixed number of current granularities(month)
      //   tick not always drawn for start of parentGranularity
      // - we always align with parentStart, meaning try to show parent ticks as much as possible,
      //   except for when the date range is on a very focused short period, like several days, weeks
      //   we don't want to show uneven ticks in that case.


      var alignWithParentStart = !(granularity === GRANULARITY.DAY && step < 10 || granularity === GRANULARITY.WEEK && step < 13); // first tick

      var tick = alignWithParentStart ? this.startOf(domain[0], parentGranularity, firstDayOfWeek) : this.startOf(domain[0], granularity, firstDayOfWeek);
      var ticks = [];

      var formatter = this._getTickFormatter(formats, granularity, isDiscrete, firstDayOfWeek);

      var parentFormatter = this._getTickFormatter(formats, parentGranularity, isDiscrete, firstDayOfWeek);

      var parentTick = this.startOf(tick.valueOf(), parentGranularity, firstDayOfWeek);

      while (true) {
        if (tick >= start) {
          var text;
          var parentStart = this$1.startOf(tick.valueOf(), parentGranularity, firstDayOfWeek);

          if (parentStart > parentTick) {
            // step into new parent grain
            if (alignWithParentStart) {
              tick = parentStart;
            }

            text = parentFormatter(tick.valueOf());
          } else {
            text = tick.hasSame(parentStart, GRANULARITY.MILLISECOND) ? parentFormatter(tick.valueOf()) : alignWithParentStart && this$1._tooCloseToParentTick(tick.valueOf(), parentStart, parentGranularity, minDistance, scale, firstDayOfWeek) ? null : formatter(tick.valueOf());
          }

          if (tick > end) {
            break;
          }

          if (text) {
            ticks.push({
              time: tick.valueOf(),
              text: text
            });
          }

          parentTick = parentStart;
        }

        tick = this$1.offset(tick.valueOf(), step, granularity, firstDayOfWeek);
      }

      return ticks;
    },
    // estimate maximum label width per time granularity given a set of formats
    //
    // @param formats {Object} format for each time granularity
    estimateWidth: function estimateWidth(formats, size) {
      var format, granularity;

      if (Delegate == null) {
        Delegate = WaveChartsRuntime.getDelegate();
      }

      var widths = {};

      if (size != null) {
        for (granularity in formats) {
          format = formats[granularity];
          widths[granularity] = size;
        }
      } else {
        SAMPLES.forEach(function (sample) {
          var t = luxon.DateTime.fromISO(sample);

          for (granularity in formats) {
            format = formats[granularity];

            if (sfdcWeek.isSfdcWeekFormat(format)) {
              format = 'W[w]';
            }

            var w = Delegate.getTextWidth(t.toFormat(format), constants$1.AXIS.LABELS.TEXT.SIZE);

            if (widths[granularity] == null) {
              widths[granularity] = 0;
            }

            widths[granularity] = Math.max(widths[granularity], w);
          }
        });
      }

      return widths;
    },
    // returns a DateTime object to be at the start of a granularity of time passed in
    // - in all granularities other than weekYear, it is equavalent to DateTime.startOf
    //   DateTime does not support startOf(GRANULARITY.WEEKYEAR)
    //
    // e.g.
    // startOf( 2011 july 08 , month   ) -> 2011 july 01
    // startOf( 2011 july 08 , weekYear  ) -> 2010 dec 26
    // startOf( 2011 july 08 , year ) -> 2011 jan 01
    //
    // startOf( 2011 july 08 1pm , day ) ->  2011 july 08
    //
    // @param t {Object} DateTime time object
    // @param granularity {String} granularity which to calculate start
    startOf: function startOf(t, granularity, firstDayOfWeek) {
      if (granularity === GRANULARITY.WEEKYEAR) {
        return luxon.DateTime.fromMillis(t).set({
          weekNumber: 1,
          weekday: 1,
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
      } else if (granularity === GRANULARITY.SFDC_WEEK) {
        return sfdcWeek.startOf(t, firstDayOfWeek);
      } else {
        return luxon.DateTime.fromMillis(t).startOf(granularity);
      }
    },
    // returns a DateTime object to be offseted by n units of granularity from time passed in
    // - in all granularities other than weekYear, it is equavalent to DateTime.plus
    //   DateTime does not support plus(GRANULARITY.WEEKYEAR)
    // - granularity is GRANULARITY.WEEKYEAR, result is always the start of weekYear (year has different
    //   number of weeks, so can not keep t's offset within weekYear)
    //
    // e.g.
    // offset( 2011 july 08 , 1, month    ) -> 2011 August 08
    // offset( 2011 july 08 , 2, day      ) ->  2011 july 10
    // offset( 2014-12-28   , 1, weekYear ) -> 2015-12-27
    //
    // @param t {Object} DateTime time object
    // @param granularity {String} granularity by which to offset
    // @param n {Number} number of units of granularities to offset
    offset: function offset(t, n, granularity, firstDayOfWeek) {
      var obj;

      if (granularity === GRANULARITY.WEEKYEAR) {
        var dt = luxon.DateTime.fromMillis(t);
        return dt.set({
          year: dt.weekYear + n,
          month: 6,
          day: 1
        }).set({
          weekNumber: 1
        }); // May 01, always has the same weekYear and year
      } else if (granularity === GRANULARITY.SFDC_WEEK) {
        return sfdcWeek.offset(t, n, firstDayOfWeek);
      } else if (granularity === GRANULARITY.QUARTER) {
        return quarterTime.offset(t, n);
      } else {
        granularity = GRANULARITY_INFO[granularity].durationGranuarilty;
        return luxon.DateTime.fromMillis(t).plus((obj = {}, obj[granularity] = n, obj));
      }
    },
    diff: function diff(min, max, granularity, firstDayOfWeek) {
      if (granularity === GRANULARITY.SFDC_WEEK) {
        return sfdcWeek.diff(min, max, firstDayOfWeek);
      }

      if (granularity === GRANULARITY.QUARTER) {
        return quarterTime.diff(min, max);
      } // granularity: month => months


      var durationGranuarilty = GRANULARITY_INFO[granularity].durationGranuarilty;
      var difference = luxon.DateTime.fromMillis(max).diff(luxon.DateTime.fromMillis(min), durationGranuarilty).toObject()[durationGranuarilty] || 0;
      return difference;
    },
    duration: function duration(n, granularity) {
      var obj;

      if (granularity === GRANULARITY.SFDC_WEEK) {
        granularity = GRANULARITY.WEEK;
      }

      if (granularity === GRANULARITY.QUARTER) {
        return quarterTime.duration(n);
      } // granularity: month => months


      return luxon.Duration.fromObject((obj = {}, obj[GRANULARITY_INFO[granularity].durationGranuarilty] = n, obj));
    },
    getDateTimeFromMillis: function getDateTimeFromMillis(epoch) {
      return luxon.DateTime.fromMillis(epoch);
    },
    getDateTimeFromObject: function getDateTimeFromObject(object) {
      return luxon.DateTime.fromObject(object);
    }
  };
  var SERIES_KEY$1 = constants$1.SERIES_KEY;
  var percentageUtils = {
    // calculates the percent for a given value
    percent: function percent(val, total) {
      if (val == null) {
        val = 0;
      }

      return total === 0 ? total : val * 100 / total;
    },
    getDataPercent: function getDataPercent(data, measureName) {
      var percentData = rowsUtils$1.getRowInternalField(data, constants$1.PERCENTAGE_INFO_KEY);
      return percentData ? percentData.measures[measureName].percent : undefined;
    },

    /*
    	groups the rows to calculate a total.
    	eg:
    	rows: [
    		{year: 2010, region: AP, sumAmount: 10, numOpps: 20}
    		{year: 2010, region: US, sumAmount: 20, numOpps: 30}
    		{year: 2011, region: AP, sumAmount: 30, numOpps: 40}
    		{year: 2011, region: US, sumAmount: 40, numOpps: 50}
    	]
    	groupColumns: [{column: "year"}]
    	measureColumns: [{column: "sumAmount"}, {column: "numOpps"}]
    		groups = {
    		groupNames: ["year"]
    		2010:
    			sumAmount: 30
    			numOpps: 50
    		2011:
    			sumAmount: 70
    			numOpps: 90
    	}
    		returns a row transform function, which takes in a row and augments it with the percentData:
    	row: {year: 2010, region: AP, sumAmount: 10, numOpps: 20}
    	transformedRow: {
    		year: 2010,
    		region: AP,
    		sumAmount: 10,
    		numOpps: 20,
    	____Rowinternal: {
    			"__%__": {
    				groups: [ "year" ]
    				measures: {
    					sumAmount:
    						percent: 33.333333
    						total: 30
    					numOpps:
    						percent: 40
    						total: 50
    				}
    			}
    		}
    	}
    */
    getPercentRowTransform: function getPercentRowTransform(rows, groupColumns, measureColumns) {
      var this$1 = this;
      var groupNames = groupColumns.map(function (column) {
        return column.getName();
      });
      var keyFct = valueFctUtils.getValueFct({
        field: groupColumns
      });
      var groups = {};

      var getMeasureGroup = function getMeasureGroup(row) {
        var key = keyFct(row) || "";

        if (!groups[key]) {
          groups[key] = {};
        }

        return groups[key];
      };

      rows.forEach(function (row) {
        if (row[SERIES_KEY$1] != null) {
          return;
        }

        var measureGroup = getMeasureGroup(row);
        measureColumns.forEach(function (column) {
          var columnName = column.getName();

          if (row[columnName] != null) {
            if (!measureGroup[columnName]) {
              measureGroup[columnName] = 0;
            }

            measureGroup[columnName] += Math.abs(row[columnName]);
          }
        });
      });
      return function (row) {
        if (row[SERIES_KEY$1] == null) {
          this$1.addPercentData(row, {
            groupNames: groupNames,
            measures: getMeasureGroup(row)
          });
        }

        return row;
      };
    },
    // add the percent field to a data object so that the tooltip shows a formatted percentage
    // @param data {Object} data object to which percent field is added
    // @param percentData {Object} percent field details
    //		- total {number} total value over which percent is to be calculated
    //		- name {string} name of the measure
    // return
    // data["__%__"]
    // 		groups: [ "year", "quarter" ]
    //		measures:
    // 			sumAmount:
    // 				percent: 76
    // 				total: 100
    // 			numOpps:
    // 				percent: 84.56
    // 				total: 177233.67
    addPercentData: function addPercentData(data, percentData) {
      var this$1 = this;

      if (percentData == null) {
        percentData = {};
      }

      var groupNames = percentData.groupNames;
      var measures = percentData.measures;
      var _measures = {};

      for (var measure in measures) {
        var total = measures[measure];

        if ((data != null ? data[measure] : undefined) != null) {
          _measures[measure] = {
            percent: this$1.percent(data[measure], total),
            total: total
          };
        }
      }

      rowsUtils$1.setRowInternalField(data, constants$1.PERCENTAGE_INFO_KEY, {
        groups: groupNames,
        measures: _measures
      });
      return data;
    }
  }; //-ignore

  var ROW_INTERNAL_KEY$1 = constants$1.ROW_INTERNAL_KEY;
  var SERIES_KEY = constants$1.SERIES_KEY;
  var rowsUtils;
  var rowsUtils$1 = rowsUtils = {
    //--------------------------------------------------------------------------------
    //
    // data reshape
    //
    //--------------------------------------------------------------------------------
    layoutTabularRows: function layoutTabularRows(rows, columns, keyFct, options) {
      if (options === void 0) options = {};
      var tabularRows = new TabularRows(rows, columns, keyFct, options);
      var sorting = options.sorting;

      if (sorting && sorting.enabled && sorting.column && columns.length > 0 && sorting.internal) {
        var sortColumn = sorting.column[0];

        if (sortColumn.getType() == constants$1.COLUMN_TYPE.MEASURE) {
          // summarize - true sort by absolute sum, false original value
          tabularRows.rollup(sortColumn, function (values) {
            var res = lodash__default.filter(values);

            if (options.summarize) {
              res = res.map(Math.abs);
            }

            return mathUtils.sum(res);
          });
          tabularRows.sortByRollup(sortColumn, sorting.order);
        }
      }

      return tabularRows;
    },
    // rows = [
    // 	[1, 2, 3],
    // 	[a, b, c]
    // ];
    // cols = [
    // 	[1, a],
    // 	[2, b],
    // 	[3, c]
    // ];
    //
    // transpose(rows) = cols
    // transpose(cols) = rows
    transpose: function transpose(rows) {
      // transpose matrix
      return dataUtils.zip.apply(dataUtils, rows);
    },
    // convert an array of rows into an object of columns and vice versa
    //
    // rows = [
    //   {name:"n1", amount:20, state:"NY"}
    //   {name:"n2", amount:30, state:"CA"}
    // ];
    //
    // cols = {
    //   name: ["n1", "n2"]
    //   amount: [20, 30]
    //   state: ["NY", "CA"]
    // };
    //
    // rows_with_holes = [
    // 	{name:"n1", amount:20,           }
    // 	{           amount:30, state:"NY"}
    // 	{name:"n3",            state:"CA"}
    // ]
    //
    // cols_with_holes =
    // name: ["n1", undefined, "n3"]
    // amount: [20, 30, undefined ]
    // state: [ undefined, "NY", "CA"]
    //
    // rows2cols(rows) = cols
    // cols2rows(cols) = rows
    rows2cols: function rows2cols(rows) {
      var cols = {};
      rows.forEach(function (row) {
        lodash__default.keys(row).forEach(function (key) {
          if (cols[key] == null) {
            cols[key] = [];
          }
        });
      });
      var keys = lodash__default.keys(cols);
      rows.forEach(function (row) {
        keys.forEach(function (key) {
          cols[key].push(row[key]);
        });
      });
      return cols;
    },
    cols2rows: function cols2rows(cols) {
      var keys = lodash__default.keys(cols);

      if (keys.length === 0) {
        return [];
      }

      var numRows = cols[keys[0]].length;
      var rows = [];

      var loop = function loop(i) {
        var row$1 = {};
        keys.map(function (key) {
          return row$1[key] = cols[key][i];
        });
        rows.push(row$1);
      };

      for (var i = 0; i < numRows; i++) {
        loop(i);
      }

      return rows;
    },
    // [
    //	{ Region: US, Quarter: 1, Amount: 100}
    //	{ Region: US, Quarter: 2, Amount: 200}
    //	{ Region: US, Quarter: 3, Amount: 300}
    //	{ Region: EU, Quarter: 1, Amount: 100}
    //	{ Region: EU, Quarter: 2, Amount: 200}
    // ]
    //
    // foldRows(rows, ["Region"], "Quarter", "Amount")
    //
    // [
    // 	{ Region: US, 1: 100, 2: 200, 3: 300}
    // 	{ Region: EU, 1: 100, 2: 200}
    // ]
    foldRows: function foldRows(rows, fields, foldFields, measureField) {
      if (!foldFields) {
        return rows;
      }

      fields = dataUtils.ensureArray(fields);
      var newRows = {};
      var rowKeys = [];
      var keyFct = valueFctUtils.getValueFct({
        field: fields
      });
      var foldValueFct = valueFctUtils.getValueFct({
        field: foldFields
      });
      rows.forEach(function (row) {
        var rowKey = keyFct(row);
        var newRowKey = foldValueFct(row);
        var newRow = newRows[rowKey];

        if (!newRow) {
          newRow = lodash__default.pick.apply(lodash__default, [row].concat(lodash__default.map(fields, function (c) {
            return c.getName();
          })));
          newRows[rowKey] = newRow;
          newRow["$$data"] = {};
          rowKeys.push(rowKey);
        }

        newRow[newRowKey] = row[measureField.getName()];
        newRow["$$data"][newRowKey] = row;
      });
      return rowKeys.map(function (key) {
        return newRows[key];
      });
    },
    // The reverse operation of foldRows
    // [
    // 	{ Region: US, 1: 100, 2: 200, 3: 300}
    // 	{ Region: EU, 1: 100, 2: 200}
    // ]
    //
    // unfoldRows(rows, ["Region"] ,["1", "2", "3"], "Quarter", "Amount")
    //
    // [
    //	{ Region: US, Quarter: 1, Amount: 100}
    //	{ Region: US, Quarter: 2, Amount: 200}
    //	{ Region: US, Quarter: 3, Amount: 300}
    //	{ Region: EU, Quarter: 1, Amount: 100}
    //	{ Region: EU, Quarter: 2, Amount: 200}
    // ]
    //
    // @param rows {Array} rows
    // @param fields {Array|Object} fields to keep
    // @param values {Array} dimension values of newField to unfold
    // @param newField {Object} new field values to be unfolded into
    // @param measureField {Object} measure field
    unfoldRows: function unfoldRows(rows, fields, values, newField, measureField) {
      fields = dataUtils.ensureArray(fields);
      var newRows = [];
      var columns = lodash__default.map(fields, function (c) {
        return c.getName();
      });
      rows.forEach(function (row) {
        var originalData = row["$$data"] || {};
        var internalKey;

        for (var i = 0; i < values.length; i++) {
          var value = values[i];
          var measureValue = row[value];
          var newRow = originalData[value];

          if (!newRow && measureValue == undefined) {
            continue;
          }

          if (!newRow) {
            newRow = lodash__default.pick(row, columns);
          }

          newRow[newField.getName()] = value;
          newRow[measureField.getName()] = measureValue;

          if (internalKey = row[ROW_INTERNAL_KEY$1]) {
            if (!newRow[ROW_INTERNAL_KEY$1]) {
              newRow[ROW_INTERNAL_KEY$1] = {};
            }

            lodash__default.extend(newRow[ROW_INTERNAL_KEY$1], internalKey);
          }

          newRows.push(newRow);
        }
      });
      return newRows;
    },
    // Zero fill rows
    // e.g.
    //[
    //	{ Region: US, Quarter: 1, Amount: 100}
    //	{ Region: US, Quarter: 2, Amount: 200}
    //	{ Region: US, Quarter: 3, Amount: 300}
    //	{ Region: EU, Quarter: 1, Amount: 100}
    //	{ Region: EU, Quarter: 2, Amount: 200}
    // ]
    // zeroFillRows(rows, ["Region"] , [1, 2, 3, 4], {column: "Quarter"}, { column: "Amount" })
    //
    // [
    //	{ Region: US, Quarter: 1, Amount: 100}
    //	{ Region: US, Quarter: 2, Amount: 200}
    //	{ Region: US, Quarter: 3, Amount: 300}
    //	{ Region: US, Quarter: 4, Amount: 0  }*
    //	{ Region: EU, Quarter: 1, Amount: 100}
    //	{ Region: EU, Quarter: 2, Amount: 200}
    //	{ Region: EU, Quarter: 3, Amount: 0  }*
    //	{ Region: EU, Quarter: 4, Amount: 0  }*
    // ]
    //
    // @param rows {Array} rows
    // @param fields {Array|Object} the fields to parse
    // @param values {Array} dimension values for zerofill field
    // @param zeroFillField {Object} the field to zerofill
    // @param measureField {Object} measure field
    zeroFillRows: function zeroFillRows(rows, fields, values, zeroFillField, measureField) {
      fields = dataUtils.ensureArray(fields);
      var foldedRows = this.foldRows(rows, fields, zeroFillField, measureField);
      foldedRows.forEach(function (row) {
        values.forEach(function (value) {
          if (row[value] == null) {
            row[value] = 0;
          }
        });
      });
      return this.unfoldRows(foldedRows, fields, values, zeroFillField, measureField);
    },
    // Add total and subtotal rows
    // e.g.
    //[
    //	{ Region: US, Quarter: 1, Amount: 100}
    //	{ Region: US, Quarter: 2, Amount: 200}
    //	{ Region: US, Quarter: 3, Amount: 300}
    //	{ Region: EU, Quarter: 1, Amount: 100}
    //	{ Region: EU, Quarter: 2, Amount: 200}
    //	{ Region: AP, Quarter: 1, Amount: 100}
    //	{ Region: AP, Quarter: 2, Amount: 200}
    //	{ Region: AP, Quarter: 3, Amount: 200}
    // ]
    // addTotalRows(rows, [
    // 		{row: -1, label: 'Total'},
    // 		{row: 1, label: 'Subtotal'}
    // 	], [{column: "Region"}], {column: "Quarter"} , { column: "Amount" })
    //
    //[
    //	{ Region: US      , Quarter: 1, Amount: 100}
    //	{ Region: US      , Quarter: 2, Amount: 200}
    //	{ Region: US      , Quarter: 3, Amount: 300}
    //	{ Region: Subtotal, Quarter: 1, Amount: 100} *
    //	{ Region: Subtotal, Quarter: 2, Amount: 200} *
    //	{ Region: Subtotal, Quarter: 3, Amount: 300} *
    //	{ Region: EU      , Quarter: 1, Amount: 100}
    //	{ Region: EU      , Quarter: 2, Amount: 200}
    //	{ Region: EU      , Quarter: 3, Amount: 0  } *
    //	{ Region: AP      , Quarter: 1, Amount: 100}
    //	{ Region: AP      , Quarter: 2, Amount: 200}
    //	{ Region: AP      , Quarter: 3, Amount: 200}
    //	{ Region: Total   , Quarter: 1, Amount: 300} *
    //	{ Region: Total   , Quarter: 2, Amount: 600} *
    //	{ Region: Total   , Quarter: 3, Amount: 500} *
    // ]
    //
    // @param rows {Array} rows
    // @param parseField {Object} the field to parse
    // @param parser {Function} function to parse value of parseField
    // @param computeTotal {Boolean} whether to compute total rows or use existing rows as total
    addTotalRows: function addTotalRows(rows, totals, fields, subField, measureField, computeTotal) {
      // make a copy of rows, so inserting total rows do not modify original data rows
      var foldedCols, foldedRows, subValues;

      if (computeTotal == null) {
        computeTotal = true;
      }

      rows = dataUtils.deepCopy(rows);

      if (!totals || !totals.length) {
        return rows;
      }

      fields = dataUtils.ensureArray(fields);
      var cols = rowsUtils.rows2cols(rows);

      if (subField) {
        subValues = dataUtils.uniq(cols[subField.getName()]);
        foldedRows = this.foldRows(rows, fields, subField, measureField);
        foldedCols = rowsUtils.rows2cols(foldedRows);
      } else {
        subValues = [measureField.getName()];
        foldedRows = rows;
        foldedCols = cols;
      }

      totals = lodash__default.chain(totals).map(function (total) {
        if (total.row < 0) {
          total.row = foldedRows.length;

          if (!computeTotal) {
            total.row--;
          }
        }

        return total;
      }).sortBy(function (total) {
        return -total.row;
      }).value();
      totals.forEach(function (total) {
        var field, totalRow;
        var row = total.row;
        var label = total.label;

        if (computeTotal) {
          if (label == null) {
            label = LOC.getLabel("wave-charts", "total");
          }

          totalRow = {};
          rowsUtils.setRowInternalField(totalRow, "isTotal", true);
          fields.forEach(function (field) {
            totalRow[field.getName()] = label;
          });
          subValues.forEach(function (subValue) {
            totalRow[subValue] = mathUtils.sum(lodash__default.filter(foldedCols[subValue].slice(0, row)));
          });
          foldedRows.splice(row, 0, totalRow);
        } else if (totalRow = foldedRows[Math.round(row)]) {
          rowsUtils.setRowInternalField(totalRow, "isTotal", true); // override label for dimension value

          if (label != null) {
            fields.forEach(function (field) {
              if (field.getValueLabels() == null) {
                field._valueLabels = {};
              }

              field._valueLabels[totalRow[field.getName()]] = label;
            });
          }
        }
      });

      if (subField) {
        rows = this.unfoldRows(foldedRows, fields, subValues, subField, measureField);

        if (computeTotal) {
          var rowTransform = percentageUtils.getPercentRowTransform(rows, fields, [measureField]);
          rows = rows.map(rowTransform);
        }

        return rows;
      } else {
        return foldedRows;
      }
    },
    // Filter out any row that doesn't have a value for the specified fields
    filterOutRowsWithMissingFields: function filterOutRowsWithMissingFields(rows) {
      var this$1 = this;
      var fields = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        fields[len] = arguments[len + 1];
      }

      fields = fields.filter(function (field) {
        return field != null;
      });
      return lodash__default.filter(rows, function (row) {
        return (ref = this$1).rowHasAllFields.apply(ref, [row].concat(fields));
        var ref;
      });
    },
    rowHasAllFields: function rowHasAllFields(row) {
      var fields = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        fields[len] = arguments[len + 1];
      }

      return lodash__default.reduce(fields, function (acc, f) {
        return row[f.getName()] != null && acc;
      }, true);
    },
    // determine if the dataset is going to contain all null measures for the chart
    hasMeasures: function hasMeasures(rows, measureColumns) {
      return !lodash__default.isEmpty(lodash__default.find(rows, function (row) {
        return lodash__default.find(measureColumns, function (measure) {
          return row[measure.getName()] != null;
        }) != null;
      }));
    },
    // filter rows to only return rows for a given series
    getRowsForSeries: function getRowsForSeries(rows, series) {
      return lodash__default.filter(rows, function (row) {
        return row[SERIES_KEY] === series;
      });
    },
    // sum up a measure across all rows
    measureSum: function measureSum(rows, measure, absolute) {
      if (absolute == null) {
        absolute = false;
      }

      var values = absolute ? lodash__default.map(rows, function (row) {
        return Math.abs(row[measure.getName()]);
      }) : lodash__default.map(rows, measure.getName());
      return mathUtils.sum(values);
    },

    /**
     *  Creates a function that parses a time column of a row.
     *  The column value is mutated with its parsed value.
     *
     *  @param column the column key
     *  @param format a datetime format
     *  @return a function that takes a row and parses the specified
     *  column as a time string having the specified format
     */
    parseTimeRowTransform: function parseTimeRowTransform(column) {
      var dataFormat = column.getDataFormat();
      var columnName = column.getName();
      var firstDayOfWeek = column.getFirstDayOfWeek();
      var dataSeparator = column.getDataSeparator();
      var parser = column.getParser() || time.getParser(dataFormat, firstDayOfWeek, dataSeparator);
      return this.getInternalValueTransform(column, function (row) {
        return parser(row[columnName]);
      });
    },

    /**
     * Creates a transform function that parses a row to get row key
     * @param  {Column} keyColumn, column to assign rowKey to for each row
     * @param  {Column} fromColumns where to parse row key from, currently we join values from these columns
     * @return {Function}
     */
    parseInternalKeyTransform: function parseInternalKeyTransform(keyColumn, fromColumns) {
      var keyFct = valueFctUtils.getValueFct({
        field: fromColumns,
        defaultValue: ""
      });
      return this.getInternalValueTransform(keyColumn, keyFct);
    },

    /**
     * Creates a transform function that sets valueFct(row) back to row as internal column
     * @param  {Column} column to set value back to
     * @param  {Function} valueFct
     * @return {Function}
     */
    getInternalValueTransform: function getInternalValueTransform(column, valueFct) {
      var this$1 = this;
      var columnName = column.getInternalColumnName();
      return function (row) {
        this$1.setRowInternalField(row, columnName, valueFct(row));
        return row;
      };
    },

    /**
     *  Set an internal value on a row
     *  @param row the row
     *  @param key the key
     *  @param value the value
     */
    setRowInternalField: function setRowInternalField(row, key, value) {
      if (!row) {
        return;
      }

      var rowInternals = row[ROW_INTERNAL_KEY$1];

      if (!rowInternals) {
        row[ROW_INTERNAL_KEY$1] = rowInternals = {};
      }

      rowInternals[key] = value;
    },

    /*
     *  Get an internal value from a row
     *  @param row the row
     *  @param key the key
     *  @return the internal value or undefined if none found
     */
    getRowInternalField: function getRowInternalField(row, key) {
      var rowInternals = row[ROW_INTERNAL_KEY$1];

      if (rowInternals) {
        return rowInternals[key];
      }

      return undefined;
    },

    /**
     *  Return a copy of row without the____ROW_INTERNAL field
     *  @param row the row
     *  @return  a copy of row without____ROW_INTERNAL field
     */
    getRowWithoutInternalValue: function getRowWithoutInternalValue(row) {
      row = lodash__default.extend({}, row);
      delete row[ROW_INTERNAL_KEY$1];
      return row;
    },

    /**
     * Sort rows by value in one specific column and fill dummy rows if no row
     * has the value specified
     *
     * e.g. sortRows(
     *     [{value: "a"}, {value: "c"}],
     *     new Column("value"),
     *     ["c", "b", "a"]
     * )
     * =>
     * [
     *     {value: "c"}
     *     {value: "b"}
     *     {value: "a"}
     * ]
     *
     * @param  {Array} rows   rows to sort
     * @param  {Column} column column to sort by
     * @param  {Array} values column values to sort against
     * @return {Array}
     */
    sortRows: function sortRows(rows, column, values) {
      var obj;
      var keyFct = valueFctUtils.getValueFct({
        field: column
      });
      var columnName = column.getName();
      var rowsMap = {};
      rows.forEach(function (row) {
        var key = keyFct(row);

        if (rowsMap[key]) {
          rowsMap[key].push(row);
        } else {
          rowsMap[key] = [row];
        }
      });
      var newRows = [];
      values.forEach(function (value) {
        if (rowsMap[value]) {
          newRows = newRows.concat(rowsMap[value]);
        } else {
          newRows.push((obj = {}, obj[columnName] = value, obj));
        }
      });
      return newRows;
    }
  }; //--------------------------------------------------------------------------------
  // value functions
  //--------------------------------------------------------------------------------

  var joinValues = function joinValues(keys) {
    return JSON.stringify(keys);
  };

  var getValueFromArrayFields = function getValueFromArrayFields(fields, useParsedData) {
    if (useParsedData == null) {
      useParsedData = false;
    }

    var fcts = fields.map(function (field) {
      return getValueFctFromSingleField(field, useParsedData);
    });
    return function (row) {
      return joinValues(fcts.map(function (fct) {
        return fct(row);
      }));
    };
  };

  var getValueFctFromSingleField = function getValueFctFromSingleField(column, useParsedData) {
    if (useParsedData === void 0) useParsedData = false;

    if (!column) {
      return function (row) {
        return undefined;
      };
    }

    if (useParsedData || column.isInternalOnly()) {
      var name = column.getInternalColumnName();
      return function (row) {
        return rowsUtils$1.getRowInternalField(row, name);
      };
    } else {
      var name$1 = column.getName();
      return function (row) {
        return row[name$1];
      };
    }
  };

  var getValueFctFromField = function getValueFctFromField(field, defaultValue, useParsedData) {
    if (useParsedData == null) {
      useParsedData = false;
    }

    if (lodash__default.isArray(field)) {
      if (!field.length) {
        return getRowDefaultValueFct(defaultValue);
      } else if (field.length === 1) {
        return getValueFctFromSingleField(field[0], useParsedData);
      } else {
        return getValueFromArrayFields(field, useParsedData);
      }
    } else {
      return getValueFctFromSingleField(field, useParsedData);
    }
  };

  var getRowDefaultValueFct = function getRowDefaultValueFct(defaultValue) {
    return function () {
      return defaultValue != null ? defaultValue : undefined;
    };
  };

  var getDefaultValueFct = function getDefaultValueFct(defaultValue) {
    return function (value) {
      return value != null ? value : defaultValue;
    };
  };

  var valueFctUtils = {
    joinValues: joinValues,
    getValueFctFromSingleField: getValueFctFromSingleField,
    // Takes a value function definition object(params) and returns
    // a function which maps one row of data to a value. value function
    // definition object could have 3 properties
    //
    // 1. field - one field, an array of fields, or null
    // 2. value - function or any other data type
    // 3. scale - a scale
    // 4. parser - a parser function to apply after getting value from field, before scale
    // 5. defaultValue - a default value to apply when function result is undefined/null
    //
    // - params is { field }
    // eg 1. field non-array
    // f = getValueFct({ field: { column: "miles"} })
    // f(origin:"SJC", carrier:"UA", dest:"SFO", miles:500) -> 500
    //
    // eg 2. field array
    // f = getValueFct({ field: [{ column: "dest"}, { column: "origin"}] })
    // f(origin:"SJC", carrier:"UA", dest:"SFO", miles:500) -> "[\"SFO\",\"SJC\",\"UA\"]"
    //
    // eg 3. field array, single element
    // f = getValueFct({ field: [{ column: "dest"}] })
    // f(origin:"SJC", carrier:"UA", dest:"SFO", miles:500) -> "SFO"
    //
    // eg 4. fields null
    // f = getValueFct({ field: null })
    // f(origin:"SJC", carrier:"UA", dest:"SFO", miles:500) -> ""
    //
    // - param is { value }
    // if value is function, getValueFct returns value, otherwise, returns
    // a function which always returns value
    //
    // - param is { value, scale } or { field, scale }
    // scale the result of getValueFct({value}) or getValueFct({field})
    //
    // @param param {Object} value function definition
    getValueFct: function getValueFct(param, useParsedData) {
      if (param == null) {
        param = {};
      }

      if (useParsedData == null) {
        useParsedData = false;
      }

      var value = param.value;
      var field = param.field;
      var parser = param.parser;
      var scale = param.scale;
      var defaultValue = param.defaultValue;
      var valueFcts = value != null ? lodash__default.isFunction(value) ? [value] : [function () {
        return value;
      }] : field != null ? [getValueFctFromField(field, defaultValue, useParsedData)] : [getRowDefaultValueFct(defaultValue)];

      if (scale != null) {
        valueFcts.push(scale.scale);
      }

      if (defaultValue != null) {
        valueFcts.push(getDefaultValueFct(defaultValue));
      }

      valueFcts = lodash__default.filter(valueFcts);
      return valueFcts.length === 1 ? valueFcts[0] : dataUtils.flow(valueFcts);
    },
    // Takes a map of property name to value function definition(paramMap),
    // returns a function which converts a row of data to a map of property name
    // to value. The value is the result of executing value function defined by
    // value function definition of the property(param in paramMap) on the row of data.
    //
    // e.g.
    // f = getValueMapFct({ x: paramX, y: paramY })
    // f(row) -> { x: getValueFct(paramX)(row), y: getValueFct(paramY)(row) }
    //
    // @param paramMap {Object} map of property name to value function definition
    getValueMapFct: function getValueMapFct(paramMap) {
      var this$1 = this;
      var valueFctMap = {};

      for (var prop in paramMap) {
        var param = paramMap[prop]; // W-3849481: use the raw data for keys, so that we don't mess up selections

        valueFctMap[prop] = this$1.getValueFct(param, param.useParsedData);
      }

      return function (row) {
        var value = {};

        for (prop in valueFctMap) {
          var valueFct = valueFctMap[prop];
          value[prop] = valueFct(row);
        }

        return value;
      };
    },
    // Returns a function which allows you to safely access deeply nested fields
    //
    // @param fieldPath {String} dot separated fieldPath (like 'x.y.z', or just 'x')
    // @return {Function(data):String} a function, which takes an object (data) and returns
    //     data.x.y.z (if fieldPath is 'x.y.z') or data.x (if fieldPath is 'x'), etc...
    //
    // e.g:
    //   f = getDotAccessorFct("props.name")
    //   f(data) -> data.props.name
    //
    //   f = getDotAccessorFct("name")
    //   f(data) -> data.name
    getDotAccessorFct: function getDotAccessorFct(fieldPath) {
      if (fieldPath.indexOf(".") === -1) {
        return function (data) {
          return data != null ? data[fieldPath] : undefined;
        };
      } else {
        var fields = fieldPath.split(".");
        return function (data) {
          fields.forEach(function (field) {
            data = data != null ? data[field] : undefined;
          });
          return data;
        };
      }
    },
    // JSON parse value. If not parsable (e.g. "China"), return the original value.
    parseValue: function parseValue(value) {
      var parsedValue = value;

      try {
        parsedValue = JSON.parse(value);
      } catch (e) {}

      return parsedValue;
    }
  }; //
  //@flow-ignore

  var ShapeGroup$1;
  /*::(x: ShapeContainer<*,*,*>) => (x: IShapeContainer<*,*,*,*>)*/

  var ShapeContainer$1 = function (Group) {
    function ShapeContainer() {
      Group.apply(this, arguments);
    }

    if (Group) ShapeContainer.__proto__ = Group;
    ShapeContainer.prototype = Object.create(Group && Group.prototype);
    ShapeContainer.prototype.constructor = ShapeContainer;

    ShapeContainer.setShapeGroup = function setShapeGroup(ShapeGroupClass) {
      ShapeGroup$1 = ShapeGroupClass;
    };

    ShapeContainer.prototype.getShapes = function getShapes() {
      return this.getChildren();
    };

    ShapeContainer.prototype.shapeByKey = function shapeByKey(key) {
      return this.getChildByKey(key);
    }; // returns all shapes roll up to current shapeContainer


    ShapeContainer.prototype.getFlattenShapes = function getFlattenShapes() {
      return lodash__default.flatten(this.getChildren().map(function (child) {
        return child.getFlattenShapes();
      }));
    }; // flatten all shapes roll up to current shapeContainer


    ShapeContainer.prototype.flatten = function flatte____1() {
      var shapes = this.getFlattenShapes();
      this.removeAll();
      return this.appendAll(shapes);
    }; //--------------------------------------------------------------------------------
    // layout
    //--------------------------------------------------------------------------------
    // TODO alice declare scales type


    ShapeContainer.prototype.applyScales = function applyScales(scales) {
      if (scales == null) {
        return this;
      }

      this.getChildren().forEach(function (child) {
        child.applyScales(scales);
      });
      return this;
    }; // connect every child shape with its sibling by calling fct(child, childNext)
    //
    // @param fct {Function} fct to call on child and childNext


    ShapeContainer.prototype.connectBy = function connectBy(fct) {
      var children = this.getChildren().slice();

      for (var i = 0; i < children.length; i++) {
        var child = children[i];

        if (i > 0) {
          fct(children[i - 1], child);
        }
      }

      return this;
    }; // Splits all child shapes into shapeGroups, grouped by the fields value of
    // data binded with each shape. Shapes without data binded stays.
    //
    // @param field {Array|Object} list of fields or field to split shapes by


    ShapeContainer.prototype.groupByField = function groupByField(field) {
      var this$1 = this;
      var groupKeyFct = valueFctUtils.getValueFct({
        field: field
      }); // let shapes = [];

      var shapes = this.getFlattenShapes();
      this.removeAll();

      for (var i = 0; i < shapes.length; i++) {
        var shape = shapes[i];

        if (shape.get("data") && shape.get("data").row) {
          var groupKey = groupKeyFct(shape.get("data").row) || "";

          if (!this$1.getChildByKey(groupKey)) {
            this$1.append(new ShapeGroup$1({
              key: groupKey
            }));
          }

          this$1.getChildByKey(groupKey).append(shape);
        } else {
          this$1.append(shape);
        }
      }

      return this;
    };

    ShapeContainer.prototype.sortByField = function sortByField(field) {
      if (field == null) {
        return this;
      }

      this._setChildren(lodash__default.sortBy(this.getChildren(), // @flow-ignore
      function (child) {
        return child.get("data").row[field.getName()];
      }));

      return this;
    };

    ShapeContainer.prototype.sortBy = function sortBy(fct) {
      if (fct == null) {
        return this;
      }

      this._setChildren(lodash__default.sortBy(this.getChildren(), fct));

      return this;
    };

    return ShapeContainer;
  }(Group$1); //
  //@flow-ignore


  var __super__$1 = Object.getPrototypeOf(ShapeContainer$1.prototype);

  lodash__default.extend(ShapeContainer$1.prototype, {
    select: function select() {
      return this;
    },
    unselect: function unselect() {
      return this;
    },
    resetSelect: function resetSelect() {
      return this;
    },
    isSelected: function isSelected() {
      return false;
    }
  });
  /**
   * Note: redefine static method here because it is not inherited on IE10
   */
  //@flow-ignore

  ShapeContainer$1.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    return __super__$1.constructor.fromJson.call(this, json, deepCopy);
  }; //
  //@flow-ignore

  /*::(x: ShapeGroup<*>) => (x: IShapeGroup<*>)*/


  var ShapeGroup$2 = function (ShapeContainer) {
    function ShapeGroup(props, silent) {
      if (!props) {
        props = {
          layer: undefined,
          shapeGroup: undefined
        };
      }

      ShapeContainer.call(this, props, silent);
      var layer = props.layer;
      var shapeGroup = props.shapeGroup;

      if (layer) {
        layer.append(this);
      }

      if (shapeGroup) {
        shapeGroup.append(this);
      }
    }

    if (ShapeContainer) ShapeGroup.__proto__ = ShapeContainer;
    ShapeGroup.prototype = Object.create(ShapeContainer && ShapeContainer.prototype);
    ShapeGroup.prototype.constructor = ShapeGroup;

    ShapeGroup.prototype._setDefaultProps = function _setDefaultProps() {
      ShapeContainer.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "shapeGroup";
      props.canSelect = true;
      props.canHover = true;
      props.data = undefined;
      props.annotateChildKeys = undefined;
    };

    return ShapeGroup;
  }(ShapeContainer$1);

  ShapeGroup$2.type = "ShapeGroup"; //
  //@flow-ignore

  var __super__ = Object.getPrototypeOf(ShapeGroup$2.prototype);

  ShapeGroup$2.prototype._select = constants$1.SELECT_STATE.NONE;
  lodash__default.extend(ShapeGroup$2.prototype, {
    //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------
    hover: function hover() {
      this.getChildren().forEach(function (child) {
        if (child.get("canHover")) {
          child.hover();
        }
      });
      return this;
    },
    unhover: function unhover() {
      this.getChildren().forEach(function (child) {
        if (child.get("canHover")) {
          child.unhover();
        }
      });
      return this;
    },
    select: function select() {
      this._select = constants$1.SELECT_STATE.TRUE;
      this.getChildren().forEach(function (child) {
        if (child.get("canSelect")) {
          child.select();
        }
      });
      var parent = this.getParent();

      if (parent) {
        parent.select();
      }

      return this;
    },
    unselect: function unselect() {
      this._select = constants$1.SELECT_STATE.FALSE;
      this.getChildren().forEach(function (child) {
        if (child.get("canSelect")) {
          child.unselect();
        }
      });
      var parent = this.getParent();

      if (parent) {
        parent.unselect();
      }

      return this;
    },
    resetSelect: function resetSelect() {
      this._select = constants$1.SELECT_STATE.NONE;
      this.getChildren().forEach(function (child) {
        if (child.get("canSelect")) {
          child.resetSelect();
        }
      });
      var parent = this.getParent();

      if (parent) {
        parent.resetSelect();
      }

      return this;
    },
    isSelected: function isSelected() {
      return this._select === constants$1.SELECT_STATE.TRUE;
    },
    tabOn: function tabOn() {
      this.getChildren().filter(function (child) {
        return child.get("canHover");
      }).map(function (child) {
        return child.tabOn();
      });
      return this;
    },
    tabOff: function tabOff() {
      this.getChildren().filter(function (child) {
        return child.get("canHover");
      }).map(function (child) {
        return child.tabOff();
      });
      return this;
    },
    getInteractionEntity: function getInteractionEntity() {
      return this;
    },
    toModel: function toModel() {
      var this$1 = this;
      var models = lodash__default.flatten(this.getChildren().map(function (child) {
        return child.toModel();
      })).map(function (c) {
        c.groupKey = this$1.getKey();
        return c;
      });
      return models;
    }
  }); //-----------------------------------------------------------------------------------------
  // to model
  //-----------------------------------------------------------------------------------------

  /**
   * Note: redefine static method here because it is not inherited on IE10
   */

  ShapeGroup$2.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    return __super__.constructor.fromJson.call(this, json, deepCopy);
  }; //
  //@flow-ignore

  /*::(x: Layer<*>) => (x: ILayer<*>)*/


  var Layer = function (ShapeContainer) {
    function Layer(props, silent) {
      if (!props) {
        props = {
          cell: undefined
        };
      }

      ShapeContainer.call(this, props, silent);
      var cell = props.cell;

      if (cell) {
        cell.append(this);
      }
    }

    if (ShapeContainer) Layer.__proto__ = ShapeContainer;
    Layer.prototype = Object.create(ShapeContainer && ShapeContainer.prototype);
    Layer.prototype.constructor = Layer;

    Layer.prototype._setDefaultProps = function _setDefaultProps() {
      ShapeContainer.prototype._setDefaultProps.call(this);

      var props = this._props; // note: Layer's canHover, canSelect are by default false, while shape and
      // shapeGroup are by default true. so Layer serves as the big switch for
      // control whether child shapes/shapeGroups are interactable.

      props.x = 0;
      props.y = 0;
      props.staggerAnim = true;
      props.scales = undefined;
      props.viewport = undefined;
      props.axisOptions = undefined; // whether the Layer changes it's zindex when interacted with

      props.interactive = false; // whether Layer and children responds to select interaction

      props.canSelect = false; // whether Layer and children responds to hover interaction

      props.canHover = false; // whether the layer can scroll

      props.canScroll = true;
      props.brush = null;
    };

    Layer.prototype._onChange = function _onChange(diffOptions) {
      ShapeContainer.prototype._onChange.call(this, diffOptions);

      var diff;

      if (diff = diffOptions.scales) {
        this.applyScales(diff[0]);
      }

      return;
    };

    Layer.prototype.getCell = function getCell() {
      return this.getParent();
    };

    Layer.prototype.getScene = function getScene() {
      var cell = this.getCell();

      if (cell) {
        return cell.getScene();
      }

      return undefined;
    }; //--------------------------------------------------------------------------------
    // transforms
    //--------------------------------------------------------------------------------


    Layer.prototype.flipX = function flipX() {
      var props = this._props;
      var cell = this.getCell();
      var lastPix = cell ? cell.get("w") === 0 ? 0 : cell.get("w") - 1 : 0;

      if (props.viewport) {
        var ref = props.viewport;
        var _x = ref[0];
        var _y = ref[1];
        var _w = ref[2];
        var _h = ref[3];
        props.viewport[0] = lastPix - _x - _w;
      }

      props.x = lastPix - props.x;
      var scale____1 = props.scales;

      if (scale____1 && scale____1.x) {
        scale____1.x = scale____1.x.flip();
      }

      ShapeContainer.prototype.flipX.call(this);
      return this;
    };

    Layer.prototype.flipY = function flipY() {
      var props = this._props;
      var cell = this.getCell();
      var lastPix = cell ? cell.get("h") === 0 ? 0 : cell.get("h") - 1 : 0;

      if (props.viewport) {
        var ref = props.viewport;
        var _x = ref[0];
        var _y = ref[1];
        var _w = ref[2];
        var _h = ref[3];
        props.viewport[1] = lastPix - _y - _h;
      }

      props.y = lastPix - props.y;
      var scale____1 = props.scales;

      if (scale____1 && scale____1.y) {
        scale____1.y = scale____1.y.flip();
      }

      ShapeContainer.prototype.flipY.call(this);
      return this;
    };

    Layer.prototype.rotate = function rotate() {
      var props = this._props;
      var cell = this.getCell();
      var lastPix = cell ? cell.get("h") === 0 ? 0 : cell.get("h") - 1 : 0;

      if (props.viewport) {
        var ref = props.viewport;
        var _x = ref[0];
        var _y = ref[1];
        var _w = ref[2];
        var _h = ref[3];
        props.viewport = [_y, lastPix - _x - _w, _h, _w];
      } // TODO alice
      // Flow doesn't support [p.a, p.b] = [....] destructing, revisit when solved
      // https://github.com/facebook/flow/issues/183


      var x = props.y;
      var y = lastPix - props.x;
      props.x = x;
      props.y = y;
      var scale____1 = props.scales;

      if (scale____1) {
        var xScale = scale____1.y;
        var yScale = scale____1.x && scale____1.x.flip();
        scale____1.x = xScale;
        scale____1.y = yScale;

        if (!scale____1.x) {
          delete scale____1.x;
        }

        if (!scale____1.y) {
          delete scale____1.y;
        }
      }

      ShapeContainer.prototype.rotate.call(this);
      return this;
    }; // translate layer and viewport on x by dx


    Layer.prototype.offsetX = function offsetX(dx) {
      this._props.x += dx;

      if (this._props.viewport) {
        this._props.viewport[0] += dx;
      }

      return this;
    }; // translate layer and viewport on y by dy


    Layer.prototype.offsetY = function offsetY(dy) {
      this._props.y += dy;

      if (this._props.viewport) {
        this._props.viewport[1] += dy;
      }

      return this;
    };

    Layer.prototype.postProcess = function postProcess() {
      delete this._props.axisOptions;
      return ShapeContainer.prototype.postProcess.call(this);
    };

    Layer.prototype.boundingBox = function boundingBox(withTranslation) {
      if (withTranslation === void 0) withTranslation = false;
      var props = this._props;

      if (props.viewport) {
        // if there is a viewport, use it as the bounding box
        var ref = props.viewport;
        var x = ref[0];
        var y = ref[1];
        var w = ref[2];
        var h = ref[3];
        var bb = new Box({
          x: x - props.x,
          y: y - props.y,
          w: w,
          h: h
        });

        if (bb && withTranslation) {
          bb.offset.apply(bb, this.translation());
        }

        return bb;
      } else {
        return ShapeContainer.prototype.boundingBox.call(this, withTranslation);
      }
    }; // returns translation of current layer, considering scroll offset


    Layer.prototype.translation = function translation() {
      var ref = [this._props.x, this._props.y];
      var tx = ref[0];
      var ty = ref[1];
      var cell = this.getCell();
      var scene = this.getScene();

      if (cell && scene) {
        var sceneOffset = scene.get("scrollOffset");

        if (cell.get("scrollX")) {
          tx -= sceneOffset[0];
        }

        if (cell.get("scrollY")) {
          ty -= sceneOffset[1];
        }
      }

      return [tx, ty];
    };

    Layer.prototype.totalTranslation = function totalTranslation(withScrollX, withScrollY) {
      if (withScrollX === void 0) withScrollX = false;
      if (withScrollY === void 0) withScrollY = false;
      var x = this._props.x;
      var y = this._props.y;
      var parent = this.getParent();
      var ref = this._props;
      var canScroll = ref.canScroll;
      if (canScroll === void 0) canScroll = true;
      var ref$1 = parent && parent.totalTranslation(withScrollX && canScroll, withScrollY && canScroll) || [0, 0];
      var parentX = ref$1[0];
      var parentY = ref$1[1];
      return [parentX + x, parentY + y];
    };

    Layer.prototype.toJson = function toJson() {
      var this$1 = this;
      var json = ShapeContainer.prototype.toJson.call(this);

      if (this._props.scales) {
        json.props.scales = {};

        for (var name in this$1._props.scales) {
          var scale = this$1._props.scales[name];

          if (scale) {
            json.props.scales[name] = scale.toJson();
          }
        }
      }

      return json;
    };

    return Layer;
  }(ShapeContainer$1);

  Layer.type = "Layer";
  Layer._sensitiveProps = new StaticArraySet(["scales"]); // log params to control different levels of logging

  var log$1 = {
    events: false,
    // log all events dispatched
    scripts: false,
    // log scripts dependency loading and script execution
    perf: false,
    // log perf result
    animation: false,
    debugParams: false,
    // log debug information
    map: false,
    // draw map bounding box
    rendering: false,
    // log chart rendering
    moduleLoader: false,
    // log module loader activity
    images: false // log image loading activity

  };
  /**
  	Base Shape Effect class. Does nothing.
  
  	@author ppominville
  */

  var ShapeEffect = function ShapeEffect() {};

  ShapeEffect.prototype.applyEffect = function applyEffect(props) {
    return props;
  };

  ShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("ShapeEffect", options);
  };

  ShapeEffect.getDescriptorForType = function (type, options) {
    var descriptor = {
      type: type
    };

    if (options != null) {
      descriptor.options = options;
    }

    return descriptor;
  };

  ShapeEffect.addEffectToShape = function (shape, type) {
    var descriptor = this.getDescriptor();
    var effects = shape.get(type);

    if (!lodash__default.isArray(effects)) {
      effects = [effects];
    }

    if (!lodash__default.find(effects, function (effect) {
      return effect.type === descriptor.type;
    })) {
      effects.push(descriptor);
      shape.set(type, effects);
    }
  };
  /**
  	Default selection effect: the stroke and fill of a shape are greyscaled if there is a selection,
  	but the shape itself is not selected.
  
  	@author ppominville
  */


  var DefaultSelectionShapeEffect = function (ShapeEffec____1) {
    function DefaultSelectionShapeEffect() {
      ShapeEffec____1.apply(this, arguments);
    }

    if (ShapeEffec____1) DefaultSelectionShapeEffect.__proto__ = ShapeEffec____1;
    DefaultSelectionShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    DefaultSelectionShapeEffect.prototype.constructor = DefaultSelectionShapeEffect;

    DefaultSelectionShapeEffect.prototype.applyEffect = function applyEffect(props, ref) {
      var selectState = ref.selectState;
      var fill = props.fill;
      var stroke = props.stroke;
      var texture = props.texture;
      var r = props.r;
      var hidden = props.hidden;

      if (selectState != null) {
        var isUnselected = selectState === constants$1.SELECT_STATE.FALSE;

        if (fill) {
          fill = isUnselected ? fill.toGreyscale() : fill;
        }

        if (stroke) {
          stroke = isUnselected ? stroke.toGreyscale() : stroke;
        }

        if (isUnselected && r != null && hidden) {
          r = 0;
        }

        if (texture && isUnselected) {
          texture.shade += 0.2;
        }
      }

      return lodash__default.extend(props, {
        fill: fill,
        stroke: stroke,
        texture: texture,
        r: r
      });
    };

    return DefaultSelectionShapeEffect;
  }(ShapeEffect);

  DefaultSelectionShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("DefaultSelectionShapeEffect", options);
  };
  /**
  	Default hover shape effect
  
  	@author ppominville
  */


  var DIMMING_FACTOR = 0.5;

  var DefaultHoverShapeEffect = function (ShapeEffec____1) {
    function DefaultHoverShapeEffect() {
      ShapeEffec____1.apply(this, arguments);
    }

    if (ShapeEffec____1) DefaultHoverShapeEffect.__proto__ = ShapeEffec____1;
    DefaultHoverShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    DefaultHoverShapeEffect.prototype.constructor = DefaultHoverShapeEffect;

    DefaultHoverShapeEffect.prototype.applyEffect = function applyEffect(props, ref) {
      var hoverState = ref.hoverState;
      var fill = props.fill;
      var stroke = props.stroke;
      var texture = props.texture;

      if (hoverState != null && hoverState == constants$1.HOVER_STATE.TRUE) {
        if (fill) {
          fill = fill.dimColor(DIMMING_FACTOR);
        }

        if (stroke) {
          stroke = stroke.dimColor(DIMMING_FACTOR);
        }

        if (texture) {
          texture.shade += 0.2;
        }
      }

      return lodash__default.extend(props, {
        fill: fill,
        stroke: stroke,
        texture: texture
      });
    };

    return DefaultHoverShapeEffect;
  }(ShapeEffect);

  DefaultHoverShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("DefaultHoverShapeEffect", options);
  }; // 
  //@flow-ignore


  var colorFactory$2 = ColorFactory$1.getInstance();
  var colorFields = ['fill', 'hoverFill', 'stroke', 'hoverStroke', 'bgColor', 'hoverBgColor', 'textColor', 'textColorDark', 'textColorLight'];

  var Shape = function (Node) {
    function Shape(props, silent) {
      if (!props) {
        props = {
          layer: undefined,
          shapeGroup: undefined
        };
      }

      Node.call(this, props, silent);
      var layer = props.layer;
      var shapeGroup = props.shapeGroup;

      if (layer) {
        layer.append(this);
      }

      if (shapeGroup) {
        shapeGroup.append(this);
      }
    }

    if (Node) Shape.__proto__ = Node;
    Shape.prototype = Object.create(Node && Node.prototype);
    Shape.prototype.constructor = Shape;

    Shape.prototype._setDefaultProps = function _setDefaultProps() {
      Node.prototype._setDefaultProps.call(this);

      var props = this._props; // - opacity: shape opacity, will be applied to fill and stroke
      //            similar to globalAlpha

      props.opacity = 1;
      props.canHover = true; // whether shape responds to hover interaction

      props.canSelect = true; // whether shape responds to select interaction
      // when true, shape will be skipped when finding which shape is under cursor,
      // so it can not be clicked on, or trigger any mouse event

      props.skipInFind = false;
      props.data = undefined; // data binded with shape

      props.cursorType = constants$1.CURSOR_TYPE.DEFAULT;
      props.selectionShapeEffect = DefaultSelectionShapeEffect.getDescriptor();
      props.hoverShapeEffect = DefaultHoverShapeEffect.getDescriptor(); // array of selection keys, if undefined, the shape's "key" will be used

      props.selectionKeys = undefined;
      props.onClick = undefined;
    };

    Shape.prototype._mapValue = function _mapValue(prop, value) {
      if (colorFields.indexOf(prop) > -1) {
        return this._mapColor(value);
      } else {
        return value;
      }
    };

    Shape.prototype._mapColor = function _mapColor(value) {
      if (typeof value === 'string' && value !== '') {
        return colorFactory$2.getColor(value);
      } else {
        return value;
      }
    };

    Shape.prototype.getLayer = function getLayer() {
      var parent = this.getParent();

      while (parent && !(parent instanceof Layer)) {
        parent = parent.getParent();
      }

      return parent;
    };

    Shape.prototype.getFlattenShapes = function getFlattenShapes() {
      return this;
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------
    // scale the shape's properties according to scale definition on layer
    // returns new property map
    //
    // note that if the properly to scale is an array, the scale is applied to every element of the array
    // @perf-optimized


    Shape.prototype.applyScales = function applyScales(scales) {
      var this$1 = this;
      var propMap = {};
      var propertiesByScale = this.getPropertiesByScale();

      var loop = function loop(scaleName) {
        var props = propertiesByScale[scaleName];
        var scale = scales[scaleName];

        if (!scale) {
          return;
        }

        var thisProps = this$1._props;

        for (var i = 0; i < props.length; i++) {
          var prop = props[i];
          var val = thisProps[prop];
          propMap[prop] = val == null ? undefined : lodash__default.isArray(val) ? val.map(function (v) {
            return scale.scale(v);
          }) : scale.scale(val);
        }
      };

      for (var scaleName in propertiesByScale) {
        loop(scaleName);
      }

      return this.set(propMap);
    };

    Shape.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {};
    };

    Shape.prototype.getRotation = function getRotation() {
      return;
    };

    Shape.prototype.isVisible = function isVisible() {
      return this._props.opacity > 0;
    }; //-----------------------------------------------------------------------------------------
    // Bounding box
    //
    // trueBoundingBox - boundingBox of shape(can have rotation)
    // boundingBox - axis aligned bounding box(aabb) of trueBoundingBox(no rotation)
    //
    //  _____________
    // |      ⟋⟍    |
    // |    ⟋    ⟍  |
    // |  ⟋        ⟍|
    // |⟋  true bb ⟋|
    // |⟍        ⟋  |
    // |  ⟍    ⟋    | <- boundingBox
    // |____⟍⟋______|
    //
    // - trueBoundingBox is cached at @_trueBoundingBox
    // - call _forceRecomputeBoundingBox to clear cache and force compute bb next time when its needed
    // - subclass implements _computeTrueBoundingBox to compute true boundingBox
    //-----------------------------------------------------------------------------------------
    // force bb recompute next time it's needed


    Shape.prototype._forceRecomputeBoundingBox = function _forceRecomputeBoundingBox() {
      this._trueBoundingBox = null;
      return;
    };

    Shape.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      return new Box();
    }; // Return the axis aligned bb of true bounding box


    Shape.prototype.boundingBox = function boundingBox() {
      return this.trueBoundingBox().toAABB();
    }; // Return bb if cached, otherwise recompute bb


    Shape.prototype.trueBoundingBox = function trueBoundingBox() {
      if (!this._trueBoundingBox) {
        this._trueBoundingBox = this._computeTrueBoundingBox();
      }

      return this._trueBoundingBox;
    }; // area a shape occupies on x,y coordinate and affected by x,y scale


    Shape.prototype.domainBox = function domainBox() {
      return this.boundingBox();
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------
    // flip a properties (x -> -x)
    //
    // note that if the properly to flip is an array, the flip is applied to every element of the array


    Shape.prototype._flipProp = function _flipProp(prop) {
      var val = this._props[prop];

      if (val != null) {
        this._props[prop] = lodash__default.isArray(val) ? val.map(function (v) {
          return -v;
        }) : -val;
      }

      return this;
    }; // flip(mirror) shape horizontally


    Shape.prototype.flipX = function flipX() {
      var this$1 = this;

      this._forceRecomputeBoundingBox();

      var propertiesByScale = this.getPropertiesByScale();

      if (propertiesByScale.x) {
        propertiesByScale.x.forEach(function (prop) {
          this$1._flipProp(prop);
        });
      }

      this._props.angle = -this._props.angle;
      return this;
    }; // flip(mirror) shape vertically


    Shape.prototype.flipY = function flipY() {
      var this$1 = this;

      this._forceRecomputeBoundingBox();

      var propertiesByScale = this.getPropertiesByScale();

      if (propertiesByScale.y) {
        propertiesByScale.y.forEach(function (prop) {
          this$1._flipProp(prop);
        });
      }

      this._props.angle = -this._props.angle;
      return this;
    }; // move shape on x coordinate by dx


    Shape.prototype.offsetX = function offsetX(dx) {
      this._forceRecomputeBoundingBox();

      return this;
    }; // move shape on y coordinate by dy


    Shape.prototype.offsetY = function offsetY(dy) {
      this._forceRecomputeBoundingBox();

      return this;
    };

    Shape.prototype.rotate = function rotate() {
      this._forceRecomputeBoundingBox();

      return this;
    };

    return Shape;
  }(Node$1);
  /**
  	Highlight shape effect
  
  	@author ppominville
  */


  var HighlightHoverShapeEffect = function (ShapeEffec____1) {
    function HighlightHoverShapeEffect() {
      ShapeEffec____1.apply(this, arguments);
    }

    if (ShapeEffec____1) HighlightHoverShapeEffect.__proto__ = ShapeEffec____1;
    HighlightHoverShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    HighlightHoverShapeEffect.prototype.constructor = HighlightHoverShapeEffect;

    HighlightHoverShapeEffect.prototype.applyEffect = function applyEffect(props, ref) {
      var hoverState = ref.hoverState;
      var hoverBgColor = props.hoverBgColor;
      var hoverStroke = props.hoverStroke;
      var bgColor = props.bgColor;
      var stroke = props.stroke;

      if (hoverState != null && hoverState == constants$1.HOVER_STATE.TRUE) {
        if (hoverBgColor != null) {
          bgColor = hoverBgColor;
        }

        if (hoverStroke != null) {
          stroke = hoverStroke;
        }
      }

      return lodash__default.extend(props, {
        bgColor: bgColor,
        stroke: stroke
      });
    };

    return HighlightHoverShapeEffect;
  }(ShapeEffect);

  HighlightHoverShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("HighlightHoverShapeEffect", options);
  };

  var flipHalign = {
    right: "left",
    left: "right",
    center: "center"
  };
  var transposeHalign = {
    right: "top",
    left: "bottom",
    center: "middle"
  };
  var flipValign = {
    top: "bottom",
    bottom: "top",
    middle: "middle"
  };
  var transposeValign = {
    top: "left",
    bottom: "right",
    middle: "center"
  }; // note:
  // 1) about x, y property to model property conversion (x_m, y_m are model props)
  // - model x, y is always the left-baseline point of the text
  // e.g. halign right
  // vertical: false
  //            x
  //       |    |
  // y_m___|text|___y
  //       |    |
  //      x_m
  //
  // vertial: true
  //     x
  //     |___y
  //    t|
  //    e|
  //    x|
  //    t|___y_m
  //     x_m
  //

  var SIZE_ASCENDER = 0;
  var SIZE_DESCENDER = 0;

  var Text$1 = function (Shap____1) {
    function Text(options) {
      if (options == null) {
        options = {};
      }

      if (!SIZE_ASCENDER) {
        var assign;
        assign = WaveChartsRuntime.getDelegate().fontInfo(), SIZE_ASCENDER = assign.SIZE_ASCENDER, SIZE_DESCENDER = assign.SIZE_DESCENDER;
      }

      Shap____1.call(this, options);
      this._maxTextWidth = 0; // we will compute (and cache) the max text width

      this._isTruncated = undefined;
    }

    if (Shap____1) Text.__proto__ = Shap____1;
    Text.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Text.prototype.constructor = Text;

    Text.initClass = function initClass() {
      this.type = "Text";
      this.shapeEffectsProps = ["stroke", "bgColor", "hoverBgColor", "hoverStroke"];
      this._sensitiveProps = new StaticArraySet(["pivot", "text"]);
    };

    Text.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "Text";
      props.x = 0;
      props.y = 0;
      props.text = undefined;
      props.stroke = undefined;
      props.size = 12;
      props.halign = "left"; // left | center | right

      props.valign = "bottom"; // top | middle | bottom

      props.vertical = false; // - maxWidth of text, text will be truncated based on maxWidth
      //   undefined or null == no maxWidth

      props.maxWidth = undefined; // - true if you want to consider the descender when aligning text
      //   (set it to false when you knowthe text is always going to be above the basline, like for numbers...)

      props.includeDescender = true; // - for vertical text, whether the script is rotate clock wide (true) or counter clock wide (false)
      //   true - rotate clock-wise, as opposed to natural ccw rotation

      props.cw = false; // - rotation pivot point, if not specified, rotation will piovot at (x, y)

      props.pivot = undefined;
      props.pivot_x = undefined;
      props.pivot_y = undefined; // - rotation angle in radian

      props.angle = 0; // - background color for text on hover

      props.hoverBgColor = undefined; // - color for text on hover

      props.hoverStroke = undefined; // - background color for text

      props.bgColor = undefined;
      props.hotSpots = undefined;
      props.canSelect = false; // - When fixedOrientation is set, the orientation is fixed regardless of transforms

      props.fixedOrientation = false;
      props.hoverShapeEffect = [props.hoverShapeEffect, HighlightHoverShapeEffect.getDescriptor()];
      props.padding = new Padding({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      });
    };

    Text.prototype._mapValue = function _mapValue(prop, value) {
      value = Shap____1.prototype._mapValue.call(this, prop, value);

      if (prop === "angle") {
        return lodash__default.isNumber(value) ? value : 0;
      } else if (prop === "padding") {
        return new Padding(value);
      }

      return value;
    };

    Text.prototype._onChange = function _onChange(optionsDiff) {
      var diff, value;

      Shap____1.prototype._onChange.call(this, optionsDiff);

      if (diff = optionsDiff.pivot) {
        value = diff[0];
        this._props.pivot_x = value[0];
        this._props.pivot_y = value[1];
      }

      if (diff = optionsDiff.text) {
        this._props.text = "" + diff[0];
      }
    };

    Text.prototype._hasFixedWidth = function _hasFixedWidth() {
      return this.hasBackground() && this._props.maxWidth != null;
    };

    Text.prototype.set = function set(props, value, silent) {
      this._isTruncated = undefined;

      this._forceRecomputeBoundingBox();

      return Shap____1.prototype.set.call(this, props, value, silent);
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------


    Text.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x", "pivot_x"],
        y: ["y", "pivot_y"]
      };
    }; // Fit the text element into the given width/height, bounded by min/max font sizes.
    //


    Text.prototype.fitToSize = function fitToSize(targetWidth, targetHeight, MIN_FONT_SIZE, MAX_FONT_SIZE) {
      var this$1 = this;

      if (MIN_FONT_SIZE == null) {
        MIN_FONT_SIZE = 12;
      }

      if (MAX_FONT_SIZE == null) {
        MAX_FONT_SIZE = 1000;
      }

      this.set({
        size: MAX_FONT_SIZE
      });
      var currentMinSize = MIN_FONT_SIZE;
      var currentMaxSize = MAX_FONT_SIZE; // As an added safety precaution, prevent possible infinite loops with a max iteration guard of 1000.

      var i = 0;

      while (i < 1000) {
        var oldFontSize = fontSize;
        var fontSize = currentMinSize + (currentMaxSize - currentMinSize) / 2;
        this$1.set({
          size: fontSize
        });
        var renderedSize = this$1.boundingBox(); // If the size is tolerably close to the available width

        var isWithinTolerance = renderedSize.w >= targetWidth * 0.95 && renderedSize.w <= targetWidth && renderedSize.h < targetHeight || renderedSize.h >= targetHeight * 0.95 && renderedSize.h <= targetHeight && renderedSize.w < targetWidth;

        if (fontSize === oldFontSize || fontSize === MIN_FONT_SIZE || fontSize === MAX_FONT_SIZE || isWithinTolerance) {
          break;
        } else if (renderedSize.w > targetWidth || renderedSize.h > targetHeight) {
          currentMaxSize = fontSize;
        } else {
          currentMinSize = fontSize;
        }

        i++;
      }

      return this;
    }; // This method is mostly a helper method for tests
    //
    // It simulates what the renderer does so we can test the text
    // truncation without having to fully render the chart


    Text.prototype.getText = function getText() {
      this.trueBoundingBox();
      var ref = this.getModelProps();
      var maxWidth = ref.maxWidth;
      var text = ref.text;
      var fontSize = ref.fontSize;

      if (maxWidth != null) {
        var sizeRatio = fontSize / 12;
        return WaveChartsRuntime.getDelegate().getTruncatedText(text, maxWidth / sizeRatio);
      } else {
        return text;
      }
    }; // halign: "left" for all scenarios, getW() returns w
    // - no maxWidth
    //   __________________________________________________
    //   |      |#                                   |    |
    //   |      |#                                   |    |
    //   |      |#                                   |    |
    //   |      |#                                   |    |
    //   |      |#                                   |    |
    //   |      |#      ##### ##### ##### ##### #####|    |
    //   | lPad |#      #   # #   # #   # #   # #   #|rPad|
    //   |      |#      #   # #   # #   # #   # #   #|    |
    //   |      |#      #   # #   # #   # #   # #   #|    |
    //   |      |###### ##### ##### ##### ##### #####|    |
    //   |      |                               #    |    |
    //   |      |                               #    |    |
    //   |      |                               #    |    |
    //   |      |                               #    |    |
    //   |______|_______________________________#____|____|
    //   |<                      w                       >|
    //
    // - maxWidth, truncation
    //
    //   |<                maxWidth                  >|
    //    ____________________________________________
    //   |      |#                               |    |
    //   |      |#                               |    |
    //   |      |#                               |    |
    //   |      |#                               |    |
    //   |      |#                               |    |
    //   |      |#      ##### #####         #####|    |
    //   | lPad |#      #   # #   #         #   #|rPad|
    //   |      |#      #   # #   #         #   #|    |
    //   |      |#      #   # #   #         #   #|    |
    //   |      |###### ##### ##### # # # # #####|    |
    //   |      |                           #    |    |
    //   |      |                           #    |    |
    //   |      |                           #    |    |
    //   |      |                           #    |    |
    //   |______|___________________________#____|____|
    //   |<                   w                      >|
    //
    // -  maxWidth, no truncation
    //    no bgColor
    //
    //   |<                             maxWidth                            >|
    //   _____________________________________________________________________
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#      ##### ##### ##### ##### #####|    |                  |
    //   | lPad |#      #   # #   # #   # #   # #   #|rPad|                  |
    //   |      |#      #   # #   # #   # #   # #   #|    |                  |
    //   |      |#      #   # #   # #   # #   # #   #|    |                  |
    //   |      |###### ##### ##### ##### ##### #####|    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |______|_______________________________#____|____|__________________|
    //   |<                      w                       >|
    //
    // -  maxWidth, no truncation
    //    bgColor
    //
    //   |<                             maxWidth                            >|
    //   _____________________________________________________________________
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#                                   |    |                  |
    //   |      |#      ##### ##### ##### ##### #####|    |                  |
    //   | lPad |#      #   # #   # #   # #   # #   #|rPad|                  |
    //   |      |#      #   # #   # #   # #   # #   #|    |                  |
    //   |      |#      #   # #   # #   # #   # #   #|    |                  |
    //   |      |###### ##### ##### ##### ##### #####|    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |      |                               #    |    |                  |
    //   |______|_______________________________#____|____|__________________|
    //   |<                                w                                >|


    Text.prototype.getW = function getW() {
      if (this._hasFixedWidth()) {
        return this._props.maxWidth;
      } else {
        var ref = this._props.padding;
        var left = ref.left;
        var right = ref.right;
        return this.getTextW() + left + right;
      }
    };

    Text.prototype.getH = function getH() {
      var ref = this._props.padding;
      var top = ref.top;
      var bottom = ref.bottom;
      return this.getTextH() + top + bottom;
    };

    Text.prototype.getTextH = function getTextH() {
      return WaveChartsRuntime.getDelegate().getRealFontSize(this._props.size);
    };

    Text.prototype.getTextW = function getTextW() {
      if (this._hasFixedWidth()) {
        var ref = this._props.padding;
        var left = ref.left;
        var right = ref.right;
        this._maxTextWidth = Math.max(this._props.maxWidth - left - right, 0);
        return this._maxTextWidth;
      } else if (this.isTruncated()) {
        return this._maxTextWidth;
      } else {
        return WaveChartsRuntime.getDelegate().getTextWidth(this._props.text, this._props.size);
      }
    };

    Text.prototype.getRotation = function getRotation() {
      var angle = this._props.vertical ? this._props.cw ? Math.PI / 2 : -Math.PI / 2 : 0;
      angle += this._props.angle;

      if (angle) {
        var ref = this._props.pivot_x != null ? [this._props.pivot_x, this._props.pivot_y] : [this._props.x, this._props.y];
        var x = ref[0];
        var y = ref[1];
        return {
          x: x,
          y: y,
          angle: angle
        };
      } else {
        return null;
      }
    };

    Text.prototype.hasBackground = function hasBackground() {
      return this._props.bgColor || this._props.hoverBgColor;
    }; // Get text bottom-left (tX, tY) or boundingBox bottom-left (boxX, boxY)
    // coordinates depending on halign, valign
    // - no padding
    //                          boundingBox
    //                   ________________________   _________________
    //                  |#                       |   /|\          /|\
    //                  |#                       |    |            |
    //                  |#                       |    |ascender    |
    //                  |#                       |    |            |
    //                  |#_______________________|  _\|/_______    |
    //                  |#      ##### ##### #####|                 |
    //                  |#      #   # #   # #   #|                 |
    //                  |#      #   # #   # #   #|                 |  textH
    //                  |#      #   # #   # #   #|                 |
    //       (tX, tY) _ |###### ##### ##### #####|  ____________   |
    //                  |                   #    |   /|\           |
    //                  |                   #    |    |            |
    //                  |                   #    |    |descender   |
    //                  |                   #    |    |            |
    //   (boxX, boxY) _ |___________________#____|  _\|/__________\|/
    //
    // - with padding
    //                          boundingBox
    //                   ______________________________________    _________________
    //                  |                                      |    /|\          /|\
    //                  |                                      |     |            |
    //                  |                                      |     |ascender    |
    //                  |      #                               |     |            |
    //                  |     _#_______________________        |   _\|/_______    |
    //                  |left |#                       |       |    /|\           |
    //                  |pad  |#                       |       |     | top-pad    |
    //                  |     |#                       |       |   _\|/_______    |
    //                  |     |#      ##### ##### #####|       |                  |
    //                  |     |#      #   # #   # #   #|  right|                  |
    //                  |     |#      #   # #   # #   #|    pad|                  |  textH
    //                  |(tX, |#      #   # #   # #   #|       |                  |
    //                  | tY)_|###### ##### ##### #####|       |   _____________  |
    //                  |     |                   #    |       |    /|\           |
    //                  |     |                   #    |       |     | bottom-pad |
    //                  |     |___________________#____|       |   _\|/_________  |
    //                  |                         #            |    /|\           |
    //                  |                         #            |     |            |
    //                  |                                      |     |descender   |
    //                  |                                      |     |            |
    //   (boxX, boxY) _ |______________________________________|   _\|/__________\|/
    // @param w {Number} total width
    // @param forText {Boolean} true - (tX, tY) false - (boxX, boxY)


    Text.prototype._getBaseXY = function _getBaseXY(w, forText) {
      if (forText == null) {
        forText = true;
      }

      var h = this.getH();
      var textH = this.getTextH();
      var ref = this._props.padding;
      var top = ref.top;
      var left = ref.left;
      var bottom = ref.bottom;
      var right = ref.right;
      var sizeDescender = this._props.includeDescender ? SIZE_DESCENDER : 0;
      var baseXOffset;

      switch (this._props.halign) {
        case "right":
          baseXOffset = -w;
          break;

        case "center":
          baseXOffset = -w / 2;
          break;

        default:
          baseXOffset = 0;
        // left
      }

      var baseYOffset;

      switch (this._props.valign) {
        case "top":
          baseYOffset = textH * (1 - SIZE_ASCENDER - sizeDescender) + top;
          break;

        case "middle":
          baseYOffset = textH * (1 - SIZE_ASCENDER - sizeDescender) / 2;
          break;

        default:
          baseYOffset = -bottom;
        // bottom
      }

      if (forText) {
        baseXOffset += left;
      } else {
        baseYOffset += bottom + textH * sizeDescender;
      }

      return [this._props.x + baseXOffset, this._props.y + baseYOffset];
    }; // Adjust for text bottom-left (x, y) coordinates


    Text.prototype.getTextXY = function getTextXY() {
      var ref = this._props.padding;
      var left = ref.left;
      var right = ref.right;
      var w = this.getTextW() + left + right;

      var ref$1 = this._getBaseXY(w);

      var x = ref$1[0];
      var y = ref$1[1];
      return [Math.round(x), Math.round(y)];
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Text.prototype.isTruncated = function isTruncated() {
      if (this._isTruncated == null) {
        this._isTruncated = this._computeIsTruncated();
      }

      return this._isTruncated;
    };

    Text.prototype._computeIsTruncated = function _computeIsTruncated() {
      if (this._props.maxWidth != null) {
        var ref = this._props.padding;
        var left = ref.left;
        var right = ref.right;
        this._maxTextWidth = Math.max(this._props.maxWidth - left - right, 0);
        return WaveChartsRuntime.getDelegate().getTextWidth(this._props.text, this._props.size) > this._maxTextWidth;
      } else {
        return false;
      }
    };

    Text.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      var w = this.getW();
      var h = this.getH();

      var ref = this._getBaseXY(w, false);

      var x = ref[0];
      var y = ref[1];
      return new Box({
        x: x,
        y: y - h,
        w: w,
        h: h,
        rotation: this.getRotation()
      });
    };

    Text.prototype.domainBox = function domainBox() {
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: 0,
        h: 0
      });
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Text.prototype._flipHalign = function _flipHalign() {
      this._props.halign = flipHalign[this._props.halign];
      return this;
    };

    Text.prototype._flipValign = function _flipValign() {
      this._props.valign = flipValign[this._props.valign];
      return this;
    };

    Text.prototype._transposeTexAlign = function _transposeTexAlign() {
      var ref = this._props;
      var valign = ref.valign;
      var halign = ref.halign;
      this._props.valign = transposeHalign[halign];
      this._props.halign = transposeValign[valign];
      return this;
    };

    Text.prototype.flipY = function flipY() {
      Shap____1.prototype.flipY.call(this);

      if (this._props.vertical) {
        this._flipHalign();

        this._props.padding.flipX();
      } else {
        this._flipValign();

        this._props.padding.flipY();
      }

      return this;
    };

    Text.prototype.flipX = function flipX() {
      Shap____1.prototype.flipX.call(this);

      if (this._props.vertical) {
        this._flipValign();

        this._props.padding.flipY();
      } else {
        this._flipHalign();

        this._props.padding.flipX();
      }

      return this;
    };

    Text.prototype.offsetY = function offsetY(dy) {
      Shap____1.prototype.offsetY.call(this, dy);
      this._props.y += dy;
      return this;
    };

    Text.prototype.offsetX = function offsetX(dx) {
      Shap____1.prototype.offsetX.call(this, dx);
      this._props.x += dx;
      return this;
    };

    Text.prototype.rotate = function rotate() {
      Shap____1.prototype.rotate.call(this);

      if (this._props.vertical) {
        this._flipHalign();

        this._flipValign();
      }

      if (!this._props.fixedOrientation) {
        this._props.vertical = !this._props.vertical;
      } else {
        this._transposeTexAlign();
      }

      var assign;
      assign = [this._props.y, -this._props.x], this._props.x = assign[0], this._props.y = assign[1];
      return this;
    };

    Text.prototype.rotateTextDirection = function rotateTextDirection() {
      if (this._props.vertical) {
        this._flipHalign();

        this._flipValign();
      }

      this._props.vertical = !this._props.vertical;
      return this;
    };

    Text.prototype.toJson = function toJson() {
      var json = Shap____1.prototype.toJson.call(this);
      json.props.padding = json.props.padding != null ? json.props.padding.toJson() : undefined;
      return json;
    };

    return Text;
  }(Shape);

  Text$1.initClass();
  /**
   * Created by yi.chen on 8/31/16.
   */

  var commonConstants = {
    FONT: {
      FAMILY: '"Salesforce Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      SIZE: 12,
      LOADING_TEST: {
        TEXT: "9",
        // text to use to figure out whether the proper font has been loaded
        WIDTH: 7,
        // expected size of the text if the font has been loaded
        MAX_DELAY: 500 // maximum delay to wait for

      }
    },
    DOCUMENT_READY_MAX_DELAY: 60 * 1000,
    VIEWPORT_PADDING: 10,
    EPSILON: 0.0000001,
    ELLIPSIS: "..."
  };
  var utils$3 = {
    //--------------------------------------------------------------------------------
    // intersection
    //--------------------------------------------------------------------------------
    // returns true if the 2 rects intersect
    // each rect is [x, y, w, h]
    intersectRectRect: function intersectRectRect(r1, r2) {
      //       |      |
      //   1   |  2   |  3
      //       |      |
      // -------------------
      //       |      |
      //   4   |  5   |  6
      //       |      |
      // -------------------
      //       |      |
      //   7   |  8   |  9
      //       |      |
      //
      // let's assume r2 is in the center
      // and see where r1 falls
      if (r1[0] + r1[2] < r2[0]) {
        return false;
      } // 1,4,7


      if (r2[0] + r2[2] < r1[0]) {
        return false;
      } // 3,6,9


      if (r1[1] + r1[3] < r2[1]) {
        return false;
      } // 1,2,3


      if (r2[1] + r2[3] < r1[1]) {
        return false;
      } // 7,8,9


      return true;
    },
    // intersectLineLine: (a1, a2, b1, b2) ->
    // 	ua_t = (b2[0] - b1[0]) * (a1[1] - b1[1]) - (b2[1] - b1[1]) * (a1[0] - b1[0])
    // 	ub_t = (a2[0] - a1[0]) * (a1[1] - b1[1]) - (a2[1] - a1[1]) * (a1[0] - b1[0])
    // 	u_b = (b2[1] - b1[1]) * (a2[0] - a1[0]) - (b2[0] - b1[0]) * (a2[1] - a1[1])
    // 	unless u_b is 0
    // 		ua = ua_t / u_b
    // 		ub = ub_t / u_b
    // 		if 0 <= ua and ua <= 1 and 0 <= ub and ub <= 1
    // 			return true
    // 		else
    // 			return false
    // 	else
    // 		return false
    // intersectLinePolygon: (a1, a2, points) ->
    // 	length = points.length
    // 	for b1, i in points
    // 		b2 = points[(i+1) % length]
    // 		return true if utils.intersectLineLine a1, a2, b1, b2
    // 	return false
    // intersectRectPoly: ([x, y, w, h], points) ->
    // 	if w < 0
    // 		w = -w
    // 		x -= w
    // 	if h < 0
    // 		h = -h
    // 		y -= h
    // 	topLeft = [x, y]
    // 	bottomRight = [x + w, y + h]
    // 	topRight = [x + w, y]
    // 	bottomLeft = [x, y + h]
    // 	return true if utils.intersectLinePolygon topLeft, topRight, points
    // 	return true if utils.intersectLinePolygon topRight, bottomRight, points
    // 	return true if utils.intersectLinePolygon bottomRight, bottomLeft, points
    // 	return true if utils.intersectLinePolygon bottomLeft, topLeft, points
    // 	return false
    //--------------------------------------------------------------------------------
    // misc
    //--------------------------------------------------------------------------------
    getFont: function getFont(size) {
      return size + "px " + commonConstants.FONT.FAMILY;
    },
    // Return the value of the property of an object by taking tweening into account
    // If the property is being tweened, it returned the tweened value
    // Otherwise it returns the current value of the property
    tweenedValue: function tweenedValue(obj, property) {
      var tween;

      if (obj.tweens && (tween = obj.tweens[property]) !== undefined) {
        return tween[1];
      } else {
        return obj[property];
      }
    },
    setStyles: function setStyles(el, styles) {
      return function () {
        var result = [];

        for (var name in styles) {
          var value = styles[name];
          result.push(el.style[name] = value);
        }

        return result;
      }();
    },
    // Get current page scroll offset
    pageScrollOffset: function pageScrollOffset() {
      var docElm = document.documentElement;
      var top = (window.pageYOffset || docElm.scrollTop || 0) - (docElm.clientTop || 0);
      var left = (window.pageXOffset || docElm.scrollLeft || 0) - (docElm.clientLeft || 0);
      return {
        top: top,
        left: left
      };
    },
    // http://www.javascriptkit.com/javatutors/navigator.shtml
    isIE: function isIE() {
      var detectIEregexp = navigator.userAgent.indexOf('MSIE') !== -1 ? /MSIE (\d+\.\d+);/ //test for MSIE x.x
      : // if no "MSIE" string in userAgent
      /Trident.*rv[ :]*(\d+\.\d+)/; //test for rv:x.x or rv x.x where Trident string exists

      return detectIEregexp.test(navigator.userAgent);
    },
    // @param {HTML div} el
    // @param {Array} [w, h] of div
    // @return {Boolean} if html element is visible in viewport
    //
    // note: the size is needed since technically a chart can be renderered
    // outside of its enclosing div. We expect the consumer app to size the
    // div correctly but we do not enforce it
    isElementInViewport: function isElementInViewport(el, size) {
      var ref = el.getBoundingClientRect();
      var left = ref.left;
      var top = ref.top;
      var width = ref.width;
      var height = ref.height; // dda, 18/10/2016:
      // Not sure why this seems to happen: in wave whenever we close a tab
      // each chart div gets moved to [0, 0] and resized to [0, 0]... is it a react issue ?
      //
      // So this protects against this. The unfortunate side effect is that if you
      // have a legit div in [0, 0], of size [0, 0], then it won't be rendered.
      // This should be quite unlikely thought (the size [0,0] is already a semi user-error...)

      if (left === 0 && top === 0 && width === 0 && height === 0) {
        return false;
      }

      var elRect = [left, top, size[0], size[1]];
      var windowBottom = window.innerHeight || document.documentElement.clientHeight;
      var windowRight = window.innerWidth || document.documentElement.clientWidth;
      var windowRect = [0, 0, windowRight, windowBottom];
      return utils$3.intersectRectRect(elRect, windowRect);
    }
  }; //

  /**
   * Created by yi.chen on 3/23/17.
   */

  var ELLIPSIS$1 = commonConstants.ELLIPSIS;
  var FONT = commonConstants.FONT;
  var EPSILON = commonConstants.EPSILON;

  var TextUtils = function TextUtils() {
    this._delegate = null;
    this.reset();
  };

  TextUtils.cacheKey = function cacheKey(text, truncatedWidth) {
    return text + "-" + truncatedWidth;
  };

  TextUtils.prototype.getTextDelegate = function getTextDelegate() {
    return this._delegate;
  };

  TextUtils.prototype.setTextDelegate = function setTextDelegate(delegate) {
    this._delegate = delegate;
  };

  TextUtils.prototype.reset = function reset() {
    this._measuredText = {};
    this._truncatedText = {};
    return this;
  };

  TextUtils.prototype.getFont = function getFont(size) {
    return size + "px " + FONT.FAMILY;
  };

  TextUtils.prototype.getTextWidth = function getTextWidth(text) {
    var textWidth = 0;

    if (text != null) {
      if (this._measuredText.hasOwnProperty(text)) {
        textWidth = this._measuredText[text];
      } else if (this._delegate) {
        textWidth = this._delegate.measureText(text).width;
        this._measuredText[text] = textWidth;
      }
    }

    return textWidth || 0;
  };

  TextUtils.prototype.getTruncatedText = function getTruncatedText(text, truncatedWidth) {
    var this$1 = this;
    var cacheKey = TextUtils.cacheKey(text, truncatedWidth);
    var truncatedText;

    if (this._truncatedText.hasOwnProperty(cacheKey)) {
      truncatedText = this._truncatedText[cacheKey];
    } else {
      if (this.getTextWidth(text) <= truncatedWidth + EPSILON) {
        truncatedText = text;
      } else {
        var ellipsisWidth = this.getTextWidth(ELLIPSIS$1);
        truncatedText = "";

        if (truncatedWidth > ellipsisWidth) {
          var head = 0,
              tail = text.length - 1;

          while (tail >= head) {
            var mid = head + (tail - head >> 1);
            var textWidth = this$1.getTextWidth(text.slice(0, mid + 1) + ELLIPSIS$1);

            if (textWidth === truncatedWidth) {
              tail = mid;
              break;
            }

            if (textWidth < truncatedWidth) {
              head = mid + 1;
            } else {
              tail = mid - 1;
            }
          }

          truncatedText = (tail === -1 ? "" : text.slice(0, tail + 1)) + ELLIPSIS$1;
        }
      }

      this._truncatedText[cacheKey] = truncatedText;
    }

    return truncatedText;
  };
  /**
  	 * Wrap the given list of words into multiple lines based on the max width given in the third arg.
  	 * It will take at most nLines and put the remaining in the 'rest' field
  	 * @param {*} listOfWords The list of words that will be wrapped
  	 * @param {*} nLines The max number of lines
  	 * @param {*} width The max width
  	 */


  TextUtils.prototype.wrap = function wrap(listOfWords, nLines, width) {
    var this$1 = this;
    var len = listOfWords.length;

    if (nLines <= 0 || len === 0) {
      return {
        lines: [],
        rest: listOfWords.join(' ')
      };
    }

    var currentText = "";
    var i = 0;

    for (i = 0; i < len; ++i) {
      var testString = currentText + listOfWords[i];

      if (this$1.getTextWidth(testString) > width) {
        currentText = currentText.substring(0, currentText.length - 1);
        break;
      } else {
        currentText = testString + (i === len - 1 ? "" : " ");
      }
    }

    var ref = this.wrap(listOfWords.slice(i), nLines - 1, width);
    var lines = ref.lines;
    var rest = ref.rest;
    return {
      lines: [currentText].concat(lines),
      rest: rest
    };
  };

  var textUtils = singleton(TextUtils); // Base implementation of Deferred
  //
  // a deferred is an object with:
  // - a promise
  // - a function resolve(<val>): function to call to resolve the promise
  // - a functio reject(<val>): function to call to reject the promise
  // Why, oh why isn't this simple class part of the es6 standard
  // is a mistery to me. -Didier 2/14/2015
  //-ignore

  var Deferred = function Deferred() {
    this.resolve = this.resolve.bind(this);
    this.reject = this.reject.bind(this);
    this.promise = new es6Promise.Promise(function (_resolve, _reject) {
      this._resolve = _resolve;
      this._reject = _reject;
    }.bind(this));
  };

  Deferred.prototype.resolve = function resolve() {
    (ref = this)._resolve.apply(ref, arguments);

    return this;
    var ref;
  };

  Deferred.prototype.reject = function reject() {
    (ref = this)._reject.apply(ref, arguments);

    return this;
    var ref;
  };

  var xhr = {
    mockXhrUrl: function mockXhrUrl(url) {
      // if the tests are executing under karma, the base url is always appended by "/base/tests/"
      // make sure we only change those urls that are not already karma url
      if (window.__karma__ && url.indexOf("/base") != 0) {
        url = "/base/tests/" + url;
      }

      return url;
    },
    request: function request(ref) {
      var url = ref.url;
      var action = ref.action;
      var dataType = ref.dataType;
      var data = ref.data;
      var isSync = ref.isSync;

      if (action == null) {
        action = "GET";
      }

      var req = new XMLHttpRequest();
      url = this.mockXhrUrl(url);

      if (isSync) {
        req.open(action, url, false);

        if (dataType) {
          req.responseType = dataType;
        }

        req.send(data);
        return req;
      } else {
        var def = new Deferred();

        req.onload = function () {
          if (this.status < 300) {
            return def.resolve(this.response);
          } else {
            return def.reject(this.statusText);
          }
        };

        req.onerror = function () {
          return def.reject(this.statusText);
        };

        req.open(action, url);

        if (dataType) {
          req.responseType = dataType;
        }

        req.send(data);
        return def.promise;
      }
    }
  }; //
  // ImageCacheEntry
  //
  // A helper class for the ImageCache. It keeps track of the loading lifecycle of an image.
  // It allows registration of delegates (IImageLoaderDelegate) which will be
  // notified when an image is loading/loaded/failed loading.

  var mockXhrUrl = xhr.mockXhrUrl;
  var STATE_LOADING = 0;
  var STATE_LOADED = 1;
  var STATE_ERROR = 2;

  var ImageCacheEntry = function ImageCacheEntry(url) {
    this._url = url;
    this._delegates = [];
    this._state = STATE_LOADING;
    this._img = new Image();
    this._img.onload = this._onLoadImage.bind(this);
    this._img.onerror = this._onErrorImage.bind(this);
    this._img.src = mockXhrUrl(url);

    if (log$1.images) {
      console.log("ImageCache:: willLoadImage", url);
    }
  }; // Add a delegate to the image.
  //
  // If the delegate already exists for this image, return right away.
  // Otherwise, invoke the appropriate delegate method based on the current image lifecycle state


  ImageCacheEntry.prototype.addDelegate = function addDelegate(delegate) {
    switch (this._state) {
      case STATE_LOADING:
        if (this._delegates.indexOf(delegate) >= 0) {
          // delegate already registered
          return;
        }

        this._delegates.push(delegate);

        delegate.willLoadImage(this._url);
        break;

      case STATE_LOADED:
        // note: the array of delegates has been removed so we just need to fire the right event
        delegate.didLoadImage(this._url);
        break;

      case STATE_ERROR:
        // note: the array of delegates has been removed so we just need to fire the right event
        delegate.failedToLoadImage(this._url);
        break;
    }
  };

  ImageCacheEntry.prototype.isLoaded = function isLoaded() {
    return this._state === STATE_LOADED;
  };

  ImageCacheEntry.prototype.getImage = function getImage() {
    return this._img;
  }; //--------------------------------------------------------------------------------
  // helper methods
  //--------------------------------------------------------------------------------
  // error handler for image


  ImageCacheEntry.prototype._onErrorImage = function _onErrorImage() {
    this._state = STATE_ERROR;

    this._notifyDelegates("failedToLoadImage");

    this._cleanup();
  }; // success handler for image


  ImageCacheEntry.prototype._onLoadImage = function _onLoadImage() {
    this._state = STATE_LOADED;

    this._notifyDelegates("didLoadImage");

    this._cleanup();
  }; // invoke the function fctName(url) on each delegate
  // @param fctName {string} one of the methods of IImageLoaderDelegate: willLoadImage, didLoadImage, failedToLoadImage


  ImageCacheEntry.prototype._notifyDelegates = function _notifyDelegates(fctName) {
    var this$1 = this;

    if (log$1.images) {
      console.log("ImageCache::", fctName, this._url, "-> dispatching to", (this._delegates || []).length, "delegates");
    }

    if (this._delegates) {
      this._delegates.forEach(function (delegate) {
        delegate[fctName](this$1._url);
      });
    }
  }; // cleanup (usually after the delegates have been notified)


  ImageCacheEntry.prototype._cleanup = function _cleanup() {
    delete this._delegates;
    delete this._img.onload;
    delete this._img.onerror;
  }; //
  // ImageCache
  //
  // A Singleton which caches images
  // Upon registering an image, it takes a delegate object which will
  // be invoked when the image is loading/loaded/failed loading
  //
  // @see registerImage
  // @see IImageLoaderDelegate
  // default url validator: by default, reject everything (aka: trust is our #1 priority !)


  var defaultUrlValidator = function defaultUrlValidator(x) {
    return null;
  };

  var ImageCache = function ImageCache() {
    this._cache = {};
    this._urlValidator = defaultUrlValidator;
  }; // register an image url validator
  //
  // Register a validator function which allows you to control what image urls are allowed to be loaded by the cache.
  // The validator has a chance to do some url rewriting (if needed) and return the rewritten url.
  //
  // If the url should not be loaded, the function should return null/undefined/empty string.
  // Otherwise, it should return the url to load.
  //
  // @param {function: (url) -> null or filtered url} imageValidor
  // @return {this}


  ImageCache.prototype.setImageValidator = function setImageValidator(urlValidator) {
    this._urlValidator = urlValidator;
    return this;
  }; // validates/rewrites a given url
  //
  // This function is provided as a helper function. It is the responsibility of the code which uses
  // the ImageCache to call this function to validate/rewrite the urls.
  //
  // The reason for this is that the ImageCache is used at the renderer level and we don't want the renderer
  // to have to invoke a JS function for every shape with a texture (the mobile renderer is *NOT* in javascript)
  // The proper url validation will be done when preparing the rendererModel.
  //
  // @param {string} url: the url to be validated
  // @return
  //    - null/undefined/empty string: if the url should not be loaded
  //    - anything else: the rewritten url (if needed). This is the url which needs to be passed to the ImageCache


  ImageCache.prototype.validateUrl = function validateUrl(url) {
    return this._urlValidator(url);
  }; // Register an image with the image cache.
  //
  // This will work properly if multiple delegates wait for the same image (they will
  // properly be all notified) or if the same delegate waits for the same image multiple
  // times (only one notification will be triggered)
  //
  // @params url {String} the url of the image to load
  // @params delegate {IImageLoaderDelegate} a delegate which will be notified during the image loading lifecycle


  ImageCache.prototype.registerImage = function registerImage(url, delegate) {
    var cacheEntry = this._cache[url];

    if (!cacheEntry) {
      cacheEntry = this._cache[url] = new ImageCacheEntry(url);
    }

    if (cacheEntry && delegate) {
      cacheEntry.addDelegate(delegate);
    }
  };

  ImageCache.prototype.isImageLoaded = function isImageLoaded(url) {
    var cacheEntry = this._cache[url];

    if (cacheEntry) {
      return cacheEntry.isLoaded();
    } else {
      return false;
    }
  };

  ImageCache.prototype.getImage = function getImage(url) {
    var cacheEntry = this._cache[url];

    if (cacheEntry) {
      return cacheEntry.getImage();
    } else {
      return null;
    }
  };

  var ImageCache$1 = singleton(ImageCache); //
  //--------------------------------------------------------------------------------
  // An IImageLoaderDelegate bound to an IView
  //
  // It will trigger a view redraw if an image arrives after the view animation is done
  //--------------------------------------------------------------------------------
  // @flow-ignore

  /*::(x: ViewImageLoaderDelegate) => (x: IImageLoaderDelegate)*/

  var ViewImageLoaderDelegate = function ViewImageLoaderDelegate(view) {
    this._view = view; //@flow-ignore

    this._redrawIfNeeded = debounce(ViewImageLoaderDelegate.prototype._redrawIfNeeded, constants$1.ANIM_DURATION.IMAGE_LOADING_REDRAW);
  };

  ViewImageLoaderDelegate.prototype._redrawIfNeeded = function _redrawIfNeeded() {
    // note that since this function is going to be debounced, we need to check again if we are
    // still animating or not
    if (this._view.isRemoved()) {
      return;
    }

    if (!this._view.isAnimating()) {
      this._view.redraw();
    }

    return;
  }; //--------------------------------------------------------------------------------
  // IImageLoaderDelegate
  //--------------------------------------------------------------------------------
  // called when a new image is being loaded


  ViewImageLoaderDelegate.prototype.willLoadImage = function willLoadImage(url) {}; // called when a new image has been loaded


  ViewImageLoaderDelegate.prototype.didLoadImage = function didLoadImage(url) {
    if (this._view.isRemoved()) {
      return;
    } // only redraw if we are not in the middle of animating


    if (!this._view.isAnimating()) {
      this._redrawIfNeeded();
    }
  }; // called when a new image failed being loaded


  ViewImageLoaderDelegate.prototype.failedToLoadImage = function failedToLoadImage(url) {};

  var sum = function sum(arr) {
    return lodash__default.reduce(arr, function (acc, x) {
      return acc + x;
    }, 0);
  }; // sum numbers in an array


  var square = function square(x) {
    return x * x;
  }; // little helper function to compute std dev


  var leftPad = function leftPad(str, len) {
    // string left padding
    while (str.length < len) {
      str = " " + str;
    }

    return str;
  };

  var instance$5 = null;

  var Perf = function Perf(ref) {
    var _name = ref.name;
    this._name = _name;
  };

  Perf.prettyPrint = function prettyPrint(json) {
    console.log(" transaction: " + json.name + " | duration: " + json.duration + " ");

    if (lodash__default.keys(json.marks).length > 0) {
      console.table(json.marks);
    }

    if (lodash__default.keys(json.iterations).length > 0) {
      // let's sort the iterations table and add padding to reflect nesting
      var cleanIters = {};
      var i = 0;
      lodash__default.keys(json.iterations).sort().forEach(function (key) {
        var val = json.iterations[key];
        var parts = key.split(" > ");
        var lastPart = parts.pop();
        var cleanKey = parts.map(function (x) {
          return "\xA0\xA0";
        }).join("") + lastPart;
        cleanIters[leftPad("" + i++, 3) + " " + cleanKey] = val;
      });
      return console.table(cleanIters);
    }
  };

  Perf.prototype.start = function start(_info) {
    this._info = _info;
    /* start transaction */

    this._startTime = Date.now();
    this._endTime = null;
    this._marks = {};
    this._iterations = {}; // a map: iteration name -> array of [start, end, duration] for each instance

    this._nestedIterationMarks = []; // temp internal array to keep track of current iteration nesting

    return this;
  };

  Perf.prototype.getStartTime = function getStartTime() {
    return this._startTime;
  };

  Perf.prototype.end = function end() {
    /* end transaction, do not update end time if already ended */
    if (this._endTime == null) {
      this._endTime = Date.now();
    }

    return this;
  };

  Perf.prototype.getEndTime = function getEndTime() {
    return this._endTime;
  };

  Perf.prototype.mark = function mark(name) {
    /* start timer for mark, do not update start time if already started */
    if (this._marks[name] != null ? this._marks[name].start : undefined) {
      return;
    }

    this._marks[name] = {
      start: Date.now() - this._startTime
    };
    return this;
  };

  Perf.prototype.endMark = function endMark(name) {
    /* end timer for mark, do not update end time if already ended */
    if (!this._marks[name] || this._marks[name].duration != null) {
      return;
    }

    this._marks[name].duration = Date.now() - this._marks[name].start - this._startTime;
    return this;
  };

  Perf.prototype.updateInfo = function updateInfo(newInfo) {
    var this$1 = this;
    var key;

    for (key in newInfo) {
      if (newInfo.hasOwnProperty(key)) {
        this$1._info[key] = newInfo[key];
      }
    }
  };

  Perf.prototype.prettyPrint = function prettyPrint() {
    return Perf.prettyPrint(this.toJson());
  };

  Perf.prototype.toJson = function toJson() {
    var this$1 = this;
    /* export transaction as JSON */

    this.end();
    var iterations = {};

    for (var name in this$1._iterations) {
      var iters = this$1._iterations[name];
      var nbIters = iters.length;

      if (nbIters === 0) {
        continue;
      }

      var durations = lodash__default.map(iters, "duration");
      var totalTime = sum(durations);
      var avgTime = totalTime / nbIters;
      var minTime = lodash__default.min(durations);
      var maxTime = lodash__default.max(durations);
      var stdDev = Math.sqrt(sum(lodash__default.map(durations, function (time) {
        return square(time - avgTime);
      })) / nbIters);
      iterations[name] = {
        total: parseFloat(totalTime.toFixed(2)),
        nb: nbIters,
        avg: parseFloat(avgTime.toFixed(2)),
        stdDev: parseFloat(stdDev.toFixed(2)),
        min: parseFloat(minTime.toFixed(2)),
        max: parseFloat(maxTime.toFixed(2))
      };
    }

    return {
      name: this._name,
      startTime: this._startTime,
      duration: this._endTime - this._startTime,
      marks: JSON.parse(JSON.stringify(this._marks)),
      iterations: iterations,
      info: this._info
    };
  };

  Perf.prototype.merge = function merge(perfJson, prefix) {
    var this$1 = this;

    if (prefix == null) {
      prefix = "";
    }
    /*
    merge another transaction json into current transaction. the merged-in transaction
    will be one mark with transaction name, all its marks will be transferred into current
    marks with transaction name prepended to mark name
    */


    var name = perfJson.name;
    var startTime = perfJson.startTime;
    var duration = perfJson.duration;
    var marks = perfJson.marks;

    if (prefix) {
      name = prefix + '-' + name;
    }

    this._marks[name] = {
      start: startTime - this._startTime,
      duration: duration
    };

    for (var markName in marks) {
      var value = marks[markName];
      this$1._marks[name + '-' + markName] = {
        start: value.start + startTime - this$1._startTime,
        duration: value.duration
      };
    }

    return this;
  };

  Perf.prototype.add = function add(perfJson, prefix) {
    this._endTime = (this._endTime || this._startTime) + perfJson.duration;
    return this.merge(perfJson, prefix);
  }; //--------------------------------------------------------------------------------
  // iteration support
  //--------------------------------------------------------------------------------
  // In order to support nested iterations (iterations within iterations), we are going
  // to capture the full iteration path:
  // - if iteration 'computeWidth' is called from within iteration 'update', it's path will be 'update > computeWidth'
  // - this will allow us to distinguish from when 'computeWidth' is called from within interation 'renderShape'
  // (where the path will be 'renderShape > computeWidth')


  Perf.prototype._iterationPath = function _iterationPath(name) {
    return this._nestedIterationMarks.concat(name).join(" > ");
  }; // capture iteration for the given function
  // each invocation of the function will be timed and stored so we can do math on *all* the invocations at the end


  Perf.prototype.iteration = function iteration(name, fct) {
    var fullName = this._iterationPath(name);

    this._nestedIterationMarks.push(name);

    var start = Date.now() - this._startTime;

    try {
      return fct();
    } finally {
      var end = Date.now() - this._startTime;

      var duration = end - start;

      this._nestedIterationMarks.pop();

      if (this._iterations[fullName] == null) {
        this._iterations[fullName] = [];
      }

      this._iterations[fullName].push({
        start: start,
        end: end,
        duration: duration
      });
    }
  };

  Perf.prototype.resetIterations = function resetIterations() {
    return this._iterations = {};
  };

  Perf.setInstance = function setInstance(perf) {
    return instance$5 = perf;
  };

  Perf.getInstance = function getInstance() {
    return instance$5;
  }; //
  //@flow-ignore


  var shapeCounter = counter$1.init('shape');
  /*::(x: StaticRenderer) => (x: IRenderer)*/

  var StaticRenderer = function StaticRenderer() {};

  StaticRenderer.prototype.render = function render(canvas, sceneModel, options) {
    if (options === void 0) options = {
      duration: 0
    };
    var perf = new Perf({
      name: 'rendering'
    }).start();

    if (sceneModel) {
      canvas.setModel(this._assignPainter(sceneModel, canvas.getTweener()));
    }

    perf.end();
    return this._render(canvas, options).then(function (drawPerf) {
      var removeInvPerf = new Perf({
        name: 'remove-invisible'
      }).start();
      removeInvPerf.end();
      perf.add(removeInvPerf.toJson());

      if (drawPerf) {
        perf.add(drawPerf.toJson());
      }

      return perf;
    });
  };
  /**
  	 * @return true if patch operations for the model are supported
  	 *
  	 * note: this is a temporary function to make sure the
  	 * mobile renderer still works properly until patching
  	 * is properly implemented
  	 */


  StaticRenderer.prototype.isPatchSupported = function isPatchSupported() {
    return true;
  };
  /**
  	 * Render the accessibility data table
  	 * @param canvas
  	 * @param table
  	 */


  StaticRenderer.prototype.renderAccessibilityTable = function renderAccessibilityTable(canvas, table) {};
  /**
  	 * Render the accessibility data items
  	 * @param canvas
  	 */


  StaticRenderer.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems(canvas) {}; //--------------------------------------------
  // protected
  //--------------------------------------------


  StaticRenderer.prototype._createPainter = function _createPainter(type) {
    return null;
  };

  StaticRenderer.prototype._getPainter = function _getPainter(model, context) {
    return model.painter;
  };
  /**
  	 * Based on the type of the model, assign the corresponding painter to the model.
  	 * @param node
  	 * @param tweener
  	 */


  StaticRenderer.prototype._assignPainter = function _assignPainter(node, tweener) {
    var this$1 = this;
    tweener.addTweenProperties(node, node.tweens);
    node.painter = this._createPainter(node.props.type);
    node.uid = shapeCounter.next();
    node.getChildren().forEach(function (child) {
      return this$1._assignPainter(child, tweener);
    });
    return node;
  }; //--------------------------------------------
  // protected (draws)
  //--------------------------------------------

  /**
  	 * The entry for rendering an updated render model on the canvas given
  	 * @param canvas
  	 * @param options
  	 * @returns {Promise.<*>}
  	 * @private
  	 */


  StaticRenderer.prototype._render = function _render(canvas, options) {
    if (options === void 0) options = {};
    return es6Promise.Promise.resolve(this._drawContainer(canvas.getModel(), canvas.getContext()));
  };
  /**
  	 * This is the entry of the draw call for each frame.
  	 * @param ctx
  	 * @param model
  	 * @private
  	 */


  StaticRenderer.prototype._drawContainer = function _drawContainer(model, ctx) {
    var this$1 = this;
    ctx.save();
    ctx.saveGraphicsContext();

    this._applySelfTransform(model, ctx);

    var painter = this._getPainter(model, ctx);

    if (painter) {
      ctx.applyTransform();
      painter.draw(model, ctx.getGraphicsContext(), ctx.getImageLoaderDelegate());
      ctx.restoreTransform();
    }

    this._applyScrolling(model, ctx);

    this._applyChildrenTransform(model, ctx);

    model.getChildren().forEach(function (child) {
      var isContainer = child.getChildren().length > 0;
      return isContainer ? this$1._drawContainer(child, ctx) : this$1._drawElement(child, ctx);
    });
    ctx.restoreGraphicsContext();
    ctx.restore();
  };
  /**
  	 * Draw each node recursively (Happen every frame)
  	 * @param ctx The rendering context
  	 * @param model
  	 */


  StaticRenderer.prototype._drawElement = function _drawElement(model, ctx) {
    ctx.save();

    this._applySelfTransform(model, ctx);

    var painter = this._getPainter(model, ctx);

    if (painter) {
      ctx.saveGraphicsContext();
      ctx.applyTransform();
      painter.draw(model, ctx.getGraphicsContext(), ctx.getImageLoaderDelegate());
      ctx.restoreGraphicsContext();
    }

    ctx.restore();
  };
  /**
  	 * Apply transform of itself (ex. x, y positions) to the current context
  	 * @param model
  	 * @param ctx
  	 * @private
  	 */


  StaticRenderer.prototype._applySelfTransform = function _applySelfTransform(model, ctx) {
    var ref = model.props;
    var x = ref.x;
    var y = ref.y;
    var rotation = ref.rotation;

    if (rotation) {
      var x$1 = rotation.x;
      var y$1 = rotation.y;
      var angle = rotation.angle;
      ctx.translate(x$1, y$1);
      ctx.rotate(angle);
      ctx.translate(-x$1, -y$1);
    }

    if (x || y) {
      ctx.translate(x || 0, y || 0);
    }
  };
  /**
  	 * Apply transform of children (ex. tx, ty) from the model to the current context
  	 * @param ctx
  	 * @param model
  	 * @private
  	 */


  StaticRenderer.prototype._applyChildrenTransform = function _applyChildrenTransform(model, ctx) {
    var ref = model.props;
    var tx = ref.tx;
    var ty = ref.ty;

    if (tx || ty) {
      ctx.translate(tx || 0, ty || 0);
    }
  };
  /**
  	 * Apply scroll offset from the model to the current context
  	 * @param model
  	 * @param ctx
  	 * @private
  	 */


  StaticRenderer.prototype._applyScrolling = function _applyScrolling(model, ctx, reverse) {
    if (reverse === void 0) reverse = false;
    var parent = model.getParent();

    if (parent) {
      if (model.props.canScroll === false) {
        // Note that this property is set on a child contained of a scrolling container
        // (for instance on a layer belonging to a scrolling cell)
        //
        // The cell (the parent) will have already scrolled, so we need to reapply the
        // reverse scroll of the parent nodel.
        //
        // note: using the scrollableParent and testing for null
        // is mostly to keep flow from complaining...
        this._applyScrolling(parent, ctx, true);
      } else {
        var ref = model.props;
        var scrollX = ref.scrollX;
        var scrollY = ref.scrollY;
        var ref$1 = parent.props;
        var scrollOffset = ref$1.scrollOffset;

        if (scrollOffset && (scrollX || scrollY)) {
          var scrollOffsetX = scrollX ? scrollOffset[0] || 0 : 0;
          var scrollOffsetY = scrollY ? scrollOffset[1] || 0 : 0;
          var scrollMultiplier = reverse ? 1 : -1;
          ctx.translate(scrollMultiplier * scrollOffsetX, scrollMultiplier * scrollOffsetY);
        }
      }
    }
  }; //

  /**
   * Created by yi.chen on 8/25/17.
   */


  var DebugRenderer = function (StaticRendere____1) {
    function DebugRenderer() {
      StaticRendere____1.apply(this, arguments);
    }

    if (StaticRendere____1) DebugRenderer.__proto__ = StaticRendere____1;
    DebugRenderer.prototype = Object.create(StaticRendere____1 && StaticRendere____1.prototype);
    DebugRenderer.prototype.constructor = DebugRenderer;

    DebugRenderer.prototype._drawContainer = function _drawContainer(model, ctx) {
      var this$1 = this;
      ctx.save();
      ctx.saveGraphicsContext();

      this._applySelfTransform(model, ctx);

      var painter = model.painter;

      if (painter) {
        ctx.applyTransform();
        painter.draw(model, ctx.getGraphicsContext(), ctx.getImageLoaderDelegate());

        if (ctx.shouldDrawDebugInfo(model)) {
          //@flow-ignore
          painter.drawDebug(model, ctx.getGraphicsContext(), ctx.getImageLoaderDelegate());
        }

        ctx.restoreTransform();
      }

      this._applyScrolling(model, ctx);

      this._applyChildrenTransform(model, ctx);

      model.getChildren().forEach(function (child) {
        var isContainer = child.getChildren().length > 0;
        return isContainer ? this$1._drawContainer(child, ctx) : this$1._drawElement(child, ctx);
      });
      ctx.restoreGraphicsContext();
      ctx.restore();
    };
    /**
     * Draw each node recursively (Happen every frame)
     * @param ctx The rendering context
     * @param model
     */


    DebugRenderer.prototype._drawElement = function _drawElement(model, ctx) {
      StaticRendere____1.prototype._drawElement.call(this, model, ctx);

      if (ctx.shouldDrawDebugInfo(model)) {
        ctx.save();
        var painter = model.painter;

        if (painter) {
          ctx.saveGraphicsContext();
          ctx.applyTransform(); //@flow-ignore

          painter.drawDebug(model, ctx.getGraphicsContext(), ctx.getImageLoaderDelegate());
          ctx.restoreGraphicsContext();
        }

        ctx.restore();
      }
    };

    return DebugRenderer;
  }(StaticRenderer); //


  var ref$2 = constants$1.COLOR_TYPE;
  var SIMPLE_COLOR = ref$2.SIMPLE_COLOR;
  var LINEAR_GRADIENT = ref$2.LINEAR_GRADIENT;
  var ref$1$1 = constants$1.TEXTURE.FIT;
  var COVER = ref$1$1.COVER;
  var CONTAIN = ref$1$1.CONTAIN;
  var FILL = ref$1$1.FILL;
  /*::(x: Shape<*>) => (x: IPainter)*/

  var Shape$2 = function Shape() {};

  Shape$2.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
    this._setStyle(model, ctx);

    this._drawBackground(model, ctx);
  }; //--------------------------------------------
  // protected
  //--------------------------------------------


  Shape$2.prototype._drawBackground = function _drawBackground(model, ctx) {
    var ref = model.props;
    var x = ref.x;
    var y = ref.y;
    var bg = ref.bg;

    if (bg) {
      ctx.save();
      ctx.translate(-x, -y);
      var color = bg.color;
      var box = bg.box;
      ctx.fillStyle = color.toString();
      ctx.fillRect(box[0], box[1], box[2], box[3]);
      ctx.restore();
    }
  }; // draw an image into a specifc box [x, y, w, h] by respecting the fit mode


  Shape$2.prototype._drawTexture = function _drawTexture(img, fit, shade, box, ctx) {
    var x = box[0];
    var y = box[1];
    var w = box[2];
    var h = box[3]; // figure out proper ratio

    var imgWidth = img.width;
    var imgHeight = img.height;
    var imgRatio = imgWidth / imgHeight;
    var rectRatio = Math.abs(w / h);
    var scaleRatio;

    switch (fit) {
      case COVER:
        // image covers the entire box. This might result in the image being cropped
        if (imgRatio > rectRatio) {
          // the height will stretch all the way... width will be cut
          // we want: h = ratio * imgHeight
          scaleRatio = h / imgHeight;
          ctx.drawImage(img, x + (w - imgWidth * scaleRatio) / 2, y, imgWidth * scaleRatio, h);
        } else {
          // the width will stretch all the way... height will be cut
          // we want: w = ratio * imgWidth
          scaleRatio = w / imgWidth;
          ctx.drawImage(img, x, y + (h - imgHeight * scaleRatio) / 2, w, imgHeight * scaleRatio);
        }

        break;

      case CONTAIN:
        // image will be fully contained in box. This might result in empty space around the image
        if (imgRatio < rectRatio) {
          // the height will stretch all the way... width will be cut
          // we want: h = ratio * imgHeight
          scaleRatio = h / imgHeight;
          ctx.drawImage(img, x + (w - imgWidth * scaleRatio) / 2, y, imgWidth * scaleRatio, h);
        } else {
          // the width will stretch all the way... height will be cut
          // we want: w = ratio * imgWidth
          scaleRatio = w / imgWidth;
          ctx.drawImage(img, x, y + (h - imgHeight * scaleRatio) / 2, w, imgHeight * scaleRatio);
        }

        break;

      case FILL:
      default:
        // image will be stretched to fill the box
        ctx.drawImage(img, x, y, w, h);
        break;
    } // apply shade if needed


    if (shade != null && shade !== 1) {
      ctx.fillStyle = "rgba(0, 0, 0, " + shade + ")";
      ctx.fillRect.apply(ctx, box);
    }
  };

  Shape$2.prototype._getColorRegion = function _getColorRegion(model) {
    var ref = model.props.bb;
    var x = ref[0];
    var y = ref[1];
    var w = ref[2];
    var h = ref[3];
    return model.props.boundingBox ? {
      x0: x,
      y0: y,
      x1: x + w,
      y1: y + h
    } : {
      x0: 0,
      y0: 0,
      x1: 0,
      y1: 0
    };
  };

  Shape$2.prototype._setStyle = function _setStyle(model, ctx) {
    var ref = model.props;
    var opacity = ref.opacity;
    var lineWidth = ref.lineWidth;
    var stroke = ref.stroke;
    var fill = ref.fill;
    ctx.globalAlpha = opacity < 0 ? 0 : opacity;

    if (lineWidth != null) {
      ctx.lineWidth = lineWidth;
    }

    if (stroke) {
      ctx.strokeStyle = this._processColor(model, ctx, stroke);
    }

    if (fill) {
      ctx.fillStyle = this._processColor(model, ctx, fill);
    }
  };

  Shape$2.prototype._processColor = function _processColor(model, ctx, color) {
    var res = "";

    switch (color.getType()) {
      case SIMPLE_COLOR:
        res = color.toRGBAString();
        break;

      case LINEAR_GRADIENT:
        var ref = this._getColorRegion(model);

        var x0 = ref.x0;
        var y0 = ref.y0;
        var x1 = ref.x1;
        var y1 = ref.y1;
        var grad = ctx.createLinearGradient(x0, y0, x1, y1);
        color.getColorStops().forEach(function (colorStop) {
          grad.addColorStop(colorStop[1], colorStop[0].toRGBAString());
        });
        res = grad;
        break;
    }

    return res;
  }; //

  /**
   * Created by yi.chen on 4/28/17.
   */

  /*::(x: Path) => (x: IPainter)*/


  var Path = function (Shape) {
    function Path() {
      Shape.apply(this, arguments);
    }

    if (Shape) Path.__proto__ = Shape;
    Path.prototype = Object.create(Shape && Shape.prototype);
    Path.prototype.constructor = Path;

    Path.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);
      var ref = model.props;
      var closePath = ref.closePath;
      var fill = ref.fill;
      var stroke = ref.stroke;
      var dashed = ref.dashed;
      var lineWidth = ref.lineWidth;
      var baseX = ref.baseX;
      var baseY = ref.baseY;
      var lineJoin = ref.lineJoin;

      var ref$1 = this._getPoints(model.props);

      var pointsX = ref$1[0];
      var pointsY = ref$1[1];

      if (pointsX && pointsY) {
        var offset = lineWidth == null ? 1 : lineWidth % 2 / 2;
        ctx.translate(offset, offset);
        ctx.lineJoin = lineJoin;

        if (fill) {
          this._drawPath(ctx, pointsX, pointsY, baseX, baseY, true);

          ctx.fill();
        }

        if (stroke && lineWidth && lineWidth > 0) {
          this._drawPath(ctx, pointsX, pointsY, null, null, closePath);

          if (dashed && ctx.setLineDash) {
            ctx.lineCap = "round";
            ctx.setLineDash([1, dashed]);
          }

          ctx.stroke();
        }
      }
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    Path.prototype._getPoints = function _getPoints(props) {
      return [props.points_x, props.points_y];
    };

    Path.prototype._drawPath = function _drawPath(ctx, points_x, points_y, baseX, baseY, closePath) {
      if (closePath === void 0) closePath = false;
      ctx.beginPath();

      if (baseX != null) {
        ctx.moveTo(baseX, points_y[0]);
        ctx.lineTo(points_x[0], points_y[0]);
      } else if (baseY != null) {
        ctx.moveTo(points_x[0], baseY);
        ctx.lineTo(points_x[0], points_y[0]);
      } else {
        ctx.moveTo(points_x[0], points_y[0]);
      }

      for (var i = 1; i < points_x.length; ++i) {
        ctx.lineTo(points_x[i], points_y[i]);
      }

      if (baseX != null) {
        ctx.lineTo(baseX, points_y[points_y.length - 1]);
      } else if (baseY != null) {
        ctx.lineTo(points_x[points_x.length - 1], baseY);
      }

      if (closePath) {
        ctx.closePath();
      }
    };

    return Path;
  }(Shape$2);

  var Path$1 = singleton(Path); //

  /**
   * Created by yi.chen on 4/28/17.
   */

  /*::(x: AnimatePath) => (x: IPainter)*/

  var AnimatePath = function (Path) {
    function AnimatePath() {
      Path.apply(this, arguments);
    }

    if (Path) AnimatePath.__proto__ = Path;
    AnimatePath.prototype = Object.create(Path && Path.prototype);
    AnimatePath.prototype.constructor = AnimatePath;

    AnimatePath.prototype._getPoints = function _getPoints(props) {
      return [props.animate_points_x, props.animate_points_y];
    };

    return AnimatePath;
  }(Path$1);

  var AnimatePath$1 = singleton(AnimatePath); //
  //@flow-ignore

  /*::(x: AnimationRenderer) => (x: IRenderer)*/

  var AnimationRenderer = function (DebugRendere____1) {
    function AnimationRenderer() {
      DebugRendere____1.apply(this, arguments);
    }

    if (DebugRendere____1) AnimationRenderer.__proto__ = DebugRendere____1;
    AnimationRenderer.prototype = Object.create(DebugRendere____1 && DebugRendere____1.prototype);
    AnimationRenderer.prototype.constructor = AnimationRenderer;

    AnimationRenderer.getInstance = function getInstance() {
      if (!this.instance) {
        this.instance = new this();
      }

      return this.instance;
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    AnimationRenderer.prototype._render = function _render(canvas, options) {
      var this$1 = this;
      if (options === void 0) options = {};
      var perf = new Perf({
        name: 'visibility-test'
      }).start();
      var sceneModel = canvas.getModel();
      var context = canvas.getContext();
      var tweener = canvas.getTweener();
      var needsScrolling = sceneModel && sceneModel.tweens && sceneModel.tweens.scrollOffset;

      var tweenFct = function tweenFct(ratio) {
        context.setInterpolationRatio(ratio);

        this$1._drawContainer(sceneModel, context);
      };

      perf.end();
      return new es6Promise.Promise(function (resolve, reject) {
        tweener.runTween(options, tweenFct, function (tweenerPerf) {
          if (tweenerPerf) {
            perf.add(tweenerPerf.toJson());
          }

          resolve(perf);
        });
      });
    };

    AnimationRenderer.prototype._getPainter = function _getPainter(model, context) {
      return model.hasAnimatePathInfo() ? context.isAnimating() ? AnimatePath$1.getInstance() : model.painter : model.painter;
    };

    return AnimationRenderer;
  }(DebugRenderer);

  AnimationRenderer.instance = null; //
  //@flow-ignore

  var htmlUtils = {
    /**
    * escape html in text so it can be displayed safely
    * @param {string} text
    * @param {Boolean} replaceSpaces whether to replace spaces with non-breaking spaces
    * - "abc  def" -> "abc&nbsp;&nbsp;def"
    * - "abc<b>def" ->  "abc&lt;b&gt;def"
    */
    escapeHtml: function escapeHtml(text, replaceSpaces) {
      if (replaceSpaces === void 0) replaceSpaces = false;
      var etext = lodash__default.escape(text);
      return replaceSpaces ? etext.replace(new RegExp(' ', 'g'), '&nbsp;') : etext;
    }
  };
  var escapeHtml = htmlUtils.escapeHtml; //

  /**
   * Created by yi.chen on 10/4/16.
   */
  //@flow-ignore

  var ACCESSIBILITY = constants$1.ACCESSIBILITY;
  /**
   * CaptionRenderer renders captions of each node with the data table.
   */

  var AccessibilityRenderer = function (AnimationRendere____1) {
    function AccessibilityRenderer() {
      AnimationRendere____1.apply(this, arguments);
    }

    if (AnimationRendere____1) AccessibilityRenderer.__proto__ = AnimationRendere____1;
    AccessibilityRenderer.prototype = Object.create(AnimationRendere____1 && AnimationRendere____1.prototype);
    AccessibilityRenderer.prototype.constructor = AccessibilityRenderer;

    AccessibilityRenderer.prototype.render = function render(canvas, sceneModel, options) {
      if (options === void 0) options = {
        duration: 0
      };
      var perf = new Perf({
        name: 'accessibility'
      }).start();
      this.renderTooltip(sceneModel, canvas, canvas.getContext(), []);
      perf.end();
      return AnimationRendere____1.prototype.render.call(this, canvas, sceneModel, options).then(function (mainPerf) {
        return mainPerf.add(perf.toJson());
      });
    };
    /**
     * Render a table representing the data set of the chart
     # This table will be an invisible table behind the chart mainly for accessibility purposes
     # Override this method with a dummy function (return void) if no accessibility is needed
     * @param canvas a canvas
     * @param table
     */


    AccessibilityRenderer.prototype.renderAccessibilityTable = function renderAccessibilityTable(canvas, table) {
      canvas.updateAccessibilityTable(this._renderCaption(canvas) + this._renderTableMarkup(table));
    };
    /**
     * Render the accessibility items that can be tabbed on
     */


    AccessibilityRenderer.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems(canvas) {
      canvas.setDataItems(this.collectDataItems(canvas));
    };
    /**
     * Render all the data points that has annotated with accessibility type as data, and then pass the result to canvas
     * @param canvas
     * @returns {Array.<DataItem>}
     */


    AccessibilityRenderer.prototype.collectDataItems = function collectDataItems(canvas) {
      return this._collectDataItems(canvas.getModel(), [], false, false, {});
    };
    /**
     * Render the tooltip by the bounding box of a shape annotated as showTooltip.
     * The tooltip will be only presented on the last item with the annotation.
     * @param model
     * @param canvas
     * @param ctx
     * @param keyPath
     */


    AccessibilityRenderer.prototype.renderTooltip = function renderTooltip(model, canvas, ctx, keyPath) {
      var this$1 = this;
      ctx.save();

      this._applyScrolling(model, ctx);

      this._applyChildrenTransform(model, ctx);

      model.getChildren().forEach(function (child) {
        keyPath.push(child.groupKey || child.key);
        var ref = child.props;
        var accessibility = ref.accessibility;
        var bb = ref.bb;
        var bb0 = ref.bb0;

        if (accessibility && accessibility.showTooltip) {
          var ref$1 = ctx.applyTransformTo(bb || bb0);
          var x = ref$1[0];
          var y = ref$1[1];
          var w = ref$1[2];
          var h = ref$1[3];
          canvas.showTooltipAtWithKey(x + (w >> 1), y + (h >> 1), keyPath);
        }

        this$1.renderTooltip(child, canvas, ctx, keyPath);
        keyPath.pop(model.key);
      });
      ctx.restore();
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    AccessibilityRenderer.prototype._renderTableMarkup = function _renderTableMarkup(table) {
      var titleCellTmpl = function titleCellTmpl(value) {
        return "" + value.tagStart + escapeHtml(value.label) + value.tagEnd;
      };

      var dimensionCellTmpl = function dimensionCellTmpl(value) {
        return "<th scope='row'>" + escapeHtml(value.label) + "</th>";
      };

      var measureCellTmpl = function measureCellTmpl(value) {
        return "<td>" + escapeHtml(value.label) + "</td>";
      };

      var title = table.titleRow.length ? "<tr>" + table.titleRow.map(titleCellToMarkup).join("") + "</tr>" : "";
      var data = table.dataRows.map(function (row) {
        return "<tr>" + formatDataRow(row) + "</tr>";
      }).join("");
      return title + data;

      function formatDataRow(row) {
        return row.map(function (cell, i) {
          var tmpl = table.titleRow[i].type === ACCESSIBILITY.CELL_TYPE.DIMENSION ? dimensionCellTmpl : measureCellTmpl;
          return tmpl({
            label: cell
          });
        }).join("");
      }

      function titleCellToMarkup(cell) {
        return titleCellTmpl({
          tagStart: cell.label === "" ? "<td>" : "<th scope='col'>",
          tagEnd: cell.label === "" ? "</td> " : "</th>",
          label: cell.label
        });
      }
    };

    AccessibilityRenderer.prototype._renderCaption = function _renderCaption(canvas) {
      return this._renderCaptionMarkup(this._collectCaption(canvas.getModel()));
    };

    AccessibilityRenderer.prototype._collectCaption = function _collectCaption(node) {
      var this$1 = this;

      if (node) {
        var childrenCaptions = lodash.flatten(node.getChildren().map(function (c) {
          return this$1._collectCaption(c);
        }));
        var ref = node.props;
        var accessibility = ref.accessibility;

        if (accessibility && accessibility.type === ACCESSIBILITY.TYPE.CAPTION) {
          var key = accessibility.key;
          var value = accessibility.value;
          return [{
            key: key,
            value: value
          }].concat(childrenCaptions);
        } else {
          return lodash.flatten(childrenCaptions);
        }
      } else {
        return [];
      }
    };

    AccessibilityRenderer.prototype._renderCaptionMarkup = function _renderCaptionMarkup(captions) {
      return captions.length ? "<caption>" + captions.map(function (c) {
        return escapeHtml(c.key) + ":" + escapeHtml(c.value);
      }).join(",") + "</caption>" : "";
    };
    /**
     * Recursively traverse the tree and find the nodes that has annotated with accessibility type data
     * @param node
     * @param keyPath An array of keys that from parent to child
     * @param scrollX If the scene can scroll horizontally
     * @param scrollY If the scene can scroll vertically
     * @param visitedGroup If the shape is belong to a shape group, this set indicates which groups are collected
     * @returns {*}
     * @private
     */


    AccessibilityRenderer.prototype._collectDataItems = function _collectDataItems(node, keyPath, scrollX, scrollY, visitedGroup) {
      var this$1 = this;
      var cnode = node;

      if (!cnode || cnode.groupKey && visitedGroup[cnode.groupKey] != null) {
        return [];
      }

      var groupKey = cnode.groupKey;
      var ref = cnode.props;
      var accessibility = ref.accessibility;
      var opacity = ref.opacity;

      if (groupKey) {
        visitedGroup[groupKey] = groupKey;
      }

      keyPath.push(groupKey || cnode.key);
      var tail = lodash.flatten(cnode.getChildren().map(function (child) {
        return this$1._collectDataItems(child, keyPath, cnode.props.scrollX || scrollX, cnode.props.scrollY || scrollY, visitedGroup);
      }));

      if (accessibility && accessibility.type === ACCESSIBILITY.TYPE.DATA && (opacity == null || opacity > 0)) {
        tail = [{
          keyPath: keyPath.slice(1)
        }].concat(tail);
      }

      keyPath.pop();
      return tail;
    };

    return AccessibilityRenderer;
  }(AnimationRenderer);
  /**
   * Created by yi.chen on 8/24/17.
   */
  //


  var DEBUG_RECT_COLOR = 'green';

  function createDebugShape(ShapeClass) {
    return singleton(function (ShapeClass) {
      function DebugShape() {
        ShapeClass.apply(this, arguments);
      }

      if (ShapeClass) DebugShape.__proto__ = ShapeClass;
      DebugShape.prototype = Object.create(ShapeClass && ShapeClass.prototype);
      DebugShape.prototype.constructor = DebugShape;

      DebugShape.prototype.drawDebug = function drawDebug(model, ctx, imageLoaderDelegate) {
        var ref = model.props;
        var key = ref.key;
        var bb = ref.bb;

        if (bb) {
          var bx = bb[0];
          var by = bb[1];
          var w = bb[2];
          var h = bb[3];
          ctx.font = '10px Salesforce Sans';
          ctx.strokeStyle = DEBUG_RECT_COLOR;
          ctx.strokeRect(bx, by, w, h);
          ctx.textBaseline = 'top';
          ctx.strokeText(key, bx, by);
        }
      };

      return DebugShape;
    }(ShapeClass));
  } //

  /*--------------------------------------------------------------------------------
   *
   * Scene
   *
   * A simple container for layer objects.
   * Each layer contains shapes to be drawn.
   * A layer provides a clean way to control the
   * order in which the shapes are drawn.
   *
   * For instance, you could have a layer for the labels
   * and one for the rectangles so that the labels are always drawn
   * above the rectangles.
   *
   *--------------------------------------------------------------------------------*/

  /*::(x: DebugScene) => (x: IPainter)*/


  var DebugScene = function DebugScene() {};

  DebugScene.prototype.draw = function draw(node, ctx) {
    var ref = node.props;
    var w = ref.w;
    var h = ref.h;
    var background = ref.background;
    ctx.clearRect(0, 0, w, h);

    if (background) {
      ctx.fillStyle = background.toString();
      ctx.fillRect(0, 0, w, h);
    }
  };

  DebugScene.prototype.drawDebug = function drawDebug(model, ctx, imageLoaderDelegate) {};

  var Scene = singleton(DebugScene); //

  var DEBUG_RECT_COLOR$1 = 'red';
  /*::(x: DebugCell) => (x: IDebugPainter)*/

  var DebugCell = function DebugCell() {};

  DebugCell.prototype.draw = function draw(model, ctx) {
    if (model.props.viewport) {
      var ref = model.props.viewport;
      var x = ref[0];
      var y = ref[1];
      var w = ref[2];
      var h = ref[3];
      ctx.beginPath();
      ctx.rect(x, y, w, h);
      ctx.clip();
    }
  };

  DebugCell.prototype.drawDebug = function drawDebug(model, ctx, imageLoaderDelegate) {
    ctx.save();
    var ref = model.props;
    var key = ref.key;
    var tx = ref.tx;
    var ty = ref.ty;
    var w = ref.w;
    var h = ref.h;
    var type = ref.type;

    if (type === 'Cell') {
      ctx.font = '10px Salesforce Sans';
      ctx.strokeStyle = DEBUG_RECT_COLOR$1;
      ctx.strokeRect(tx, ty, w, h);
      ctx.textBaseline = 'top';
      ctx.strokeText(key, tx, ty);
    }

    ctx.restore();
  };

  var Cell = singleton(DebugCell); //

  var FONT$1 = commonConstants.FONT;
  var TWO_PI = Math.PI * 2;
  var MIN_LENGTH = 1;
  var TEXT_PADDING_RATIO = 0.1;
  /*::(x: Arc) => (x: IPainter)*/

  var Arc = function (Shape) {
    function Arc() {
      Shape.apply(this, arguments);
    }

    if (Shape) Arc.__proto__ = Shape;
    Arc.prototype = Object.create(Shape && Shape.prototype);
    Arc.prototype.constructor = Arc;

    Arc.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);
      var ref = model.props;
      var angle = ref.angle;
      var startAngle = ref.startAngle;
      var roundedCornerStart = ref.roundedCornerStart;
      var roundedCornerEnd = ref.roundedCornerEnd;
      var r1 = ref.r1;
      var r2 = ref.r2;
      var fill = ref.fill;
      var stroke = ref.stroke;
      var lineWidth = ref.lineWidth;
      var text = ref.text;
      var subText = ref.subText;
      var textColor = ref.textColor;
      var safeAngle = angle === 0 ? 0 : Math.abs(angle * (r2 || r1)) < MIN_LENGTH ? (angle < 0 ? -1 : 1) * MIN_LENGTH / (r2 || r1) : angle;

      if (angle && (!roundedCornerStart || this.roundedCornerEnd) || r1 > 0) {
        ctx.rotate(startAngle); // if value negative, draw pie slice CCW, which is outer arc r1 CCW, inner arc r2 CW

        var drawCCW = safeAngle < 0;
        ctx.beginPath();

        if (r2 > 0) {
          var roundedCornerRadius = (r1 + r2) * 0.5;
          ctx.moveTo(r2, 0);

          if (roundedCornerStart) {
            ctx.arc(roundedCornerRadius, 0, (r1 - r2) / 2, Math.PI, 0, drawCCW);
          }

          ctx.arc(0, 0, r1, 0, safeAngle, drawCCW);

          if (roundedCornerEnd) {
            var x = roundedCornerRadius * Math.cos(safeAngle);
            var y = roundedCornerRadius * Math.sin(safeAngle);
            ctx.arc(x, y, (r1 - r2) / 2, safeAngle, Math.PI + safeAngle, drawCCW);
          }

          ctx.arc(0, 0, r2, safeAngle, 0, !drawCCW);
        } else {
          ctx.moveTo(0, 0);

          if (roundedCornerStart) {
            ctx.arc(r1 / 2, 0, r1 / 2, Math.PI, 0, drawCCW);
          }

          ctx.arc(0, 0, r1, 0, safeAngle, drawCCW);

          if (roundedCornerEnd) {
            var x$1 = r1 / 2 * Math.cos(safeAngle);
            var y$1 = r1 / 2 * Math.sin(safeAngle);
            ctx.arc(x$1, y$1, r1 / 2, safeAngle, Math.PI + safeAngle, drawCCW);
          }
        }

        ctx.closePath();

        if (fill) {
          ctx.fill();
        }

        if (stroke && lineWidth && lineWidth > 0) {
          // if angle is 2 * PI, let's just stroke the outer and innner borders
          if (safeAngle === TWO_PI || safeAngle === -TWO_PI) {
            ctx.beginPath();
            ctx.arc(0, 0, r1, 0, safeAngle);
            ctx.stroke();

            if (r2 > 0) {
              ctx.beginPath();
              ctx.arc(0, 0, r2, safeAngle, 0);
              ctx.stroke();
            }
          } else {
            ctx.stroke();
          }
        }
      } // draw text and subText


      if (textColor && text) {
        var ref$1 = model.props;
        var textR = ref$1.textR;
        var fontSize = ref$1.fontSize;
        var subTextFontSize = ref$1.subTextFontSize;
        var textX = textR * Math.cos(safeAngle / 2);
        var textY = textR * Math.sin(safeAngle / 2);
        ctx.translate(textX, textY);

        if (startAngle) {
          ctx.rotate(-startAngle);
        }

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = textColor.toRGBAString(); // font for the main text

        fontSize = fontSize || FONT$1.SIZE;
        ctx.font = utils$3.getFont(fontSize);

        if (subText) {
          // Main text
          ctx.fillText(text, 0, -fontSize / 2 - fontSize * TEXT_PADDING_RATIO); // subText

          subTextFontSize = subTextFontSize || FONT$1.SIZE;
          ctx.font = utils$3.getFont(subTextFontSize);
          ctx.fillText(subText, 0, subTextFontSize / 2 + subTextFontSize * TEXT_PADDING_RATIO);
        } else {
          ctx.fillText(text, 0, 0);
        }
      }
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    Arc.prototype._getColorRegion = function _getColorRegion(model) {
      var ref = model.props;
      var r1 = ref.r1;
      return {
        x0: r1,
        y0: 0,
        x1: -r1,
        y1: r1
      };
    };

    return Arc;
  }(Shape$2);

  var Arc$1 = singleton(Arc);
  var canvasUtils = {
    drawCurve: function drawCurve(ref) {
      var ctx = ref.ctx;
      var curve = ref.curve;
      var lineWidth = ref.lineWidth;
      var type = curve.type;
      var cp0 = curve.cp0;
      var cp1 = curve.cp1;
      var cp2 = curve.cp2;
      var cp3 = curve.cp3;
      ctx.beginPath();
      ctx.lineWidth = lineWidth;
      ctx.moveTo(cp0[0], cp0[1]);

      if (type == "bezier") {
        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], cp3[0], cp3[1]);
      } else if (curve.type == "quadratic") {
        ctx.quadraticCurveTo(cp1[0], cp1[1], cp2[0], cp2[1]);
      }
    }
  }; //

  /*--------------------------------------------------------------------------------
  *
  * Line
  *
  * params:
  * - dx: diff x
  * - dy: diff y
  * - h: when filling, height of the fill area
  *
  *                     dx
  * (x,y)    h         <-->
  *  x----------------x     /\
  *  |                 \    |
  *  |                  \   | dy
  *  |                   \  |
  *  x--------------------- \/
  *
  *--------------------------------------------------------------------------------*/

  /*::(x: Line) => (x: IPainter)*/

  var Line = function (Shape) {
    function Line() {
      Shape.apply(this, arguments);
    }

    if (Shape) Line.__proto__ = Shape;
    Line.prototype = Object.create(Shape && Shape.prototype);
    Line.prototype.constructor = Line;

    Line.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);
      var ref = model.props;
      var lineWidth = ref.lineWidth;
      var fill = ref.fill;
      var stroke = ref.stroke;
      var dx = ref.dx;
      var dy = ref.dy;
      var h = ref.h;
      var dashed = ref.dashed;
      var curve = ref.curve;
      var offset = lineWidth == null ? 1 : lineWidth % 2 / 2;
      ctx.translate(offset, offset);

      if (fill) {
        ctx.beginPath();
        ctx.moveTo(h, 0);
        ctx.lineTo(dx + h, dy);
        ctx.lineTo(0, dy);
        ctx.lineTo(0, 0);
        ctx.fill();
      }

      if (stroke && lineWidth && lineWidth > 0) {
        if (dashed && ctx.setLineDash) {
          ctx.lineCap = "round";
          ctx.setLineDash([1, dashed]);
        }

        if (!curve) {
          ctx.beginPath();
          ctx.lineWidth = lineWidth;
          ctx.moveTo(h, 0);
          ctx.lineTo(dx + h, dy);
        } else {
          // FIX ME
          // When lineWidth is 1, we set the offset to 1 at the top of this method when it really
          // should be 0. This messes up the drawing of curves, so I'm reverting the offset here ...
          if (lineWidth == 1) {
            ctx.translate(-offset, -offset);
          }

          canvasUtils.drawCurve({
            ctx: ctx,
            curve: curve,
            lineWidth: lineWidth
          });
        }

        ctx.stroke();
      }
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    Line.prototype._getColorRegion = function _getColorRegion(model) {
      var ref = model.props;
      var h = ref.h;
      var dx = ref.dx;
      var dy = ref.dy;
      return h != null && dx != null && dy != null ? {
        x0: 0,
        y0: 0,
        x1: h + dx,
        y1: dy
      } : {
        x0: 0,
        y0: 0,
        x1: 0,
        y1: 0
      };
    };

    return Line;
  }(Shape$2);

  var Line$1 = singleton(Line); //

  var FONT$2 = commonConstants.FONT;
  var imageCache$1 = ImageCache$1.getInstance();
  /*::(x: Rect) => (x: IPainter)*/

  var Rect = function (Shape) {
    function Rect() {
      Shape.apply(this, arguments);
    }

    if (Shape) Rect.__proto__ = Shape;
    Rect.prototype = Object.create(Shape && Shape.prototype);
    Rect.prototype.constructor = Rect;

    Rect.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);
      var ref = model.props;
      var w = ref.w;
      var h = ref.h;
      var cornerRadius = ref.cornerRadius;
      var fill = ref.fill;
      var stroke = ref.stroke;
      var lineWidth = ref.lineWidth;
      var dashed = ref.dashed;
      var texture = ref.texture; // draw rounded corner rectangle

      if (cornerRadius) {
        var radius = cornerRadius;
        var wr = w > 0 ? radius : -radius;
        var hr = h > 0 ? radius : -radius;
        ctx.beginPath();
        ctx.moveTo(wr, 0);
        ctx.lineTo(w - wr, 0);
        ctx.quadraticCurveTo(w, 0, w, hr);
        ctx.lineTo(w, h - hr);
        ctx.quadraticCurveTo(w, h, w - wr, h);
        ctx.lineTo(wr, h);
        ctx.quadraticCurveTo(0, h, 0, h - hr);
        ctx.lineTo(0, hr);
        ctx.quadraticCurveTo(0, 0, wr, 0);
      }

      if (fill) {
        if (cornerRadius) {
          ctx.fill();
        } else {
          ctx.fillRect(0, 0, w, h);
        }
      }

      if (texture) {
        var url = texture.url;
        var fit = texture.fit;
        var shade = texture.shade;

        if (imageCache$1.isImageLoaded(url)) {
          var img = imageCache$1.getImage(url);
          ctx.save();

          if (!cornerRadius) {
            ctx.beginPath();
            ctx.rect(0, 0, w, h);
          }

          ctx.clip();

          Shape.prototype._drawTexture.call(this, img, fit, shade, [0, 0, w, h], ctx);

          ctx.restore();
        } else {
          imageCache$1.registerImage(url, imageLoaderDelegate);
        }
      }

      if (stroke && lineWidth && lineWidth > 0) {
        if (dashed && ctx.setLineDash) {
          ctx.lineCap = "round";
          ctx.setLineDash([5, dashed]);
        }

        if (cornerRadius) {
          ctx.stroke();
        } else {
          var offset = lineWidth % 2 / 2;
          ctx.strokeRect(offset, offset, w, h);
        }
      }

      this._drawText(model, ctx);
    }; //--------------------------------------------
    // protected
    //--------------------------------------------

    /**
     * Draw the text which is associated with this rectangle
     * TODO: We should move text to be a child of the rectangle
     * @param model
     * @param ctx
     */


    Rect.prototype._drawText = function _drawText(model, ctx) {
      var ref = model.props;
      var textX = ref.textX;
      var textY = ref.textY;
      var textColor = ref.textColor;
      var text = ref.text;
      var textRotation = ref.textRotation;
      var fontSize = ref.fontSize;

      if (textColor && text && textX != null && textY != null) {
        ctx.font = utils$3.getFont(fontSize ? fontSize : FONT$2.SIZE);
        ctx.fillStyle = textColor.toRGBAString();
        ctx.translate(textX, textY);

        if (textRotation) {
          ctx.rotate(textRotation);
        }

        ctx.fillText(text, 0, 0);
      }
    };

    Rect.prototype._getColorRegion = function _getColorRegion(model) {
      var w = model.props.w;
      return w < 0 ? {
        x0: -w,
        y0: 0,
        x1: 0,
        y1: 0
      } : {
        x0: 0,
        y0: 0,
        x1: w,
        y1: 0
      };
    };

    return Rect;
  }(Shape$2);

  var Rect$1 = singleton(Rect); //

  var FONT$3 = commonConstants.FONT;
  /*::(x: Text) => (x: IPainter)*/

  var Text$3 = function (Shape) {
    function Text() {
      Shape.apply(this, arguments);
    }

    if (Shape) Text.__proto__ = Shape;
    Text.prototype = Object.create(Shape && Shape.prototype);
    Text.prototype.constructor = Text;

    Text.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);

      this._setupCache(model);

      var rendererCache = model.rendererCache;
      var ref = model.props;
      var maxWidth = ref.maxWidth;
      var fontSize = ref.fontSize;
      var text = ref.text;
      var halign = ref.halign;
      ctx.font = textUtils.getInstance().getFont(fontSize ? fontSize : FONT$3.SIZE);

      if (maxWidth != null) {
        var truncatedText = rendererCache.truncatedText;
        var truncatedMaxWidth = rendererCache.truncatedMaxWidth;
        var truncatedFontSize = rendererCache.truncatedFontSize;
        var truncatedAlign = rendererCache.truncatedAlign;

        if (rendererCache && (truncatedText == null || truncatedMaxWidth !== maxWidth || truncatedFontSize !== fontSize || truncatedAlign !== halign)) {
          rendererCache.truncatedText = this._truncate(text, fontSize || FONT$3.SIZE, maxWidth, halign);
          rendererCache.truncatedMaxWidth = maxWidth;
          rendererCache.truncatedFontSize = fontSize;
          rendererCache.truncatedAlign = halign;
        }

        if (rendererCache && rendererCache.truncatedText) {
          var ref$1 = rendererCache.truncatedText;
          var text$1 = ref$1.text;
          var offset = ref$1.offset;
          ctx.fillText(text$1, offset, 0);
        }
      } else {
        var truncatedText$1 = rendererCache.truncatedText;

        if (truncatedText$1) {
          ctx.fillText(truncatedText$1.text, truncatedText$1.offset, 0);
        } else {
          ctx.fillText(text, 0, 0);
        }
      }
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    Text.prototype._setupCache = function _setupCache(model) {
      model.rendererCache = model.rendererCache ? model.rendererCache : {
        truncatedText: null,
        truncatedMaxWidth: -1,
        truncatedFontSize: -1,
        truncatedAlign: ""
      };
    };
    /**
     * Truncate the text with respect to the following criteria.
     * @param text The original text
     * @param fontSize The size of the font
     * @param maxWidth The max length that is availiable
     * @param align The horizontal alignment (left, right, center)
     * @returns {{text: string, offset: number}}
     */


    Text.prototype._truncate = function _truncate(text, fontSize, maxWidth, align) {
      if (align === void 0) align = 'left';
      var sizeRatio = fontSize / FONT$3.SIZE;
      var truncatedText = textUtils.getInstance().getTruncatedText(text, maxWidth / sizeRatio);
      var offset = 0,
          textSize;

      switch (align) {
        case 'right':
          textSize = sizeRatio * textUtils.getInstance().getTextWidth(truncatedText);
          offset = maxWidth - textSize;
          break;

        case 'center':
          textSize = sizeRatio * textUtils.getInstance().getTextWidth(truncatedText);
          offset = (maxWidth - textSize) * 0.5;
          break;

        default:
        case 'left':
          offset = 0;
          break;
      }

      return {
        text: truncatedText,
        offset: offset
      };
    };

    return Text;
  }(Shape$2);

  var Text$4 = singleton(Text$3); //
  // formatter
  // Code inspired by: http://www.xaprb.com/blog/2006/01/05/javascript-number-formatting/
  //
  // Copied over from WaveUI/Client/src/app/format.coffee
  //

  var StringHelper$2 = Helpers.StringHelper;
  var NumberHelper$1 = Helpers.NumberHelper;
  var NumberFormatter = {
    formatCache: {},
    format: function format(fmt, delimiters) {
      fmt = fmt.replace(/[<>"']/, "");
      var cacheKey = delimiters ? fmt + JSON.stringify(delimiters) : fmt;
      return NumberFormatter.formatCache[cacheKey] || (NumberFormatter.formatCache[cacheKey] = NumberFormatter.createFormat(fmt, delimiters));
    },
    createFormat: function createFormat(fmt, delimiters) {
      var ff;
      var formats = fmt.split(";");

      switch (formats.length) {
        case 1:
          ff = this._createTerminalFormat(fmt, delimiters);
          break;

        case 2:
          var neg = this._createTerminalFormat(formats[1], delimiters);

          var pos = this._createTerminalFormat(formats[0], delimiters);

          ff = function ff(n) {
            if (n < 0) {
              return neg(n);
            } else {
              return pos(n);
            }
          };

          break;

        case 3:
          neg = this._createTerminalFormat(formats[1], delimiters);

          var zero = this._createTerminalFormat(formats[2], delimiters);

          pos = this._createTerminalFormat(formats[0], delimiters);

          ff = function ff(n) {
            if (n < 0) {
              return neg(n);
            } else if (n === 0) {
              return zero(n);
            } else {
              return pos(n);
            }
          };

          break;

        default:
          throw new Error("Formatting Error: too many semicolons");
      }

      return function (n) {
        if (isNaN(n) || !lodash__default.isNumber(n)) {
          return "NaN";
        }

        if (n === +Infinity) {
          return "Infinity";
        }

        if (n === -Infinity) {
          return "-Infinity";
        }

        return ff(n);
      };
    },
    _createTerminalFormat: function _createTerminalFormat(fmt, delimiters) {
      var this$1 = this;
      delimiters = this._sanitizeDefaultOverrideSeparators(delimiters);
      var i, m;

      if (fmt.length > 0 && fmt.search(/[0#?]/) === -1) {
        return function () {
          return StringHelper$2.escape(fmt);
        };
      }

      var thousands = false;
      var lodp = fmt;
      var rodp = "";
      fmt = fmt.replace(/(e)([+-]?)(0+)/i, ""); // dump scientific stuff

      if (m = fmt.match(/^([^.]*)\.(.*)$/)) {
        lodp = m[1].replace(/\./g, "");
        rodp = m[2].replace(/\./g, "");
      }

      thousands = lodp.search(/[0#?],[0#?]/) >= 0;

      if (m || thousands) {
        lodp = lodp.replace(/,/g, "");
      }

      var minIntegerPlaces = (m = lodp.match(new RegExp('0[0#?]*'))) ? m[0].length : 0;
      var minDecimalPlaces = (i = rodp.lastIndexOf("0")) !== -1 ? i + 1 : 0;
      var maxDecimalPlaces = (m = rodp.match(new RegExp('[0#?]*'))) ? m[0].length : 0;
      var commaScaler = (m = lodp.match(/(,+)(?:$|[^0#?,])/)) ? Math.pow(1000, m[1].length) : 1;
      return function (n) {
        var delta;
        n /= commaScaler;
        var roundedNum = NumberHelper$1.round(n, maxDecimalPlaces);
        var splitNum = NumberHelper$1.toStandardFormString(roundedNum).split(".");
        var rdigits = splitNum[1] ? splitNum[1].replace(/\./g, "").length : 0;
        var decimalPlaces = rdigits < minDecimalPlaces ? minDecimalPlaces : rdigits; // add extra trailing decimal zeros if necessary

        if (delta = decimalPlaces - rdigits) {
          splitNum[1] = (splitNum[1] != null ? splitNum[1] : "") + StringHelper$2.repeat("0", delta);
        } // need to always inject the right side of the number into format if it has units


        var forceInjectRight = rodp.match(/[^#0]/) && splitNum[1] == null;

        if (forceInjectRight) {
          splitNum[1] = "";
        }

        splitNum[0] = roundedNum !== 0 && n < 0 ? // avoid converting "0" to "-0"
        "-" + StringHelper$2.leftPad(splitNum[0].substring(1), minIntegerPlaces, '0') : StringHelper$2.leftPad(splitNum[0], minIntegerPlaces, '0');

        if (thousands) {
          splitNum[0] = this$1._addSeparators(splitNum[0], delimiters.thousands);
        }

        splitNum[0] = this$1._injectIntoFormat(splitNum[0], lodp, false);

        if (splitNum[1] != null) {
          splitNum[1] = this$1._injectIntoFormat(splitNum[1], rodp, true);
        }

        if (forceInjectRight) {
          return splitNum[0] + splitNum[1];
        } else {
          return splitNum.join(delimiters.decimal);
        }
      };
    },
    // used for converting the integer and decimal parts of the number to the format
    _injectIntoFormat: function _injectIntoFormat(n, fmt, isDecimal) {
      if (!isDecimal) {
        n = StringHelper$2.reverse(n);
        fmt = StringHelper$2.reverse(fmt);
      }

      fmt = StringHelper$2.escape(fmt);
      var i = 0;
      var j = 0;
      var result = "";
      var neg = n.charAt(n.length - 1) === "-";

      if (neg) {
        n = n.substring(0, n.length - 1);
      }

      while (i < fmt.length && j < n.length && fmt.substring(i).search(/[0#?]/) >= 0) {
        if (fmt.charAt(i).match(/[0?]/)) {
          if (n.charAt(j) !== "-") {
            result += n.charAt(j);
          } else {
            result += "0";
          }

          i++;
          j++;
        } else if (fmt.charAt(i) === "#") {
          if (isDecimal) {
            if (n.length >= fmt.substring(i).length) {
              result += n.charAt(j);
              j++;
            }

            i++;
          } else {
            if (n.charAt(j) !== "-") {
              result += n.charAt(j);
            } else {
              result += "0";
            }

            i++;
            j++;
          }
        } else {
          result += fmt.charAt(i);
          i++;
        }
      }

      if (j < n.length) {
        result += n.substring(j);
      }

      if (i < fmt.length) {
        result += fmt.substring(i);
      }

      if (neg) {
        result += "-";
      }

      result = result.replace(/#/g, "").replace(/\?/g, " ");

      if (!isDecimal) {
        result = StringHelper$2.reverse(result);
      }

      return result;
    },
    _addSeparators: function _addSeparators(n, separator) {
      if (separator === "") {
        return n;
      }

      var result = StringHelper$2.reverse(StringHelper$2.reverse(n).replace(/(\d{3})/g, "$1" + separator)); // ,123,456 => 123,456  or -,123,456 => -123,456

      if (result.charAt(0) === separator) {
        result = result.substring(1);
      } else if (result.charAt(0) === "-" && result.charAt(1) === separator) {
        result = "-" + result.substring(2);
      }

      return result;
    },
    _sanitizeDefaultOverrideSeparators: function _sanitizeDefaultOverrideSeparators(delimiters) {
      delimiters = lodash__default.defaults({}, delimiters, {
        thousands: ",",
        decimal: "."
      }); // Only consider one char separator

      var thousands = delimiters.thousands;
      var decimal = delimiters.decimal;

      if (thousands.length > 1) {
        delimiters.thousands = thousands.charAt(0);
      }

      if (decimal.length > 1) {
        delimiters.decimal = decimal.charAt(0);
      }

      return delimiters;
    }
  };
  var NumberFormatter$1 = NumberFormatter.format; //
  // generic scale class for eclair
  //
  // the 2 entry points are:
  // - this.fit(n, format)
  // - this.addPrecision(n, format)
  //
  // Originally copied over from WaveUI/Eclair/src/eclair/numberFit.coffee

  var preSuffixCache = {};
  var NumberFit = {
    // nothing, Thousand, Million, Billion, Tera, Peta, eXa, Zeta, Yotta
    decoS: ["", "ᴋ", "ᴍ", "ʙ", "ᴛ", "ᴘ", "x", "ᴢ", "ʏ"],
    // nothing, milli, micro, nano, pico, femto, atto, zepto, yocto
    decos: ["", "m", "μ", "n", "p", "f", "a", "z", "y"],
    // big, small, addPrecision
    thresh: [1000, 0.01, 10],
    _needSpecialProcessing: function _needSpecialProcessing(n) {
      return n === 0 || n === Infinity || n === -Infinity || isNaN(n) || !lodash__default.isNumber(n);
    },
    _applySpecialProcessing: function _applySpecialProcessing(n, prefix, suffix) {
      if (n === undefined || n === null) {
        return "";
      }

      if (isNaN(n) || !lodash__default.isNumber(n)) {
        return "NaN";
      }

      if (n === +Infinity) {
        return "Infinity";
      }

      if (n === -Infinity) {
        return "-Infinity";
      } // we left with 0


      return prefix + "0" + suffix;
    },

    /**
     * Given a format string, extract or calculate unit parts from it.
     * For example, for format string "$(#,###.#)", compactDecimalDigits 3:
     *     prefix: "$("
     *     suffix: ")"
     *     numberformat: "#,###.#"
     *     compactFormat: "#,###.000"
     * @param  {string} format
     * @param  {number} compactDecimalDigits
     * @return {array} [prefix, suffix, numberFormat, compactFormat]
     */
    _getUnits: function _getUnits(format, compactDecimalDigits) {
      var cacheKey = format && format + compactDecimalDigits;

      if (preSuffixCache.hasOwnProperty(cacheKey)) {
        return preSuffixCache[cacheKey];
      } // Invalid format


      if (format == null || !format.match(new RegExp('.*[#0-9].*'))) {
        return ['', '', '', ''];
      } // Take anything before first number


      var prefix = format.replace(new RegExp('[0#?].*'), ''); // Take anything after last number

      var suffix = format.replace(/.*[0#?]+/, '');
      var numberFormat = format.slice(prefix.length, format.length - suffix.length);

      var compactFormat = this._getCompactFormat(numberFormat, compactDecimalDigits);

      preSuffixCache[cacheKey] = [prefix, suffix, numberFormat, compactFormat];
      return preSuffixCache[cacheKey];
    },

    /**
     * Get formatter for compact number.
     * For example, compactDecimalDigits = 3,
     *     #,###.# => #,###.000
     *     #,### => #,###.000
     * For example, compactDecimalDigits = 0,
     *     #,###.# => #,###
     *     #,### => #,###
     * @param  {string} numberFormat
     * @param  {number} compactDecimalDigits number of decimal digits
     * @return {string} Formatter for compact number.  undefined if compactDecimalDigits is undefined or < 0
     */
    _getCompactFormat: function _getCompactFormat(numberFormat, compactDecimalDigits) {
      if (compactDecimalDigits >= 0) {
        return numberFormat.split(".")[0] + "." + dataUtils.repeat("0", compactDecimalDigits);
      }
    },
    _addPrecision: function _addPrecision(n, multiplier, numberFormat, preciseCompact, delimiters) {
      n = n * multiplier;

      if (!numberFormat || preciseCompact) {
        var scale = "";
        var neg = n < 0;
        var m = neg ? -n : n;
        var thresh = preciseCompact ? this.thresh[0] : this.thresh[2];

        while (m < thresh) {
          m *= 10;

          if (Math.ceil(m / 10) * 10 !== m) {
            scale += "#";
          }
        } // make sure 5 is not converted to 5.0


        numberFormat = "#,###." + scale;
      }

      return NumberFormatter$1(numberFormat, delimiters)(n);
    },
    _big: function _big(n, multiplier, compactFormat, preciseCompact, delimiters) {
      if (!n || multiplier === 0) {
        return "0";
      }

      var m = n;
      var scale = 0;

      while (n * multiplier >= 1000) {
        n /= 1000;
        scale++;
      }

      if (!this.decoS[scale]) {
        return m.toExponential(0);
      }

      if (scale === 0) {
        return this._addPrecision(n, multiplier, compactFormat, preciseCompact, delimiters);
      } else {
        return this._addPrecision(n * multiplier, 1, compactFormat, preciseCompact, delimiters) + this.decoS[scale];
      }
    },
    _small: function _small(n, multiplier, compactFormat, preciseCompact, delimiters) {
      if (!n || multiplier === 0) {
        return "0";
      }

      var m = n;
      var scale = 0;

      while (n * multiplier < 1) {
        n *= 1000;
        scale++;
      }

      if (!this.decos[scale]) {
        return m.toExponential(0);
      }

      if (scale === 0) {
        return this._addPrecision(n, multiplier, compactFormat, preciseCompact, delimiters);
      } else {
        return this._addPrecision(n * multiplier, 1, compactFormat, preciseCompact, delimiters) + this.decos[scale];
      }
    },
    _getFormatParts: function _getFormatParts(n, format) {
      var ref = format || [];
      var formatter = ref[0];
      var multiplier = ref[1];
      var overrideFormat = ref[2]; // multiplier can be zero

      multiplier = multiplier == null ? 1 : multiplier;
      overrideFormat = overrideFormat || {};
      var compactDecimalDigits = overrideFormat.compactDecimalDigits;
      var delimiters = overrideFormat.delimiters; // formatter: "<general>;<negative>;<zero>"

      var formatters = formatter && formatter.split(";") || [];
      formatter = n < 0 && formatters.length > 1 ? formatters[1] : n === 0 && formatters.length > 2 ? formatters[2] : formatters[0];
      formatter = formatter && formatter.trim();
      compactDecimalDigits = compactDecimalDigits >= 0 ? compactDecimalDigits : -1;

      var ref$1 = this._getUnits(formatter, compactDecimalDigits);

      var prefix = ref$1[0];
      var suffix = ref$1[1];
      var numberFormat = ref$1[2];
      var compactFormat = ref$1[3];
      return {
        sign: n < 0 && formatters.length < 2 ? "-" : "",
        prefix: prefix,
        suffix: suffix,
        numberFormat: numberFormat,
        compactFormat: compactFormat,
        multiplier: multiplier,
        delimiters: delimiters
      };
    },
    addPrecision: function addPrecision(n, format) {
      var ref = this._getFormatParts(n, format);

      var sign = ref.sign;
      var prefix = ref.prefix;
      var suffix = ref.suffix;
      var numberFormat = ref.numberFormat;
      var multiplier = ref.multiplier;
      var delimiters = ref.delimiters;

      if (this._needSpecialProcessing(n)) {
        return this._applySpecialProcessing(n, prefix, suffix);
      }

      return sign + prefix + this._addPrecision(Math.abs(n), multiplier, numberFormat, undefined, delimiters) + suffix;
    },

    /**
     * For compact number.  Number of decimalDigits is controlled by compactDecimalDigits >= 0.
     * When compactDecimalDigits is undefined or < 0, the compact number formatting is auto.
     * If the preciseCompact is true, also do auto formatting.
     * @param  {[type]} n              [description]
     * @param  {[type]} format         [description]
     * @param  {Boolean} preciseCompact
     *     true - format compact number but show up to 4 significant digits if decimal is needed(200, 2.345K, 1.234M)
     *     false - show up to 2 significant digits if decimal is needed(200, 2.3K, 1M)
     * @return {[type]}                [description]
     */
    fit: function fit(n, format, preciseCompact) {
      var ref = this._getFormatParts(n, format);

      var sign = ref.sign;
      var prefix = ref.prefix;
      var suffix = ref.suffix;
      var compactFormat = ref.compactFormat;
      var multiplier = ref.multiplier;
      var delimiters = ref.delimiters;

      if (this._needSpecialProcessing(n)) {
        return this._applySpecialProcessing(n, prefix, suffix);
      }

      n = Math.abs(n);

      if (n * multiplier >= this.thresh[0]) {
        return sign + prefix + this._big(n, multiplier, compactFormat, preciseCompact, delimiters) + suffix;
      } else if (n * multiplier < this.thresh[1]) {
        return sign + prefix + this._small(n, multiplier, compactFormat, preciseCompact, delimiters) + suffix;
      } else {
        return sign + prefix + this._addPrecision(n, multiplier, compactFormat, preciseCompact, delimiters) + suffix;
      }
    }
  };

  var formatNumber = function formatNumber(format, compact, preciseCompact) {
    if (compact) {
      return function (n) {
        return NumberFit.fit(n, format, preciseCompact);
      };
    } else {
      return function (n) {
        return NumberFit.addPrecision(n, format);
      };
    }
  }; //


  var FONT$4 = commonConstants.FONT;
  /*::(x: NumberText) => (x: IPainter)*/

  var NumberText = function (Shape) {
    function NumberText() {
      Shape.apply(this, arguments);
    }

    if (Shape) NumberText.__proto__ = Shape;
    NumberText.prototype = Object.create(Shape && Shape.prototype);
    NumberText.prototype.constructor = NumberText;

    NumberText.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);

      this._setupCache(model);

      var ref = model.rendererCache;
      var formatterCache = ref.formatterCache;
      var ref$1 = model.props;
      var fontSize = ref$1.fontSize;
      var number = ref$1.number;
      var format = ref$1.format;
      var compact = ref$1.compact;

      if (fontSize !== FONT$4.SIZE) {
        ctx.font = utils$3.getFont(fontSize);
      }

      var formatter = formatterCache;

      if (formatter == null) {
        formatter = formatNumber(format, compact);
        model.rendererCache.formatterCache = formatter;
      }

      ctx.fillText(formatter(number), 0, 0);
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    NumberText.prototype._setupCache = function _setupCache(model) {
      model.rendererCache = model.rendererCache ? model.rendererCache : {
        formatterCache: null
      };
    };

    NumberText.prototype._getColorRegion = function _getColorRegion() {
      return {
        x0: 0,
        y0: 0,
        x1: 0,
        y1: 0
      };
    };

    return NumberText;
  }(Shape$2);

  var NumberText$1 = singleton(NumberText); //

  var imageCache$2 = ImageCache$1.getInstance();
  /*::(x: Circle) => (x: IPainter)*/

  var Circle = function (Shape) {
    function Circle() {
      Shape.apply(this, arguments);
    }

    if (Shape) Circle.__proto__ = Shape;
    Circle.prototype = Object.create(Shape && Shape.prototype);
    Circle.prototype.constructor = Circle;

    Circle.prototype.draw = function draw(model, ctx, imageLoaderDelegate) {
      Shape.prototype.draw.call(this, model, ctx, imageLoaderDelegate);
      var ref = model.props;
      var r = ref.r;
      var fill = ref.fill;
      var stroke = ref.stroke;
      var lineWidth = ref.lineWidth;
      var texture = ref.texture;

      if (r > 0) {
        ctx.beginPath();
        ctx.arc(0, 0, r, 0, Math.PI * 2, true);
        ctx.closePath();

        if (fill) {
          ctx.fill();
        }

        if (texture) {
          var url = texture.url;
          var fit = texture.fit;
          var shade = texture.shade;

          if (imageCache$2.isImageLoaded(url)) {
            var img = imageCache$2.getImage(url);
            ctx.save();
            ctx.clip();

            Shape.prototype._drawTexture.call(this, img, fit, shade, [-r, -r, 2 * r, 2 * r], ctx);

            ctx.restore();
          } else {
            imageCache$2.registerImage(url, imageLoaderDelegate);
          }
        }

        if (stroke && lineWidth && lineWidth > 0) {
          ctx.stroke();
        }
      }
    };

    Circle.prototype._getColorRegion = function _getColorRegion(model) {
      var ref = model.props;
      var r = ref.r;
      return {
        x0: -r,
        y0: 0,
        x1: r,
        y1: 0
      };
    };

    return Circle;
  }(Shape$2);

  var Circle$1 = singleton(Circle); //

  /**
   * This factory will produce drawers that can draw the basic shapes.
   */

  var Factory = function Factory() {};

  Factory.prototype.get = function get(type) {
    var painter;

    switch (type) {
      case 'Scene':
        painter = Scene;
        break;

      case 'Cell':
      case 'Layer':
        painter = Cell;
        break;

      case 'Rect':
        painter = createDebugShape(Rect$1);
        break;

      case 'Text':
        painter = createDebugShape(Text$4);
        break;

      case 'NumberText':
        painter = createDebugShape(NumberText$1);
        break;

      case 'Line':
        painter = createDebugShape(Line$1);
        break;

      case 'Polygon':
      case 'Path':
        painter = createDebugShape(Path$1);
        break;

      case 'Arc':
        painter = createDebugShape(Arc$1);
        break;

      case 'Point':
        painter = createDebugShape(Circle$1);
        break;

      default:
        painter = null;
        throw new Error("invalid creme node type " + type);
    }

    return painter.getInstance();
  };

  var Factory$1 = singleton(Factory); //

  /*::(x: Renderer) => (x: IRenderer)*/

  var Renderer = function (AccessibilityRendere____1) {
    function Renderer() {
      AccessibilityRendere____1.apply(this, arguments);
    }

    if (AccessibilityRendere____1) Renderer.__proto__ = AccessibilityRendere____1;
    Renderer.prototype = Object.create(AccessibilityRendere____1 && AccessibilityRendere____1.prototype);
    Renderer.prototype.constructor = Renderer;

    Renderer.getInstance = function getInstance() {
      if (!this.instance) {
        this.instance = new this();
      }

      return this.instance;
    }; //--------------------------------------------
    // protected
    //--------------------------------------------


    Renderer.prototype._createPainter = function _createPainter(type) {
      return Factory$1.getInstance().get(type);
    };

    return Renderer;
  }(AccessibilityRenderer);

  Renderer.instance = null; //
  //@flow-ignore

  var ACCESSIBILITY$1 = constants$1.ACCESSIBILITY;
  var Accessible = {
    /**
     * Enable accessibility
     */
    enableAccessibility: function enableAccessibility() {
      if (!this._accessibilityEnabled) {
        this._removeAccessibilityTimer = null;
        this._accessibilityEnabled = true;
        var el = this.container;
        var exploreBtn = this.createAccessibilityButton();
        exploreBtn.addEventListener('click', this.onBtnClick.bind(this));
        exploreBtn.addEventListener('touchstart', this.onBtnClick.bind(this));
        exploreBtn.addEventListener('focus', this.onButtonFocus.bind(this));
        exploreBtn.addEventListener('blur', this.onButtonBlur.bind(this));
        el.appendChild(exploreBtn);
      }
    },

    /**
     * The accessibility contains the following markup
     *  <button>Enable Tab Navigation</button> <span class = assisitve> and enable data table</span>
     */
    createAccessibilityButton: function createAccessibilityButton() {
      var buttonEl = document.createElement('button');
      buttonEl.innerHTML = escapeHtml(LOC.getLabel('wave-charts', 'enableTabNavigation'));
      buttonEl.setAttribute("aria-live", "polite");
      buttonEl.className = this.tooltipCSSClass + " ng-button assistiveText";
      buttonEl.appendChild(this.createAccessibilityTableSpan());
      return buttonEl;
    },
    createAccessibilityTableSpan: function createAccessibilityTableSpan() {
      var assistiveText = document.createElement('span');
      assistiveText.innerHTML = escapeHtml(LOC.getLabel('wave-charts', 'enableDataTable'));
      assistiveText.className = 'assistiveText';
      return assistiveText;
    },

    /**
     * Disable accessibility
     */
    disableAccessibility: function disableAccessibility() {
      if (this._accessibilityEnabled) {
        this._accessibilityEnabled = false;

        var exploreBtn = this._getAccessibilityButton();

        if (exploreBtn) {
          this.container.removeChild(exploreBtn);
        }
      }
    },

    /**
     * If this canvas supports accessibility
     * @returns {boolean}
     */
    supportAccessibility: function supportAccessibility() {
      return true;
    },

    /**
     * The handler when the accessible button is focused
     */
    onButtonFocus: function onButtonFocus() {
      this.setButtonVisibility(true);
    },

    /**
     * The handler when the accessible button is blurred
     */
    onButtonBlur: function onButtonBlur() {
      var button = this._getAccessibilityButton();

      if (!button || !button.disabled) {
        this.setButtonVisibility(false);
      }
    },

    /**
     * The handler when the accessible button is clicked
     */
    onBtnClick: function onBtnClick() {
      var button = this._getAccessibilityButton();

      if (button) {
        button.innerHTML = escapeHtml(LOC.getLabel('wave-charts', 'tabNavigationEnabled'));
        button.className = this.tooltipCSSClass + " ng-button enabled";
        button.setAttribute("disabled", true);
      }

      this.processor.onShowTable();
      this.processor.onShowAccessibilityDataItems();
    },

    /**
     * The anchor will always presented in the DOM tree while it is only visible when on focus
     * @param isVisible
     */
    setButtonVisibility: function setButtonVisibility(isVisible) {
      var button = this._getAccessibilityButton();

      if (button) {
        var className = "";

        if (!isVisible) {
          button.innerHTML = escapeHtml(LOC.getLabel('wave-charts', 'enableTabNavigation'));

          if (!this._getDataTableText()) {
            button.appendChild(this.createAccessibilityTableSpan());
          }

          className = "assistiveText";
        }

        button.className = this.tooltipCSSClass + " ng-button " + className;
      }
    },
    _getAccessibilityButton: function _getAccessibilityButton() {
      return lodash__default.first(this.container.getElementsByTagName("button"));
    },
    _getDataTableText: function _getDataTableText() {
      return lodash__default.first(this._getAccessibilityButton().getElementsByTagName("span"));
    },
    //--------------------------------------------
    // public (data table)
    //--------------------------------------------

    /**
     * Render the table to "this.outerDom"
     * @param table
     */
    updateAccessibilityTable: function updateAccessibilityTable(table) {
      var el = this.container;
      var tableEl = this.getTableEl();

      if (tableEl) {
        el.removeChild(tableEl);
      }

      el.appendChild(this.createTable(table));
    },

    /**
     * Remove the current accessibility table if there is one
     */
    removeAccessibilityTable: function removeAccessibilityTable() {
      var el = this.container;
      var tableEl = this.getTableEl();

      if (tableEl) {
        el.removeChild(tableEl);
      }
    },

    /**
     * Get the table element
     * @returns {*}
        */
    getTableEl: function getTableEl() {
      var el = this.container;
      return el ? lodash__default.first(el.getElementsByTagName("table")) : null;
    },

    /**
     * Create a table with content markups is given
     * @param table
     * @returns {Element}
     */
    createTable: function createTable(table) {
      var tableEl = document.createElement('table');
      tableEl.innerHTML = table;
      tableEl.className = this.tooltipCSSClass + " assistiveText";
      return tableEl;
    },
    _resetAccessibilityIn: function _resetAccessibilityIn(duration) {
      // reset timer
      this._keepAccessibility();

      this._removeAccessibilityTimer = setTimeout(this.resetAccessibility.bind(this), duration);
    },
    _keepAccessibility: function _keepAccessibility() {
      if (this._removeAccessibilityTimer) {
        clearTimeout(this._removeAccessibilityTimer);
        this._removeAccessibilityTimer = null;
      }
    },
    resetAccessibility: function resetAccessibility() {
      if (this._buttonFocusTimer) {
        clearTimeout(this._buttonFocusTimer);
        this._buttonFocusTimer = null;
      }

      var button = this._getAccessibilityButton();

      if (button) {
        button.removeAttribute("disabled");
      }

      this.setButtonVisibility(false);
      this.removeDataItems();
      this.removeAccessibilityTable();
    },
    //--------------------------------------------
    // public (data items)
    //--------------------------------------------

    /**
     * Data items are those visible data points that can be tab through
     * @param dataItems
     */
    setDataItems: function setDataItems(dataItems) {
      var el = this.container;
      var tableEl = this.getDataContainerEl();

      if (tableEl) {
        el.removeChild(tableEl);
      }

      el.appendChild(this.createDataContainerEl(this._renderDataItems(dataItems)));
    },

    /**
     * Remove the list of data items from the canvas
     */
    removeDataItems: function removeDataItems() {
      var el = this.container;
      var container = this.getDataContainerEl();

      if (container) {
        el.removeChild(container);
      }
    },

    /**
     * Get the data item container
     * @returns {*}
     */
    getDataContainerEl: function getDataContainerEl() {
      var el = this.container;
      return el ? lodash__default.first(el.getElementsByTagName("ol")) : null;
    },

    /**
     * Create a table with content markups is given
     * @param itemHtml
     * @returns {Element}
     */
    createDataContainerEl: function createDataContainerEl(itemHtml) {
      var el = document.createElement('ol');
      el.innerHTML = itemHtml;
      el.className = this.tooltipCSSClass + " assistiveText";
      el.addEventListener('focus', this.onDataItemFocus.bind(this), true);
      el.addEventListener('blur', this.onDataItemBlur.bind(this), true);
      return el;
    },
    onDataItemFocus: function onDataItemFocus(e) {
      this._keepAccessibility();

      var target = e.target;
      var id = target && target.dataset && target.dataset['id'];

      if (id) {
        var keyPath = id.split(ACCESSIBILITY$1.ID_SEPARATOR);
        this.processor.onTabOnShape(keyPath);
      }
    },
    onDataItemBlur: function onDataItemBlur(e) {
      this._resetAccessibilityIn(ACCESSIBILITY$1.INACTIVE_WAIT);

      var target = e.target;
      var id = target && target.dataset && target.dataset['id'];

      if (id) {
        var keyPath = id.split(ACCESSIBILITY$1.ID_SEPARATOR);
        this.processor.onTabOffShape(keyPath);
      }
    },

    /**
     * From DataItems => <li><a>Content...</a></li>
     * @param dataItems
     * @returns {string}
     * @private
     */
    _renderDataItems: function _renderDataItems(dataItems) {
      var this$1 = this;
      var len = dataItems.length;
      var lastItemName = this.name + "_lastDataItem";
      return dataItems.map(function (it, i) {
        var lines = this$1.processor.getTooltipWithPath(it.keyPath);
        var content = lodash__default.sortBy(lines, "type").map(this$1._formatAccessibleContent).join(",&nbsp;");
        return "<li tabIndex=\"0\" data-id=\"" + it.keyPath.map(function (x) {
          return escapeHtml(x);
        }).join(ACCESSIBILITY$1.ID_SEPARATOR) + "\" id=\"" + (i === len - 1 ? lastItemName : "") + "\">" + content + "</li>";
      }).join('');
    },
    _formatAccessibleContent: function _formatAccessibleContent(line) {
      var content = "";

      if (line) {
        var value = line.value;
        var label = line.label;
        var percentData = line.percentData;
        var percentContent = percentData ? ", " + LOC.getLabel('wave-charts', percentData.group ? "percentTooltipWithGroup" : "percentTooltip", [percentData.percent, percentData.total, percentData.group]) : "";
        content = label + " " + value + percentContent;
      }

      return escapeHtml(content, true);
    }
  };
  var animLastTime = 0;
  var LARGE_VIEWPORT_SIZE = 10000;

  var cremeRequestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
    var currTime, id, timeToCall;
    currTime = Date.now();
    timeToCall = Math.max(0, 1000 / 60 - (currTime - animLastTime));
    id = setTimeout(function () {
      return callback(currTime + timeToCall);
    }, timeToCall);
    animLastTime = currTime + timeToCall;
    return id;
  };

  var Tweener = function Tweener(tweenFunction) {
    this.tweenFunction = tweenFunction;
    this.runTween = this.runTween.bind(this);
    this.reset();
  };

  Tweener.initClass = function initClass() {
    this.TWEEN_FUNCTIONS = {
      sine: function sine(v) {
        return 0.5 - 0.5 * Math.cos(v * Math.PI);
      }
    }; // linear: (v) -> v
    // set: (v) -> Math.floor v
    // discrete: (v) -> Math.floor v
    // fullsine: (v) -> Math.sin v * Math.PI
    // sproing: (v) -> (0.5 - 0.5 * Math.cos(v * 3.59261946538606)) * 1.05263157894737
    // square: (v) -> v * v
    // cube: (v) -> v * v * v
    // sqrt: (v) -> Math.sqrt v
    // curt: (v) -> Math.pow v, -0.333333333333

    this.prototype.afterFct = null; // function to call after tweening is done (will be set in runTween)

    this.prototype.tweenSequence = 0;
    this.prototype.objectsToTween = {}; // map: layerId -> array of [object, array of [prop name, start value, end value]]

    this.prototype.tweenFunction = null;
    this.prototype.isAnimating = false; // true if we are in the middle of a tween animation
    // log data

    this.prototype.nbTweens = 0; // number of property animated (using animateTo)
  };

  Tweener.prototype.reset = function reset() {
    var this$1 = this;

    if (this.isAnimating) {
      // end previous animation properly
      ++this.tweenSequence; // to be sure processFrame won't be called for the tween anymore

      this.doTweenStep(1);

      if (this.afterFct) {
        this.afterFct();
      }
    }

    for (var layerId in this$1.objectsToTween) {
      var objects = this$1.objectsToTween[layerId];
      objects.forEach(function (object) {
        delete object.tweens;
        delete object.tweenableAttrs;
      });
    }

    this.objectsToTween = {};
    this.nbTweens = 0;
    return this.isAnimating = false;
  }; //--------------------------------------------------------------------------------
  // misc
  //--------------------------------------------------------------------------------


  Tweener.prototype.nbObjectsToTween = function nbObjectsToTween() {
    var this$1 = this;
    var nbTweenObjects = 0;

    for (var layerId in this$1.objectsToTween) {
      var objects = this$1.objectsToTween[layerId];
      nbTweenObjects += objects.length;
    }

    return nbTweenObjects;
  }; //--------------------------------------------------------------------------------
  // helpers
  //--------------------------------------------------------------------------------


  Tweener.tweenValue = function tweenValue(x, start, end) {
    return start * (1 - x) + end * x;
  };

  Tweener.tweenColor = function tweenColor(x, startRGB, endRGB) {
    return startRGB.toColor(endRGB, x);
  };

  Tweener.tweenValues = function tweenValues(x, startValues, endValues) {
    return dataUtils.zip(startValues, endValues).map(function (ref) {
      var start = ref[0];
      var end = ref[1];
      return Tweener.tweenValue(x, start, end);
    });
  }; //--------------------------------------------------------------------------------
  // tween
  //--------------------------------------------------------------------------------
  // pre-tween code


  Tweener.prototype._pre = function _pre() {
    this.isAnimating = true;
  }; // post-tween code


  Tweener.prototype._post = function _post(perf) {
    this.isAnimating = false;

    if (this.afterFct) {
      this.afterFct(perf.end());
    }
  }; // code to execute for each step of the tween


  Tweener.prototype._doStep = function _doStep(duringFct, x0) {
    this.doTweenStep(x0);
    duringFct(this.tweenFunction(x0));
  }; // run tweening animation
  // note:
  // - duringFct is called on each frame
  // - isAnimating is set to true during the animations and set to false for the last frame
  // - this means that isAnimating will be false for the last frame


  Tweener.prototype.runTween = function runTween(options, duringFct, afterFct) {
    var this$1 = this;
    var x0;
    this.afterFct = afterFct;
    var duration = options.duration;
    var frames = options.frames;
    var callback = options.callback;
    var tweenSequence = ++this.tweenSequence;
    var perf = new Perf({
      name: 'tweener'
    }).start();

    if (frames) {
      // frames execution path -> we want specific frames
      this._pre();

      frames.forEach(function (x0) {
        this$1._doStep(duringFct, x0 / 100);

        callback(x0);
      });

      this._post(perf);

      return;
    }

    if (duration === 0) {
      // immeditate execution path -> bypass all the async processes
      this._pre();

      this._doStep(duringFct, 1);

      this._post(perf);

      return;
    } // regular execution path -> we want a specific duration


    x0 = 0;
    var startTime = -1;
    var firstTime = true;
    var nbProcessFrames = 0;

    this._pre();

    var processFrame = function processFrame() {
      if (this.tweenSequence !== tweenSequence) {
        return;
      } // another tween has started...


      var currentTime = Date.now();

      if (firstTime) {
        firstTime = false;
        startTime = currentTime;
      } else {
        x0 = (currentTime - startTime) / duration;

        if (x0 < 0) {
          x0 = 0;
        }

        if (x0 > 1) {
          x0 = 1;
        }
      }

      nbProcessFrames++;

      this._doStep(duringFct, x0);

      if (x0 < 1) {
        return cremeRequestAnimFrame(perfProcessFrame);
      } else {
        if (log$1.draw) {
          console.log(new Date().toLocaleTimeString() + "|tweener:: fps: " + nbProcessFrames * 1000 / (Date.now() - startTime) + " for " + this.nbObjectsToTween() + " objects");
        }

        return this._post(perf);
      }
    };

    var perfProcessFrame = perf.iteration.bind(perf, 'draw', processFrame.bind(this));
    return perfProcessFrame();
  };

  Tweener.prototype.doTweenStep = function doTweenStep(x0) {
    var this$1 = this;

    for (var parentId in this$1.objectsToTween) {
      var objects = this$1.objectsToTween[parentId];
      var nbObjsMinusOne = objects.length;
      var staggerAnim = true;
      var parent = objects[0] != null ? objects[0].getParent() : undefined;

      if (parent) {
        staggerAnim = parent.props.staggerAnim;
      }

      var j = void 0;

      for (var i = j = 0, len = objects.length; j < len; i = ++j) {
        var object = objects[i];
        var newX0 = staggerAnim ? x0 + 0.6 * (x0 - i / nbObjsMinusOne) : x0;

        if (newX0 < 0) {
          newX0 = 0;
        }

        if (newX0 > 1) {
          newX0 = 1;
        }

        var x = this$1.tweenFunction(newX0);
        object._tweenRatio = x;

        for (var property in object.tweenableAttrs) {
          var newValue = void 0;
          var ref = object.tweenableAttrs[property];
          var startValue = ref[0];
          var endValue = ref[1];

          if (property === "fill" || property === "stroke" || property === "textColor" || property === "background") {
            newValue = Tweener.tweenColor(x, startValue, endValue);
          } else if (property === "points_x" || property === "points_y" || property === "animate_points_x" || property === "animate_points_y") {
            var lastStartPoint = startValue[startValue.length - 1];
            var lastEndPoint = endValue[endValue.length - 1];
            newValue = [];

            for (var i$1 = 0, end = Math.max(startValue.length, endValue.length), asc = 0 <= end; asc ? i$1 < end : i$1 > end; asc ? i$1++ : i$1--) {
              var left = void 0,
                  left1 = void 0;
              var vStart = (left = startValue[i$1] != null ? startValue[i$1] : lastStartPoint) != null ? left : 0;
              var vEnd = (left1 = endValue[i$1] != null ? endValue[i$1] : lastEndPoint) != null ? left1 : 0;
              newValue.push(Tweener.tweenValue(x, vStart, vEnd));
            }
          } else if (property === "viewport") {
            newValue = Tweener.tweenValues(x, startValue, endValue);
          } else if (property === "scrollOffset") {
            newValue = Tweener.tweenValues(x, startValue, endValue);
          } else if (property === "rotation") {
            newValue = {
              x: Tweener.tweenValue(x, startValue.x, endValue.x),
              y: Tweener.tweenValue(x, startValue.y, endValue.y),
              angle: Tweener.tweenValue(x, startValue.angle, endValue.angle)
            };
          } else if (property === "texture") {
            newValue = {
              url: endValue.url,
              fit: endValue.fit,
              shade: Tweener.tweenValue(x, startValue.shade, endValue.shade)
            };
          } else if (property === "bg") {
            newValue = {
              color: Tweener.tweenColor(x, startValue.color, endValue.color),
              opacity: Tweener.tweenValue(x, startValue.opacity, endValue.opacity),
              box: Tweener.tweenValues(x, startValue.box, endValue.box)
            };
          } else {
            newValue = Tweener.tweenValue(x, startValue, endValue);
          }

          object.props[property] = newValue;
        }
      }
    }
  }; // store each tween property for a given an object shape
  //   param propertiesMap: hashmap prop name -> [ startValue, endValue ]


  Tweener.prototype.addTweenProperties = function addTweenProperties(object, tweensMap) {
    var this$1 = this;

    if (!tweensMap) {
      return;
    }

    for (var property in tweensMap) {
      // special properties type (no shape morphing yet)
      if (property === "type" || property === "key") {
        continue;
      }

      var ref = tweensMap[property];
      var startValue = ref[0];
      var endValue = ref[1];

      if (startValue == null && endValue == null) {
        continue;
      } // has missing value and not one of the special property


      if (!dataUtils.includes(["fill", "stroke", "textColor", "background", "rotation", "bg", "baseX", "baseY", "viewport"], property) && (startValue == null || endValue == null)) {
        object.props[property] = endValue;
        continue;
      } // if tween not implemented on platform, directly update
      // shape property to end value


      if (!object.tweenableAttrs) {
        object.tweenableAttrs = {};
        var parentId = object.getParent() ? object.getParent().uid : 0;

        if (this$1.objectsToTween[parentId] == null) {
          this$1.objectsToTween[parentId] = [];
        }

        this$1.objectsToTween[parentId].push(object);
      }

      var switchRes = void 0;

      switch (property) {
        case "fill":
        case "stroke":
        case "textColor":
        case "background":
          if (startValue == null) {
            startValue = endValue.adjustOpacity(0);
          }

          if (endValue == null) {
            endValue = startValue.adjustOpacity(0);
          }

          switchRes = [startValue, endValue];
          break;

        case "rotation":
          if (startValue == null) {
            startValue = {
              x: endValue.x,
              y: endValue.y,
              angle: 0
            };
          }

          if (endValue == null) {
            endValue = {
              x: startValue.x,
              y: startValue.y,
              angle: 0
            };
          }

          switchRes = [startValue, endValue];
          break;

        case "baseX":
        case "baseY":
          if (startValue == null) {
            startValue = endValue;
          }

          if (endValue == null) {
            endValue = startValue;
          }

          switchRes = [startValue, endValue];
          break;

        case "bg":
          var start = startValue ? lodash__default.extend({}, startValue) : {
            color: endValue.color.adjustOpacity(0),
            box: endValue.box
          };
          var end = endValue ? lodash__default.extend({}, endValue) : {
            color: startValue.color.adjustOpacity(0),
            box: startValue.box
          };
          switchRes = [start, end];
          break;

        case "viewport":
          var startV = startValue ? startValue : [0, 0, LARGE_VIEWPORT_SIZE, LARGE_VIEWPORT_SIZE];
          var endV = endValue ? endValue : [0, 0, LARGE_VIEWPORT_SIZE, LARGE_VIEWPORT_SIZE];
          switchRes = [startV, endV];
          break;

        default:
          switchRes = [startValue, endValue];
          break;
      }

      object.tweenableAttrs[property] = switchRes;
      this$1.nbTweens++;
    }

    return object;
  };

  Tweener.initClass(); //

  /**
   * This is a subset from the lib glmatrix.js
   * https://github.com/toji/gl-matrix/blob/master/src/gl-matrix/mat3.js
   */

  var Matrix3 = function Matrix3() {};

  Matrix3.mul = function mul(out, a, b) {
    var a00 = a[0],
        a01 = a[1],
        a02 = a[2],
        a10 = a[3],
        a11 = a[4],
        a12 = a[5],
        a20 = a[6],
        a21 = a[7],
        a22 = a[8],
        b00 = b[0],
        b01 = b[1],
        b02 = b[2],
        b10 = b[3],
        b11 = b[4],
        b12 = b[5],
        b20 = b[6],
        b21 = b[7],
        b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
  };

  Matrix3.fromTranslation = function fromTranslation(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
  };

  Matrix3.fromRotation = function fromRotation(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
  }; //

  /**
   * ResourcePool manages a pool of resource specified. For a client, there are two fundamental operation to perform
   * 1. checkout 2. return
   * When checking out a resource, the pool will check if there is any resource available. Either it has a item to be reused or not,
   * it will ask the provider to produce a new resource. It is the PROVIDER's responsibility to decide if reusing is applicable.
   * If there is no space available, the pool will evict the resource in the FIFO fashion.
   */

  /*::(x: ResourcePool<any>) => (x: IResourcePool<any>)*/


  var ResourcePool = function ResourcePool() {
    this.reset();
  };

  ResourcePool.prototype.setProvider = function setProvider(provider) {
    this._provider = provider;
    return this;
  };

  ResourcePool.prototype.checkout = function checkout(options) {
    var reusedItem = this._getNextAvailableItemFromPool();

    this._numResourceCheckedOut++;
    return this._provider.checkout(options, reusedItem);
  };

  ResourcePool.prototype.returnBack = function returnBack(item) {
    this._numResourceCheckedOut--;

    this._poolAvailable.push(item);
  };

  ResourcePool.prototype.reset = function reset() {
    this._numResourceCheckedOut = 0;
    this._poolAvailable = [];
    return this;
  };

  ResourcePool.prototype.getUsedSize = function getUsedSize() {
    return this._numResourceCheckedOut;
  }; //--------------------------------------------
  // private
  //--------------------------------------------


  ResourcePool.prototype._getNextAvailableItemFromPool = function _getNextAvailableItemFromPool() {
    if (this._poolAvailable.length <= 0) {
      return null;
    } else {
      return this._poolAvailable.pop();
    }
  }; //

  /**
   * Created by yi.chen on 9/26/16.
   */

  /*::(x: Float32Array9Provider<any>) => (x: IResourceProvider<any>)*/


  var Float32Array9Provider = function Float32Array9Provider() {};

  Float32Array9Provider.prototype.checkout = function checkout(options, oldMat) {
    return oldMat ? oldMat : new Float32Array(9);
  };

  var Float32Array9ResourcePool = function (ResourcePoo____1) {
    function Float32Array9ResourcePool() {
      ResourcePoo____1.call(this);
      this.setProvider(Float32Array9ProviderInstance.getInstance());
    }

    if (ResourcePoo____1) Float32Array9ResourcePool.__proto__ = ResourcePoo____1;
    Float32Array9ResourcePool.prototype = Object.create(ResourcePoo____1 && ResourcePoo____1.prototype);
    Float32Array9ResourcePool.prototype.constructor = Float32Array9ResourcePool;
    return Float32Array9ResourcePool;
  }(ResourcePool);

  var Float32Array9ProviderInstance = singleton(Float32Array9Provider);
  var TransformStateResourcePool = singleton(Float32Array9ResourcePool); //

  /**
   * Drawing Context is a wrapper that composes a platform-dependant graphics context to provide with addition drawing info.
   * Ideally, only in the shape level needs to directly interact with the graphics context and the rest of the parts interact
   * with the abstract drawing context.
   */

  /*::(x: DrawingContext) => (x: IDrawingContext)*/

  var DrawingContext$2 = function DrawingContext(graphicsContext, options) {
    this._graphicsContext = graphicsContext;
    this._imageLoaderDelegate = options.imageLoaderDelegate;
    this._modelTransform = this._initTransform(TransformStateResourcePool.getInstance().checkout());
    this._modelStack = [];
    this._drawDebugInfo = {
      isEnabled: false,
      filter: null
    };
  };

  DrawingContext$2.prototype.translate = function translate(x, y, z) {
    var pool = TransformStateResourcePool.getInstance();
    var tempMat = pool.checkout();
    Matrix3.mul(this._modelTransform, this._modelTransform, Matrix3.fromTranslation(tempMat, [x, y]));
    pool.returnBack(tempMat);
  };

  DrawingContext$2.prototype.scale = function scale(x, y, z) {
    throw new Error("Scale in renderer is not supported yet");
  };

  DrawingContext$2.prototype.rotate = function rotate(angle) {
    var pool = TransformStateResourcePool.getInstance();
    var tempMat = pool.checkout();
    Matrix3.mul(this._modelTransform, this._modelTransform, Matrix3.fromRotation(tempMat, angle));
    pool.returnBack(tempMat);
  };

  DrawingContext$2.prototype.save = function save() {
    this._saveModelTransform();
  };

  DrawingContext$2.prototype.restore = function restore() {
    this._restoreModelTransform();
  }; // Hack: We know there is no rotation at the level of scene, cell and layer.
  // We will not apply the rotation part of the transform to the box given.


  DrawingContext$2.prototype.applyTransformTo = function applyTransformTo(box) {
    var x = box[0];
    var y = box[1];
    var w = box[2];
    var h = box[3];
    var tx = this._modelTransform[6];
    var ty = this._modelTransform[7];
    return [x + tx, y + ty, w, h];
  };

  DrawingContext$2.prototype.applyTransform = function applyTransform() {};

  DrawingContext$2.prototype.restoreTransform = function restoreTransform() {};

  DrawingContext$2.prototype.setInterpolationRatio = function setInterpolationRatio(ratio) {
    this._interpolationRatio = ratio;
  };

  DrawingContext$2.prototype.getInterpolationRatio = function getInterpolationRatio() {
    return this._interpolationRatio;
  };

  DrawingContext$2.prototype.isAnimating = function isAnimating() {
    return this._interpolationRatio !== 1;
  }; //--------------------------------------------
  // public (graphics context)
  //--------------------------------------------


  DrawingContext$2.prototype.getGraphicsContext = function getGraphicsContext() {
    return this._graphicsContext;
  };

  DrawingContext$2.prototype.saveGraphicsContext = function saveGraphicsContext() {};

  DrawingContext$2.prototype.restoreGraphicsContext = function restoreGraphicsContext() {};

  DrawingContext$2.prototype.getImageLoaderDelegate = function getImageLoaderDelegate() {
    return this._imageLoaderDelegate;
  };

  DrawingContext$2.prototype.setDebugInfo = function setDebugInfo(options) {
    this._drawDebugInfo = options;
    return this._drawDebugInfo.isEnabled;
  };

  DrawingContext$2.prototype.shouldDrawDebugInfo = function shouldDrawDebugInfo(model) {
    var ref = this._drawDebugInfo;
    var isEnabled = ref.isEnabled;
    var filter = ref.filter;

    if (!isEnabled) {
      return false;
    }

    if (!filter) {
      return true;
    } else {
      if (Array.isArray(filter)) {
        return filter.indexOf(model.props.type) !== -1;
      } else {
        //@flow-ignore
        return filter(model);
      }
    }
  }; //--------------------------------------------
  // private
  //--------------------------------------------


  DrawingContext$2.prototype._initTransform = function _initTransform(state) {
    state[0] = 1;
    state[1] = 0;
    state[2] = 0;
    state[3] = 0;
    state[4] = 1;
    state[5] = 0;
    state[6] = 0;
    state[7] = 0;
    state[8] = 1;
    return state;
  };

  DrawingContext$2.prototype._saveModelTransform = function _saveModelTransform() {
    this._modelStack.push(this._copyState(this._modelTransform));
  };

  DrawingContext$2.prototype._restoreModelTransform = function _restoreModelTransform() {
    TransformStateResourcePool.getInstance().returnBack(this._modelTransform);
    this._modelTransform = this._modelStack.pop();
  };

  DrawingContext$2.prototype._copyState = function _copyState(currentTransform) {
    var copy = TransformStateResourcePool.getInstance().checkout();

    for (var i = 0; i < 9; ++i) {
      copy[i] = currentTransform[i];
    }

    return copy;
  }; //


  var EPSILON$1 = commonConstants.EPSILON;
  /*::(x: DrawingContext) => (x: IDrawingContext)*/

  var DrawingContext = function (BaseDrawingContex____1) {
    function DrawingContext() {
      BaseDrawingContex____1.apply(this, arguments);
    }

    if (BaseDrawingContex____1) DrawingContext.__proto__ = BaseDrawingContex____1;
    DrawingContext.prototype = Object.create(BaseDrawingContex____1 && BaseDrawingContex____1.prototype);
    DrawingContext.prototype.constructor = DrawingContext;

    DrawingContext.prototype.applyTransform = function applyTransform() {
      var ref = this._decomposeTransform(this._modelTransform);

      var tx = ref.tx;
      var ty = ref.ty;
      var sx = ref.sx;
      var sy = ref.sy;
      var rotation = ref.rotation;

      if (!this._isNegligible(tx) || !this._isNegligible(ty)) {
        this._graphicsContext.translate(tx, ty);
      }

      if (!this._isNegligible(rotation)) {
        this._graphicsContext.rotate(rotation);
      }

      if (!this._isNegligible(sx - 1) || !this._isNegligible(sy - 1)) {
        this._graphicsContext.scale(sx, sy);
      }
    };

    DrawingContext.prototype.restoreTransform = function restoreTransform() {
      var ref = this._decomposeTransform(this._modelTransform);

      var tx = ref.tx;
      var ty = ref.ty;
      var sx = ref.sx;
      var sy = ref.sy;
      var rotation = ref.rotation;

      if (!this._isNegligible(tx) || !this._isNegligible(ty)) {
        this._graphicsContext.translate(-tx, -ty);
      }

      if (!this._isNegligible(rotation)) {
        this._graphicsContext.rotate(-rotation);
      }

      if (!this._isNegligible(sx - 1) || !this._isNegligible(sy - 1)) {
        this._graphicsContext.scale(1 / sx, 1 / sy);
      }
    };

    DrawingContext.prototype.saveGraphicsContext = function saveGraphicsContext() {
      this._graphicsContext.save();
    };

    DrawingContext.prototype.restoreGraphicsContext = function restoreGraphicsContext() {
      this._graphicsContext.restore();
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    DrawingContext.prototype._decomposeTransform = function _decomposeTransform(mat) {
      var halfPI = Math.PI * 0.5;
      var theta, sx, sy;

      if (this._isNegligible(mat[0])) {
        theta = mat[1] > 0 ? halfPI : -halfPI;
        var sinTheta = Math.sin(theta);
        sx = -mat[3] / sinTheta;
        sy = mat[1] / sinTheta;
      } else {
        theta = Math.atan(mat[1] / mat[4]);
        var cosTheta = Math.cos(theta);
        sx = mat[0] / cosTheta;
        sy = mat[0] / cosTheta;
      }

      return {
        tx: mat[6],
        ty: mat[7],
        sx: sx,
        sy: sy,
        rotation: theta
      };
    };

    DrawingContext.prototype._isNegligible = function _isNegligible(value) {
      return Math.abs(value) < EPSILON$1;
    };

    return DrawingContext;
  }(DrawingContext$2); // http://noraesae.github.io/perfect-scrollbar/
  // ***Note: Ps is using a custom version with v0.6.7 plus commit 942dd45


  var FONT$5 = commonConstants.FONT;

  var Canvas = function Canvas(ref) {
    var processor = ref.processor;
    var config = ref.config;
    var isLegend = ref.isLegend;
    var tooltip = ref.tooltip;
    var imageLoaderDelegate = ref.imageLoaderDelegate;
    var accessible, cssDescriptor, el, swipePropagation, tooltipCSSClass, wheelPropagation;
    this.onScroll = this.onScroll.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.processor = processor;
    this.tooltip = tooltip;
    this.isLegend = isLegend;
    this.imageLoaderDelegate = imageLoaderDelegate;
    this.size = null;
    this.fullSize = null;
    this.position = null;
    this.baseScrollOffset = [0, 0];
    this.scrollOffset = [0, 0];
    this.updateScrollBar = false;
    this.tweener = new Tweener(Tweener.TWEEN_FUNCTIONS.sine);
    this.cursorType = constants$1.CURSOR_TYPE.DEFAULT;

    if (config != null) {
      var assign;
      assign = config, el = assign.el, cssDescriptor = assign.cssDescriptor, tooltipCSSClass = assign.tooltipCSSClass, wheelPropagation = assign.wheelPropagation, swipePropagation = assign.swipePropagation, accessible = assign.accessible;
    }

    this.tooltipCSSClass = tooltipCSSClass != null ? tooltipCSSClass : "";
    this.accessible = accessible != null ? accessible : true; // create or cache el

    if (el) {
      this.el = el;
    } else if (cssDescriptor) {
      el = document.querySelector(cssDescriptor);
      this.el = el != null ? el : document.createElement('div');
    } else {
      this.el = document.createElement('div');
    }

    this.elCreated = this.el !== el;
    this.name = this.processor.getName(); // Set the internal name on the div itself
    // This way a reference to the div can now be used to first get the proper name
    // and then use the name to retrieve the Chart from the chart cache

    this.el.setAttribute("data-ngname", this.name); // create DOM structure under el

    this.createDOM(); // Perfect-scrollbar settings

    this.wheelPropagation = wheelPropagation != null ? wheelPropagation : true;
    this.swipePropagation = swipePropagation != null ? swipePropagation : true;
    this.startMouseInteraction();
    this.ctx.getGraphicsContext().font = utils$3.getFont(FONT$5.SIZE);

    if (this.accessible) {
      this.enableAccessibility();
    } else {
      this.disableAccessibility();
    }
  };

  Canvas.initClass = function initClass() {
    this.prototype.firstTime = true;
    this.prototype.el = null; // the chart's DOM element

    this.prototype.isLegend = false;
    this.prototype.elCreated = false;
    this.prototype.model = null;
    this.prototype.quietModeTimer = null;
  };

  Canvas.prototype.getContext = function getContext() {
    return this.ctx;
  };

  Canvas.prototype.getModel = function getModel() {
    return this.model;
  };

  Canvas.prototype.setModel = function setModel(model) {
    this.model = model;
    this.model.props.w = this.size[0];
    this.model.props.h = this.size[1];
    return this;
  };

  Canvas.prototype.getWidth = function getWidth() {
    return this.canvasDom.width;
  };

  Canvas.prototype.getHeight = function getHeight() {
    return this.canvasDom.height;
  };

  Canvas.prototype.getElementOffset = function getElementOffset() {
    return [this.canvasDom.offsetLeft, this.canvasDom.offsetTop];
  };

  Canvas.prototype.getScrollOffset = function getScrollOffset() {
    return this.scrollOffset;
  };

  Canvas.prototype.getTweener = function getTweener() {
    return this.tweener;
  };

  Canvas.prototype.isAnimating = function isAnimating() {
    return this.tweener.isAnimating;
  };

  Canvas.prototype.attachEvents = function attachEvents() {
    // event handlers
    this.outerDom.addEventListener("mousedown", this.onMouseDown);
    this.outerDom.addEventListener("mousemove", this.onMouseMove);
    this.outerDom.addEventListener("mouseup", this.onMouseUp);
    this.outerDom.addEventListener("mouseleave", this.onMouseLeave);
    this.outerDom.addEventListener("scroll", this.onScroll);
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("keyup", this.onKeyUp); // - for device supports touch

    this.outerDom.addEventListener("touchmove", this.onTouchMove, {
      passive: true
    });
    this.outerDom.addEventListener("touchstart", this.onTouchStart, {
      passive: true
    });
    this.outerDom.addEventListener("touchend", this.onTouchEnd, {
      passive: false
    });
  };

  Canvas.prototype.detachEvents = function detachEvents() {
    // event handlers
    this.outerDom.removeEventListener("mousedown", this.onMouseDown);
    this.outerDom.removeEventListener("mousemove", this.onMouseMove);
    this.outerDom.removeEventListener("mouseup", this.onMouseUp);
    this.outerDom.removeEventListener("mouseleave", this.onMouseLeave);
    this.outerDom.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("keyup", this.onKeyUp); // - for device supports touch

    this.outerDom.removeEventListener("touchmove", this.onTouchMove);
    this.outerDom.removeEventListener("touchstart", this.onTouchStart);
    this.outerDom.removeEventListener("touchend", this.onTouchEnd);
  }; // Set for a certain period of time that we don't want any interaction events
  // For example, after a pragmatical scroll, we don't want a mouse move event after
  // Therefore we enter the quiet mode for a short period of time after scroll


  Canvas.prototype.quietMode = function quietMode(duration) {
    // If we are already in the quiet mode
    if (this.quietModeTimer) {
      clearTimeout(this.quietModeTimer);
    }

    this.tooltip.quietMode(duration);
    this.detachEvents();
    return this.quietModeTimer = setTimeout(this.attachEvents.bind(this), duration);
  };

  Canvas.prototype.getElement = function getElement() {
    return this.el;
  };

  Canvas.prototype.getEventListeningElement = function getEventListeningElement() {
    return this.outerDom;
  };

  Canvas.prototype.createDOM = function createDOM() {
    /*
    illustration of internal DOM structure
    <el>
    	<container>
    		<outerDOM>
    			<innerDOM/>
    		</outerDOM>
    		<canvasDOM/>
    		<customDOM>
    	</container>
    </el>
    */
    this.container = this.el.appendChild(document.createElement('div'));
    utils$3.setStyles(this.container, {
      position: "relative"
    }); // build invisible divs to fake scrolling
    // the background color needs to be set for mouse interactions to work in ie10

    this.outerDom = this.container.appendChild(document.createElement('div'));
    utils$3.setStyles(this.outerDom, {
      zIndex: this.isLegend ? 3 : 2,
      position: "absolute",
      overflow: "hidden",
      'background-color': "rgba(255,255,255,0)"
    });
    this.innerDom = this.outerDom.appendChild(document.createElement('div'));
    this.canvasDom = this.container.appendChild(document.createElement("canvas"));
    this.canvasDom.className = this.isLegend ? "legend" : "chart"; // legend' canvas needs to be on top of the main chart, so assigning a relatively higher zIndex

    utils$3.setStyles(this.canvasDom, {
      zIndex: this.isLegend ? 2 : 1,
      position: "absolute",
      top: 0,
      left: 0,
      'letter-spacing': 0,
      '-webkit-font-smoothing': "antialiased"
    });
    this._pixelRatio = window.testDevicePixelRatio || window.devicePixelRatio || 1;
    return this.ctx = new DrawingContext(this.canvasDom.getContext('2d'), {
      camera: {
        viewport: null
      },
      imageLoaderDelegate: this.imageLoaderDelegate
    });
  };

  Canvas.prototype.removeDOM = function removeDOM() {
    // do not Ps.destroy a DOM not initialized(chart with legend never used)
    if (!this.firstTime) {
      Ps.destroy(this.outerDom);
    }

    this.outerDom.removeChild(this.innerDom);
    this.container.removeChild(this.outerDom);
    this.container.removeChild(this.canvasDom);
    this.el.removeChild(this.container);

    if (this.elCreated) {
      if (this.el.parentElement != null) {
        this.el.parentElement.removeChild(this.el);
      }
    }

    this.container = null;
    this.outerDom = null;
    this.innerDom = null;
    return this.canvasDom = null;
  };

  Canvas.prototype.removeCustomDOM = function removeCustomDOM(el) {
    this.container.removeChild(el);
  };

  Canvas.prototype.createCustomDOM = function createCustomDOM() {
    var customDOM = document.createElement('div');
    customDOM.classList.add("ng-custom");
    return this.container.appendChild(customDOM);
  };

  Canvas.prototype.getPatcher = function getPatcher() {
    var this$1 = this;
    return {
      update: function update(model0, model1) {
        model0.props = lodash__default.extend({}, model1.props);
        return this$1.tweener.addTweenProperties(model0, model0.tweens);
      },
      remove: function remove(model0) {
        return model0.removeFromParent();
      },
      insert: function insert(model0, parent0) {
        return model0.appendTo(parent0);
      },
      order: function order(model0, sortedKeys) {
        return model0._sortByKeys(sortedKeys);
      }
    };
  };

  Canvas.prototype.update = function update(model, options) {
    if (this.firstTime) {
      Ps.initialize(this.outerDom, {
        swipePropagation: this.swipePropagation,
        wheelPropagation: this.wheelPropagation,
        // do not show scroll bar if only < 1px overflow
        scrollYMarginOffset: 1,
        scrollXMarginOffset: 1
      });
      this.firstTime = false;
    }

    this.updateScrollBar = false;
    var fullSize = model.getEndValue("fullSize");

    if (!lodash__default.isEqual(this.fullSize, fullSize)) {
      this.fullSize = fullSize;
      this.updateScrollBar = true;
      utils$3.setStyles(this.innerDom, {
        width: fullSize[0] + 'px',
        height: fullSize[1] + 'px'
      });
    }

    var size = model.getEndValue("size");

    if (!lodash__default.isEqual(this.size, size)) {
      this.size = size;
      this.updateScrollBar = true;
      utils$3.setStyles(this.outerDom, {
        width: size[0] + 'px',
        height: size[1] + 'px'
      });
      utils$3.setStyles(this.canvasDom, {
        width: size[0] + 'px',
        height: size[1] + 'px'
      });
      this.canvasDom.width = this._pixelRatio * size[0];
      this.canvasDom.height = this._pixelRatio * size[1];

      if (this._pixelRatio !== 1) {
        this.ctx.getGraphicsContext().scale(this._pixelRatio, this._pixelRatio);
      }
    }

    var position = model.getEndValue("position");

    if (!lodash__default.isEqual(this.position, position)) {
      this.position = position;
      utils$3.setStyles(this.outerDom, {
        left: position[0] + 'px',
        top: position[1] + 'px'
      });
      utils$3.setStyles(this.canvasDom, {
        left: position[0] + 'px',
        top: position[1] + 'px'
      });
    }

    this.scrollOffset = model.getEndValue("scrollOffset");
    this.baseScrollOffset = model.getEndValue("baseScrollOffset");
    var fullScrollOffset = [this.baseScrollOffset[0] + this.scrollOffset[0], this.baseScrollOffset[1] + this.scrollOffset[1]];
    var domScrollOffset = [this.outerDom.scrollLeft, this.outerDom.scrollTop];

    if (!lodash__default.isEqual(fullScrollOffset, domScrollOffset)) {
      // let's scroll the outerdom without trigger all the events
      this.updateScrollBar = true;
      this.outerDom.removeEventListener("scroll", this.onScroll);
      this.outerDom.scrollLeft = fullScrollOffset[0];
      this.outerDom.scrollTop = fullScrollOffset[1];
      this.outerDom.addEventListener("scroll", this.onScroll);
    }

    if (this.updateScrollBar) {
      if (options != null ? options.byInteraction : undefined) {
        this.quietMode(constants$1.CANVAS.NO_EVENT_DURATION);
      }

      Ps.update(this.outerDom);
    }

    return this.ctx.getGraphicsContext().font = utils$3.getFont(FONT$5.SIZE);
  }; // call this when the canvas is not needed anymore
  // (when the parent is removed)


  Canvas.prototype.remove = function remove() {
    this.detachEvents();
    return this.removeDOM();
  };

  Canvas.prototype.hide = function hide() {
    this.el.style.display = 'none';
    return this;
  };

  Canvas.prototype.show = function show() {
    this.el.style.display = '';
    return this;
  };

  Canvas.prototype.showTruncationTooltip = function showTruncationTooltip(fullText, angle, positions, shapeOffset) {
    var ref = this.chartOffsetXY();
    var chartTx = ref[0];
    var chartTy = ref[1];
    var tx = shapeOffset[0];
    var ty = shapeOffset[1];
    var extraClass = this.tooltipCSSClass + " truncation";
    var html = this.tooltip.formatTruncationHtml(fullText);
    return this.tooltip.show(chartTx + tx, chartTy + ty, html, positions, angle, extraClass);
  }; // row - array of [formattedColumnName, formattedValue] for tooltip content


  Canvas.prototype.showTooltip = function showTooltip(lines) {
    var html = this.tooltip.formatTooltipHtml(lines);
    return this.tooltip.show(0, 0, html, "auto", 0, this.tooltipCSSClass);
  };

  Canvas.prototype.moveTooltip = function moveTooltip() {
    return this.tooltip.move();
  };

  Canvas.prototype.showTooltipAtWithKey = function showTooltipAtWithKey(x, y, keyPath) {
    var ref = this.chartOffsetXY();
    var offsetX = ref[0];
    var offsetY = ref[1];
    this.tooltip.moveTo(offsetX + x, offsetY + y);
    return this.showTooltip(this.processor.getTooltipWithPath(keyPath));
  };

  Canvas.prototype.hideTooltip = function hideTooltip() {
    return this.tooltip.hide();
  }; // return screenshot as url string
  // to build an imagae from, just set the .src property of an <img> element


  Canvas.prototype.screenshot = function screenshot() {
    return this.canvasDom.toDataURL();
  };

  Canvas.prototype.setCursorType = function setCursorType(cursorType) {
    if (cursorType !== this.cursorType) {
      this.cursorType = cursorType;
      var cursorPrefix = "ng-cursor";
      var classList = this.el.className.split(' ');
      return this.el.className = classList.filter(function (x) {
        return !x.match(new RegExp("^" + cursorPrefix));
      }).concat(cursorPrefix + "-" + cursorType).join(' ');
    }
  }; //--------------------------------------------------------------------------------
  // RendererInterface
  //--------------------------------------------------------------------------------
  // get page offset of chart outer dom


  Canvas.prototype.chartOffsetXY = function chartOffsetXY() {
    var offset = this.outerDom.getBoundingClientRect();
    var ref = utils$3.pageScrollOffset();
    var top = ref.top;
    var left = ref.left;
    return [offset.left + left, offset.top + top];
  }; // Detach all mouse events to stop interaction


  Canvas.prototype.stopMouseInteraction = function stopMouseInteraction() {
    this.detachEvents();
  }; // Attach all mouse events to start interaction


  Canvas.prototype.startMouseInteraction = function startMouseInteraction() {
    this.attachEvents();
  }; // scroll callback
  // - set x, y offset


  Canvas.prototype.scrollTo = function scrollTo(x, y) {
    if (this.isAnimating()) {
      return;
    }

    if (this.model) {
      this.model.props.scrollOffset = [x, y];
    }

    return this.scrollOffset = [x, y];
  };

  Canvas.prototype.isInViewport = function isInViewport(size) {
    return utils$3.isElementInViewport(this.el, size);
  }; //--------------------------------------------------------------------------------
  // event handlers
  //--------------------------------------------------------------------------------


  Canvas.prototype.onScroll = function onScroll(e) {
    if (this.isAnimating()) {
      return;
    }

    var x = e.target.scrollLeft;
    var y = e.target.scrollTop;
    var ref = this.baseScrollOffset;
    var baseX = ref[0];
    var baseY = ref[1];
    var ref$1 = [x - baseX, y - baseY];
    var offsetX = ref$1[0];
    var offsetY = ref$1[1];
    this.processor.onScroll(offsetX, offsetY, e); // notify chart
  };

  Canvas.prototype.onTouchMove = function onTouchMove(e) {
    var touch = e.changedTouches[0];

    if (touch) {
      this.onMouseMove(touch);
    }
  };

  Canvas.prototype.onTouchStart = function onTouchStart(e) {
    var touch = e.changedTouches[0];

    if (touch) {
      this.onMouseDown(touch);
    }
  };

  Canvas.prototype.onTouchEnd = function onTouchEnd(e) {
    e.stopPropagation();
    e.preventDefault();
    var touch = e.changedTouches[0];

    if (touch) {
      this.onMouseUp(touch);
    }
  };

  Canvas.prototype.onMouseMove = function onMouseMove(e) {
    // still pass the event to chart when animating since we need
    // to track shape under cursor during animation
    var ref = this.page2ChartXY(e.pageX, e.pageY);
    var x = ref[0];
    var y = ref[1];
    this.processor.onMouseMove(x, y, e);
  };

  Canvas.prototype.onMouseDown = function onMouseDown(e) {
    var ref = this.page2ChartXY(e.pageX, e.pageY);
    var x = ref[0];
    var y = ref[1];
    this.processor.onMouseDown(x, y, e);
  };

  Canvas.prototype.onMouseUp = function onMouseUp(e) {
    var ref = this.page2ChartXY(e.pageX, e.pageY);
    var x = ref[0];
    var y = ref[1];
    this.processor.onMouseUp(x, y, e);
  };

  Canvas.prototype.onMouseLeave = function onMouseLeave(e) {
    var ref = this.page2ChartXY(e.pageX, e.pageY);
    var x = ref[0];
    var y = ref[1];
    this.processor.onMouseLeave(x, y, e);
  };

  Canvas.prototype.onKeyDown = function onKeyDown(e) {
    this.processor.onKeyDown(e.key, e);
  };

  Canvas.prototype.onKeyUp = function onKeyUp(e) {
    this.processor.onKeyUp(e.key, e);
  }; // given (x,y) on page cordinate
  // return the coordinates in the chart coodinate system


  Canvas.prototype.page2ChartXY = function page2ChartXY(pageX, pageY) {
    var ref = this.chartOffsetXY();
    var x = ref[0];
    var y = ref[1];
    return [pageX - x, pageY - y];
  };
  /**
  	 * Set if the renderer will draw the debug info
  	 * @param draw
  	 */


  Canvas.prototype.setDebugInfo = function setDebugInfo(options) {
    return this.ctx.setDebugInfo(options);
  };

  Canvas.initClass();
  var Canvas$1 = mixin([Accessible], Canvas); //-ignore

  var setStyles = utils$3.setStyles;
  var ARROW_PADDING = 8;
  var CIRCLE_OFFSET = 7.5;
  var HIDE_STYLE = {
    visibility: "hidden",
    display: "none"
  };
  var SHOW_STYLE = {
    visibility: "visible",
    display: "block"
  };
  var CIRCLE_CLASSNAME = "ng-annotate circle";
  var counter$2 = 0;

  var Annotation = function Annotation(chartEl) {
    this._id = counter$2++;
    this._chartEl = chartEl;
    this._annotationsContainerEl = this._chartEl.getElementsByClassName("ng-annotations-container")[0];
    this._style = document.createElement("style");
    document.head.appendChild(this._style);
    this.create(); // defaults

    this._backgroundColor = new Color("#193F61");
    this._borderColor = new Color("#193F61");
    this._isBlinking = false;
  };

  Annotation.prototype.setPadding = function setPadding(padding) {
    this._padding = padding;
    return this;
  };

  Annotation.prototype.getInstanceClassName = function getInstanceClassName() {
    return 'annotation-' + this._id;
  };

  Annotation.prototype.setPositions = function setPositions(positions) {
    this._positions = positions;
    return this;
  };

  Annotation.prototype.setShapeBox = function setShapeBox(shapeBox) {
    this._shapeBox = shapeBox;
    return this;
  };

  Annotation.prototype.setDefaultVisibility = function setDefaultVisibility(show) {
    if (show === void 0) show = true;

    if (show === this._defaultShow) {
      return this;
    }

    this._previousState = null;
    this._defaultShow = show;
    return this;
  };

  Annotation.prototype.getDefaultVisibility = function getDefaultVisibility() {
    return this._defaultShow;
  };

  Annotation.prototype.setData = function setData(data) {
    if (data == null) {
      return this;
    }

    this._data = data;
    return this;
  };

  Annotation.prototype.getData = function getData() {
    return this._data;
  };

  Annotation.prototype.setBorderColor = function setBorderColor(borderColor) {
    if (borderColor == null) {
      return this;
    }

    this._borderColor = new Color(borderColor);
    return this;
  };

  Annotation.prototype.setBackgroundColor = function setBackgroundColor(backgroundColor) {
    if (backgroundColor == null) {
      return this;
    }

    this._backgroundColor = new Color(backgroundColor);
    this._borderColor = this._backgroundColor;
    return this;
  };

  Annotation.prototype.setContent = function setContent(columns, text, theme, dataFormatter) {
    if (columns === void 0) columns = [];
    if (text === void 0) text = {};
    var prevColumn = this._columns;
    var prevText = this._text;
    this._columns = columns.filter(function (column) {
      return column != null;
    });
    this._text = text;
    var backgroundColor = this._backgroundColor;
    var borderColor = this._borderColor;
    var color = backgroundColor.toHighContrast(theme.getTextColorOnLight(), theme.getTextColorOnDark());

    if (this._defaultShow && (!lodash__default.isEqual(prevColumn, this._columns) || !lodash__default.isEqual(prevText, this._text))) {
      this._previousState = {
        circleEl: HIDE_STYLE,
        annotationEl: SHOW_STYLE
      };
    }

    if (!columns.length && !text.template) {
      setStyles(this._circleEl, SHOW_STYLE);
      setStyles(this._annotationEl, HIDE_STYLE);
      this._previousState = {
        circleEl: SHOW_STYLE,
        annotationEl: HIDE_STYLE
      };
    }

    this._formatColumns(dataFormatter);

    setStyles(this._annotationEl, {
      backgroundColor: backgroundColor.toRGBAString(),
      color: color.toRGBAString(),
      borderColor: borderColor.toRGBAString()
    });
    setStyles(this._annotationEl.getElementsByClassName("cross")[0], {
      backgroundColor: this._backgroundColor
    });
    setStyles(this._circleEl, {
      backgroundColor: backgroundColor.toRGBAString(),
      borderColor: borderColor.toRGBAString()
    });
    return this;
  };

  Annotation.prototype.setIsBlinking = function setIsBlinking(isBlinking) {
    if (isBlinking === void 0) isBlinking = false;
    this._isBlinking = isBlinking;

    if (isBlinking) {
      this._circleEl.className = CIRCLE_CLASSNAME + " blink";
    } else {
      this._circleEl.className = CIRCLE_CLASSNAME;
    }

    return this;
  };

  Annotation.prototype.setShouldUpdate = function setShouldUpdate(shouldUpdate) {
    this._shouldUpdate = shouldUpdate;
    return this;
  };

  Annotation.prototype.shouldUpdate = function shouldUpdate() {
    return this._shouldUpdate;
  };

  Annotation.prototype.getColumns = function getColumns() {
    return this._columns;
  };

  Annotation.prototype.getInfo = function getInfo() {
    return {
      row: this._data.row,
      measure: this._data.measure,
      properties: {
        column: this._columns.map(function (column) {
          return column.getName();
        }),
        borderColor: this._borderColor.toHex(),
        backgroundColor: this._backgroundColor.toHex(),
        defaultShow: this._defaultShow,
        text: this._text,
        isBlinking: this._isBlinking
      }
    };
  };

  Annotation.prototype.hasSetPosition = function hasSetPosition() {
    return !!this._coordinates;
  }; // create the els required to form the annotation


  Annotation.prototype.create = function create() {
    var this$1 = this;
    var ref = this;
    var _annotationEl = ref._annotationEl;
    var _circleEl = ref._circleEl;
    var _previousState = ref._previousState;

    if (!_circleEl) {
      var circleEl = document.createElement('div');
      circleEl.className = CIRCLE_CLASSNAME;

      this._annotationsContainerEl.appendChild(circleEl);

      this._circleEl = circleEl;
      circleEl.addEventListener('click', this._onClick.bind(this));
    } else if (_previousState) {
      setStyles(_circleEl, _previousState.circleEl);
    }

    if (!_annotationEl) {
      var annotationEl = document.createElement('div');
      annotationEl.className = "ng-annotate";

      this._annotationsContainerEl.appendChild(annotationEl);

      this._annotationEl = annotationEl;
      var contentEl = document.createElement('div');
      contentEl.className = "content";
      annotationEl.appendChild(contentEl);
      this._contentEl = contentEl;
      var crossEl = document.createElement('div');
      crossEl.className = "cross";
      crossEl.innerHTML = "X";
      annotationEl.appendChild(crossEl);
      annotationEl.addEventListener('click', this._onClick.bind(this));
      annotationEl.addEventListener('mouseenter', function (event) {
        setStyles(this$1._annotationEl, {
          "z-index": "9999",
          "box-shadow": "0 2px 3px 0 rgba(0, 0, 0, 0.16)"
        });
        setStyles(this$1._annotationEl.getElementsByClassName("cross")[0], {
          visibility: "visible"
        });
      });
      annotationEl.addEventListener('mouseleave', function (event) {
        setStyles(this$1._annotationEl, {
          "z-index": "3",
          "box-shadow": ""
        });
        setStyles(this$1._annotationEl.getElementsByClassName("cross")[0], {
          visibility: "hidden"
        });
      });
    } else if (_previousState) {
      setStyles(_annotationEl, _previousState.annotationEl);
    }

    return this;
  }; // find an appropriate place to position the annotation


  Annotation.prototype.positionAndShow = function positionAndShow() {
    var this$1 = this;
    var ref = this;
    var _annotationEl = ref._annotationEl;
    var _circleEl = ref._circleEl;
    var _defaultShow = ref._defaultShow;
    var _previousState = ref._previousState;
    var _positions = ref._positions;
    var _contentEl = ref._contentEl;
    this._coordinates = null;

    if (this._isInViewPort(this._shapeBox)) {
      // there is a wierd issue where the div doesnt overflow from the right edge if no width is set.
      // so we first get the width of the div when it is non wrapped
      var annDisplay = _annotationEl.style.display;
      setStyles(_annotationEl, {
        display: 'block'
      });
      setStyles(_contentEl, {
        "max-width": "",
        "white-space": "nowrap",
        "width": ""
      });
      var baseWidth = _contentEl.getBoundingClientRect().width + "px";
      setStyles(_contentEl, {
        "max-width": 3 * this._annotationsContainerEl.clientWidth / 4 - ARROW_PADDING + "px",
        "max-height": 3 * this._annotationsContainerEl.clientHeight / 4 - ARROW_PADDING + "px",
        "white-space": "normal",
        "width": baseWidth
      });
      var coords;
      var cx, cy;

      for (var i = 0; i < _positions.length; i++) {
        var ref$1 = _positions[i];
        var x = ref$1.x;
        var y = ref$1.y;
        var orientations = ref$1.orientations;
        x -= this$1._padding.left;
        y -= this$1._padding.top;

        for (var j = 0; j < orientations.length; j++) {
          var orientation = orientations[i];

          switch (orientation) {
            case "left":
              {
                coords = this$1._getHorizontalPosition({
                  x: x,
                  y: y
                }, "borderLeftColor", "right");
                break;
              }

            case "right":
              {
                coords = this$1._getHorizontalPosition({
                  x: x,
                  y: y
                }, "borderRightColor", "left");
                break;
              }

            case "top":
              {
                coords = this$1._getVerticalPosition({
                  x: x,
                  y: y
                }, "borderTopColor", "down");
                break;
              }

            case "bottom":
              {
                coords = this$1._getVerticalPosition({
                  x: x,
                  y: y
                }, "borderBottomColor", "up");
                break;
              }
          }

          if (coords) {
            cx = x - CIRCLE_OFFSET;
            cy = y - CIRCLE_OFFSET;
            break;
          }
        }

        if (coords) {
          break;
        }
      }

      setStyles(_annotationEl, {
        display: annDisplay
      });

      if (coords) {
        var x$1 = coords.x;
        var y$1 = coords.y;
        var arrow = coords.arrow;
        this._coordinates = {
          annotation: {
            top: y$1,
            left: x$1
          },
          circle: {
            top: cy,
            left: cx
          }
        };
        setStyles(_annotationEl, {
          top: y$1 + "px",
          left: x$1 + "px"
        });
        setStyles(_circleEl, {
          top: cy + "px",
          left: cx + "px"
        });

        if (!_previousState) {
          _previousState = {
            circleEl: _defaultShow ? HIDE_STYLE : SHOW_STYLE,
            annotationEl: _defaultShow ? SHOW_STYLE : HIDE_STYLE
          };
        }

        this._previousState = _previousState;
        setStyles(_annotationEl, _previousState.annotationEl);
        setStyles(_circleEl, _previousState.circleEl);
      }
    }

    if (!this._coordinates) {
      setStyles(_circleEl, HIDE_STYLE);
      setStyles(_annotationEl, HIDE_STYLE);
    }
  };

  Annotation.prototype.onScroll = function onScroll(newBox) {
    if (!this._isInViewPort(newBox) || !this._coordinates) {
      setStyles(this._annotationEl, HIDE_STYLE);
      setStyles(this._circleEl, HIDE_STYLE);
      return this;
    }

    var ref = this._shapeBox;
    var x = ref.x;
    var y = ref.y;
    var topDiff = newBox.y - y;
    var leftDiff = newBox.x - x;
    var ref$1 = this._coordinates;
    var annotation = ref$1.annotation;
    var circle = ref$1.circle;
    setStyles(this._annotationEl, {
      top: annotation.top + topDiff + "px",
      left: annotation.left + leftDiff + "px"
    });
    setStyles(this._circleEl, {
      top: circle.top + topDiff + "px",
      left: circle.left + leftDiff + "px"
    });
    var positionX = circle.left + leftDiff + CIRCLE_OFFSET + this._padding.left;
    var positionY = circle.top + topDiff + CIRCLE_OFFSET + this._padding.top;

    if (!this._isInViewPort({
      x: positionX,
      y: positionY,
      w: 0,
      h: 0
    })) {
      setStyles(this._annotationEl, HIDE_STYLE);
      setStyles(this._circleEl, HIDE_STYLE);
    } else {
      setStyles(this._annotationEl, this._previousState.annotationEl);
      setStyles(this._circleEl, this._previousState.circleEl);
    }

    return this;
  };

  Annotation.prototype.remove = function remove() {
    this._annotationsContainerEl.removeChild(this._annotationEl);

    this._annotationsContainerEl.removeChild(this._circleEl);
  };

  Annotation.prototype.setViewPort = function setViewPort(viewPort) {
    this._viewPort = viewPort;
    return this;
  }; //--------------------------------------------
  // private methods
  //--------------------------------------------


  Annotation.prototype._onClick = function _onClick(event) {
    if (!this._columns.length && !this._text.template) {
      return;
    }

    this._toggleVisibility(this._circleEl);

    this._toggleVisibility(this._annotationEl);

    this._previousState = {
      circleEl: {
        visibility: this._circleEl.style.visibility,
        display: this._circleEl.style.display
      },
      annotationEl: {
        visibility: this._annotationEl.style.visibility,
        display: this._annotationEl.style.display
      }
    };
  };

  Annotation.prototype._isInViewPort = function _isInViewPort(shapeBB) {
    var x = shapeBB.x;
    var y = shapeBB.y;
    var w = shapeBB.w;
    var h = shapeBB.h;
    var viewPort = this._viewPort; // due to some pixel issues, sometimes the x, y coordinates are outside the port with decimal point pixel difference.
    // so to offset that difference, use the ceil/floor value

    return !(Math.floor(x) > viewPort.x + viewPort.w || Math.floor(y) > viewPort.y + viewPort.h || Math.ceil(x + w) < viewPort.x || Math.ceil(y + h) < viewPort.y);
  };

  Annotation.prototype._formatColumns = function _formatColumns(dataFormatter) {
    var this$1 = this;
    var contentText = "";
    dataFormatter.formatAnnotation(this._data.row, this._columns, this._text).forEach(function (line) {
      switch (line.type) {
        case "text":
          contentText += "<div style='color:" + this$1._text.color + ";white-space:pre-line;'>" + escapeHtml(line.label) + "</div>";
          break;

        default:
          var text = "";

          if (line.label) {
            text += escapeHtml(line.label);
          }

          if (line.value) {
            text += ": " + escapeHtml(line.value);
          }

          contentText += "<div>" + text + "</div>";
      }
    });
    this._contentEl.innerHTML = contentText;
  };

  Annotation.prototype._getChartBB = function _getChartBB() {
    var chart = this._annotationsContainerEl;
    return {
      left: 0,
      right: chart.clientWidth,
      top: 0,
      bottom: chart.clientHeight
    };
  };

  Annotation.prototype._toggleVisibility = function _toggleVisibility(el) {
    var ref = el.style;
    var visibility = ref.visibility;
    var display = ref.display;
    setStyles(el, visibility === "hidden" ? SHOW_STYLE : HIDE_STYLE);
  }; // Due to rounding issues, sometimes the x,y calculated values are slightly above the edges of the viewport, so to offset,
  // we always compare with the ceil/floor value instead.
  // try to find a position on the left/right of a shape


  Annotation.prototype._getHorizontalPosition = function _getHorizontalPosition(coords, border, arrowClass) {
    this._annotationEl.className = ["ng-annotate", this.getInstanceClassName(), arrowClass].join(" ");
    var x = coords.x;
    var y = coords.y;

    var ref = this._getChartBB();

    var top = ref.top;
    var left = ref.left;
    var right = ref.right;
    var bottom = ref.bottom;

    var initialWdith = this._annotationEl.getBoundingClientRect().width;

    var maxPossibleWidth = (arrowClass === "left" ? right - x : x - left) - ARROW_PADDING;

    if (initialWdith >= right - left) {
      setStyles(this._annotationEl, {
        "max-width": Math.max(maxPossibleWidth, (right - left) / 2) - 2 * ARROW_PADDING + "px"
      });
    }

    var ref$1 = this._annotationEl.getBoundingClientRect();

    var width = ref$1.width;
    var height = ref$1.height;
    width += ARROW_PADDING;

    if (arrowClass === "right") {
      x -= width;
    }

    if (arrowClass === "left") {
      x += ARROW_PADDING;
    }

    y -= height / 2;
    var arrowtop = (height - ARROW_PADDING + 5) / 2;
    var canFit = false;

    if (Math.ceil(x) >= left && Math.floor(x + width) <= right && height <= bottom) {
      // it is fitting horizontally
      if (Math.ceil(y) >= top && Math.floor(y + height) <= bottom) {
        canFit = true;
      } else {
        var bottomOverflow = Math.max(y + height - bottom, 0);
        var upperOverflow = Math.min(y - top, 0);
        var overflow = bottomOverflow + upperOverflow;
        var y1 = y - overflow;

        if (Math.ceil(y1) >= top && Math.floor(y1 + height) <= bottom && Math.floor(y1) <= coords.y - ARROW_PADDING && Math.ceil(y1 + height) >= coords.y + ARROW_PADDING) {
          canFit = true;
          y = y1;
          arrowtop += overflow;
        }
      }
    }

    if (canFit) {
      this._resetStyleSheet();

      var cssClass = '.' + arrowClass;
      var borderType = arrowClass === "left" ? "right" : "left";

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'border-' + borderType + '-color: ' + this._borderColor.toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'border-color: ' + this._backgroundColor.adjustOpacity(0).toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'border-' + borderType + '-color: ' + this._backgroundColor.toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'border-color: ' + this._borderColor.adjustOpacity(0).toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'top: ' + arrowtop + "px" + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'top: ' + arrowtop + "px" + " } ", 0);

      var crossStyle = arrowClass === "left" ? {
        top: '0px',
        right: '0px'
      } : {
        top: '0px',
        left: '0px'
      };
      setStyles(this._annotationEl.getElementsByClassName("cross")[0], crossStyle);
      return {
        x: x,
        y: y
      };
    }

    setStyles(this._contentEl, {
      "max-width": 3 * this._annotationsContainerEl.clientWidth / 4 - ARROW_PADDING + "px"
    });
    return null;
  }; // try to find a position on the top/bottom of a shape


  Annotation.prototype._getVerticalPosition = function _getVerticalPosition(coords, border, arrowClass) {
    this._annotationEl.className = ["ng-annotate", this.getInstanceClassName(), arrowClass].join(" ");
    var x = coords.x;
    var y = coords.y;

    var ref = this._getChartBB();

    var top = ref.top;
    var left = ref.left;
    var right = ref.right;
    var bottom = ref.bottom;

    var initialHeight = this._annotationEl.getBoundingClientRect().height;

    var maxPossibleHeight = (arrowClass === "up" ? bottom - y : y - top) - 2 * ARROW_PADDING;

    var ref$1 = this._annotationEl.getBoundingClientRect();

    var width = ref$1.width;
    var height = ref$1.height;

    if (height >= bottom - top) {
      setStyles(this._annotationEl, {
        "max-height": Math.max(maxPossibleHeight, (bottom - top) / 2) + "px"
      });
    }

    height += ARROW_PADDING;

    if (arrowClass === "down") {
      y -= height;
    }

    if (arrowClass === "up") {
      y += ARROW_PADDING;
    }

    var arrowleft = (width - ARROW_PADDING + 5) / 2;
    x -= width / 2;
    var canFit = false;

    if (Math.ceil(y + ARROW_PADDING / 2) >= top && Math.floor(y + height) <= bottom && width <= right) {
      // it fits vertically and the width can be contained
      if (Math.ceil(x) >= left && Math.floor(x + width) <= right) {
        // it fits horizontally
        canFit = true;
      } else {
        // left                right
        // |         x          | rightOverflow
        // |---------|----------|----| x+w
        var leftOverFlow = Math.min(x - left, 0);
        var rightOverflow = Math.max(x + width - right, 0);
        var overflow = rightOverflow + leftOverFlow;
        var x1 = x - overflow;

        if (Math.ceil(x1) >= left && Math.floor(x1 + width) <= right && Math.floor(x1) <= coords.x - ARROW_PADDING && Math.ceil(x1 + width) >= coords.x + ARROW_PADDING) {
          canFit = true;
          x = x1;
          arrowleft += overflow;
        }
      }
    }

    if (canFit) {
      this._resetStyleSheet();

      var cssClass = '.' + arrowClass;
      var borderType = arrowClass === "up" ? "bottom" : "top";

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'border-' + borderType + '-color: ' + this._borderColor.toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'border-color: ' + this._backgroundColor.adjustOpacity(0).toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'border-' + borderType + '-color: ' + this._backgroundColor.toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'border-color: ' + this._borderColor.adjustOpacity(0).toRGBAString() + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':after' + " { " + 'left: ' + arrowleft + "px" + " } ", 0);

      this._style.sheet.insertRule("." + this.getInstanceClassName() + cssClass + ':before' + " { " + 'left: ' + arrowleft + "px" + " } ", 0);

      var crossStyle = arrowClass === "up" ? {
        right: '0px',
        bottom: '0px'
      } : {
        right: '0px',
        top: '0px'
      };
      setStyles(this._annotationEl.getElementsByClassName("cross")[0], crossStyle);
      return {
        x: x,
        y: y
      };
    }

    setStyles(this._contentEl, {
      "max-height": 3 * this._annotationsContainerEl.clientHeight / 4 - ARROW_PADDING + "px"
    });
    return null;
  };

  Annotation.prototype._resetStyleSheet = function _resetStyleSheet() {
    var this$1 = this;

    while (this._style.sheet.cssRules.length) {
      this$1._style.sheet.deleteRule(0);
    }
  }; //

  /**
   * Created by yi.chen on 11/16/16.
   */
  //@flow-ignore


  var View = function View(options) {
    this._isRemoved = false;
    this._renderer = Renderer.getInstance();
    this._imageLoaderDelegate = new ViewImageLoaderDelegate(this);
    this._canvas = new Canvas$1(lodash__default.extend({}, options, {
      imageLoaderDelegate: this._imageLoaderDelegate
    }));
  };

  View.prototype.createCustomDOM = function createCustomDOM() {
    return this._canvas.createCustomDOM();
  };

  View.prototype.removeCustomDOM = function removeCustomDOM(el) {
    return this._canvas.removeCustomDOM(el);
  };
  /**
  	 * Update model in the view
  	 * @param model
  	 * @param options
  	 * @param callback to invode when update action is done
  	 */


  View.prototype.update = function update(model, options, callback) {
    this._canvas.update(model, options);

    this._renderer.render(this._canvas, model, options).then(callback);
  };
  /**
  	 * Redraw the view
  	 */


  View.prototype.redraw = function redraw() {
    return this._renderer.render(this._canvas, this._canvas.getModel(), {
      duration: 0,
      triggerEvent: false
    });
  };
  /**
  	 * @return true if the view is currently animating
  	 */


  View.prototype.isAnimating = function isAnimating() {
    return this._canvas.getTweener().isAnimating;
  };
  /**
  	 * @return true if the view has been removed
  	 */


  View.prototype.isRemoved = function isRemoved() {
    return this._isRemoved;
  };
  /**
  	 * Reset the view
  	 */


  View.prototype.reset = function reset() {
    this._canvas.getTweener().reset();

    return this;
  };
  /**
  	 * Remove this view
  	 */


  View.prototype.remove = function remove() {
    this._isRemoved = true;

    this._canvas.remove();

    return this;
  };
  /**
  	 * Scroll the view to the given x, y location
  	 * @param x
  	 * @param y
  	 */


  View.prototype.scrollTo = function scrollTo(x, y, callback) {
    this._canvas.scrollTo(x, y);

    return this.redraw().then(callback);
  };
  /**
  	 * Show the view
  	 */


  View.prototype.show = function show() {
    this._canvas.show();

    return this;
  };
  /**
  	 * Hide the view
  	 */


  View.prototype.hide = function hide() {
    this._canvas.hide();

    return this;
  };
  /**
  	 * Compute chart offset on page
  	 */


  View.prototype.chartOffsetXY = function chartOffsetXY() {
    return this._canvas.chartOffsetXY() || [0, 0];
  };

  View.prototype.getScrollOffset = function getScrollOffset() {
    return this._canvas.getScrollOffset();
  };
  /**
  	 * If this view is inside the window viewport
  	 */


  View.prototype.isInViewport = function isInViewport(size) {
    return this._canvas.isInViewport(size);
  };

  View.prototype.getElement = function getElement() {
    return this._canvas.getElement();
  };

  View.prototype.getAnnotation = function getAnnotation() {
    return new Annotation(this.getElement());
  };
  /**
  	 * Get the root element of the view
  	 */


  View.prototype.getEventListeningElement = function getEventListeningElement() {
    return this._canvas.getEventListeningElement();
  };

  View.prototype.getElementOffset = function getElementOffset() {
    return this._canvas.getElementOffset();
  }; //--------------------------------------------
  // public (Interaction)
  //--------------------------------------------

  /**
  	 * Enable mouse interaction
  	 */


  View.prototype.startMouseInteraction = function startMouseInteraction() {
    this._canvas.startMouseInteraction();

    return this;
  };
  /**
  	 * Disable mouse interaction
  	 */


  View.prototype.stopMouseInteraction = function stopMouseInteraction() {
    this._canvas.stopMouseInteraction();

    return this;
  };
  /**
  	 * Capture the current screen and encode into strings
  	 */


  View.prototype.screenshot = function screenshot() {
    return this._canvas.screenshot();
  }; //--------------------------------------------
  // public (Tooltip)
  //--------------------------------------------

  /**
  	 * If this view can display tooltip
  	 */


  View.prototype.hasTooltip = function hasTooltip() {
    return true;
  };
  /**
  	 * Show the tooltip with the given content
  	 * @param lines
  	 */


  View.prototype.showTooltip = function showTooltip(lines) {
    this._canvas.showTooltip(lines);

    return this;
  };
  /**
  	 * Show the tooltip with info given
  	 * @param fullText
  	 * @param angle
  	 * @param positions
  	 * @param shapeOffset
  	 */


  View.prototype.showTruncationTooltip = function showTruncationTooltip(fullText, angle, positions, shapeOffset) {
    this._canvas.showTruncationTooltip(fullText, angle, positions, shapeOffset);

    return this;
  };
  /**
  	 * Hide the tooltip
  	 */


  View.prototype.hideTooltip = function hideTooltip() {
    this._canvas.hideTooltip();

    return this;
  };
  /**
  	 * Move the tooltip to the cursor position
  	 */


  View.prototype.moveTooltip = function moveTooltip() {
    this._canvas.moveTooltip();

    return this;
  };
  /**
  	 * If this view supports accessibility features
  	 */


  View.prototype.supportAccessibility = function supportAccessibility() {
    return true;
  };
  /**
  	 * Reset all the accessibility elements
  	 */


  View.prototype.resetAccessibility = function resetAccessibility() {
    this._canvas.resetAccessibility();

    return this;
  };
  /**
  	 * Render the accessibility table
  	 */


  View.prototype.renderAccessibilityTable = function renderAccessibilityTable(table) {
    this._renderer.renderAccessibilityTable(this._canvas, table);

    return this;
  };
  /**
  	 * Render the accessibility items that can be tabbed on
  	 */


  View.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems() {
    this._renderer.renderAccessibilityDataItems(this._canvas);

    return this;
  };
  /**
  	 * Set the cursor type
  	 * @param cursorType
  	 */


  View.prototype.setCursorType = function setCursorType(cursorType) {
    this._canvas.setCursorType(cursorType);

    return this;
  };
  /**
  	 * Set if the renderer will draw the debug info
  	 * @param draw
  	 */


  View.prototype.setDebugInfo = function setDebugInfo(options) {
    this._canvas.setDebugInfo(options);

    return this;
  };
  /**
  	 * If the renderer needs a serialized model
  	 */


  View.prototype.requestSerializedModels = function requestSerializedModels() {
    return false;
  }; //
  //@flow-ignore

  /**
   * Find the greatest commond divisor of two numbers
   */


  function gcd(num1, num2) {
    var gn = num1,
        ln = num2;

    if (num1 < num2) {
      gn = num2;
      ln = num1;
    }

    if (gn % ln === 0) {
      return ln;
    } else {
      return gcd(ln, gn % ln);
    }
  }
  /**
   * Find the least common multiple of two numbers
   */


  function lcm(num1, num2) {
    var gcdValue = gcd(num1, num2);
    return gcdValue * (num1 / gcdValue) * (num2 / gcdValue);
  }
  /**
   Wait for a condition
   @param conditionFct conditionFct that returns a boolean
   @param options timeout, failOnTimeout, pollInterval and errorMessage
  */


  function waitFor(conditionFct, ref) {
    var timeout = ref.timeout;
    var failOnTimeout = ref.failOnTimeout;
    if (failOnTimeout === void 0) failOnTimeout = true;
    var pollInterval = ref.pollInterval;
    if (pollInterval === void 0) pollInterval = 10;
    var errorMessage = ref.errorMessage;
    return new es6Promise.Promise(function (resolve, reject) {
      var timeoutHandle;
      var intervalHandle; // set a timeout if we have a timeout value

      if (timeout != null) {
        timeoutHandle = setTimeout(function () {
          clearInterval(intervalHandle);

          if (failOnTimeout) {
            reject(errorMessage || "Timed out for waitFor");
          } else {
            resolve();
          }
        }, timeout);
      } // check the condition every pollInterval ms


      intervalHandle = setInterval(function () {
        if (conditionFct()) {
          if (timeoutHandle != null) {
            clearTimeout(timeoutHandle);
          }

          if (intervalHandle != null) {
            clearInterval(intervalHandle);
          }

          resolve();
        }
      }, pollInterval);
    });
  } // Canvas base delegate
  //
  // Refer to the class DelegateInterface for a list of all the methods needed to be implemented
  // we need a base context to be able to get the size of text elements


  var ctx;

  function initializeCtx() {
    if (ctx == null) {
      ctx = document.createElement("canvas").getContext("2d");
      ctx.font = utils$3.getFont(commonConstants.FONT.SIZE);
      textUtils.getInstance().setTextDelegate(ctx);
    }
  }

  function isDocumentReady() {
    return document.readyState === "complete";
  } // We are going to wait for the font to be loaded
  //
  // The approach is to simply try to render a '9' and see if the size  matches the sfdc-sans size
  // By default, a 9 has a width of less than 7 pixels. Sfdc-sans is wider (> 7 pixels)
  //
  // Since loading the font could fail, we are only going to wait for 500ms


  function isFontLoaded() {
    initializeCtx();
    var measureText = ctx.measureText(commonConstants.FONT.LOADING_TEST.TEXT);
    return measureText && measureText.width > commonConstants.FONT.LOADING_TEST.WIDTH;
  }

  var Delegate$1 = function (DelegateInterfac____1) {
    function Delegate() {
      DelegateInterfac____1.apply(this, arguments);
    }

    if (DelegateInterfac____1) Delegate.__proto__ = DelegateInterfac____1;
    Delegate.prototype = Object.create(DelegateInterfac____1 && DelegateInterfac____1.prototype);
    Delegate.prototype.constructor = Delegate;

    Delegate.prototype.ready = function ready() {
      return waitFor(isDocumentReady, {
        timeout: commonConstants.DOCUMENT_READY_MAX_DELAY,
        errorMessage: "Timeout for document.readyState == 'complete'"
      }).then(function () {
        return waitFor(isFontLoaded, {
          failOnTimeout: false,
          timeout: commonConstants.FONT.LOADING_TEST.MAX_DELAY
        });
      });
    };

    Delegate.prototype.getRenderer = function getRenderer(ref) {
      var processor = ref.processor;
      var config = ref.config;
      var isLegend = ref.isLegend;
      var tooltip = ref.tooltip;
      return new View({
        processor: processor,
        config: config,
        isLegend: isLegend,
        tooltip: tooltip
      });
    }; //--------------------------------------------------------------------------------
    // dynamic loading
    //--------------------------------------------------------------------------------


    Delegate.prototype.require = function require(fileName) {
      return xhr.request({
        url: fileName,
        isSync: false
      });
    }; //--------------------------------------------------------------------------------
    // font sizing
    //--------------------------------------------------------------------------------


    Delegate.prototype.getTextWidth = function getTextWidth(txt, size) {
      if (size == null) {
        size = commonConstants.FONT.SIZE;
      }

      var sizeRatio = size / commonConstants.FONT.SIZE;
      return sizeRatio * textUtils.getInstance().getTextWidth(txt);
    };

    Delegate.prototype.getTruncatedText = function getTruncatedText(txt, maxWidth, size) {
      if (size == null) {
        size = commonConstants.FONT.SIZE;
      }

      var sizeRatio = size / commonConstants.FONT.SIZE;
      return textUtils.getInstance().getTruncatedText(txt, maxWidth / sizeRatio);
    };

    Delegate.prototype.getRealFontSize = function getRealFontSize(size) {
      // on the desktop all font sizes are supported
      return size;
    };

    Delegate.prototype.isPointInStroke = function isPointInStroke(drawPathFct, x, y) {
      drawPathFct(ctx);
      return ctx.isPointInStroke(x, y);
    };

    Delegate.prototype.fontInfo = function fontInfo() {
      return {
        SIZE_ASCENDER: 0.25,
        SIZE_DESCENDER: 0.2
      };
    };

    return Delegate;
  }(DelegateInterface);

  var webDelegateInstance = new Delegate$1();

  var ServiceProvider = function ServiceProvider() {};

  ServiceProvider.prototype.setDelegate = function setDelegate(delegate) {
    this._delegate = delegate;
  };

  ServiceProvider.prototype.getDelegate = function getDelegate() {
    return this._delegate || webDelegateInstance;
  };

  var ServiceProvider$1 = singleton(ServiceProvider).getInstance();
  var TWEENABLE_PROPERTIES$1 = [// currently supported
  "x", "y", "w", "h", "dx", "dy", "r", "rotation", "textRotation", "opacity", "fill", "stroke", "textColor", "textX", "textY", "r1", "r2", "textR", "angle", "startAngle", "lineWidth", "points_x", "points_y", "animate_points_x", "animate_points_y", "bg", "cornerRadius", "fontSize", "number", "dashed", "texture", "baseX", "baseY"];

  var ShapeModel = function (NodeMode____1) {
    function ShapeModel() {
      NodeMode____1.apply(this, arguments);
    }

    if (NodeMode____1) ShapeModel.__proto__ = NodeMode____1;
    ShapeModel.prototype = Object.create(NodeMode____1 && NodeMode____1.prototype);
    ShapeModel.prototype.constructor = ShapeModel;

    ShapeModel.prototype.tweenRemove = function tweenRemove(ctx) {
      return this.fadeOut(this.getEndModelRemove(ctx));
    }; // insert shape to layer0 and apply proper tweens according to
    // transition scenario:
    // 1. layer0 -> current layer, and shape gets inserted
    // 2. current layer gets inserted(layer0 is null)


    ShapeModel.prototype.tweenInsert = function tweenInsert(ctx) {
      return this.fadeIn(this.getStartModelInsert(ctx));
    }; // update shape layout to shape1 and apply proper tweens


    ShapeModel.prototype.tweenUpdate = function tweenUpdate(shape1) {
      this.props.bb0 = this.props.bb;

      if (this.props.type === shape1.props.type) {
        this.tween(null, shape1.props);
      }

      return this;
    }; // compute tweens for shape transition


    ShapeModel.prototype.tween = function tween(startProps, endProps, unionKeys) {
      var this$1 = this;
      if (unionKeys === void 0) unionKeys = false;
      var from, to, tweenProps;
      var tweens = {};

      if (startProps) {
        tweenProps = unionKeys ? dataUtils.uniq(lodash__default.keys(startProps).concat(lodash__default.keys(this.props))) : lodash__default.keys(startProps);
        from = startProps;
        to = this.props;
      } else if (endProps) {
        tweenProps = unionKeys ? dataUtils.uniq(lodash__default.keys(this.props).concat(lodash__default.keys(endProps))) : lodash__default.keys(endProps);
        from = this.props;
        to = endProps;
      } else {
        return this;
      }

      tweenProps.forEach(function (prop) {
        var v0 = from[prop];
        var v1 = to[prop];

        if (v0 !== v1) {
          if (lodash__default.indexOf(TWEENABLE_PROPERTIES$1, prop) != -1) {
            if (prop === "fontSize") {
              var noFontSizeTweening = (startProps != null ? startProps.isTruncated : undefined) || (endProps != null ? endProps.isTruncated : undefined);

              if (noFontSizeTweening) {
                this$1.props[prop] = v1;
              } else if (!tweens[prop]) {
                tweens[prop] = [v0, v1];
              }
            } else if (prop === "texture") {
              // we are only going to animate the shade
              if ((v0 != null ? v0.shade : undefined) === (v1 != null ? v1.shade : undefined)) {
                this$1.props[prop] = v1;
              } else if (!tweens[prop]) {
                tweens[prop] = [v0, v1];
              }
            } else if ((v0 != null ? v0.isEqual : undefined) != null && !v0.isEqual(v1)) {
              tweens[prop] = [v0, v1];
            } else if ((lodash__default.isObject(v1) || lodash__default.isObject(v0)) && lodash__default.isEqual(v0, v1)) {// nested properties... let's do a deep equal test
            } else if (!tweens[prop]) {
              tweens[prop] = [v0, v1];
            }
          } else {
            this$1.props[prop] = v1;
          }
        }
      });

      if (!lodash__default.isEmpty(tweens)) {
        this.tweens = tweens;
      }

      return this;
    };

    ShapeModel.prototype.fadeIn = function fadeIn(startModel) {
      if (startModel == null) {
        startModel = {};
      }

      startModel.opacity = 0;
      this.tween(startModel, null);
      return this;
    };

    ShapeModel.prototype.fadeOut = function fadeOut(endModel) {
      if (endModel == null) {
        endModel = {};
      }

      endModel.opacity = 0;
      this.tween(null, endModel);
      return this;
    }; // override in subclass
    // returns phantom endModel when removing a shape


    ShapeModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      var oldParent = ctx.oldParent;
      var newParent = ctx.newParent;
      var scales0 = oldParent && oldParent.props.scales;
      var scales1 = newParent != null ? newParent.get('scales') : undefined;

      if (!scales1 || !scales0) {
        return null;
      }

      return this._getTweensByScale(scales0, scales1);
    }; // override in subclass
    // returns phantom startModel when creating a shape


    ShapeModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      var oldParent = ctx.oldParent;
      var newParent = ctx.newParent;
      var scales0 = oldParent && oldParent.props.scales;
      var scales1 = newParent != null ? newParent.get('scales') : undefined;

      if (!scales1 || !scales0) {
        return null;
      }

      return this._getTweensByScale(scales1, scales0);
    }; // return array of tweens by scale field


    ShapeModel.prototype._getTweensByScale = function _getTweensByScale(scales0, scales1) {
      var this$1 = this;
      var tweens = {};

      for (var scaleName in this$1.props.propertiesByScale) {
        var properties = this$1.props.propertiesByScale[scaleName];
        var s1 = scales1[scaleName];
        var s0 = scales0[scaleName];

        if (s0 && s1) {
          properties.forEach(function (prop) {
            if (this$1.props[prop] != null) {
              var val = this$1.props[prop];
              tweens[prop] = lodash__default.isArray(val) ? val.map(function (v) {
                return scales.transpose(v, s1, s0);
              }) : scales.transpose(val, s1, s0);
            }
          });
        }
      }

      this._handleRotation(tweens, scales0, scales1);

      return tweens;
    };

    ShapeModel.prototype._handleRotation = function _handleRotation(tweens, scales0, scales1) {
      // the x/y fields of the rotation object (containing angle, x, y) should follow
      // the exact same tweening rules as the x/y fields of the shape
      if (this.props.rotation) {
        var hasX = scales0.x && scales1.x;
        var hasY = scales0.y && scales1.y;

        if (hasX || hasY) {
          if (!tweens.rotation) {
            tweens.rotation = lodash__default.clone(this.props.rotation);
          }

          if (hasX) {
            tweens.rotation.x = scales.transpose(tweens.rotation.x, scales1.x, scales0.x);
          }

          if (hasY) {
            return tweens.rotation.y = scales.transpose(tweens.rotation.y, scales1.y, scales0.y);
          }
        }
      }
    };

    return ShapeModel;
  }(NodeModel);

  var TextModel = function (ShapeMode____1) {
    function TextModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) TextModel.__proto__ = ShapeMode____1;
    TextModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    TextModel.prototype.constructor = TextModel;
    return TextModel;
  }(ShapeModel); //
  //@flow-ignore


  var extend = lodash__default.extend;

  function pathable(ClassDef) {
    return function (ClassDef) {
      function PathShape() {
        ClassDef.apply(this, arguments);
      }

      if (ClassDef) PathShape.__proto__ = ClassDef;
      PathShape.prototype = Object.create(ClassDef && ClassDef.prototype);
      PathShape.prototype.constructor = PathShape;

      PathShape.prototype.tweenUpdate = function tweenUpdate(shape1) {
        ClassDef.prototype.tweenUpdate.call(this, shape1);
        this.props.bb0 = this.props.bb;

        if (this.props.type !== shape1.props.type && this.getNumVertices() !== -1 && shape1.getNumVertices() !== -1) {
          var numInterpolation = lcm(this.getNumVertices(), shape1.getNumVertices());
          var pathProperties = this.getPathProps(numInterpolation, this.props);

          if (pathProperties) {
            extend(this.props, pathProperties);
          }

          this.tween(null, extend({}, shape1.props, shape1.getPathProps(numInterpolation, shape1.props)), true);
          shape1.tweens = this.tweens;
          return shape1;
        }

        return this;
      };

      PathShape.prototype.getPathProps = function getPathProps(nVertices, props) {
        return null;
      };

      PathShape.prototype.getNumVertices = function getNumVertices() {
        return -1;
      };

      PathShape.prototype._sampleLine = function _sampleLine(x0, y0, x1, y1, nVertices) {
        var pointsX = [];
        var pointsY = [];

        for (var i = 0; i < nVertices; ++i) {
          var factor = 1 / nVertices;
          pointsX.push(x0 + factor * i * (x1 - x0));
          pointsY.push(y0 + factor * i * (y1 - y0));
        }

        return [pointsX, pointsY];
      };

      PathShape.prototype._sampleCurve = function _sampleCurve(startAngle, angle, r, clockwise, nVertices) {
        var pointsX = [];
        var pointsY = [];
        var angleInc = angle / nVertices;

        for (var i = 0; i < nVertices; ++i) {
          var currentAngle = clockwise ? startAngle + angleInc * i : startAngle + angle - angleInc * i;
          pointsX.push(r * Math.cos(currentAngle));
          pointsY.push(r * Math.sin(currentAngle));
        }

        return [pointsX, pointsY];
      };

      return PathShape;
    }(ClassDef);
  } //


  var TextMorphingModel = pathable(TextModel);
  var colorFactory$1 = ColorFactory$1.getInstance();
  var black = colorFactory$1.getColor("#000");
  var modelPropsByScale = {
    x: ["x"],
    y: ["y"]
  };

  var __super__$3 = Object.getPrototypeOf(Text$1.prototype);

  lodash__default.extend(Text$1.prototype, {
    //-----------------------------------------------------------------------------------------
    // interaction - tooltip
    //-----------------------------------------------------------------------------------------
    // Provides two potential position for truncation text tooltip
    //    _____________
    //    | Long text | (2)
    //    -------------
    //    __________
    //    | Lo...t |
    //    ----------
    //    _____________
    //    | Long text |  (1)
    //    -------------
    truncationTooltipPositions: function truncationTooltipPositions() {
      var ref = this.getTextXY();
      var x = ref[0];
      var y = ref[1]; // adjust tooltip origin to align with text top left

      x -= 6;
      y -= this.getTextH() + 1; // calculate two potential tooltip position, on above, on below

      var offset = this.getTextH() + 6;
      var ref$1 = geometryUtils.rotate([x, y + offset], this.getRotation());
      var x0 = ref$1[0];
      var y0 = ref$1[1];
      var ref$2 = geometryUtils.rotate([x, y - offset], this.getRotation());
      var x1 = ref$2[0];
      var y1 = ref$2[1];
      return [[null, x0, y0], [null, x1, y1]];
    },
    //-----------------------------------------------------------------------------------------
    // to model
    //-----------------------------------------------------------------------------------------
    getModelProps: function getModelProps() {
      var ref = this.applyShapeEffects();
      var stroke = ref.stroke;
      var bgColor = ref.bgColor;
      var fill = stroke || black;
      var fontSize = ServiceProvider$1.getDelegate().getRealFontSize(this._props.size);
      var rotation = this.getRotation();
      var ref$1 = this.getTextXY();
      var x = ref$1[0];
      var y = ref$1[1];
      var bg = bgColor ? {
        color: bgColor,
        box: this.trueBoundingBox().toArray()
      } : null;
      var maxWidth = this._hasFixedWidth() || this.isTruncated() ? this._maxTextWidth : undefined;
      return lodash__default.extend(this.getCommonModelProps(), {
        x: x,
        y: y,
        propertiesByScale: modelPropsByScale,
        text: this._props.text,
        fontSize: fontSize,
        fill: fill,
        rotation: rotation,
        bg: bg,
        maxWidth: maxWidth,
        halign: this._props.halign
      });
    },
    toModel: function toModel() {
      return __super__$3.toModel.call(this, TextMorphingModel);
    }
  });

  Text$1.fromJson = function (json, deepCopy) {
    if (deepCopy == null) {
      deepCopy = true;
    }

    var shape = __super__$3.constructor.fromJson.call(this, json, deepCopy);

    if (json && json.props) {
      shape._props.padding = Padding.fromJson(json.props.padding, deepCopy);
    }

    return shape;
  };

  var colorFactory = ColorFactory$1.getInstance();
  var DEFAULT_COLORS = {
    color: colorFactory.getColor(constants$1.HOTSPOT.COLOR),
    bgColor: colorFactory.getColor(constants$1.HOTSPOT.BG_COLOR),
    hoverColor: colorFactory.getColor(constants$1.HOTSPOT.HOVER_COLOR),
    hoverBgColor: colorFactory.getColor(constants$1.HOTSPOT.HOVER_BG_COLOR)
  };

  var HotSpot = function HotSpot(ref) {
    var key = ref.key;
    var icon = ref.icon;
    var box = ref.box;
    var name = ref.name;
    var colors = ref.colors;
    var manager = ref.manager;
    this.key = key;
    this.box = box;
    this.name = name;
    this.manager = manager;
    this.icon = icon != null ? icon[0] : undefined;
    this.colors = colors || {};
    lodash__default.defaults(this.colors, DEFAULT_COLORS);
    this._reRenderOnHover = !(this.colors.color.isEqual(this.colors.hoverColor) && this.colors.bgColor.isEqual(this.colors.hoverBgColor));
  }; // Returns renderable shape(currently Text) representing hotSpot icon
  // @returns {Text}


  HotSpot.prototype.getShape = function getShape() {
    if (this._shape == null) {
      this._shape = this._computeShape();
    }

    return this._shape;
  }; // Returns hotSpot info
  // - which is a new copy, so there is no reference to the hotSpot object
  // - box position relative to scene
  //
  // @returns {Object} hotSpot info
  //                  {String} name
  //                  {Box} box of hotSpot relative to scene's coordinate


  HotSpot.prototype.getInfo = function getInfo() {
    return this.manager.getHotSpotInfo(this);
  };

  HotSpot.prototype._computeShape = function _computeShape() {
    var ref = this.box.getCenter();
    var cx = ref[0];
    var cy = ref[1];
    var ref$1 = this.box.toJson();
    var w = ref$1.w;
    var h = ref$1.h;
    var iconShape = new Text$1({
      key: this.key + "_" + this.name + "_hotSpot",
      text: this.icon,
      x: cx,
      y: cy,
      maxWidth: w,
      bgColor: this.colors.bgColor,
      size: Math.min(h, w) - 4,
      padding: {
        top: 1,
        bottom: 2
      },
      valign: "middle",
      halign: "center",
      stroke: this.colors.color,
      canHover: false,
      canSelect: false,
      skipInFind: true
    });

    if (this.box.hasRotation()) {
      var ref$2 = this.box.rotation;
      var x = ref$2.x;
      var y = ref$2.y;
      var angle = ref$2.angle;
      iconShape.set({
        pivot: [x, y],
        angle: angle
      });
    }

    return iconShape;
  }; // Detects whether hotSpot is under cursor


  HotSpot.prototype.isUnderCursor = function isUnderCursor(x, y) {
    return this.box.contains(x, y);
  }; // Update icon shape style when onhover


  HotSpot.prototype.hover = function hover() {
    if (this._reRenderOnHover) {
      var shape = this.getShape();
      shape.set({
        stroke: this.colors.hoverColor,
        bgColor: this.colors.hoverBgColor
      });
      return true;
    }

    return false;
  }; // Update icon shape style when unhover


  HotSpot.prototype.unhover = function unhover() {
    if (this._reRenderOnHover) {
      var shape = this.getShape();
      shape.set({
        stroke: this.colors.color,
        bgColor: this.colors.bgColor
      });
      return true;
    }

    return false;
  };

  var HotSpotManager = function HotSpotManager(ref) {
    var this$1 = this;
    var hotSpots = ref.hotSpots;
    var host = ref.host;
    this.host = host;
    this.hotSpots = {};
    this._hotSpotShapes = null;
    this._hostParent = this.host.getLayer();
    var box = this.host.trueBoundingBox();
    hotSpots.forEach(function (hotSpot) {
      var name = hotSpot.name;
      var position = hotSpot.position;
      var icon = hotSpot.icon;
      var size = hotSpot.size;
      var colors = hotSpot.colors;

      if (size == null) {
        size = 10;
      }

      this$1.hotSpots[name] = new HotSpot({
        key: this$1.host.key,
        box: box.getRelativeBox(position, size),
        icon: icon,
        name: name,
        colors: colors,
        manager: this$1
      });
    });
  }; // @returns {HotSpot} hotSpot under coordinate x, y


  HotSpotManager.prototype.getHotSpotUnderCursor = function getHotSpotUnderCursor(x, y) {
    var this$1 = this;

    for (var name in this$1.hotSpots) {
      var hotSpot = this$1.hotSpots[name];

      if (hotSpot.isUnderCursor(x, y)) {
        return hotSpot;
      }
    }

    return null;
  }; // Returns hotSpot info
  // - which is a new copy, so there is no reference to the hotSpot object
  // - box position relative to scene
  //
  // @returns {Object} hotSpot fnfo
  //                  {String} name
  //                  {Box} box of hotSpot relative to scene's coordinate


  HotSpotManager.prototype.getHotSpotInfo = function getHotSpotInfo(hotSpot) {
    var box = (ref = hotSpot.box.clone()).offset.apply(ref, this.host.totalTranslation(true, true) || []);

    var scene = this._hostParent.getScene();

    if (scene) {
      box.offset.apply(box, scene.get("position") || []);
    }

    return {
      name: hotSpot.name,
      box: box
    };
    var ref;
  }; // Get all renderable shapes representing hotSpot icons


  HotSpotManager.prototype._getHotSpotShapes = function _getHotSpotShapes() {
    if (this._hotSpotShapes == null) {
      this._hotSpotShapes = lodash__default.values(this.hotSpots).map(function (hotSpot) {
        return hotSpot.getShape();
      });
    }

    return this._hotSpotShapes;
  }; // Hover will append all hotspots icons to shape's parent


  HotSpotManager.prototype.hover = function hover() {
    var this$1 = this;

    this._getHotSpotShapes().forEach(function (shape) {
      this$1._hostParent.append(shape);
    });
  }; // Hover will remove all hotspots icons


  HotSpotManager.prototype.unhover = function unhover() {
    this._getHotSpotShapes().forEach(function (shape) {
      shape.removeFromParent();
    });
  }; //
  //@flow-ignore


  var __super__$5 = Object.getPrototypeOf(Layer.prototype);

  lodash__default.extend(Layer.prototype, {
    isBrushLayer: function isBrushLayer() {
      return false;
    },
    //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------
    findShapeUnderPos: function findShapeUnderPos(x, y) {
      var props = this._props;

      if (props.viewport) {
        // if there is a viewport, make sure we only look *inside* the viewport
        var ref = props.viewport;
        var _x = ref[0];
        var _y = ref[1];
        var _w = ref[2];
        var _h = ref[3];
        var viewportBox = new Box({
          x: _x - props.x,
          y: _y - props.y,
          w: _w,
          h: _h
        });

        if (!viewportBox.contains(x, y)) {
          return null;
        }
      }

      return __super__$5.findShapeUnderPos.call(this, x, y);
    },
    toScenePosition: function toScenePosition(x, y) {
      var cell = this.getParent();
      var ref = this.translation();
      var tx = ref[0];
      var ty = ref[1];
      return !cell ? [x + tx, y + ty] : cell.toScenePosition(x + tx, y + ty);
    },
    toLocalPosition: function toLocalPosition(x, y) {
      var cell = this.getParent();
      var ref = this.translation();
      var tx = ref[0];
      var ty = ref[1];
      return !cell ? [x - tx, y - ty] : cell.toLocalPosition(x - tx, y - ty);
    },
    //-----------------------------------------------------------------------------------------
    // selection
    //-----------------------------------------------------------------------------------------
    select: function select() {
      if (this._props.interactive) {
        this._originalZIndex = this._props.zIndex;
        this.set({
          zIndex: Shape.INTERACTION_ZINDEX++
        });
      }

      return this;
    },
    unselect: function unselect() {
      if (this._props.interactive && this._originalZIndex != null) {
        this.set({
          zIndex: this._originalZIndex
        });
        this._originalZIndex = undefined;
      }

      return this;
    },
    resetSelect: function resetSelect() {
      if (this._props.interactive && this._originalZIndex != null) {
        this.set({
          zIndex: this._originalZIndex
        });
        this._originalZIndex = undefined;
      }

      return this;
    },
    _sortChildren: function _sortChildren() {
      if (this._props.interactive) {
        this._children = lodash__default.sortBy(this._children, function (child) {
          return child.get("zIndex");
        });
      }

      __super__$5._sortChildren.call(this);

      return this;
    },
    //-----------------------------------------------------------------------------------------
    // from/to
    //-----------------------------------------------------------------------------------------
    // TODO alice - type for model props, json
    getModelProps: function getModelProps() {
      return {
        type: this.getType(),
        key: this._props.key,
        zIndex: this._props.zIndex,
        tx: this._props.x,
        ty: this._props.y,
        staggerAnim: this._props.staggerAnim,
        scales: this._props.scales,
        viewport: this._props.viewport,
        accessibility: this._props.accessibility,
        canScroll: this._props.canScroll
      };
    }
  });

  Layer.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;

    var layer = __super__$5.constructor.fromJson.call(this, json, deepCopy, Layer);

    var scalesJson = json.props && json.props.scales;

    if (scalesJson) {
      var nodeScales = {};

      if (!deepCopy) {
        scalesJson = dataUtils.deepCopy(scalesJson);
      }

      for (var name in scalesJson) {
        nodeScales[name] = scales.fromJson(scalesJson[name]);
      }

      layer._props.scales = nodeScales;
    }

    return layer;
  };

  Layer._roundProps = new StaticArraySet(["x", "y"]); //

  var ShapeMorphingModel = pathable(ShapeModel);
  /**
  	Composite shape effect that applies an array of effects to a shape, from left to right,
  	each effect acting on the state outputed from the previous effect
  
  	@author ppominville
  */

  var CompositeShapeEffect = function (ShapeEffec____1) {
    function CompositeShapeEffect(effects) {
      ShapeEffec____1.call(this);
      this._effects = effects;
    }

    if (ShapeEffec____1) CompositeShapeEffect.__proto__ = ShapeEffec____1;
    CompositeShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    CompositeShapeEffect.prototype.constructor = CompositeShapeEffect;

    CompositeShapeEffect.prototype.applyEffect = function applyEffect(props, interactionState) {
      var flowFcts = this._effects.map(function (effect) {
        return function (props) {
          return effect.applyEffect(props, interactionState);
        };
      });

      return dataUtils.flow(flowFcts)(props, interactionState);
    };

    return CompositeShapeEffect;
  }(ShapeEffect);

  CompositeShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("CompositeShapeEffect", options);
  };

  var DEFAULT_HALO_OPACITY = 0.4;
  var DEFAULT_HALO_WIDTH = 10;
  /**
  	Effect that adds a "halo" around a shape when the shape is selected
  
  	@author ppominville
  */

  var HaloSelectionShapeEffect = function (ShapeEffec____1) {
    function HaloSelectionShapeEffect(ref) {
      if (ref === void 0) ref = {};
      var haloOpacity = ref.haloOpacity;
      if (haloOpacity === void 0) haloOpacity = DEFAULT_HALO_OPACITY;
      var haloWidth = ref.haloWidth;
      if (haloWidth === void 0) haloWidth = DEFAULT_HALO_WIDTH;
      ShapeEffec____1.call(this);
      this._haloOpacity = haloOpacity;
      this._haloWidth = haloWidth;
    }

    if (ShapeEffec____1) HaloSelectionShapeEffect.__proto__ = ShapeEffec____1;
    HaloSelectionShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    HaloSelectionShapeEffect.prototype.constructor = HaloSelectionShapeEffect;

    HaloSelectionShapeEffect.prototype.applyEffect = function applyEffect(props, ref) {
      var selectState = ref.selectState;
      var stroke = props.stroke;
      var lineWidth = props.lineWidth;
      var fill = props.fill;

      if (selectState != null && selectState === constants$1.SELECT_STATE.TRUE) {
        stroke = fill.adjustOpacity(this._haloOpacity);
        lineWidth = this._haloWidth;
      }

      return lodash__default.extend(props, {
        stroke: stroke,
        lineWidth: lineWidth
      });
    };

    return HaloSelectionShapeEffect;
  }(ShapeEffect);

  HaloSelectionShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("HaloSelectionShapeEffect", options);
  };

  var DEFAULT_RADIUS_SCALING_FACTOR = 0.9;
  var DEFAULT_APPLY_TO_STATE = constants$1.SELECT_STATE.FALSE;
  var RADIUS_PROPS = ["r", "r1", "r2", "textR"];
  /**
  	Effect that scales the radius of a shape for a given selection state
  
  	@author ppominville
  */

  var RadiusScalingSelectionShapeEffect = function (ShapeEffec____1) {
    function RadiusScalingSelectionShapeEffect(ref) {
      if (ref === void 0) ref = {};
      var radiusScalingFactor = ref.radiusScalingFactor;
      if (radiusScalingFactor === void 0) radiusScalingFactor = DEFAULT_RADIUS_SCALING_FACTOR;
      var applyToState = ref.applyToState;
      if (applyToState === void 0) applyToState = DEFAULT_APPLY_TO_STATE;
      ShapeEffec____1.call(this);
      this._radiusScalingFactor = radiusScalingFactor;
      this._applyToState = applyToState;
    }

    if (ShapeEffec____1) RadiusScalingSelectionShapeEffect.__proto__ = ShapeEffec____1;
    RadiusScalingSelectionShapeEffect.prototype = Object.create(ShapeEffec____1 && ShapeEffec____1.prototype);
    RadiusScalingSelectionShapeEffect.prototype.constructor = RadiusScalingSelectionShapeEffect;

    RadiusScalingSelectionShapeEffect.prototype.applyEffect = function applyEffect(props, ref) {
      var selectState = ref.selectState;

      if (selectState != null && selectState === this._applyToState) {
        RADIUS_PROPS.map(function (propName) {
          var value = props[propName];

          if (value != null) {
            props[propName] = value * DEFAULT_RADIUS_SCALING_FACTOR;
          }
        });
      }

      return props;
    };

    return RadiusScalingSelectionShapeEffect;
  }(ShapeEffect);

  RadiusScalingSelectionShapeEffect.getDescriptor = function (options) {
    return ShapeEffect.getDescriptorForType("RadiusScalingSelectionShapeEffect", options);
  };

  var shapeEffectClasses = [ShapeEffect, DefaultHoverShapeEffect, CompositeShapeEffect, DefaultSelectionShapeEffect, HaloSelectionShapeEffect, RadiusScalingSelectionShapeEffect, HighlightHoverShapeEffect];
  var instance$6 = null;
  var shapeEffects = {};

  function createShapeEffectInstance(ref) {
    if (ref === void 0) ref = {};
    var type = ref.type;
    var options = ref.options;
    var shapeEffectClass = shapeEffects[type] || ShapeEffect;
    return new shapeEffectClass(options);
  }
  /**
  	Factory for shape effects
  
  	@author ppominville
  */


  var ShapeEffectFactory = function ShapeEffectFactory() {};

  ShapeEffectFactory.getInstance = function getInstance() {
    if (!instance$6) {
      instance$6 = new ShapeEffectFactory();
      shapeEffectClasses.forEach(function (shapeEffect) {
        return shapeEffects[shapeEffect.getDescriptor().type] = shapeEffect;
      });
    }

    return instance$6;
  };

  ShapeEffectFactory.prototype.getShapeEffect = function getShapeEffect(effect) {
    var this$1 = this;

    if (Array.isArray(effect)) {
      return new CompositeShapeEffect(effect.map(function (singleEffect) {
        return this$1.getShapeEffect(singleEffect);
      }));
    } else {
      return createShapeEffectInstance(effect);
    }
  }; //
  //@flow-ignore


  var shapeEffectFactoryInst = ShapeEffectFactory.getInstance();
  var commonProps = ["key", "opacity", "type", "zIndex", "bgColor", "accessibility"];
  var imageCache$3 = ImageCache$1.getInstance();

  var __super__$4 = Object.getPrototypeOf(Shape.prototype);

  var HotSpotManager$2;
  Shape.prototype._select = constants$1.SELECT_STATE.NONE;
  Shape.prototype._isOnhover = false; // zindex that is above all other zindexes

  Shape.INTERACTION_ZINDEX = 1000000000;
  lodash__default.extend(Shape.prototype, {
    _trueBoundingBox: undefined,
    _select: undefined,
    _isOnhover: undefined,
    _hotSpotMgr: undefined,
    getInteractionEntity: function getInteractionEntity() {
      var self = this;

      while (true) {
        var parent = self.getParent();

        if (!parent || parent instanceof Layer) {
          break;
        }

        self = parent;
      }

      return self;
    },
    //-----------------------------------------------------------------------------------------
    // hotSpot
    //-----------------------------------------------------------------------------------------
    hasHotSpots: function hasHotSpots() {
      return this._props.hotSpots != null;
    },
    getHotSpotManager: function getHotSpotManager() {
      if (this._hotSpotMgr == null) {
        this._hotSpotMgr = new HotSpotManager$2({
          host: this,
          hotSpots: this._props.hotSpots
        });
      }

      return this._hotSpotMgr;
    },
    findHotSpotUnderPos: function findHotSpotUnderPos(x, y) {
      if (!this.hasHotSpots()) {
        return null;
      }

      var ref = this.totalTranslation(true, true);
      var tx = ref[0];
      var ty = ref[1];
      x -= tx;
      y -= ty;
      return this.getHotSpotManager().getHotSpotUnderCursor(x, y);
    },
    //-----------------------------------------------------------------------------------------
    // interaction - shape detection
    //-----------------------------------------------------------------------------------------
    // returns true/false, whether a shape is under coordinate (x, y)
    isUnderCursor: function isUnderCursor(x, y) {
      return this.trueBoundingBox().contains(x, y);
    },
    isInArea: function isInArea(x, y, w, h) {
      return this.trueBoundingBox().intersect(x, y, w, h);
    },
    isUnderLine: function isUnderLine(x0, y0, x1, y1) {
      return false;
    },
    findShapeUnderPos: function findShapeUnderPos() {
      return this;
    },
    findShapesInArea: function findShapesInArea(x, y, w, h) {
      return [this];
    },
    findShapeUnderLine: function findShapeUnderLine(x0, y0, x1, y1) {
      return this;
    },
    //-----------------------------------------------------------------------------------------
    // interaction - mouse over
    //-----------------------------------------------------------------------------------------
    cross: function cross() {
      this._isCrossed = true;
      return this;
    },
    uncross: function uncross() {
      this._isCrossed = false;
      return this;
    },
    hover: function hover() {
      this._isOnhover = true;
      this.markAsModified();

      if (this._props.interactive) {
        this._originalZIndex = this._props.zIndex;
        this.set({
          zIndex: Shape.INTERACTION_ZINDEX++
        });
      }

      if (this.hasHotSpots()) {
        this.getHotSpotManager().hover();
      }

      return this;
    },
    unhover: function unhover() {
      this._isOnhover = false;
      this.markAsModified();

      if (this.hasHotSpots()) {
        this.getHotSpotManager().unhover();
      }

      if (this._props.interactive && this._originalZIndex != null) {
        this.set({
          zIndex: this._originalZIndex
        });
        this._originalZIndex = undefined;
      }

      return this;
    },
    extendHoverArea: function extendHoverArea() {
      this._isHoverAreaExtended = true;
      return this;
    },
    restoreHoverArea: function restoreHoverArea() {
      this._isHoverAreaExtended = false;
      return this;
    },
    tabOn: function tabOn() {
      this._isOnhover = true;
      this.set('accessibility', lodash__default.extend({}, this.get('accessibility'), {
        showTooltip: true
      }));
      return this;
    },
    tabOff: function tabOff() {
      this._isOnhover = false;
      this.set('accessibility', lodash__default.extend({}, this.get('accessibility'), {
        showTooltip: false
      }));
      return this;
    },
    //-----------------------------------------------------------------------------------------
    // interaction
    //-----------------------------------------------------------------------------------------
    getSelectedState: function getSelectedState() {
      return this._select;
    },
    isSelected: function isSelected() {
      return this._select === constants$1.SELECT_STATE.TRUE;
    },
    select: function select() {
      this._select = constants$1.SELECT_STATE.TRUE;
      this.markAsModified();
      return this;
    },
    unselect: function unselect() {
      this._select = constants$1.SELECT_STATE.FALSE;
      this.markAsModified();
      return this;
    },
    resetSelect: function resetSelect() {
      this._select = constants$1.SELECT_STATE.NONE;
      this.markAsModified();
      return this;
    },
    applyShapeEffects: function applyShapeEffects() {
      var props = lodash__default.pick(this._props, this.constructor.shapeEffectsProps);

      if (props.texture != null) {
        props.texture = this._getTexture();
      }

      var effect = shapeEffectFactoryInst.getShapeEffect([this._props.selectionShapeEffect, this._props.hoverShapeEffect]);
      var res = effect.applyEffect(props, {
        hoverState: this._isOnhover ? constants$1.HOVER_STATE.TRUE : constants$1.HOVER_STATE.FALSE,
        selectState: this._select
      });
      return res;
    },
    toModel: function toModel(modelClass) {
      return __super__$4.toModel.call(this, modelClass || ShapeMorphingModel);
    },
    // return texture if it is defined, otherwise return undefined
    // it also makes sure that the texture has a style
    _getTexture: function _getTexture() {
      var texture = this._props.texture; // flow-ignore is needed since flow doesn't know that this._props has a texture field

      if (texture && texture.url) {
        var url = imageCache$3.validateUrl(texture.url);

        if (url) {
          return {
            shade: 0,
            fit: texture.fit || constants$1.TEXTURE.FIT.COVER,
            url: url
          };
        } else {
          if (log$1.images) {
            console.log("Image:: rejected url", texture.url);
          }

          return undefined;
        }
      } else {
        return undefined;
      }
    },
    getTranslatedBox: function getTranslatedBox() {
      var box = (ref = this.trueBoundingBox().clone()).offset.apply(ref, this.totalTranslation(true, true));
      var layer = this.getLayer();

      if (layer) {
        var scene$1 = layer.getScene();

        if (scene$1) {
          box.offset.apply(box, scene$1.get("position"));
        }
      }

      return box;
      var ref;
    },
    // Returns shape info
    // - which is a new copy, so there is no reference to the shape object
    // - box position relative to scene
    //
    // @return {Object} shape info
    //                {Object} data
    //                {String} key
    //                {Box} shape bounding box relative to scene's coordinate
    getInfo: function getInfo() {
      var data = this._props.data;
      return {
        data: data ? {
          column: data.column,
          row: rowsUtils$1.getRowWithoutInternalValue(data.row)
        } : data,
        key: this.key,
        box: this.getTranslatedBox()
      };
    },
    getAnnotationInfo: function getAnnotationInfo() {
      return {
        positions: [],
        shouldUpdate: false
      };
    },
    getCommonModelProps: function getCommonModelProps() {
      var this$1 = this;
      var props = {};
      commonProps.forEach(function (propName) {
        if (this$1._props[propName] != null) {
          props[propName] = this$1._props[propName];
        }
      });
      props.bb = (this._props.bb || this.boundingBox()).toArray();
      props.type = this.getType();
      props.opacity = this._props.opacity;

      if (this._props.zIndex) {
        props.zIndex = this._props.zIndex;
      }

      if (this._props.accessibility) {
        props.accessibility = this._props.accessibility;
      }

      return props;
    }
  });

  Shape.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    return __super__$4.constructor.fromJson.call(this, json, deepCopy);
  };

  Shape.setHotSpotManagerImpl = function (HotSpotManagerImpl) {
    HotSpotManager$2 = HotSpotManagerImpl;
  }; //

  /**
   * Decoration Layer handles the transforms of objects that are dynamically added
   * to it. It also provides with the mapping from world space to layer local space.
   * Namely, you can query a shape which falls under the cursor position.
   *
   * Created by yi.chen on 5/30/17.
   */


  var TRANSFORM = constants$1.TRANSFORM;

  var DecorationLayer = function (Laye____1) {
    function DecorationLayer(props, silent) {
      Laye____1.call(this, props, silent);
      this._transforms = [];
    }

    if (Laye____1) DecorationLayer.__proto__ = Laye____1;
    DecorationLayer.prototype = Object.create(Laye____1 && Laye____1.prototype);
    DecorationLayer.prototype.constructor = DecorationLayer;
    /**
     * @override
     * @returns {ILayer}
     */

    DecorationLayer.prototype.rotate = function rotate() {
      this._transforms.push(TRANSFORM.ROTATE);

      return Laye____1.prototype.rotate.call(this);
    };
    /**
     * @override
     * @returns {ILayer}
     */


    DecorationLayer.prototype.flipX = function flipX() {
      this._transforms.push(TRANSFORM.FLIP_X);

      return Laye____1.prototype.flipX.call(this);
    };
    /**
     * @override
     * @returns {ILayer}
     */


    DecorationLayer.prototype.flipY = function flipY() {
      this._transforms.push(TRANSFORM.FLIP_Y);

      return Laye____1.prototype.flipY.call(this);
    };
    /**
     * Is the layer under the cursor (in local coordinates)
     * @override
     * @param x
     * @param y
     * @returns {boolean}
     */


    DecorationLayer.prototype.isUnderCursor = function isUnderCursor(x, y) {
      var ref = this.toNormalizedPosition(x, y);
      var _x = ref[0];
      var _y = ref[1];
      var ref$1 = this._props;
      var w = ref$1.w;
      var h = ref$1.h;
      return (w >= 0 ? _x >= 0 && _x < w : _x <= 0 && _x > w) && (h >= 0 ? _y >= 0 && _y < h : _y <= 0 && _y > h);
    };
    /**
     * Transform the coordinate system from the global system to layer system (non-transformed)
     * @param x
     * @param y
     */


    DecorationLayer.prototype.toNormalizedPosition = function toNormalizedPosition(x, y) {
      return this._toNormalizedPosition(x, y, this._transforms);
    };
    /**
     * Transform the coordinate system from the layer system to layer system (transformed)
     * @param x
     * @param y
     */


    DecorationLayer.prototype.toTransformedPosition = function toTransformedPosition(x, y) {
      return this._toTransformedPosition(x, y, this._transforms);
    };

    DecorationLayer.prototype.notifyShapeChanged = function notifyShapeChanged() {
      this._transformShapes();
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    DecorationLayer.prototype._setDefaultProps = function _setDefaultProps() {
      Laye____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.w = 0;
      props.h = 0;
      props.staggerAnim = false;
      props.decorationType = "";
      props.refContainerKeys = [];
    };
    /**
     * The shapes added or updated will be in the non-transformed space
     * This method will transform them accordingly
     * @returns {Array<IShape>}
     */


    DecorationLayer.prototype._transformShapes = function _transformShapes() {
      var this$1 = this;
      var shapes = this.getChildren();
      var transforms = this._transforms;

      for (var i = 0; i < transforms.length; ++i) {
        var transform = transforms[i];

        switch (transform) {
          case TRANSFORM.ROTATE:
            shapes.forEach(function (s) {
              return s.rotate();
            });

            if (this$1._brushArea) {
              this$1._brushArea.rotateTextDirection();
            }

            break;

          case TRANSFORM.FLIP_X:
            shapes.forEach(function (s) {
              return s.flipX();
            });
            break;

          case TRANSFORM.FLIP_Y:
            shapes.forEach(function (s) {
              return s.flipY();
            });
            break;
        }
      }

      return shapes;
    };
    /**
     * Local positions are the non-transformed space where the origin lies in the top left corner
     * @param x
     * @param y
     * @param transforms
     */


    DecorationLayer.prototype._toNormalizedPosition = function _toNormalizedPosition(x, y, transforms) {
      var _x = x,
          _y = y;

      for (var i = transforms.length - 1; i >= 0; --i) {
        var transform = transforms[i];

        switch (transform) {
          case TRANSFORM.FLIP_X:
            _x = -_x;
            break;

          case TRANSFORM.FLIP_Y:
            _y = -_y;
            break;

          case TRANSFORM.ROTATE:
            var temp = _x;
            _x = -_y;
            _y = temp;
            break;
        }
      }

      return [_x, _y];
    };
    /**
     * Global positions are the transformed space. However, here we did not offset by the cell's offset
     * @param x
     * @param y
     * @param transforms
     */


    DecorationLayer.prototype._toTransformedPosition = function _toTransformedPosition(x, y, transforms) {
      var _x = x,
          _y = y;

      for (var i = 0; i < transforms.length; ++i) {
        var transform = transforms[i];

        switch (transform) {
          case TRANSFORM.FLIP_X:
            _x = -_x;
            break;

          case TRANSFORM.FLIP_Y:
            _y = -_y;
            break;

          case TRANSFORM.ROTATE:
            var temp = _x;
            _x = _y;
            _y = -temp;
            break;
        }
      }

      return [_x, _y];
    };

    return DecorationLayer;
  }(Layer);

  DecorationLayer.type = "Layer";
  DecorationLayer._roundProps = new StaticArraySet(["x", "y"]);
  DecorationLayer._sensitiveProps = new StaticArraySet(["scales"]);

  var RectModel = function (ShapeMode____1) {
    function RectModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) RectModel.__proto__ = ShapeMode____1;
    RectModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    RectModel.prototype.constructor = RectModel;

    RectModel.prototype._getTweensByScale = function _getTweensByScale(scales0, scales1) {
      var s0, s1, stretchDim, stretchText;
      var ref = this.props;
      var x = ref.x;
      var y = ref.y;
      var stretchX = ref.stretchX;
      var stretchY = ref.stretchY;
      var rotation = ref.rotation;
      var tweens = {};

      if ((s0 = scales0.x) && (s1 = scales1.x)) {
        tweens.x = scales.transpose(x, s1, s0);

        if (stretchX) {
          stretchDim = rotation != null ? "h" : "w";
          tweens[stretchDim] = scales.transpose(x + this.props[stretchDim], s1, s0) - tweens.x;
          stretchText = rotation != null ? "textY" : "textX";
          tweens[stretchText] = scales.transpose(x + this.props[stretchText], s1, s0) - tweens.x;
        }
      }

      if ((s0 = scales0.y) && (s1 = scales1.y)) {
        tweens.y = scales.transpose(y, s1, s0);

        if (stretchY) {
          stretchDim = rotation != null ? "w" : "h";
          tweens[stretchDim] = scales.transpose(y + this.props[stretchDim], s1, s0) - tweens.y;
          stretchText = rotation != null ? "textX" : "textY";
          tweens[stretchText] = scales.transpose(y + this.props[stretchText], s1, s0) - tweens.y;
        }
      }

      this._handleRotation(tweens, scales0, scales1);

      return tweens;
    };

    RectModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        x: this.props.x + this.props.w / 2,
        y: this.props.y + this.props.h / 2,
        w: 0,
        h: 0
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    RectModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        x: this.props.x,
        y: this.props.y,
        w: this.props.w * 1.5,
        h: this.props.h * 1.5
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    return RectModel;
  }(ShapeModel); //


  var BasePathableRectModel = pathable(RectModel);
  /*::(x: RectMorphingModel) => (x: IPathable<RectModelProperties>)*/

  var RectMorphingModel = function (BasePathableRectModel) {
    function RectMorphingModel() {
      BasePathableRectModel.apply(this, arguments);
    }

    if (BasePathableRectModel) RectMorphingModel.__proto__ = BasePathableRectModel;
    RectMorphingModel.prototype = Object.create(BasePathableRectModel && BasePathableRectModel.prototype);
    RectMorphingModel.prototype.constructor = RectMorphingModel;

    RectMorphingModel.prototype.getPathProps = function getPathProps(nVertices, props) {
      var w = props.w;
      var h = props.h;

      if (w != null && h != null) {
        var pointsPerSide = Math.floor(nVertices / 4);

        var ref = this._sampleLine(0, 0, w, 0, pointsPerSide + (nVertices % 4 > 0 ? 1 : 0));

        var xs1 = ref[0];
        var ys1 = ref[1];

        var ref$1 = this._sampleLine(w, 0, w, h, pointsPerSide + (nVertices % 4 > 1 ? 1 : 0));

        var xs2 = ref$1[0];
        var ys2 = ref$1[1];

        var ref$2 = this._sampleLine(w, h, 0, h, pointsPerSide + (nVertices % 4 > 2 ? 1 : 0));

        var xs3 = ref$2[0];
        var ys3 = ref$2[1];

        var ref$3 = this._sampleLine(0, h, 0, 0, pointsPerSide);

        var xs4 = ref$3[0];
        var ys4 = ref$3[1];
        return {
          animate_points_x: xs1.concat(xs2).concat(xs3).concat(xs4),
          animate_points_y: ys1.concat(ys2).concat(ys3).concat(ys4)
        };
      } else {
        return null;
      }
    };

    RectMorphingModel.prototype.getNumVertices = function getNumVertices() {
      return 4;
    };

    return RectMorphingModel;
  }(BasePathableRectModel); // - textCenter: whether to center text in rectangle or show text on edge
  // - textHorizontal: whether to keep text shown horizontal regarless of rectangle's own vertical property
  // - textInside: only display text if it fits inside rectangle
  // - textCenter
  // - textRotate
  // - cornerRadius
  //
  // +------------------------------->
  // |
  // |		(x,y)
  // |		+----------------+
  // |		|                | h
  // |		|                |
  // |		+----------------+(x+w, y+h)
  // |				w
  // v
  // 1) stretchX = false, stretchY = false
  // When stretchX is false, scale only x so that the width of the rectangle remains same
  // When stretchY is false, scale only y so that the height of the rectangle remains same
  // +------------------------------->
  // |
  // |
  // |				(x',y')
  // |				+----------------+
  // |				|                | h
  // |				|                |
  // |				+----------------+(x'+w, y'+h)
  // |						w
  // v
  //
  // 2) stretchX = true, stretchY = true
  // When stretchX is true, scale both x and x1 changing the width of the rectangle
  // When stretchY is true, scale both y and y1 changing the height of the rectangle
  // +------------------------------->
  // |
  // |
  // |
  // |
  // |	(x',y')
  // |	+--------------------------------+
  // |	|                                |
  // |	|                                |
  // |	|                                | h'
  // |	|                                |
  // |	|                                |
  // |	+--------------------------------+(x'+w', y'+h')
  // |					w'
  // v


  var Rect$3 = function (Shap____1) {
    function Rect() {
      Shap____1.apply(this, arguments);
    }

    if (Shap____1) Rect.__proto__ = Shap____1;
    Rect.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Rect.prototype.constructor = Rect;

    Rect.initClass = function initClass() {
      this.type = "Rect";
      this.shapeEffectsProps = ["fill", "stroke", "texture"];
    }; // we don't round x/y/w/h to not accumulate rounding error (when stacking...)
    // we only round them when we draw a stroke around the rectangle (so the stroke lines are clean 1 pixel lines)


    Rect.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.vertical = false;
      props.textInside = false;
      props.textCenter = true;
      props.textRotate = false;
      props.cornerRadius = 0;
      props.x = 0;
      props.y = 0;
      props.w = 0;
      props.h = 0;
      props.stroke = undefined;
      props.fill = undefined;
      props.text = undefined;
      props.textColorLight = undefined;
      props.textColorDark = undefined;
      props.stretchX = true;
      props.stretchY = false;
      props.lineWidth = 1;
      props.dashed = 0;
      return props.texture = undefined;
    };

    Rect.prototype.set = function set(props, value, silent) {
      this._forceRecomputeBoundingBox();

      return Shap____1.prototype.set.call(this, props, value, silent);
    };

    Rect.prototype.getRotation = function getRotation() {
      if (this._props.vertical) {
        return {
          x: this._props.stroke ? Math.round(this._props.x) : this._props.x,
          y: this._props.stroke ? Math.round(this._props.y) : this._props.y,
          angle: -Math.PI / 2
        };
      } else {
        return null;
      }
    };

    Rect.prototype.applyScales = function applyScales(scales) {
      if (scales == null) {
        scales = {};
      }

      var ref = this._props;
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      var stretchX = ref.stretchX;
      var stretchY = ref.stretchY;
      var xScale = scales.x;
      var yScale = scales.y;
      var propMap = {};

      if (xScale != null) {
        propMap.x = xScale.scale(x);

        if (stretchX) {
          propMap.w = xScale.scale(x + w) - propMap.x;
        }
      }

      if (yScale != null) {
        propMap.y = yScale.scale(y);

        if (stretchY) {
          propMap.h = yScale.scale(y + h) - propMap.y;
        }
      }

      this.set(propMap);
      return this;
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Rect.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      // not adding rotation here because x,y,w,h is already the post rotation result
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: this._props.w,
        h: this._props.h
      }).padAll(this._props.stroke ? this._props.lineWidth / 2 : 0);
    };

    Rect.prototype.domainBox = function domainBox() {
      var w = this._props.stretchX ? this._props.w : 0;
      var h = this._props.stretchY ? this._props.h : 0;
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: w,
        h: h
      });
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Rect.prototype.offsetY = function offsetY(dy) {
      Shap____1.prototype.offsetY.call(this, dy);
      this._props.y += dy;
      return this;
    };

    Rect.prototype.offsetX = function offsetX(dx) {
      Shap____1.prototype.offsetX.call(this, dx);
      this._props.x += dx;
      return this;
    };

    Rect.prototype.rotate = function rotate() {
      Shap____1.prototype.rotate.call(this);
      this._props.vertical = !this._props.vertical;
      var assign;
      assign = [this._props.y, -this._props.x, this._props.h, -this._props.w, this._props.stretchY, this._props.stretchX], this._props.x = assign[0], this._props.y = assign[1], this._props.w = assign[2], this._props.h = assign[3], this._props.stretchX = assign[4], this._props.stretchY = assign[5];
      return this;
    };

    Rect.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x", "w"],
        y: ["y", "h"]
      };
    };

    return Rect;
  }(Shape);

  Rect$3.initClass(); // - textCenter: whether to center text in rectangle or show text on edge
  // - textHorizontal: whether to keep text shown horizontal regarless of rectangle's own vertical property
  // - textInside: only display text if it fits inside rectangle
  // - textCenter
  // - textRotate
  // - cornerRadius
  //
  // +------------------------------->
  // |
  // |		(x,y)
  // |		+----------------+
  // |		|                | h
  // |		|                |
  // |		+----------------+(x+w, y+h)
  // |				w
  // v
  // 1) stretchX = false, stretchY = false
  // When stretchX is false, scale only x so that the width of the rectangle remains same
  // When stretchY is false, scale only y so that the height of the rectangle remains same
  // +------------------------------->
  // |
  // |
  // |				(x',y')
  // |				+----------------+
  // |				|                | h
  // |				|                |
  // |				+----------------+(x'+w, y'+h)
  // |						w
  // v
  //
  // 2) stretchX = true, stretchY = true
  // When stretchX is true, scale both x and x1 changing the width of the rectangle
  // When stretchY is true, scale both y and y1 changing the height of the rectangle
  // +------------------------------->
  // |
  // |
  // |
  // |
  // |	(x',y')
  // |	+--------------------------------+
  // |	|                                |
  // |	|                                |
  // |	|                                | h'
  // |	|                                |
  // |	|                                |
  // |	+--------------------------------+(x'+w', y'+h')
  // |					w'
  // v

  var __super__$7 = Object.getPrototypeOf(Rect$3.prototype);

  lodash__default.extend(Rect$3.prototype, {
    //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------
    _computeTrueBoundingBox: function _computeTrueBoundingBox() {
      // not adding rotation here because x,y,w,h is already the post rotation result
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: this._props.w,
        h: this._props.h
      }).padAll(this._props.stroke ? this._props.lineWidth / 2 : 0);
    },
    domainBox: function domainBox() {
      var w = this._props.stretchX ? this._props.w : 0;
      var h = this._props.stretchY ? this._props.h : 0;
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: w,
        h: h
      });
    },
    getAnnotationInfo: function getAnnotationInfo() {
      var ref = this.getTranslatedBox();
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      var orientations;

      if (this._props.textCenter) {
        x += w / 2;
        y += h / 4;
        orientations = ["right", "top", "bottom", "left"];
      } else if (this._props.vertical) {
        x += w / 2;
        orientations = ["top", "left", "right", "bottom"];

        if (this._props.h >= 0) {
          y += h;
          orientations = ["bottom", "left", "right", "top"];
        }
      } else {
        y += h / 2;
        orientations = ["left", "top", "bottom", "right"];

        if (this._props.w >= 0) {
          x += w;
          orientations = ["right", "top", "bottom", "left"];
        }
      }

      return {
        positions: [{
          x: x,
          y: y,
          orientations: orientations
        }],
        shouldUpdate: false
      };
    },
    //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------
    offsetY: function offsetY(dy) {
      __super__$7.offsetY.call(this, dy);

      this._props.y += dy;
      return this;
    },
    offsetX: function offsetX(dx) {
      __super__$7.offsetX.call(this, dx);

      this._props.x += dx;
      return this;
    },
    rotate: function rotate() {
      __super__$7.rotate.call(this);

      this._props.vertical = !this._props.vertical;
      var assign;
      assign = [this._props.y, -this._props.x, this._props.h, -this._props.w, this._props.stretchY, this._props.stretchX], this._props.x = assign[0], this._props.y = assign[1], this._props.w = assign[2], this._props.h = assign[3], this._props.stretchX = assign[4], this._props.stretchY = assign[5];
      return this;
    },
    //-----------------------------------------------------------------------------------------
    // to model
    //-----------------------------------------------------------------------------------------
    toModel: function toModel() {
      return __super__$7.toModel.call(this, RectMorphingModel);
    },
    // TODO: W-2547360 use font matrix to replace hard code numbers
    // figure out text location from the three locations
    // below, ranked in priority, depending on bar size
    // and it's position on layer (eg in horizontal rect)
    // 1. positive value bar:
    //  |                              |
    //  |    x                         |
    //  |    |                         |
    //  |    __________________        |
    //  |(3) |       (4)   (1)| (2)    |
    //  |text|      text  text|text    |
    //  |    |________________|        |
    //  |                              |
    //  |                     |        |
    //  0                   x + w  xScale.range[1]
    // 2. negative value bar:
    //  |                              |
    //  |  x + w                       |
    //  |    |                         |
    //  |    __________________        |
    //  | (2)| (1)  (4)       | (3)    |
    //  |text|text  text      |text    |
    //  |    |________________|        |
    //  |                              |
    //  |                     |        |
    //  xScale.range[0]       x
    // textCenter - true
    // textInside - (4)
    // non textInside - (4) (2) (3)
    // textCenter - false
    // textInside - (1)
    // non textInside - (1) (2) (3)
    //
    getModelProps: function getModelProps() {
      var this$1 = this;
      var bbPad, text, textColor, textX, textY;
      var shapeEffectsProps = this.applyShapeEffects();
      var fill = shapeEffectsProps.fill;
      var stroke = shapeEffectsProps.stroke;
      var ref = this._props;
      var vertical = ref.vertical;
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      var textCenter = ref.textCenter;
      var textRotate = ref.textRotate;
      var textRotation = textRotate ? Math.PI / 2 : 0;

      if (vertical) {
        var assign;
        assign = [-h, w], w = assign[0], h = assign[1];
      }

      if (this._props.text !== undefined) {
        // figure out where to place the text
        if (vertical) {
          var assign$1;
          assign$1 = [-y, x], x = assign$1[0], y = assign$1[1];
        }

        var computeRange = function computeRange() {
          var range = undefined;
          var ROUNDING_TOLERANCE = 0.00001;

          if (this$1.getLayer() && this$1.getLayer().get("scales")) {
            var scales = this$1.getLayer().get("scales");
            range = vertical ? scales.y ? scales.y.flip().range().slice() : undefined : scales.x ? scales.x.range().slice() : undefined;
          }

          if (range == null) {
            range = [x, x + w];
          }

          range = range.sort(function (a, b) {
            return a - b;
          });
          return [range[0] - ROUNDING_TOLERANCE, range[1] + ROUNDING_TOLERANCE];
        };

        text = this._props.text != null ? this._props.text : "";
        var ref$1 = [ServiceProvider$1.getDelegate().getTextWidth(text), 8];
        var textW = ref$1[0];
        var textH = ref$1[1];

        if (textRotation) {
          var assign$2;
          assign$2 = [textH, -textW], textW = assign$2[0], textH = assign$2[1];
        }

        textX = 0;
        textY = (h + textH) / 2;
        var textIsInside = true;
        bbPad = null;
        var range = computeRange();

        if (w >= 0) {
          if (textW + 10 < w && x + w - textW - 5 >= range[0] && x + w <= range[1]) {
            textX = textCenter ?
            /* position 4 */
            (w - textW) / 2 :
            /* position 1 */
            w - textW - 5;
          } else if (!this._props.textInside) {
            if (x + w + textW + 5 < range[1] && x + w >= range[0]) {
              // position 2
              textX = w + 5;
              textIsInside = false;
              bbPad = vertical ? {
                top: textW + 5
              } : {
                right: textW + 5
              };
            } else if (x - textW - 5 > range[0] && x <= range[1]) {
              // position 3
              textX = -textW - 5;
              textIsInside = false;
              bbPad = vertical ? {
                bottom: textW + 5
              } : {
                left: textW + 5
              };
            } else {
              text = "";
            }
          } else {
            text = "";
          }
        } else {
          if (textW + 10 < -w && x + w >= range[0] && x + w + textW + 5 <= range[1]) {
            // position 1
            textX = textCenter ? (w - textW) / 2 : w + 5;
          } else if (!this._props.textInside) {
            if (x + w - textW - 5 > range[0] && x + w <= range[1]) {
              // position 2
              textX = w - textW - 5;
              textIsInside = false;
              bbPad = vertical ? {
                bottom: textW + 5
              } : {
                left: textW + 5
              };
            } else if (x + textW + 5 < range[1] && x >= range[0]) {
              // position 3
              textX = 5;
              textIsInside = false;
              bbPad = vertical ? {
                top: textW + 5
              } : {
                right: textW + 5
              };
            } else {
              text = "";
            }
          } else {
            text = "";
          }
        } // adjust text color based on lightness of fill


        textColor = text ? (textIsInside && fill ? fill : this.getParentBackgroundColor()).toHighContrast(this._props.textColorLight, this._props.textColorDark) : // no text... let's pick a color...
        // note that ideally with no text we shouldn't even send any text property...
        this._props.textColorLight;
        textX = Math.round(textX);
        textY = Math.round(textY);

        if (vertical) {
          var assign$3;
          assign$3 = [y, -x], x = assign$3[0], y = assign$3[1];
        }
      }

      if (stroke) {
        // we are drawing the borders here, so let's make sure there is no antialiasing
        x = Math.round(x);
        y = Math.round(y);
        w = Math.round(w);
        h = Math.round(h);
      }

      var baseBb = this.boundingBox();
      var bb = (bbPad ? new Box(baseBb.toJson()).padBy(bbPad) : baseBb).toArray();
      var rotation = this.getRotation();
      var cornerRadius = this._props.cornerRadius ? this._props.cornerRadius < 0 ? 0 : Math.min(this._props.cornerRadius, Math.abs(w / 2), Math.abs(h / 2)) : 0;
      return lodash__default.extend(this.getCommonModelProps(), shapeEffectsProps, {
        bb: bb,
        x: x,
        y: y,
        w: w,
        h: h,
        lineWidth: this._props.lineWidth,
        text: text,
        textX: textX,
        textY: textY,
        textColor: textColor,
        textRotation: textRotation,
        rotation: rotation,
        cornerRadius: cornerRadius,
        stretchX: this._props.stretchX,
        stretchY: this._props.stretchY,
        dashed: this._props.dashed
      });
    }
  });
  Rect$3._roundProps = new StaticArraySet(["x0", "y0", "x1", "y1", "baseXValue", "baseYValue"]); //

  /**
   * Created by yi.chen on 1/10/17.
   */

  var BRUSH$1 = constants$1.BRUSH;
  var CURSOR_TYPE = constants$1.CURSOR_TYPE;
  var INVISIBLE_OPACITY = 0.000001;
  var CAPTION_TEXT_PADDING = 20;
  /*::(x: BrushArea) => (x: IBrushArea)*/

  var BrushArea = function BrushArea(layer, colors, hasControlPoints) {
    this._layer = layer;
    this._fillColor = colors && colors.fillColor || new Color('rgb(255, 255, 255)');
    this._strokeColor = colors && colors.strokeColor || new Color('rgb(0, 0, 0)');
    this._textColor = colors && colors.textColor || new Color('rgb(0, 0, 0)');
    this._hasControlPoints = !!hasControlPoints;
    this._controlPoints = [];
  };

  BrushArea.prototype.getArea = function getArea() {
    return this._area;
  };
  /**
  	 * Return all the shapes of the brush
  	 * Note: The order matters, 0 has to be the area itself
  	 * @returns {Array}
  	 */


  BrushArea.prototype.getShapes = function getShapes() {
    var items = [];

    if (this._shapeArea) {
      items.push(this._shapeArea);
    }

    if (this._controlPoints && this._controlPoints.length) {
      this._controlPoints.forEach(function (c) {
        return items.push(c);
      });
    }

    if (this._captionText) {
      items.push(this._captionText);
    }

    return items;
  };

  BrushArea.prototype.setText = function setText(text) {
    if (this._captionText) {
      this._captionText.set({
        text: text,
        opacity: 1
      });

      this._layout();
    }
  };

  BrushArea.prototype.hideText = function hideText() {
    if (this._captionText) {
      this._captionText.set({
        opacity: INVISIBLE_OPACITY
      });
    }
  };

  BrushArea.prototype.removeBrush = function removeBrush() {
    return this.getShapes().forEach(function (shape) {
      shape.removeFromParent();
    });
  };

  BrushArea.prototype.select = function select(x, y, w, h) {
    var _x = x,
        _y = y,
        _w = w,
        _h = h;

    if (_w < 0) {
      _x = x + w + 1;
      _w = -w;
    }

    if (_h < 0) {
      _y = y + h + 1;
      _h = -h;
    }

    if (!this._area) {
      return this._initArea(_x, _y, _w, _h);
    } else {
      this._area.x0 = _x;
      this._area.y0 = _y;
      this._area.x1 = _x + _w - 1;
      this._area.y1 = _y + _h - 1;

      this._layout();

      return this.getShapes();
    }
  };

  BrushArea.prototype.rotateTextDirection = function rotateTextDirection() {
    if (this._captionText) {
      // TODO: IText
      //@flow-ignore
      this._captionText.rotateTextDirection();
    }
  }; //--------------------------------------------
  // private
  //--------------------------------------------


  BrushArea.prototype._initArea = function _initArea(x, y, w, h) {
    this._area = {
      x0: x,
      y0: y,
      x1: x + w - 1,
      y1: y + h - 1
    };

    this._createShapes();

    this._layout();

    return this.getShapes();
  };

  BrushArea.prototype._createShapes = function _createShapes() {
    this._shapeArea = new Rect$3({
      key: 'brushSelect',
      layer: this._layer,
      stroke: this._strokeColor,
      fill: this._fillColor,
      cursorType: CURSOR_TYPE.MOVE,
      skipInFind: true
    });
    this._captionText = new Text$1({
      text: "",
      key: 'brushCaptionText',
      layer: this._layer,
      stroke: this._textColor,
      skipInFind: true
    });

    if (this._hasControlPoints) {
      this._controlPoints[0] = new Rect$3({
        key: 'brushControlPoint0',
        layer: this._layer,
        stroke: this._strokeColor,
        fill: new Color('rgb(255, 255, 255)'),
        w: BRUSH$1.CONTROL_POINT_SIZE,
        h: BRUSH$1.CONTROL_POINT_SIZE,
        cursorType: CURSOR_TYPE.EW_RESIZE
      });
      this._controlPoints[1] = new Rect$3({
        key: 'brushControlPoint1',
        layer: this._layer,
        stroke: this._strokeColor,
        fill: new Color('rgb(255, 255, 255)'),
        w: BRUSH$1.CONTROL_POINT_SIZE,
        h: BRUSH$1.CONTROL_POINT_SIZE,
        cursorType: CURSOR_TYPE.EW_RESIZE
      });
    }
  };
  /**
  	 * Layout the brush (update the properties) that would match the current brush area
  	 * @private
  	 */


  BrushArea.prototype._layout = function _layout() {
    var ref = this;
    var _area = ref._area;
    var _shapeArea = ref._shapeArea;
    var _captionText = ref._captionText;

    if (_area && _shapeArea) {
      var x0 = _area.x0;
      var y0 = _area.y0;
      var x1 = _area.x1;
      var y1 = _area.y1;
      var w = x1 - x0 + 1;
      var h = y1 - y0 + 1;
      var isVisible = w >= 1 && h >= 1;

      _shapeArea.set({
        x: x0,
        y: y0,
        w: isVisible ? w : 0,
        h: isVisible ? h : 0,
        vertical: true
      });

      if (this._hasControlPoints) {
        var offset = BRUSH$1.CONTROL_POINT_SIZE / 2;
        var size = isVisible ? BRUSH$1.CONTROL_POINT_SIZE : 0;

        this._controlPoints[0].set({
          x: x0 + w / 2 - offset,
          y: y0 - 2 * offset,
          w: size,
          h: size,
          vertical: true
        });

        this._controlPoints[1].set({
          x: x0 + w / 2 - offset,
          y: y1,
          w: size,
          h: size,
          vertical: true
        });
      }

      if (_captionText) {
        _captionText.set({
          x: x0 + w - 1 - CAPTION_TEXT_PADDING,
          y: y0 + CAPTION_TEXT_PADDING,
          vertical: false,
          valign: 'center',
          halign: 'right',
          text: isVisible ? _captionText.get('text') : ""
        });
      }
    }
  }; //

  /**
   * Created by yi.chen on 1/4/17.
   */

  /*::(x: BrushLayer<*>) => (x: IBrushLayer)*/


  var BrushLayer = function (DecorationLaye____1) {
    function BrushLayer() {
      DecorationLaye____1.apply(this, arguments);
    }

    if (DecorationLaye____1) BrushLayer.__proto__ = DecorationLaye____1;
    BrushLayer.prototype = Object.create(DecorationLaye____1 && DecorationLaye____1.prototype);
    BrushLayer.prototype.constructor = BrushLayer;

    BrushLayer.prototype.isBrushLayer = function isBrushLayer() {
      return true;
    };
    /**
     * Get the step for a given range value
     * @param value range value
     */


    BrushLayer.prototype.getBrushStepByPosition = function getBrushStepByPosition(value) {
      return {
        position: -1
      };
    };
    /**
     * Get the step for a given index
     * @param value
     */


    BrushLayer.prototype.getBrushStepByIndex = function getBrushStepByIndex(value) {
      return {
        position: -1
      };
    };
    /**
     * Get the step for a given index
     * @param value
     */


    BrushLayer.prototype.getBrushStepBySelectionValue = function getBrushStepBySelectionValue(value) {
      return {
        position: -1
      };
    };
    /**
     * Get the current selected brush area
     * @return {x0, y0, x1, y1} (x0, y0) is the top left and (x1, y1) is the bottom right
     */


    BrushLayer.prototype.getBrushArea = function getBrushArea() {
      return this._brushArea && this._brushArea.getArea();
    };
    /**
     * Get the control id under the position given
     * 0: somewhere in the area, 1: first control point , 2: second control point
     * @param x
     * @param y
     * @returns {number}
     */


    BrushLayer.prototype.getControl = function getControl(x, y) {
      var brush = this._brushArea;

      if (brush) {
        var shapes = brush.getShapes();
        var ref = this.toTransformedPosition(x, y);
        var globalX = ref[0];
        var globalY = ref[1];

        for (var i = shapes.length - 1; i >= 0; --i) {
          var shape = shapes[i];

          if (shape.isUnderCursor(globalX, globalY)) {
            return i;
          }
        }
      }

      return -1;
    };
    /**
     * Set the keys to the containers containing the interesting shapes for brushing selecting from
     * @param keys
     */


    BrushLayer.prototype.setShapeContainerKeys = function setShapeContainerKeys(keys) {
      this._props.shapeContainerKeys = keys;
    };
    /**
     * Get the keys to the containers containing the interesting shapes for brushing selecting from
     */


    BrushLayer.prototype.getShapeContainerKeys = function getShapeContainerKeys() {
      return this._props.shapeContainerKeys;
    };
    /**
     * Set the text for the brush area
     * @param text
     */


    BrushLayer.prototype.setBrushCaptionText = function setBrushCaptionText(text) {
      if (this._brushArea) {
        this._brushArea.setText(text);
      }
    };
    /**
     * Hide text for the brush area
     */


    BrushLayer.prototype.hideBrushCaptionText = function hideBrushCaptionText() {
      if (this._brushArea) {
        this._brushArea.hideText();
      }
    };
    /**
     * Remove the brush from the scene
     */


    BrushLayer.prototype.removeBrush = function removeBrush() {
      if (this._brushArea) {
        this._brushArea.removeBrush();

        this._brushArea = null;
      }
    };
    /**
     * Brush select the given area
     * @param x
     * @param y
     * @param w
     * @param h
     * @return the shapes that have updated
     */


    BrushLayer.prototype.brushSelect = function brushSelect(x, y, w, h) {
      if (!this._brushArea) {
        this._brushArea = new BrushArea(this, {
          fillColor: this.get('brushFillColor'),
          strokeColor: this.get('brushStrokeColor'),
          textColor: this.get('brushTextColor')
        }, this.get('hasControlPoints'));
      }

      var brushArea = this._brushArea;

      if (brushArea) {
        // Normalized for the width/height
        var _x = x,
            _y = y,
            _w = w,
            _h = h;

        if (_w < 0) {
          _x = x + w + 1;
          _w = -w;
        }

        if (_h < 0) {
          _y = y + h + 1;
          _h = -h;
        }

        var layerW = this.get('w') || 0,
            layerH = this.get('h') || 0;

        var x0 = this._boundInLayer(_x, layerW);

        var x1 = this._boundInLayer(_x + _w - 1, layerW);

        var y0 = this._boundInLayer(_y, layerH);

        var y1 = this._boundInLayer(_y + _h - 1, layerH);

        brushArea.select(x0, y0, x1 - x0 + 1, y1 - y0 + 1);
        return this._transformShapes();
      }

      return [];
    };
    /**
     * Have the brush area snap to the given steps
     */


    BrushLayer.prototype.snapToSteps = function snapToSteps() {
      var ref = this._getRangeSteps();

      var startStep = ref[0];
      var endStep = ref[1];

      if (startStep && endStep) {
        this.brushSelect(0, startStep.position, this.get('w'), endStep.position - startStep.position + 1);
        return [startStep, endStep];
      } else {
        return [];
      }
    };
    /**
     * If a set of steps given, this method returns the start/end of the label from the steps
     */


    BrushLayer.prototype.getRangeLabels = function getRangeLabels() {
      return this._getRangeSteps().map(function (x) {
        return x.label;
      });
    }; //--------------------------------------------
    // private
    //--------------------------------------------

    /**
     * Get the closest steps by the two end points of the range
     * @param keepNumSteps
     * @returns {*}
     * @private
     */


    BrushLayer.prototype._getRangeSteps = function _getRangeSteps() {
      var brush = this._brushArea;
      var brushArea = brush && brush.getArea();

      if (brush && brushArea) {
        var x0 = brushArea.x0;
        var y0 = brushArea.y0;
        var x1 = brushArea.x1;
        var y1 = brushArea.y1;
        return [this.getBrushStepByPosition(y0), this.getBrushStepByPosition(y1)];
      }

      return [];
    };

    BrushLayer.prototype._setDefaultProps = function _setDefaultProps() {
      DecorationLaye____1.prototype._setDefaultProps.call(this);

      var props = this._props; // note: Layer's canHover, canSelect are by default false, while shape and
      // shapeGroup are by default true. so Layer serves as the big switch for
      // control whether child shapes/shapeGroups are interactable.

      props.shapeContainerKeys = [];
      props.hasControlPoints = false;
      props.brushFillColor = new Color('rgba(100, 100, 100, 0.5)');
      props.brushStrokeColor = new Color('rgb(0, 0, 0)');
      props.brushTextColor = new Color('rgb(0, 0, 0)');
    };

    BrushLayer.prototype._boundInLayer = function _boundInLayer(x, end) {
      var max = end >= 0 ? end : 0;
      var min = end >= 0 ? 0 : end;
      return x < min ? min : x > max ? max : x;
    };

    return BrushLayer;
  }(DecorationLayer);

  BrushLayer.type = "Layer";
  BrushLayer._roundProps = new StaticArraySet(["x", "y"]);
  BrushLayer._sensitiveProps = new StaticArraySet(["scales"]);
  /**
   * Created by yi.chen on 2/27/17.
   */
  //-ignore
  //@flow-ignore

  var GRANULARITY$2 = constants$1.TIME_GRANULARITY;
  /*::(x: BrushLayer<*>) => (x: IBrushLayer)*/

  var TimeBrushLayer = function (BrushLaye____1) {
    function TimeBrushLayer() {
      BrushLaye____1.apply(this, arguments);
    }

    if (BrushLaye____1) TimeBrushLayer.__proto__ = BrushLaye____1;
    TimeBrushLayer.prototype = Object.create(BrushLaye____1 && BrushLaye____1.prototype);
    TimeBrushLayer.prototype.constructor = TimeBrushLayer;

    TimeBrushLayer.prototype.getBrushStepByPosition = function getBrushStepByPosition(rangeVal) {
      var ref = this._props;
      var dataGranularity = ref.dataGranularity;
      var scale = ref.scale;
      var firstDayOfWeek = ref.firstDayOfWeek;

      if (dataGranularity && scale) {
        var ref$1 = scale.domain();
        var domainStart = ref$1[0];
        var domainEnd = ref$1[1];

        var snappedValue = this._closestStep(luxon.DateTime.fromMillis(scale.invert(rangeVal)), dataGranularity, firstDayOfWeek, domainStart, domainEnd);

        var mSnappedValue = luxon.DateTime.fromMillis(snappedValue);

        var firstStep = this._getFirstStep();

        return {
          label: this._format(snappedValue),
          selectionValue: snappedValue,
          position: scale.scale(mSnappedValue),
          index: Math.floor(time.diff(firstStep, mSnappedValue, dataGranularity, firstDayOfWeek))
        };
      }

      return {
        position: -1,
        index: -1
      };
    };

    TimeBrushLayer.prototype.getBrushStepByIndex = function getBrushStepByIndex(index) {
      var ref = this._props;
      var dataGranularity = ref.dataGranularity;
      var scale = ref.scale;
      var firstDayOfWeek = ref.firstDayOfWeek;

      if (dataGranularity && scale) {
        var firstStep = this._getFirstStep();

        var current = time.offset(firstStep, index, dataGranularity, firstDayOfWeek);
        return {
          label: this._format(current),
          selectionValue: current.valueOf(),
          position: scale.scale(current),
          index: index
        };
      }

      return {
        position: -1,
        index: -1
      };
    };

    TimeBrushLayer.prototype.getBrushStepBySelectionValue = function getBrushStepBySelectionValue(value) {
      var ref = this._props;
      var scale = ref.scale;

      if (scale) {
        return this.getBrushStepByPosition(scale.scale(value));
      }

      return {
        position: -1,
        index: -1
      };
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    TimeBrushLayer.prototype._setDefaultProps = function _setDefaultProps() {
      BrushLaye____1.prototype._setDefaultProps.call(this);

      var props = this._props; // note: Layer's canHover, canSelect are by default false, while shape and
      // shapeGroup are by default true. so Layer serves as the big switch for
      // control whether child shapes/shapeGroups are interactable.

      props.dataGranularity = "";
      props.firstDayOfWeek = null;
      props.format = null;
      props.scale = null;
    };

    TimeBrushLayer.prototype._getFirstStep = function _getFirstStep() {
      var ref = this._props;
      var dataGranularity = ref.dataGranularity;
      var scale = ref.scale;
      var firstDayOfWeek = ref.firstDayOfWeek;

      if (dataGranularity && scale) {
        var ref$1 = scale.domain();
        var domainStart = ref$1[0];
        var domainEnd = ref$1[1];
        var mDomainStart = luxon.DateTime.fromMillis(domainStart);

        if (!mDomainStart.hasSame(time.startOf(domainStart, dataGranularity, firstDayOfWeek), GRANULARITY$2.MILLISECOND)) {
          mDomainStart = time.startOf(time.offset(domainStart, 1, dataGranularity, firstDayOfWeek), dataGranularity);
        }

        return mDomainStart;
      }
    };

    TimeBrushLayer.prototype._closestStep = function _closestStep(m, dataGranularity, firstDayOfWeek, domainStart, domainEnd) {
      var timeEpoch = m.valueOf();
      var lastStep = time.startOf(m, dataGranularity, firstDayOfWeek).valueOf();
      var nextStep = time.offset(lastStep, 1, dataGranularity, firstDayOfWeek).valueOf();

      if (Math.abs(timeEpoch - lastStep) < Math.abs(timeEpoch - nextStep) && lastStep >= domainStart) {
        return lastStep;
      } else if (nextStep <= domainEnd) {
        return nextStep;
      } else {
        return timeEpoch;
      }
    };

    TimeBrushLayer.prototype._onChange = function _onChange(diffOptions) {
      BrushLaye____1.prototype._onChange.call(this, diffOptions);

      var props = this._props;

      if (diffOptions.format || diffOptions.firstDayOfWeek) {
        var format = diffOptions.format ? diffOptions.format[0] : props.format;
        var firstDayOfWeek = diffOptions.firstDayOfWeek ? diffOptions.firstDayOfWeek[0] : props.firstDayOfWeek;
        this._formatter = time.getFormatter(format, firstDayOfWeek);
      }

      return;
    };

    TimeBrushLayer.prototype._format = function _format(timeEpoch) {
      return this._formatter ? this._formatter(timeEpoch) : timeEpoch;
    };

    return TimeBrushLayer;
  }(BrushLayer);

  TimeBrushLayer.type = "Layer";
  TimeBrushLayer._roundProps = new StaticArraySet(["x", "y"]);
  TimeBrushLayer._sensitiveProps = new StaticArraySet(["scales", "format", "firstDayOfWeek"]); //

  /**
   * Created by yi.chen on 2/27/17.
   */

  var BRUSH = constants$1.BRUSH;
  var BrushLayerFactory = {
    make: function make(type) {
      var args = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        args[len] = arguments[len + 1];
      }

      switch (type) {
        case BRUSH.LAYER_TYPE.TIME:
          return new (Function.prototype.bind.apply(TimeBrushLayer, [null].concat(args)))();

        default:
          return new (Function.prototype.bind.apply(BrushLayer, [null].concat(args)))();
      }
    }
  }; //
  //@flow-ignore

  /*::(x: Cell) => (x: ICell)*/

  var Cell$2 = function (Group) {
    function Cell(props, silent) {
      if (!props) {
        props = {
          key: undefined,
          zIndex: 0,
          column: 0,
          row: 0,
          scene: undefined
        };
      }

      if (props.key == null) {
        props.key = "CellKey" + props.column + "||" + props.row;
      }

      Group.call(this, props, silent);
      var scene = props.scene;

      if (scene) {
        scene.append(this);
      }
    }

    if (Group) Cell.__proto__ = Group;
    Cell.prototype = Object.create(Group && Group.prototype);
    Cell.prototype.constructor = Cell;

    Cell.prototype._setDefaultProps = function _setDefaultProps() {
      Group.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.x = 0;
      props.y = 0;
      props.w = 0;
      props.h = 0;
      props.scrollX = false;
      props.scrollY = false;
      props.clip = undefined;
      props.column = 0;
      props.row = 0;
    }; //--------------------------------------------------------------------------------
    // child management
    //--------------------------------------------------------------------------------


    Cell.prototype._childSorter = function _childSorter(child) {
      return child.get("zIndex");
    };

    Cell.prototype.getScene = function getScene() {
      return this.getParent();
    };

    Cell.prototype.getLayers = function getLayers() {
      return this.getChildren();
    };

    Cell.prototype.layerByKey = function layerByKey(key) {
      return this.getChildByKey(key);
    }; //--------------------------------------------------------------------------------
    // transforms
    //--------------------------------------------------------------------------------


    Cell.prototype.rotate = function rotate() {
      var props = this._props;
      var ref = this._props;
      var scrollX = ref.scrollX;
      var scrollY = ref.scrollY;
      this._props.scrollX = scrollY;
      this._props.scrollY = scrollX;
      Group.prototype.rotate.call(this);
      return this;
    }; // translate layer on x by dx


    Cell.prototype.offsetX = function offsetX(dx) {
      this._props.x += dx;
      return this;
    }; // translate layer on y by dy


    Cell.prototype.offsetY = function offsetY(dy) {
      this._props.y += dy;
      return this;
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------


    Cell.prototype.adjustWidth = function adjustWidth(w) {
      var scene = this.getScene();
      scene && scene.adjustColumnSize(this._props.column, w);
      return this;
    };

    Cell.prototype.adjustHeight = function adjustHeight(h) {
      var scene = this.getScene();
      scene && scene.adjustRowSize(this._props.row, h);
      return this;
    };

    Cell.prototype.adjustRowToFit = function adjustRowToFit() {
      var scene = this.getScene();
      scene && scene.adjustRowToFit(this._props.row);
      return this;
    };

    Cell.prototype.adjustColumnToFit = function adjustColumnToFit() {
      var scene = this.getScene();
      scene && scene.adjustColumnToFit(this._props.column);
      return this;
    };

    Cell.prototype.translation = function translation() {
      var scene = this.getScene();
      var x = this._props.x;
      var y = this._props.y;

      if (scene) {
        var ref = scene.get("padding");
        var top = ref.top;
        var left = ref.left;
        return [x + left, y + top];
      } else {
        return [x, y];
      }
    };

    Cell.prototype.totalTranslation = function totalTranslation(withScrollX, withScrollY) {
      if (withScrollX === void 0) withScrollX = false;
      if (withScrollY === void 0) withScrollY = false;
      var x = this._props.x;
      var y = this._props.y;
      var parent = this.getParent();
      var ref = this._props;
      var scrollX = ref.scrollX;
      if (scrollX === void 0) scrollX = true;
      var scrollY = ref.scrollY;
      if (scrollY === void 0) scrollY = true;
      var ref$1 = parent && parent.totalTranslation(withScrollX && scrollX, withScrollY && scrollY) || [0, 0];
      var parentX = ref$1[0];
      var parentY = ref$1[1];
      return [parentX + x, parentY + y];
    };

    return Cell;
  }(Group$1);

  Cell$2.type = "Cell"; //
  //@flow-ignore

  var __super__$8 = Object.getPrototypeOf(Cell$2.prototype);

  lodash__default.extend(Cell$2.prototype, {
    toScenePosition: function toScenePosition(x, y) {
      var ref = this.translation();
      var tx = ref[0];
      var ty = ref[1];
      return [x + tx, y + ty];
    },
    toLocalPosition: function toLocalPosition(x, y) {
      var ref = this.translation();
      var tx = ref[0];
      var ty = ref[1];
      return [x - tx, y - ty];
    },
    isUnderCursor: function isUnderCursor(x, y) {
      var ref = this._props;
      var clip = ref.clip;
      var w = ref.w;
      var h = ref.h;
      var scrollX = ref.scrollX;
      var scrollY = ref.scrollY;
      var isUnderX = scrollX || clip ? x >= 0 && x <= w : true;
      var isUnderY = scrollY || clip ? y >= 0 && y <= h : true;
      return isUnderX && isUnderY;
    },
    isInArea: function isInArea(rx, ry, rw, rh) {
      var ref = this._props;
      var clip = ref.clip;
      var w = ref.w;
      var h = ref.h;
      var scrollX = ref.scrollX;
      var scrollY = ref.scrollY;
      var isInX = scrollX || clip ? !(w < rx || rx + rw - 1 < 0) : true;
      var isInY = scrollY || clip ? !(h < ry || ry + rh - 1 < 0) : true;
      return isInX && isInY;
    },
    //-----------------------------------------------------------------------------------------
    // to/from
    //-----------------------------------------------------------------------------------------
    getModelProps: function getModelProps() {
      var scene = this.getScene();
      var ref = this.translation();
      var x = ref[0];
      var y = ref[1];
      var ref$1 = this._props;
      var w = ref$1.w;
      var h = ref$1.h;
      var scrollX = ref$1.scrollX;
      var scrollY = ref$1.scrollY;
      var clip = ref$1.clip;

      if (scene) {
        var ref$2 = scene.get("size");
        var sceneW = ref$2[0];
        var sceneH = ref$2[1]; // viewport rect, relative to scene

        var viewport = scrollX || clip ? scrollY || clip ? [x, y, w, h] : [x, 0, w, sceneH] : scrollY ? [0, y, sceneW, h] : null;
      }

      return {
        type: this.getType(),
        key: this._props.key,
        zIndex: this._props.zIndex,
        scrollX: this._props.scrollX,
        scrollY: this._props.scrollY,
        tx: x,
        ty: y,
        w: w,
        h: h,
        viewport: viewport,
        accessibility: this._props.accessibility
      };
    }
  });

  Cell$2.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    return __super__$8.constructor.fromJson.call(this, json, deepCopy);
  };

  Cell$2._roundProps = new StaticArraySet(["x", "y", "w", "h"]);

  var Grid = function Grid(options) {
    if (options === void 0) options = {};
    this.columns = []; // allocation rules for columns

    this.rows = []; // allocation rules for rows

    this._columns = []; // computed layout for columns

    this._rows = []; // computed layout for rows

    this._cellByIndex = {};
    lodash__default.extend(this, options);
  };

  Grid.initClass = function initClass() {
    this.prototype.scene = null;
  };

  Grid.prototype.attachScene = function attachScene(scene) {
    this.scene = scene;

    if (!this.scene) {
      return this;
    }

    return this._updateIndex();
  };

  Grid.prototype.buildCells = function buildCells(opts) {
    return this.updateCellLayout(opts);
  }; // size the grid occupies, can be smaller than available size


  Grid.prototype.size = function size() {
    var lastCol = lodash__default.last(this._columns);
    var lastRow = lodash__default.last(this._rows);
    var w = lastCol ? lastCol.pos + lastCol.size : 0;
    var h = lastRow ? lastRow.pos + lastRow.size : 0;
    return [w, h];
  }; // assign a new grid layout
  // - when new grid layout has different number of columns or rows
  //   cells from previous layout on the same location(col, row index)
  //   will be reused, cells removed will be detached from scene.


  Grid.prototype.updateCellLayout = function updateCellLayout(opts) {
    var this$1 = this;
    if (opts === void 0) opts = {};

    if (!this.scene) {
      return this;
    }

    var oldnRows = this.rows.length;
    var oldnColumn = this.columns.length;
    this.scene.getChildren().slice().forEach(function (cell) {
      cell.removeFromParent();
    });
    var rows = opts.rows;
    var columns = opts.columns;

    if (rows) {
      this.rows = rows;
    }

    if (columns) {
      this.columns = columns;
    }

    this._traverseGrid(function (cell, column, row) {
      if (column < oldnColumn && row < oldnRows) {
        return cell.appendTo(this$1.scene);
      } else {
        return new Cell$2({
          scene: this$1.scene,
          column: column,
          row: row
        });
      }
    });

    return this._refreshLayout();
  };

  Grid.prototype.rotate = function rotate() {
    var this$1 = this;

    if (!this.scene) {
      return this;
    }

    var ref = this._getAvailableSize();

    var w = ref[0];
    var h = ref[1];

    this._traverseGrid(function (cell) {
      return cell.set({
        x: cell.get("y"),
        y: h - cell.get("x") - cell.get("w"),
        w: cell.get("h"),
        h: cell.get("w"),
        column: cell.get("row"),
        row: this$1.columns.length - cell.get("column") - 1
      });
    });

    var assign;
    assign = [this.columns.slice().reverse(), this.rows.slice()], this.rows = assign[0], this.columns = assign[1];
    var assign$1;
    assign$1 = [this._columns.slice().reverse(), this._rows.slice()], this._rows = assign$1[0], this._columns = assign$1[1];
    return this._updateIndex();
  };

  Grid.prototype.flipX = function flipX() {
    var this$1 = this;

    if (!this.scene) {
      return this;
    }

    var ref = this._getAvailableSize();

    var w = ref[0];
    var h = ref[1];

    this._traverseGrid(function (cell) {
      return cell.set({
        x: w - (cell.get("x") + cell.get("w")),
        column: this$1.columns.length - cell.get("column") - 1
      });
    });

    return this._updateIndex();
  };

  Grid.prototype.flipY = function flipY() {
    var this$1 = this;

    if (!this.scene) {
      return this;
    }

    var ref = this._getAvailableSize();

    var w = ref[0];
    var h = ref[1];

    this._traverseGrid(function (cell) {
      return cell.set({
        y: h - (cell.get("y") + cell.get("h")),
        row: this$1.rows.length - cell.get("row") - 1
      });
    });

    return this._updateIndex();
  };

  Grid.prototype.adjustColumnToFit = function adjustColumnToFit(colIndex) {
    var this$1 = this;

    if (colIndex > this.columns.length - 1) {
      return;
    }

    var widths = [];

    for (var rowIndex = 0; rowIndex < this.rows.length; rowIndex++) {
      var bb = this$1.getCell(colIndex, rowIndex).boundingBox();

      if (bb) {
        widths.push(bb.x + bb.w);
      } else {
        widths.push(0);
      }
    }

    var maxWidth = lodash__default.max(widths); // maxWidth, as a result of bounding box measurement, sometimes could be 200.200000001, because of js rounding error
    // in this case, original size passed in was 200.2, and we should adjust column. so we always round to 2 digits
    // and then compare the size, to get away with this rounding error

    if (mathUtils.round2d(maxWidth) <= mathUtils.round2d(this._columns[colIndex].size)) {
      this.columns[colIndex] = maxWidth;
      return this.updateCellLayout({
        columns: this.columns
      });
    }
  };

  Grid.prototype.adjustRowToFit = function adjustRowToFit(rowIndex) {
    var this$1 = this;

    if (rowIndex > this.rows.length - 1) {
      return;
    }

    var heights = [];

    for (var colIndex = 0; colIndex < this.columns.length; colIndex++) {
      var bb = this$1.getCell(colIndex, rowIndex).boundingBox();

      if (bb) {
        heights.push(bb.y + bb.h);
      } else {
        heights.push(0);
      }
    }

    var maxHeight = lodash__default.max(heights);

    if (mathUtils.round2d(maxHeight) <= mathUtils.round2d(this._rows[rowIndex].size)) {
      this.rows[rowIndex] = maxHeight;
      return this.updateCellLayout({
        rows: this.rows
      });
    }
  };

  Grid.prototype.adjustRowSize = function adjustRowSize(rowIndex, size) {
    this.rows[rowIndex] = size;
    return this.updateCellLayout({
      rows: this.rows
    });
  };

  Grid.prototype.adjustColumnSize = function adjustColumnSize(colIndex, size) {
    this.columns[colIndex] = size;
    return this.updateCellLayout({
      columns: this.columns
    });
  };

  Grid.prototype.getCell = function getCell(col, row) {
    return this._cellByIndex[this._getCellIndex(col, row)];
  };

  Grid.prototype.getBaseScrollOffset = function getBaseScrollOffset() {
    var baseX = 0;
    var baseY = 0;
    var ref = this.scene.getScrollOffset();
    var xOffset = ref[0];
    var yOffset = ref[1];

    this._traverseGrid(function (cell) {
      var w = cell.get("w");
      var h = cell.get("h");
      var scrollX = cell.get("scrollX");
      var scrollY = cell.get("scrollY");
      var bb = cell.boundingBox();

      if (bb && (scrollX || scrollY)) {
        bb.x += xOffset;
        bb.y += yOffset;
        var viewPortBb = {
          x: 0,
          y: 0,
          w: w,
          h: h
        };
        var combinedBb = Box.boundingBox([bb, viewPortBb]);

        if (scrollX) {
          baseX = Math.min(combinedBb.x, baseX);
        }

        if (scrollY) {
          return baseY = Math.min(combinedBb.y, baseY);
        }
      }
    });

    return [-baseX, -baseY];
  }; // calculate the full size of chart


  Grid.prototype.getFullSize = function getFullSize() {
    if (!this.scene) {
      return null;
    }

    var widths = this.rows.map(function () {
      return 0;
    });
    var heights = this.columns.map(function () {
      return 0;
    });
    var ref = this.scene.getScrollOffset();
    var xOffset = ref[0];
    var yOffset = ref[1];

    this._traverseGrid(function (cell, col, row) {
      var w = cell.get("w");
      var h = cell.get("h");
      var scrollX = cell.get("scrollX");
      var scrollY = cell.get("scrollY");
      var bb = cell.boundingBox();

      if (bb && (scrollX || scrollY)) {
        bb.x += xOffset;
        bb.y += yOffset;
        var viewPortBb = {
          x: 0,
          y: 0,
          w: w,
          h: h
        };
        var combinedBb = Box.boundingBox([bb, viewPortBb]);

        if (scrollX) {
          var assign;
          assign = combinedBb, w = assign.w;
        }

        if (scrollY) {
          var assign$1;
          assign$1 = combinedBb, h = assign$1.h;
        }
      }

      widths[row] += w;
      return heights[col] += h;
    });

    return [lodash__default.max(widths), lodash__default.max(heights)];
  };

  Grid.prototype._refreshLayout = function _refreshLayout() {
    this._updateIndex();

    this._refreshColumns();

    this._refreshRows();

    this._refreshCells();

    return this;
  }; // traverse grid cells, and invoke a custom function taking current cell, column index
  // and row index. Results of custom function returned in array.
  // - returns array with custom function results
  // - @param fct {Function} custom function (cell, col, row) ->


  Grid.prototype._traverseGrid = function _traverseGrid(fct) {
    var this$1 = this;
    var res = [];

    for (var col = 0, end = this.columns.length, asc = 0 <= end; asc ? col < end : col > end; asc ? col++ : col--) {
      for (var row = 0, end1 = this.rows.length, asc1 = 0 <= end1; asc1 ? row < end1 : row > end1; asc1 ? row++ : row--) {
        res.push(fct(this$1.getCell(col, row), col, row));
      }
    }

    return res;
  };

  Grid.prototype._getCellIndex = function _getCellIndex(col, row) {
    return col + "/" + row;
  }; // Get the entire charting space
  // @return {[number, number]} width and height of the charting space


  Grid.prototype._getAvailableSize = function _getAvailableSize() {
    return this.scene.getAvailableSize();
  };

  Grid.prototype._updateIndex = function _updateIndex() {
    var this$1 = this;
    this._cellByIndex = {};
    this.scene.getChildren().forEach(function (cell) {
      this$1._cellByIndex[this$1._getCellIndex(cell.get("column"), cell.get("row"))] = cell;
    });
    return this;
  }; // Distribute the width based on @columns
  // @param {[number || string]} Ratio can be expressed as absolute number (ex. 5) in px or string ("50%")


  Grid.prototype._refreshColumns = function _refreshColumns() {
    return this._columns = this._assignLayout(this._getAvailableSize()[0], this.columns);
  }; // Distribute the height based on @rows
  // @param {[number || string]} Ratio can be expressed as absolute number (ex. 5) in px or string ("50%")


  Grid.prototype._refreshRows = function _refreshRows() {
    return this._rows = this._assignLayout(this._getAvailableSize()[1], this.rows);
  };

  Grid.prototype._refreshCells = function _refreshCells() {
    var this$1 = this;

    if (this._columns && this._rows) {
      this._traverseGrid(function (cell, col, row) {
        return cell.set({
          x: this$1._columns[col].pos,
          y: this$1._rows[row].pos,
          w: this$1._columns[col].size,
          h: this$1._rows[row].size
        });
      });
    }

    return this;
  }; // normalize a rule (pixel or proportinal size)
  // - 100 -> ['px', 100]
  // - -10 -> ['px', 0]
  // - "20%" -> ['%', 20]
  // - "10%" -> ['%', 10]


  Grid._normalizeRule = function _normalizeRule(rule) {
    if (lodash__default.isNumber(rule)) {
      return ["px", rule > 0 ? rule : 0];
    }

    if (lodash__default.isString(rule) && lodash__default.last(rule) === "%") {
      return ["%", parseInt(rule, 10)];
    }

    throw new Error("invalid rule " + JSON.stringify(rule));
  }; // assign layout for a column or row according to rules and total size available
  // - @param totalSize {Number}
  // - @param rules {Array}
  // - returns array, describing layout for column/row
  //    e.g. [ { pos: 0, size: 100}, { pos: 100, size: 50}]
  //    column1 starts at 0, width 100
  //    column2 starts at 100, width 50
  // - note: size will always >= 0


  Grid.prototype._assignLayout = function _assignLayout(totalSize, rules) {
    if (totalSize == null) {
      totalSize = 0;
    }

    if (rules == null) {
      rules = [];
    }

    var nProportion = 0;
    var normalizedRules = rules.map(Grid._normalizeRule);
    var sizeLeft = totalSize;
    normalizedRules.forEach(function (ref) {
      var unit = ref[0];
      var nb = ref[1];

      if (unit === "%") {
        nProportion += nb;
      } else {
        sizeLeft -= nb;
      }
    });
    var proportion = nProportion > 0 && sizeLeft > 0 ? sizeLeft / nProportion : 0;
    var pos = 0;
    var layout = [];
    normalizedRules.forEach(function (ref) {
      var unit = ref[0];
      var nb = ref[1];
      var size = unit === "%" ? proportion * nb : nb;
      layout.push({
        size: size,
        pos: pos
      });
      pos += size;
    });
    return layout;
  }; //-----------------------------------------------------------------------------------------
  // to/from
  //-----------------------------------------------------------------------------------------


  Grid.prototype.toJson = function toJson() {
    return {
      columns: this.columns,
      rows: this.rows,
      _columns: this._columns,
      _rows: this._rows
    };
  };

  Grid.fromJson = function fromJson(json, deepCopy) {
    if (deepCopy == null) {
      deepCopy = true;
    }

    if (deepCopy) {
      json = dataUtils.deepCopy(json);
    }

    return new Grid(json);
  };

  Grid.initClass(); //
  //@flow-ignore

  var sceneUtils = {
    // applies transforms to a cell
    applyTransforms: function applyTransforms(cell, transforms) {
      if (transforms) {
        if (transforms.flipY) {
          cell.flipY();
        }
      }
    },
    radius: function radius(cell) {
      return Math.min(cell.get("w") / 2, cell.get("h") / 2) - 1;
    },
    getLayerKey: function getLayerKey(cell) {
      return cell.key + "-layer";
    },
    newLayer: function newLayer(cell) {
      return new Layer({
        key: this.getLayerKey(cell),
        cell: cell,
        staggerAnim: false
      });
    },
    cellMap: function cellMap(scene) {
      var cellMap = {};
      scene.getCells().forEach(function (cell) {
        //@flow-ignore
        cellMap[dataUtils.camelCase(cell.key)] = cell;
      });
      return cellMap;
    },
    toShapeKeys: function toShapeKeys(shapeKey) {
      if (shapeKey[0] === "[" && shapeKey[shapeKey.length - 1] === "]") {
        // potential multigroup (note that we first try this to avoid calling JSON.parse on every single key...)
        try {
          return JSON.parse(shapeKey);
        } catch (e) {
          return [shapeKey];
        }
      } else {
        return [shapeKey];
      }
    }
  };
  var columnUtils;
  var columnUtils$1 = columnUtils = {
    // returns list of columns with unique column name
    // - keeping the original order
    // - for repeated columns, the last one will be used
    //
    // @param columns {list of columns/arrays} list of columns or array of columns (it will be flattened)
    uniqueColumns: function uniqueColumns() {
      var columns = [],
          len = arguments.length;

      while (len--) {
        columns[len] = arguments[len];
      }

      columns = lodash__default.flatten(columns);
      var columnKeys = [];
      var uniqueColumns = [];
      columns.forEach(function (column) {
        if (column) {
          var columnKey = column.getName();

          if (!dataUtils.includes(columnKeys, columnKey)) {
            columnKeys.push(columnKey);
            uniqueColumns.push(column);
          }
        }
      });
      return uniqueColumns;
    },
    // returns list of columns with withoutField removed
    //
    // @param columns {Array} array of columns
    // @param withoutField {Obj} a column to remove
    withoutColumns: function withoutColumns(columns, withoutColumns$1) {
      if (!withoutColumns$1) {
        return columns;
      }

      withoutColumns$1 = dataUtils.ensureArray(withoutColumns$1);
      columns = dataUtils.ensureArray(columns);
      return columns.filter(function (column) {
        return !dataUtils.includes(lodash__default.map(withoutColumns$1, function (c) {
          return c.getName();
        }), column.getName());
      });
    },
    joinColumns: function joinColumns(columns) {
      return lodash__default.map(columns, function (c) {
        return c.getName();
      }).join("-");
    },
    // filter out "" measure labels and join with comma
    measuresDefaultTitle: function measuresDefaultTitle(measures) {
      return measures.map(function (measure) {
        return columnUtils.defaultText(measure.getLabel(), measure.getName());
      }).filter(function (l) {
        return l;
      }).join(", ");
    },
    // Return the first valid non-empty string in the argument list
    //
    // @param text, [text1, [text2,...]] {String}
    // @return {string}
    defaultText: function defaultText() {
      var texts = [],
          len = arguments.length;

      while (len--) {
        texts[len] = arguments[len];
      }

      return lodash__default.find(texts);
    },
    sortColumns: function sortColumns(columns) {
      return lodash__default.sortBy(columns, function (column) {
        return column.getName();
      });
    }
  };
  var domainUtils = {
    // merge a set of domains
    // note: null domains are automatically removed
    mergeDomains: function mergeDomains(domains) {
      var min = +Infinity;
      var max = -Infinity;
      domains.forEach(function (domain) {
        if (domain) {
          var low = domain[0];
          var high = domain[1];

          if (low < min) {
            min = low;
          }

          if (high > max) {
            max = high;
          }
        }
      });

      if (min === +Infinity && max === -Infinity) {
        return null;
      } else {
        return [min, max];
      }
    },
    // adjust domain
    // - single value domain:
    //   numeric: expand domain by +- 20%
    //   time: expand domain by +-2 granularities
    adjustDomain: function adjustDomain(domain, granularity) {
      var min = domain[0];
      var max = domain[1];

      if (min === max) {
        // numeric domain
        if (min === 0) {
          var assign;
          assign = [0, 100], min = assign[0], max = assign[1]; // we have to pick *some* value I guess...
        } else {
          if (min > 0) {
            min *= 0.8;
            max *= 1.2;
          } else {
            min *= 1.2;
            max *= 0.8;
          }
        }
      }

      return [min, max];
    },
    // given a domain, margin and a scale,
    // adjust the margin wrt to the scale
    adjustMargin: function adjustMargin(domain, margin, scale) {
      var newDomain = scale.domain();
      var range = scale.range();
      scale = scales.linear().domain(domain).range([margin[0], range[1] - margin[1]]).adjustRange([0, range[1]]);
      return [Math.max(scale.scale(newDomain[0]), 0), Math.max(range[1] - scale.scale(newDomain[1]), 0)];
    },
    // assumption is that the domains are "niced" so are equally divisible by the step
    // so we try to find the number of ticks for each domain on the positive and negative sides.
    // then we try to force the max number of ticks on each side of 0 to all the domains
    // so that for each domain, we have the exact number of steps above and below zero, thus aligning the ticks
    alignTicks: function alignTicks(domains, steps) {
      var maxTicks = 0;
      var minTicks = 0;
      var alignedSteps = [];
      var step, ticks;
      var hasZero = false;
      var maxTotalTicks = 0;
      var tickDomains = [];
      var alignedDomains = []; // find if even one domain includes 0 i.e [0, n), (-m, 0], (-m, n)

      for (var i = 0; i < domains.length; i++) {
        var ref = domains[i];
        var min = ref[0];
        var max = ref[1];
        step = steps[i];
        min = Math.ceil(min / step) * step;
        max = Math.floor(max / step) * step;

        if (min <= 0 && max >= 0) {
          hasZero = true;
        }

        tickDomains.push([min, max]);
      } // calculate the max number of positive and negative ticks


      for (var i$1 = 0; i$1 < tickDomains.length; i$1++) {
        var ref$1 = tickDomains[i$1];
        var min$1 = ref$1[0];
        var max$1 = ref$1[1];
        step = steps[i$1];
        ticks = [-min$1 / step, max$1 / step];

        if (hasZero) {
          // if even one axis has zero, we need to find the number of ticks the domain would need wrt 0
          if (min$1 > 0) {
            ticks = [0, max$1 / step];
          } else if (max$1 < 0) {
            ticks = [-min$1 / step, 0];
          }
        } else if (min$1 > 0) {
          ticks = [0, (max$1 - min$1) / step];
        } else if (max$1 < 0) {
          ticks = [(max$1 - min$1) / step, 0];
        }

        minTicks = Math.max(ticks[0], minTicks);
        maxTicks = Math.max(ticks[1], maxTicks);
        maxTotalTicks = Math.max(maxTotalTicks, ticks[0] + ticks[1]);
      }

      var factor = 1;

      if (!hasZero) {
        minTicks = maxTicks = Math.max(minTicks, maxTicks);
      }

      var totalTicks = hasZero ? minTicks + maxTicks : minTicks; // if the max number of ticks on the domain is less than the number of ticks we are going to enforce on the domains
      // reduce the number of ticks by half and double the steps.

      if (totalTicks - maxTotalTicks > 2) {
        minTicks = (minTicks + minTicks % 2) / 2;
        maxTicks = (maxTicks + maxTicks % 2) / 2;
        factor = 2;
      }

      for (var i$2 = 0; i$2 < tickDomains.length; i$2++) {
        var ref$2 = tickDomains[i$2];
        var min$2 = ref$2[0];
        var max$2 = ref$2[1];
        step = steps[i$2] * factor;

        if (hasZero) {
          min$2 = -step * minTicks;
          max$2 = step * maxTicks;
        } else if (min$2 > 0) {
          max$2 = min$2 + step * maxTicks;
        } else if (max$2 < 0) {
          min$2 = max$2 - step * minTicks;
        }

        alignedDomains.push([min$2, max$2]);
        alignedSteps.push(step);
      }

      return {
        aligned: true,
        domains: alignedDomains,
        steps: alignedSteps
      };
    },
    alignZerosForDomain: function alignZerosForDomain(domains, steps, refDomain) {
      var i, max, min, refRatio;
      var noAlignResult = {
        aligned: false,
        domains: domains
      };

      if (domains.length < 2) {
        return noAlignResult;
      }

      var alignedDomains = [];

      if (steps) {
        return this.alignTicks(domains, steps);
      }

      if (refDomain != null) {
        var refMin = refDomain[0];
        var refMax = refDomain[1]; // return early if refDomain is [-n, -n] or [n, n]

        if (!(refMin < 0 && refMax > 0)) {
          return noAlignResult;
        }

        refRatio = refMax / (refMax - refMin); // do not align if the other domain needs to shrink. We align domains only by expanding domains
        // refRatio is 1 when [0, n],  refRatio is 0 when [-n, 0]

        if (refRatio >= 1 || refRatio === 0) {
          return noAlignResult;
        }
      } else {
        var totalMin = Infinity;
        var totalMax = -Infinity;
        var haveZero = false;

        for (i = 0; i < domains.length; i++) {
          var assign;
          assign = domains[i], min = assign[0], max = assign[1];

          if (min < totalMin) {
            totalMin = min;
          }

          if (max > totalMax) {
            totalMax = max;
          }

          if (min === 0 || max === 0) {
            haveZero = true;
          }

          if (min < 0 && max > 0) {
            // - always align with the first domain which includes zero [-n, n] unless a reference domain is specified
            refRatio = max / (max - min);
            break;
          }
        }

        if (refRatio == null) {
          if (totalMax < 0) {
            return noAlignResult;
          } // [-n, 0)


          if (totalMin > 0) {
            return noAlignResult;
          } // (0, n]
          // This is the case at least one zero is included in one of the domains
          // We regard this case as aligned even when all domains are [0, m] or [-m,0],
          // the domains are not modified(looks like no align operation happened), but
          // we want the margin to be adjusted downstream.


          if (totalMin === 0) {
            refRatio = 1;
          } // (0, n], [0, n]


          if (totalMax === 0) {
            refRatio = 0;
          } // [-n, 0), [-n, 0]


          if (refRatio == null) {
            if (!haveZero) {
              return noAlignResult;
            } // mix of [-n, 0), (0, n]


            refRatio = 0.5; // mix of [-n, 0), [0, n], or [-n, 0], (0, n]
          }
        }
      }

      for (i = 0; i < domains.length; i++) {
        var assign$1;
        assign$1 = domains[i], min = assign$1[0], max = assign$1[1];
        var ratio = max / (max - min);

        if (ratio > refRatio) {
          min = max * (1 - 1 / refRatio);
        }

        if (ratio < refRatio) {
          max = min * refRatio / (refRatio - 1);
        }

        alignedDomains.push([min, max]);
      }

      return {
        aligned: true,
        domains: alignedDomains
      };
    },
    // return an absolute domain for min/max
    toAbsoluteDomain: function toAbsoluteDomain() {
      var args = [],
          len = arguments.length;

      while (len--) {
        args[len] = arguments[len];
      }

      var ref = args[0];
      var min = ref[0];
      var max = ref[1];

      if (min < 0) {
        max = Math.max(Math.abs(min), Math.abs(max));
        min = 0;
      }

      return [min, max];
    },
    getNumericDomain: function getNumericDomain(rows, column, useParsedData) {
      var valueFct = valueFctUtils.getValueFctFromSingleField(column, useParsedData);
      return mathUtils.getMinMax(rows.map(function (row) {
        return valueFct(row);
      }));
    },
    getOrdinalDomain: function getOrdinalDomain(rows, column) {
      var cols = rowsUtils$1.rows2cols(rows)[column.getName()];

      if (!cols) {
        cols = [null];
      }

      return dataUtils.uniq(cols);
    }
  };
  var convertConfigUtils; // TODO alice.chen yi
  // Deprecate these utils after we have a way to cleanup colors

  var convertConfigUtils$1 = convertConfigUtils = {
    convertConfigColors: function convertConfigColors(config) {
      var this$1 = this;
      ['dimension', 'color', "x", "y", "plots", "plots.*"].forEach(function (name) {
        this$1._convertDimConfig(config, name);
      });
      ["measureAxis1", "measureAxis2", "x", "y", "measure"].forEach(function (name) {
        this$1._convertMeasureAxisConfig(config, name);
      });
      ["color"].forEach(function (name) {
        this$1._convertColorConfig(config, name);
      });
      ["plots.*.color"].forEach(function (name) {
        this$1._convertDimConfig(config, name);

        this$1._convertColorConfig(config, name);
      });
      ["plots"].forEach(function (name) {
        this$1._convertPlotConfig(config, name);
      });
      return convertConfigUtils._convertConfigColors(config, ['positiveColor', 'negativeColor', 'totalColor', 'startColor', 'ranges.bands.*', 'ranges.bands.*.color', 'gradient.range']);
    },
    _convertDimConfig: function _convertDimConfig(config, name) {
      return this._convertConfigColors(config, [name + ".column.*._hotSpots.*.colors.*", name + ".column.*._valueColors.*"]);
    },
    _convertPlotConfig: function _convertPlotConfig(config, name) {
      return this._convertConfigColors(config, [name + ".*.color", name + ".*.referenceLines.*.color"]);
    },
    _convertColorConfig: function _convertColorConfig(config, name) {
      return this._convertConfigColors(config, [name + ".range", name + ".bands.*.color", name + ".colors.*"]);
    },
    _convertMeasureAxisConfig: function _convertMeasureAxisConfig(config, name) {
      return this._convertConfigColors(config, [name + ".referenceLines.*.color"]);
    },
    // Temporary solution to convert color strings to color
    _convertConfigColors: function _convertConfigColors(config, paths) {
      var _convertConfigColor = function _convertConfigColor(config, path) {
        var _convert = function _convert(value) {
          if (value && (typeof value === 'string' || Array.isArray(value))) {
            return ColorFactory$1.getInstance().getColor(value);
          } else {
            return value;
          }
        };

        return config = convertConfigUtils.scatter(config, path, _convert);
      };

      return paths.forEach(function (path) {
        return _convertConfigColor(config, path);
      });
    },
    // Scatter applies the 'ops' operation to all the fields inside the object specified in 'path'.
    // It is similar to lodash.set while it supports * in the path.
    // ex. when if the object looks like
    // contact = {
    // 	friends: [ {firstName:'John', lastName:'Doe'},  {firstName:'Yi', lastName:'Chen'}]
    // }
    // and we want to change all the last names to upper case. It is hard to achieve with lodash.set since a specified path has to be given.
    // While with scatter, it can be done with scatter( contact, 'friends.*.lastName', (name) => name.toUpperCase )
    // The wild card operator not only applies to an array but also applies to an object. Ex.
    // person = {
    //   name: "John", id: "ID"
    // }
    // and we want to have all the fields under person to lower case.
    // We can do scatter( person, '*', (name) => name.toLowercase )
    // Note. The changes will be made in place
    scatter: function scatter(object, path, ops) {
      var paths = path.split('.');

      var _traverseReplace = function _traverseReplace(obj, paths) {
        if (!obj) {
          return obj;
        } else if (!paths.length) {
          return ops(obj);
        } else {
          var nextKey = paths[0];

          if (typeof obj === 'object') {
            if (!Array.isArray(obj)) {
              // if it is an object
              var propNames = nextKey === '*' ? lodash__default.keys(obj) : [nextKey];
              propNames.forEach(function (p) {
                var value = _traverseReplace(obj[p], paths.slice(1));

                if (value != null) {
                  return obj[p] = value;
                }
              });
              return obj;
            } else if (nextKey === '*') {
              // if it is an array with wild operator
              return obj = obj.map(function (o) {
                return _traverseReplace(o, paths.slice(1));
              });
            } else {
              // error (path is not done while this is a primitive type)
              return obj;
            }
          } else {
            // error (path is not done while this is a primitive type)
            return obj;
          }
        }
      };

      return _traverseReplace(object, paths);
    },
    // bucketize measures into different axes depending on the axis mode:
    // - for sync mode, all measures go to the 1st axsi
    // - for dual mode, the 1st measure goes to the 1st axis, the rest to the 2nd axis
    // - for multi mode, each measure goes into its own axis
    // If axisMode is unspecified, measures will be bucketed based on their `axis` property:
    // - measures with axis=axis2 will go onto the second axis
    // - all other measures will go onto the first axis
    //
    // @return {Object} {axis1, axis2, ... axiesN} (axis2... axisN could be null)
    measures2Axes: function measures2Axes(measures, axisMode, axisTitles) {
      var this$1 = this;

      if (!measures.length) {
        return {};
      }

      var buckets = function () {
        if (axisMode) {
          switch (axisMode) {
            case constants$1.AXIS_MODE.SYNC:
              return [measures];
            // all the measures in a single bucket

            case constants$1.AXIS_MODE.DUAL:
              return [[measures[0]], measures.slice(1)];
            // 1st measure on its own and the rest in another bucket

            case constants$1.AXIS_MODE.MULTI:
              return measures.map(function (measure) {
                return [measure];
              });
            // each measure in its own bucket
          }
        } else {
          var secondAxis = lodash__default.filter(measures, {
            axis: "axis2"
          });

          if (secondAxis.length) {
            return [lodash__default.filter(measures, function (m) {
              return m.axis !== "axis2";
            }), secondAxis];
          } else {
            return [measures]; // all the measures in a single bucket
          }
        }
      }();

      var axisMap = {};

      for (var i = 0; i < buckets.length; i++) {
        var meas = buckets[i];
        var axisName = "measureAxis" + (i + 1);
        axisMap[axisName] = this$1.measures2Axis(meas, axisTitles ? axisTitles[i] : undefined, axisName);
      }

      return axisMap;
    },
    // combine multiple measures into a single axis
    // and return the axis info
    //
    // @param measures {Array} array of measures
    // @param customTitle {String} custom title to use (otherwise, we concatenate the measure titles)
    // @param axisName {String, optional} if passed, the axisname will be set on each measure
    //
    // @return {Object} the axis info, or null (if measures is null or empty)
    measures2Axis: function measures2Axis(measures, customTitle, axisName) {
      if ((!measures || measures.length) <= 0) {
        return undefined;
      } // set axis name if needed


      measures.forEach(function (measure) {
        if (axisName) {
          measure.axis = axisName;
        }
      });
      var domain = domainUtils.mergeDomains(lodash__default.map(measures, "domain"));

      if (domain === null) {
        domain = undefined;
      }

      var referenceLines = lodash__default.flatten(lodash__default.map(measures, "referenceLines")).filter(function (r) {
        return r;
      });

      if (referenceLines.length === 0) {
        referenceLines = undefined;
      }

      return {
        title: customTitle,
        titleMaxLines: measures[0].titleMaxLines || 1,
        format: measures[0].format,
        domain: domain,
        referenceLines: referenceLines,
        scale: measures[0].scale
      };
    },
    measure2Axis: function measure2Axis(measure, customTitle) {
      if (!measure) {
        return undefined;
      }

      return this.measures2Axis([measure], customTitle);
    }
  };

  var Line$2 = function (Shap____1) {
    function Line() {
      Shap____1.apply(this, arguments);
    }

    if (Shap____1) Line.__proto__ = Shap____1;
    Line.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Line.prototype.constructor = Line;

    Line.initClass = function initClass() {
      this.type = "Line";
      this.shapeEffectsProps = ["fill", "stroke"];
    };

    Line.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.x0 = 0;
      props.x1 = 0;
      props.y0 = 0;
      props.y1 = 0;
      props.stroke = undefined;
      props.fill = undefined;
      props.vertical = false; // - true: line fill extends vetically, false: line fill extends horizontally

      props.baseYValue = 0; // - when vertical, this determines how far down the fill should extend

      props.baseXValue = 0; // - when horizontal, this determines how far to the left the fill should extend

      props.dashed = 0;
      props.lineWidth = 1;
      props.curveFunction = undefined;
    };

    Line.prototype.set = function set(props, value, silent) {
      this._forceRecomputeBoundingBox();

      return Shap____1.prototype.set.call(this, props, value, silent);
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Line.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x0", "x1", "baseXValue"],
        y: ["y0", "y1", "baseYValue"]
      };
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Line.prototype.rotate = function rotate() {
      Shap____1.prototype.rotate.call(this);
      this._props.vertical = !this._props.vertical;
      var assign;
      assign = [this._props.y0, this._props.y1, -this._props.x0, -this._props.x1], this._props.x0 = assign[0], this._props.x1 = assign[1], this._props.y0 = assign[2], this._props.y1 = assign[3];
      var assign$1;
      assign$1 = [this._props.baseYValue, -this._props.baseXValue], this._props.baseXValue = assign$1[0], this._props.baseYValue = assign$1[1];
      return this;
    };

    Line.prototype.offsetX = function offsetX(dx) {
      this._forceRecomputeBoundingBox();

      this._props.x0 += dx;
      this._props.x1 += dx;
      return this;
    };

    Line.prototype.offsetY = function offsetY(dy) {
      this._forceRecomputeBoundingBox();

      this._props.y0 += dy;
      this._props.y1 += dy;
      return this;
    };

    Line.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      var extraX = this._props.x0;
      var extraY = this._props.y0;

      if (this._props.fill) {
        if (this._props.vertical) {
          extraY = this._props.baseYValue;
        } else {
          extraX = this._props.baseXValue;
        }
      }

      var left = Math.min(this._props.x0, this._props.x1, extraX);
      var right = Math.max(this._props.x0, this._props.x1, extraX);
      var top = Math.min(this._props.y0, this._props.y1, extraY);
      var bottom = Math.max(this._props.y0, this._props.y1, extraY);
      return new Box({
        x: left,
        y: top,
        w: right - left,
        h: bottom - top
      });
    };

    return Line;
  }(Shape);

  Line$2.initClass();

  var Polygon = function (Shap____1) {
    function Polygon() {
      Shap____1.apply(this, arguments);
    }

    if (Shap____1) Polygon.__proto__ = Shap____1;
    Polygon.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Polygon.prototype.constructor = Polygon;

    Polygon.initClass = function initClass() {
      this.type = "Polygon";
      this.shapeEffectsProps = ["fill", "stroke"];
      this._sensitiveProps = new StaticArraySet(["points", "angle", "points_x", "points_y"]);
    };

    Polygon.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "Polygon";
      props.closePath = true;
      props.vertical = false;
      props.angle = 0;
      props.x = 0;
      props.y = 0;
      props.stroke = undefined;
      props.fill = undefined;
      props.points = []; // note: when setting the points property, we internally maintain 2 arrays: points_x and points_y.
      // This makes propertiesByScale a lot easier to manage.

      props.points_x = [];
      props.points_y = [];
      props.lineWidth = 1;
      props.lineJoin = 'miter';
    };

    Polygon.prototype._onChange = function _onChange(optionsDiff) {
      var diff;

      Shap____1.prototype._onChange.call(this, optionsDiff);

      if (diff = optionsDiff.points) {
        var value = diff[0];

        this._forceRecomputeBoundingBox();

        this._props.points_x = value.map(function (point) {
          return point[0];
        });
        this._props.points_y = value.map(function (point) {
          return point[1];
        });
      }

      if (optionsDiff.points_x || optionsDiff.points_y) {
        this._forceRecomputeBoundingBox();
      }

      if (optionsDiff.angle) {
        // only need to update rotation on cached bb
        if (this._trueBoundingBox != null) {
          this._trueBoundingBox.rotation = this.getRotation();
        }
      }
    };

    Polygon.prototype._mapValue = function _mapValue(prop, value) {
      value = Shap____1.prototype._mapValue.call(this, prop, value);

      if (prop === "angle") {
        return lodash__default.isNumber(value) ? value : 0;
      }

      return value;
    };

    Polygon.prototype.getRotation = function getRotation() {
      if (this._props.angle) {
        return {
          x: this._props.x,
          y: this._props.y,
          angle: this._props.angle
        };
      } else {
        return null;
      }
    };

    Polygon.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x", "points_x"],
        y: ["y", "points_y"]
      };
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Polygon.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      if (this._props.points_x) {
        var ref = [lodash__default.min(this._props.points_x), lodash__default.max(this._props.points_x)];
        var minX = ref[0];
        var maxX = ref[1];
        var ref$1 = [lodash__default.min(this._props.points_y), lodash__default.max(this._props.points_y)];
        var minY = ref$1[0];
        var maxY = ref$1[1];
        return new Box({
          x: this._props.x + minX,
          y: this._props.y + minY,
          w: maxX - minX,
          h: maxY - minY,
          rotation: this.getRotation()
        });
      } else {
        return null;
      }
    }; // @return {Number} area of a set of points.
    // Note that this used the extended definition of 'area' for concave polygons
    // (meaning the area could be negative or even null for some shapes)


    Polygon.prototype.area = function area(points) {
      points = dataUtils.zip(this._props.points_x, this._props.points_y);
      return geometryUtils.area(points);
    }; // @return {[x, y]} coordinates of centroid of polygon.
    // It is a more intelligent way of determining the center point
    // of a polygon (works on concave polygons)


    Polygon.prototype.centroid = function centroid() {
      var points = dataUtils.zip(this._props.points_x, this._props.points_y);
      return geometryUtils.centroid(points);
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Polygon.prototype.offsetY = function offsetY(dy) {
      Shap____1.prototype.offsetY.call(this, dy);
      this._props.y += dy;
      return this;
    };

    Polygon.prototype.offsetX = function offsetX(dx) {
      Shap____1.prototype.offsetX.call(this, dx);
      this._props.x += dx;
      return this;
    };

    Polygon.prototype.rotate = function rotate() {
      this._props.vertical = !this._props.vertical;
      var assign;
      assign = [this._props.points_y, this._props.points_x], this._props.points_x = assign[0], this._props.points_y = assign[1];
      this._props.points_y = this._props.points_y.map(function (y) {
        return -y;
      });
      return Shap____1.prototype.rotate.call(this);
    };

    return Polygon;
  }(Shape);

  Polygon.initClass(); //

  /**
   * Created by yi.chen on 4/28/17.
   */

  /*::(x: Path) => (x: IShape<*,*,*,*>)*/

  var Path$2 = function (Shap____1) {
    function Path(props, silent) {
      Shap____1.call(this, props, silent);
    }

    if (Shap____1) Path.__proto__ = Shap____1;
    Path.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Path.prototype.constructor = Path;

    Path.initClass = function initClass() {
      this.type = "Path";
      this.shapeEffectsProps = ["fill", "stroke"];
    };

    Path.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x", "points_x", "baseX"],
        y: ["y", "points_y", "baseY"]
      };
    };
    /**
     * Properties getter
     */


    Path.prototype.get = function get(prop) {
      if (prop === 'points') {
        return dataUtils.zip(this._props.points_x, this._props.points_y);
      } else {
        return Shap____1.prototype.get.call(this, prop);
      }
    };

    Path.prototype.set = function set(props, value, silent) {
      this._forceRecomputeBoundingBox();

      if (typeof props === "string") {
        if (props === "points") {
          this._setPositions(value);
        } else {
          return Shap____1.prototype.set.apply(this, arguments);
        }
      } else {
        this._setPositions(props.points);

        delete props.points;
        return Shap____1.prototype.set.apply(this, arguments);
      }

      return this;
    }; // Transpose


    Path.prototype.rotate = function rotate() {
      var ref = this._props;
      var x = ref.x;
      var y = ref.y;
      var points_x = ref.points_x;
      var points_y = ref.points_y;
      var baseX = ref.baseX;
      var baseY = ref.baseY;

      if (points_x && points_y) {
        this._props.points_x = points_y;
        this._props.points_y = points_x.map(function (x) {
          return -x;
        });
      }

      if (baseX != null || baseY != null) {
        this._props.baseX = baseY;
        this._props.baseY = -(baseX != null ? baseX : 0);
      }

      if (x != 0 || y != 0) {
        this._props.x = y;
        this._props.y = -x;
      }

      return Shap____1.prototype.rotate.call(this);
    };

    Path.prototype.offsetX = function offsetX(dx) {
      this._props.x += dx;

      if (this._trueBoundingBox) {
        this._trueBoundingBox.offset(dx, 0);
      }

      return this;
    };

    Path.prototype.offsetY = function offsetY(dy) {
      this._props.y += dy;

      if (this._trueBoundingBox) {
        this._trueBoundingBox.offset(0, dy);
      }

      return this;
    };

    Path.prototype.applyScales = function applyScales(scales) {
      if (scales.x) {
        this._offsetPoints('x', true);
      }

      if (scales.y) {
        this._offsetPoints('y', true);
      }

      Shap____1.prototype.applyScales.call(this, scales);

      if (scales.x) {
        this._offsetPoints('x', false);
      }

      if (scales.y) {
        this._offsetPoints('y', false);
      }

      return this;
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    Path.prototype._offsetPoints = function _offsetPoints(field, isPositive) {
      var offset = isPositive ? this._props[field] : -this._props[field];
      var list = field === 'x' ? this._props.points_x : this._props.points_y;

      for (var i = 0; i < list.length; ++i) {
        list[i] = list[i] + offset;
      }
    };

    Path.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.x = 0;
      props.y = 0;
      props.points = [];
      props.points_x = [];
      props.points_y = [];
      props.stroke = undefined;
      props.fill = undefined;
      props.dashed = 0;
      props.lineWidth = 1;
      props.closePath = false;
      props.baseX = undefined;
      props.baseY = undefined;
      props.lineJoin = 'round';
    };

    Path.prototype._setPositions = function _setPositions(points) {
      if (points && points.length) {
        this._props.points_x = [];
        this._props.points_y = [];
        var ref = this._props;
        var points_x = ref.points_x;
        var points_y = ref.points_y;

        for (var i = 0; i < points.length; ++i) {
          var point = points[i];
          points_x[i] = point[0];
          points_y[i] = point[1];
        }
      }
    };

    Path.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      var ref = this._props;
      var x = ref.x;
      var y = ref.y;
      var points_x = ref.points_x;
      var points_y = ref.points_y;

      if (points_x.length && points_y.length) {
        var ref$1 = mathUtils.getMinMax(points_x);
        var minX = ref$1[0];
        var maxX = ref$1[1];
        var ref$2 = mathUtils.getMinMax(points_y);
        var minY = ref$2[0];
        var maxY = ref$2[1];
        return new Box({
          x: x + minX,
          y: y + minY,
          w: maxX - minX,
          h: maxY - minY
        });
      }

      return new Box({
        x: 0,
        y: 0,
        w: 0,
        h: 0
      });
    };

    return Path;
  }(Shape);

  Path$2.initClass();

  var NumberText$2 = function (Text) {
    function NumberText() {
      Text.apply(this, arguments);
    }

    if (Text) NumberText.__proto__ = Text;
    NumberText.prototype = Object.create(Text && Text.prototype);
    NumberText.prototype.constructor = NumberText;

    NumberText.initClass = function initClass() {
      this.type = "NumberText";
      this.shapeEffectsProps = ["stroke", "bgColor"];
      this._sensitiveProps = new StaticArraySet(["number", "format", "compact", "size", "pivot"]);
    };

    NumberText.prototype._setDefaultProps = function _setDefaultProps() {
      Text.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.format = undefined;
      props.compact = true;
      props.number = undefined;
      return props.includeDescender = false;
    };

    NumberText.prototype._onChange = function _onChange(optionsDiff) {
      Text.prototype._onChange.call(this, optionsDiff);

      if (optionsDiff.number || optionsDiff.format || optionsDiff.compact) {
        var format = (optionsDiff.format != null ? optionsDiff.format[0] : undefined) != null ? optionsDiff.format != null ? optionsDiff.format[0] : undefined : this._props.format;
        var number = (optionsDiff.number != null ? optionsDiff.number[0] : undefined) != null ? optionsDiff.number != null ? optionsDiff.number[0] : undefined : this._props.number;
        var compact = (optionsDiff.compact != null ? optionsDiff.compact[0] : undefined) != null ? optionsDiff.compact != null ? optionsDiff.compact[0] : undefined : this._props.compact;
        var formatter = formatNumber(format, compact);
        this._props.text = formatter(number);
      }
    };

    return NumberText;
  }(Text$1);

  NumberText$2.initClass();

  var Point = function (Shap____1) {
    function Point() {
      Shap____1.apply(this, arguments);
    }

    if (Shap____1) Point.__proto__ = Shap____1;
    Point.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Point.prototype.constructor = Point;

    Point.initClass = function initClass() {
      this.type = "Point";
      this.shapeEffectsProps = ["fill", "stroke", "lineWidth", "r", "hidden", "texture"];
      this._sensitiveProps = new StaticArraySet(["size", "pivot"]);
    };

    Point.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "Point";
      props.x = 0;
      props.y = 0;
      props.r = 0;
      props.stroke = undefined;
      props.fill = undefined;
      props.lineWidth = 1;
      props.texture = undefined;
      props.hidden = false;
      props.showWhenCrossed = false;
    };

    Point.prototype.set = function set(props, value, silent) {
      this._forceRecomputeBoundingBox();

      return Shap____1.prototype.set.call(this, props, value, silent);
    };

    Point.prototype.domainBox = function domainBox() {
      return new Box({
        x: this._props.x,
        y: this._props.y,
        w: 0,
        h: 0
      });
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Point.prototype.offsetY = function offsetY(dy) {
      Shap____1.prototype.offsetY.call(this, dy);
      this._props.y += dy;
      return this;
    };

    Point.prototype.offsetX = function offsetX(dx) {
      Shap____1.prototype.offsetX.call(this, dx);
      this._props.x += dx;
      return this;
    };

    Point.prototype.rotate = function rotate() {
      Shap____1.prototype.rotate.call(this);
      var assign;
      assign = [this._props.y, -this._props.x], this._props.x = assign[0], this._props.y = assign[1];
      return this;
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------


    Point.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        x: ["x"],
        y: ["y"],
        r: ["r"]
      };
    };

    Point.prototype.isVisible = function isVisible() {
      return Shap____1.prototype.isVisible.call(this) && !(!this._select && this._props.hidden);
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Point.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      return new Box({
        x: this._props.x - this._props.r,
        y: this._props.y - this._props.r,
        w: 2 * this._props.r,
        h: 2 * this._props.r
      }).padAll(this._props.stroke ? this._props.lineWidth / 2 : 0);
    };

    return Point;
  }(Shape);

  Point.initClass(); //

  var Column = function Column(name, label) {
    this._name = name;
    this._label = label;
    this._internalOnly = false;
  };

  Column.prototype.getName = function getName() {
    return this._name;
  };

  Column.prototype.setType = function setType(type) {
    this._type = type;
    return this;
  };

  Column.prototype.getType = function getType() {
    return this._type;
  };

  Column.prototype.setLabel = function setLabel(label) {
    this._label = label;
    return this;
  };

  Column.prototype.getLabel = function getLabel() {
    return this._label;
  };

  Column.prototype.setValueLabels = function setValueLabels(valueLabels) {
    this._valueLabels = valueLabels;
    return this;
  };

  Column.prototype.getValueLabels = function getValueLabels() {
    return this._valueLabels;
  };

  Column.prototype.setValueColors = function setValueColors(valueColors) {
    this._valueColors = valueColors;
    return this;
  };

  Column.prototype.getValueColors = function getValueColors() {
    return this._valueColors;
  };

  Column.prototype.setIsAllNull = function setIsAllNull(isAllNull) {
    this._isAllNull = isAllNull;
    return this;
  };

  Column.prototype.isAllNull = function isAllNull() {
    return this._isAllNull;
  };

  Column.prototype.setInternalOnly = function setInternalOnly(inernalOnly) {
    this._internalOnly = inernalOnly;
    return this;
  };

  Column.prototype.isInternalOnly = function isInternalOnly() {
    return this._internalOnly;
  };

  Column.prototype.setInternalColumnName = function setInternalColumnName(internalColumnName) {
    this._internalColumnName = internalColumnName;
    return this;
  };

  Column.prototype.getInternalColumnName = function getInternalColumnName() {
    return this.isInternalOnly() ? this._name : this._internalColumnName;
  };

  Column.prototype.toJson = function toJson() {
    var ref = this;
    var _name = ref._name;
    var _type = ref._type;
    var _label = ref._label;
    var _isAllNull = ref._isAllNull;
    var _valueLabels = ref._valueLabels;
    var _valueColors = ref._valueColors;
    var _internalOnly = ref._internalOnly;
    var _internalColumnName = ref._internalColumnName;
    var json = {};

    if (this._name) {
      json.name = this._name;
    }

    if (this._type) {
      json.type = this._type;
    }

    if (this._label) {
      json.label = this._label;
    }

    if (this._isAllNull) {
      json.isAllNull = this._isAllNull;
    }

    if (this._valueLabels) {
      json.valueLabels = this._valueLabels;
    }

    if (this._valueColors) {
      json.valueColors = this._valueColors;
    }

    if (this._internalOnly) {
      json.internalOnly = this._internalOnly;
    }

    if (this._internalColumnName) {
      json.internalColumnName = this._internalColumnName;
    }

    return json;
  }; //


  var COLUMN_TYPE$4 = constants$1.COLUMN_TYPE;

  var DimensionColumn = function (Colum____1) {
    function DimensionColumn(name, label) {
      Colum____1.call(this, name, label);
      this.setType(COLUMN_TYPE$4.DIMENSION);
    }

    if (Colum____1) DimensionColumn.__proto__ = Colum____1;
    DimensionColumn.prototype = Object.create(Colum____1 && Colum____1.prototype);
    DimensionColumn.prototype.constructor = DimensionColumn;

    DimensionColumn.prototype.setCardinality = function setCardinality(cardinality) {
      this._cardinality = cardinality;
      return this;
    };

    DimensionColumn.prototype.getCardinality = function getCardinality() {
      return this._cardinality;
    };

    DimensionColumn.prototype.setHotSpots = function setHotSpots(hotSpots) {
      this._hotSpots = hotSpots;
      return this;
    };

    DimensionColumn.prototype.getHotSpots = function getHotSpots() {
      return this._hotSpots;
    };

    DimensionColumn.prototype.setGeoKey = function setGeoKey(geoKey) {
      this._geoKey = geoKey;
      return this;
    };

    DimensionColumn.prototype.getGeoKey = function getGeoKey() {
      return this._geoKey;
    };

    DimensionColumn.prototype.toJson = function toJson() {
      var ref = this;
      var _cardinality = ref._cardinality;
      var _hotSpots = ref._hotSpots;
      var _geoKey = ref._geoKey;
      var json = Colum____1.prototype.toJson.call(this);

      if (_cardinality) {
        json.cardinality = _cardinality;
      }

      if (_hotSpots) {
        json.hotSpots = _hotSpots;
      }

      if (_geoKey) {
        json.geoKey = _geoKey;
      }

      return json;
    };

    return DimensionColumn;
  }(Column); //


  var COLUMN_TYPE$5 = constants$1.COLUMN_TYPE;

  var GeoColumn = function (DimensionColum____1) {
    function GeoColumn(name, label) {
      DimensionColum____1.call(this, name, label);
      this.setType(COLUMN_TYPE$5.GEO);
    }

    if (DimensionColum____1) GeoColumn.__proto__ = DimensionColum____1;
    GeoColumn.prototype = Object.create(DimensionColum____1 && DimensionColum____1.prototype);
    GeoColumn.prototype.constructor = GeoColumn;

    GeoColumn.prototype.setGeoMap = function setGeoMap(geoMap) {
      this._geoMap = geoMap;
      return this;
    };

    GeoColumn.prototype.getGeoMap = function getGeoMap() {
      return this._geoMap;
    };

    GeoColumn.prototype.toJson = function toJson() {
      var ref = this;
      var _geoMap = ref._geoMap;
      var json = DimensionColum____1.prototype.toJson.call(this);

      if (_geoMap) {
        json.geoMap = _geoMap;
      }

      return json;
    };

    return GeoColumn;
  }(DimensionColumn); //


  var COLUMN_TYPE$6 = constants$1.COLUMN_TYPE;

  var MeasureColumn = function (Colum____1) {
    function MeasureColumn(name, label) {
      Colum____1.call(this, name, label);
      this.setType(COLUMN_TYPE$6.MEASURE);
    }

    if (Colum____1) MeasureColumn.__proto__ = Colum____1;
    MeasureColumn.prototype = Object.create(Colum____1 && Colum____1.prototype);
    MeasureColumn.prototype.constructor = MeasureColumn;

    MeasureColumn.prototype.setFormat = function setFormat(format) {
      this._format = format;
      return this;
    };

    MeasureColumn.prototype.getFormat = function getFormat() {
      return this._format;
    };

    MeasureColumn.prototype.setPercentFormat = function setPercentFormat(percentFormat) {
      this._percentFormat = percentFormat;
      return this;
    };

    MeasureColumn.prototype.getPercentFormat = function getPercentFormat() {
      return this._percentFormat;
    };

    MeasureColumn.prototype.setDomain = function setDomain(domain) {
      this._domain = domain;
      return this;
    };

    MeasureColumn.prototype.getDomain = function getDomain() {
      return this._domain;
    };

    MeasureColumn.prototype.toJson = function toJson() {
      var ref = this;
      var _format = ref._format;
      var _percentFormat = ref._percentFormat;
      var _domain = ref._domain;
      var json = Colum____1.prototype.toJson.call(this);

      if (_format) {
        json.format = _format;
      }

      if (_percentFormat) {
        json.percentFormat = _percentFormat;
      }

      if (_domain) {
        json.domain = _domain;
      }

      return json;
    };

    return MeasureColumn;
  }(Column); //


  var COLUMN_TYPE$7 = constants$1.COLUMN_TYPE;

  var TimeColumn = function (DimensionColum____1) {
    function TimeColumn(name, label) {
      DimensionColum____1.call(this, name, label);
      this.setType(COLUMN_TYPE$7.TIME);
      this.setFirstDayOfWeek(-1);
    }

    if (DimensionColum____1) TimeColumn.__proto__ = DimensionColum____1;
    TimeColumn.prototype = Object.create(DimensionColum____1 && DimensionColum____1.prototype);
    TimeColumn.prototype.constructor = TimeColumn;

    TimeColumn.prototype.setFormat = function setFormat(format) {
      this._format = format;
      return this;
    };

    TimeColumn.prototype.getFormat = function getFormat() {
      return this._format;
    };

    TimeColumn.prototype.setDataFormat = function setDataFormat(dataFormat) {
      this._dataFormat = dataFormat;
      return this;
    };

    TimeColumn.prototype.getDataFormat = function getDataFormat() {
      return this._dataFormat;
    };

    TimeColumn.prototype.setGranularity = function setGranularity(granularity) {
      this._dataGranularity = granularity;
      return this;
    };

    TimeColumn.prototype.getGranularity = function getGranularity() {
      return this._dataGranularity;
    };

    TimeColumn.prototype.setFirstDayOfWeek = function setFirstDayOfWeek(firstDayOfWeek) {
      this._firstDayOfWeek = firstDayOfWeek;
      return this;
    };

    TimeColumn.prototype.getFirstDayOfWeek = function getFirstDayOfWeek() {
      return this._firstDayOfWeek;
    };

    TimeColumn.prototype.setDataSeparator = function setDataSeparator(dataSeparator) {
      this._dataSeparator = dataSeparator;
      return this;
    };

    TimeColumn.prototype.getDataSeparator = function getDataSeparator() {
      return this._dataSeparator;
    };

    TimeColumn.prototype.setParser = function setParser(parser) {
      this._parser = parser;
      return this;
    };

    TimeColumn.prototype.getParser = function getParser() {
      return this._parser;
    };

    TimeColumn.prototype.setFormatter = function setFormatter(formatter) {
      this._formatter = formatter;
      return this;
    };

    TimeColumn.prototype.getFormatter = function getFormatter() {
      return this._formatter;
    };

    TimeColumn.prototype.setIsDiscrete = function setIsDiscrete(isDiscrete) {
      this._isDiscrete = isDiscrete;
      return this;
    };

    TimeColumn.prototype.isDiscrete = function isDiscrete() {
      return this._isDiscrete;
    };

    TimeColumn.prototype.toJson = function toJson() {
      var ref = this;
      var _format = ref._format;
      var _dataFormat = ref._dataFormat;
      var _dataGranularity = ref._dataGranularity;
      var _firstDayOfWeek = ref._firstDayOfWeek;
      var json = DimensionColum____1.prototype.toJson.call(this);

      if (_format) {
        json.format = _format;
      }

      if (_dataFormat) {
        json.dataFormat = _dataFormat;
      }

      if (_dataGranularity) {
        json.dataGranularity = _dataGranularity;
      }

      if (_firstDayOfWeek) {
        json.firstDay = _firstDayOfWeek;
      }

      return json;
    };

    return TimeColumn;
  }(DimensionColumn); //


  var COLUMN_TYPE$8 = constants$1.COLUMN_TYPE;
  var instance$8 = null;

  var ColumnFactory = function ColumnFactory() {};

  ColumnFactory.prototype.buildColumn = function buildColumn(column) {
    switch (column.type) {
      case COLUMN_TYPE$8.TIME:
        return this._buildTimeColumn(column);

      case COLUMN_TYPE$8.MEASURE:
        return this._buildMeasureColumn(column);

      case COLUMN_TYPE$8.GEO:
        return this._buildGeoColumn(column);

      default:
        return this._buildDimensionColumn(column);
    }
  };
  /**
  	 * Convert dimension column
  	 * @return {DimensionColumn}
  	 */


  ColumnFactory.prototype._buildGeoColumn = function _buildGeoColumn(column) {
    return new GeoColumn(column.column, column.label).setHotSpots(column.hotSpots).setValueColors(column.valueColors).setGeoKey(column.geoKey).setValueLabels(column.valueLabels).setGeoMap(column.geoMap).setCardinality(column.cardinality);
  };

  ColumnFactory.prototype._buildDimensionColumn = function _buildDimensionColumn(column) {
    return new DimensionColumn(column.column, column.label).setHotSpots(column.hotSpots).setValueColors(column.valueColors).setGeoKey(column.geoKey).setValueLabels(column.valueLabels).setCardinality(column.cardinality);
  };
  /**
  	 * Convert measure column
  	 * @return {MeasureColumn}
  	 */


  ColumnFactory.prototype._buildMeasureColumn = function _buildMeasureColumn(column) {
    return new MeasureColumn(column.column, column.label).setFormat(column.format).setPercentFormat(column.percentFormat).setDomain(column.domain);
  };
  /**
  	 * Convert time column
  	 * @return {MeasureColumn}
  	 */


  ColumnFactory.prototype._buildTimeColumn = function _buildTimeColumn(column) {
    var dataFormat = column.dataFormat;
    var format = column.format;
    var firstDayOfWeek = column.firstDayOfWeek;
    var dataSeparator = column.dataSeparator;
    return new TimeColumn(column.column, column.label).setFormat(format).setDataFormat(dataFormat).setGranularity(column.dataGranularity).setFirstDayOfWeek(firstDayOfWeek).setDataSeparator(dataSeparator).setHotSpots(column.hotSpots).setValueColors(column.valueColors).setValueLabels(column.valueLabels).setCardinality(column.cardinality).setParser(time.getParser(dataFormat, firstDayOfWeek, dataSeparator)).setFormatter(time.getFormatter(format || dataFormat, firstDayOfWeek)).setIsDiscrete(time.isDiscreteTimeFormat(dataFormat));
  };

  var ColumnFactory$1 = {
    getInstance: function getInstance() {
      if (instance$8 == null) {
        instance$8 = new ColumnFactory();
      }

      return instance$8;
    }
  }; //

  var RowsMetadata = function RowsMetadata(columns) {
    this._columns = columns.map(function (column) {
      return ColumnFactory$1.getInstance().buildColumn(column);
    });
    this._columnMap = this._buildColumnMap(this._columns);
  };

  RowsMetadata.prototype.setColumns = function setColumns(columns) {
    this._columns = columns;
    this._columnMap = this._buildColumnMap(this._columns);
    return this;
  };

  RowsMetadata.prototype._buildColumnMap = function _buildColumnMap(columns) {
    var columnMap = {};
    columns.forEach(function (column) {
      return columnMap[column.getName()] = column;
    });
    return columnMap;
  };

  RowsMetadata.prototype.getColumns = function getColumns(names) {
    var this$1 = this;

    if (!names) {
      return this._columns;
    } //@flow-ignore


    return names.map(function (name) {
      return this$1.getColumn(name);
    }).filter(function (a) {
      return a;
    });
  };
  /**
  	 * Get column metadata by column name
  	 * @param  {string} name of column
  	 * @return {TColumn} column metadata
  	 */


  RowsMetadata.prototype.getColumn = function getColumn(name) {
    return this._columnMap[name];
  };
  /**
  	 * Get all column metadata of a specific type
  	 * @param  {string} type
  	 * @return {Array<TColumn>} column
  	 */


  RowsMetadata.prototype.getColumnsByType = function getColumnsByType(type) {
    return this._columns.filter(function (column) {
      return column.getType() === type;
    });
  };

  RowsMetadata.prototype.toJson = function toJson() {
    return {
      columns: this._columns.map(function (column) {
        return column.toJson();
      })
    };
  };

  RowsMetadata.fromJson = function fromJson(json) {
    var rowsMetadata = new RowsMetadata([]);

    if (json.columns) {
      var columns = json.columns.map(function (column) {
        return ColumnFactory$1.getInstance().buildColumn(column);
      });
      rowsMetadata.setColumns(columns);
    }

    return rowsMetadata;
  }; //
  //@flow-ignore


  var COLUMN_TYPE$1 = constants$1.COLUMN_TYPE;

  var RowsFormatter = function RowsFormatter() {};

  RowsFormatter.prototype.formatRow = function formatRow(row, rowsMetadata) {
    var this$1 = this;
    row = rowsUtils$1.getRowWithoutInternalValue(row);
    var formattedRows = [];

    for (var columnName in row) {
      var value = row[columnName];
      var foramttedCell = this$1.formatColumn(columnName, value, rowsMetadata);
      foramttedCell && formattedRows.push(foramttedCell);
    }

    return formattedRows;
  };
  /**
  	 * Format percentage data on row
  	 */


  RowsFormatter.prototype.formatPercentData = function formatPercentData(row, rowsMetadata) {
    var this$1 = this;
    var percentData = rowsUtils$1.getRowInternalField(row, constants$1.PERCENTAGE_INFO_KEY);

    if (!percentData) {
      return null;
    }

    var groups = percentData.groups;
    var measures = percentData.measures;
    var groupNames = [];

    if (groups) {
      // for percentage in tooltip, show all the dimension names too.
      groupNames = groups.map(function (group) {
        return this$1.formatColumnValue(row[group], rowsMetadata && rowsMetadata.getColumn(group));
      });
    }

    return {
      measures: measures,
      group: groupNames.join(" - ")
    };
  };

  RowsFormatter.prototype.isPercentFormat = function isPercentFormat(format) {
    if (format == null) {
      format = ["", 1];
    }

    var formatter = format[0] || "";
    return formatter.indexOf("%") !== -1;
  };

  RowsFormatter.prototype.formatPercentValue = function formatPercentValue(value, columnMetadata) {
    var format = columnMetadata && columnMetadata.getPercentFormat() || constants$1.FORMAT.PERCENT.MEASURE;
    return formatNumber(format)(value);
  };
  /*
  	Formats a template text.
  	@param row {object}
  	@param template {string}
  	@param rowsMetadata {RowsMetadata}
  	@return displayLabel {string}
  
  	eg:
  	row: { "Region": "China", "Total Sales": 56593967}
  	template: "The Total Sales for [Region] is [Total Sales]
  
  	displayLabel: "The Total Sales for China is $56,593,967"
  */


  RowsFormatter.prototype.formatText = function formatText(row, template, rowsMetadata) {
    var this$1 = this;
    var displayLabel = template.replace("\\\[", "&#91;").replace("\\\]", "&#93;");
    var match;

    while (match = /\[([^\[\]]*)\]/.exec(displayLabel)) {
      var columnName = match[1];
      var formattedColumn = this$1.formatColumn(columnName, row[columnName], rowsMetadata);
      displayLabel = displayLabel.replace(match[0], formattedColumn.value);
    }

    displayLabel = displayLabel.replace("&#91;", "[").replace("&#93;", "]");
    return displayLabel;
  }; // returns [ formatedColumnName, formattedColumnValue ]


  RowsFormatter.prototype.formatColumn = function formatColumn(name, value, rowsMetadata, percentData) {
    var columnMetadata = rowsMetadata && rowsMetadata.getColumn(name);
    var type = columnMetadata && columnMetadata.getType();
    var formattedValue = value == null ? LOC.getLabel("wave-charts", "nullLabel") : this.formatColumnValue(value, columnMetadata);
    var column = {
      label: this.formatColumnName(columnMetadata),
      value: formattedValue,
      type: type
    }; // TODO cleanup this file to use Column properly

    if (type === COLUMN_TYPE$1.MEASURE) {
      //@flow-ignore
      var format = columnMetadata && columnMetadata.getFormat();

      if (percentData && percentData.measures && percentData.measures[name] && !this.isPercentFormat(format)) {
        var ref = percentData.measures[name];
        var percent = ref.percent;
        var total = ref.total; //@flow-ignore

        column.percentData = {
          group: percentData.group,
          //@flow-ignore
          percent: this.formatPercentValue(percent, columnMetadata),
          total: this.formatMeasureValue(total, columnMetadata, true)
        };
      }
    }

    return column;
  };

  RowsFormatter.prototype.formatColumnName = function formatColumnName(columnMetadata) {
    if (!columnMetadata) {
      return undefined;
    }

    var column = columnMetadata.getName();
    var label = columnMetadata.getLabel();
    return label !== undefined ? label : column;
  };

  RowsFormatter.prototype.formatColumnValue = function formatColumnValue(value, columnMetadata, compact) {
    var type = columnMetadata && columnMetadata.getType();

    switch (type) {
      case COLUMN_TYPE$1.DIMENSION:
        return this.formatDimensionValue(value, columnMetadata);

      case COLUMN_TYPE$1.MEASURE:
        return this.formatMeasureValue(value, columnMetadata);

      case COLUMN_TYPE$1.TIME:
        return this.formatTimeValue(value, columnMetadata);

      default:
        return this._fallbackFormatValue(value, columnMetadata, compact);
    }
  };

  RowsFormatter.prototype._fallbackFormatValue = function _fallbackFormatValue(value, columnMetadata, compact) {
    if (lodash__default.isNumber(value)) {
      return this.formatMeasureValue(value, columnMetadata, compact);
    } else {
      return this.formatDimensionValue(value, columnMetadata);
    }
  };

  RowsFormatter.prototype.formatDimensionValue = function formatDimensionValue(value, columnMetadata) {
    if (!columnMetadata) {
      return value;
    }

    var valueLabels = columnMetadata.getValueLabels();
    var valueLabel = value == null ? LOC.getLabel("wave-charts", "nullLabel") : value;

    if (valueLabels) {
      var label = valueLabels[value];
      return label !== undefined ? label : valueLabel;
    } else {
      return valueLabel;
    }
  };

  RowsFormatter.prototype.formatMeasureValue = function formatMeasureValue(value, columnMetadata, compact) {
    //if formatter is supplied, use it
    var format = columnMetadata && columnMetadata.getFormat(); //if no format, will use default formatter
    // e.g. 2310000 -> 2,310,000

    return formatNumber(format, compact)(value);
  };

  RowsFormatter.prototype.formatTimeValue = function formatTimeValue(value, columnMetadata) {
    var dataFormat = columnMetadata.getDataFormat();
    var format = columnMetadata.getFormat();
    var valueLabels = columnMetadata.getValueLabels();
    var firstDayOfWeek = columnMetadata.getFirstDayOfWeek();
    var dataSeparator = columnMetadata.getDataSeparator();

    if (valueLabels && valueLabels[value]) {
      return valueLabels[value];
    }

    if (!format) {
      return value;
    }

    var formatter = columnMetadata.getFormatter() || time.getFormatter(format || dataFormat, firstDayOfWeek);

    if (lodash__default.isNumber(value)) {
      // if value is already in utc (eg a number), format it
      return formatter(value);
    } else if (value == null) {
      return "";
    } else {
      var parser = columnMetadata.parser || time.getParser(dataFormat, firstDayOfWeek, dataSeparator);
      var parsedValue = parser(value);
      return parsedValue == null || isNaN(parsedValue.valueOf()) ? value : formatter(parsedValue);
    }
  };

  var RowsFormatter$1 = singleton(RowsFormatter);
  /**
   *
   * Interval search tree implemented using a BST
   * Partially ported from https://algs4.cs.princeton.edu/93intersection/IntervalST.java.html
   *
   * Created by bmo
   *
   */

  var Node$3 = function Node(interval, value) {
    this.interval = interval;
    this.value = value;
    this.n = 1;
    this.max = interval.max;
  };

  var IntervalSearchTree = function IntervalSearchTree() {};

  IntervalSearchTree.prototype.get = function get(interval) {
    return this._get(this.root, interval);
  };

  IntervalSearchTree.prototype.put = function put(interval, value) {
    this.root = this._insert(this.root, interval, value);
  }; // remove and return value associated with given interval.
  // if no such interval exists return null


  IntervalSearchTree.prototype.remove = function remove(interval) {
    var value = this.get(interval);
    this.root = this._remove(this.root, interval);
    return value;
  }; // return an interval in data structure that intersects the given inteval;
  // return null if no such interval exists
  // running time is proportional to log N


  IntervalSearchTree.prototype.search = function search(interval) {
    return this._search(this.root, interval);
  };

  IntervalSearchTree.prototype.size = function size() {
    return this._size(this.root);
  };

  IntervalSearchTree.prototype._get = function _get(node, interval) {
    if (!node) {
      return null;
    }

    var cmp = this._compareTo(interval, node.interval);

    if (cmp < 0) {
      return this._get(node.left, interval);
    } else if (cmp > 0) {
      return this._get(node.right, interval);
    } else {
      return node.value;
    }
  }; // May want to make new node the root with uniform probabiity for large dataset


  IntervalSearchTree.prototype._insert = function _insert(node, interval, value) {
    if (!node) {
      return new Node$3(interval, value);
    }

    var cmp = this._compareTo(interval, node.interval);

    if (cmp < 0) {
      node.left = this._insert(node.left, interval, value);
    } else {
      node.right = this._insert(node.right, interval, value);
    }

    this._updateCountAndMax(node);

    return node;
  };

  IntervalSearchTree.prototype._remove = function _remove(node, interval) {
    if (!node) {
      return null;
    }

    var cmp = this._compareTo(interval, node.interval);

    if (cmp < 0) {
      node.left = this._remove(node.left, interval);
    } else if (cmp > 0) {
      node.right = this._remove(node.right, interval);
    } else {
      node = this._joinLR(node.left, node.right);
    }

    this._updateCountAndMax(node);

    return node;
  }; // look in subtree rooted at node


  IntervalSearchTree.prototype._search = function _search(node, interval) {
    var this$1 = this;

    while (node) {
      if (this$1._intersects(interval, node.interval)) {
        return node.interval;
      } else if (!node.left) {
        node = node.right;
      } else if (node.left.max < interval.min) {
        node = node.right;
      } else {
        node = node.left;
      }
    }

    return null;
  };

  IntervalSearchTree.prototype._size = function _size(node) {
    if (!node) {
      return 0;
    } else {
      return node.n;
    }
  };

  IntervalSearchTree.prototype._intersects = function _intersects(interval1, interval2) {
    if (interval2.max < interval1.min) {
      return false;
    }

    if (interval1.max < interval2.min) {
      return false;
    }

    return true;
  };

  IntervalSearchTree.prototype._compareTo = function _compareTo(interval1, interval2) {
    if (interval1.min < interval2.min) {
      return -1;
    } else if (interval1.min > interval2.min) {
      return +1;
    } else if (interval1.max < interval2.max) {
      return -1;
    } else if (interval1.max > interval2.max) {
      return +1;
    } else {
      return 0;
    }
  };

  IntervalSearchTree.prototype._joinLR = function _joinLR(lNode, rNode) {
    if (!lNode) {
      return rNode;
    }

    if (!rNode) {
      return lNode;
    }

    if (Math.random() * (this._size(lNode) + this._size(rNode)) < this._size(lNode)) {
      lNode.right = this._joinLR(lNode.right, rNode);

      this._updateCountAndMax(lNode);

      return lNode;
    } else {
      rNode.left = this._joinLR(lNode, rNode.left);

      this._updateCountAndMax(rNode);

      return rNode;
    }
  };

  IntervalSearchTree.prototype._updateCountAndMax = function _updateCountAndMax(node) {
    if (!node) {
      return;
    }

    node.n = 1 + this._size(node.left) + this._size(node.right);
    node.max = this._max3(node.interval.max, this._max(node.left), this._max(node.right));
  };

  IntervalSearchTree.prototype._max = function _max(node) {
    if (!node) {
      return Number.MIN_SAFE_INTEGER;
    }

    return node.max;
  }; // precondition: a is not null


  IntervalSearchTree.prototype._max3 = function _max3(a, b, c) {
    return Math.max(a, Math.max(b, c));
  };

  var rowsFormatter = RowsFormatter$1.getInstance();
  var adjustPlotUtils = {
    // Adjust fill opacity of area under lines
    // - when showZero, fill base is always zero
    // - when not showZero, fill base is the min/max of the domain
    //
    // @param {Array} layers with lines to adjust
    // @param {Boolean} vertical line or horizontal line
    // @param {Number} fillOpacity of area fill
    // @param {Boolean} showZero - whether zero is included in the domain
    // @param {Object} scale of the line layers
    adjustLineFill: function adjustLineFill(layers, vertical, fillOpacity, showZero, scale) {
      var domain;
      layers = dataUtils.ensureArray(layers);
      var baseValue = !showZero ? (domain = scale.domain(), domain[0] > 0 ? domain[0] : domain[1] < 0 ? domain[1] : 0) : 0;
      baseValue = scale.scale(baseValue);
      layers.forEach(function (layer) {
        layer.find({
          type: "Path"
        }).forEach(function (line) {
          line.set({
            fill: line.get("fill") || line.get("stroke").adjustOpacity(fillOpacity)
          });
          return line.set(vertical ? {
            baseY: baseValue
          } : {
            baseX: baseValue
          });
        });
      });
    },
    // Ajust bar text orientation and visibility according to space available
    //
    // vertical bar - first try text width all fit within barSize, then text height, then hidden
    // horizontal bar - first try text height all fit within barSize, then hidden
    //
    // @param {Array} layers with bars to adjust
    // @param {Boolean} vertical line or horizontal line
    // @param {Number} barSize - whether zero is included in the domain
    // @param {Number} padding of the line layers
    // @param {Number} barTextSize of the line layers
    adjustBarText: function adjustBarText(layers, vertical, barSize, padding, barTextSize) {
      layers = dataUtils.ensureArray(layers);
      var bars = lodash__default.flatten(layers.map(function (layer) {
        return layer.find({
          type: "Rect"
        });
      }));
      var availableSize = barSize - 2 * padding;
      var Delegate = WaveChartsRuntime.getDelegate();
      var textRotate = vertical ? lodash__default.every(bars, function (bar) {
        return Delegate.getTextWidth(bar.get("text")) <= availableSize;
      }) : false;
      var displayText = textRotate ? true : barTextSize <= availableSize + 0.1;
      var prop = displayText ? {
        textRotate: textRotate
      } : {
        text: null
      };
      bars.forEach(function (bar) {
        return bar.set(prop);
      });
    },

    /**
     * Hide line labels if they overlap.  It uses sweepline algorithm.
     * @param {array} allLabelsInof label related info e.g. associated point and text
     **/
    adjustLineLabels: function adjustLineLabels(allLabelsInfo) {
      if (allLabelsInfo.length < 2) {
        return;
      } // Start and end events for sweepline for y-direction.


      var events = [];

      for (var i = 0; i < allLabelsInfo.length; i++) {
        var labelInfo = allLabelsInfo[i];
        var text = labelInfo.text;
        var labelX = text.get("x");
        var labelY = text.get("y");
        var vertical = text.get("vertical");
        var labelSizeY = vertical ? text.getTextW() : text.getTextH();
        var labelSizeX = vertical ? text.getTextH() : text.getTextW();
        var xMin = labelX - labelSizeX / 2;
        var xMax = labelX + labelSizeX / 2;
        var yMin = labelY - labelSizeY / 2;
        var yMax = labelY + labelSizeY / 2;
        var key = labelInfo.point.key;
        events.push({
          y: yMin,
          yMax: yMax,
          xMin: xMin,
          xMax: xMax,
          key: key,
          labelInfo: labelInfo
        });
        events.push({
          y: yMax,
          yMax: yMax,
          xMin: xMin,
          xMax: xMax,
          key: key
        });
      } // sorting y ascendingly


      events.sort(function (a, b) {
        return a.y - b.y;
      }); // Run sweep-line algorithm. Scanning y-direction

      var st = new IntervalSearchTree();

      for (var i$1 = 0; i$1 < events.length; i$1++) {
        var ref = events[i$1];
        var y = ref.y;
        var yMax$1 = ref.yMax;
        var xMin$1 = ref.xMin;
        var xMax$1 = ref.xMax;
        var key$1 = ref.key;
        var labelInfo$1 = ref.labelInfo;
        var intervalX = {
          min: xMin$1,
          max: xMax$1
        }; // Remove the interval if the sweepline hits the end of the label

        if (y === yMax$1) {
          // remove only if the interval belongs to the event
          if (st.get(intervalX) === key$1) {
            st.remove(intervalX);
          } // It is the start of the label

        } else {
          // Check if the label overlaps
          if (st.search(intervalX)) {
            labelInfo$1.text.set({
              opacity: 0
            });
          } else {
            st.put(intervalX, key$1);
          }
        }
      }
    },
    adjustPointFill: function adjustPointFill(points, radiusLayout, positiveOpacity, negativeOpacity) {
      if (positiveOpacity == undefined) {
        return;
      }

      if (radiusLayout && !radiusLayout.isConstant()) {
        // radius reflecting a measure, opacity depends on the measure value
        var radiusField = radiusLayout.getField();
        points.forEach(function (point) {
          var fillOpacity = point.get("data").row[radiusField.getName()] < 0 ? negativeOpacity : positiveOpacity;
          point.set({
            fill: point.get("fill").adjustOpacity(fillOpacity)
          });
        });
      } else {
        // always adjust fill opacity to positiveOpacity
        points.forEach(function (point) {
          point.set({
            fill: point.get("fill").adjustOpacity(positiveOpacity)
          });
        });
      }
    },
    // Truncate columns to a certain width so that the total width is within a given value
    //
    // The rule is to truncate from the widest column, if not enough, the second widest, and so on.
    // Also all truncated columns will be of the same width, and no smaller than untruncated columns.
    //
    // e.g.
    //   c0     c1    c2
    // |123456|12345|1234|
    // |      |     |    |
    //
    // totalSize 12
    // overflow = 15 - 12 = 3
    //
    // - 1. try to only truncate c0, no smaller than c1
    //      c0 -> 5 save -> 1
    //      save < overflow, not enough
    // - 2. try to truncate c0, c1, to have same size and no smaller than c2
    //      c0 -> 4 c1 -> 4 save -> 3
    //		save = overflow, success
    //
    //   c0   c1   c2
    // |1..6|1..5|1234|
    // |    |    |    |
    //
    // @param {Array} columnsSizes array of column sizes
    // @param {Number} totalSize the maximum of all column sizes sum up
    // @return {Object} a map of index of column to truncate and the truncated max size, returns
    //                  null if no truncation is needed
    truncateColumns: function truncateColumns(columnSizes, totalSize) {
      var overflow = mathUtils.sum(columnSizes) - totalSize;

      if (overflow <= 0) {
        return null;
      }

      if (columnSizes.length > 1) {
        overflow += 1;
      }

      var columns = columnSizes.map(function (size, index) {
        return {
          index: index,
          size: size
        };
      }).sort(function (c1, c2) {
        return c2.size - c1.size;
      });
      var sortedSizes = lodash__default.map(columns, "size");

      for (var i = 0; i < columns.length; i++) {
        var newSize = (mathUtils.sum(sortedSizes.slice(0, i + 1 || undefined)) - overflow) / (i + 1);
        var minSize = i === columns.length - 1 ? 0 : columns[i + 1].size;

        if (newSize >= minSize) {
          var columnsTruncation = {};

          for (var j = 0, end = i, asc = 0 <= end; asc ? j <= end : j >= end; asc ? j++ : j--) {
            columnsTruncation[columns[j].index] = newSize;
          }

          return columnsTruncation;
        }
      }

      return null;
    },

    /**
     * formatting info for a text according to the measure, valuetype and percent sign in formatter string
     * @param  {String} valueType
     * @param  {Object} measure
     * @return {Object} format info
     *    keySuffix { String } to prevent animation between numebrs of different format
     *    format { Array } final measure format depending on valueType
     *    valueType { String } valueType of data
     *    compact { boolean }
     *    formatter { Function(text: String) }
     *    textFct { Function(text: String) } Function to format the text
     */
    getFormatInfo: function getFormatInfo(valueType, measure) {
      var ref = constants$1.VALUETYPE;
      var COMPACT_NUMBER = ref.COMPACT_NUMBER;
      var PERCENT = ref.PERCENT;
      var NUMBER = ref.NUMBER;
      var NONE = ref.NONE;
      var measureFormat = measure.getFormat();
      var compactDecimalDigits = measureFormat && measureFormat[2] && measureFormat[2].compactDecimalDigits;
      var isImpliedPercent = rowsFormatter.isPercentFormat(measureFormat);
      var compact = valueType === COMPACT_NUMBER && (!isImpliedPercent || compactDecimalDigits >= 0);
      valueType = rowsFormatter.isPercentFormat(measureFormat) && valueType !== NONE || valueType === NUMBER ? COMPACT_NUMBER : valueType;
      var format = valueType === PERCENT ? measure.getPercentFormat() || constants$1.FORMAT.PERCENT.MEASURE : measure.getFormat() || [null, 1];
      var formatter = formatNumber(format, compact);
      return {
        keySuffix: (format[0] ? format[0] : "") + format[1] + compact,
        format: format,
        valueType: valueType,
        compact: compact,
        formatter: formatter,
        textFct: function textFct(data) {
          switch (valueType) {
            case constants$1.VALUETYPE.NONE:
              return "";

            case constants$1.VALUETYPE.PERCENT:
              return formatter(percentageUtils.getDataPercent(data, measure.getName()));

            default:
              return formatter(data[measure.getName()]);
          }
        }
      };
    },
    // measure text
    getTextWidth: function getTextWidth(text, size) {
      var Delegate = WaveChartsRuntime.getDelegate();
      return Delegate.getTextWidth(text, size);
    },
    // get real text height
    getTextHeight: function getTextHeight(size) {
      var Delegate = WaveChartsRuntime.getDelegate();
      return Delegate.getRealFontSize(size);
    },
    // Take a layerbuilder function and return new layerbuilder function
    // which produces rotated shapes
    //
    // It does this by 'hijacking' the cell from the params map
    // and first 'rotating' the cell. This way, the layerbuilder
    // function can access params.cell.w and params.cell.h correctly.
    //
    // The cell is then restored to its initial value.
    rotateBuilderFct: function rotateBuilderFct(layerBuilderFct) {
      return function () {
        var args = [],
            len = arguments.length;

        while (len--) {
          args[len] = arguments[len];
        }

        var ref = args[0];
        var cell = ref.cell;
        var scene = cell.getScene(); // 'fake' rotate

        cell.set({
          w: cell.get("h"),
          h: cell.get("w")
        });
        scene.get("transforms").rotate = !scene.get("transforms").rotate;
        var layer = layerBuilderFct.apply(void 0, args); // 'rotate' back

        cell.set({
          w: cell.get("h"),
          h: cell.get("w")
        });
        scene.get("transforms").rotate = !scene.get("transforms").rotate;

        if (layer) {
          return layer.rotate();
        }
      };
    },
    getMeasureAxisCellHeight: function getMeasureAxisCellHeight(format, valueType) {
      var longNumber = 444.4;
      var longSuffix = 'M';

      var ref = NumberFit._getFormatParts(longNumber, format);

      var prefix = ref.prefix;
      var suffix = ref.suffix;
      var number = formatNumber(undefined, true, true)(longNumber);
      return WaveChartsRuntime.getDelegate().getTextWidth(prefix + number + longSuffix + suffix);
    }
  };
  var PADDING = 2;
  /**
   * Add value function definition for data property to params
   *
   * - combine all the column names of fields referenced in params
   *   and append a valueFct definition for data property which
   *   picks values from above columns out of a row
   *
   * @param params {Object} map of value function definition
   * @return {Object} params with data
   */

  var addDataParam = function addDataParam(params) {
    if (params.data) {
      return params;
    }

    params.data = {
      value: function value(row) {
        return {
          row: row
        };
      }
    };
    return params;
  };
  /**
   * Plot a series of shapes
   *
   * - {ValueFct Def} is definition for value function, {field, scale, value}
   * - params map describes {ValueFct Def} for each property of Shape
   * - layer by default is selectable and hoverable
   *
   * @param Shape {Function} shape constructor
   * @param params {Object} params for plotter
   * @param rows {Array} rows
   * @return {Layer} layer with shapes
   */


  var plot = function plot(Shape, params, rows, layer) {
    if (!layer) {
      layer = new Layer({
        canSelect: true,
        canHover: true,
        key: "plot"
      });
    }

    var valueMapFct = valueFctUtils.getValueMapFct(addDataParam(params));
    rows.forEach(function (row) {
      new Shape(valueMapFct(row)).appendTo(layer);
    });
    return layer;
  };
  /**
   * Plot a series of lines
   *
   * {ValueFct Def} is definition for value function, {field, scale, value}
   *
   * params:
   *   key {ValueFct Def} line point key
   *   x {ValueFct Def} line point x
   *   y {ValueFct Def} line point y
   *   stroke {ValueFct Def} line point fill and line color
   *   lineWidth {Number} line width
   *   pointRadius {Number} line point radius
   *   showPoints {Boolean} if to show points on lines
   *   categories {Object} category map to determine whether to connect two points
   *   lines {Object} connect lines by { field }
   *   missingValue {Boolean} how to handle missing values between points
   *   axisOptions {Object} map of axis name by x/y dimension
   *
   * @param params {Object} params for plotter
   * @param rows {Array} rows
   * @return {Layer} layer with lines and line points
   */


  var line = function line(params, rows) {
    var pointParams = lodash__default.pick(params, ["key", "x", "y", "stroke", "data"]);
    var accessibility = params.accessibility;
    var categories = params.categories;
    var missingValue = params.missingValue;
    var pointRadius = params.pointRadius;
    var showPoints = params.showPoints;
    var connect = missingValue === constants$1.MISSING_VALUE.CONNECT;
    var disconnect = missingValue === constants$1.MISSING_VALUE.DISCONNECT;
    var cumulative = missingValue === constants$1.MISSING_VALUE.CUMULATIVE;
    var overallCumulative = cumulative || missingValue === constants$1.MISSING_VALUE.CUMULATIVE_UNTIL_LAST_DATA;
    var selectionShapeEffect = [new Point().get("selectionShapeEffect"), HaloSelectionShapeEffect.getDescriptor()];
    pointParams.r = {
      value: pointRadius
    };
    pointParams.fill = pointParams.stroke;
    pointParams.selectionShapeEffect = {
      value: selectionShapeEffect
    };

    if (accessibility) {
      pointParams.accessibility = accessibility;
    }

    delete pointParams.stroke;
    var yFct;
    var reversedCat = [];

    if (!connect && categories) {
      yFct = valueFctUtils.getValueFct({
        field: params.y.field
      }, params.y.useParsedData); // Build a reversed categories for looking up an existing category by index.
      // The last category of the same index will win.  e.g. categories of { ..., 2012-Q4-AP: 11, 2012-Q4-US: 11 }
      // reversedCat[11] = 2012-Q4-US

      if (overallCumulative) {
        var catKeys = Object.keys(categories);

        for (var i = 0, len = catKeys.length; i < len; i++) {
          var catKey = catKeys[i];
          reversedCat[categories[catKey]] = catKey;
        }
      }
    }

    var layer = plot(Point, pointParams, rows).set({
      zIndex: 1,
      staggerAnim: false,
      axisOptions: params.axisOptions
    });
    layer.groupByField(params.lines ? params.lines.field : null).forEach(function (group, i) {
      var points = group.sortBy(function (point) {
        return point.get("y");
      }).getChildren().map(function (p) {
        return p.set({
          hidden: !showPoints,
          showWhenCrossed: !showPoints
        });
      });
      var pathGroups = [points]; // Go through each point to see any gaps in between and reconstruct a new pathGroups

      if (points.length > 1 || points.length && overallCumulative) {
        if (!connect && categories) {
          pathGroups = [[points[0]]];
          var cIndexCurrPt, cIndexLastPt, lastGroup;
          var yScale = params.y.scale;

          for (var i$1 = 1; i$1 < points.length; ++i$1) {
            lastGroup = pathGroups[pathGroups.length - 1];
            var point = points[i$1];
            var lastPoint = points[i$1 - 1];
            cIndexLastPt = cIndexCurrPt || categories[yFct(lastPoint.get("data").row)];
            cIndexCurrPt = categories[yFct(point.get("data").row)]; // If adjacent points, put it into the last group.

            if (cIndexCurrPt - cIndexLastPt === 1) {
              lastGroup.push(point);
            } else if (disconnect) {
              // new path group
              pathGroups.push([point]);
            } else if (overallCumulative) {
              // Adding a culmuative dummy point that extends from the last point
              lastGroup.push(new Point({
                key: "cumulative" + i$1,
                x: lastPoint.get("x"),
                // x is extended from the previous point
                y: yScale.scale(reversedCat[cIndexCurrPt - 1]) // y is the previous category of the current point

              }));
              lastGroup.push(point);
            }
          } // Extend the line from the last point to the last category in chart. ie. extending the line to the end of the chart


          if (cumulative) {
            var lastPoint$1 = points[points.length - 1]; // Make sure the last point is not sitting at the last reversed category index. Ok to extend the line.

            if (categories[yFct(lastPoint$1.get("data").row)] < reversedCat.length - 1) {
              // Adding a dummy point at the last category.
              pathGroups[0].push(new Point({
                key: "cumulative-end",
                x: lastPoint$1.get("x"),
                y: yScale.scale(reversedCat[reversedCat.length - 1])
              }));
            }
          }
        }

        pathGroups.forEach(function (points, j) {
          var pathParams = {
            points: points.map(function (p) {
              return [p.get("x"), p.get("y")];
            }),
            stroke: points[0].get('fill'),
            lineWidth: params.lineWidth,
            dashed: params.dashed,
            canSelect: false,
            key: "measure-path-" + points[0].get('key') + "-" + points[points.length - 1].get('key') + "-" + j,
            canHover: false
          };
          new Path$2(pathParams).prependTo(group);
        });
      }

      pathGroups.filter(function (g) {
        return g.length === 1;
      }).forEach(function (g) {
        return g[0].set({
          hidden: false,
          showWhenCrossed: false
        });
      });
    }).flatten();
    return layer;
  };
  /**
   * Plot a series of areas (polygons) defined by points from *both* two measures.
   * One polyon per group
   *
   * {ValueFct Def} is definition for value function, {field, scale, value}
   *
   * params:
   *   x {ValueFct Def} line point x
   *   y {ValueFct Def} line point y
   *   stroke {ValueFct Def} line point fill and line color
   *   groups {Object} group by { field }
   *
   * @param area {Array} Two measures defining the area
   * @param rows {Array} rows
   * @param {Layer} layer where the polygons attach to.
   */


  var area = function area(_area2, params, rows, layer) {
    var groups = {}; // Lines can be grouped by fields.  If there is no grouping, groupKey is "default"

    var groupKeyFct = params.groups ? valueFctUtils.getValueFct(params.groups) : function (row) {
      return "default";
    };
    delete params.groups;
    params.high = {
      field: _area2[0]
    };
    params.low = {
      field: _area2[1]
    };
    var valueMapFct = valueFctUtils.getValueMapFct(params);
    rows.forEach(function (row) {
      var ref = valueMapFct(row);
      var high = ref.high;
      var low = ref.low;
      var y = ref.y;
      var stroke = ref.stroke;
      var groupKey = groupKeyFct(row);
      var groupData = groups[groupKey] = groups[groupKey] || {
        high: [],
        low: []
      };

      if (y !== undefined) {
        if (high !== undefined) {
          groupData.high.push([high, y]);
        }

        if (low !== undefined) {
          groupData.low.push([low, y]);
        }
      } // fill color for the polygon in the group


      groupData.fill = stroke;
    });
    lodash__default.values(groups).map(function (groupData, i) {
      var highPoints = groupData.high;
      var lowPoints = groupData.low;
      var points = lodash__default.sortBy(highPoints, function (point) {
        return point[1];
      }).concat(lodash__default.sortBy(lowPoints, function (point) {
        return -point[1];
      })); // highPoints.length > 0 && lowPoints.length > 0 ensures the polygon is formed by both measures.
      // And polygon needs at least 3 points.

      if (highPoints.length > 0 && lowPoints.length > 0 && highPoints.length + lowPoints.length > 2) {
        new Path$2({
          key: "area-" + i,
          lineWidth: 0,
          fill: groupData.fill.adjustOpacity(0.4),
          stroke: groupData.fill,
          points: points,
          canHover: false,
          closePath: true
        }).prependTo(layer);
      }
    });
  };
  /**
   * Plot a series of bars
   *
   * {ValueFct Def} is definition for value function, {field, scale, value}
   *
   * params:
   *   key {ValueFct Def} bar key
   *   x {ValueFct Def} bar x
   *   y {ValueFct Def} bar y
   *   w {ValueFct Def} bar width
   *   h {ValueFct Def} bar height
   *   text {ValueFct Def} bar text
   *   fill {ValueFct Def} bar fill
   *   textInside {ValueFct Def} textInside property of bar
   *   textCenter {ValueFct Def} textCenter property of bar
   *   layout {Object} bars layout { field, type }, group by field and layout type
   *   axisOptions {Object} map of axis name by x/y dimension
   *
   * @param params {Object} params for plotter
   * @param rows {Array} rows
   * @return {Layer} layer with bars
   */


  var rect = function rect(params, rows) {
    var rectParams = lodash__default.pick(params, ["key", "x", "y", "w", "h", "text", "fill", "textInside", "textCenter", "textColorLight", "textColorDark", "accessibility", "data"]);
    var textfct = params.text;
    var layout = params.layout;
    var layer = plot(Rect$3, rectParams, rows).set({
      zIndex: 0,
      axisOptions: params.axisOptions
    });

    if (layout) {
      var field = layout.field;
      var stack = layout.stack;
      var stackField = stack && stack.column && stack.column[0];
      var layoutOptions;
      layer.groupByField(field).forEach(function (group) {
        switch (layout.type) {
          case "stackX":
            if (layout.normalize) {
              layoutOptions = {
                type: "normalizeX",
                measureProp: layout.measure.column
              };
            } else {
              layoutOptions = {
                type: "stackX",
                cumulativeProp: "w"
              };
            }

            break;

          case "stackY":
            layoutOptions = {
              type: "stackY",
              cumulativeProp: "h"
            };
            break;
        } // For stackbar


        if (stackField) {
          if (!stack.sorting || stack.sorting.type !== constants$1.SORT.TYPE.ROWS) {
            group.sortByField(stackField);
          }

          if (stack.sorting && stack.sorting.order === constants$1.SORT.ORDER.DESC) {
            group.reverse();
          }
        }

        group.applyLayout(layoutOptions);
      }).flatten();
    }

    if (textfct) {
      var bars = layer.getChildren();
      bars.forEach(function (bar) {
        return bar.set({
          text: textfct(bar.get("data").row)
        });
      });
    }

    return layer;
  };
  /**
   * Plot a series of points
   *
   * {ValueFct Def} is definition for value function, {field, scale, value}
   *
   * params:
   *   key {ValueFct Def} point key
   *   x {ValueFct Def} point x
   *   y {ValueFct Def} point y
   *   r {ValueFct Def} point radius
   *   fill {ValueFct Def} point fill
   *   stroke {ValueFct Def} point stroke
   *   lineWidth {ValueFct Def} point stroke lineWidth
   *   axisOptions {Object} map of axis name by x/y dimension
   *
   * @param params {Object} params for plotter
   * @param rows {Array} rows
   * @return {Layer} layer with points
   */


  var point = function point(params, rows, layer) {
    var pointParams = lodash__default.pick(params, ["key", "x", "y", "r", "fill", "stroke", "lineWidth", "accessibility", "data", "selectionShapeEffect"]);
    var plotLayer = plot(Point, pointParams, rows, layer);

    if (!layer) {
      plotLayer.set({
        zIndex: 0,
        axisOptions: params.axisOptions
      });
      layer = plotLayer;
    }

    return layer;
  };
  /**
   * Add value text in the middle of bubbles
   *
   * @param allPoints {Array} all points on the layer
   * @param r {Object} radius
   * @param config {Object} chart config
   * @return {Array} all points with texts on the layer
   */


  var addValueText = function addValueText(layer, radiusField, config) {
    if (!radiusField) {
      return;
    }

    var theme = config.theme;
    var transforms = config.transforms;
    var allPoints = layer.getChildren(); // note: we are carefully adding them in the same order we sorted the

    var allPointsAndTexts = [];
    allPoints.forEach(function (point) {
      allPointsAndTexts.push(point);
      var radius = point.get("r");
      var fontSize = Math.round(radius / 2);

      if (fontSize > 10) {
        var value = point.get("data").row[radiusField.getName()];
        var numberText = new NumberText$2({
          key: point.key + "_text",
          number: value,
          format: radiusField.getFormat(),
          compact: true,
          x: point.get("x"),
          y: point.get("y"),
          stroke: value >= 0 ? point.get("stroke").toHighContrast(theme.getTextColorOnLight(), theme.getTextColorOnDark()) : point.get("stroke"),
          size: fontSize,
          valign: "middle",
          halign: "center",
          skipInFind: true,
          vertical: transforms.rotate
        });
        allPointsAndTexts.push(numberText);
      }
    });
    layer.removeAll();
    layer.appendAll(allPointsAndTexts);
  };
  /**
   * Add either the number or config.centerText in the middle of the chart
   * depending on the value of centerValueType
   *
   * @param params {Object} params for
   * @return {Layer} layer with text
   */


  var addInnerText = function addInnerText(params) {
    var centerText = params.centerText;
    var theme = params.theme;
    var innerRadius = params.innerRadius;
    var format = params.format;
    var number = params.number;
    var isText = params.centerValueType === constants$1.CENTER_VALUE_TYPE.TEXT;
    var isCompact = params.compact == null ? true : params.compact;
    var textLayer = new Layer({
      key: "plot"
    });
    textLayer.set({
      x: params.x,
      y: params.y,
      accessibility: {
        type: constants$1.ACCESSIBILITY.TYPE.CAPTION,
        key: constants$1.ACCESSIBILITY.CAPTION_KEY.TOTAL,
        value: isText ? centerText : formatNumber(format, true)(number)
      }
    });
    var textProperties = {
      stroke: theme.getBackgroundColor().toHighContrast(theme.getTextColorOnLight(), theme.getTextColorOnDark()),
      halign: "center",
      valign: "middle",
      size: Math.round(innerRadius / 3)
    };
    var totalText;
    var isFitToSize = false;

    if (isText) {
      lodash__default.extend(textProperties, {
        key: "centerText",
        text: centerText !== undefined ? centerText : ""
      });
      isFitToSize = true;
      totalText = new Text$1(textProperties);
    } else {
      lodash__default.extend(textProperties, {
        key: "total",
        skipInFind: true,
        format: format,
        number: number,
        compact: isCompact
      });
      isFitToSize = !isCompact;
      totalText = new NumberText$2(textProperties);
    }

    if (isFitToSize) {
      totalText.fitToSize(2 * innerRadius - 12, innerRadius / 2, 12, innerRadius / 3).set({
        maxWidth: 2 * innerRadius - 10
      });
    }

    totalText.appendTo(textLayer);
    return textLayer;
  };
  /**
   * Add value label next to each point in a line/timeline chart
   *
   */


  var addPointValueLabel = function addPointValueLabel(layer, theme, rotated, valueType, column, viewportSize) {
    var points = layer.find({
      type: "Point"
    });
    var textFormatInfoFct = adjustPlotUtils.getFormatInfo(valueType, column).textFct;
    var stroke = theme.getBackgroundColor().toHighContrast(theme.getTextColorOnLight(), theme.getTextColorOnDark());
    var prevX,
        prevY,
        labelsInfo = [];

    for (var i = 0; i < points.length; i++) {
      var point = points[i];
      var text = new Text$1({
        key: point.key + "-pvalue",
        layer: layer,
        text: textFormatInfoFct(points[i].get("data").row),
        stroke: stroke,
        valign: "middle",
        halign: "center",
        size: constants$1.TEXT_SIZE,
        includeDescender: false,
        skipInFind: true,
        vertical: rotated
      }); // get value label x, y offset for each point

      var offset = getPointValueLabelOffset(i, points, text, viewportSize, rotated);
      text.set({
        x: point.get("x") + offset.x,
        y: point.get("y") + offset.y
      });
      labelsInfo.push({
        text: text,
        point: point
      });
    }

    return labelsInfo;
  };
  /**
   * Calculate the offset for the value label for the point.
   *
   * @param i {number} index for the points
   * @param points {Array} points in line
   * @param text {Object} label text for the point
   * @param viewportSize {Object} viewport size (height and width)
   * @param rotated {boolean} if it is rotated in transform
   * @return {Object} label offset from the point
   */


  var getPointValueLabelOffset = function getPointValueLabelOffset(i, points, text, viewportSize, rotated) {
    var point = points[i];
    var prevPoint = points[i - 1];
    var nextPoint = points[i + 1];
    var textInfo = {
      sizeX: rotated ? text.getTextH() : text.getTextW(),
      // sizeX: text size in x direction
      sizeY: rotated ? text.getTextW() : text.getTextH(),
      // sizeY: text size in y direction
      padding: !point.get("hidden") ? point.get("r") + 2 : 3 // padding between text and the point

    };
    var offset = {
      x: null,
      // x direction offset with +/- of xd or xr
      y: null,
      // y direction offset with +/- of yd or yr
      xd: textInfo.sizeX / 2 + textInfo.padding,
      // x direction offset distance.
      yd: textInfo.sizeY / 2 + textInfo.padding,
      // y direction offset distance.
      xr: textInfo.sizeX / 2 + textInfo.padding / Math.sqrt(2),
      // for 45 degree offset x distance
      yr: textInfo.sizeY / 2 + textInfo.padding / Math.sqrt(2) // for 45 degree offset y distance

    };
    /**
     * Calculate the slopes of incoming line (slopeIn) to the point and the outgoing line (slopeOut) from the point.
     * The slopes of the incoming line and outgoing line determine where to put the label.
     * We only put labels in four locations: Left, Right, TopLeft and TopRight.
     *
     * Quadrant definition:
    	 *                   Top(T)
     *                     |
     *                     |
     *         TopLeft(TL) |   TopRight(TR)
     *                     |
     *  Left(L) -----------+------------> X Right(R)
     *                     |(0,0)
     *                     |
     *      BottomLeft(BL) |  BottomRight(BR)
     *                     |
     *                     V Y
     *               Bottom(B)
     *
     * Four cases where to put the label:
     *
     * Case 1: incoming in TopLeft and outgoing in BottomLeft.  Label put to Right.
     *
     *         incoming line (TL)
     *               ⟍
     *                 ⟍
     *                   ⟍     -------
     *                     *  | label |
     *                   ⟋     -------
     *                 ⟋
     *               ⟋
     *         outgoing line (BL)
     *
     * Case 2: incoming in TopRight and outgoing in BottomRight.  Label put to Left.
     *
     *                  incoming line (TR)
     *                          ⟋
     *                        ⟋
     *           -------    ⟋
     *          | label |  *
     *           -------    ⟍
     *                        ⟍
     *                          ⟍
     *                  outgoing line (BR)
     *
     * Case 3: incoming in TopRight and outgoing in BottomLeft.  Label put in BottomRight.
     *
     *                   incoming line (TR)
     *                           ⟋
     *                         ⟋
     *                       ⟋
     *                     *
     *                   ⟋
     *                 ⟋    -------
     *               ⟋     | label |
     *             ⟋        -------
     *       outgoing line (BL)
     *
     * Case 4: incoming in TopLeft and outgoing in BottomRight.  Label put in TopRight.
     *
     *       incoming line (TL)
     *             ⟍        -------
     *               ⟍     | label |
     *                 ⟍    -------
     *                   ⟍
     *                     *
     *                       ⟍
     *                         ⟍
     *                           ⟍
     *                   outgoing line (BR)
     *
     **/

    var slopeIn, slopeOut;

    if (prevPoint) {
      var deltaX = point.get("x") - prevPoint.get("x");

      if (deltaX) {
        slopeIn = (point.get("y") - prevPoint.get("y")) / deltaX;
      }
    }

    if (nextPoint) {
      var deltaX$1 = point.get("x") - nextPoint.get("x");

      if (deltaX$1) {
        slopeOut = (point.get("y") - nextPoint.get("y")) / deltaX$1;
      }
    } // positive slope: "⟍"
    // negative slope: "⟋"


    var labelLoc; // slopeIn TopLeft

    if (slopeIn > 0) {
      // Case 4: "⟍"
      // slopeOut BottomRight.  This is for slopeIn and slopeOut in this shape:  "⟍"
      if (slopeOut > 0) {
        labelLoc = moveLabelToTopRight(offset); // Case 1: ">"
        // slopeOut BottomLeft or undefined (possible last point of the line).  This is for slopeIn and slopeOut in this shape:  ">"
      } else {
        labelLoc = moveLabelToRight(offset);
      } // slopeIn TopRight or slopeIn undefined (possible first point of the line)

    } else {
      // Case 2: "<"
      // slopeOut in BottomRight.
      if (slopeOut > 0) {
        labelLoc = moveLabelToLeft(offset); // Case 3: "⟋"
        // slopeOut BottomLeft.
      } else {
        labelLoc = moveLabelToBottomRight(offset);
      }
    } // adjust text location to make sure inside of the viewport.


    adjustOffset(point, labelLoc, offset, viewportSize, rotated, textInfo, 0);
    return offset;
  };
  /**
   * Recursive function to adjust the offset for the value label for the point to make sure it is inside the viewport.
   * All 4 locations (L, R, BR, TR) will be checked for L, R, B, T boundary.
   * 
   * @param point {Object} point
   * @param loc {string} label location to check for adjustment
   * @param offset {Object} x, y offset of the text from the point.  Center/middle of text to center of point.
   * @param viewport {Object} viewport size (height and width)
   * @param rotated {boolean} if it is rotated in transform
   * @param textInfo {Object} h and w of the text and padding between the text and the point
   * @numTrial {number} internal counter to terminate this recursive function
   **/


  var adjustOffset = function adjustOffset(point, loc, offset, viewport, rotated, textInfo, numTrial) {
    var nextLoc;

    if (++numTrial > 4) {
      return;
    }
    /**
     * Logic for moving labels outside the viewport to inside.
     * 4 outmost sides of the label will be checked counterclockwise against 4 sides of the viewport to see if there is enough space between.
     * In each recursive call, it checks one side (either Top, Left, Bottom, or Right)
     * For example, if the label is at TopRight of the point:
     * The 1st recursive call checks if we have enough space from the top for the label (+ 2px padding). 
     * If not, move the label to the left of the point and check the top again. If there is still not enough space from top, then
     * adjust the label further down from the viewport top boundary (+ 2px padding).  Now, the label is at the left of the point.
     * The 2nd recursive call, checks the left side of the label and move to the BottomRight if needed.
     * If it still touches left side, adjust the label to the right from the left-hand side boundary. Similarly, for all the remaining calls.  
     *
     **/


    if (loc === labelLoc.topRight) {
      if (!enoughSpaceTop(point, offset, viewport, textInfo)) {
        moveLabelToLeft(offset, textInfo);

        if (!enoughSpaceTop(point, offset, viewport, textInfo)) {
          // still touching the top boundary. Adjust the text down to below the top boundary
          offset.y = PADDING + textInfo.sizeY / 2 - point.get("y");
        }
      }

      nextLoc = labelLoc.left;
    }

    if (loc === labelLoc.left) {
      if (!enoughSpaceLeft(point, offset, viewport, textInfo)) {
        moveLabelToBottomRight(offset, textInfo);

        if (!enoughSpaceLeft(point, offset, viewport, textInfo)) {
          // after moving to BottomRight, still touching the left boundary. Adjust the text further to the right over the left boundary
          offset.x = PADDING + textInfo.sizeX / 2 - point.get("x");
        }
      }

      nextLoc = labelLoc.bottomRight;
    }

    if (loc === labelLoc.bottomRight) {
      if (!enoughSpaceBottom(point, offset, viewport, textInfo)) {
        moveLabelToRight(offset, textInfo);

        if (!enoughSpaceBottom(point, offset, viewport, textInfo)) {
          // after moving to right, still touching the bottom boundary. Adjust the text up above the bottom boundary
          offset.y = viewport.h - PADDING - textInfo.sizeY / 2 - point.get("y");
        }
      }

      nextLoc = labelLoc.right;
    }

    if (loc === labelLoc.right) {
      if (!enoughSpaceRight(point, offset, viewport, textInfo)) {
        moveLabelToTopRight(offset, textInfo);

        if (!enoughSpaceRight(point, offset, viewport, textInfo)) {
          // after moving to TopRight , still touching the right boundary. Adjust the text further to the left over the right boundary
          offset.x = viewport.w - PADDING - textInfo.sizeX / 2 - point.get("x");
        }
      }

      nextLoc = labelLoc.topRight;
    }

    return adjustOffset(point, nextLoc, offset, viewport, rotated, textInfo, numTrial);
  };

  var enoughSpaceTop = function enoughSpaceTop(point, offset, viewport, textInfo) {
    return Math.ceil(point.get("y") + offset.y - textInfo.sizeY / 2 - PADDING) >= 0;
  };

  var enoughSpaceBottom = function enoughSpaceBottom(point, offset, viewport, textInfo) {
    return viewport.h >= Math.ceil(point.get("y") + offset.y + textInfo.sizeY / 2 + PADDING);
  };

  var enoughSpaceRight = function enoughSpaceRight(point, offset, viewport, textInfo) {
    return viewport.w >= Math.ceil(point.get("x") + offset.x + textInfo.sizeX / 2 + PADDING);
  };

  var enoughSpaceLeft = function enoughSpaceLeft(point, offset, viewport, textInfo) {
    return Math.ceil(point.get("x") + offset.x - textInfo.sizeX / 2 - PADDING) >= 0;
  };

  var moveLabelToLeft = function moveLabelToLeft(offset) {
    offset.x = -offset.xd;
    offset.y = 0;
    return labelLoc.left;
  };

  var moveLabelToRight = function moveLabelToRight(offset) {
    offset.x = offset.xd;
    offset.y = 0;
    return labelLoc.right;
  };

  var moveLabelToBottomRight = function moveLabelToBottomRight(offset) {
    offset.x = offset.xr;
    offset.y = offset.yr;
    return labelLoc.bottomRight;
  };

  var moveLabelToTopRight = function moveLabelToTopRight(offset) {
    offset.x = offset.xr;
    offset.y = -offset.yr;
    return labelLoc.topRight;
  };

  var labelLoc = {
    left: 0,
    right: 1,
    bottomRight: 2,
    topRight: 3
  };

  var getDefaultFontSize = function getDefaultFontSize() {
    return adjustPlotUtils.getTextHeight(constants$1.TEXT_SIZE);
  };

  var getMinFontSize = function getMinFontSize() {
    return adjustPlotUtils.getTextHeight(constants$1.MIN_FONT_SIZE);
  };

  var plotUtils = {
    line: line,
    point: point,
    rect: rect,
    area: area,
    addInnerText: addInnerText,
    addValueText: addValueText,
    addPointValueLabel: addPointValueLabel,
    adjustLineFill: adjustPlotUtils.adjustLineFill,
    adjustPointFill: adjustPlotUtils.adjustPointFill,
    adjustBarText: adjustPlotUtils.adjustBarText,
    adjustLineLabels: adjustPlotUtils.adjustLineLabels,
    truncateColumns: adjustPlotUtils.truncateColumns,
    getFormatInfo: adjustPlotUtils.getFormatInfo,
    getTextWidth: adjustPlotUtils.getTextWidth,
    getTextHeight: adjustPlotUtils.getTextHeight,
    getDefaultFontSize: getDefaultFontSize,
    getMinFontSize: getMinFontSize,
    rotateBuilderFct: adjustPlotUtils.rotateBuilderFct,
    getMeasureAxisCellHeight: adjustPlotUtils.getMeasureAxisCellHeight
  };
  var COLOR_TYPE$4 = constants$1.COLOR_TYPE;
  var colorUtils = {
    getColor: function getColor(color) {
      if (color.getType && (color.getType() === COLOR_TYPE$4.SIMPLE_COLOR || color.getType() === COLOR_TYPE$4.LINEAR_GRADIENT)) {
        return color;
      } else {
        return ColorFactory$1.getInstance().getColor(color);
      }
    },
    isColor: function isColor(color) {
      return color instanceof LinearGradient || color instanceof Color;
    },
    isValidColorConfig: function isValidColorConfig(color) {
      return color != null && (this.isColor(color) || color.column && color.column.length > 0);
    }
  };
  var defaultTheme = ThemeFactory.getInstance().getDefaultTheme();
  var REF_LINE_LAYER_ZINDEX = 100;
  var DEFAULT_REF_LINE_WIDTH = 2;

  function xRefLines(ref) {
    var cell = ref.cell;
    var theme = ref.theme;
    var layer = ref.layer;
    var key = ref.key;
    var scale = ref.scale;
    var length = ref.length;
    var lines = ref.lines;
    var formatMultiplier = ref.formatMultiplier;
    var rotateLabel = ref.rotateLabel;
    formatMultiplier = formatMultiplier || 1;
    theme = theme || defaultTheme;
    layer = layer || new Layer({
      cell: cell,
      key: key,
      staggerAnim: false,
      canSelect: false,
      canScroll: false,
      zIndex: REF_LINE_LAYER_ZINDEX
    });
    lines.forEach(function (line, index) {
      var value = line.value / formatMultiplier;
      var isRefLineVisible = value >= scale.domain()[0] && value <= scale.domain()[1];
      addRefLine({
        layer: layer,
        length: length,
        value: scale.scale(value),
        lineColor: line.color || theme.getReferenceLineColor(),
        lineWidth: line.lineWidth || DEFAULT_REF_LINE_WIDTH,
        key: line.key || index,
        transparent: line.transparent,
        label: line.label,
        theme: theme,
        scale: scale,
        rotateLabel: rotateLabel,
        isRefLineVisible: isRefLineVisible
      });
    });
    return layer;
  }

  function addRefLine(ref) {
    var layer = ref.layer;
    var length = ref.length;
    var value = ref.value;
    var lineColor = ref.lineColor;
    var lineWidth = ref.lineWidth;
    var key = ref.key;
    var transparent = ref.transparent;
    var label = ref.label;
    var theme = ref.theme;
    var scale = ref.scale;
    var rotateLabel = ref.rotateLabel;
    var isRefLineVisible = ref.isRefLineVisible; // adjust x position to make sure the box fits

    var x = value;
    var lineTop = 0; // where the line starts

    lineColor = colorUtils.getColor(lineColor);

    if (label && isRefLineVisible) {
      var Delegate = WaveChartsRuntime.getDelegate();
      var labelTextH = Delegate.getRealFontSize(constants$1.TEXT_SIZE);
      var labelTextW = Delegate.getTextWidth(label);
      lineTop = rotateLabel ? labelTextH + 2 : labelTextW + 14;

      if (lineTop < length) {
        var polyFill; // fill color for polygon

        var textStroke; // stroke color for text

        var sizeOffset = 0; // extra size for polygon

        if (transparent) {
          polyFill = theme.getBackgroundColor().toOpaque().adjustOpacity(0.7);
          textStroke = lineColor;
          sizeOffset = 1; // when simply drawing a box around the text, the box feels very close to the text, so we are just exanding by 1 pixel
        } else {
          polyFill = lineColor;
          textStroke = lineColor.toHighContrast(theme.getTextColorOnLight(), theme.getTextColorOnDark());
        } // Flat label do not use Polygon


        if (!rotateLabel) {
          new Polygon({
            key: "refline-rect" + key,
            layer: layer,
            points: [[x + 8 + sizeOffset, 1], [x + 8 + sizeOffset, lineTop - 6], [x, lineTop], [x - 8 - sizeOffset, lineTop - 6], [x - 8 - sizeOffset, 1]],
            lineWidth: lineWidth,
            stroke: lineColor.adjustOpacity(0.9),
            fill: polyFill
          });
        }

        var refText = new Text$1({
          key: "refline-label" + key,
          layer: layer,
          x: x,
          y: rotateLabel ? 0 : 5,
          vertical: !rotateLabel,
          halign: rotateLabel ? "center" : "right",
          valign: rotateLabel ? "top" : "middle",
          includeDescender: false,
          text: label,
          stroke: textStroke,
          bgColor: rotateLabel ? lineColor : undefined,
          padding: rotateLabel ? {
            top: 2,
            left: 10,
            right: 10,
            bottom: 5
          } : undefined,
          accessibility: {
            type: constants$1.ACCESSIBILITY.TYPE.CAPTION,
            key: constants$1.ACCESSIBILITY.CAPTION_KEY.REFERENCE_LINE,
            value: label
          }
        }); // Make sure flat label visiable by adjusting location

        if (rotateLabel) {
          var textBb = refText.boundingBox(); // make sure text doesn't overlap to the left

          if (textBb.x < scale.range()[0]) {
            refText.set({
              x: scale.range()[0],
              halign: "left"
            });
          } // make sure text doesn't overlap to the rigth


          if (textBb.x + textBb.w > scale.range()[1]) {
            refText.set({
              x: scale.range()[1],
              halign: "right"
            });
          }
        }
      } else {
        // no room to show box + text... just draw line
        lineTop = 0;
      }
    }

    if (length > 0) {
      new Line$2({
        layer: layer,
        lineWidth: lineWidth,
        stroke: lineColor,
        key: "refline-line" + key,
        x0: x,
        y0: lineTop,
        x1: x,
        y1: length,
        opacity: isRefLineVisible ? 1 : 0
      });
    }
  }

  function getValidReferenceLines(referenceLines) {
    // - parse string values
    // - filter out ref lines whose value is not a finite number (eg: null, NaN, Infinity, "", etc ...)
    return referenceLines.map(function (refLine) {
      if (refLine.value && lodash__default.isString(refLine.value)) {
        console.warn("EclairNG: Got string for referenceLine \"value\": " + refLine.value + ". \"value\" should be a number.");
        refLine.value = parseFloat(refLine.value);
      }

      return refLine;
    }).filter(function (refLine) {
      return lodash__default.isFinite(refLine.value);
    });
  }

  var referenceLineUtils = {
    xRefLines: xRefLines,
    // reflines on the x axis (vertical reflines)
    yRefLines: plotUtils.rotateBuilderFct(xRefLines),
    // reflines on the y axis (horizontal reflines)
    getValidReferenceLines: getValidReferenceLines
  }; // weak
  //@flow-ignore

  var ref$4 = constants$1.CHART_LAYOUT;
  var COLOR_TYPE$3 = ref$4.COLOR_TYPE;
  var COLUMN_TYPE = constants$1.COLUMN_TYPE;
  var VALUETYPE = constants$1.VALUETYPE;
  var AUTO_KEY_COLUMN = "$$KEY";

  function defaultTrue(param) {
    return param != undefined ? param : true;
  }

  function _getHotSpotsDefaults(config) {
    return {
      position: "right",
      icon: "\u2335",
      colors: config.theme.getHotspotColors()
    };
  }

  function traverseConfigSections(config, sectionNames, callback) {
    if (!sectionNames || !sectionNames.length) {
      sectionNames = config ? lodash__default.keys(config) : [];
    }

    var loop = function loop(i) {
      var sectionName = sectionNames[i];
      var configSection = config[sectionName];

      if (lodash__default.isArray(configSection)) {
        configSection.forEach(function (section) {
          return callback(section, sectionName);
        });
      } else {
        callback(configSection, sectionName);
      }
    };

    for (var i = 0; i < sectionNames.length; i++) {
      loop(i);
    }
  }

  function getColumns(config, sectionNames, type) {
    var columns = [];
    traverseConfigSections(config, sectionNames, function (section) {
      var cols = section && section.column;

      if (!cols) {
        return;
      }

      for (var i = 0; i < cols.length; i++) {
        var col = cols[i];

        if (!type || col.getType() === type) {
          columns.push(col);
        }
      }
    }); // filter out duplicates

    var columnMap = {};
    columns.forEach(function (column) {
      return columnMap[column.getName()] = column;
    });
    return lodash__default.values(columnMap);
  } // parse the line.time field and add to line.value


  function parseTimeAndAddToValue(lines, parser) {
    lines.forEach(function (line) {
      if (line.time) {
        line.value = parser(line.time);
      }
    });
  }

  var configUtils = {
    traverseConfigSections: function traverseConfigSections$1(config, names, callback) {
      traverseConfigSections(config, names, callback);
    },
    getColumns: function getColumns$1(config) {
      var sectionNames = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        sectionNames[len] = arguments[len + 1];
      }

      return getColumns(config, sectionNames);
    },
    getDimensionColumns: function getDimensionColumns(config) {
      var sectionNames = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        sectionNames[len] = arguments[len + 1];
      }

      return getColumns(config, sectionNames, COLUMN_TYPE.DIMENSION);
    },
    getMeasureColumns: function getMeasureColumns(config) {
      var sectionNames = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        sectionNames[len] = arguments[len + 1];
      }

      return getColumns(config, sectionNames, COLUMN_TYPE.MEASURE);
    },
    getTimeColumns: function getTimeColumns(config) {
      var sectionNames = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        sectionNames[len] = arguments[len + 1];
      }

      return getColumns(config, sectionNames, COLUMN_TYPE.TIME);
    },

    /**
     * Create a column for storing internal key, the column is internal only
     * @return {DimensionColumn}
     */
    createInternalKeyColumn: function createInternalKeyColumn() {
      return this.createInternalColumn(AUTO_KEY_COLUMN);
    },

    /**
     * Create an internal only column
     * @param  {String} name of column
     * @return {DimensionColumn}
     */
    createInternalColumn: function createInternalColumn(name) {
      return new DimensionColumn(name).setInternalOnly(true);
    },
    sanitizeAxis: function sanitizeAxis(axis, columns, isMeasure) {
      if (columns.length) {
        axis.title = isMeasure ? columnUtils$1.defaultText(axis.title, columnUtils$1.measuresDefaultTitle(columns)) : axis.title || columns.map(function (column) {
          return columnUtils$1.defaultText(column.getLabel(), column.getName());
        });

        if (isMeasure) {
          axis.format = axis.format || columns[0].getFormat();
        }
      } else {
        axis.showAxis = false;
        axis.showTitle = false;
      } // valid depth is >= 1
      // use showAxis: false for depth = 0


      if (!lodash__default.isNumber(axis.labelsDepth) || axis.labelsDepth < 1) {
        axis.labelsDepth = columns.length;
      } // For timeAxis predictiveLine


      if (axis.predictiveLine) {
        if (axis.predictiveLine.lineStyleAfter === undefined) {
          axis.predictiveLine.lineStyleAfter = "dashed";
        }

        axis.predictiveLine.time = axis.predictiveLine.time ? axis.predictiveLine.time : Date.now();
        parseTimeAndAddToValue([axis.predictiveLine], columns[0].getParser());
      } // For reference lines


      if (axis.referenceLines) {
        if (isMeasure) {
          axis.referenceLines = referenceLineUtils.getValidReferenceLines(axis.referenceLines);
        }

        if (columns[0].getType() === COLUMN_TYPE.TIME) {
          parseTimeAndAddToValue(axis.referenceLines, columns[0].getParser());
        }
      }
    },
    addLegacyLayout: function addLegacyLayout(measureAxis1, measureAxis2, dimensionAxis, timeAxis) {
      if (measureAxis1 === void 0) measureAxis1 = {};
      if (measureAxis2 === void 0) measureAxis2 = {};
      if (dimensionAxis === void 0) dimensionAxis = {};
      if (timeAxis === void 0) timeAxis = {};
      return {
        showMeasure1: defaultTrue(measureAxis1.showAxis),
        showMeasure2: defaultTrue(measureAxis2.showAxis),
        showMeasureTitle1: defaultTrue(measureAxis1.showTitle),
        showMeasureTitle2: defaultTrue(measureAxis2.showTitle),
        showDimension: defaultTrue(dimensionAxis.showAxis),
        showDimensionTitle: defaultTrue(dimensionAxis.showTitle),
        showTime: defaultTrue(timeAxis.showTime),
        showTimeTitle: defaultTrue(timeAxis.showTitle)
      };
    },
    convertAxisMode: function convertAxisMode(axisMode, config) {
      if (axisMode === void 0) axisMode = constants$1.AXIS_MODE.DUAL;
      var plots = config.plots;

      if (axisMode == constants$1.AXIS_MODE.SYNC) {
        // force all plots to measureAxis1
        plots.map(function (plot) {
          return plot.axis = "measureAxis1";
        });
      } else if (axisMode == constants$1.AXIS_MODE.DUAL) {
        // default first plot to measureAxis1, others to measureAxis2
        plots.map(function (plot, i) {
          var defaultAxis = i == 0 ? "measureAxis1" : "measureAxis2";

          if (!plot.axis) {
            plot.axis = defaultAxis;
          }
        });
      } else {
        // default plots to measureAxisX sequentially
        plots.map(function (plot, i) {
          var defaultAxis = "measureAxis" + (i + 1);

          if (!plot.axis) {
            plot.axis = defaultAxis;
          }
        });
      }
    },
    hydrateConfigSection: function hydrateConfigSection(configSection, rowsMetadata) {
      if (!configSection) {
        return;
      }

      var columns = configSection.column;

      if (configSection.color) {
        this.hydrateConfigSection(configSection.color, rowsMetadata);
      }

      if (columns) {
        configSection.column = columns.map(function (column) {
          return rowsMetadata.getColumn(column);
        });
      }

      var iconColumn = configSection.icon && configSection.icon.column;

      if (iconColumn) {
        configSection.icon.column = rowsMetadata.getColumn(iconColumn);
      }

      var areaColumns = configSection.area;

      if (areaColumns) {
        configSection.area = areaColumns.map(function (column) {
          return rowsMetadata.getColumn(column);
        });
      }
    },
    addSortingInfoToAxis: function addSortingInfoToAxis(axis, sorting, config) {
      if (!axis.column || axis.column.length == 0) {
        return;
      }

      var order = SortingEnum.NONE.value;

      if (sorting.column && axis.column[0].getName() == sorting.column[0].getName()) {
        order = sorting.order;
      }

      var disabled = !sorting.enabled || axis.column.length > 1 || axis.column[0].getType() == constants$1.COLUMN_TYPE.TIME || this.getDimensionColumns(config).length + this.getTimeColumns(config).length == 0 || sorting.columnTypes != null && !lodash__default.find(sorting.columnTypes, function (columnType) {
        return axis.column[0].getType() == columnType;
      });
      axis.sorting = {
        enabled: !disabled,
        order: order
      };
    },
    enrichAxis: function enrichAxis(config) {
      var this$1 = this;
      var x = config.x;
      var y = config.y;
      var dimensionAxis = config.dimensionAxis;
      var timeAxis = config.timeAxis;
      var plots = config.plots;
      var sorting = config.sorting;
      var order = sorting.order;
      var column = sorting.column;
      var axisNames = ["measureAxis1", "measureAxis2"]; // add columns to measure axes

      config.plots && config.plots.forEach(function (plot) {
        var axisName = plot.axis;

        if (axisName) {
          axisNames.push(axisName);
          var axis = config[axisName];
          axis.column = dataUtils.uniq((axis.column || []).concat(plot.column), function (column) {
            return column.getName();
          });
        }
      }); // add sorting to measure axes

      var axes = lodash__default.filter(dataUtils.uniq(axisNames).map(function (axisName) {
        return config[axisName];
      }));
      axes.forEach(function (axis) {
        this$1.addSortingInfoToAxis(axis, sorting, config);
      });

      if (dimensionAxis && timeAxis && timeAxis.column.length > 0) {
        dimensionAxis.column = timeAxis.column;
      } // add sorting to dimension axes


      lodash__default.filter([timeAxis, dimensionAxis, x, y]).map(function (axis) {
        this$1.addSortingInfoToAxis(axis, sorting, config);
      });
    },
    hydrateRowsMetadata: function hydrateRowsMetadata(rows, rowsMetadata) {
      rowsMetadata.forEach(function (column) {
        var valueColorsColumn;
        var valueLabelsColumn;

        if (lodash__default.isString(column.valueColors)) {
          valueColorsColumn = column.valueColors;
          column.valueColors = {};
        }

        if (lodash__default.isString(column.valueLabels)) {
          valueLabelsColumn = column.valueLabels;
          column.valueLabels = {};
        }

        if (valueLabelsColumn || valueColorsColumn) {
          var addColumnValue = function addColumnValue(row, columnName, columnValueName, mappings) {
            var key = row[columnName];
            var value = row[columnValueName];

            if (key != null && value != null && mappings[value] == null) {
              mappings[key] = value;
            }
          };

          rows.forEach(function (row) {
            if (valueColorsColumn) {
              addColumnValue(row, column.column, valueColorsColumn, column.valueColors);
            }

            if (valueLabelsColumn) {
              addColumnValue(row, column.column, valueLabelsColumn, column.valueLabels);
            }
          });
        }
      });
      return rowsMetadata;
    },
    hydrateConfig: function hydrateConfig(config, rowsMetadata) {
      var this$1 = this; // traverse all config sections

      traverseConfigSections(config, undefined, function (section) {
        return this$1.hydrateConfigSection(section, rowsMetadata);
      });
    },
    // Checks if there is a custom cell size defined for a given dimension config
    // Also, make sure the size is valid (between 0 and 100)
    // @return {Number|Null} the custom size if it exsits and is valud, otherwise return undefined
    getCustomCellSize: function getCustomCellSize(dimConfig) {
      return dimConfig && dimConfig.size && dimConfig.size > 0 && dimConfig.size < 100 ? dimConfig.size : undefined;
    },
    getXAxisDefinition: function getXAxisDefinition(config) {
      return this.getAxisDefinition(config.x);
    },
    getYAxisDefinition: function getYAxisDefinition(config) {
      return this.getAxisDefinition(config.y);
    },
    getAxisDefinition: function getAxisDefinition(axis) {
      if (!axis) {
        return null;
      }

      var axisDefinition = {
        showZero: axis.showZero,
        showAxis: axis.showAxis,
        showTitle: axis.showTitle,
        scale: axis.scale
      };

      if (!axis.fields || axis.fields.length == 0) {
        return axisDefinition;
      }

      var field = axis.fields[0];
      var titles = axis.title ? axis.title : axis.fields.map(function (field) {
        return columnUtils$1.defaultText(field.getLabel(), field.getName());
      });
      return lodash__default.extend(axisDefinition, {
        label: titles,
        format: field.getFormat(),
        domain: field.domain,
        referenceLines: field.referenceLines
      });
    },
    setMarkType: function setMarkType(config, markType) {
      config.plots.forEach(function (plot) {
        plot.mark = plot.mark || markType;
      });
    },
    // @return {Boolean} whether the chart is using bins coloring
    isBinned: function isBinned(config) {
      var color = config.plots[0].color;
      return color && color.type === COLOR_TYPE$3.BINS;
    },
    isTrellis: function isTrellis(config) {
      if (config === void 0) config = {};
      var trellis = config.trellis;
      return !!(trellis && trellis.column && trellis.column.length);
    },
    // @return {Boolean} true is series are used for any of the measures
    hasSeries: function hasSeries(plots) {
      return lodash__default.find(plots, function (plot) {
        return plot.series !== undefined;
      }) !== undefined;
    },
    // @return {Boolean} whether the config has a dimension field with an icon
    hasIcon: function hasIcon(dimensionAxis) {
      return dimensionAxis && !!dimensionAxis.icon;
    },

    /**
     	Return the default plot(s) configurations for the chart.
    	By default use categorical coloring if the chart has one plot,
    	and static coloring if it has more than one plot.
    	(Note that all charts have at least one plot element)
     */
    getPlotsDefaults: function getPlotsDefaults(config, colorType) {
      var this$1 = this;
      colorType = colorType || (config.plots.length == 1 ? COLOR_TYPE$3.CATEGORICAL : COLOR_TYPE$3.CONSTANT);
      var plots = config.plots;
      return plots.map(function (plot, i) {
        return colorType == COLOR_TYPE$3.CATEGORICAL ? {
          column: [],
          color: {
            type: COLOR_TYPE$3.CATEGORICAL
          }
        } : {
          color: this$1.getPaletteColor(config.theme, i, plots.length)
        };
      });
    },

    /**
    	Return the color "column" for the plot at a given index
     */
    getPlotColorColumn: function getPlotColorColumn(config, index) {
      if (index === void 0) index = 0;
      return this.getColumns(config.plots[index], "color")[0];
    },

    /**
    	Return the columns from the specified sections and
    	from the plots' color fields
     */
    getTooltipColumns: function getTooltipColumns(config) {
      var this$1 = this;
      var sectionNames = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        sectionNames[len] = arguments[len + 1];
      }

      var columns = (ref = this).getColumns.apply(ref, [config].concat(sectionNames));
      config.plots.forEach(function (plot) {
        columns = columns.concat(this$1.getColumns(plot, "color"));
      });
      return columnUtils$1.uniqueColumns(columns);
      var ref;
    },

    /**
    	Denormalize the config:
    	If a color element is defined as a top level property,
    	assign it to all the plots that don't have a color specified.
     */
    denormalizeConfig: function denormalizeConfig(config) {
      if (config.color != null) {
        config.plots.forEach(function (plot) {
          var color = plot.color;

          if (color == null) {
            plot.color = config.color;
          }
        });
      }
    },

    /**
    	Get the a theme's pallete color at a given index
     */
    getPaletteColor: function getPaletteColor(theme, i, domainLength, colors, respectPaletteColorOrder) {
      if (i === void 0) i = 0;
      if (domainLength === void 0) domainLength = 1;
      colors = colors || theme.getPaletteColors();
      return colors[i % colors.length];
    },
    fixConfig: function fixConfig(config, defaultConfig) {
      this.denormalizeConfig(config);
      dataUtils.defaultsDeep(config, defaultConfig);
      convertConfigUtils$1.convertConfigColors(config); // ensure uniqueness in every config option fields

      traverseConfigSections(config, undefined, function (section) {
        var columns = section && section.column;

        if (columns && columns.length > 1) {
          section.column = columnUtils$1.uniqueColumns(columns);
        }
      });
      this.getColumns(config, "dimension").forEach(function (dimension) {
        var hotSpots = dimension.getHotSpots();

        if (hotSpots) {
          dimension._hotSpots = hotSpots.map(function (hotSpot) {
            return lodash__default.defaults(hotSpot, _getHotSpotsDefaults(config));
          });
        }
      });
    },
    sanitizeChartTitleConfig: function sanitizeChartTitleConfig(titleConfig) {
      if (titleConfig) {
        var chartTitleDefaults = {
          fontSize: constants$1.TITLE.DEFAULT_FONT_SIZE,
          subtitleFontSize: constants$1.TITLE.DEFAULT_SUBTITLE_FONT_SIZE,
          align: constants$1.TITLE.DEFAULT_ALIGN
        };
        lodash__default.defaults(titleConfig, chartTitleDefaults);
        titleConfig.fontSize = Math.max(0, titleConfig.fontSize);
        titleConfig.subtitleFontSize = Math.max(0, titleConfig.subtitleFontSize);
      }
    },
    sanitizeValueTypeConfig: function sanitizeValueTypeConfig(valueType, allowedValueTypes) {
      if (allowedValueTypes === void 0) allowedValueTypes = [VALUETYPE.COMPACT_NUMBER, VALUETYPE.PERCENT, VALUETYPE.NONE];
      return allowedValueTypes.indexOf(valueType) >= 0 ? valueType : VALUETYPE.COMPACT_NUMBER;
    },
    //deprecate this function once both sfx and wave start using "valueType"
    defaultShowValues: function defaultShowValues(config) {
      if (config.showValues == null) {
        config.showValues = true;
      }

      if (config.valueType == null) {
        config.valueType = config.showPercentage || config.showValues && config.normalize ? constants$1.VALUETYPE.PERCENT : config.showValues ? constants$1.VALUETYPE.COMPACT_NUMBER : constants$1.VALUETYPE.NONE;
      }

      delete config.showValues;
      return config;
    },
    createDefaultSplitConfig: function createDefaultSplitConfig(colorConfig, columnField) {
      if (columnField === void 0) columnField = "column";
      var splitConfig = {};
      splitConfig[columnField] = dataUtils.deepCopy(colorConfig[columnField]);
      splitConfig.sorting = {
        type: colorConfig.sortColor === false ? constants$1.SORT.TYPE.ROWS : constants$1.SORT.TYPE.VALUES,
        order: constants$1.SORT.ORDER.ASC
      };
      return splitConfig;
    },
    getFormatMultiplier: function getFormatMultiplier(axis) {
      var format = axis.format;
      return format && format[1] || 1;
    },
    convertConfigColors: function convertConfigColors(config) {
      return convertConfigUtils$1.convertConfigColors(config);
    },
    isSortingSupported: function isSortingSupported(config) {
      return config.sorting.enabled && !this.isTrellis(config);
    },
    removeColumnlessSections: function removeColumnlessSections(config, keys) {
      keys.forEach(function (key) {
        if (config[key] && config[key].column && config[key].column.length == 0) {
          delete config[key];
        }
      });
    }
  }; //
  //@flow-ignore

  var ref$3 = ThemeFactory.getInstance();
  var getDefaultTheme = ref$3.getDefaultTheme;
  var exportCounter = counter$1.init('scene::export');
  var updateCounter$1 = counter$1.init('scene::update');
  /*::(x: Scene) => (x: IScene)*/

  var Scene$2 = function (Group) {
    function Scene(props, silent) {
      if (!props) {
        props = {
          key: "scene"
        };
      } else if (props.key == null) {
        props.key = "scene";
      }

      Group.call(this, props, silent);
      this.grid = new Grid().attachScene(this);
    }

    if (Group) Scene.__proto__ = Group;
    Scene.prototype = Object.create(Group && Group.prototype);
    Scene.prototype.constructor = Scene;

    Scene.prototype._setDefaultProps = function _setDefaultProps() {
      Group.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.size = [0, 0];
      props.position = [0, 0];
      props.scrollOffset = [0, 0];
      props.baseScrollOffset = [0, 0];
      props.selectMode = constants$1.SELECTMODE.NONE;
      props.background = undefined;
      props.config = {};
      props.rowsMetadata = undefined;
      props.selectionKeyFct = undefined;
      props.keyTransform = undefined;
      props.padding = new Padding({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      });
      props.dataFormatter = null;
    };

    Scene.prototype._mapValue = function _mapValue(prop, value) {
      if (prop === "padding") {
        return new Padding(value);
      } else {
        return value;
      }
    };

    Scene.prototype._onChange = function _onChange(diffOptions) {
      Group.prototype._onChange.call(this, diffOptions);

      if (diffOptions.padding) {
        this.grid && this.grid.updateCellLayout();
      }

      var diff = diffOptions.transforms;

      if (diff && diff[0]) {
        var value = diff[0];

        if (value.flipY) {
          this._props.padding.flipY();
        }

        if (value.flipX) {
          this._props.padding.flipX();
        }

        if (value.rotate) {
          var size = this._props.size;
          this._props.size = [size[1], size[0]];

          this._props.padding.rotate({
            isCW: true
          });
        }
      }

      return;
    }; //--------------------------------------------------------------------------------
    // child management
    //--------------------------------------------------------------------------------


    Scene.prototype._childSorter = function _childSorter(child) {
      return child.get("zIndex");
    }; //--------------------------------------------------------------------------------
    // getter/setter
    //--------------------------------------------------------------------------------


    Scene.prototype.getParentBackgroundColor = function getParentBackgroundColor() {
      return this._props.background;
    };

    Scene.prototype.getCell = function getCell(colIndex, rowIndex) {
      return this.grid.getCell(colIndex, rowIndex);
    };

    Scene.prototype.getCells = function getCells() {
      return this.getChildren();
    };

    Scene.prototype.cellByKey = function cellByKey(key) {
      return this.getChildByKey(key);
    };

    Scene.prototype.getFullSize = function getFullSize() {
      var ref = this.grid.getFullSize();
      var w = ref[0];
      var h = ref[1];
      var ref$1 = this._props.padding;
      var top = ref$1.top;
      var right = ref$1.right;
      var bottom = ref$1.bottom;
      var left = ref$1.left;
      return [w + left + right, h + top + bottom];
    };

    Scene.prototype.getBaseScrollOffset = function getBaseScrollOffset() {
      return this.grid.getBaseScrollOffset();
    };

    Scene.prototype.getScrollOffset = function getScrollOffset() {
      return this._props.scrollOffset;
    };

    Scene.prototype.buildCells = function buildCells(opts) {
      this.grid.buildCells(opts);
      return this;
    }; //--------------------------------------------------------------------------------
    // transforms
    //--------------------------------------------------------------------------------


    Scene.prototype.rotate = function rotate() {
      var size = this._props.size;
      this.set({
        size: [size[1], size[0]]
      }, true);

      this._props.padding.rotate();

      this.grid.rotate();
      return Group.prototype.rotate.apply(this, arguments);
    };

    Scene.prototype.flipX = function flipX() {
      this.grid.flipX();

      this._props.padding.flipX();

      return Group.prototype.flipX.apply(this, arguments);
    };

    Scene.prototype.flipY = function flipY() {
      this.grid.flipY();

      this._props.padding.flipY();

      return Group.prototype.flipY.apply(this, arguments);
    };

    Scene.prototype.postProcess = function postProcess() {
      var isTrellis = configUtils.isTrellis(this._props.config);

      if (!isTrellis) {
        this._addBrushLayers();
      }

      Group.prototype.postProcess.call(this);

      if (!isTrellis) {
        this._repositionCrosshair();
      }

      this.set({
        baseScrollOffset: this.getBaseScrollOffset()
      });
      return this;
    }; //-----------------------------------------------------------------------------------------
    // layout
    //-----------------------------------------------------------------------------------------


    Scene.prototype.getAvailableSize = function getAvailableSize() {
      var size = this._props.size;
      var ref = this._props.padding;
      var top = ref.top;
      var bottom = ref.bottom;
      var left = ref.left;
      var right = ref.right;
      var w = Math.max(size[0] - left - right, 0);
      var h = Math.max(size[1] - top - bottom, 0);
      return [w, h];
    }; // will center the chart within the scene


    Scene.prototype.center = function center() {
      var ref = this.getAvailableSize();
      var availableWidth = ref[0];
      var availableHeight = ref[1];
      var ref$1 = this._props.padding;
      var top = ref$1.top;
      var bottom = ref$1.bottom;
      var left = ref$1.left;
      var right = ref$1.right;
      var bb = this.boundingBox();

      if (!bb) {
        return this;
      }

      var x = bb.x;
      var y = bb.y;
      var w = bb.w;
      var h = bb.h; // center x

      var dy = h < availableHeight ? (availableHeight - h) / 2 - (y - top) : 0; // center y

      var dx = w < availableWidth ? (availableWidth - w) / 2 - (x - left) : 0;
      Group.prototype.center.call(this, dx, dy);
      return this;
    }; // ajust height of row


    Scene.prototype.adjustRowToFit = function adjustRowToFit(rowIndex) {
      this.grid.adjustRowToFit(rowIndex);
      return this;
    }; // ajust width of column


    Scene.prototype.adjustColumnToFit = function adjustColumnToFit(colIndex) {
      this.grid.adjustColumnToFit(colIndex);
      return this;
    };

    Scene.prototype.adjustRowSize = function adjustRowSize(rowIndex, size) {
      this.grid.adjustRowSize(rowIndex, size);
      return this;
    };

    Scene.prototype.adjustColumnSize = function adjustColumnSize(colIndex, size) {
      this.grid.adjustColumnSize(colIndex, size);
      return this;
    }; // Function used when exporting a chart into a given cell.
    //
    // It is used to transform the data of a given shape by adding extra fields
    // (consisting of the column/row name + value the trellis cell is in)
    //
    // @param {Object} shapeData: the key data object
    // @param {Object} extraData: the extra data fields
    // @return {Object} the resulting data


    Scene.prototype._redataFct = function _redataFct(shapeData, extraData) {
      // we want to make sure extraData is first so the trellis dims appear first
      return lodash__default.extend({}, extraData, shapeData);
    }; // exports current scene into a single cell (of another scene)
    // it takes every single layer from the current scene and adds them to the new cell.
    //
    // @param newCell {Cell} the cell into which the scene will be pasted
    // @param options {Object} an optional set of options
    // - tx/ty {Number} x/y translations into the new cell
    // - keyPrefix {String}: prefix to added to each layer key in the new cell
    //   (this is usefull if you end up pasting similar 'scenes' into a single destination cell)
    // - extraData (Object, optional): a map dimName -> dimValue of extra fields to put in the data object of each shape
    //   make sure that all shapes have a tooltip which will show the row/col in tooltip mode
    //   make sure all shapes have globally unique keys across trellis cells
    // @return the new cell


    Scene.prototype.exportIntoCell = function exportIntoCell(newCell, options) {
      var this$1 = this;
      if (options === void 0) options = {};
      var tx = options.tx;
      if (tx === void 0) tx = 0;
      var ty = options.ty;
      if (ty === void 0) ty = 0;
      var keyPrefix = options.keyPrefix;
      var extraData = options.extraData;

      if (keyPrefix == null) {
        keyPrefix = exportCounter.next();
      }

      var cells = lodash__default.sortBy(this.getCells(), function (cell) {
        return cell.get("zIndex");
      });
      cells.forEach(function (cell) {
        var ref = cell.translation();
        var x = ref[0];
        var y = ref[1];
        var clipped = cell.get("clip");
        var cellViewport = [0, 0, 0, 0];

        if (clipped) {
          cellViewport = cell.getModelProps().viewport;
        }

        var layers = lodash__default.sortBy(cell.getLayers(), function (layer) {
          return layer.get("zIndex");
        });
        layers.forEach(function (layer) {
          // since all the layers (from different trellis cells) are going to be mixed together in the newCell,
          // let's remove the zIndex. We are inserting the layer in the rigth order anyway
          layer.set({
            key: keyPrefix + "/" + cell.getKey() + "/" + layer.getKey(),
            zIndex: 0
          });

          if (layer.isBrushLayer()) {
            layer.setShapeContainerKeys(layer.getShapeContainerKeys().map(function (key) {
              return keyPrefix + "/" + cell.getKey() + "/" + key;
            }));
          }

          if (layer.get('decorationType')) {
            layer.set('refContainerKeys', layer.get('refContainerKeys').map(function (key) {
              var ref = key.split('&');
              var cellKey = ref[0];
              var layerKey = ref[1];
              return cell.getKey() + "&" + keyPrefix + "/" + cellKey + "/" + layerKey;
            }));
          }

          newCell.append(layer);
          layer.offsetX(x + tx);
          layer.offsetY(y + ty);

          if (clipped) {
            layer.set({
              viewport: [cellViewport[0] + x + tx, cellViewport[1] + y + ty, cellViewport[2], cellViewport[3]]
            });
          }

          if (extraData && (layer.get("canSelect") || layer.get("canHover"))) {
            layer.updateChildren(function (shape) {
              if (shape instanceof ShapeGroup$2) {
                // for a ShapeGroup, the tooltip is going to be on each subshape so let's modify the data there
                shape.getChildren().forEach(function (subshape) {
                  var shapeData = subshape.get("data") || {};
                  subshape.set({
                    data: {
                      row: this$1._redataFct(shapeData.row, extraData),
                      column: shapeData.column
                    }
                  });
                });
              } else {
                var shapeData = shape.get("data") || {};
                shape.set({
                  data: {
                    row: this$1._redataFct(shapeData.row, extraData),
                    column: shapeData.column
                  }
                });
              }
            });
          }
        });
      });
      return newCell;
    };

    Scene.prototype.toJson = function toJson() {
      var json = Group.prototype.toJson.call(this);
      json.grid = this.grid.toJson();
      json.props.padding = json.props.padding.toJson();
      json.legend = this.legend && this.legend.toJson(); //if (json.props.rowsMetadata) json.props.rowsMetadata = json.props.rowsMetadata.toJson();

      return json;
    };

    Scene.prototype.totalTranslation = function totalTranslation(withScrollX, withScrollY) {
      if (withScrollX === void 0) withScrollX = false;
      if (withScrollY === void 0) withScrollY = false;
      var ref = this.get("padding");
      var top = ref.top;
      var left = ref.left;
      var ref$1 = this.get('scrollOffset') || [0, 0];
      var scrollOffsetX = ref$1[0];
      var scrollOffsetY = ref$1[1];
      return [(withScrollX ? -scrollOffsetX : 0) + left, (withScrollY ? -scrollOffsetY : 0) + top];
    };

    return Scene;
  }(Group$1);

  Scene$2.type = "Scene";
  Scene$2._sensitiveProps = new StaticArraySet(["padding", "transforms"]); //
  //@flow-ignore

  var updateCounter = counter$1.init('scene::update');

  var __super__$6 = Object.getPrototypeOf(Scene$2.prototype);

  lodash__default.extend(Scene$2.prototype, {
    //--------------------------------------------------------------------------------
    // interaction
    //--------------------------------------------------------------------------------
    onScroll: function onScroll(x, y) {
      this.set({
        scrollOffset: [x, y]
      });
      return this;
    },
    prepareForInteraction: function prepareForInteraction() {
      this._sortChildren();

      return this;
    },
    //-----------------------------------------------------------------------------------------
    // serialize/materialize
    //-----------------------------------------------------------------------------------------
    getModelProps: function getModelProps() {
      return {
        key: this._props.key,
        type: this.getType(),
        fullSize: this.getFullSize(),
        size: this._props.size,
        scrollOffset: this._props.scrollOffset,
        baseScrollOffset: this._props.baseScrollOffset,
        position: this._props.position,
        background: this._props.background,
        accessibility: this._props.accessibility
      };
    },
    //-----------------------------------------------------------------------------------------
    // composite scene
    //-----------------------------------------------------------------------------------------

    /**
     * Crosshairs are in between the plot cell and the axis cell. Before we relax the cell constrains (W-3867059)
     * We need to temporarily have a cloned axis cell on top of the plot cell containing only the crosshair layer.
     * @private
     */
    _repositionCrosshair: function _repositionCrosshair() {
      var this$1 = this;
      var crossableLayerKeys = this.find({
        type: 'Layer',
        canSelect: true
      }).map(function (l) {
        var cell = l.getParent();
        return cell && cell.get('key') + "&" + l.get('key');
      });
      var crosshairLayers = this.find({
        decorationType: function decorationType(_decorationType) {
          return _decorationType === constants$1.DECORATION_LAYER_TYPE.TIME_CROSSHAIR || _decorationType === constants$1.DECORATION_LAYER_TYPE.DISCRETE_CROSSHAIR;
        }
      });

      if (crosshairLayers.length) {
        crosshairLayers.forEach(function (layer, i) {
          var cell = layer && layer.getParent();
          layer.set({
            'refContainerKeys': crossableLayerKeys
          });

          if (cell) {
            this$1.append(this$1._separateCrosshairLayer(cell, layer, i));
          }
        });
      }
    },
    _separateCrosshairLayer: function _separateCrosshairLayer(cell, crosshairLayer, index) {
      var allLayers = cell.getChildren();
      var nonDecorationLayers = allLayers.filter(function (layer) {
        return layer !== crosshairLayer;
      });
      cell.removeAll();
      var newCell = cell.clone();
      cell.appendAll(nonDecorationLayers);
      newCell.append(crosshairLayer);
      newCell.set('key', "crosshair-cell-" + index);
      newCell.set('zIndex', 10);
      return newCell;
    },
    _addBrushLayers: function _addBrushLayers() {
      var brushLayerMap = {};
      this.getChildren().forEach(function (cell) {
        cell.getChildren().forEach(function (layer) {
          var brushInfo = layer.get('brush');

          if (layer.get('canSelect') && brushInfo) {
            if (brushLayerMap[brushInfo.key] == null) {
              brushLayerMap[brushInfo.key] = [];
            }

            var layers = brushLayerMap[brushInfo.key];

            if (layers) {
              layers.push(layer);
            }
          }
        });
      });

      this._createBrushLayers(brushLayerMap);
    },
    _createBrushLayers: function _createBrushLayers(brushLayerMap) {
      var this$1 = this;
      lodash__default.keys(brushLayerMap).forEach(function (key) {
        var layers = brushLayerMap[key];

        if (layers.length) {
          var firstLayer = layers[0];
          var brushInfo = firstLayer.get('brush');

          if (brushInfo) {
            var type = brushInfo.type;
            var key$1 = brushInfo.key;
            var area = brushInfo.area;
            var color = brushInfo.color;
            var getBrushStep = brushInfo.getBrushStep;
            var dataGranularity = brushInfo.dataGranularity;
            var firstDayOfWeek = brushInfo.firstDayOfWeek;
            var format = brushInfo.format;
            var scale = brushInfo.scale;
            var parent = firstLayer.getParent();
            BrushLayerFactory.make(type, {
              key: key$1,
              cell: parent,
              x: firstLayer.get('x'),
              y: firstLayer.get('y'),
              w: area.width,
              h: area.height,
              zIndex: 100,
              brushStrokeColor: color.stroke,
              brushFillColor: color.fill,
              brushTextColor: color.text,
              shapeContainerKeys: layers.map(function (x) {
                return x.get('key');
              }),
              hasControlPoints: this$1.get('selectMode') === constants$1.SELECTMODE.RANGE,
              getBrushStep: getBrushStep,
              dataGranularity: dataGranularity,
              firstDayOfWeek: firstDayOfWeek,
              format: format,
              scale: scale
            });
          }
        }
      });
    }
  });

  Scene$2.fromJson = function (json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;

    var scene = __super__$6.constructor.fromJson.call(this, json, deepCopy, Scene$2);

    scene.grid = Grid.fromJson(json.grid, deepCopy).attachScene(scene);

    if (json.props) {
      var padding = json.props.padding;

      if (padding) {
        scene._props.padding = Padding.fromJson(padding, deepCopy);
      }

      var selectionColumns = json.props.selectionColumns;

      if (selectionColumns) {
        scene._props.selectionColumns = selectionColumns.map(function (selectionColumn) {
          return ColumnFactory$1.getInstance().buildColumn(selectionColumn);
        });
      }

      var rowsMetadata = json.props.rowsMetadata;

      if (rowsMetadata) {
        scene._props.rowsMetadata = RowsMetadata.fromJson(rowsMetadata);
      }

      var background = json.props.background;

      if (background) {
        scene._props.background = colorUtils.getColor(background);
      }
    }

    if (json.legend) {
      scene.legend = Scene$2.fromJson(json.legend);
    }

    return scene;
  };

  var LineModel = function (ShapeMode____1) {
    function LineModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) LineModel.__proto__ = ShapeMode____1;
    LineModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    LineModel.prototype.constructor = LineModel;

    LineModel.prototype._getTweensByScale = function _getTweensByScale(scales0, scales1) {
      var s0, s1, stretchDim;
      var ref = this.props;
      var x = ref.x;
      var y = ref.y;
      var h = ref.h;
      var vertical = ref.vertical;
      var tweens = {};

      if ((s0 = scales0.x) && (s1 = scales1.x)) {
        tweens.x = scales.transpose(x, s1, s0);
        stretchDim = vertical ? "dy" : "dx";

        if (!vertical) {
          tweens.h = scales.transpose(x + h, s1, s0);
        }

        tweens[stretchDim] = scales.transpose(x + this.props[stretchDim], s1, s0) - tweens.x;
      }

      if ((s0 = scales0.y) && (s1 = scales1.y)) {
        tweens.y = scales.transpose(y, s1, s0);
        stretchDim = vertical ? "dx" : "dy";

        if (vertical) {
          tweens.h = scales.transpose(y + h, s1, s0);
        }

        tweens[stretchDim] = scales.transpose(y + this.props[stretchDim], s1, s0) - tweens.y;
      }

      this._handleRotation(tweens, scales0, scales1);

      return tweens;
    };

    LineModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        dx: 0,
        dy: 0,
        lineWidth: 0
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    LineModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getEndModelRemove.call(this, ctx);
      }

      return lodash__default.extend({
        dx: this.props.dx * 1.5,
        dy: this.props.dy * 1.5
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    return LineModel;
  }(ShapeModel); //


  var LineMorphingModel = pathable(LineModel);

  var __super__$9 = Object.getPrototypeOf(Line$2.prototype);

  function getDelegate() {
    return ServiceProvider$1.getDelegate();
  }

  lodash__default.extend(Line$2.prototype, {
    //-----------------------------------------------------------------------------------------
    // interaction - shape detection
    //-----------------------------------------------------------------------------------------
    isUnderCursor: function isUnderCursor(x, y) {
      var ref = this._props;
      var x0 = ref.x0;
      var y0 = ref.y0;
      var x1 = ref.x1;
      var y1 = ref.y1;
      var lineWidth = ref.lineWidth;
      var curve;

      if (this._props.curveFunction) {
        curve = this._props.curveFunction([x0, y0], [x1, y1]);
      }

      if (curve && getDelegate().isPointInStroke) {
        return getDelegate().isPointInStroke(function (ctx) {
          canvasUtils.drawCurve({
            ctx: ctx,
            lineWidth: lineWidth,
            curve: curve
          });
        }, x, y);
      } else {
        return false;
      }
    },
    isInArea: function isInArea(x, y, w, h) {
      return false;
    },
    //-----------------------------------------------------------------------------------------
    // to model
    //-----------------------------------------------------------------------------------------
    toModel: function toModel() {
      return __super__$9.toModel.call(this, LineMorphingModel);
    },
    getModelProps: function getModelProps() {
      var ref = this._props.vertical ? [this._props.x0, this._props.baseYValue, this._props.y0 - this._props.y1, this._props.x1 - this._props.x0, this._props.baseYValue - this._props.y0] : [this._props.baseXValue, this._props.y0, this._props.x1 - this._props.x0, this._props.y1 - this._props.y0, this._props.x0 - this._props.baseXValue];
      var x = ref[0];
      var y = ref[1];
      var dx = ref[2];
      var dy = ref[3];
      var h = ref[4];
      var curve = undefined;

      if (this._props.curveFunction) {
        curve = this._props.curveFunction([h, 0], [dx + h, dy]);
      }

      var rotation = {
        x: x,
        y: y,
        angle: this._props.vertical ? -Math.PI / 2 : 0
      };
      return lodash__default.extend(this.getCommonModelProps(), this.applyShapeEffects(), {
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        lineWidth: this._props.lineWidth,
        h: h,
        rotation: rotation,
        dashed: this._props.dashed,
        vertical: this._props.vertical,
        curve: curve
      });
    }
  });
  Line$2._roundProps = new StaticArraySet(["x0", "y0", "x1", "y1", "baseXValue", "baseYValue"]);

  var PointModel = function (ShapeMode____1) {
    function PointModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) PointModel.__proto__ = ShapeMode____1;
    PointModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    PointModel.prototype.constructor = PointModel;

    PointModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getEndModelRemove.call(this, ctx);
      }

      return lodash__default.extend({
        r: this.props.r * 1.5
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    PointModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        r: 0
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    return PointModel;
  }(ShapeModel); //


  var BasePathablePointModel = pathable(PointModel);
  /*::(x: PointMorphingModel) => (x: IPathable<CircleModelProperties>)*/

  var PointMorphingModel = function (BasePathablePointModel) {
    function PointMorphingModel() {
      BasePathablePointModel.apply(this, arguments);
    }

    if (BasePathablePointModel) PointMorphingModel.__proto__ = BasePathablePointModel;
    PointMorphingModel.prototype = Object.create(BasePathablePointModel && BasePathablePointModel.prototype);
    PointMorphingModel.prototype.constructor = PointMorphingModel;

    PointMorphingModel.prototype.getPathProps = function getPathProps(nVertices, props) {
      var ref = this._sampleCurve(Math.PI, Math.PI * 2, props.r, true, nVertices);

      var pointsX = ref[0];
      var pointsY = ref[1];
      return {
        animate_points_x: pointsX,
        animate_points_y: pointsY
      };
    };

    PointMorphingModel.prototype.getNumVertices = function getNumVertices() {
      return 20;
    };

    return PointMorphingModel;
  }(BasePathablePointModel);

  var __super__$10 = Object.getPrototypeOf(Point.prototype);

  var EPSILON$2 = 0.00001;
  lodash__default.extend(Point.prototype, {
    //-----------------------------------------------------------------------------------------
    // interaction - shape detection
    //-----------------------------------------------------------------------------------------
    getAnnotationInfo: function getAnnotationInfo() {
      var ref = this.getTranslatedBox();
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      var positions = [{
        x: x + w / 2,
        y: y + h / 2,
        orientations: ["right", "top", "left", "bottom"]
      }];

      if (this._props.r > 5) {
        positions = [{
          x: x + w,
          y: y + h / 2,
          orientations: ["right"]
        }, {
          x: x + w / 2,
          y: y,
          orientations: ["top"]
        }, {
          x: x,
          y: y + h / 2,
          orientations: ["left"]
        }, {
          x: x + w / 2,
          y: y + h,
          orientations: ["bottom"]
        }, {
          x: x + w,
          y: y + h / 2,
          orientations: ["top", "bottom", "left"]
        }, {
          x: x + w / 2,
          y: y,
          orientations: ["right", "left", "bottom"]
        }, {
          x: x,
          y: y + h / 2,
          orientations: ["top", "bottom", "right"]
        }, {
          x: x + w / 2,
          y: y + h,
          orientations: ["right", "left", "top"]
        }];
      }

      return {
        positions: positions,
        shouldUpdate: false
      };
    },
    isUnderCursor: function isUnderCursor(x, y) {
      var diffX = x - this._props.x;
      var diffY = y - this._props.y;
      var rsquare = diffX * diffX + diffY * diffY;
      var r = this._props.r + (this._props.stroke ? this._props.lineWidth / 2 : 0) + (this._isHoverAreaExtended ? 50 : 0);
      return rsquare <= r * r;
    },
    isUnderLine: function isUnderLine(x0, y0, x1, y1) {
      var ref = this._props;
      var x = ref.x;
      var y = ref.y;
      return mathUtils.isInRange(x, x0, x1, 1) && mathUtils.isInRange(y, y0, y1, 1) && Math.abs((y1 - y0) * x + (x0 - x1) * y + (x1 * y0 - x0 * y1)) < EPSILON$2;
    },
    cross: function cross() {
      if (this.get('data') && this.get('showWhenCrossed')) {
        this.set('hidden', false);
      }

      __super__$10.cross();

      return this;
    },
    uncross: function uncross() {
      if (this.get('data') && this.get('showWhenCrossed')) {
        this.set('hidden', true);
      }

      __super__$10.uncross();

      return this;
    },
    tabOn: function tabOn() {
      if (this.get('data') && this.get('showWhenCrossed')) {
        this.set('hidden', false);
      }

      __super__$10.tabOn.call(this);

      return this;
    },
    tabOff: function tabOff() {
      if (this.get('data') && this.get('showWhenCrossed')) {
        this.set('hidden', true);
      }

      __super__$10.tabOff.call(this);

      return this;
    },
    //-----------------------------------------------------------------------------------------
    // to/from
    //-----------------------------------------------------------------------------------------
    toModel: function toModel() {
      return __super__$10.toModel.call(this, PointMorphingModel);
    },
    getModelProps: function getModelProps() {
      var effectsProps = this.applyShapeEffects(); // don't add hidden to the model

      delete effectsProps.hidden;
      return lodash__default.extend(this.getCommonModelProps(), effectsProps, {
        x: this._props.x,
        y: this._props.y,
        propertiesByScale: this.getPropertiesByScale()
      });
    }
  });

  var PathModel = function (ShapeMode____1) {
    function PathModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) PathModel.__proto__ = ShapeMode____1;
    PathModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    PathModel.prototype.constructor = PathModel;

    PathModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        points_x: this.props.points_x.map(function (x) {
          return x;
        }),
        points_y: this.props.points_y.map(function (y) {
          return 0;
        }),
        lineWidth: 0
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    PathModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getEndModelRemove.call(this, ctx);
      }

      return lodash__default.extend({
        points_x: this.props.points_x.map(function (x) {
          return x;
        }),
        points_y: this.props.points_y.map(function (y) {
          return y * 1.5;
        })
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    return PathModel;
  }(ShapeModel); //


  var PathMorphingModel = pathable(PathModel); //

  /**
   * Created by yi.chen on 4/28/17.
   */
  //@flow-ignore

  var __super__$11 = Object.getPrototypeOf(Path$2.prototype);

  lodash__default.extend(Path$2.prototype, {
    isUnderCursor: function isUnderCursor(x, y) {
      return false;
    },
    isInArea: function isInArea(x, y) {
      return false;
    },
    isUnderLine: function isUnderLine(x0, y0, x1, y1) {
      return false;
    },
    getModelProps: function getModelProps() {
      var ref = this._props;
      var x = ref.x;
      var y = ref.y;
      var points_x = ref.points_x;
      var points_y = ref.points_y;
      var dashed = ref.dashed;
      var closePath = ref.closePath;
      var lineWidth = ref.lineWidth;
      var baseX = ref.baseX;
      var baseY = ref.baseY;
      var lineJoin = ref.lineJoin;
      return lodash__default.extend(this.getCommonModelProps(), this.applyShapeEffects(), {
        x: x,
        y: y,
        points_x: points_x,
        points_y: points_y,
        dashed: dashed,
        closePath: closePath,
        lineWidth: lineWidth,
        lineJoin: lineJoin,
        baseX: baseX == null || closePath ? null : baseX - x,
        baseY: baseY == null || closePath ? null : baseY - y
      });
    },
    toModel: function toModel() {
      return __super__$11.toModel.call(this, PathMorphingModel);
    }
  });
  var envUtils = {
    // return true if we are in a browser
    inBrowser: function inBrowser() {
      return typeof MobileDelegate === "undefined" || MobileDelegate === null;
    },
    isMobile: function isMobile() {
      var check = false;

      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);

      return check;
    }
  };
  lodash__default.extend(NumberText$2.prototype, {
    getModelProps: function getModelProps() {
      var ref = this.applyShapeEffects();
      var stroke = ref.stroke;
      var bgColor = ref.bgColor;
      var fill = stroke;
      var fontSize = this._props.size;
      var rotation = this.getRotation();
      var ref$1 = this.getTextXY();
      var x = ref$1[0];
      var y = ref$1[1];
      var bg = bgColor ? {
        color: bgColor,
        box: this.trueBoundingBox().toArray()
      } : null;
      var propertiesByScale = {
        x: ["x"],
        y: ["y"]
      };
      return lodash__default.extend(this.getCommonModelProps(), {
        x: x,
        y: y,
        fontSize: fontSize,
        fill: fill,
        propertiesByScale: propertiesByScale,
        rotation: rotation,
        bg: bg,
        format: this._props.format,
        number: this._props.number,
        compact: this._props.compact
      }, this._exposeFormattingInfo());
    },
    _exposeFormattingInfo: function _exposeFormattingInfo() {
      var ref = this._props;
      var format = ref.format;
      var number = ref.number;
      var compact = ref.compact;
      return envUtils.inBrowser() ? {
        format: format,
        number: number,
        compact: compact
      } : {
        formattedNumber: formatNumber(format, compact)(number)
      };
    }
  });

  var ArcModel = function (ShapeMode____1) {
    function ArcModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) ArcModel.__proto__ = ShapeMode____1;
    ArcModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    ArcModel.prototype.constructor = ArcModel;

    ArcModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getEndModelRemove.call(this, ctx);
      }

      return lodash__default.extend({
        r1: this.props.r1 * 1.5,
        r2: this.props.r2 * 1.5,
        textR: this.props.textR * 1.5
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    ArcModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        r1: this.props.r1 * 0.9,
        r2: this.props.r2 * 0.9,
        textR: this.props.textR * 0.9
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    return ArcModel;
  }(ShapeModel); //


  var BasePathableArcModel = pathable(ArcModel);
  /*::(x: ArcMorphingModel) => (x: IPathable<ArcModelProperties>)*/

  var ArcMorphingModel = function (BasePathableArcModel) {
    function ArcMorphingModel() {
      BasePathableArcModel.apply(this, arguments);
    }

    if (BasePathableArcModel) ArcMorphingModel.__proto__ = BasePathableArcModel;
    ArcMorphingModel.prototype = Object.create(BasePathableArcModel && BasePathableArcModel.prototype);
    ArcMorphingModel.prototype.constructor = ArcMorphingModel;

    ArcMorphingModel.prototype.getPathProps = function getPathProps(nVertices, props) {
      var startAngle = props.startAngle;
      var angle = props.angle;
      var r1 = props.r1;
      var r2 = props.r2;
      var nSamples = Math.floor(nVertices / 4);
      var residue = nVertices % 4;

      var ref = this._sampleCurve(startAngle, angle, r1, true, nSamples + (residue > 0 ? 1 : 0));

      var outerX = ref[0];
      var outerY = ref[1];

      var ref$1 = this._sampleCurve(startAngle, angle, r2, false, nSamples + (residue > 2 ? 1 : 0));

      var innerX = ref$1[0];
      var innerY = ref$1[1];

      var ref$2 = this._sampleLine(r2 * Math.cos(startAngle), r2 * Math.sin(startAngle), r1 * Math.cos(startAngle), r1 * Math.sin(startAngle), nSamples + (residue > 1 ? 1 : 0));

      var lxs1 = ref$2[0];
      var lys1 = ref$2[1];

      var ref$3 = this._sampleLine(r1 * Math.cos(startAngle + angle), r1 * Math.sin(startAngle + angle), r2 * Math.cos(startAngle + angle), r2 * Math.sin(startAngle + angle), nSamples);

      var lxs2 = ref$3[0];
      var lys2 = ref$3[1];
      return {
        animate_points_x: innerX.concat(lxs1).concat(outerX).concat(lxs2),
        animate_points_y: innerY.concat(lys1).concat(outerY).concat(lys2)
      };
    };

    ArcMorphingModel.prototype.getNumVertices = function getNumVertices() {
      return 40;
    };

    return ArcMorphingModel;
  }(BasePathableArcModel);

  var Arc$3 = function (Shap____1) {
    function Arc() {
      Shap____1.apply(this, arguments);
    }

    if (Shap____1) Arc.__proto__ = Shap____1;
    Arc.prototype = Object.create(Shap____1 && Shap____1.prototype);
    Arc.prototype.constructor = Arc;

    Arc.initClass = function initClass() {
      this.type = "Arc";
      this.shapeEffectsProps = ["fill", "stroke", "r1", "r2", "textR"];
    };

    Arc.prototype._setDefaultProps = function _setDefaultProps() {
      Shap____1.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "Arc";
      props.r1 = 0;
      props.r2 = 0;
      props.stroke = undefined;
      props.fill = undefined;
      props.startAngle = 0;
      props.angle = 0;
      props.roundedCornerStart = false;
      props.roundedCornerEnd = false;
      props.lineWidth = 1;
      props.text = undefined; // text to display

      props.subText = undefined; // subText below the main text

      props.textR = 0; // distance (radius) of text from center

      props.textColor = undefined; // text color

      props.fontSize = undefined; // font size (undefined == default)

      props.subTextFontSize = undefined; // subText font size (undefined == default)

      props.selectionShapeEffect = [props.selectionShapeEffect, RadiusScalingSelectionShapeEffect.getDescriptor()];
    };

    Arc.prototype.set = function set(props, value, silent) {
      this._forceRecomputeBoundingBox();

      return Shap____1.prototype.set.call(this, props, value, silent);
    };

    Arc.prototype.isVisible = function isVisible() {
      return Shap____1.prototype.isVisible.call(this) && this._props.r1 > 0;
    }; //-----------------------------------------------------------------------------------------
    // bounding box
    //-----------------------------------------------------------------------------------------


    Arc.prototype._computeTrueBoundingBox = function _computeTrueBoundingBox() {
      return new Box({
        x: -this._props.r1,
        y: -this._props.r1,
        w: 2 * this._props.r1,
        h: 2 * this._props.r1
      });
    }; // x, y scale does not impact Arc position


    Arc.prototype.domainBox = function domainBox() {
      return new Box({
        x: 0,
        y: 0,
        w: 0,
        h: 0
      });
    }; //-----------------------------------------------------------------------------------------
    // transform
    //-----------------------------------------------------------------------------------------


    Arc.prototype.rotate = function rotate() {
      this._props.startAngle -= Math.PI / 2;
      return this;
    };

    Arc.prototype.flipY = function flipY() {
      this._props.startAngle = -this._props.startAngle;
      this._props.angle = -this._props.angle;
      return this;
    };

    Arc.prototype.flipX = function flipX() {
      this._props.startAngle = Math.PI - this._props.startAngle;
      this._props.angle = -this._props.angle;
      return this;
    };

    Arc.prototype.offsetAngle = function offsetAngle(alpha) {
      this._props.startAngle += alpha;
      return this;
    };

    Arc.prototype.getPropertiesByScale = function getPropertiesByScale() {
      return {
        r: ["r1", "r2"]
      };
    };

    return Arc;
  }(Shape);

  Arc$3.initClass();
  var TwoPI = Math.PI * 2;

  var __super__$12 = Object.getPrototypeOf(Arc$3.prototype);

  function getDelegate$1() {
    return ServiceProvider$1.getDelegate();
  }

  lodash__default.extend(Arc$3.prototype, {
    //-----------------------------------------------------------------------------------------
    // interaction - shape detection
    //-----------------------------------------------------------------------------------------
    isUnderCursor: function isUnderCursor(x, y) {
      var middle, middle1;
      var ref = this.applyShapeEffects();
      var r1 = ref.r1;
      var r2 = ref.r2;
      var ref$1 = this._props;
      var startAngle = ref$1.startAngle;
      var angle = ref$1.angle;
      var roundedCornerStart = ref$1.roundedCornerStart;
      var roundedCornerEnd = ref$1.roundedCornerEnd;

      if (this._props.stroke) {
        r1 += this._props.lineWidth / 2;
        r2 = Math.max(r2 - this._props.lineWidth / 2, 0);
      }

      var rsquare = x * x + y * y;

      if (rsquare > r1 * r1 || rsquare < r2 * r2) {
        return false;
      }

      var myangle = Math.atan2(y, x);

      if (angle < 0) {
        angle = -angle;
        startAngle -= angle;
        var assign;
        assign = [roundedCornerEnd, roundedCornerStart], roundedCornerStart = assign[0], roundedCornerEnd = assign[1];
      }

      var roundedRadius = (r1 - r2) / 2;
      var roundedCornerAngle = Math.atan(roundedRadius / (r2 + roundedRadius));

      if (roundedCornerStart) {
        startAngle -= roundedCornerAngle;
        angle += roundedCornerAngle;
      }

      if (roundedCornerEnd) {
        angle += roundedCornerAngle;
      }

      return startAngle <= myangle && myangle <= startAngle + angle || startAngle <= (middle = myangle - TwoPI) && middle <= startAngle + angle || startAngle <= (middle1 = myangle + TwoPI) && middle1 <= startAngle + angle;
    },
    //-----------------------------------------------------------------------------------------
    // to/from
    //-----------------------------------------------------------------------------------------
    toModel: function toModel() {
      return __super__$12.toModel.call(this, ArcMorphingModel);
    },
    getAnnotationInfo: function getAnnotationInfo() {
      var ref = this.totalTranslation(true, true);
      var tx = ref[0];
      var ty = ref[1];
      var ref$1 = this.getModelProps();
      var r1 = ref$1.r1;
      var r2 = ref$1.r2;
      var startAngle = ref$1.startAngle;
      var angle = ref$1.angle;
      var myangle = startAngle + angle / 2;

      if (myangle > TwoPI) {
        myangle -= TwoPI;
      }

      if (myangle < 0) {
        myangle += TwoPI;
      }

      var outerSideOrientation = "left";
      var innerSideOrientation = "right";

      if (myangle <= Math.PI / 2 || myangle >= 3 * Math.PI / 2) {
        outerSideOrientation = "right";
        innerSideOrientation = "left";
      }

      var xOuter = r1 * Math.cos(myangle) + tx;
      var yOuter = r1 * Math.sin(myangle) + ty;
      var xInner = r2 * Math.cos(myangle) + tx;
      var yInner = r2 * Math.sin(myangle) + ty;
      var layer = this.getLayer();

      if (layer) {
        var scene = layer.getScene();

        if (scene) {
          var ref$2 = scene.get("position");
          var sx = ref$2[0];
          var sy = ref$2[1];
          xOuter += sx;
          yOuter += sy;
          xInner += sx;
          yInner += sy;
        }
      }

      return {
        positions: [{
          x: xOuter,
          y: yOuter,
          orientations: [outerSideOrientation, "top", "bottom"]
        }, {
          x: xInner,
          y: yInner,
          orientations: [innerSideOrientation, "top", "bottom"]
        }],
        shouldUpdate: true
      };
    },
    getModelProps: function getModelProps() {
      // let's make sure r2 < r1
      if ((this._props.r1 || 0) < (this._props.r2 || 0)) {
        var assign;
        assign = [this._props.r2, this._props.r1], this._props.r1 = assign[0], this._props.r2 = assign[1];
      }

      var shapeEffectProps = this.applyShapeEffects();
      var ref = this._props;
      var startAngle = ref.startAngle;
      var angle = ref.angle;
      var lineWidth = ref.lineWidth;
      var roundedCornerStart = ref.roundedCornerStart;
      var roundedCornerEnd = ref.roundedCornerEnd;
      var text = ref.text;
      var subText = ref.subText;
      var textColor = ref.textColor;
      var fontSize = ref.fontSize;
      var subTextFontSize = ref.subTextFontSize;
      fontSize = fontSize && Math.ceil(fontSize);
      subTextFontSize = subTextFontSize && Math.ceil(subTextFontSize);

      if (text && textColor) {
        var textH = getDelegate$1().getRealFontSize(fontSize);
        var textAngle = startAngle + angle / 2;
        var textR = shapeEffectProps.textR;
        var xCenter = textR * Math.cos(textAngle);
        var yCenter = textR * Math.sin(textAngle); // small optimization: let's try to fit a small box inside the arc.
        // If it doesn't fit, let's not even try to measure the text

        var textDoesFit = false; // w roughtly 2 letters...

        var w = textH * 2;
        var h = textH; // if there is subText, add padding (0.1 of the text and the subText height) between the main text and the subText, and the text height of the subText

        if (subText) {
          var subTextH = getDelegate$1().getRealFontSize(subTextFontSize);
          h += textH * 0.1 + subTextH * 1.1;
        }

        if (this._isRectInsideArc(xCenter, yCenter, w, h)) {
          // now let's try with the real text width
          w = subText ? Math.max(getDelegate$1().getTextWidth(text, fontSize), getDelegate$1().getTextWidth(subText, subTextFontSize)) : getDelegate$1().getTextWidth(text, fontSize);

          if (this._isRectInsideArc(xCenter, yCenter, w, h)) {
            textDoesFit = true;
          }
        }

        if (!textDoesFit) {
          text = undefined;
          subText = undefined;
        }
      }

      return lodash__default.extend(this.getCommonModelProps(), shapeEffectProps, {
        x: 0,
        y: 0,
        startAngle: startAngle,
        angle: angle,
        lineWidth: lineWidth,
        propertiesByScale: this.getPropertiesByScale(),
        roundedCornerStart: roundedCornerStart,
        roundedCornerEnd: roundedCornerEnd,
        text: text,
        subText: subText,
        textColor: textColor,
        fontSize: fontSize,
        subTextFontSize: subTextFontSize
      });
    },
    // checks whether a rectangle fits inside the arc
    // the box is a rectangle of width w and height h, centered on [ xCenter, yCenter ]
    _isRectInsideArc: function _isRectInsideArc(xCenter, yCenter, w, h) {
      var x = xCenter - w / 2;
      var y = yCenter - h / 2;
      return this.isUnderCursor(x, y) && this.isUnderCursor(x + w, y) && this.isUnderCursor(x + w, y + h) && this.isUnderCursor(x, y + h);
    }
  });

  var PolygonModel = function (ShapeMode____1) {
    function PolygonModel() {
      ShapeMode____1.apply(this, arguments);
    }

    if (ShapeMode____1) PolygonModel.__proto__ = ShapeMode____1;
    PolygonModel.prototype = Object.create(ShapeMode____1 && ShapeMode____1.prototype);
    PolygonModel.prototype.constructor = PolygonModel;

    PolygonModel.prototype.getStartModelInsert = function getStartModelInsert(ctx) {
      var this$1 = this;

      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getStartModelInsert.call(this, ctx);
      }

      return lodash__default.extend({
        points_x: this.props.points_x.map(function (x) {
          return x - (x - this$1.props.centroidX) / 4;
        }),
        points_y: this.props.points_y.map(function (y) {
          return y - (y - this$1.props.centroidY) / 4;
        })
      }, ShapeMode____1.prototype.getStartModelInsert.call(this, ctx));
    };

    PolygonModel.prototype.getEndModelRemove = function getEndModelRemove(ctx) {
      var this$1 = this;

      if (ctx.disableMorphing) {
        return ShapeMode____1.prototype.getEndModelRemove.call(this, ctx);
      }

      return lodash__default.extend({
        points_x: this.props.points_x.map(function (x) {
          return x + (x - this$1.props.centroidX) * 1.2;
        }),
        points_y: this.props.points_y.map(function (y) {
          return y + (y - this$1.props.centroidY) * 1.2;
        })
      }, ShapeMode____1.prototype.getEndModelRemove.call(this, ctx));
    };

    return PolygonModel;
  }(ShapeModel); //


  var BasePathablePolygonModel = pathable(PolygonModel);
  /*::(x: PolygonMorphingModel) => (x: IPathable<PolygonModelProperties>)*/

  var PolygonMorphingModel = function (BasePathablePolygonModel) {
    function PolygonMorphingModel() {
      BasePathablePolygonModel.apply(this, arguments);
    }

    if (BasePathablePolygonModel) PolygonMorphingModel.__proto__ = BasePathablePolygonModel;
    PolygonMorphingModel.prototype = Object.create(BasePathablePolygonModel && BasePathablePolygonModel.prototype);
    PolygonMorphingModel.prototype.constructor = PolygonMorphingModel;

    PolygonMorphingModel.prototype.getPathProps = function getPathProps(nVertices, props) {
      var this$1 = this;
      var points_x = props.points_x;
      var points_y = props.points_y;

      if (points_x && points_x.length && points_y && points_y.length) {
        var startIdx = this._getStartIndex(points_x, points_y);

        var len = points_x.length;
        var nSamplesPerSide = Math.floor(nVertices / len);
        var residue = nVertices % len;
        var pointsX = [];
        var pointsY = [];

        for (var i = 0; i < len; ++i) {
          var idx = (startIdx + i) % len;
          var nSamples = nSamplesPerSide + (i < residue ? 1 : 0);
          var nextIdx = i === len - 1 ? startIdx : (idx + 1) % len;

          var ref = this$1._sampleLine(points_x[idx], points_y[idx], points_x[nextIdx], points_y[nextIdx], nSamples);

          var pxs = ref[0];
          var pys = ref[1];
          pointsX = pointsX.concat(pxs);
          pointsY = pointsY.concat(pys);
        }

        return {
          animate_points_x: pointsX,
          animate_points_y: pointsY
        };
      }

      return null;
    }; // For the case we support now, it does not need to further find the first index


    PolygonMorphingModel.prototype._getStartIndex = function _getStartIndex(points_x, points_y) {
      return 0;
    };

    PolygonMorphingModel.prototype.getNumVertices = function getNumVertices() {
      return this.props.points_x && this.props.points_x.length || -1;
    };

    return PolygonMorphingModel;
  }(BasePathablePolygonModel);

  var __super__$13 = Object.getPrototypeOf(Polygon.prototype);

  lodash__default.extend(Polygon.prototype, {
    getAnnotationInfo: function getAnnotationInfo() {
      var ref = this.centroid();
      var x = ref[0];
      var y = ref[1];
      var ref$1 = this.totalTranslation(true, true);
      var tx = ref$1[0];
      var ty = ref$1[1];
      x += tx;
      y += ty;
      var layer = this.getLayer();

      if (layer) {
        var scene = layer.getScene();

        if (scene) {
          var ref$2 = scene.get("position");
          var sx = ref$2[0];
          var sy = ref$2[1];
          x += sx;
          y += sy;
        }
      }

      return {
        positions: [{
          x: x,
          y: y,
          orientations: ["right", "top", "left", "bottom"]
        }],
        shouldUpdate: false
      };
    },
    //-----------------------------------------------------------------------------------------
    // interaction - shape detection
    //-----------------------------------------------------------------------------------------
    isUnderCursor: function isUnderCursor(x, y) {
      // TODO this is a huge hack!  need to write PIP
      var inBb = __super__$13.isUnderCursor.call(this, x, y);

      var inside = false;

      if (inBb && this._props.points_x.length > 2) {
        var rotation = this.getRotation();

        if (rotation) {
          var assign;
          assign = geometryUtils.rotate([x, y], {
            x: rotation.x,
            y: rotation.y,
            angle: -rotation.angle
          }), x = assign[0], y = assign[1];
        }

        x -= this._props.x;
        y -= this._props.y;
        var points = dataUtils.zip(this._props.points_x, this._props.points_y);
        var ref = points[points.length - 1];
        var x0 = ref[0];
        var y0 = ref[1];
        points.map(function (point) {
          var xn = point[0];
          var yn = point[1];
          var x1, x2, y1, y2;

          if (xn > x0) {
            x1 = x0;
            y1 = y0;
            x2 = xn;
            y2 = yn;
          } else {
            x1 = xn;
            y1 = yn;
            x2 = x0;
            y2 = y0;
          }

          if (xn < x === x <= x0 && (y - y1) * (x2 - x1) < (y2 - y1) * (x - x1)) {
            inside = !inside;
          }

          x0 = xn;
          y0 = yn;
        });
      }

      return inside;
    },
    //-----------------------------------------------------------------------------------------
    // to/from
    //-----------------------------------------------------------------------------------------
    toModel: function toModel() {
      return __super__$13.toModel.call(this, PolygonMorphingModel);
    },
    getModelProps: function getModelProps() {
      // on hover layout override selection layout
      var rotation = this.getRotation();
      var propertiesByScale = this._props.vertical ? {
        x: ["x", "points_y"],
        y: ["y", "points_x"]
      } : {
        x: ["x", "points_x"],
        y: ["y", "points_y"]
      };
      var ref = this.centroid();
      var centroidX = ref[0];
      var centroidY = ref[1];
      return lodash__default.extend(this.getCommonModelProps(), this.applyShapeEffects(), {
        x: this._props.x,
        y: this._props.y,
        centroidX: centroidX,
        centroidY: centroidY,
        points_x: this._props.points_x,
        points_y: this._props.points_y,
        lineWidth: this._props.lineWidth,
        closePath: this._props.closePath,
        propertiesByScale: propertiesByScale,
        rotation: rotation,
        lineJoin: this._props.lineJoin
      });
    }
  }); //

  var instance$7 = null;
  var constructorByNodeType = null;

  var NodeFactory$1 = function NodeFactory() {};

  NodeFactory$1.getInstance = function getInstance() {
    if (!instance$7) {
      instance$7 = new NodeFactory$1();
      constructorByNodeType = {
        Arc: Arc$3,
        Scene: Scene$2,
        Cell: Cell$2,
        Layer: Layer,
        Line: Line$2,
        Point: Point,
        Path: Path$2,
        Rect: Rect$3,
        Text: Text$1,
        NumberText: NumberText$2,
        ShapeGroup: ShapeGroup$2,
        Polygon: Polygon
      };
    }

    return instance$7;
  };

  NodeFactory$1.prototype.fromJson = function fromJson(json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    var type = json.type; //@flow-ignore

    var nodeConstructor = type && constructorByNodeType[type];

    if (!nodeConstructor) {
      throw new Error("invalid scene node type " + type);
    }

    return nodeConstructor.fromJson(json, deepCopy);
  }; //


  var instance$9;
  var constructorByNodeType$1;

  var NodeModelFactory = function NodeModelFactory() {};

  NodeModelFactory.getInstance = function getInstance() {
    if (!instance$9) {
      instance$9 = new NodeModelFactory();
      constructorByNodeType$1 = {
        Scene: GroupModel,
        Cell: GroupModel,
        Layer: GroupModel,
        Arc: ArcModel,
        Line: LineModel,
        Rect: RectModel,
        Point: PointModel,
        Text: TextModel,
        NumberText: ShapeModel,
        Polygon: PolygonModel,
        Path: PathModel
      };
    }

    return instance$9;
  };

  NodeModelFactory.prototype.fromJson = function fromJson(json, deepCopy) {
    if (deepCopy === void 0) deepCopy = true;
    var type = json && json.props && json.props.type;
    var nodeConstructor = type && constructorByNodeType$1[type];

    if (!nodeConstructor) {
      throw new Error("invalid scene model node type " + type);
    }

    var node = nodeConstructor.fromJson(json, deepCopy);
    return node;
  };

  var BUILD = {
    "branch": "tswardenski",
    "commit": "9a365e30f120cf141497dd8017b0185d6486e6ce",
    "date": "Mon Aug  6 12:16:17 EDT 2018"
  }; //--------------------------------------------------------------------------------
  // wave EventBus
  //
  // fire events:
  // - wave: EventBus.trigger("myevent", arg1, arg2)
  // - js: wave.EventBus.trigger("myevent", arg1, arg2)
  //
  // attach events:
  // - wave: EventBus.on("myevent", function(arg1, arg2) { ... });
  // - js: wave.EventBus.on("myevent", function(arg1, arg2) { ... });
  //
  // Most of the time an object will be used as an EventDispatcher:
  //   class MyObj extends Events.Dispatcher
  //     constructor: ->
  //       super "obj_name"
  //
  // And if the object already extends another class, add this to the constructor:
  //   Events.Dispatcher::mixin @, "obj_name"
  //
  // Instances of MyObj can now dispatch events:
  // (inside a method) @trigger("myevent", arg1, arg2)
  //
  // You can attach event listeners to an instance:
  // - wave: myObj.on("myevent", function(arg1, arg2) { ... });
  // - js: myObj.on("myevent", function(arg1, arg2) { ... });
  //
  // The object-specific events will all be placed on the main event bus,
  // with the namespace "obj_name:"
  //
  // So, the previous listeners could be written:
  // - js: wave.EventBus.on("obj_name:myevent", function(arg1, arg2) { ... });
  //
  //--------------------------------------------------------------------------------

  var EventBus = function EventBus() {
    this._listeners = {};
  };

  EventBus.initClass = function initClass() {
    //# singleton class, use the instance
    this.instance = new EventBus();
  };

  EventBus.prototype.on = function on(event, listener) {
    /* bind event to a listener function. */
    var listeners;

    if (listeners = this._listeners[event]) {
      var i = listeners.indexOf(listener);

      if (i < 0) {
        listeners.push(listener);
      }
    } else {
      this._listeners[event] = [listener];
    }
  };

  EventBus.prototype.off = function off(event, listener) {
    /* unbind listener function from event. if listener is null, will unbind all listeners for event. */
    var listeners;

    if (listeners = this._listeners[event]) {
      if (!listener) {
        delete this._listeners[event];
        return;
      }

      var i = listeners.indexOf(listener);

      if (i >= 0) {
        if (i === 0 && listeners.length === 1) {
          delete this._listeners[event];
        } else {
          listeners.splice(i, 1);
        }
      }
    }
  };

  EventBus.prototype.trigger = function trigger(event) {
    var this$1 = this;
    var args = [],
        len = arguments.length - 1;

    while (len-- > 0) {
      args[len] = arguments[len + 1];
    }

    if (log$1.events) {
      if (args.length) {
        console.info.apply(console, ["EventBus::trigger " + event + ", params: "].concat(args));
      } else {
        console.info("EventBus::trigger " + event);
      }
    }

    (this._listeners[event] || []).forEach(function (listener) {
      return listener.apply(this$1, args);
    });
  };

  EventBus.prototype.one = function one(event, listener) {
    var wrapper = function () {
      listener.apply(this, arguments);
      return this.off(event, wrapper);
    }.bind(this);

    return this.on(event, wrapper);
  };

  EventBus.initClass();

  var Dispatcher$1 = function Dispatcher(subscope) {
    this._initDispatcher(subscope);
  };

  Dispatcher$1.prototype._initDispatcher = function _initDispatcher(subscope) {
    this._evbase = subscope + ":";
    this._events = {}; // events ever registered
  };

  Dispatcher$1.prototype.on = function on(event, listener) {
    /* bind listener function to event. */
    EventBus.instance.on(this._evbase + event, listener);
    this._events[event] = true;
    return this;
  };

  Dispatcher$1.prototype.off = function off(event, listener) {
    var this$1 = this;
    /* unbind listener function from event. if event is null, will unbind all events. */

    if (event) {
      EventBus.instance.off(this._evbase + event, listener);

      if (!EventBus.instance._listeners[this._evbase + event]) {
        delete this._events[event];
      }
    } else {
      for (event in this$1._events) {
        EventBus.instance.off(this$1._evbase + event);
      }

      this._events = {};
    }

    return this;
  };

  Dispatcher$1.prototype.trigger = function trigger(event) {
    var args = [],
        len = arguments.length - 1;

    while (len-- > 0) {
      args[len] = arguments[len + 1];
    }

    (ref = EventBus.instance).trigger.apply(ref, [this._evbase + event].concat(args));
    return this;
    var ref;
  };

  Dispatcher$1.prototype.one = function one(event, listener) {
    EventBus.instance.one(this._evbase + event, listener);
    return this;
  };

  Dispatcher$1.prototype.mixin = function mixin(self, name) {
    Object.keys(Dispatcher$1.prototype).forEach(function (k) {
      return self[k] = Dispatcher$1.prototype[k];
    });
    return self._initDispatcher(name);
  };

  var Events = {
    Bus: EventBus.instance,
    Dispatcher: Dispatcher$1
  }; //
  // Cache
  //
  // A simple cache which emits events when items are added/removed.
  // It's a simple wrapper around a Map object.
  //
  // Events fired:
  // - add(name): after an object is added to the cache
  // - remove(name): after an object is remove to the cache
  // - addFirst(name): after the first object is added to the cache
  // - removeLast(name): after the last object is removed from the cache
  // Event order:
  // suppose you start from an empty cache and add 'a', then 'b',
  // and then then remove 'b', then remove'a'
  //
  // The order of events is going to be:
  // - addFirst(a)
  // - add(a)
  // - add(b)
  // - remove(b)
  // - remove(a)
  // - removeLast(a)
  //@flow-ignore

  var Dispatcher = Events.Dispatcher;

  var Cache = function (Dispatcher) {
    function Cache(name) {
      Dispatcher.call(this, name);
      this._cache = {};
    }

    if (Dispatcher) Cache.__proto__ = Dispatcher;
    Cache.prototype = Object.create(Dispatcher && Dispatcher.prototype);
    Cache.prototype.constructor = Cache;

    Cache.prototype.add = function add(name, obj) {
      this._cache[name] = obj;

      if (this.size() === 1) {
        this.trigger("addFirst", name);
      }

      this.trigger("add", name);
      return this;
    };

    Cache.prototype.remove = function remove(name) {
      delete this._cache[name];
      this.trigger("remove", name);

      if (this.size() === 0) {
        this.trigger("removeLast", name);
      }

      return this;
    };

    Cache.prototype.size = function size() {
      return lodash__default.size(this._cache);
    };

    Cache.prototype.get = function get(name) {
      return this._cache[name];
    }; //--------------------------------------------------------------------------------
    // convenience iteration functions
    //--------------------------------------------------------------------------------


    Cache.prototype.forEach = function forEach(fct) {
      var this$1 = this;
      lodash__default.keys(this._cache).forEach(function (key) {
        fct(key, this$1._cache[key]);
      });
      return this;
    };

    Cache.prototype.keys = function keys() {
      return lodash__default.keys(this._cache);
    };

    Cache.prototype.values = function values() {
      return lodash__default.values(this._cache);
    };

    return Cache;
  }(Dispatcher);

  var setStyles$1 = utils$3.setStyles;
  var pageScrollOffset$1 = utils$3.pageScrollOffset;
  var ARROW_WIDTH = 20 * 2; // width when arrow pointing up

  var ARROW_HEIGHT = 8; // height when arrow pointing up

  var ARROW_PADDING$1 = 2; // space between arrow and 'shape' (bar)

  var ARROW_OFFSET_X = ARROW_HEIGHT + ARROW_PADDING$1;
  var ARROW_OFFSET_Y = ARROW_WIDTH / 2;

  var Tooltip = function Tooltip() {
    // always keep track of mouse position(for use in sticky tooltip)
    this.show = this.show.bind(this);
    this.positionAndShow = this.positionAndShow.bind(this);
    this.removeGlobalEventListeners = this.removeGlobalEventListeners.bind(this);
    this.addGlobalEventListeners = this.addGlobalEventListeners.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this.clearTimers = this.clearTimers.bind(this);
    this.hide = this.hide.bind(this);
    this._hide = this._hide.bind(this);
    this.mouseX = 0;
    this.mouseY = 0; // create Tooltip DOM

    this.el = document.createElement('div');
    this.el.className = 'ng-charthover';
    this.content = this.el.appendChild(document.createElement('div'));
    this.content.className = 'content';
    this.attachEvents();
    this.theme = ThemeFactory.getInstance().getDefaultTheme();
  }; // Move tooltip according to current mouse position so that tooltip appears sticky


  Tooltip.initClass = function initClass() {
    this.prototype.el = null;
    this.prototype.content = null;
    this.prototype.arrow = null;
    this.prototype.timerShow = null;
    this.prototype.timerHide = null;
    this.prototype.quietModeTimer = null;
    this.prototype.theme = null;
  };

  Tooltip.prototype.move = function move() {
    if (this.el.style.visibility === 'visible' && this.positions === "auto") {
      return this.positionAndShow();
    }
  };

  Tooltip.prototype.moveTo = function moveTo(mouseX, mouseY) {
    this.mouseX = mouseX;
    this.mouseY = mouseY;
    return this.move();
  }; // @param html {String} html to display
  // @param positions {Array} array of tooltip positions ranked by preference
  // 		[ orientation, arrowX, arrowY ]
  // 		[ orientation, arrowX, arrowY ]
  // @param offsetX {Number} offset for arrowX relative to page
  // @param offsetY {Number} offset for arrowY relative to page
  // @param angle {Number} rotation angle for tooltip
  // @param extraClass {String} additional class to put on the tooltop main dev
  //
  // *orientation:
  //
  // topLeft:              topRight:
  //    |                            |
  //    --------              --------
  //    |      |              |      |
  //    --------              --------
  //
  // bottomLeft:           bottomRight:
  //    --------              --------
  //    |      |              |      |
  //    --------              --------
  //    |                            |
  //
  // leftTop:              leftBottom:
  //  ----------              --------
  //    |      |              |      |
  //    --------            ----------
  //
  // rightTop:             rightBottom:
  //    ----------            --------
  //    |      |              |      |
  //    --------              ----------
  //
  // noneLeft:             noneRight:
  // (no arrow, but        (no arrow, but
  //  callout on the left   callout on the right
  //  of the tip)           of the tip)


  Tooltip.prototype.show = function show(offsetX, offsetY, html, positions, angle, extraClass) {
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.html = html;
    this.positions = positions;
    this.angle = angle;

    if (extraClass == null) {
      extraClass = "";
    }

    this.extraClass = extraClass;
    this.clearTimers();
    return this.timerShow = setTimeout(this.positionAndShow, constants$1.TOOLTIP.DELAY.SHOW);
  };

  Tooltip.prototype.setTheme = function setTheme(theme) {
    this.theme = theme;
  };

  Tooltip.prototype._positionTooltip = function _positionTooltip(x, y, w, h, rotation, positions, windowW, windowH) {
    var tooltipBox = new Box({
      x: x,
      y: y,
      w: w,
      h: h,
      rotation: rotation
    });
    var bestTooltipBox = null;
    var bestOverflow = Number.POSITIVE_INFINITY;

    for (var i = 0; i < positions.length; i++) {
      var ref = positions[i];
      var orientation = ref[0];
      var tooltipX = ref[1];
      var tooltipY = ref[2];
      var bb = tooltipBox.clone().offset(tooltipX, tooltipY).toAABB();
      var assign;
      assign = bb, x = assign.x, y = assign.y, w = assign.w, h = assign.h;
      var offX = 0;
      var offY = 0;

      switch (orientation) {
        case "leftTop":
          offX = ARROW_OFFSET_X;
          offY = -ARROW_OFFSET_Y;
          break;

        case "leftBottom":
          offX = ARROW_OFFSET_X;
          offY = -(h - ARROW_OFFSET_Y);
          break;

        case "rightTop":
          offX = -(w + ARROW_OFFSET_X);
          offY = -ARROW_OFFSET_Y;
          break;

        case "rightBottom":
          offX = -(w + ARROW_OFFSET_X);
          offY = -(h - ARROW_OFFSET_Y);
          break;

        case "topRight":
          offX = -(w - ARROW_OFFSET_Y);
          offY = ARROW_OFFSET_X;
          break;

        case "topLeft":
          offX = -ARROW_OFFSET_Y;
          offY = ARROW_OFFSET_X;
          break;

        case "bottomRight":
          offX = -(w - ARROW_OFFSET_Y);
          offY = -(h + ARROW_OFFSET_X);
          break;

        case "bottomLeft":
          offX = -ARROW_OFFSET_Y;
          offY = -(h + ARROW_OFFSET_X);
          break;
      }

      bb.offset(offX, offY);
      var assign$1;
      assign$1 = bb.toAABB(), x = assign$1.x, y = assign$1.y; // make sure tooltip fits on the screen

      var overflowX = x < 0 ? x : x + w > windowW ? x + w - windowW : 0;
      var overflowY = y < 0 ? y : y + h > windowH ? y + h - windowH : 0;
      var totalOverflow = Math.abs(overflowX) + Math.abs(overflowY);

      if (totalOverflow < bestOverflow) {
        bestOverflow = totalOverflow;
        bestTooltipBox = bb.offset(-overflowX, -overflowY);
      }

      if (totalOverflow === 0) {
        break;
      }
    } // now we have a tooltip box that sits in the window


    var assign$2;
    assign$2 = bestTooltipBox, x = assign$2.x, y = assign$2.y;
    var angle = rotation.angle; // if there is a rotation, we need to translate the origin

    if (angle !== 0) {
      if (angle < 0) {
        y = y + h - Math.sin(Math.PI * 0.5 - angle) * tooltipBox.h;
      } else {
        x = x + Math.sin(angle) * tooltipBox.h;
      }
    }

    return {
      x: x,
      y: y
    };
  };

  Tooltip.prototype.positionAndShow = function positionAndShow() {
    var ref = this;
    var html = ref.html;
    var angle = ref.angle;
    var extraClass = ref.extraClass;
    var positions = ref.positions;
    var offsetX = ref.offsetX;
    var offsetY = ref.offsetY;
    var isAuto = positions === "auto";
    var degAngle = angle ? Math.round(180 * angle / Math.PI) : 0; // viewport size

    var windowW = window.innerWidth;
    var windowH = window.innerHeight;

    if (isAuto) {
      offsetX = this.mouseX;
      offsetY = this.mouseY; // auto mode: we will try all the positions around the current mouse positions
      // do we have more space on the left or right?

      var moreSpaceOnLeft = this.mouseX > windowW / 2;
      positions = moreSpaceOnLeft ? [["rightTop", -15, 0], ["rightBottom", -15, 0], ["leftTop", 15, 0], ["leftBottom", 15, 0], ["topRight", 0, 15], ["bottomRight", 0, -15], ["topLeft", 0, 15], ["bottomLeft", 0, -15]] : [["leftTop", 15, 0], ["leftBottom", 15, 0], ["rightTop", -15, 0], ["rightBottom", -15, 0], ["topLeft", 0, 15], ["bottomRight", 0, -15], ["topRight", 0, 15], ["bottomLeft", 0, -15]];
    } // convert offset to relative to viewport


    var ref$1 = pageScrollOffset$1();
    var top = ref$1.top;
    var left = ref$1.left;
    offsetX -= left;
    offsetY -= top;
    this.el.className = "ng-charthover " + extraClass; // display to block so that we can measure width/height

    setStyles$1(this.el, {
      display: "block"
    });
    this.content.innerHTML = html;
    var rotation = {
      x: offsetX,
      y: offsetY,
      angle: angle || 0
    };

    var ref$2 = this._positionTooltip(offsetX, offsetY, this.el.offsetWidth, this.el.offsetHeight, rotation, positions, windowW, windowH);

    var x = ref$2.x;
    var y = ref$2.y;
    var backgroundColor = this.theme.getToolTipBackgroundColor().toRGBAString();
    var truncationBackgoundColor = this.theme.getToolTipTruncationBackgroundColor().toRGBAString();
    setStyles$1(this.el, {
      left: x + left + 'px',
      top: y + top + 'px',
      transform: "translateZ(0) rotate(" + degAngle + "deg)",
      '-webkit-transform': "rotate(" + degAngle + "deg)",
      '-ms-transform': "rotate(" + degAngle + "deg)",
      backgroundColor: extraClass.indexOf(" truncation") >= 0 ? truncationBackgoundColor : backgroundColor
    });
    return this.el.style.visibility = 'visible';
  }; //--------------------------------------------------------------------------------
  // events
  //--------------------------------------------------------------------------------


  Tooltip.prototype.removeGlobalEventListeners = function removeGlobalEventListeners() {
    document.body.removeChild(this.el);
    this.detachEvents();
  };

  Tooltip.prototype.addGlobalEventListeners = function addGlobalEventListeners() {
    document.body.appendChild(this.el);
    this.attachEvents();
  };

  Tooltip.prototype.attachEvents = function attachEvents() {
    window.addEventListener('mousemove', this._onMouseMove);
    window.addEventListener('touchmove', this._onTouchMove);
    window.addEventListener('touchstart', this._onTouchStart);
    this.el.addEventListener('mouseleave', this.hide);
    return this.el.addEventListener('click', this._hide);
  };

  Tooltip.prototype.detachEvents = function detachEvents() {
    window.removeEventListener('mousemove', this._onMouseMove);
    window.removeEventListener('touchmove', this._onTouchMove);
    window.removeEventListener('touchstart', this._onTouchStart);
    this.el.removeEventListener('mouseleave', this.hide);
    return this.el.removeEventListener('click', this._hide);
  }; // Set for a certain period of time that we don't want any interaction events
  // For example, after a pragmatical scroll, we don't want a mouse move event after
  // Therefore we enter the quiet mode for a short period of time after scroll


  Tooltip.prototype.quietMode = function quietMode(duration) {
    // If we are already in the quiet mode
    if (this.quietModeTimer) {
      clearTimeout(this.quietModeTimer);
    }

    this.detachEvents();
    return this.quietModeTimer = setTimeout(this.attachEvents.bind(this), duration);
  };

  Tooltip.prototype._onTouchStart = function _onTouchStart(e) {
    var touch = e.touches[0];

    if (touch) {
      this.mouseX = touch.pageX;
      return this.mouseY = touch.pageY;
    }
  };

  Tooltip.prototype._onMouseMove = function _onMouseMove(e) {
    this.mouseX = e.pageX;
    return this.mouseY = e.pageY;
  };

  Tooltip.prototype._onTouchMove = function _onTouchMove(e) {
    var touch = e.touches[0];

    if (touch) {
      this.mouseX = touch.pageX;
      return this.mouseY = touch.pageY;
    }
  }; //--------------------------------------------------------------------------------
  // helpers
  //--------------------------------------------------------------------------------


  Tooltip.prototype.clearTimers = function clearTimers() {
    if (this.timerShow) {
      clearTimeout(this.timerShow);
    }

    if (this.timerHide) {
      return clearTimeout(this.timerHide);
    }
  };

  Tooltip.prototype.hide = function hide() {
    this.clearTimers();
    return this.timerHide = setTimeout(this._hide, constants$1.TOOLTIP.DELAY.HIDE);
  };

  Tooltip.prototype._hide = function _hide() {
    return setStyles$1(this.el, {
      display: "none",
      visibility: "hidden"
    });
  };

  Tooltip.prototype.formatTruncationHtml = function formatTruncationHtml(text) {
    return "<div class=\"truncation-text\">" + escapeHtml(text, true) + "</div>";
  };

  Tooltip.prototype.formatTooltipHtml = function formatTooltipHtml(lines) {
    var labelColor = this.theme.getToolTipLabelColor().toRGBAString();
    var valueColor = this.theme.getToolTipValueColor().toRGBAString();
    var dimHtml = [];
    var meaHtml = [];
    var txtHtml = "";
    lines.forEach(function (line) {
      var label = line.label;
      var value = line.value;
      var color = line.color;
      var percentData = line.percentData;
      var type = line.type;

      if (color instanceof Color) {
        color = color.toRGBAString();
      } // the width of the color mark is 4px and we want 8px padding between them


      var padding = type !== "text" && color ? 12 : 0;
      var labelTxtColor = type === "text" && color ? color : labelColor;
      var labelHtml = label ? "<label style='color:" + labelTxtColor + ";padding-left:" + padding + "px;'>" + escapeHtml(label, true) + "</label>" : "";
      var colorHeight = type !== "measure" && labelHtml ? 36 : 18;
      var colorHtml = color ? "<span class='marking' style='background-color:" + color + "; height:" + colorHeight + "px;'></span>" : "";
      var valueHtml = "<label class='value' style='color:" + valueColor + ";padding-left:" + padding + "px;'>" + escapeHtml(value, true) + "</label>";
      var percentHtml = "";

      if (percentData != null) {
        var percent = percentData.percent;
        var total = percentData.total;
        var group = percentData.group;
        var percentType = group ? "percentTooltipWithGroup" : "percentTooltip";
        percentHtml = "<small style='color:" + labelColor + ";'>" + escapeHtml(" (" + LOC.getLabel('wave-charts', percentType, [percent, total, group]) + ")", true) + "</small>";
      }

      switch (type) {
        case "measure":
          meaHtml.push("<tr><td>" + colorHtml + labelHtml + "</td><td class=\"valueCell\">" + valueHtml + percentHtml + "</td></tr>");
          break;

        case "text":
          txtHtml = "<div class='line dimension'>" + labelHtml + "</div>";
          break;

        default:
          dimHtml.push("<div class='line dimension'>" + colorHtml + labelHtml + valueHtml + "</div>");
      }
    });
    dimHtml = dimHtml.join("");
    meaHtml = meaHtml.length ? "<table class='line measure'>" + meaHtml.join("") + "</table>" : "";
    var hrTag = dimHtml && meaHtml ? "<hr class='ng-separator-line'>" : "";
    return [txtHtml, dimHtml, hrTag, meaHtml].join("");
  };

  Tooltip.initClass(); //-ignore

  var defaultLoader = function defaultLoader(fileName) {
    return WaveChartsRuntime.getDelegate().require(fileName).then(function (res) {
      return JSON.parse(res);
    });
  };

  var Cache$2 = function Cache(name, getInstance) {
    this._cache = {};
    this._name = name;
    this._getInstance = getInstance;
    this._pendingPromises = {};
  };

  Cache$2.prototype.get = function get(url) {
    var entry = this._cache[url];

    if (entry) {
      return entry;
    } else {
      throw new Error(name + "::get invalid url " + url);
    }
  }; // load a
  // @param url {Stirng} url of the Geometry
  // @param geoJsonLoader {Loader} a function(url) which returns a promise, resolve with
  // the json content of the url
  // @return {Promise} a promise which gets resolved with the Geometry once the geojson gets loaded

  /**
  	 * Load an entry
  	 * @param  {string} url    url of the entry
  	 * @param  {Function} loader a function(url) which returns a promise, resolve with the json content of the url
  	 * @return {[type]}        [description]
  	 */


  Cache$2.prototype.load = function load(url, loader) {
    var this$1 = this; // first, let's see if it's there

    var entry, pendingPromise;
    var pendingPromises = this._pendingPromises;

    if (loader == null) {
      loader = defaultLoader;
    }

    if (this._cache[url]) {
      entry = this._cache[url];
      return es6Promise.Promise.resolve(entry);
    } // then see if it's pending loading


    if (this._pendingPromises[url]) {
      pendingPromise = this._pendingPromises[url];
      return pendingPromise;
    } // finally, let's load it


    if (log$1.scripts) {
      console.debug(name + ":: loading " + url);
    }

    pendingPromises[url] = loader(url).then(function (content) {
      entry = this$1._getInstance(url, content);
      this$1._cache[url] = entry;
      delete pendingPromises[url];
      return entry;
    }).catch(function (e) {
      delete pendingPromises[url];
      throw e;
    });
    return pendingPromises[url];
  }; //-ignore

  /*
  Geometry class
  
  A class to handle geojson gemoetries.
  It loads the geojson synchronously and caches the result in a local cache.
  
  Upon loading, it will compute (and cache) the full bounding box and also
  clean up the json file to make sure every geojson feature has a proper name
  
  @author didier.prophete
  */
  // map: geometry url (string) -> geometry (Geometry)
  // map: geometry url (string) -> Promise which will get resolved once the geometry is loaded


  var Geometry = function Geometry(ref) {
    var url = ref.url;
    var geojson = ref.geojson; // initialize geometry

    this.url = url;
    this.geojson = geojson;
    this._isValid = true;

    try {
      // 1 - make sure every subfeature has a proper string id (if possible)
      this.forEachFeature(function (feature) {
        var id = feature.id;
        var properties = feature.properties; // some geojson don't have an id. Let's us the name then
        // note that if both the id and the name are not defined, then shape simply won't be shown...

        if (id == null) {
          id = properties != null ? properties.name : undefined;
        }

        if (id != null) {
          // some geojson have a numerical id... let's convert it to a string
          id = "" + id;
          return feature.id = id;
        }
      }); // 2 - compute (and cache) bounding box

      this.boundingBox = this._computeBoundingBox();

      this._computeCentroids();
    } catch (e) {
      this._isValid = false;
    }
  };
  /**
  	 * Compute matchable keys(lower cased) of all features as an array
  	 *
  	 * used in chart recommendation to see if a data column match to any geo json features
  	 * @param  {String} geoKey, an alternative dot accessor key path than feature.id
  	 * @return {Array} array of all matchable feature keys
  	 */


  Geometry.prototype.getFeatureKeys = function getFeatureKeys(geoKey) {
    var this$1 = this;
    if (geoKey === void 0) geoKey = "properties.name";

    if (!this._featureKeys) {
      this._featureKeys = [];
      var altKeyFct = valueFctUtils.getDotAccessorFct(geoKey);
      this.forEachFeature(function (feature) {
        var id = feature.id;
        var altKey = altKeyFct(feature);

        if (id) {
          this$1._featureKeys.push(id.toLowerCase());
        }

        if (altKey) {
          this$1._featureKeys.push(altKey.toLowerCase());
        }
      });
    }

    return this._featureKeys;
  };

  Geometry.prototype._computeCentroids = function _computeCentroids() {
    this.forEachFeature(function (feature) {
      var ref = feature.geometry;
      var type = ref.type;
      var coordinates = ref.coordinates;

      switch (type) {
        case "Polygon":
          return feature.geometry.centroid = geometryUtils.centroid(coordinates[0]);

        case "MultiPolygon":
          return feature.geometry.centroid = geometryUtils.multiPolygonCentroid(coordinates);
      }
    });
  }; // compute the bounding box of the geometry


  Geometry.prototype._computeBoundingBox = function _computeBoundingBox() {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    var processPoint = function processPoint(point) {
      var x = point[0];
      var y = point[1];

      if (x < minX) {
        minX = x;
      }

      if (x > maxX) {
        maxX = x;
      }

      if (y < minY) {
        minY = y;
      }

      if (y > maxY) {
        maxY = y;
      }
    };

    var processPoly = function processPoly(coordinates) {
      return coordinates[0].map(processPoint);
    };

    this.forEachFeature(function (feature) {
      var ref = feature.geometry;
      var type = ref.type;
      var coordinates = ref.coordinates;

      switch (type) {
        case "Polygon":
          return processPoly(coordinates);

        case "MultiPolygon":
          return coordinates.map(processPoly);
      }
    });
    return {
      x: minX,
      y: minY,
      w: maxX - minX,
      h: maxY - minY
    };
  }; // Iterate over the features of the geometry
  // @param processor {Function(feature, index)} a function which gets invoked for each valid feature of the geometry


  Geometry.prototype.forEachFeature = function forEachFeature(processor) {
    var i = 0;
    this.geojson.features.forEach(function (feature) {
      if (feature && feature.geometry) {
        processor(feature, i++);
      }
    });
  };

  Geometry.prototype.isValid = function isValid() {
    return this._isValid;
  };
  /*
  GeoMap class
  
  A map holds the data necessary to draw shapes (countries, states, etc...) with a given projection
  
  It is made up of:
  - a geojson file (for the shapes to draw)
  - a unique name
  - a label
  - an optional bounding box (for sub-regions of a larger map)
  - a projection
  - metadata associated with the map
  
  Maps are registered and cached in an internal cache.
  
  @author didier.prophete
  */


  var geometryCache = new Cache$2("Geometry", function (url, geojson) {
    return new Geometry({
      url: url,
      geojson: geojson
    });
  }); // hashmap: GeoMap name (string) -> GeoMap object

  var cache = {};

  var GeoMap = function GeoMap(ref) {
    var name = ref.name;
    var geoJson = ref.geoJson;
    var boundingBox = ref.boundingBox;
    var projection = ref.projection;
    var metadata = ref.metadata;
    var skipRegistration = ref.skipRegistration;
    this.name = name;
    this.geoJson = geoJson;
    this.projection = projection || "Equirectangular";

    if (this._isValidBoundingBox(boundingBox)) {
      this.boundingBox = new Box(boundingBox);
    }

    this._metadata = metadata;
    this.setBoundingBox(boundingBox);
    this.size = null;

    if (!skipRegistration) {
      this._registerWithCache();
    }
  };

  GeoMap.prototype.isZoomable = function isZoomable() {
    return false;
  };

  GeoMap.prototype.setSize = function setSize(size) {
    this.size = size;
    return this;
  };

  GeoMap.prototype.getName = function getName() {
    return this.name;
  };

  GeoMap.prototype.getGeoJson = function getGeoJson() {
    return this.geoJson;
  };

  GeoMap.prototype.getMetadata = function getMetadata() {
    return this._metadata;
  };

  GeoMap.prototype.getProjection = function getProjection() {
    return this.projection;
  };

  GeoMap.prototype.setProjection = function setProjection(projection) {
    if (projection) {
      this.projection = projection;
    }

    return this;
  };

  GeoMap.prototype.getBoundingBox = function getBoundingBox() {
    if (this.boundingBox != null) {
      var ref = this.boundingBox.toJson();
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      return {
        left: x,
        right: x + w,
        top: y + h,
        bottom: y
      };
    }

    return null;
  };

  GeoMap.prototype.setBoundingBox = function setBoundingBox(boundingBox) {
    this.boundingBox = boundingBox ? new Box(boundingBox) : null;
    return this;
  };

  GeoMap.prototype.toJson = function toJson() {
    var boundingBox;

    if (this.boundingBox != null) {
      var ref = this.boundingBox.toJson();
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      boundingBox = {
        left: x,
        right: x + w,
        top: y + h,
        bottom: y
      };
    }

    return {
      name: this.name,
      projection: this.projection,
      metadata: this._metadata,
      geoJson: this.geoJson,
      boundingBox: boundingBox
    };
  };

  GeoMap.prototype.clone = function clone() {
    var record = this.toJson();
    record.skipRegistration = true;
    return new GeoMap(record);
  };
  /**
  	 * To check if the bounding box is valid in either {left, right, top, bottom} or {x, y, width, height} form
  	 * This check is to prevent a invalid bounding box other than undefined
  	 * We will not render anything (failed silently) if there is an invalid bounding box defined other than null or undefined
  	 * @param {*} bbox
  	 */


  GeoMap.prototype._isValidBoundingBox = function _isValidBoundingBox(bbox) {
    return bbox && (bbox.left != null && bbox.right != null && bbox.top != null && bbox.bottom != null || bbox.x != null && bbox.y != null && bbox.w != null && bbox.h != null);
  }; // register map with cache


  GeoMap.prototype._registerWithCache = function _registerWithCache() {
    if (log$1.scripts) {
      console.debug("GeoMap:: registering " + this.name + " with cache");
    }

    cache[this.name] = this;
    return;
  }; //--------------------------------------------------------------------------------
  // misc
  //--------------------------------------------------------------------------------


  GeoMap.prototype.isValid = function isValid() {
    return this.getGeometry().isValid();
  }; // @return {Geometry} geometry (set of shapes) for the GeoMap


  GeoMap.prototype.getGeometry = function getGeometry() {
    return geometryCache.get(this.geoJson.url);
  }; // @return {Promise} a promise which gets resolved with the Geometry once the geojson gets loaded


  GeoMap.prototype.load = function load() {
    var this$1 = this; // if the geoJson has data attached to it use that instead of the url

    var loader = this.geoJson.data ? function () {
      return es6Promise.Promise.resolve(this$1.geoJson.data);
    } : this.geoJson.loader;
    return geometryCache.load(this.geoJson.url, loader);
  }; //--------------------------------------------------------------------------------
  // static functions
  //--------------------------------------------------------------------------------
  // get a GeoMap by name
  // @param name {String} name of the map
  // @return {GeoMap}


  GeoMap.get = function get(name) {
    var map = cache[name];

    if (map) {
      return map.clone();
    } else {
      console.warn("GeoMap::get: invalid map name " + name);
      return null;
    }
  }; // delete a GeoMap by name
  // @param name {String} name of the map to delete
  // @return {GeoMap} the delete map or undefined if not found


  GeoMap.delete = function delete$1(name) {
    var map = GeoMap.get(name);

    if (map != null) {
      delete cache[name];
    }

    return map;
  }; // get all the maps registered
  // @return {Array of GeoMap}


  GeoMap.getMaps = function getMaps() {
    return lodash__default.values(cache);
  };

  var release = "216";
  var version = "44.0";
  var apiVersion = {
    release: release,
    version: version
  }; //
  //@flow-ignore

  function getChartInstance(module, config, rows, rowsMetadata, props, delegate) {
    var Klass = module['default'];
    return Klass.make ? Klass.make(config, rows, rowsMetadata, props, delegate) : new Klass(config, rows, rowsMetadata, props, delegate);
  }

  function getEmptyChart(rows, config, labelName) {
    if (config === void 0) config = {};
    var labels = config.labels;
    var padding = config.padding;
    var size = config.size;
    var theme = config.theme;
    var title = config.title;
    var emptyLabel = LOC.getLabel("wave-charts", labelName, null, labels);
    return WaveCharts$1.getModule("sfdc-empty-chart", apiVersion.version).then(function (module) {
      return getChartInstance(module, {
        padding: padding,
        theme: theme,
        size: size,
        title: title
      }, rows, emptyLabel);
    });
  }

  var WaveChartFactory = function WaveChartFactory() {};

  WaveChartFactory.prototype.getChartPromise = function getChartPromise(module, config, rows, rowsMetadata, props, delegate) {
    var chart = getChartInstance(module, config, rows, rowsMetadata, props, delegate);

    if (!chart.hasRows(rows)) {
      return getEmptyChart(rows, config, "noData");
    } else if (!chart.hasMeasures(rows)) {
      return getEmptyChart(rows, config, "noValues");
    } else if (chart.isTrellis()) {
      return WaveCharts$1.getModule("sfdc-trellis-chart", apiVersion.version).then(function (module) {
        return getChartInstance(module, config, rows, chart);
      });
    } else {
      return es6Promise.Promise.resolve(chart);
    }
  };

  var WaveChartFactory$1 = singleton(WaveChartFactory); //-ignore

  /*
  This class encapsulates the process of rendering a chart.
  
  Depending on chart's config, some pre-processing might be required actually running the code
  that renders a chart.
  
  The key idea is that in the config.json file, some fields can be marked as requiring
  special processing. For now, this is done by using different field types. The processConfig function will process
  these fields based on the fieldProcessors declared for each type (most of the time, there are non since no
  processing is needed, but for custom types we will register processors)
  
  Since the processors are async, it allows us to do some async preprocessing *before* a script execute and keep
  the script execution synchronous so the end user doesn't have to deal with deferreds, promises, etc...
  */
  // a map: fieldType -> field processor
  //
  // A field process is a function(field, config) which will do the necessary processing
  // for a given field. It returns a deferred which gets resolved once the field has been processed.
  //
  // This gives us a change to do some async processing for special fields

  var fieldProcessors = {
    GEOJSON: function GEOJSON(field, config) {
      var property = field.property;
      var mapName = config[property];
      var map = GeoMap.get(mapName);
      return map != null ? map.load() : undefined;
    }
  }; // Process config passed to a script *before* executing the script
  //
  // @return {Promise} a promise which gets resolved when all the processing is done (the return value could be undefined)

  var processConfig = function processConfig(config, metadata) {
    var configMeta = metadata != null ? metadata.config : undefined;

    if (config && configMeta) {
      var defs = [];
      configMeta.forEach(function (field) {
        var processor;

        if (processor = fieldProcessors[field.type]) {
          var def = processor(field, config);

          if (def) {
            defs.push(def);
          }
        }
      });

      if (defs.length) {
        return es6Promise.Promise.all(defs);
      }
    }

    return es6Promise.Promise.resolve();
  };

  var ChartModuleRunner = function ChartModuleRunner() {};

  ChartModuleRunner.prototype.renderChart = function renderChart(ref) {
    var module = ref.module;
    var config = ref.config;
    var rows = ref.rows;
    var rowsMetadata = ref.rowsMetadata;
    var props = ref.props;
    var delegate = ref.delegate;
    var context = ref.context;
    var runtimeChart = ref.runtimeChart; // the chart's metadata

    var metadata = module.getMetadata() || {};
    var moduleLoader = module.moduleLoader;
    return processConfig(config, metadata).then(function () {
      // if the module is not trusted, all arguments passed to the untrusted module code
      // must first be evaluated by the moduleLoader's secure script evaluator (aka locker service)
      if (moduleLoader && !moduleLoader.isTrusted()) {
        config = moduleLoader.evaluate(JSON.stringify(config));
        rows = moduleLoader.evaluate(JSON.stringify(rows));
        rowsMetadata = moduleLoader.evaluate(JSON.stringify(rowsMetadata));
        props = moduleLoader.evaluate(JSON.stringify(props)); // only trusted modules have access to chart delegate for now

        delegate = null;
        context = null;
      }

      return WaveChartFactory$1.getInstance().getChartPromise(module, config, rows, rowsMetadata, props, delegate);
    }).then(function (chart) {
      return new es6Promise.Promise(function (resolve, reject) {
        Perf.setInstance(new Perf({
          name: 'script'
        }));
        Perf.getInstance().start(); // start transaction for script execution

        try {
          runtimeChart && runtimeChart.remove(context, chart);
          var scene = chart.render(context); // end transaction for script execution and report with perf json

          return resolve({
            chart: chart,
            scene: scene,
            scriptPerf: Perf.getInstance().toJson(),
            moduleLoader: moduleLoader
          });
        } catch (e) {
          // end transaction on error
          Perf.getInstance().end();
          return reject(e);
        }
      });
    });
  };
  /*
  EclairNGBootstrap
  
  A set of bootstrapping functions which should be invoked when EclairNG starts.
  For now, we only register the default regions but we could start registering
  default scripts, etc...
  
  */


  function id() {
    return lodash__default.uniqueId();
  }

  var EclairNGBootstrap = {
    registerDefaultMaps: function registerDefaultMaps(EclairNG, config) {
      var prefix = config.prefix != null ? config.prefix : "";
      var geoJsonLoader = config.geoJsonLoader;
      var worldGeoJson = {
        url: prefix + "geojson/sfdc/world-countries.geo.json",
        loader: geoJsonLoader,
        metadata: {
          id: id()
        }
      };
      var usStatesGeoJson = {
        url: prefix + "geojson/sfdc/us-states.geo.json",
        loader: geoJsonLoader,
        metadata: {
          id: id()
        }
      };
      return [{
        name: "US States",
        geoJson: usStatesGeoJson,
        projection: "AlbersUSA"
      }, {
        name: "World Countries"
      }, {
        name: "Americas",
        boundingBox: {
          left: -170,
          bottom: -59,
          right: -32,
          top: 72
        }
      }, {
        name: "North America",
        boundingBox: {
          left: -170.2,
          bottom: 6,
          right: -32,
          top: 72
        }
      }, {
        name: "South America",
        boundingBox: {
          left: -83.5,
          bottom: -56.15,
          right: -32,
          top: 14
        }
      }, {
        name: "Central America",
        boundingBox: {
          left: -93,
          bottom: 7,
          right: -76,
          top: 18.8
        }
      }, {
        name: "Caribbean",
        boundingBox: {
          left: -86,
          bottom: 17,
          right: -64,
          top: 27.5
        }
      }, {
        name: "Europe",
        boundingBox: {
          left: -10.5,
          bottom: 34,
          right: 46.5,
          top: 72
        }
      }, {
        name: "Eastern Europe",
        boundingBox: {
          left: 17,
          bottom: 41.19,
          right: 55,
          top: 72
        }
      }, {
        name: "Northern Europe",
        boundingBox: {
          left: -26.26,
          bottom: 54,
          right: 34.8,
          top: 72
        }
      }, {
        name: "Southern Europe",
        boundingBox: {
          left: -10,
          bottom: 35,
          right: 29.65,
          top: 48
        }
      }, {
        name: "Western Europe",
        boundingBox: {
          left: -10.5,
          bottom: 42,
          right: 10,
          top: 59
        }
      }, {
        name: "Central Europe",
        boundingBox: {
          left: 5.87,
          bottom: 45.42,
          right: 24.15,
          top: 55.08
        }
      }, {
        name: "Scandanavia",
        boundingBox: {
          left: 4.06,
          bottom: 54.43,
          right: 31.59,
          top: 71.31
        }
      }, {
        name: "Asia",
        boundingBox: {
          left: 25,
          bottom: -14.5,
          right: 180,
          top: 78
        }
      }, {
        name: "South Asia",
        boundingBox: {
          left: 60,
          bottom: 5,
          right: 98,
          top: 38.5
        }
      }, {
        name: "South East Asia",
        boundingBox: {
          left: 91.5,
          bottom: -11.5,
          right: 142,
          top: 29
        }
      }, {
        name: "East Asia",
        boundingBox: {
          left: 73.5,
          bottom: 18,
          right: 153.99,
          top: 53.56
        }
      }, {
        name: "Australasia",
        boundingBox: {
          left: 112,
          bottom: -48,
          right: 180,
          top: 0
        }
      }, {
        name: "Africa",
        boundingBox: {
          left: -18,
          bottom: -35.5,
          right: 52,
          top: 38
        }
      }, {
        name: "East Africa",
        boundingBox: {
          left: 21,
          bottom: -27.5,
          right: 52,
          top: 18.5
        }
      }, {
        name: "Middle Africa",
        boundingBox: {
          left: 7.5,
          bottom: -18.5,
          right: 31.75,
          top: 24
        }
      }, {
        name: "North Africa",
        boundingBox: {
          left: -17.5,
          bottom: 8,
          right: 39.5,
          top: 37.5
        }
      }, {
        name: "Southern Africa",
        boundingBox: {
          left: 11,
          bottom: -35.5,
          right: 33.5,
          top: -16
        }
      }, {
        name: "Western Africa",
        boundingBox: {
          left: -18,
          bottom: 3.5,
          right: 16.5,
          top: 28
        }
      }, {
        name: "EMEA",
        boundingBox: {
          left: -25,
          bottom: -36,
          right: 61,
          top: 71.5
        }
      }, {
        name: "APAC",
        boundingBox: {
          left: 60,
          bottom: -48,
          right: 180,
          top: 54.5
        }
      }, {
        name: "World(zoomable)",
        zoomable: true,
        level: "admin-0",
        lookupUrl: prefix + "zoomableLookup/a0.json"
      }, {
        name: "US States(zoomable)",
        zoomable: true,
        level: "admin-1",
        lookupUrl: prefix + "zoomableLookup/a1/US.json",
        boundingBox: {
          left: -160.2,
          bottom: 36,
          right: -52,
          top: 52
        }
      }].map(function (map) {
        lodash__default.defaults(map, {
          projection: "Mercator",
          geoJson: worldGeoJson,
          loader: geoJsonLoader
        });
        map.metadata = {
          id: id(),
          name: map.name,
          label: LOC.getLabel("wave-charts", map.name.replace(/ /g, "_"))
        };
        return EclairNG.registerMap(map);
      });
    }
  };
  var lookupTableCache = new Cache$2("LookupTable", function (url, content) {
    return content;
  });

  var ZoomableGeoMap = function (GeoMa____1) {
    function ZoomableGeoMap(ref) {
      var name = ref.name;
      var level = ref.level;
      var lookupUrl = ref.lookupUrl;
      var boundingBox = ref.boundingBox;
      var metadata = ref.metadata;
      var skipRegistration = ref.skipRegistration;
      var loader = ref.loader;
      GeoMa____1.call(this, {
        name: name,
        lookupUrl: lookupUrl,
        boundingBox: boundingBox,
        metadata: metadata,
        skipRegistration: skipRegistration
      });
      this._loader = loader;
      this._lookupUrl = lookupUrl;
      this._level = level;
      this._division = level.split("-")[0];
      this._grain = level.slice(-1);
    }

    if (GeoMa____1) ZoomableGeoMap.__proto__ = GeoMa____1;
    ZoomableGeoMap.prototype = Object.create(GeoMa____1 && GeoMa____1.prototype);
    ZoomableGeoMap.prototype.constructor = ZoomableGeoMap;

    ZoomableGeoMap.prototype.isZoomable = function isZoomable() {
      return true;
    };

    ZoomableGeoMap.prototype.getSourceUrl = function getSourceUrl() {
      return "mapbox://mapbox.enterprise-boundaries-" + this._division[0] + this._grain + "-v1";
    };

    ZoomableGeoMap.prototype.getBoundariesSourceLayer = function getBoundariesSourceLayer() {
      return "boundaries_" + this._division + "_" + this._grain;
    };

    ZoomableGeoMap.prototype.getPointsSourceLayer = function getPointsSourceLayer() {
      return "points_" + this._division + "_" + this._grain;
    };

    ZoomableGeoMap.prototype.getLookupTable = function getLookupTable() {
      return lookupTableCache.get(this._lookupUrl);
    };

    ZoomableGeoMap.prototype.load = function load() {
      return lookupTableCache.load(this._lookupUrl, this._loader);
    };

    ZoomableGeoMap.prototype.toJson = function toJson() {
      var json = GeoMa____1.prototype.toJson.call(this);
      json.level = this._level;
      json.lookupUrl = this._lookupUrl;
      return json;
    };

    ZoomableGeoMap.prototype.clone = function clone() {
      var record = this.toJson();
      record.skipRegistration = true;
      return new ZoomableGeoMap(record);
    };

    ZoomableGeoMap.prototype.isValid = function isValid() {
      return this._lookupUrl !== null;
    };

    return ZoomableGeoMap;
  }(GeoMap); // 
  //@flow-ignore


  var RowsSelector = function RowsSelector(sceneProcessors, eventDelegate, runtimeChart) {
    this._eventDelegate = eventDelegate;
    this._sceneProcessors = sceneProcessors;
    this._runtimeChart = runtimeChart;
  };

  RowsSelector.prototype.resetAll = function resetAll() {
    this.resetKeyFct();
    this.resetSelection();
    this.resetRows();
    return this;
  };

  RowsSelector.prototype.resetKeyFct = function resetKeyFct() {
    this._keyFct = null;
    this._legendKeyFct = null;
    this._keyTransform = null;
    return this;
  };

  RowsSelector.prototype.resetSelection = function resetSelection() {
    this._selection = [];
    this._selectionKeys = [];
    return this;
  };

  RowsSelector.prototype.resetRows = function resetRows(rows) {
    this._rows = rows;
    this._rowsMap = null;
    return this;
  };
  /**
  	 * Update current selection logic with new data rows, selection key function, and selectMode.
  	 * Usually called when a new scene is generated, we need to re-setup selection logic.
  	 * @param {Rows} rows new data rows
  	 * @param {Function} selectionKeyFct, maps a row to row key for main chart selection
  	 * @param {Function} legendSelectionKeyFct, maps a row to legend row key for legend selection
  	 * @param {Function} keyTransform, transform function to augment a data row with internal values, including row key information
  	 * @param {string} selectMode
  	 */


  RowsSelector.prototype.update = function update(rows, selectionKeyFct, legendSelectionKeyFct, keyTransform, selectMode) {
    if (selectMode === void 0) selectMode = "none";
    this.resetSelection();

    if (rows !== this._rows) {
      this.resetRows(rows);
    }

    this.resetKeyFct();

    if (selectMode === constants$1.SELECTMODE.NONE) {
      return this;
    }

    this._keyTransform = keyTransform;
    this._keyFct = selectionKeyFct;
    this._legendKeyFct = legendSelectionKeyFct;
    return this;
  };
  /**
  	 * Returns the current selection
  	 */


  RowsSelector.prototype.getSelection = function getSelection() {
    return this._selection;
  };
  /**
  	 * [DEPRECATE IN 208]Returns the current selection in legacy format
  	 */


  RowsSelector.prototype.getLegacySelection = function getLegacySelection() {
    // W-4972922
    // In Lightning bar + line chart, the line selection may contain null that needs to be removed.
    // The null value only happens in multi-grouping case which has this nested array structure:
    // e.g. ["[\"{\\\"groupValue\\\":\\\"New Business\\\"}\",null]"] ==> ["[\"{\\\"groupValue\\\":\\\"New Business\\\"}\"]"]
    // Other formats: ["["1988-10-01"]"],[10], ["China"].
    return this._selectionKeys.map(function (key) {
      // Remove null from the array
      var parsedKey = valueFctUtils.parseValue(key);

      if (Array.isArray(parsedKey)) {
        key = JSON.stringify(parsedKey.filter(function (selected) {
          return selected !== null;
        }));
      }

      return key;
    });
  };
  /**
  	 * Callback when a selection action happened on main chart or legend scene.
  	 */


  RowsSelector.prototype.onSelect = function onSelect(name, action, key, keys) {
    name === "main" ? this._onMainChartSelect(action, key, keys) : this._onLegendSelect(action, key, keys);
  };
  /**
  	 * Set selection programmatically
  	 */


  RowsSelector.prototype.setSelection = function setSelection(selection, options) {
    var this$1 = this;
    if (options === void 0) options = {
      skipRender: false,
      silent: false
    };

    if (!this._keyFct) {
      return;
    }

    selection = selection ? selection : [];

    if (this._keyTransform) {
      // calculate row key for selected rows
      //@flow-ignore
      selection = selection.map(function (row) {
        return this$1._keyTransform(lodash__default.clone(row));
      });
    }

    var keys = selection.map(this._keyFct).sort();

    if (!this._hasSelectionChanged(keys)) {
      return;
    }

    var ref = options || {};
    var skipRender = ref.skipRender;
    if (skipRender === void 0) skipRender = false;
    var silent = ref.silent;
    if (silent === void 0) silent = false;

    this._mainChartHandleSelection("setSelection", keys, selection, {
      skipRender: skipRender
    });

    if (this._legendKeyFct) {
      var legendKeys = this._chart2LegendKeys(keys);

      this._sceneProcessors.legend.setSelection(legendKeys, {
        skipRender: skipRender
      });
    }

    this._updateSelection(keys, silent);
  };

  RowsSelector.prototype._hasSelectionChanged = function _hasSelectionChanged(keys) {
    return !dataUtils.deepEqual(this._selectionKeys, keys);
  };

  RowsSelector.prototype._updateSelection = function _updateSelection(keys, silent) {
    var this$1 = this;
    this._selectionKeys = keys.slice();
    this._selection = lodash__default.filter(this._selectionKeys.map(function (key) {
      var row = this$1._getRowByKey(key);

      if (row) {
        // don't emit internal stuff
        row = rowsUtils$1.getRowWithoutInternalValue(row);
      }

      return row;
    }));

    if (!silent) {
      this._eventDelegate.trigger(constants$1.EVENT_NAME.SELECTION_CHANGED, this.getSelection());
    }

    if (!silent) {
      this._eventDelegate.trigger(constants$1.UNDOCUMENTED_EVENTS.LEGACY_SELECTION_CHANGED, this.getLegacySelection());
    }
  };
  /**
  	 * Callback when a selection happened on main scene.
  	 * Will calculate corresponding shape keys to select on legend, and trigger selectionChanged event.
  	 */


  RowsSelector.prototype._onMainChartSelect = function _onMainChartSelect(action, key, keys) {
    if (!this._keyFct || !this._hasSelectionChanged(keys)) {
      return;
    }

    if (this._legendKeyFct) {
      var legendKeys = this._chart2LegendKeys(keys);

      this._sceneProcessors.legend.setSelection(legendKeys);
    }

    this._updateSelection(keys);
  };
  /**
  	 * Callback when a selection happened on legend scene.
  	 * Will calculate corresponding shapes keys to select/unselect on main scene, and trigger selectionChanged event.
  	 */


  RowsSelector.prototype._onLegendSelect = function _onLegendSelect(action, legendKey, legendKeys) {
    var this$1 = this;

    if (!(this._keyFct && this._legendKeyFct && this._rows)) {
      return;
    }

    var keyFct = this._keyFct;
    var legendKeyFct = this._legendKeyFct;
    var rows = this._rows;

    if (legendKeys.length) {
      if (action === constants$1.SELECT_ACTION.SELECT) {
        var keys$1 = rows.filter(function (row) {
          return legendKeyFct(row) === legendKey;
        }).map(keyFct);

        this._mainChartHandleSelection("select", keys$1);
      } else if (action === constants$1.SELECT_ACTION.UNSELECT && this._selectionKeys) {
        var keys = [];

        for (var i = 0; i < this._selectionKeys.length; i++) {
          var key = this$1._selectionKeys[i];

          var row = this$1._getRowByKey(key);

          if (!row) {
            continue;
          }

          if (legendKeyFct(row) === legendKey) {
            keys.push(key);
          }
        }

        this._mainChartHandleSelection("unselect", keys);
      }
    } else {
      this._mainChartHandleSelection("setSelection", []);
    }

    var selectedKeys = this._mainChartHandleSelection("getSelection");

    if (this._hasSelectionChanged(selectedKeys)) {
      this._updateSelection(selectedKeys);
    }
  };

  RowsSelector.prototype._mainChartHandleSelection = function _mainChartHandleSelection(methodName, selectionKeys, selection, options) {
    if (this._runtimeChart && this._runtimeChart[methodName]) {
      return this._runtimeChart[methodName](selectionKeys, selection);
    } //@flow-ignore


    return this._sceneProcessors.main[methodName](selectionKeys, options);
  };
  /**
  	 * Helper to summarize legend keys given an array of shape keys from chart
  	 */


  RowsSelector.prototype._chart2LegendKeys = function _chart2LegendKeys(keys) {
    var this$1 = this;
    var legendKeys = keys.map(function (key) {
      var row = this$1._getRowByKey(key); //@flow-ignore


      return row ? this$1._legendKeyFct(row) : null;
    });
    return dataUtils.uniq(lodash__default.filter(legendKeys, function (key) {
      return key != null;
    }));
  };
  /**
  	 * Builds a map for data rows indexed by their corresponding shape keys in main scene.
  	 * So when selection happened on a shape in main scene, can quickly find the data row it represents.
  	 */


  RowsSelector.prototype._buildRowsMap = function _buildRowsMap() {
    var this$1 = this;

    if (this._rowsMap != null || !this._rows || !this._keyFct) {
      return;
    }

    this._rowsMap = {};

    for (var i = 0; i < this._rows.length; i++) {
      var row = this$1._rows[i];
      this$1._rowsMap[this$1._keyFct(row)] = row;
    }

    return;
  };

  RowsSelector.prototype._getRowByKey = function _getRowByKey(key) {
    this._buildRowsMap();

    if (!this._rowsMap) {
      return;
    }

    return this._rowsMap[key];
  }; //-ignore

  /**
   * Created by yi.chen on 2/6/17.
   */

  /**
   * For RowRangeSelector, selection keys are not used. Selection would be passed directly from
   * the lower level components.
   *
   * _selection: ValuesSelection; The selection values returned
   * _selectionKeys: Array<string>; Not used
   */


  var RowRangeSelector = function (RowsSelecto____1) {
    function RowRangeSelector() {
      RowsSelecto____1.apply(this, arguments);
    }

    if (RowsSelecto____1) RowRangeSelector.__proto__ = RowsSelecto____1;
    RowRangeSelector.prototype = Object.create(RowsSelecto____1 && RowsSelecto____1.prototype);
    RowRangeSelector.prototype.constructor = RowRangeSelector;

    RowRangeSelector.prototype.setSelection = function setSelection(selection, options) {
      if (options === void 0) options = {};

      if (!this._keyFct) {
        return;
      }

      selection = selection ? selection : [];

      if (!this._hasSelectionChanged(selection)) {
        return;
      }

      var skipRender = options.skipRender;
      var silent = options.silent;

      this._sceneProcessors.main.setSelection(selection, {
        skipRender: skipRender
      });

      this._updateSelection(selection, silent);
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    RowRangeSelector.prototype._hasSelectionChanged = function _hasSelectionChanged(values) {
      return !dataUtils.deepEqual(this._selection, values);
    };

    RowRangeSelector.prototype._updateSelection = function _updateSelection(values, silent) {
      this._selection = values;

      if (!silent) {
        this._eventDelegate.trigger(constants$1.EVENT_NAME.SELECTION_CHANGED, this.getSelection());
      }
    };

    RowRangeSelector.prototype._onMainChartSelect = function _onMainChartSelect(action, key, values) {
      if (this._hasSelectionChanged(values)) {
        this._updateSelection(values);
      }
    };

    RowRangeSelector.prototype._onLegendSelect = function _onLegendSelect(action, legendKey, legendKeys) {};

    return RowRangeSelector;
  }(RowsSelector); //

  /**
   * Created by yi.chen on 2/14/17.
   */


  var SELECTMODE = constants$1.SELECTMODE;

  var makeSelector = function makeSelector(selectMode) {
    var args = [],
        len = arguments.length - 1;

    while (len-- > 0) {
      args[len] = arguments[len + 1];
    }

    var constructor = RowsSelector;

    switch (selectMode) {
      case SELECTMODE.RANGE:
        constructor = RowRangeSelector;
        break;

      default:
        constructor = RowsSelector;
    }

    return new (Function.prototype.bind.apply(constructor, [null].concat(args)))();
  }; //
  //@flow-ignore


  var ChartInteractionManager = function ChartInteractionManager(sceneProcessors, eventDelegate) {
    var this$1 = this;
    this._eventDelegate = eventDelegate;
    this._sceneProcessors = sceneProcessors;

    for (var name in this$1._sceneProcessors) {
      this$1._sceneProcessors[name].setChartDelegate(this$1._getChartDelegate(name));
    }
  };
  /**
  	 * Life cycle method when new scenes are generated for the chart.
  	 * Notify sceneProcessors on new scene, also notify all interactions to re-setup for the new scene
  	 */


  ChartInteractionManager.prototype.onNewScenes = function onNewScenes(scenes, config, rows, runtimeChart) {
    var this$1 = this;

    for (var name in this$1._sceneProcessors) {
      this$1._sceneProcessors[name].setScene(scenes[name]);
    }

    var mainScene = scenes.main;

    if (mainScene) {
      var selectMode = mainScene.get('selectMode');
      var selectionKeyFct = mainScene.get('selectionKeyFct');
      var legendSelectionKeyFct = scenes.legend && scenes.legend.get('selectionKeyFct');
      var keyTransform = mainScene.get('keyTransform');
      this._rowsSelector = makeSelector(selectMode, this._sceneProcessors, this._eventDelegate, runtimeChart);

      this._rowsSelector.update(rows, selectionKeyFct, legendSelectionKeyFct, keyTransform, selectMode);
    } else {
      if (this._rowsSelector) {
        this._rowsSelector.resetAll();
      }
    }

    return this;
  };
  /**
  	 * Given the new size, return if the scene (with the new size) will be in the viewport
  	 * Ex. for web platform, it will detect the HTMLCanvas element when applied the new dimension
  	 * will be in the window or not
  	 */


  ChartInteractionManager.prototype.isInViewport = function isInViewport(size) {
    return this._sceneProcessors.main.isInViewport(size);
  };
  /**
  	 * Get the screenshot of the chart including the main chart and the legend
  	 */


  ChartInteractionManager.prototype.screenshot = function screenshot(inputCanvas, size) {
    var this$1 = this;

    if (!envUtils.inBrowser()) {
      return es6Promise.Promise.resolve(null);
    }

    return new es6Promise.Promise(function (resolve, reject) {
      var width = size[0];
      var height = size[1];
      var canvas = inputCanvas != null ? inputCanvas : document.createElement("canvas");
      var pixelRatio = window.testDevicePixelRatio || window.devicePixelRatio || 1;

      if (!inputCanvas) {
        canvas.width = width;
        canvas.height = height;
      }

      var chartScreenshotInfo = this$1._sceneProcessors.main.screenshot();

      var legendScreenshotInfo = this$1._sceneProcessors.legend.screenshot();

      var ctx = canvas.getContext('2d');

      if (ctx && pixelRatio !== 1) {
        ctx.scale(1 / pixelRatio, 1 / pixelRatio);
      }

      if (ctx && chartScreenshotInfo) {
        var mainChartOffsetLeft = chartScreenshotInfo.left;
        var mainChartOffsetTop = chartScreenshotInfo.top;
        var chartSrc = chartScreenshotInfo.src;
        ctx.clearRect(mainChartOffsetLeft, mainChartOffsetTop, width, height); // Draw the main and legend views onto the canvas in the correct positions

        var image = new Image();
        var isLegend = false;

        image.onload = function () {
          if (isLegend && legendScreenshotInfo) {
            ctx.drawImage(image, legendScreenshotInfo.left, legendScreenshotInfo.top);
            resolve({
              screenshot: canvas.toDataURL(),
              size: [canvas.width, canvas.height]
            });
          } else {
            ctx.drawImage(image, mainChartOffsetLeft, mainChartOffsetTop);

            if (legendScreenshotInfo != null) {
              image.src = legendScreenshotInfo.src;
              isLegend = true;
            } else {
              resolve({
                screenshot: canvas.toDataURL(),
                size: [canvas.width, canvas.height]
              });
            }
          }
        };

        image.src = chartSrc;
      }
    });
  };

  ChartInteractionManager.prototype.getAutoFitRatio = function getAutoFitRatio() {
    return this._sceneProcessors.main.getAutoFitRatio();
  };

  ChartInteractionManager.prototype.startInteraction = function startInteraction() {
    this._sceneProcessors.main.startInteraction();

    this._sceneProcessors.legend.startInteraction();

    return this;
  };

  ChartInteractionManager.prototype.stopInteraction = function stopInteraction() {
    this._sceneProcessors.main.stopInteraction();

    this._sceneProcessors.legend.stopInteraction();

    return this;
  };
  /**
  	 * Set selection programmatically
  	 */


  ChartInteractionManager.prototype.setSelection = function setSelection(selection, options) {
    if (options === void 0) options = {};

    if (this._rowsSelector) {
      this._rowsSelector.setSelection(selection, options);
    }

    return this;
  };
  /**
  	 * Returns the current selection
  	 */


  ChartInteractionManager.prototype.getSelection = function getSelection() {
    if (this._rowsSelector) {
      return this._rowsSelector.getSelection();
    }

    return [];
  };
  /**
  	 * Set annotations programmatically
  	 */


  ChartInteractionManager.prototype.setAnnotations = function setAnnotations(annotations) {
    this._sceneProcessors["main"].setAnnotations(annotations);

    return this;
  };

  ChartInteractionManager.prototype.getAnnotations = function getAnnotations() {
    return this._sceneProcessors["main"].getAnnotations();
  };
  /**
  	 * Prepares ChartDelegate for a sceneProcessor with callbacks to chart level interaction handling.
  	 * Each delegate method is binded with the sceneProcessor's name so that sceneProcessor doesn't
  	 * need to always pass its name but the original delegate method can differentiate calls from each
  	 * sceneProcessor
  	 */


  ChartInteractionManager.prototype._getChartDelegate = function _getChartDelegate(name) {
    var this$1 = this;
    return {
      onSelect: function onSelect(action, key, keys) {
        return this$1._onSelect(name, action, key, keys);
      },
      onShowTable: this._eventDelegate.onShowTable.bind(this._eventDelegate),
      onEvent: function onEvent(eventName, eventData) {
        return this$1._onChartEvent(name, eventName, eventData);
      }
    };
  };
  /**
  	 * Callback to handle select from scene
  	 */


  ChartInteractionManager.prototype._onSelect = function _onSelect(name, action, key, keys) {
    if (this._rowsSelector) {
      this._rowsSelector.onSelect(name, action, key, keys);
    }
  };
  /**
  	 * Callback to handle event triggering from scene
  	 */


  ChartInteractionManager.prototype._onChartEvent = function _onChartEvent(name, eventName) {
    var args = [],
        len = arguments.length - 2;

    while (len-- > 0) {
      args[len] = arguments[len + 2];
    }

    var namespacedEvtName = name === "main" ? eventName : name + "::" + eventName;

    (ref = this._eventDelegate).trigger.apply(ref, [namespacedEvtName].concat(args));

    var ref;
  };

  ChartInteractionManager.prototype.scrollTo = function scrollTo(x, y, duration) {
    if (duration === void 0) duration = 0;
    var waits = [this._sceneProcessors.main, this._sceneProcessors.legend].filter(function (p) {
      return p;
    }).map(function (p) {
      return p.scrollTo(x, y, duration);
    });
    return waits.length ? es6Promise.Promise.all(waits) : es6Promise.Promise.resolve(new Perf());
  };

  ChartInteractionManager.prototype.isRemoved = function isRemoved() {
    return this._sceneProcessors.main.isRemoved() || this._sceneProcessors.legend.isRemoved();
  };

  ChartInteractionManager.prototype.showTooltip = function showTooltip() {
    this._sceneProcessors.main.hideTooltip();

    return this;
  };

  ChartInteractionManager.prototype.hideTooltip = function hideTooltip() {
    this._sceneProcessors.main.hideTooltip();

    return this;
  };

  ChartInteractionManager.prototype.renderAccessibilityTable = function renderAccessibilityTable(rows) {
    this._sceneProcessors.main.renderAccessibilityTable(rows);

    return this;
  };
  /*::(x: Animation) => (x: IAnimation)*/


  var Animation = function Animation(ref) {
    var name = ref.name;
    var scene = ref.scene;
    var options = ref.options;
    var interrupt = ref.interrupt;
    if (interrupt === void 0) interrupt = false;
    this._name = name;
    this._scene = scene;
    this._options = options;
    this._interrupt = interrupt;
    this._isRunning = false;
    this._perf = new Perf({
      name: 'animate'
    }).start();
    this._def = new Deferred();
  };

  Animation.prototype.getScene = function getScene() {
    return this._scene;
  };

  Animation.prototype.getOptions = function getOptions() {
    return this._options;
  };

  Animation.prototype.getPromise = function getPromise() {
    return this._def.promise;
  };

  Animation.prototype.isInterrupt = function isInterrupt() {
    return this._interrupt;
  };

  Animation.prototype.isRunning = function isRunning() {
    return this._isRunning;
  };

  Animation.prototype.defer = function defer() {
    if (log$1.animation) {
      console.log(this._name + "  - defer");
    }

    this._perf.mark('defer');

    return this;
  };

  Animation.prototype.start = function start() {
    if (log$1.animation) {
      console.log(this._name + "  - start");
    }

    this._isRunning = true;

    this._perf.endMark('defer');

    return this;
  };

  Animation.prototype.end = function end(childPerf) {
    if (log$1.animation) {
      console.log(this._name + "  - end");
    }

    if (childPerf) {
      this._perf.merge(childPerf.toJson());
    }

    this._perf.endMark('defer');

    this._perf.end();

    this._isRunning = false;

    this._done();

    return this;
  };

  Animation.prototype._done = function _done() {
    this._def.resolve(this._perf);

    return this;
  };

  var AnimationQueue = function AnimationQueue(_delegate) {
    this._delegate = _delegate;
    this._currentAnim = null;
    this._deferredAnim = null;
  };

  AnimationQueue.prototype.reset = function reset() {
    return this._resetDeferredAnim();
  };

  AnimationQueue.prototype.run = function run(animation) {
    if (animation.isInterrupt()) {
      this._resetDeferredAnim();

      this._resetCurrentAnim();
    }

    if (this._currentAnim != null ? this._currentAnim.isRunning() : undefined) {
      this._defer(animation);
    } else {
      this._run(animation);
    }

    return this;
  };

  AnimationQueue.prototype._run = function _run(animation) {
    var this$1 = this;
    this._currentAnim = animation;

    this._delegate.runAnimation(animation);

    animation.getPromise().then(function () {
      this$1._currentAnim = null;

      if (this$1._deferredAnim) {
        this$1._run(this$1._deferredAnim);

        return this$1._deferredAnim = null;
      }
    });
    return this;
  };

  AnimationQueue.prototype._defer = function _defer(animation) {
    // Note: when we replace a deferred animation, the new animation's
    // duration has to be at least the replaced duration. e.g. selecting
    // pie slices quickly and mouse out
    // 1.select -> 450ms animation
    // 2.select -> 450ms animation
    // 3.mouse out -> 0ms animation
    //
    // we throttle 2. and eventually play 3. after 1. is finished
    // we want a 450ms animation instead of 0ms to show the transition for both 2. and 3.
    var minDuration = this._deferredAnim ? this._deferredAnim.getOptions().duration : 0;
    var options = animation.getOptions();
    options.duration = Math.max(options.duration, minDuration);

    this._resetDeferredAnim();

    this._delegate.deferAnimation(animation);

    this._deferredAnim = animation;
    return this;
  };

  AnimationQueue.prototype._resetCurrentAnim = function _resetCurrentAnim() {
    if (!this._currentAnim) {
      return this;
    }

    this._delegate.cancelAnimation(this._currentAnim);

    this._currentAnim = null;
    return this;
  };

  AnimationQueue.prototype._resetDeferredAnim = function _resetDeferredAnim() {
    if (!this._deferredAnim) {
      return this;
    }

    this._delegate.cancelAnimation(this._deferredAnim);

    this._deferredAnim = null;
    return this;
  }; //
  //@flow-ignore


  var COLOR_TYPE$5 = constants$1.CHART_LAYOUT.COLOR_TYPE;
  var COLUMN_TYPE$9 = constants$1.COLUMN_TYPE;
  var TYPE_BY_KEY = {
    dimension: COLUMN_TYPE$9.DIMENSION,
    color: COLUMN_TYPE$9.DIMENSION,
    measure: COLUMN_TYPE$9.MEASURE,
    trellis: COLUMN_TYPE$9.DIMENSION,
    time: COLUMN_TYPE$9.TIME,
    plot: COLUMN_TYPE$9.MEASURE,
    x: COLUMN_TYPE$9.MEASURE,
    y: COLUMN_TYPE$9.MEASURE,
    r: COLUMN_TYPE$9.MEASURE
  };

  function _inferTypeFromConfig(key, value) {
    return key === "color" ? value.type === COLOR_TYPE$5.GRADIENT || value.type === COLOR_TYPE$5.BINS ? COLUMN_TYPE$9.MEASURE : COLUMN_TYPE$9.DIMENSION : TYPE_BY_KEY[key] || COLUMN_TYPE$9.DIMENSION;
  }

  var rowsMetadataUtils = {
    /**
     * Extract RowsMetadata from config for legacy lightning charts, which have not yet
     * started to pass in rowsMetadata
     */
    getRowsMetadataFromConfig: function getRowsMetadataFromConfig(config) {
      if (!config) {
        return undefined;
      }

      var rowsMetadataMap = {};
      configUtils.traverseConfigSections(config, undefined, function (section, key) {
        var cols = section && (section.column || section.fields);

        if (!cols) {
          return;
        }

        cols.map(function (col) {
          var colCopy = dataUtils.deepCopy(col);
          colCopy.type = _inferTypeFromConfig(key, section);
          rowsMetadataMap[col.column] = colCopy;
        });
      });
      return lodash__default.values(rowsMetadataMap);
    },

    /**
     * Merge two rowsMetadata, like lodash.extend, merge the sourceJson into rowsMetadataJson
     */
    mergeRowsMetadata: function mergeRowsMetadata(rowsMetadataJson, sourceJson) {
      if (!sourceJson) {
        return rowsMetadataJson;
      }

      var columnMap = {};
      rowsMetadataJson.forEach(function (columnJson) {
        columnMap[columnJson.column] = columnJson;
      });
      sourceJson.forEach(function (sourceColumnJson) {
        var column = sourceColumnJson.column;
        var type = sourceColumnJson.type;

        if (type) {
          delete sourceColumnJson.type;
          console.warn("can not change rowsMetadata column type for column " + column);
        }

        if (columnMap[column]) {
          dataUtils.extendDeep(columnMap[column], sourceColumnJson);
        }
      });
      return lodash__default.values(columnMap);
    }
  }; //

  /*::(x: Actor) => (x: IActor)*/

  var Actor = function Actor() {
    var actors = [],
        len = arguments.length;

    while (len--) {
      actors[len] = arguments[len];
    }

    this._actors = actors;
  };

  Actor.prototype.trigger = function trigger(state) {
    return this._delegate(state);
  };

  Actor.prototype._delegate = function _delegate(state) {
    var this$1 = this;
    var currentState = state;

    for (var i = 0, len = this._actors.length; i < len; ++i) {
      currentState = this$1._actors[i](currentState);
    }

    return currentState;
  }; //
  //@flow-ignore

  /*::(x: CompositeAction) => (x: IActions & IAction)*/


  var CompositeAction = function CompositeAction(actions, type) {
    this._actions = actions;
    this._type = type;
  };

  CompositeAction.prototype.addAction = function addAction(action) {
    this._actions.push(action);

    return this;
  };

  CompositeAction.prototype.onMouseUp = function onMouseUp(state) {
    return this._delegate('onMouseUp', state);
  };

  CompositeAction.prototype.onMouseDown = function onMouseDown(state) {
    return this._delegate('onMouseDown', state);
  };

  CompositeAction.prototype.onMouseClick = function onMouseClick(state) {
    return this._delegate('onMouseClick', state);
  };

  CompositeAction.prototype.onMouseMove = function onMouseMove(state) {
    return this._delegate('onMouseMove', state);
  };

  CompositeAction.prototype.onMouseLeave = function onMouseLeave(state) {
    return this._delegate('onMouseLeave', state);
  };

  CompositeAction.prototype.onMouseEnterShape = function onMouseEnterShape(state) {
    return this._delegate('onMouseEnterShape', state);
  };

  CompositeAction.prototype.onMouseLeaveShape = function onMouseLeaveShape(state) {
    return this._delegate('onMouseLeaveShape', state);
  };

  CompositeAction.prototype.onKeyDown = function onKeyDown(state) {
    return this._delegate('onKeyDown', state);
  };

  CompositeAction.prototype.onKeyUp = function onKeyUp(state) {
    return this._delegate('onKeyUp', state);
  };

  CompositeAction.prototype.onScroll = function onScroll(state) {
    return this._delegate('onScroll', state);
  };

  CompositeAction.prototype.onSelect = function onSelect(state) {
    return this._delegate('onSelect', state);
  };

  CompositeAction.prototype._delegate = function _delegate(eventName, state) {
    var this$1 = this;
    var currentState = state;

    for (var i = 0; i < this._actions.length; ++i) {
      var action = this$1._actions[i]; //@flow-ignore

      currentState = action[eventName].call(action, lodash__default.extend({}, state, {
        states: currentState.states || []
      }));
    }

    return currentState;
  }; //

  /*::(x: Action) => (x: IAction)*/


  var Action = function Action(input) {
    //@flow-ignore
    this._enterActor = input.enter;
    this._updateActor = input.update; //@flow-ignore

    this._leaveActor = input.leave;
  };

  Action.prototype.onMouseUp = function onMouseUp(state) {
    return state;
  };

  Action.prototype.onMouseDown = function onMouseDown(state) {
    return state;
  };

  Action.prototype.onMouseClick = function onMouseClick(state) {
    return state;
  };

  Action.prototype.onMouseMove = function onMouseMove(state) {
    return state;
  };

  Action.prototype.onMouseLeave = function onMouseLeave(state) {
    return state;
  };

  Action.prototype.onMouseEnterShape = function onMouseEnterShape(state) {
    return state;
  };

  Action.prototype.onMouseLeaveShape = function onMouseLeaveShape(state) {
    return state;
  };

  Action.prototype.onKeyDown = function onKeyDown(state) {
    return state;
  };

  Action.prototype.onKeyUp = function onKeyUp(state) {
    return state;
  };

  Action.prototype.onScroll = function onScroll(state) {
    return state;
  };

  Action.prototype.onSelect = function onSelect(state) {
    return state;
  }; //

  /*::(x: ClickAction) => (x: IAction)*/


  var ClickAction = function (Actio____1) {
    function ClickAction(input) {
      Actio____1.call(this, input);
    }

    if (Actio____1) ClickAction.__proto__ = Actio____1;
    ClickAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    ClickAction.prototype.constructor = ClickAction;

    ClickAction.prototype.onMouseDown = function onMouseDown(state) {
      var pointerPosition = state.pointerPosition;
      this._startPos = pointerPosition;
      return state;
    };

    ClickAction.prototype.onMouseUp = function onMouseUp(state) {
      var pointerPosition = state.pointerPosition;

      if (pointerPosition && this._startPos) {
        var ref = this._startPos;
        var sx = ref[0];
        var sy = ref[1];
        var ex = pointerPosition[0];
        var ey = pointerPosition[1];

        if (sx === ex && sy === ey && this._updateActor) {
          return this._updateActor.trigger(state);
        }
      }

      this._startPos = null;
      return state;
    };

    return ClickAction;
  }(Action); // FSM (Flying Speghetti Monster)
  //
  // A simple implementation of Finite State Machine
  //
  // - example of a FSM representing single selection
  // new FSM
  //	initial: "NONE"
  //	states:
  //		NONE:
  //			onEnter: (from, e) ->
  //			onLeave: (to, e) ->
  //			events:
  //				select: "ONE"
  //		ONE:
  //			onEnter: (from, e) ->
  //			onLeave: (to, e) ->
  //			events:
  //				select: "ONE"
  //				unselect: "NONE"
  //				reset: "NONE"
  //	events:
  //		select:
  //			beforeTransition: (params) ->
  //			afterTransition: (params) ->
  //		unselect:
  //			beforeTransition: (params) ->
  //			afterTransition: (params) ->
  //
  // - callbacks
  //   beforeTransition: (eventParams)
  //   afterTransition: (eventParams)
  //	onEnter: (fromState, eventName)
  //	onLeave: (toState, eventName)
  // - order of callbacks and state transition when event is triggered
  //   fsm.onEvent(event)
  //   event.beforeTransition
  //   state0.onLeave
  //   state1.onEnter
  //   event.afterTransition
  //
  //   Note: events not listed in states description are inactive, their
  //   beforeTransition and afterTransition callbacks will not be triggered
  //
  //


  var FSM = function FSM(ref) {
    var initial = ref.initial;
    var states = ref.states;
    var events = ref.events;
    this.states = states;
    this.events = events;

    if (this.events == null) {
      this.events = {};
    }

    if (this.states == null) {
      this.states = {};
    }

    this._currentState = initial;
  };

  FSM.initClass = function initClass() {
    this.prototype._currentState = null;
  };

  FSM.prototype.transition = function transition(state, e, params) {
    if (typeof this.states[this._currentState].onLeave === 'function') {
      this.states[this._currentState].onLeave(state, e, params);
    }

    var oldState = this._currentState;
    this._currentState = state;
    return typeof this.states[state].onEnter === 'function' ? this.states[state].onEnter(oldState, e, params) : undefined;
  };

  FSM.prototype.onEvent = function onEvent(name, params) {
    var next = this.states[this._currentState].events[name];

    if (next) {
      if (this.events[name] != null && this.events[name].beforeTransition != null) {
        this.events[name].beforeTransition(params);
      }

      var ret = this.transition(next, name, params);

      if (this.events[name] != null && this.events[name].afterTransition != null) {
        this.events[name].afterTransition(params);
      }

      return ret;
    }
  };

  FSM.prototype.getState = function getState() {
    return this._currentState;
  };

  FSM.initClass(); //
  //@flow-ignore

  var DRAG_STATE = {
    INACTIVE: 'inactive',
    DRAG_START: 'dragstart',
    DRAG_SELECTING: 'dragselecting'
  };
  var DRAG_EVENT = {
    POINTER_DOWN: 'pointerDown',
    POINTER_UP: 'pointerUp',
    POINTER_MOVE: 'pointerMove'
  };
  /*::(x: DragAction) => (x: IAction)*/

  var DragAction = function (Actio____1) {
    function DragAction(input) {
      Actio____1.call(this, input);

      this._setupState();

      this._trace = [];
    }

    if (Actio____1) DragAction.__proto__ = Actio____1;
    DragAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    DragAction.prototype.constructor = DragAction;

    DragAction.prototype.onMouseDown = function onMouseDown(state) {
      var pointerPosition = state.pointerPosition;

      if (pointerPosition) {
        var x = pointerPosition[0];
        var y = pointerPosition[1];
        return this._stateMachine.onEvent(DRAG_EVENT.POINTER_DOWN, state) || state;
      }

      return state;
    };

    DragAction.prototype.onMouseUp = function onMouseUp(state) {
      return this._stateMachine.onEvent(DRAG_EVENT.POINTER_UP, state) || state;
    };

    DragAction.prototype.onMouseMove = function onMouseMove(state) {
      var pointerPosition = state.pointerPosition;

      if (pointerPosition) {
        return this._stateMachine.onEvent(DRAG_EVENT.POINTER_MOVE, state) || state;
      }

      return state;
    };

    DragAction.prototype.onMouseLeave = function onMouseLeave(state) {
      return this._reset("", "onMouseLeave", state);
    };

    DragAction.prototype._anchor = function _anchor(oldState, event, state) {
      var pointerPosition = state.pointerPosition;

      if (pointerPosition) {
        this._dragStart = pointerPosition;
      }

      return state;
    };

    DragAction.prototype._reset = function _reset(oldState, event, state) {
      this._dragStart = null;
      this._trace = [];

      if (this._leaveActor) {
        return this._leaveActor.trigger(state);
      }

      return state;
    };

    DragAction.prototype._update = function _update(oldState, event, state) {
      var pointerPosition = state.pointerPosition;
      var dragStart = this._dragStart;

      if (pointerPosition && dragStart) {
        this._trace.push(pointerPosition);

        if (this._trace.length === 1 && this._enterActor) {
          return this._enterActor.trigger(lodash__default.extend({}, state, {
            pointerTrace: [this._dragStart].concat(this._trace)
          }));
        } else if (this._updateActor) {
          return this._updateActor.trigger(lodash__default.extend({}, state, {
            pointerTrace: [this._dragStart].concat(this._trace)
          }));
        }
      }

      return state;
    };
    /**
     * Setup the state machine to simulate a drag event
     * @private
     */


    DragAction.prototype._setupState = function _setupState() {
      var obj, obj$1, obj$2, obj$3;
      this._stateMachine = new FSM({
        initial: DRAG_STATE.INACTIVE,
        states: (obj$3 = {}, obj$3[DRAG_STATE.INACTIVE] = {
          onEnter: this._reset.bind(this),
          events: (obj = {}, obj[DRAG_EVENT.POINTER_DOWN] = DRAG_STATE.DRAG_START, obj)
        }, obj$3[DRAG_STATE.DRAG_START] = {
          onEnter: this._anchor.bind(this),
          events: (obj$1 = {}, obj$1[DRAG_EVENT.POINTER_UP] = DRAG_STATE.INACTIVE, obj$1[DRAG_EVENT.POINTER_MOVE] = DRAG_STATE.DRAG_SELECTING, obj$1)
        }, obj$3[DRAG_STATE.DRAG_SELECTING] = {
          onEnter: this._update.bind(this),
          events: (obj$2 = {}, obj$2[DRAG_EVENT.POINTER_UP] = DRAG_STATE.INACTIVE, obj$2[DRAG_EVENT.POINTER_MOVE] = DRAG_STATE.DRAG_SELECTING, obj$2)
        }, obj$3)
      });
    };

    return DragAction;
  }(Action); //

  /*::(x: HoverAction) => (x: IAction)*/


  var HoverAction = function (Actio____1) {
    function HoverAction(input) {
      Actio____1.call(this, input);
    }

    if (Actio____1) HoverAction.__proto__ = Actio____1;
    HoverAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    HoverAction.prototype.constructor = HoverAction;

    HoverAction.prototype.onMouseEnterShape = function onMouseEnterShape(state) {
      if (this._enterActor) {
        return this._enterActor.trigger(state);
      }

      return state;
    };

    HoverAction.prototype.onMouseLeaveShape = function onMouseLeaveShape(state) {
      if (this._leaveActor) {
        return this._leaveActor.trigger(state);
      }

      return state;
    };

    return HoverAction;
  }(Action); //

  /*::(x: HoverAction) => (x: IAction)*/


  var HoverAction$2 = function (Actio____1) {
    function HoverAction(input) {
      Actio____1.call(this, input);
    }

    if (Actio____1) HoverAction.__proto__ = Actio____1;
    HoverAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    HoverAction.prototype.constructor = HoverAction;

    HoverAction.prototype.onMouseMove = function onMouseMove(state) {
      if (this._updateActor) {
        return this._updateActor.trigger(state);
      }

      return state;
    };

    return HoverAction;
  }(Action); //

  /**
   * SelectAction is triggered by a programatical selection
   */

  /*::(x: SelectAction) => (x: IAction)*/


  var SelectAction = function (Actio____1) {
    function SelectAction(input) {
      Actio____1.call(this, input);
    }

    if (Actio____1) SelectAction.__proto__ = Actio____1;
    SelectAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    SelectAction.prototype.constructor = SelectAction;

    SelectAction.prototype.onSelect = function onSelect(state) {
      if (this._updateActor) {
        return this._updateActor.trigger(state);
      }

      return state;
    };

    return SelectAction;
  }(Action); //

  /*::(x: KeyAction) => (x: IAction)*/


  var KeyAction = function (Actio____1) {
    function KeyAction(input) {
      Actio____1.call(this, input);
    }

    if (Actio____1) KeyAction.__proto__ = Actio____1;
    KeyAction.prototype = Object.create(Actio____1 && Actio____1.prototype);
    KeyAction.prototype.constructor = KeyAction;

    KeyAction.prototype.onKeyDown = function onKeyDown(state) {
      if (this._updateActor) {
        return this._updateActor.trigger(state);
      }

      return state;
    };

    return KeyAction;
  }(Action); //

  /*::(x: TabAction) => (x: IAction)*/


  var TabAction = function (KeyActio____1) {
    function TabAction() {
      KeyActio____1.apply(this, arguments);
    }

    if (KeyActio____1) TabAction.__proto__ = KeyActio____1;
    TabAction.prototype = Object.create(KeyActio____1 && KeyActio____1.prototype);
    TabAction.prototype.constructor = TabAction;

    TabAction.prototype.onKeyDown = function onKeyDown(state) {
      var activeKeys = state.activeKeys;

      if (activeKeys && activeKeys.indexOf(constants$1.KEYBOARD_KEY.TAB) >= 0 && this._updateActor) {
        return this._updateActor.trigger(state);
      }

      return state;
    };

    return TabAction;
  }(KeyAction); //


  var InteractionDelegate = function InteractionDelegate(sceneInteractionManagerDelegate) {
    this._sceneInteractionManagerDelegate = sceneInteractionManagerDelegate;
  }; //-ignore


  var AnnotationInteraction = function (InteractionDelegat____1) {
    function AnnotationInteraction(sceneInteractionDelegate) {
      InteractionDelegat____1.call(this, sceneInteractionDelegate);
      this.type = "annotation";
      this._annotationMap = {};

      this._setScene(sceneInteractionDelegate.getScene());
    }

    if (InteractionDelegat____1) AnnotationInteraction.__proto__ = InteractionDelegat____1;
    AnnotationInteraction.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    AnnotationInteraction.prototype.constructor = AnnotationInteraction;

    AnnotationInteraction.prototype.reset = function reset() {
      var this$1 = this;
      Object.keys(this._annotationMap).forEach(function (key) {
        this$1._annotationMap[key].remove();
      });
    };

    AnnotationInteraction.prototype._setScene = function _setScene(scene) {
      if (!scene) {
        return this;
      }

      this._scene = scene;
      this._keyTransform = scene.get('keyTransform');
      this._keyFct = scene.get('selectionKeyFct');
      this._dataFormatter = this._scene.get("dataFormatter");
      this._theme = this._scene.get("config").theme;
      return this;
    }; // set a single annotation


    AnnotationInteraction.prototype._setAnnotation = function _setAnnotation(annotation) {
      if (annotation === void 0) annotation = {};

      if (!this._scene || !annotation.row) {
        return;
      }

      var row = annotation.row;
      var measure = annotation.measure;
      if (measure === void 0) measure = "";
      var properties = annotation.properties;
      if (properties === void 0) properties = {};
      row = this._transformRow(row);

      var shapekey = this._keyFct(row || {});

      var shapes = this._scene.find({
        key: shapekey
      });

      var shape = this._findShape(shapes, measure);

      var key = this._getAnnotationKey({
        row: row,
        measure: measure
      });

      if (shape && shape.get("data")) {
        if (!this._annotationMap[key]) {
          var annotation$1 = this._sceneInteractionManagerDelegate.getAnnotation();

          if (!annotation$1) {
            return;
          }

          this._annotationMap[key] = annotation$1.setPadding(this._sceneInteractionManagerDelegate.getPadding());
        }

        var ref = shape.getAnnotationInfo();
        var positions = ref.positions;
        var shouldUpdate = ref.shouldUpdate;
        var viewPortCell = this._scene.getChildByKey("content") || this._scene.getChildByKey("plot") || shape.getParent().getCell();
        var ref$1 = viewPortCell.getModelProps();
        var tx = ref$1.tx;
        var ty = ref$1.ty;
        var w = ref$1.w;
        var h = ref$1.h;
        var data = rowsUtils$1.getRowWithoutInternalValue(shape.get("data").row);
        var columns = {
          column: properties.column
        };
        configUtils.hydrateConfigSection(columns, this._dataFormatter.getRowsMetadata());

        this._annotationMap[key].setViewPort({
          x: tx,
          y: ty,
          w: w,
          h: h
        }).setData({
          row: data,
          measure: measure
        }).setDefaultVisibility(properties.defaultShow).setShouldUpdate(shouldUpdate).setPositions(positions).setBackgroundColor(properties.backgroundColor).setBorderColor(properties.borderColor).setContent(columns.column, properties.text, this._theme, this._dataFormatter).setShapeBox(shape.getTranslatedBox()).setIsBlinking(properties.isBlinking).positionAndShow();
      } else if (this._annotationMap[key]) {
        this._annotationMap[key].remove();

        delete this._annotationMap[key];
      }
    }; // given an array of annotations, set each annotation, and remove any annotation that exists but is not specified in the array


    AnnotationInteraction.prototype.setAnnotations = function setAnnotations(annotations) {
      var this$1 = this;
      if (annotations === void 0) annotations = [];

      if (!this._scene) {
        return;
      }

      var newMap = {};
      annotations.forEach(function (annotation) {
        if (!this$1._scene || !annotation.row) {
          return;
        }

        var key = this$1._getAnnotationKey(annotation);

        this$1._setAnnotation(annotation);

        if (this$1._annotationMap[key]) {
          newMap[key] = this$1._annotationMap[key];
          delete this$1._annotationMap[key];
        }
      });
      lodash__default.keys(this._annotationMap).forEach(function (key) {
        return this$1._annotationMap[key].remove();
      });
      this._annotationMap = newMap;
    }; // get a list of all annotations


    AnnotationInteraction.prototype.getAnnotations = function getAnnotations() {
      var this$1 = this;
      var annotations = [];
      lodash__default.keys(this._annotationMap).forEach(function (key) {
        return annotations.push(this$1._annotationMap[key].getInfo());
      });
      return annotations;
    }; // update the position of an annotation. Usually called during scrolling or any changes in the base chart


    AnnotationInteraction.prototype.update = function update(isScroll) {
      var this$1 = this;
      lodash__default.keys(this._annotationMap).forEach(function (key) {
        var annotation = this$1._annotationMap[key];
        var ref = annotation.getData();
        var row = ref.row;
        var measure = ref.measure;
        if (measure === void 0) measure = "";
        row = this$1._transformRow(row);

        var shapes = this$1._scene.find({
          key: this$1._keyFct(row || {})
        });

        var shape = this$1._findShape(shapes, measure);

        if (!shape) {
          return;
        }

        var shapeBB = shape.getTranslatedBox();

        if (!annotation.hasSetPosition() || annotation.shouldUpdate() && !isScroll) {
          // if the shape might change on an event (like arcs radius reduces on selection), or the annotation wasnt visible earlier, then check again.
          annotation.setPositions(shape.getAnnotationInfo().positions).setShapeBox(shapeBB).positionAndShow();
        } else if (isScroll) {
          // if the chart is scrolling and we had previously calculated a position for the annotation then only move it, dont recalculate
          annotation.onScroll(shapeBB);
        }
      });
    };

    AnnotationInteraction.prototype.clickUpdate = function clickUpdate(state) {
      this.update(false);
      return state;
    }; //--------------------------------------------
    // private methods
    //--------------------------------------------


    AnnotationInteraction.prototype._findShape = function _findShape(shapes, measure) {
      if (shapes === void 0) shapes = [];

      if (!shapes.length) {
        return null;
      }

      var shape = shapes[0];

      if (measure) {
        shape = lodash__default.find(shapes, function (s) {
          return s.get("data") && s.get("data").column === measure;
        }) || shapes[0];
      }

      if (shape.getType() === "ShapeGroup") {
        return this._getAnnotationShapeFromShapeGroup(shape, measure);
      }

      return shape;
    };

    AnnotationInteraction.prototype._transformRow = function _transformRow(row) {
      return this._keyTransform ? this._keyTransform(lodash__default.clone(row)) : row;
    };

    AnnotationInteraction.prototype._getAnnotationKey = function _getAnnotationKey(ref) {
      var row = ref.row;
      var measure = ref.measure;
      if (measure === void 0) measure = "";
      row = this._transformRow(row);
      return this._keyFct(row || {}) + measure;
    };

    AnnotationInteraction.prototype._getAnnotationShapeFromShapeGroup = function _getAnnotationShapeFromShapeGroup(shapeGroup, measure) {
      if (measure === void 0) measure = "";
      var annotateShape;

      if (shapeGroup.geometry) {
        var maxArea = -Infinity;
        shapeGroup.getChildren().forEach(function (shape) {
          var area = Math.abs(geometryUtils.area(shape.get("points")));

          if (area > maxArea) {
            maxArea = area;
            return annotateShape = shape;
          }
        });
      }

      return annotateShape || shapeGroup.getChildByKey(shapeGroup.get("annotateChildKeys")[measure]);
    };

    return AnnotationInteraction;
  }(InteractionDelegate); //

  /**
   * Created by yi.chen on 1/19/17.
   */
  //@flow-ignore


  var BrushDelegate = function (InteractionDelegat____1) {
    function BrushDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) BrushDelegate.__proto__ = InteractionDelegat____1;
    BrushDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    BrushDelegate.prototype.constructor = BrushDelegate;

    BrushDelegate.prototype.updateWithTrace = function updateWithTrace(state) {
      var pointerTrace = state.pointerTrace;

      if (pointerTrace && pointerTrace.length >= 2) {
        var ref = pointerTrace[0];
        var sx = ref[0];
        var sy = ref[1];
        var ref$1 = pointerTrace[pointerTrace.length - 1];
        var ex = ref$1[0];
        var ey = ref$1[1];

        var layer = this._getBrushLayerAt(sx, sy);

        if (layer) {
          var ref$2 = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition(sx, sy));
          var localSx = ref$2[0];
          var localSy = ref$2[1];
          var ref$3 = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition(ex, ey));
          var localEx = ref$3[0];
          var localEy = ref$3[1];
          layer.brushSelect(localSx, localSy, localEx - localSx + 1, localEy - localSy + 1);
          return lodash__default.extend({}, state, {
            focusedShapes: this._findInterstingShapes(this._getShapesInBrushLayer(layer)),
            states: (state.states || []).concat(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH)
          });
        }
      }

      return state;
    };

    BrushDelegate.prototype.reset = function reset(state) {
      this._reset();

      return state;
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    BrushDelegate.prototype._getBrushLayers = function _getBrushLayers() {
      return this._sceneInteractionManagerDelegate.getInteractionLayers(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH);
    };

    BrushDelegate.prototype._getSelectionLayers = function _getSelectionLayers() {
      return this._sceneInteractionManagerDelegate.getInteractionLayers(constants$1.INTERACTION_DELEGATE_TYPE.SELECTION);
    };

    BrushDelegate.prototype._reset = function _reset() {
      this._resetBrush();

      this._shapesInArea = {};
    };
    /**
     * Get the layer at (x, y) if there's any
     * This is an O(n) operation where the n is the length of brush layers (this._layers)
     * @param x The x coordinate rpt the origin of the canvas
     * @param y The y coordinate rpt the origin of the canvas
     * @returns {Array.<IBrushLayer>}
     */


    BrushDelegate.prototype._getBrushLayerAt = function _getBrushLayerAt(x, y) {
      return lodash__default.find(this._getBrushLayers(), function (layer) {
        var cell = layer.getParent();
        var ref = cell ? cell.translation() : [0, 0];
        var tx = ref[0];
        var ty = ref[1];
        var ref$1 = layer.translation();
        var lx = ref$1[0];
        var ly = ref$1[1];
        return layer.isUnderCursor(x - tx - lx, y - ty - ly);
      });
    };
    /**
     * Remove the brush for the current brush layer
     * @private
     */


    BrushDelegate.prototype._resetBrush = function _resetBrush() {
      this._getBrushLayers().forEach(function (layer) {
        layer.removeBrush();
      });
    };
    /**
     * Find the shapes under current brush area
     * @param layer
     * @private
     */


    BrushDelegate.prototype._getShapesInBrushLayer = function _getShapesInBrushLayer(layer) {
      var burshArea = layer.getBrushArea();

      var shapeLayers = this._getShapeContainers(layer);

      if (burshArea) {
        var x0 = burshArea.x0;
        var y0 = burshArea.y0;
        var x1 = burshArea.x1;
        var y1 = burshArea.y1;
        var ref = layer.toTransformedPosition(x0, y0);
        var gX0 = ref[0];
        var gY0 = ref[1];
        var ref$1 = layer.toTransformedPosition(x1, y1);
        var gX1 = ref$1[0];
        var gY1 = ref$1[1];
        var w = gX1 - gX0 + 1;
        var h = gY1 - gY0 + 1;
        return this._findShapesInAreaFromLayers(shapeLayers, gX0, gY0, w, h).filter(function (shape) {
          return shape.get('canSelect');
        });
      }

      return [];
    };
    /**
     * Get all the shape layers associated with the given brush layer
     * Note. This is an O(m+n) operation where n is the length of all the layers and m is the length of all the plot layers
     * @param layer
     * @private
     */


    BrushDelegate.prototype._getShapeContainers = function _getShapeContainers(layer) {
      var layerSet = dataUtils.setFromValues(layer.get('shapeContainerKeys'));
      return this._getSelectionLayers().filter(function (layer) {
        return layerSet[layer.get('key')] != null;
      });
    };

    BrushDelegate.prototype._findShapesInAreaFromLayers = function _findShapesInAreaFromLayers(shapeLayers, x, y, w, h) {
      return lodash__default.flatten(shapeLayers.map(function (layer) {
        return layer.findShapesInArea(x, y, w, h);
      }));
    };
    /**
     * Find the shapes that were not in the previous selection, and toggle the selection state based on their current selection state
     * @param {*} shapes
     */


    BrushDelegate.prototype._findInterstingShapes = function _findInterstingShapes(shapes) {
      var this$1 = this;
      var interestingShapes = [];
      this._shapesInArea = this._shapesInArea || {};

      if (shapes.length) {
        var shapeMap = shapes.reduce(function (m, shape) {
          var key = shape.get('key');
          m[key] = shape;
          return m;
        }, {});
        interestingShapes = dataUtils.notIntersect(this._shapesInArea, shapeMap);
        interestingShapes.forEach(function (shape) {
          var key = shape.get('key');

          if (this$1._shapesInArea[key]) {
            delete this$1._shapesInArea[key];
          } else {
            this$1._shapesInArea[key] = shape;
          }
        });
      } else {
        var a = Object.keys(this._shapesInArea).map(function (key) {
          return this$1._shapesInArea[key];
        });
        interestingShapes = a;
        this._shapesInArea = {};
      }

      return interestingShapes;
    };

    return BrushDelegate;
  }(InteractionDelegate); //
  //@flow-ignore


  var CenterActor = function (InteractionDelegat____1) {
    function CenterActor() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) CenterActor.__proto__ = InteractionDelegat____1;
    CenterActor.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    CenterActor.prototype.constructor = CenterActor;

    CenterActor.prototype.center = function center(state) {
      var focusedShapes = state.focusedShapes;
      var blurredShapes = state.blurredShapes;
      var focusedShape = lodash__default.first(focusedShapes);

      if (focusedShape) {
        var interactionEntity = focusedShape.getInteractionEntity();

        if (interactionEntity.get("canHover")) {
          if (interactionEntity === focusedShape) {
            this._centerShapeIfPossible(focusedShape);
          }
        }
      }

      return state;
    }; //--------------------------------------------
    // protected
    //--------------------------------------------

    /**
     * A simplified logic to compute the offset to get the shape center. Here we always assume the container either
     * the start or the end is aligned with the viewport's start or end
     *
     * (isContainerNotAtZero = false)
     *  viewport
     * \--------\
     * \---------------------\
     * container
     *
     * or
     * (isContainerNotAtZero = true)
     *              viewport
     *              \--------\
     * \---------------------\
     * container
     *
     * With this constrain, we are able to greatly simplify the logic (calculating only in the cell coordinate space)
     * @param vw
     * @param cw
     * @param bx
     * @param bw
     * @param isContainerNotAtZero
     * @returns {number}
     * @private
     */


    CenterActor.prototype._getCenterOffset1D = function _getCenterOffset1D(vw, cw, bx, bw, isContainerNotAtZero) {
      var desireOffset = bx + bw * 0.5 - vw * 0.5; // desireOffset < 0 => wanna move to right (down)
      // desireOffset > 0 => wanna move to left (up)

      return desireOffset < 0 ? isContainerNotAtZero ? Math.min(0, Math.max(vw - cw, desireOffset)) : 0 : isContainerNotAtZero ? 0 : Math.max(0, Math.min(cw - vw, desireOffset));
    };
    /**
     * Center the shape as much as possible by setting the scene's scroll offset
     * @param shape
     * @returns {IShapeNode}
     * @private
     */


    CenterActor.prototype._centerShapeIfPossible = function _centerShapeIfPossible(shape) {
      var layer = shape.getParent();
      var cell = layer && layer.getParent();
      var scene = cell && cell.getParent();

      if (scene && cell && layer) {
        var ref = cell.get();
        var w = ref.w;
        var h = ref.h;
        var scrollX = ref.scrollX;
        var scrollY = ref.scrollY;
        var transforms = scene.get("transforms");

        if (scrollX || scrollY) {
          var shapeBBox = shape.boundingBox();

          if (shapeBBox) {
            var ref$1 = cell.boundingBox();
            var cx = ref$1.x;
            var cy = ref$1.y;
            var cw = ref$1.w;
            var ch = ref$1.h;
            var ref$2 = shapeBBox.clone().offset(layer.get("x"), layer.get("y"));
            var sx = ref$2.x;
            var sy = ref$2.y;
            var sw = ref$2.w;
            var sh = ref$2.h; // apply some scrollOffsetX/Y to the scene that the shape is in the center if possible

            var scrollOffset = [!scrollX ? 0 : this._getCenterOffset1D(w, cw, sx, sw, transforms && transforms.flipX), !scrollY ? 0 : this._getCenterOffset1D(h, ch, sy, sh, transforms && transforms.flipY)];
            scene.set({
              scrollOffset: scrollOffset
            });
          }
        }
      }

      return shape;
    };

    return CenterActor;
  }(InteractionDelegate); //
  //@flow-ignore
  // Highlight
  //


  var CursorDelegate = function (InteractionDelegat____1) {
    function CursorDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) CursorDelegate.__proto__ = InteractionDelegat____1;
    CursorDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    CursorDelegate.prototype.constructor = CursorDelegate;

    CursorDelegate.prototype.update = function update(state) {
      var focusedShapes = state.focusedShapes;
      var cursorType = state.cursorType;
      var focusedShape = lodash__default.first(focusedShapes);

      if (cursorType) {
        this._sceneInteractionManagerDelegate.onCursorChange(cursorType);
      } else if (focusedShape) {
        var left;

        var scene = this._sceneInteractionManagerDelegate.getScene();

        var defaultCursorType = focusedShape.get('cursorType');
        var cursorType$1 = defaultCursorType !== constants$1.CURSOR_TYPE.DEFAULT ? defaultCursorType : this._isActionable(focusedShape) ? (left = scene && scene.get('config').dataCursor) != null ? left : constants$1.CURSOR_TYPE.POINTER : constants$1.CURSOR_TYPE.DEFAULT;

        this._sceneInteractionManagerDelegate.onCursorChange(cursorType$1 || constants$1.CURSOR_TYPE.DEFAULT);
      }

      return state;
    };

    CursorDelegate.prototype.reset = function reset(state) {
      this._sceneInteractionManagerDelegate.onCursorChange(constants$1.CURSOR_TYPE.DEFAULT);

      return state;
    };

    CursorDelegate.prototype._isActionable = function _isActionable(shape) {
      var scene = this._sceneInteractionManagerDelegate.getScene();

      var hasDataCursor = scene && scene.get('config').dataCursor != null;

      if (shape != null && scene && scene.get("selectMode") === constants$1.SELECTMODE.NONE && !hasDataCursor) {
        return false;
      }

      if (shape) {
        var shapeInteractionEntity = shape.getInteractionEntity();
        var layer = shapeInteractionEntity.getParent(); // @bug W-4168246

        return shapeInteractionEntity.get("canSelect") && layer && layer.get("canSelect") || hasDataCursor && shapeInteractionEntity.get("data") != null;
      } else {
        return false;
      }
    };

    return CursorDelegate;
  }(InteractionDelegate); //

  /**
   * Created by yi.chen on 5/31/17.
   */
  //@flow-ignore


  var INTERACTION_DELEGATE_TYPE$2 = constants$1.INTERACTION_DELEGATE_TYPE;

  var CrosshairDelegate = function (InteractionDelegat____1) {
    function CrosshairDelegate(sceneInteractionManagerDelegate) {
      InteractionDelegat____1.call(this, sceneInteractionManagerDelegate);
      this._isCrosshiarVisible = false;
    }

    if (InteractionDelegat____1) CrosshairDelegate.__proto__ = InteractionDelegat____1;
    CrosshairDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    CrosshairDelegate.prototype.constructor = CrosshairDelegate;

    CrosshairDelegate.prototype.update = function update(interactionState) {
      var ref = interactionState.pointerPosition || [];
      var x = ref[0];
      var y = ref[1];

      if (x != null && y != null && interactionState.states.indexOf(INTERACTION_DELEGATE_TYPE$2.BRUSH) === -1) {
        var crosshairLayers = this._getLayers();

        var activeCrossLayer = this._findActiveLayer(crosshairLayers, x, y);

        if (activeCrossLayer) {
          this._isCrosshiarVisible = true;

          this._onActiveLayerCrosshairMove(activeCrossLayer, x, y);
        } else {
          this._removeAllCrosshair();
        }
      }

      return interactionState;
    };

    CrosshairDelegate.prototype.reset = function reset(interactionState) {
      this._removeAllCrosshair();

      return interactionState;
    }; //--------------------------------------------
    // private
    //--------------------------------------------


    CrosshairDelegate.prototype._getLayers = function _getLayers() {
      return this._sceneInteractionManagerDelegate.getInteractionLayers(INTERACTION_DELEGATE_TYPE$2.DISCRETE_CROSSHAIR);
    };

    CrosshairDelegate.prototype._onActiveLayerCrosshairMove = function _onActiveLayerCrosshairMove(layer, x, y) {
      var ref = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition(x, y));
      var locX = ref[0];
      var locY = ref[1];
      return this._moveAllCrosshairTo(this._getLayers(), locY);
    };

    CrosshairDelegate.prototype._removeAllCrosshair = function _removeAllCrosshair() {
      var this$1 = this;

      if (this._isCrosshiarVisible) {
        this._getLayers().forEach(function (layer) {
          var crosshair = this$1._getCrosshair(layer);

          crosshair.set({
            opacity: 0
          }); //@flow-ignore

          layer.notifyShapeChanged();
        });

        this._isCrosshiarVisible = false;
        return true;
      }

      return false;
    };

    CrosshairDelegate.prototype._getCrosshair = function _getCrosshair(layer) {
      return layer.getChildren()[0];
    };

    CrosshairDelegate.prototype._isInLayer = function _isInLayer(layer, x, y) {
      return x >= 0 && x < layer.get('w') && y >= 0 && y < layer.get('h');
    };

    CrosshairDelegate.prototype._findActiveLayer = function _findActiveLayer(layers, x, y) {
      var this$1 = this;
      return lodash.find(layers, function (layer) {
        var ref = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition(x, y));
        var locX = ref[0];
        var locY = ref[1];
        return this$1._isInLayer(layer, locX, locY);
      });
    };

    CrosshairDelegate.prototype._boundingIntervalsToSegments = function _boundingIntervalsToSegments(intervals) {
      var sortedIntervals = intervals.map(function (interval) {
        return interval[0] < interval[1] ? interval : [interval[1], interval[0]];
      });

      var mergedIntervals = this._mergeIntervals(sortedIntervals.sort(function (ref, ref$1) {
        var s0 = ref[0];
        var e0 = ref[1];
        var s1 = ref$1[0];
        var e1 = ref$1[1];
        return s0 - s1;
      }));

      var segments = [];
      var start = 0;

      for (var i = 0; i < mergedIntervals.length; ++i) {
        var ref = mergedIntervals[i];
        var intStart = ref[0];
        var intEnd = ref[1];
        segments.push([start, intStart]);
        start = intEnd;
      }

      return segments;
    };

    CrosshairDelegate.prototype._boundingBoxToLocalIntervals = function _boundingBoxToLocalIntervals(decorationLayer, shapes, withXAxis) {
      if (withXAxis === void 0) withXAxis = false;
      var coordIdx = withXAxis ? 0 : 1;
      return this._boundingIntervalsToSegments(!shapes.length ? [[0, 0]] : shapes.map(function (shape) {
        var layer = shape.getParent(); //@flow-ignore

        var vertices = shape.boundingBox().toVertices().map(function (ref) {
          var x = ref[0];
          var y = ref[1];
          return layer.toScenePosition(x, y);
        }).map(function (ref) {
          var x = ref[0];
          var y = ref[1];
          return decorationLayer.toNormalizedPosition.apply(decorationLayer, decorationLayer.toLocalPosition(x, y));
        });
        return vertices[0][coordIdx] !== vertices[1][coordIdx] ? [vertices[0][coordIdx], vertices[1][coordIdx]] : [vertices[0][coordIdx], vertices[2][coordIdx]];
      }));
    };

    CrosshairDelegate.prototype._mergeIntervals = function _mergeIntervals(intervals) {
      if (intervals.length === 0) {
        return [];
      }

      var ref = intervals[intervals.length - 1];
      var lastStart = ref[0];
      var lastEnd = ref[1];

      var mergedIntervals = this._mergeIntervals(intervals.slice(0, intervals.length - 1));

      if (!mergedIntervals.length) {
        return [[lastStart, lastEnd]];
      } else {
        var ref$1 = mergedIntervals[mergedIntervals.length - 1];
        var prevStart = ref$1[0];
        var prevEnd = ref$1[1];

        if (prevEnd >= lastStart) {
          if (prevEnd < lastEnd) {
            mergedIntervals[mergedIntervals.length - 1][1] = lastEnd;
          }
        } else {
          mergedIntervals.push([lastStart, lastEnd]);
        }
      }

      return mergedIntervals;
    };

    CrosshairDelegate.prototype._moveAllCrosshairTo = function _moveAllCrosshairTo(layers, locY) {
      var this$1 = this;
      var shouldRender = false;
      layers.forEach(function (layer) {
        var crosshair = this$1._getCrosshair(layer);

        var formatter = crosshair.get('formatter');
        var scale = crosshair.get('scale');

        if (formatter && scale) {
          crosshair.set({
            y: locY,
            opacity: 1,
            text: formatter(scale.invert(locY))
          });
          layer.notifyShapeChanged();
          shouldRender = true;
        }
      });
      return shouldRender;
    };

    return CrosshairDelegate;
  }(InteractionDelegate); //

  /**
   * Created by yi.chen on 5/30/17.
   */


  var LABEL_HORIZONTAL_PADDING = 10;
  var LABEL_VERTICAL_PADDING = 2;
  var INVISIBLE_OPACITY$1 = 0.000001;

  var Crosshair = function (ShapeGroup) {
    function Crosshair(props, silent) {
      ShapeGroup.call(this, props, silent);

      this._render(this._props);
    }

    if (ShapeGroup) Crosshair.__proto__ = ShapeGroup;
    Crosshair.prototype = Object.create(ShapeGroup && ShapeGroup.prototype);
    Crosshair.prototype.constructor = Crosshair; //--------------------------------------------
    // private
    //--------------------------------------------

    Crosshair.prototype._setDefaultProps = function _setDefaultProps() {
      ShapeGroup.prototype._setDefaultProps.call(this);

      var props = this._props;
      props.key = "shapeGroup";
      props.text = "";
      props.stroke = undefined;
      props.fill = undefined;
      props.x = 0;
      props.y = 0;
      props.intervals = [];
      props.labelWidth = 0;
      props.scale = undefined;
      props.formatter = undefined;
      props.opacity = INVISIBLE_OPACITY$1;
      props.textVAlign = 'middle';
      props.textHAlign = 'center';
      props.dataGranularity = undefined;
      props.firstDayOfWeek = undefined;
    };

    Crosshair.prototype._setProp = function _setProp(prop, value, silent) {
      ShapeGroup.prototype._setProp.call(this, prop, value, silent);

      this._render(this._props);

      return this;
    };

    Crosshair.prototype._setProps = function _setProps(props, silent) {
      ShapeGroup.prototype._setProps.call(this, props, silent);

      this._render(this._props);

      return this;
    };

    Crosshair.prototype._render = function _render(props) {
      this._renderLines(props);

      this._renderLabel(props);
    };

    Crosshair.prototype._renderLabel = function _renderLabel(props) {
      if (props.text != null && props.text !== '') {
        var x = props.x;
        var y = props.y;
        var text = props.text;
        var stroke = props.stroke;
        var fill = props.fill;
        var opacity = props.opacity;
        var textHAlign = props.textHAlign;
        var textVAlign = props.textVAlign;

        if (!this._label) {
          this._label = new Text$1({
            key: 'crosshair-text'
          });
          this.append(this._label);
        }

        this._label.set({
          text: text,
          x: x,
          y: y,
          bgColor: fill,
          padding: new Padding({
            top: LABEL_VERTICAL_PADDING,
            right: LABEL_HORIZONTAL_PADDING,
            bottom: LABEL_VERTICAL_PADDING,
            left: LABEL_HORIZONTAL_PADDING
          }),
          stroke: stroke,
          halign: textHAlign,
          valign: textVAlign,
          vertical: false,
          fixedOrientation: true,
          includeAscender: false,
          opacity: opacity
        });
      }

      return this._label;
    };

    Crosshair.prototype._updateLineNumber = function _updateLineNumber(nLines) {
      var this$1 = this;
      var currentLines = this._lines.length;

      if (currentLines !== nLines) {
        if (currentLines < nLines) {
          for (var i = 0; i < nLines - currentLines; i++) {
            var line = new Line$2({
              key: "crosshair-line-" + (i + currentLines)
            });

            this$1._lines.push(line);

            this$1.append(line);
          }
        } else {
          var removedLines = this._lines.splice(nLines, currentLines - nLines);

          removedLines.forEach(function (l) {
            this$1.remove(l);
          });
        }
      }
    };

    Crosshair.prototype._renderLines = function _renderLines(props) {
      var x = props.x;
      var y = props.y;
      var intervals = props.intervals;
      var fill = props.fill;
      var opacity = props.opacity;

      if (!this._lines) {
        this._lines = [];
      }

      this._updateLineNumber(intervals.length);

      this._lines.forEach(function (line, i) {
        var ref = intervals[i];
        var start = ref[0];
        var end = ref[1];
        line.set({
          stroke: fill,
          opacity: opacity,
          vertical: false,
          x0: start,
          y0: y,
          x1: end,
          y1: y
        });
      });

      return this._lines;
    };

    return Crosshair;
  }(ShapeGroup$2);

  Crosshair.type = "ShapeGroup"; //

  /**
   * Created by yi.chen on 6/6/17.
   */
  //@flow-ignore

  var DiscreteCrosshairDelegate = function (CrosshairDelegat____1) {
    function DiscreteCrosshairDelegate(sceneInteractionManagerDelegate) {
      CrosshairDelegat____1.call(this, sceneInteractionManagerDelegate);
      this._decoratedShapes = [];
      this._closestShape = null;
    }

    if (CrosshairDelegat____1) DiscreteCrosshairDelegate.__proto__ = CrosshairDelegat____1;
    DiscreteCrosshairDelegate.prototype = Object.create(CrosshairDelegat____1 && CrosshairDelegat____1.prototype);
    DiscreteCrosshairDelegate.prototype.constructor = DiscreteCrosshairDelegate; //--------------------------------------------
    // private
    //--------------------------------------------

    DiscreteCrosshairDelegate.prototype.update = function update(interactionState) {
      CrosshairDelegat____1.prototype.update.call(this, interactionState);
      return lodash__default.extend(interactionState, {
        focusedShapes: [this._closestShape]
      });
    };

    DiscreteCrosshairDelegate.prototype._onActiveLayerCrosshairMove = function _onActiveLayerCrosshairMove(layer, x, y) {
      var ref = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition(x, y));
      var locX = ref[0];
      var locY = ref[1];

      var shouldRenderCrosshair = this._moveAllCrosshairTo(this._getLayers(), locY);

      this._hoverClosestShape(this._decoratedShapes, x, y);

      return shouldRenderCrosshair;
    };

    DiscreteCrosshairDelegate.prototype._removeAllCrosshair = function _removeAllCrosshair() {
      this._updateDecoratedShapes([]);

      this._closestShape = null;
      return CrosshairDelegat____1.prototype._removeAllCrosshair.call(this);
    };

    DiscreteCrosshairDelegate.prototype._getContainers = function _getContainers(layer) {
      var this$1 = this;
      return layer.get('refContainerKeys').map(function (key) {
        var ref = key.split('&');
        var cellKey = ref[0];
        var layerKey = ref[1];

        var scene = this$1._sceneInteractionManagerDelegate.getScene();

        var found = scene && scene.find({
          key: layerKey
        });
        return found && found.length && found[0];
      }).filter(function (x) {
        return x;
      });
    };

    DiscreteCrosshairDelegate.prototype._getCrossedShapes = function _getCrossedShapes(layer, x0, y0, x1, y1) {
      var containers = this._getContainers(layer);

      return containers.reduce(function (shapes, layer) {
        var ref = layer.toLocalPosition(x0, y0);
        var lx0 = ref[0];
        var ly0 = ref[1];
        var ref$1 = layer.toLocalPosition(x1, y1);
        var lx1 = ref$1[0];
        var ly1 = ref$1[1];
        return shapes.concat(layer.findShapeUnderLine(lx0, ly0, lx1, ly1).filter(function (shape) {
          return shape.get('canSelect');
        }));
      }, []);
    };

    DiscreteCrosshairDelegate.prototype._updateDecoratedShapes = function _updateDecoratedShapes(newShapes) {
      this._decoratedShapes.forEach(function (s) {
        return s.uncross();
      });

      this._decoratedShapes = newShapes.map(function (s) {
        return s.cross();
      });
      return this._decoratedShapes;
    };

    DiscreteCrosshairDelegate.prototype._getCrosshairPositionLabel = function _getCrosshairPositionLabel(yValue, crosshair) {
      var scale = crosshair.get('scale');
      var formatter = crosshair.get('formatter');
      var dest = scale.invert(yValue);
      var destPos = scale.scale(dest);
      return {
        position: destPos,
        label: formatter(dest)
      };
    };

    DiscreteCrosshairDelegate.prototype._centerOfShape = function _centerOfShape(shape) {
      var layer = shape.getParent(); //@flow-ignore

      var ref = shape.boundingBox();
      var x = ref.x;
      var y = ref.y;
      var w = ref.w;
      var h = ref.h;
      return layer ? layer.toScenePosition(x + w / 2, y + h / 2) : [x + w / 2, y + h / 2];
    };

    DiscreteCrosshairDelegate.prototype._hoverClosestShape = function _hoverClosestShape(crossedShapes, x, y) {
      var this$1 = this;

      if (this._closestShape) {
        this._closestShape.restoreHoverArea();
      }

      if (crossedShapes.length) {
        var closestShape = crossedShapes[0];

        var ref = this._centerOfShape(closestShape);

        var cx = ref[0];
        var cy = ref[1];
        var minDis = (cx - x) * (cx - x) + (cy - y) * (cy - y);

        for (var i = 1; i < crossedShapes.length; ++i) {
          var shape = crossedShapes[i];

          var ref$1 = this$1._centerOfShape(shape);

          var mx = ref$1[0];
          var my = ref$1[1];
          var dis = (mx - x) * (mx - x) + (my - y) * (my - y);

          if (dis < minDis) {
            closestShape = shape;
            minDis = dis;
          }
        }

        this._closestShape = closestShape;

        this._closestShape.extendHoverArea();
      }
    };

    DiscreteCrosshairDelegate.prototype._moveAllCrosshairTo = function _moveAllCrosshairTo(layers, locY) {
      var this$1 = this;
      var shouldRender = false;
      var newShapesCollection = [];
      var hasChanges = false;
      layers.forEach(function (layer) {
        var crosshair = this$1._getCrosshair(layer);

        var ref = this$1._getCrosshairPositionLabel(locY, crosshair);

        var position = ref.position;
        var label = ref.label;

        if (position !== crosshair.get('y') || crosshair.get('opacity') === 0) {
          hasChanges = true;
          var ref$1 = layer.toScenePosition.apply(layer, layer.toTransformedPosition(crosshair.get('x'), position));
          var lx0 = ref$1[0];
          var ly0 = ref$1[1];
          var ref$2 = layer.toScenePosition.apply(layer, layer.toTransformedPosition(crosshair.get('x') + layer.get('w'), position));
          var lx1 = ref$2[0];
          var ly1 = ref$2[1];

          var crossedShapes = this$1._getCrossedShapes(layer, lx0, ly0, lx1, ly1);

          var intervals = this$1._boundingBoxToLocalIntervals(layer, crossedShapes, true);

          crosshair.set({
            intervals: intervals,
            y: position,
            opacity: 1,
            text: label
          });
          newShapesCollection = newShapesCollection.concat(crossedShapes);
          layer.notifyShapeChanged();
          shouldRender = true;
        }
      });

      if (hasChanges) {
        this._updateDecoratedShapes(newShapesCollection);
      }

      return shouldRender;
    };

    return DiscreteCrosshairDelegate;
  }(CrosshairDelegate); //
  //@flow-ignore
  // Highlight
  //


  var EventDelegate = function (InteractionDelegat____1) {
    function EventDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) EventDelegate.__proto__ = InteractionDelegat____1;
    EventDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    EventDelegate.prototype.constructor = EventDelegate;

    EventDelegate.prototype.clickEvent = function clickEvent(state) {
      var pointerPosition = state.pointerPosition;
      var focusedShapes = state.focusedShapes;
      var hotSpot = state.hotSpot;
      var activeKeys = state.activeKeys;
      var nativeEvent = state.nativeEvent;

      if (pointerPosition) {
        this._sceneInteractionManagerDelegate.onEvent(constants$1.EVENT_NAME.MOUSE_CLICK, {
          x: pointerPosition[0],
          y: pointerPosition[1],
          shape: lodash__default.first(focusedShapes),
          hotSpot: hotSpot,
          metaKey: activeKeys && activeKeys.indexOf('Meta') >= 0,
          ctrlKey: activeKeys && activeKeys.indexOf('Control') >= 0,
          nativeEvent: nativeEvent
        });
      }

      return state;
    };

    return EventDelegate;
  }(InteractionDelegate); //
  //@flow-ignore
  // Highlight
  //


  var HighlightDelegate = function (InteractionDelegat____1) {
    function HighlightDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) HighlightDelegate.__proto__ = InteractionDelegat____1;
    HighlightDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    HighlightDelegate.prototype.constructor = HighlightDelegate;

    HighlightDelegate.prototype.update = function update(state) {
      var focusedShapes = state.focusedShapes;
      var blurredShapes = state.blurredShapes;
      var states = state.states;
      var focusedShape = lodash__default.first(focusedShapes);
      var blurredShape = lodash__default.first(blurredShapes);

      if (states.indexOf(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH) < 0) {
        if (focusedShape) {
          this._perform(focusedShape, true);
        }

        if (blurredShape) {
          this._perform(blurredShape, false);
        }
      }

      return state;
    };

    HighlightDelegate.prototype._perform = function _perform(shape, isHover) {
      if (isHover === void 0) isHover = true;
      var interactionEntity = shape.getInteractionEntity();

      if (interactionEntity.get("canHover")) {
        if (this._sceneInteractionManagerDelegate.getInteractionLayers(constants$1.INTERACTION_DELEGATE_TYPE.HIGHLIGHT).some(function (l) {
          return l === interactionEntity.getParent();
        })) {
          if (isHover) {
            interactionEntity.hover();
          } else {
            interactionEntity.unhover();
          }
        }
      }
    };

    return HighlightDelegate;
  }(InteractionDelegate); //

  /**
   * Created by yi.chen on 2/6/17.
   */
  //@flow-ignore


  var RangeDelegate = function (BrushDelegat____1) {
    function RangeDelegate() {
      BrushDelegat____1.apply(this, arguments);
    }

    if (BrushDelegat____1) RangeDelegate.__proto__ = BrushDelegat____1;
    RangeDelegate.prototype = Object.create(BrushDelegat____1 && BrushDelegat____1.prototype);
    RangeDelegate.prototype.constructor = RangeDelegate;

    RangeDelegate.prototype.updateWithTrace = function updateWithTrace(state) {
      var pointerPosition = state.pointerPosition;
      var pointerTrace = state.pointerTrace;
      var states = state.states;

      if (pointerTrace && pointerTrace.length > 1) {
        var start = lodash__default.first(pointerTrace);
        var end = lodash__default.last(pointerTrace);

        var layer = this._getBrushLayerAt(start[0], start[1]);

        if (layer) {
          var lStartPosition = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition.apply(layer, start));
          var lEndPosition = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition.apply(layer, end));
          this._control = this._control == null ? layer.getControl.apply(layer, lStartPosition) : this._control;

          switch (this._control) {
            case 0:
              // move
              var lPreviousPosition = layer.toNormalizedPosition.apply(layer, layer.toLocalPosition.apply(layer, pointerTrace[pointerTrace.length - 2]));

              this._onMoving(layer, lPreviousPosition, lEndPosition);

              return lodash__default.extend({}, state, {
                cursorType: constants$1.CURSOR_TYPE.POINTER,
                states: states.concat(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH)
              });

            case 1: // resize

            case 2:
              this._onResizing(layer, this._control, lEndPosition);

              return lodash__default.extend({}, state, {
                cursorType: constants$1.CURSOR_TYPE.EW_RESIZE,
                states: states.concat(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH)
              });

            default:
              this._onDragSelecting(layer, lStartPosition, lEndPosition);

              return lodash__default.extend({}, state, {
                cursorType: constants$1.CURSOR_TYPE.POINTER,
                states: states.concat(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH)
              });
          }
        }
      }

      return state;
    };

    RangeDelegate.prototype.updateWithSelection = function updateWithSelection(state) {
      var this$1 = this;
      var selectionInfo = state.selectionInfo;

      if (selectionInfo && selectionInfo.isRange) {
        var ref = selectionInfo.keys;
        var startValue = ref[0];
        var endValue = ref[1];

        this._getBrushLayers().forEach(function (layer) {
          var startStep = layer.getBrushStepBySelectionValue(startValue);
          var endStep = layer.getBrushStepBySelectionValue(endValue);

          if (startStep.index > 0 && endStep.index > 0) {
            layer.setBrushCaptionText(this$1._formatCaptionText(layer.getRangeLabels()));
            layer.brushSelect(0, startStep.position, layer.get('w'), endStep.position - startStep.position + 1);
            this$1._nSteps = endStep.index - startStep.index + 1;
          }
        });
      }

      return state;
    };

    RangeDelegate.prototype.release = function release(state) {
      var pointerPosition = state.pointerPosition;

      if (pointerPosition) {
        var layer = (ref = this)._getBrushLayerAt.apply(ref, pointerPosition);

        if (layer) {
          var range = this._onRelease(layer);

          this._getBrushLayers().forEach(function (layer) {
            layer.hideBrushCaptionText();
            layer.snapToSteps();
          });

          if (range) {
            return lodash__default.extend({}, state, {
              focusedShapes: null,
              selectionInfo: {
                keys: range,
                isSelect: true,
                isRange: true
              }
            });
          }
        }
      }

      return state;
      var ref;
    };

    RangeDelegate.prototype.reset = function reset(state) {
      this._resetBrush();

      this._control = null;
      return lodash__default.extend({}, state, {
        focusedShapes: null,
        selectionInfo: {
          keys: [],
          isSelect: true,
          isRange: true
        }
      });
    }; //--------------------------------------------
    // private
    //--------------------------------------------

    /**
     * Remove the brush for the current brush layer
     * @private
     */


    RangeDelegate.prototype._resetBrush = function _resetBrush() {
      this._nSteps = -1;

      this._getBrushLayers().forEach(function (layer) {
        layer.removeBrush();
      });
    };
    /**
     * apply the selection range to all the brush layers
     * @param x
     * @param y
     * @param w
     * @param h
     * @private
     */


    RangeDelegate.prototype._brushSelectAllLayers = function _brushSelectAllLayers(x, y, w, h) {
      var this$1 = this;

      this._getBrushLayers().forEach(function (layer) {
        layer.setBrushCaptionText(this$1._formatCaptionText(layer.getRangeLabels()));
        var updatedShapes = layer.brushSelect(x, y, w, h);
      });
    };

    RangeDelegate.prototype._onDragSelecting = function _onDragSelecting(layer, ref, ref$1) {
      var lsx = ref[0];
      var lsy = ref[1];
      var lex = ref$1[0];
      var ley = ref$1[1];

      if (lsx !== lex || lsy !== ley) {
        this._brushSelectAllLayers(0, lsy, layer.get('w'), ley - lsy + 1);
      }
    };

    RangeDelegate.prototype._onResizing = function _onResizing(layer, control, ref) {
      var lex = ref[0];
      var ley = ref[1];
      var brushArea = layer.getBrushArea();

      if (brushArea) {
        var x0 = brushArea.x0;
        var y0 = brushArea.y0;
        var x1 = brushArea.x1;
        var y1 = brushArea.y1;

        if (control === 1) {
          if (ley > y1) {
            this._control = 2;

            this._brushSelectAllLayers(x0, y1, x1 - x0 + 1, 0);
          } else {
            this._brushSelectAllLayers(x0, ley, x1 - x0 + 1, y1 - ley + 1);
          }
        } else if (control === 2) {
          if (ley < y0) {
            this._control = 1;

            this._brushSelectAllLayers(x0, y0, x1 - x0 + 1, 0);
          } else {
            this._brushSelectAllLayers(x0, y0, x1 - x0 + 1, ley - y0 + 1);
          }
        }
      }
    };

    RangeDelegate.prototype._adjustArea = function _adjustArea(layer, x, y, w, h) {
      var layerWidth = layer.get('w');
      var layerHeight = layer.get('h');

      var xOverflow = this._getOverflow(0, layerWidth, x) || this._getOverflow(0, layerWidth, x + w - 1);

      var yOverflow = this._getOverflow(0, layerHeight, y) || this._getOverflow(0, layerHeight, y + h - 1);

      return {
        x: x - xOverflow,
        y: y - yOverflow,
        w: w,
        h: h
      };
    };

    RangeDelegate.prototype._getOverflow = function _getOverflow(origin, size, target) {
      var head = origin,
          tail = origin + size - 1;
      var min = Math.min(head, tail);
      var max = Math.max(head, tail);
      return target - (target < min ? min : target > max ? max : target);
    };

    RangeDelegate.prototype._onMoving = function _onMoving(layer, ref, ref$1) {
      var lsx = ref[0];
      var lsy = ref[1];
      var lex = ref$1[0];
      var ley = ref$1[1];
      var brushArea = layer && layer.getBrushArea();

      if (brushArea) {
        var x0 = brushArea.x0;
        var y0 = brushArea.y0;
        var x1 = brushArea.x1;
        var y1 = brushArea.y1;
        var ref$2 = [lex - lsx, ley - lsy];
        var ty = ref$2[1];
        var rangeStartStep = layer.getBrushStepByPosition(y0 + ty);
        var rangeEndStep = layer.getBrushStepByIndex(rangeStartStep.index + this._nSteps - 1);

        var ref$3 = this._adjustArea(layer, x0, y0 + ty, x1 - x0 + 1, rangeEndStep.position - rangeStartStep.position + 1);

        var _x = ref$3.x;
        var _y = ref$3.y;
        var _w = ref$3.w;
        var _h = ref$3.h;

        this._brushSelectAllLayers(_x, _y, _w, _h);
      }
    };

    RangeDelegate.prototype._onRelease = function _onRelease(layer) {
      var ref = layer.snapToSteps();
      var startStep = ref[0];
      var endStep = ref[1];

      if (startStep && endStep) {
        this._control = null;
        this._nSteps = endStep.index - startStep.index + 1;
        return [startStep.selectionValue, endStep.selectionValue];
      } else {
        return [];
      }
    };

    RangeDelegate.prototype._formatCaptionText = function _formatCaptionText(labels) {
      var text = "";

      if (labels.length === 2) {
        text = labels[0] + " – " + labels[1];
      }

      return text;
    };

    return RangeDelegate;
  }(BrushDelegate);

  var SelectManager = function (FS____1) {
    function SelectManager(layer, states) {
      var this$1 = this;
      FS____1.call(this, {
        initial: "NONE",
        states: states,
        events: {
          select: {
            afterTransition: function afterTransition(keys) {
              return keys.map(function (key) {
                return this$1.select(key);
              });
            }
          },
          selectExclusive: {
            afterTransition: function afterTransition(keys) {
              return keys.map(function (key) {
                return this$1.select(key);
              });
            }
          },
          unselect: {
            beforeTransition: function beforeTransition(keys) {
              return keys.map(function (key) {
                return this$1.unselect(key);
              });
            }
          }
        }
      });
      this.layer = layer;
      this.selection = [];
    }

    if (FS____1) SelectManager.__proto__ = FS____1;
    SelectManager.prototype = Object.create(FS____1 && FS____1.prototype);
    SelectManager.prototype.constructor = SelectManager;

    SelectManager.prototype.resetAll = function resetAll() {
      this.selection = [];

      if (this.layer) {
        this.layer.getChildren().forEach(function (shape) {
          if (shape.get("canSelect")) {
            shape.resetSelect();
          }
        });
      }
    };

    SelectManager.prototype.unselectAll = function unselectAll() {
      this.selection = [];

      if (this.layer) {
        this.layer.getChildren().forEach(function (shape) {
          if (shape.get("canSelect")) {
            shape.unselect();
          }
        });
      }
    };

    SelectManager.prototype.unselect = function unselect(key) {
      var i = this.selection.indexOf(key);

      if (i > -1) {
        this.selection.splice(i, 1);
      }

      if (this.layer) {
        var shape = this.layer.shapeByKey(key);

        if (shape) {
          shape.unselect();
        }
      }
    };

    SelectManager.prototype.select = function select(key) {
      if (this.layer) {
        var shape = this.layer.shapeByKey(key);

        if (shape) {
          shape.select();
        }
      }

      this.selection.push(key);
    };

    SelectManager.prototype.setSelection = function setSelection(selection) {
      selection = this.sanitizeSelection(selection);
      this.transition("NONE");

      if (selection.length) {
        this.onEvent("select", selection);
      }
    }; // sanitize selection according to select mode, override
    // in subclass
    //
    // @param keys {Array} selection


    SelectManager.prototype.sanitizeSelection = function sanitizeSelection(keys, isSingleMode) {
      if (isSingleMode == null) {
        isSingleMode = false;
      }

      if (isSingleMode && keys.length > 1) {
        return [keys[0]];
      } else {
        return keys;
      }
    };

    return SelectManager;
  }(FSM);

  var MultiRequiredSelectManager = function (SelectManage____1) {
    function MultiRequiredSelectManager(layer) {
      var this$1 = this;
      SelectManage____1.call(this, layer, {
        NONE: {
          onEnter: function onEnter() {
            return this$1.resetAll();
          },
          onLeave: function onLeave() {
            return this$1.unselectAll();
          },
          events: {
            select: "SOME",
            selectExclusive: "SOME"
          }
        },
        SOME: {
          onEnter: function onEnter(from, e, keys) {
            if (e === "unselect" && this$1.selection.length === 0) {
              return keys.map(function (key) {
                return this$1.select(key);
              });
            }
          },
          events: {
            unselect: "SOME",
            select: "SOME",
            selectExclusive: "SOME"
          }
        }
      });
    }

    if (SelectManage____1) MultiRequiredSelectManager.__proto__ = SelectManage____1;
    MultiRequiredSelectManager.prototype = Object.create(SelectManage____1 && SelectManage____1.prototype);
    MultiRequiredSelectManager.prototype.constructor = MultiRequiredSelectManager; // Sanitize selection when including keys which do not
    // have corresponding shapes on layer
    //
    // @param keys {Array} selection

    MultiRequiredSelectManager.prototype.sanitizeSelection = function sanitizeSelection(keys) {
      return SelectManage____1.prototype.sanitizeSelection.call(this, keys, false);
    };

    return MultiRequiredSelectManager;
  }(SelectManager);

  var MultiSelectManager = function (SelectManage____1) {
    function MultiSelectManager(layer) {
      var this$1 = this;
      SelectManage____1.call(this, layer, {
        NONE: {
          onEnter: function onEnter() {
            return this$1.resetAll();
          },
          onLeave: function onLeave() {
            return this$1.unselectAll();
          },
          events: {
            select: "SOME",
            selectExclusive: "SOME"
          }
        },
        SOME: {
          onEnter: function onEnter(from, e) {
            if (e === constants$1.SELECT_ACTION.UNSELECT && this$1.selection.length === 0) {
              return this$1.transition("NONE");
            } else if (e == constants$1.SELECT_ACTION.SELECT_EXCLUSIVE) {
              lodash__default.clone(this$1.selection).forEach(function (selection) {
                return this$1.unselect(selection);
              });
            }
          },
          events: {
            unselect: "SOME",
            select: "SOME",
            selectExclusive: "SOME",
            reset: "NONE"
          }
        }
      });
    }

    if (SelectManage____1) MultiSelectManager.__proto__ = SelectManage____1;
    MultiSelectManager.prototype = Object.create(SelectManage____1 && SelectManage____1.prototype);
    MultiSelectManager.prototype.constructor = MultiSelectManager; // Sanitize selection when including keys which do not
    // have corresponding shapes on layer
    //
    // @param keys {Array} selection

    MultiSelectManager.prototype.sanitizeSelection = function sanitizeSelection(keys) {
      return SelectManage____1.prototype.sanitizeSelection.call(this, keys, false);
    };

    return MultiSelectManager;
  }(SelectManager);

  var SingleRequiredSelectManager = function (SelectManage____1) {
    function SingleRequiredSelectManager(layer) {
      var this$1 = this;
      SelectManage____1.call(this, layer, {
        NONE: {
          onEnter: function onEnter() {
            return this$1.resetAll();
          },
          onLeave: function onLeave() {
            return this$1.unselectAll();
          },
          events: {
            select: "FIRST",
            selectExclusive: "FIRST"
          }
        },
        FIRST: {
          events: {
            select: "ONE",
            selectExclusive: "ONE"
          }
        },
        ONE: {
          onEnter: function onEnter() {
            return this$1.unselect(this$1.selection[0]);
          },
          events: {
            select: "ONE",
            selectExclusive: "ONE"
          }
        }
      });
    }

    if (SelectManage____1) SingleRequiredSelectManager.__proto__ = SelectManage____1;
    SingleRequiredSelectManager.prototype = Object.create(SelectManage____1 && SelectManage____1.prototype);
    SingleRequiredSelectManager.prototype.constructor = SingleRequiredSelectManager;

    SingleRequiredSelectManager.prototype.sanitizeSelection = function sanitizeSelection(keys) {
      return SelectManage____1.prototype.sanitizeSelection.call(this, keys, true);
    };

    return SingleRequiredSelectManager;
  }(SelectManager);

  var SingleSelectManager = function (SelectManage____1) {
    function SingleSelectManager(layer) {
      var this$1 = this;
      SelectManage____1.call(this, layer, {
        NONE: {
          onEnter: function onEnter() {
            return this$1.resetAll();
          },
          onLeave: function onLeave() {
            return this$1.unselectAll();
          },
          events: {
            select: "FIRST",
            selectExclusive: "FIRST"
          }
        },
        FIRST: {
          events: {
            select: "ONE",
            selectExclusive: "ONE",
            unselect: "NONE",
            reset: "NONE"
          }
        },
        ONE: {
          onEnter: function onEnter() {
            return this$1.unselect(this$1.selection[0]);
          },
          events: {
            select: "ONE",
            selectExclusive: "ONE",
            unselect: "NONE",
            reset: "NONE"
          }
        }
      });
    }

    if (SelectManage____1) SingleSelectManager.__proto__ = SelectManage____1;
    SingleSelectManager.prototype = Object.create(SelectManage____1 && SelectManage____1.prototype);
    SingleSelectManager.prototype.constructor = SingleSelectManager; // Sanitize selection when having more than one key, or including
    // keys which do not have corresponding shapes on layer
    //
    // @param keys {Array} selection

    SingleSelectManager.prototype.sanitizeSelection = function sanitizeSelection(keys) {
      return SelectManage____1.prototype.sanitizeSelection.call(this, keys, true);
    };

    return SingleSelectManager;
  }(SelectManager);

  var SELECT_ACTION = constants$1.SELECT_ACTION; // Selection
  //
  // Selection interaction. Responds to mouseClick event of the chart.
  // Also expose setSelection, getSelection, onLegendSelect and onLegendUnselect
  // when selection can be changed programatically.
  //
  // - has four mode
  //   - single: can only select single value
  //   - single_required: can only select single value and selection is required
  //   - multi: can select multiple values
  //   - multi_required: can select multiple values and selection is required
  // - mode is defined by the chart's selectMode
  // - sync selection between chart and legend
  // - use a finite state machine internally to manage selection state
  //

  /*::(x: SelectionDelegate) => (x: ISelectionDelegate)*/

  var SelectionDelegate = function (InteractionDelegat____1) {
    function SelectionDelegate(sceneInteractionDelegate) {
      InteractionDelegat____1.call(this, sceneInteractionDelegate); // selectMode

      this.mode = sceneInteractionDelegate.getScene().get("selectMode");
      this.selectMgrByLayer = {};

      this._setupManagers(this._getLayers());
    }

    if (InteractionDelegat____1) SelectionDelegate.__proto__ = InteractionDelegat____1;
    SelectionDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    SelectionDelegate.prototype.constructor = SelectionDelegate;

    SelectionDelegate.initClass = function initClass() {
      this.prototype.type = "selection";
      this.prototype.selectMgrByLayer = null;
    };

    SelectionDelegate.prototype._getLayers = function _getLayers() {
      return this._sceneInteractionManagerDelegate.getInteractionLayers(constants$1.INTERACTION_DELEGATE_TYPE.SELECTION);
    };

    SelectionDelegate.prototype._setupManagers = function _setupManagers(layers) {
      var this$1 = this;
      layers.forEach(function (layer) {
        var manager;

        switch (this$1.mode) {
          case constants$1.SELECTMODE.RANGE:
          case constants$1.SELECTMODE.SINGLE:
            manager = new SingleSelectManager(layer);
            break;

          case constants$1.SELECTMODE.SINGLE_REQUIRED:
            manager = new SingleRequiredSelectManager(layer);
            break;

          case constants$1.SELECTMODE.MULTI:
            manager = new MultiSelectManager(layer);
            break;

          case constants$1.SELECTMODE.MULTI_REQUIRED:
            manager = new MultiRequiredSelectManager(layer);
            break;
          //	todo add default
        }

        this$1.selectMgrByLayer[layer.key] = manager;
      });
    };

    SelectionDelegate.prototype.selectRange = function selectRange(state) {
      var selectionInfo = state.selectionInfo;

      if (selectionInfo) {
        var keys = selectionInfo.keys;

        this._sceneInteractionManagerDelegate.onSelect(SELECT_ACTION.SELECT, null, keys);
      }

      return lodash__default.extend({}, state, {
        selectionInfo: {
          keys: this.getSelection()
        }
      });
    };

    SelectionDelegate.prototype.selectShapes = function selectShapes(state) {
      var this$1 = this;
      var focusedShapes = state.focusedShapes;
      var hotSpot = state.hotSpot;
      var activeKeys = state.activeKeys;

      if (focusedShapes && !hotSpot) {
        focusedShapes.forEach(function (shape) {
          if (!shape) {
            var action = constants$1.SELECT_ACTION.RESET;

            this$1._delegateToSelectMgr(action);

            this$1._invokeSceneCallback();

            this$1._sceneInteractionManagerDelegate.onSelect(action, undefined, this$1.getSelection());
          } else {
            this$1._selectShape(shape, activeKeys && activeKeys.indexOf(constants$1.KEYBOARD_KEY.SHIFT) >= 0);
          }
        });
      }

      return lodash__default.extend({}, state, {
        selectionInfo: {
          keys: this.getSelection()
        }
      });
    };

    SelectionDelegate.prototype.selectKeys = function selectKeys(state) {
      var selectionInfo = state.selectionInfo;

      if (selectionInfo) {
        var keys = selectionInfo.keys;
        this.setSelection(keys);
      }

      return lodash__default.extend({}, state, {
        selectionInfo: {
          keys: this.getSelection()
        }
      });
    };

    SelectionDelegate.prototype._selectShape = function _selectShape(shape, disbleExclusiveMode) {
      if (disbleExclusiveMode === void 0) disbleExclusiveMode = true;
      shape = shape.getInteractionEntity();
      var layer = shape.getParent(); // click on shape on non-selection layer

      if (!dataUtils.includes(this._getLayers(), layer)) {
        return false;
      } // click on shape which can not be selected


      if (!shape.get("canSelect")) {
        return false;
      } // select/unselect the shape


      var action = shape.isSelected() ? constants$1.SELECT_ACTION.UNSELECT : constants$1.SELECT_ACTION.SELECT;

      if (!disbleExclusiveMode && action === constants$1.SELECT_ACTION.SELECT && this._isSelectModeExclusive(shape)) {
        action = constants$1.SELECT_ACTION.SELECT_EXCLUSIVE;
      }

      this._delegateToSelectMgr(action, shape.get("selectionKeys") ? shape.get("selectionKeys") : [shape.key]); // if select/unselect action is done, under required mode, sometimes unselect will be ignored


      var isActionDone = (action === constants$1.SELECT_ACTION.SELECT || action === constants$1.SELECT_ACTION.SELECT_EXCLUSIVE) && shape.isSelected() || action === constants$1.SELECT_ACTION.UNSELECT && !shape.isSelected();

      if (!isActionDone) {
        return false;
      }

      this._invokeSceneCallback();

      this._sceneInteractionManagerDelegate.onSelect(action, shape != null ? shape.key : undefined, this.getSelection());

      return true;
    }; // this will invoke the scene level callback registered when the selection changes.
    //
    // Note that the rest of the code will properly handle updating the selected rows
    // in the rowsSelector and fire the selection events, etc...
    // Here we are just concerned about invoking callback registered with the scene
    // *before* the chart gets rendered (so the callback has a chance to modify the scene)


    SelectionDelegate.prototype._invokeSceneCallback = function _invokeSceneCallback() {
      var scene = this._sceneInteractionManagerDelegate.getScene();

      if (scene && scene.onSelectionChanged) {
        scene.onSelectionChanged(this.getSelection());
      }
    };

    SelectionDelegate.prototype._delegateToSelectMgr = function _delegateToSelectMgr(action, shapeKeys) {
      var this$1 = this;

      for (var key in this$1.selectMgrByLayer) {
        var layerSelecMgr = this$1.selectMgrByLayer[key];
        layerSelecMgr.onEvent(action, shapeKeys);
        layerSelecMgr.selection.sort();
      }
    };

    SelectionDelegate.prototype._isSelectModeExclusive = function _isSelectModeExclusive(shape) {
      while (shape.getParent() != null) {
        shape = shape.getParent();
      }

      var config = shape.get("config");
      return config ? config.selectModeExclusive : false;
    }; // override the current selection state
    // for all layers associated, select all shapes with keys present in
    // selection arary passed in, unselect all others. if selection is empty
    // array, reset selection for all layers.
    // - update legend selection unless opts.skipLegendUpdate,
    //
    // @param selection {Array} array of shape keys
    //
    // note: this is called when manually setting selection on chart


    SelectionDelegate.prototype.setSelection = function setSelection(selection) {
      var this$1 = this;
      selection.sort();

      for (var key in this$1.selectMgrByLayer) {
        var selectMgr = this$1.selectMgrByLayer[key];
        selectMgr.setSelection(selection);
      }

      this._invokeSceneCallback();
    };

    SelectionDelegate.prototype.getSelection = function getSelection() {
      var layers = this._getLayers();

      if (layers && layers.length) {
        var manager = this.selectMgrByLayer[lodash__default.first(this._getLayers()).key];
        return manager && manager.selection || [];
      } else {
        return [];
      }
    }; // note: this is called when clicking on legend


    SelectionDelegate.prototype.select = function select(selection) {
      if (selection != null) {
        this._delegateToSelectMgr(constants$1.SELECT_ACTION.SELECT, selection);

        this._invokeSceneCallback();
      }
    }; // note: this is called when clicking on legend


    SelectionDelegate.prototype.unselect = function unselect(selection) {
      if (selection != null) {
        this._delegateToSelectMgr(constants$1.SELECT_ACTION.UNSELECT, selection);

        this._invokeSceneCallback();
      }
    };

    return SelectionDelegate;
  }(InteractionDelegate); //

  /**
   * Created by yi.chen on 6/6/17.
   */
  //@flow-ignore


  var INTERACTION_DELEGATE_TYPE$3 = constants$1.INTERACTION_DELEGATE_TYPE;

  var TimeCrosshairDelegate = function (DiscreteCrosshairDelegat____1) {
    function TimeCrosshairDelegate() {
      DiscreteCrosshairDelegat____1.apply(this, arguments);
    }

    if (DiscreteCrosshairDelegat____1) TimeCrosshairDelegate.__proto__ = DiscreteCrosshairDelegat____1;
    TimeCrosshairDelegate.prototype = Object.create(DiscreteCrosshairDelegat____1 && DiscreteCrosshairDelegat____1.prototype);
    TimeCrosshairDelegate.prototype.constructor = TimeCrosshairDelegate;

    TimeCrosshairDelegate.prototype._getLayers = function _getLayers() {
      return this._sceneInteractionManagerDelegate.getInteractionLayers(INTERACTION_DELEGATE_TYPE$3.TIME_CROSSHAIR);
    };

    TimeCrosshairDelegate.prototype._getCrosshairPositionLabel = function _getCrosshairPositionLabel(target, crosshair) {
      var scale = crosshair.get('scale');
      var formatter = crosshair.get('formatter');
      var dataGranularity = crosshair.get('dataGranularity') || 'month';
      var targetTime = scale.invert(target);
      var last, next;

      if (dataGranularity == constants$1.TIME_GRANULARITY.SFDC_WEEK) {
        var firstDayOfWeek = crosshair.get('firstDayOfWeek');
        last = sfdcWeek.startOf(targetTime, firstDayOfWeek).valueOf();
        next = sfdcWeek.offset(last, 1, firstDayOfWeek).valueOf();
      } else {
        last = luxon.DateTime.fromMillis(targetTime).startOf(dataGranularity).valueOf();
        next = time.offset(last, 1, dataGranularity).valueOf();
      }

      var domain = scale.domain();
      var desTime = next > domain[domain.length - 1] ? last : last < domain[0] ? next : Math.abs(targetTime - next) < Math.abs(targetTime - last) ? next : last;
      return {
        position: scale.scale(desTime),
        label: formatter(desTime)
      };
    };

    return TimeCrosshairDelegate;
  }(DiscreteCrosshairDelegate); //
  //@flow-ignore


  var TooltipDelegate = function (InteractionDelegat____1) {
    function TooltipDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) TooltipDelegate.__proto__ = InteractionDelegat____1;
    TooltipDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    TooltipDelegate.prototype.constructor = TooltipDelegate;

    TooltipDelegate.prototype.showTooltip = function showTooltip(state) {
      var focusedShapes = state.focusedShapes;
      var blurredShapes = state.blurredShapes;
      var states = state.states;
      var focusedShape = lodash__default.first(focusedShapes);

      if (states.indexOf(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH) < 0) {
        if (focusedShape && focusedShape.getType() !== 'Text') {
          this._sceneInteractionManagerDelegate.onTooltipStateChange(true, focusedShape);
        }
      }

      return state;
    };

    TooltipDelegate.prototype.hideTooltip = function hideTooltip(state) {
      this._sceneInteractionManagerDelegate.onTooltipStateChange(false);

      return state;
    };

    TooltipDelegate.prototype.changeVisibility = function changeVisibility(state, hideTooltipIfNotSelected) {
      var focusedShapes = state.focusedShapes;
      var blurredShapes = state.blurredShapes;
      var states = state.states;
      var focusedShape = lodash__default.first(focusedShapes);

      if (hideTooltipIfNotSelected && focusedShape && !focusedShape.isSelected()) {
        this._sceneInteractionManagerDelegate.onTooltipStateChange(false, focusedShape);
      } else if (states.indexOf(constants$1.INTERACTION_DELEGATE_TYPE.BRUSH) < 0 && focusedShape && focusedShape.getType() !== 'Text') {
        this._sceneInteractionManagerDelegate.onTooltipStateChange(true, focusedShape);
      } else {
        this._sceneInteractionManagerDelegate.onTooltipStateChange(false);
      }

      return state;
    };

    return TooltipDelegate;
  }(InteractionDelegate); //
  //@flow-ignore


  var CustomDelegate = function (InteractionDelegat____1) {
    function CustomDelegate() {
      InteractionDelegat____1.apply(this, arguments);
    }

    if (InteractionDelegat____1) CustomDelegate.__proto__ = InteractionDelegat____1;
    CustomDelegate.prototype = Object.create(InteractionDelegat____1 && InteractionDelegat____1.prototype);
    CustomDelegate.prototype.constructor = CustomDelegate;

    CustomDelegate.prototype.update = function update(state) {
      var focusedShapes = state.focusedShapes;
      var shape = lodash__default.first(focusedShapes);

      if (shape && shape.get("onClick")) {
        var ref = shape.get("onClick");
        var eventName = ref.eventName;
        var eventData = ref.eventData;

        if (eventName != null) {
          this._sceneInteractionManagerDelegate.onEvent(eventName, eventData);
        }
      }

      return state;
    };

    return CustomDelegate;
  }(InteractionDelegate); //


  var INTERACTION_DELEGATE_TYPE$1 = constants$1.INTERACTION_DELEGATE_TYPE;

  var InteractionDelegateFactory = function InteractionDelegateFactory(sceneInteractionManagerDelegate) {
    this._cache = {};
    this._sceneInteractionManagerDelegate = sceneInteractionManagerDelegate;
  };

  InteractionDelegateFactory.prototype.make = function make(type) {
    if (this._cache[type]) {
      return this._cache[type];
    }

    var delegate;

    switch (type) {
      case INTERACTION_DELEGATE_TYPE$1.DISCRETE_CROSSHAIR:
        delegate = new DiscreteCrosshairDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.BRUSH:
        delegate = new BrushDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.CENTER:
        delegate = new CenterActor(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.CURSOR:
        delegate = new CursorDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.EVENT:
        delegate = new EventDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.HIGHLIGHT:
        delegate = new HighlightDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.RANGE:
        delegate = new RangeDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.SELECTION:
        delegate = new SelectionDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.TIME_CROSSHAIR:
        delegate = new TimeCrosshairDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.TOOLTIP:
        delegate = new TooltipDelegate(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.ANNOTATION:
        delegate = new AnnotationInteraction(this._sceneInteractionManagerDelegate);
        break;

      case INTERACTION_DELEGATE_TYPE$1.CUSTOM:
        delegate = new CustomDelegate(this._sceneInteractionManagerDelegate);
        break;
    }

    if (delegate) {
      this._cache[type] = delegate;
    }

    return delegate;
  };

  InteractionDelegateFactory.prototype.reset = function reset() {
    var this$1 = this;
    Object.keys(this._cache).forEach(function (key) {
      var delegate = this$1._cache[key];

      if (delegate.reset) {
        delegate.reset();
      }
    });
    this._cache = {};
  }; //
  // Actions


  var ref$5 = constants$1.INTERACTION_DELEGATE_TYPE;
  var ANNOTATION = ref$5.ANNOTATION;
  var BRUSH$2 = ref$5.BRUSH;
  var CENTER = ref$5.CENTER;
  var CURSOR = ref$5.CURSOR;
  var CUSTOM = ref$5.CUSTOM;
  var DISCRETE_CROSSHAIR = ref$5.DISCRETE_CROSSHAIR;
  var EVENT = ref$5.EVENT;
  var HIGHLIGHT = ref$5.HIGHLIGHT;
  var RANGE = ref$5.RANGE;
  var SELECTION = ref$5.SELECTION;
  var TIME_CROSSHAIR = ref$5.TIME_CROSSHAIR;
  var TOOLTIP$1 = ref$5.TOOLTIP;

  var DesktopActionFactory = function DesktopActionFactory() {};

  DesktopActionFactory.make = function make(type, interactionDelegateFactory) {
    var annotation, brush, center, cursor, event, highlight, range, selection, tooltip, crosshair, custom;

    switch (type) {
      case constants$1.INTERACTION_TYPE.COMMON:
        event = interactionDelegateFactory.make(EVENT);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return event.clickEvent(state);
          })
        })], constants$1.INTERACTION_TYPE.COMMON);

      case constants$1.INTERACTION_TYPE.DIMENSION_CROSSHAIR:
        tooltip = interactionDelegateFactory.make(TOOLTIP$1);
        crosshair = interactionDelegateFactory.make(DISCRETE_CROSSHAIR);
        return new CompositeAction([new HoverAction$2({
          update: new Actor(function (state) {
            return crosshair.update(state);
          })
        }), new DragAction({
          enter: new Actor(function (state) {
            return crosshair.reset(state);
          }, function (state) {
            return tooltip.hideTooltip(state);
          })
        })], constants$1.INTERACTION_TYPE.DIMENSION_CROSSHAIR);

      case constants$1.INTERACTION_TYPE.TIME_CROSSHAIR:
        tooltip = interactionDelegateFactory.make(TOOLTIP$1);
        crosshair = interactionDelegateFactory.make(TIME_CROSSHAIR);
        return new CompositeAction([new HoverAction$2({
          update: new Actor(function (state) {
            return crosshair.update(state);
          })
        }), new DragAction({
          enter: new Actor(function (state) {
            return crosshair.reset(state);
          }, function (state) {
            return tooltip.hideTooltip(state);
          })
        })], constants$1.INTERACTION_TYPE.TIME_CROSSHAIR);

      case constants$1.INTERACTION_TYPE.HIGHLIGHT:
        highlight = interactionDelegateFactory.make(HIGHLIGHT);
        tooltip = interactionDelegateFactory.make(TOOLTIP$1);
        cursor = interactionDelegateFactory.make(CURSOR);
        return new CompositeAction([new HoverAction({
          enter: new Actor(function (state) {
            return highlight.update(state);
          }, function (state) {
            return tooltip.showTooltip(state);
          }, function (state) {
            return cursor.update(state);
          }),
          leave: new Actor(function (state) {
            return highlight.update(state);
          }, function (state) {
            return tooltip.hideTooltip(state);
          }, function (state) {
            return cursor.reset(state);
          })
        })], constants$1.INTERACTION_TYPE.HIGHLIGHT);

      case constants$1.INTERACTION_TYPE.MULTI_SELECTION:
        selection = interactionDelegateFactory.make(SELECTION);
        brush = interactionDelegateFactory.make(BRUSH$2);
        cursor = interactionDelegateFactory.make(CURSOR);
        return new CompositeAction([new DragAction({
          update: new Actor(function (state) {
            return brush.updateWithTrace(state);
          }, function (state) {
            return selection.selectShapes(state);
          }, function (state) {
            return cursor.update(state);
          }),
          leave: new Actor(function (state) {
            return brush.reset(state);
          })
        }), new ClickAction({
          update: new Actor(function (state) {
            return selection.selectShapes(state);
          })
        }), new SelectAction({
          update: new Actor(function (state) {
            return selection.selectKeys(state);
          })
        })], constants$1.INTERACTION_TYPE.MULTI_SELECTION);

      case constants$1.INTERACTION_TYPE.RANGE_SELECTION:
        selection = interactionDelegateFactory.make(SELECTION);
        range = interactionDelegateFactory.make(RANGE);
        tooltip = interactionDelegateFactory.make(TOOLTIP$1);
        return new CompositeAction([new DragAction({
          enter: new Actor(function (state) {
            return tooltip.hideTooltip(state);
          }),
          update: new Actor(function (state) {
            return range.updateWithTrace(state);
          }),
          leave: new Actor(function (state) {
            return range.release(state);
          }, function (state) {
            return selection.selectRange(state);
          })
        }), new ClickAction({
          update: new Actor(function (state) {
            return range.reset(state);
          }, function (state) {
            return selection.selectRange(state);
          })
        }), new SelectAction({
          update: new Actor(function (state) {
            return range.updateWithSelection(state);
          })
        })], constants$1.INTERACTION_TYPE.RANGE_SELECTION);

      case constants$1.INTERACTION_TYPE.SINGLE_SELECTION:
        selection = interactionDelegateFactory.make(SELECTION);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return selection.selectShapes(state);
          })
        }), new SelectAction({
          update: new Actor(function (state) {
            return selection.selectKeys(state);
          })
        })], constants$1.INTERACTION_TYPE.SINGLE_SELECTION);

      case constants$1.INTERACTION_TYPE.TAB:
        highlight = interactionDelegateFactory.make(HIGHLIGHT);
        tooltip = interactionDelegateFactory.make(TOOLTIP$1);
        center = interactionDelegateFactory.make(CENTER);
        return new CompositeAction([new TabAction({
          update: new Actor(function (state) {
            return highlight.update(state);
          }, function (state) {
            return tooltip.showTooltip(state);
          }, function (state) {
            return center.center(state);
          })
        })], constants$1.INTERACTION_TYPE.TAB);

      case constants$1.INTERACTION_TYPE.ANNOTATION:
        annotation = interactionDelegateFactory.make(ANNOTATION);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return annotation.clickUpdate(state);
          })
        })], constants$1.INTERACTION_TYPE.ANNOTATION);

      case constants$1.INTERACTION_TYPE.CUSTOM:
        custom = interactionDelegateFactory.make(CUSTOM);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return custom.update(state);
          })
        })], constants$1.INTERACTION_TYPE.CUSTOM);
    }

    return new CompositeAction([], "none");
  }; //
  //@flow-ignore
  // Actions


  var ref$6 = constants$1.INTERACTION_DELEGATE_TYPE;
  var ANNOTATION$1 = ref$6.ANNOTATION;
  var BRUSH$3 = ref$6.BRUSH;
  var CURSOR$1 = ref$6.CURSOR;
  var CUSTOM$1 = ref$6.CUSTOM;
  var DISCRETE_CROSSHAIR$1 = ref$6.DISCRETE_CROSSHAIR;
  var EVENT$1 = ref$6.EVENT;
  var HIGHLIGHT$1 = ref$6.HIGHLIGHT;
  var SELECTION$1 = ref$6.SELECTION;
  var TIME_CROSSHAIR$1 = ref$6.TIME_CROSSHAIR;
  var TOOLTIP$2 = ref$6.TOOLTIP;

  var MobileActionFactory = function MobileActionFactory() {};

  MobileActionFactory.make = function make(type, interactionDelegateFactory) {
    var annotation, brush, cursor, event, highlight, range, selection, tooltip, crosshair, custom;

    switch (type) {
      case constants$1.INTERACTION_TYPE.COMMON:
        event = interactionDelegateFactory.make(EVENT$1);
        tooltip = interactionDelegateFactory.make(TOOLTIP$2);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return tooltip.changeVisibility(state);
          }, function (state) {
            return event.clickEvent(state);
          })
        })], constants$1.INTERACTION_TYPE.COMMON);

      case constants$1.INTERACTION_TYPE.DIMENSION_CROSSHAIR:
      case constants$1.INTERACTION_TYPE.TIME_CROSSHAIR:
        crosshair = interactionDelegateFactory.make(type === constants$1.INTERACTION_TYPE.DIMENSION_CROSSHAIR ? DISCRETE_CROSSHAIR$1 : TIME_CROSSHAIR$1);
        selection = interactionDelegateFactory.make(SELECTION$1);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return crosshair.update(state);
          })
        })], type);

      case constants$1.INTERACTION_TYPE.MULTI_SELECTION:
        selection = interactionDelegateFactory.make(SELECTION$1);
        brush = interactionDelegateFactory.make(BRUSH$3);
        cursor = interactionDelegateFactory.make(CURSOR$1);
        tooltip = interactionDelegateFactory.make(TOOLTIP$2);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return selection.selectShapes(state);
          }, function (state) {
            return tooltip.changeVisibility(state, true);
          })
        }), new SelectAction({
          update: new Actor(function (state) {
            return selection.selectKeys(state);
          })
        })], constants$1.INTERACTION_TYPE.MULTI_SELECTION);

      case constants$1.INTERACTION_TYPE.SINGLE_SELECTION:
        selection = interactionDelegateFactory.make(SELECTION$1);
        tooltip = interactionDelegateFactory.make(TOOLTIP$2);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return selection.selectShapes(state);
          }, function (state) {
            return tooltip.changeVisibility(state, true);
          })
        }), new SelectAction({
          update: new Actor(function (state) {
            return selection.selectKeys(state);
          })
        })], constants$1.INTERACTION_TYPE.SINGLE_SELECTION);

      case constants$1.INTERACTION_TYPE.TAB:
        highlight = interactionDelegateFactory.make(HIGHLIGHT$1);
        tooltip = interactionDelegateFactory.make(TOOLTIP$2);
        return new CompositeAction([new TabAction({
          update: new Actor(function (state) {
            return highlight.update(state);
          }, function (state) {
            return tooltip.showTooltip(state);
          })
        })], constants$1.INTERACTION_TYPE.TAB);

      case constants$1.INTERACTION_TYPE.ANNOTATION:
        annotation = interactionDelegateFactory.make(ANNOTATION$1);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return annotation.clickUpdate(state);
          })
        })], constants$1.INTERACTION_TYPE.ANNOTATION);

      case constants$1.INTERACTION_TYPE.CUSTOM:
        custom = interactionDelegateFactory.make(CUSTOM$1);
        return new CompositeAction([new ClickAction({
          update: new Actor(function (state) {
            return custom.update(state);
          })
        })], constants$1.INTERACTION_TYPE.CUSTOM);
    }

    return new CompositeAction([], "none");
  }; //
  //@flow-ignore
  //@flow-ignore


  var INTERACTION_DELEGATE_TYPE = constants$1.INTERACTION_DELEGATE_TYPE;
  var ActionFactory = envUtils.inBrowser() && !envUtils.isMobile() ? DesktopActionFactory : MobileActionFactory;
  var EVENT_NAME = constants$1.EVENT_NAME; // SceneInteractionManager
  //
  // Manages user interaction with EclairNG chart. Everytime chart.render is called, chart
  // will produce a new scene and hand it over to SceneInteractionManager. From then on until the
  // next render call, InteractionManger will do initial rendering of scene, properly modify
  // scene when mouse event comes in and rerender scene if needed.
  //
  // It has a animation queue and a scene processor, which are used to render the scene. When 'render'
  // is called, an animation object will be constructed and issued to the queue. The queue will further
  // uses the scene processor to do further rendering.
  //
  // It also has a global state that shared by all the interaction instances. Ex. We do not want a hover
  // interaction when doing a brush select. The hover interaction can query this global state to check.
  //
  // - chart delegates all mouse events to SceneInteractionManager
  // - SceneInteractionManager handles mouse events by further delegating them to
  //   Interaction instances in order. Each one of them will have a chance to
  //   modify scene according to the event. Return value is boolean, indicating whether
  //   the scene is modified. After checking with all Interaction instances, InteractionManger
  //   will decide whether to re-render the scene, and in case there is an animation happening,
  //   it should interrupt or defer(_render method).
  // - SceneInteractionManager takes/initalize a perf transaction instance on init or on getting
  //   interaction event. it drops marks along the process of responding to interaction and
  //   triggers 'perfReady' event on Chart instance with perf report when finish

  /*::(x: SceneInteractionManager) => (x: ISceneInteractionManager & ISceneInteractionManagerDelegate)*/

  var SceneInteractionManager$1 = function SceneInteractionManager(sceneInteractionDelegate, options) {
    this._shape0 = null;
    this._hotSpot0 = null;
    this._scene = null;
    this._durations = options.durations || {};
    this._sceneInteractionDelegate = sceneInteractionDelegate;
    this._interactionLayers = {};
    this._interactionDelegateFactory = new InteractionDelegateFactory(this);
    this._activeKeys = [];
    this._action = new CompositeAction([]);
  };
  /**
  	 * Assign a scene to the manager. All the interaction will based on the scene assigned.
  	 * SceneInteractionManager is statefull and will keep the scene until the next one comes.
  	 */


  SceneInteractionManager$1.prototype.setScene = function setScene(scene) {
    var this$1 = this;
    this._scene = scene;
    this.reset();
    var hasSelection = false;
    var hasHover = false;
    var crosshairType;

    if (scene) {
      scene.prepareForInteraction();

      this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.COMMON, this._interactionDelegateFactory));

      scene.getCells().forEach(function (cell) {
        cell.getLayers().forEach(function (layer) {
          if (layer.get("decorationType") === constants$1.DECORATION_LAYER_TYPE.DISCRETE_CROSSHAIR) {
            crosshairType = constants$1.INTERACTION_TYPE.DIMENSION_CROSSHAIR;
            this$1.addInteractionLayer(layer, INTERACTION_DELEGATE_TYPE.DISCRETE_CROSSHAIR);
          }

          if (layer.get("decorationType") === constants$1.DECORATION_LAYER_TYPE.TIME_CROSSHAIR) {
            crosshairType = constants$1.INTERACTION_TYPE.TIME_CROSSHAIR;
            this$1.addInteractionLayer(layer, INTERACTION_DELEGATE_TYPE.TIME_CROSSHAIR);
          }

          if (layer.get("canHover")) {
            hasHover = true;
            this$1.addInteractionLayer(layer, constants$1.INTERACTION_DELEGATE_TYPE.HIGHLIGHT);
          }

          if (scene && scene.get("selectMode") !== constants$1.SELECTMODE.NONE) {
            if (layer.isBrushLayer()) {
              hasSelection = true;
              this$1.addInteractionLayer(layer, constants$1.INTERACTION_DELEGATE_TYPE.BRUSH);
            } else if (layer.get("canSelect")) {
              hasSelection = true;
              this$1.addInteractionLayer(layer, constants$1.INTERACTION_DELEGATE_TYPE.SELECTION);
            }
          }
        });
      });

      if (hasSelection) {
        this._selectionDelegate = this._interactionDelegateFactory.make(constants$1.INTERACTION_DELEGATE_TYPE.SELECTION);
        var selectMode = scene.get("selectMode");

        if (selectMode === constants$1.SELECTMODE.SINGLE || selectMode === constants$1.SELECTMODE.SINGLE_REQUIRED) {
          this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.SINGLE_SELECTION, this._interactionDelegateFactory));
        } else if (selectMode === constants$1.SELECTMODE.MULTI || selectMode === constants$1.SELECTMODE.MULTI_REQUIRED) {
          this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.MULTI_SELECTION, this._interactionDelegateFactory));
        } else if (selectMode === constants$1.SELECTMODE.RANGE) {
          this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.RANGE_SELECTION, this._interactionDelegateFactory));
        }
      }

      if (crosshairType) {
        this._action.addAction(ActionFactory.make(crosshairType, this._interactionDelegateFactory));
      }

      if (hasHover) {
        this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.HIGHLIGHT, this._interactionDelegateFactory));
      }

      this._annotationDelegate = this._interactionDelegateFactory.make(constants$1.INTERACTION_DELEGATE_TYPE.ANNOTATION);

      this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.ANNOTATION, this._interactionDelegateFactory));

      this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.TAB, this._interactionDelegateFactory));

      this._action.addAction(ActionFactory.make(constants$1.INTERACTION_TYPE.CUSTOM, this._interactionDelegateFactory));
    }

    return this;
  };
  /**
  	 * If there is a scene set with the manager
  	 */


  SceneInteractionManager$1.prototype.hasScene = function hasScene() {
    return this._scene != null;
  };
  /**
  	 * Based on different interactions, there are different layers for them.
  	 * This adds a mapping between the type and the layer
  	 */


  SceneInteractionManager$1.prototype.addInteractionLayer = function addInteractionLayer(layer, type) {
    this._interactionLayers[type] = this._interactionLayers[type] || [];

    this._interactionLayers[type].push(layer);
  };
  /**
  	 * Get all the layers of a type
  	 */


  SceneInteractionManager$1.prototype.getInteractionLayers = function getInteractionLayers(type) {
    return this._interactionLayers[type] || [];
  };
  /**
  	 * render current scene with duration
  	 * - if there is a current animation happening
  	 *  render isnt interruptive: defer the render till after current animation finishes
  	 *  render is interruptive: end current animation, cancel all deferred render and start render immediately
  	 */


  SceneInteractionManager$1.prototype.render = function render(options, interrupt, type) {
    if (options === void 0) options = {
      duration: 0
    };
    if (interrupt === void 0) interrupt = false;
    if (type === void 0) type = constants$1.RENDER_TYPE.INTERACTION;
    return this._sceneInteractionDelegate.onRender(this._scene, lodash__default.extend({}, options, {
      forcedFullRender: false
    }), interrupt, type);
  };
  /**
  	 * Reset the scene processor to the initial state
  	 */


  SceneInteractionManager$1.prototype.reset = function reset() {
    this._action = new CompositeAction([]);
    this._interactionLayers = {};

    this._interactionDelegateFactory.reset();

    this._activeKeys = [];
    return this;
  };
  /**
  	 * S1 requires this information. This returns the auto fit ratio of the scene
  	 */


  SceneInteractionManager$1.prototype.getAutoFitRatio = function getAutoFitRatio() {
    var scene = this._scene;
    var config = scene && scene.get("config");
    return config && config._autoFitRatio || 0;
  };
  /**
  	 * Scroll the scene to the given position
  	 */


  SceneInteractionManager$1.prototype.scrollTo = function scrollTo(x, y, duration) {
    if (duration === void 0) duration = 0;

    if (this._sceneInteractionDelegate.isRemoved()) {
      return es6Promise.Promise.resolve(new Perf({
        name: 'scrollTo'
      }).start());
    }

    var ref = this._getScrollOffset();

    var scrollOffsetX = ref[0];
    var scrollOffsetY = ref[1];

    if (x !== scrollOffsetX || y !== scrollOffsetY) {
      this._sceneInteractionDelegate.onTooltipStateChange(false);

      if (this._scene != null) {
        this._scene.onScroll(x, y);

        if (this._annotationDelegate) {
          this._annotationDelegate.update(true);
        }
      }

      return this.render({
        duration: duration || 0
      });
    }

    return es6Promise.Promise.resolve(new Perf({
      name: 'scrollTo'
    }).start());
  };

  SceneInteractionManager$1.prototype._getScrollOffset = function _getScrollOffset() {
    return this._scene ? this._scene.get('scrollOffset') : [0, 0];
  };
  /**
  	 * Render the table which contains the rows as the entries
  	 */


  SceneInteractionManager$1.prototype.renderAccessibilityTable = function renderAccessibilityTable(rows) {
    return this;
  };
  /**
  	 * Render all the accessibility data items (items that cab be tabbed on)
  	 */


  SceneInteractionManager$1.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems() {
    return es6Promise.Promise.resolve();
  };
  /**
  	 * Get a formatted text for the tooltip with a path to the shape
  	 */


  SceneInteractionManager$1.prototype.getTooltipWithPath = function getTooltipWithPath(path) {
    if (this._scene) {
      var shape = this._getHoverEntityWithPath(this._scene, path);

      var dataFormatter = shape.get('dataFormatter');

      if (shape && shape.get("data") && shape.get("data").row && dataFormatter && dataFormatter.hasTooltip()) {
        return dataFormatter.formatTooltip(shape.get("data").row);
      }
    }

    return [];
  };

  SceneInteractionManager$1.prototype._getHoverEntityWithPath = function _getHoverEntityWithPath(scene, path) {
    var shape = utils$2.getModelNode(scene, path);
    return shape ? shape : this._getShapeGroupNodeWithPath(scene, path);
  }; // Due to the different scene structure passed in the renderer
  // The key path will be missing the shape group key if it has a shape group
  // This is a quite hacky function that will try to compute the shape group key and return it


  SceneInteractionManager$1.prototype._getShapeGroupNodeWithPath = function _getShapeGroupNodeWithPath(scene, path) {
    var shapeGroupKey = "";
    var shapeKey = path[path.length - 1];

    if (shapeKey) {
      shapeGroupKey = shapeKey.replace(/(^.*)\/[0-9]+$/, function (m, x) {
        return x;
      });
    }

    if (shapeGroupKey !== shapeKey) {
      return utils$2.getModelNode(scene, path.slice(0, -1).concat(shapeGroupKey));
    }
  };

  SceneInteractionManager$1.prototype.updateScrollPosition = function updateScrollPosition(x, y) {
    if (this._scene) {
      this._scene.onScroll(x, y);
    }

    return this;
  }; //--------------------------------------------------------------------------------
  // selection
  //--------------------------------------------------------------------------------

  /**
  	 * Get the current selection of the scene
  	 */


  SceneInteractionManager$1.prototype.getSelection = function getSelection() {
    if (this._selectionDelegate) {
      return this._selectionDelegate.getSelection();
    }

    return [];
  };
  /**
  	 * Override the current selection state of the chart
  	 * - for all layers associated, select all shapes with keys present in
  	 * selection array passed in, unselect all others. if selection is empty
  	 * array, reset selection for all layers. Unless options.skipLegendUpdate,
  	 * update legend selection.
  	 * - re-render chart to reflect visual changes for selection unless options.skipRender
  	 */


  SceneInteractionManager$1.prototype.setSelection = function setSelection(keys, options) {
    if (options === void 0) options = {}; // Note: we cannot simply ask the selectionDelegate to set the selection since there might be other interactions also triggered by the selection
    // ex. creating a range selection when selecting

    var selectionMode = this._scene && this._scene.get("selectMode");

    this._delegate('onSelect', {
      selectionInfo: {
        keys: keys,
        overwrite: true,
        isRange: selectionMode === constants$1.SELECTMODE.RANGE
      }
    });

    if (!(options && options.skipRender)) {
      this.render({
        duration: this._durations.select
      });
    }

    if (this._annotationDelegate) {
      this._annotationDelegate.update();
    }

    return this;
  };
  /**
  	 * Select new rows with the keys given (this will not overwrite the exisiting selected ones)
  	 */


  SceneInteractionManager$1.prototype.select = function select(keys, options) {
    if (options === void 0) options = {};

    if (this._selectionDelegate) {
      this._selectionDelegate.select(keys);
    }

    if (!(options && options.skipRender)) {
      this.render({
        duration: this._durations.select
      });
    }

    if (this._annotationDelegate) {
      this._annotationDelegate.update();
    }

    return this;
  };
  /**
  	 * Unselect new rows with the keys given (this will not overwrite the exisiting selected ones)
  	 */


  SceneInteractionManager$1.prototype.unselect = function unselect(keys, options) {
    if (options === void 0) options = {};

    if (this._selectionDelegate) {
      this._selectionDelegate.unselect(keys);
    }

    if (!(options && options.skipRender)) {
      this.render({
        duration: this._durations.select
      });
    }

    if (this._annotationDelegate) {
      this._annotationDelegate.update();
    }

    return this;
  };
  /**
  	 * Even though we track the active keyboard keys through key events, for funtional keys (ex. meta, control), it's not very accurate
  	 * (user might key up outside of the window). For those functional keys, we override with the native event's value.
  	 * @param {*} activeKeys
  	 * @param {*} nativeEvent
  	 */


  SceneInteractionManager$1.prototype._updateKeyFromNativeEvent = function _updateKeyFromNativeEvent(activeKeys, nativeEvent) {
    if (!nativeEvent) {
      return activeKeys;
    }

    var targetedKeys = {
      Meta: "metaKey",
      Control: "ctrlKey",
      Shift: "shiftKey",
      Alt: "altKey"
    };
    var otherKeys = activeKeys.filter(function (key) {
      return !targetedKeys.hasOwnProperty(key);
    });
    return otherKeys.concat(Object.keys(targetedKeys).reduce(function (ls, key) {
      var eventField = targetedKeys[key]; //@flow-ignore

      if (nativeEvent[eventField]) {
        ls.push(key);
      }

      return ls;
    }, []));
  };
  /**
  	 * There is a mouse move event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.mouseMove = function mouseMove(x, y, e) {
    var shape1 = this._scene && this._scene.findShapeUnderPos(x, y);

    var hotSpot1 = shape1 && shape1.findHotSpotUnderPos(x, y);

    var state = this._delegate("onMouseMove", {
      pointerPosition: [x, y],
      focusedShapes: [shape1],
      activeKeys: this._updateKeyFromNativeEvent(this._activeKeys, e),
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    if (shape1 !== this._shape0) {
      if (this._shape0) {
        if (this._hotSpot0) {
          this._onMouseLeaveHotSpot(this._hotSpot0);
        }

        this._onMouseLeaveShape(this._shape0, shape1, state);
      }

      if (shape1) {
        this._onMouseEnterShape(this._shape0, shape1, state);

        if (hotSpot1) {
          this._onMouseEnterHotSpot(hotSpot1);
        }
      }
    } else {
      // mouse move on the same shape, may need to reposition tooltip
      if (shape1) {
        this._sceneInteractionDelegate.onTooltipMove();
      }

      if (hotSpot1 !== this._hotSpot0) {
        if (this._hotSpot0) {
          this._onMouseLeaveHotSpot(this._hotSpot0);
        }

        if (hotSpot1) {
          this._onMouseEnterHotSpot(hotSpot1);
        }
      }
    } // TODO: fix the duraion


    this.render({
      duration: constants$1.ANIM_DURATION.HOVER
    });

    this._trigger(constants$1.UNDOCUMENTED_EVENTS.MOUSE_MOVE, {
      x: x,
      y: y,
      shape: this._shape0,
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    return this;
  };
  /**
  	 * There is a mouse down event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.mouseDown = function mouseDown(x, y, e) {
    this._delegate("onMouseDown", {
      pointerPosition: [x, y],
      focusedShapes: [this._scene && this._scene.findShapeUnderPos(x, y)],
      activeKeys: this._updateKeyFromNativeEvent(this._activeKeys, e),
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    this.render({
      duration: 0
    });

    this._trigger(constants$1.UNDOCUMENTED_EVENTS.MOUSE_DOWN, {
      x: x,
      y: y,
      shape: this._shape0,
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    return this;
  };
  /**
  	 * There is a mouse up event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.mouseUp = function mouseUp(x, y, e) {
    this._delegate("onMouseUp", {
      pointerPosition: [x, y],
      focusedShapes: [this._scene && this._scene.findShapeUnderPos(x, y)],
      activeKeys: this._updateKeyFromNativeEvent(this._activeKeys, e),
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    this.render({
      duration: this._durations.select
    });

    this._trigger(constants$1.UNDOCUMENTED_EVENTS.MOUSE_UP, {
      x: x,
      y: y,
      shape: this._shape0,
      hotSpot: this._hotSpot0,
      nativeEvent: e
    });

    return this;
  };

  SceneInteractionManager$1.prototype.mouseClick = function mouseClick(x, y) {
    var shape = this._scene && this._scene.findShapeUnderPos(x, y);

    this._delegate("onMouseDown", {
      pointerPosition: [x, y],
      focusedShapes: [shape],
      activeKeys: this._activeKeys,
      hotSpot: this._hotSpot0
    });

    this._delegate("onMouseUp", {
      pointerPosition: [x, y],
      focusedShapes: [shape],
      activeKeys: this._activeKeys,
      hotSpot: this._hotSpot0
    });

    this.render({
      duration: this._durations.select
    });
    return this;
  };
  /**
  	 * There is a mouse leave event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.mouseLeave = function mouseLeave(x, y, e) {
    var shouldRender = false;

    if (this._hotSpot0) {
      shouldRender = this._onMouseLeaveHotSpot(this._hotSpot0) || shouldRender;
    }

    if (this._shape0) {
      shouldRender = this._onMouseLeaveShape(this._shape0, null) || shouldRender;
    }

    shouldRender = this._delegate("onMouseLeave", {
      pointerPosition: [x, y],
      nativeEvent: e
    }) || shouldRender;

    if (shouldRender) {
      this.render({
        duration: constants$1.ANIM_DURATION.HOVER
      });
    }

    this._trigger(EVENT_NAME.MOUSE_LEAVE, {
      x: x,
      y: y,
      nativeEvent: e
    });

    return this;
  };
  /**
  	 * There is a mouse tab (focus) event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.tabOnShape = function tabOnShape(keyPath) {
    return this;
  };
  /**
  	 * There is a mouse tab (blurr) event, trigger the interaction correspondingly
  	 */


  SceneInteractionManager$1.prototype.tabOffShape = function tabOffShape(keyPath) {
    return this;
  };
  /**
  	 * The keydown event. key is the key code
  	 */


  SceneInteractionManager$1.prototype.keyDown = function keyDown(key, e) {
    if (this._activeKeys.indexOf(key) === -1) {
      this._activeKeys.push(key);
    }

    if (this._delegate("onKeyDown", {
      activeKeys: this._activeKeys
    })) {
      this.render({
        duration: 0
      });
    }

    this._trigger(EVENT_NAME.KEY_DOWN, {
      nativeEvent: e
    });

    return this;
  };
  /**
  	 * The keydown event. key is the key code
  	 */


  SceneInteractionManager$1.prototype.keyUp = function keyUp(key, e) {
    this._activeKeys.splice(this._activeKeys.indexOf(key), 1);

    if (this._delegate("onKeyUp", {
      activeKeys: this._activeKeys
    })) {
      this.render({
        duration: this._durations.select
      });
    }

    this._trigger(EVENT_NAME.KEY_UP, {
      nativeEvent: e
    });

    return this;
  }; //--------------------------------------------------------------------------------
  // annotation
  //--------------------------------------------------------------------------------

  /**
  	 * Set the annotation to the scene (they will be delegated to the interaction instance)
  	 */


  SceneInteractionManager$1.prototype.setAnnotations = function setAnnotations(annotations) {
    if (annotations === void 0) annotations = [];

    if (this._annotationDelegate) {
      this._annotationDelegate.setAnnotations(annotations);
    }

    return this;
  };
  /**
  	 * Get the annotation of the scene
  	 */


  SceneInteractionManager$1.prototype.getAnnotations = function getAnnotations() {
    if (this._annotationDelegate) {
      return this._annotationDelegate.getAnnotations();
    }

    return [];
  }; //--------------------------------------------------------------------------------
  // tooltip
  //--------------------------------------------------------------------------------


  SceneInteractionManager$1.prototype.hideTooltip = function hideTooltip() {
    this._sceneInteractionDelegate.onTooltipStateChange(false);

    return this;
  };

  SceneInteractionManager$1.prototype.showTooltip = function showTooltip(shape, row, color, columns) {
    var dataFormatter = this._scene && this._scene.get('dataFormatter');

    if (!dataFormatter) {
      return this;
    }

    if (!row) {
      if (this._sceneInteractionDelegate.isRemoved() || !(shape && shape.get("data")) || !dataFormatter) {
        return this;
      }

      row = shape.get("data").row;
    }

    if (!row || !dataFormatter.hasTooltip()) {
      return this;
    } // FIXME: HACK


    if (shape) {
      var data = shape.get("data");
      columns = data.columns;

      if (data.color) {
        color = data.color;
      } else {
        color = shape.get("fill");
      }
    }

    this._sceneInteractionDelegate.onTooltipStateChange(true, dataFormatter.formatTooltipWithColumns(row, color, columns));

    return this;
  }; //--------------------------------------------------------------------------------
  // ISceneInteractionManagerDelegate
  //--------------------------------------------------------------------------------


  SceneInteractionManager$1.prototype.getScene = function getScene() {
    return this._scene;
  };

  SceneInteractionManager$1.prototype.getPadding = function getPadding() {
    return this._sceneInteractionDelegate.getPadding();
  };

  SceneInteractionManager$1.prototype.getAnnotation = function getAnnotation() {
    return this._sceneInteractionDelegate.getAnnotation();
  };

  SceneInteractionManager$1.prototype.onEvent = function onEvent(evtName, evtData) {
    this._sceneInteractionDelegate.onEvent(evtName, evtData);
  };

  SceneInteractionManager$1.prototype.onSelect = function onSelect(action, key, keys) {
    this._sceneInteractionDelegate.onSelect(action, key, keys);
  };

  SceneInteractionManager$1.prototype.onCursorChange = function onCursorChange(cursorType) {
    this._sceneInteractionDelegate.onCursorChange(cursorType);
  };

  SceneInteractionManager$1.prototype.onTooltipStateChange = function onTooltipStateChange(showTooltip, shape) {
    if (showTooltip) {
      this.showTooltip(shape);
    } else {
      this.hideTooltip();
    }
  }; //--------------------------------------------------------------------------------
  // mouse interaction helper methods
  // these methods all return true if a rerender needs to happen
  //--------------------------------------------------------------------------------


  SceneInteractionManager$1.prototype._onMouseEnterHotSpot = function _onMouseEnterHotSpot(hotSpot) {
    this._hotSpot0 = hotSpot;

    this._trigger(EVENT_NAME.MOUSE_ENTER_HOTSPOT, {
      shape: this._shape0,
      hotSpot: hotSpot
    });

    return hotSpot.hover();
  };

  SceneInteractionManager$1.prototype._onMouseLeaveHotSpot = function _onMouseLeaveHotSpot(hotSpot) {
    this._hotSpot0 = null;

    this._trigger(EVENT_NAME.MOUSE_LEAVE_HOTSPOT, {
      shape: this._shape0,
      hotSpot: hotSpot
    });

    return hotSpot.unhover();
  };

  SceneInteractionManager$1.prototype._onMouseEnterShape = function _onMouseEnterShape(shape0, shape1, mouseMoveState) {
    //@flow-ignore
    if (shape1.getType() === "Text" && shape1.isTruncated()) {
      // truncation tooltip
      if (this._sceneInteractionDelegate.isRemoved()) {
        return;
      }

      var rotation = shape1.getRotation();
      var angle = rotation ? rotation.angle : 0;

      this._sceneInteractionDelegate.onShowTruncationTooltip(shape1.get("text"), angle, shape1.truncationTooltipPositions(), shape1.totalTranslation(true, true));
    }

    this._shape0 = shape1;

    this._trigger(EVENT_NAME.MOUSE_ENTER_SHAPE, {
      shape: shape1
    });

    var states = mouseMoveState && mouseMoveState.states || [];
    return this._delegate("onMouseEnterShape", {
      focusedShapes: [shape1],
      blurredShapes: [shape0],
      states: states
    });
  };

  SceneInteractionManager$1.prototype._onMouseLeaveShape = function _onMouseLeaveShape(shape0, shape1, mouseMoveState) {
    this._shape0 = null;

    this._trigger(EVENT_NAME.MOUSE_LEAVE_SHAPE, {
      shape: shape0
    });

    var states = mouseMoveState && mouseMoveState.states || [];
    return this._delegate("onMouseLeaveShape", {
      focusedShapes: [shape1],
      blurredShapes: [shape0],
      states: states
    });
  }; // Dispatch event on chart, if cursor coordinates are part of
  // the params, convert the coords to include scene translation.
  // e.g. when interacting with legend, input (x, y) is relative to
  // legend scene, which has a translation relative to main chart, we
  // need to add this translation so the final event params provided
  // are all relative to main chart.


  SceneInteractionManager$1.prototype._trigger = function _trigger(name, params) {
    if (this._scene) {
      var x = params.x;
      var y = params.y;

      if (x != null) {
        var ref = this._scene.get("position");

        var tx = ref[0];
        var ty = ref[1];
        params.x = tx + x;
        params.y = ty + y;
      }

      this._sceneInteractionDelegate.onEvent(name, params);
    }
  };

  SceneInteractionManager$1.prototype._delegate = function _delegate(action) {
    var params = [],
        len = arguments.length - 1;

    while (len-- > 0) {
      params[len] = arguments[len + 1];
    } //@flow-ignore


    return this._action[action].apply(this._action, params);
  }; //
  //@flow-ignore


  var ACCESSIBILITY$2 = constants$1.ACCESSIBILITY;
  var rowsFormatter$1 = RowsFormatter$1.getInstance();
  /*::(x: AccessibleSceneInteractionManager) => (x: ISceneInteractionManager & ISceneInteractionManagerDelegate)*/

  var AccessibleSceneInteractionManager = function (SceneInteractionManager) {
    function AccessibleSceneInteractionManager() {
      SceneInteractionManager.apply(this, arguments);
    }

    if (SceneInteractionManager) AccessibleSceneInteractionManager.__proto__ = SceneInteractionManager;
    AccessibleSceneInteractionManager.prototype = Object.create(SceneInteractionManager && SceneInteractionManager.prototype);
    AccessibleSceneInteractionManager.prototype.constructor = AccessibleSceneInteractionManager;

    AccessibleSceneInteractionManager.prototype.renderAccessibilityTable = function renderAccessibilityTable(rows) {
      if (this._scene) {
        this._sceneInteractionDelegate.onRenderAccessibilityTable(this._getTable(rows, this._scene.get('rowsMetadata')));
      }

      return this;
    };
    /**
     * Render all the accessibility data items (items that cab be tabbed on)
     */


    AccessibleSceneInteractionManager.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems() {
      var this$1 = this;
      return this._sceneInteractionDelegate.onRender(this._scene, {
        duration: 0,
        forcedFullRender: true
      }).then(function () {
        return this$1._sceneInteractionDelegate.onRenderAccessibilityDataItems();
      });
    };

    AccessibleSceneInteractionManager.prototype.getTooltipWithPath = function getTooltipWithPath(path) {
      var scene = this._scene;

      if (scene) {
        var shape = this._getHoverEntityWithPath(scene, path);

        var dataFormatter = scene.get('dataFormatter');

        if (shape && shape.get("data") && shape.get("data").row && dataFormatter != null && dataFormatter.hasTooltip()) {
          return dataFormatter.formatTooltip(shape.get("data").row);
        } else {
          return [];
        }
      } else {
        return [];
      }
    };
    /**
     * Format rows into a table with annotations for the title row
     * @param rows
     * @returns {*}
     */


    AccessibleSceneInteractionManager.prototype.toTable = function toTable(rows) {
      if (!rows.length) {
        return {
          titleRow: [],
          dataRows: []
        };
      }

      var titles = [];
      var dataRows = rows.map(function (row, i) {
        return row.reduce(function (row, cell) {
          var type = cell.type;
          var label = cell.label;
          var value = cell.value;

          if (type !== undefined) {
            // undefined means it's not in use, false => dimension, true => measure
            if (i === 0) {
              titles.push({
                label: label,
                type: type
              });
            }

            row.push(value);
          }

          return row;
        }, []);
      });
      return {
        titleRow: titles,
        dataRows: lodash__default.find(titles, function (title) {
          return title.type === ACCESSIBILITY$2.CELL_TYPE.DIMENSION;
        }) == null ? dataRows.slice(0, 1) : dataRows
      };
    };
    /**
     * Get formatted rows (including the title row) given the data row and a config
     * @param rows
     * @param config
     * @returns {Array}
     */


    AccessibleSceneInteractionManager.prototype.getRows = function getRows(rows, rowsMetadata) {
      return rows.map(function (row) {
        return rowsFormatter$1.formatRow(row, rowsMetadata);
      });
    };
    /**
     * Convert the dataset into a table
     * @param rows
     * @param config
     * @returns {*|{titleRow, dataRows}|{titleRow: {label: string, type: string}[], dataRows: string[][]}}
     */


    AccessibleSceneInteractionManager.prototype._getTable = function _getTable(rows, rowsMetadata) {
      if (rows === void 0) rows = [];
      return this.toTable(this.getRows(rows, rowsMetadata));
    };

    AccessibleSceneInteractionManager.prototype._getHoverEntityWithPath = function _getHoverEntityWithPath(scene, path) {
      var shape = utils$2.getModelNode(scene, path);
      return shape ? shape : this._getShapeGroupNodeWithPath(scene, path);
    }; // Due to the different scene structure passed in the renderer
    // The key path will be missing the shape group key if it has a shape group
    // This is a quite hacky function that will try to compute the shape group key and return it


    AccessibleSceneInteractionManager.prototype._getShapeGroupNodeWithPath = function _getShapeGroupNodeWithPath(scene, path) {
      var shapeGroupKey = "";
      var shapeKey = path[path.length - 1];

      if (shapeKey) {
        shapeGroupKey = shapeKey.replace(/(^.*)\/[0-9]+$/, function (m, x) {
          return x;
        });
      }

      if (shapeGroupKey !== shapeKey) {
        return utils$2.getModelNode(scene, path.slice(0, -1).concat(shapeGroupKey));
      }
    };

    AccessibleSceneInteractionManager.prototype.tabOnShape = function tabOnShape(keyPath) {
      var scene = this._scene;

      if (scene) {
        var shape = utils$2.getModelNode(scene, keyPath);

        if (shape) {
          this._delegate("onKeyDown", {
            focusedShapes: [shape],
            activeKeys: [constants$1.KEYBOARD_KEY.TAB]
          });

          this._sceneInteractionDelegate.onRender(this._scene, {
            duration: constants$1.ANIM_DURATION.TAB,
            forcedFullRender: true
          }, false, 'tab'); //@flow-ignore


          this._shape0 = shape;
        }
      }

      return this;
    };

    AccessibleSceneInteractionManager.prototype.tabOffShape = function tabOffShape(keyPath) {
      var scene = this._scene;

      if (scene) {
        var shape = utils$2.getModelNode(scene, keyPath);

        if (shape) {
          this._delegate("onKeyDown", {
            blurredShapes: [shape],
            activeKeys: [constants$1.KEYBOARD_KEY.TAB]
          });

          this._sceneInteractionDelegate.onRender(this._scene, {
            duration: constants$1.ANIM_DURATION.TAB,
            forcedFullRender: true
          }, false, 'tab');

          this._shape0 = null;
        }
      }

      return this;
    };

    AccessibleSceneInteractionManager.prototype.keyDown = function keyDown(key, e) {
      // This is a request from SFX that we always interpret enter as a mouse click on a shape
      if (key === constants$1.KEYBOARD_KEY.ENTER && this._shape0) {
        this._delegate("onMouseDown", {
          pointerPosition: [0, 0],
          focusedShapes: [this._shape0]
        });

        this._delegate("onMouseUp", {
          pointerPosition: [0, 0],
          focusedShapes: [this._shape0]
        });

        this.render({
          duration: this._durations.select
        }, false, constants$1.EVENT_NAME.MOUSE_CLICK);
        return this;
      } else {
        return SceneInteractionManager.prototype.keyDown.call(this, key, e);
      }
    };

    return AccessibleSceneInteractionManager;
  }(SceneInteractionManager$1); //
  //@flow-ignore


  var SceneCleaner = function SceneCleaner() {};

  SceneCleaner.prototype.cleanModel = function cleanModel(model) {
    return JSON.stringify(this._recurse(model)) || "{}";
  }; // Returns a stringified JSON of the renderer options
  //
  // @param options {Object} the scene graph renderer options
  // @return {String} A stringified JSON of the renderer options


  SceneCleaner.prototype.cleanOptions = function cleanOptions(options) {
    return JSON.stringify(options);
  }; // Recursive helper function to traverse each node of the renderer model
  //
  // @param node {any} the current node being traversed
  // @return {?any} the filtered node, or can be null/undefined


  SceneCleaner.prototype._recurse = function _recurse(node) {
    var this$1 = this;

    if (Array.isArray(node)) {
      return node.map(function (elem) {
        return this$1._recurse(elem);
      });
    } else if (lodash__default.isObject(node)) {
      var applyMap = function applyMap(key) {
        var elem = node[key];
        return SceneCleaner._colorKeys.hasOwnProperty(key) ? this$1._colorsFromNode(elem) : this$1._recurse(elem);
      };

      var mapKey = function mapKey(acc, key) {
        var mapping = applyMap(key);

        if (mapping != null) {
          acc[key] = mapping;
        }

        return acc;
      };

      return Object.keys(node).filter(function (key) {
        return SceneCleaner._validKeys.hasOwnProperty(key) && node[key] != null;
      }).reduce(function (acc, key) {
        return mapKey(acc, key);
      }, {});
    } else {
      return node;
    }
  }; // Gets an object containing the color properties of the given node
  //
  // @param colors {Object} the node to get color properties from
  // @return {?any} the filtered node containing color properties


  SceneCleaner.prototype._colorsFromNode = function _colorsFromNode(colors) {
    var this$1 = this;

    var applyMap = function applyMap(color) {
      if (this$1._hasGradientColor(color)) {
        return this$1._gradientColorsFromNode(color);
      } else if (this$1._hasCssColor(color)) {
        return this$1._cssColorFromRGBA(color);
      }
    };

    if (Array.isArray(colors)) {
      return colors.filter(function (elem) {
        return elem != null;
      }).map(function (color) {
        return applyMap(color);
      }).filter(function (color) {
        return color != null;
      });
    } else {
      return applyMap(colors);
    }
  }; // Checks if the given colors object has a gradient color properties
  //
  // @param colors {Object} the node to check
  // @return {Boolean} true if the colors object has gradient color properties, false otherwise


  SceneCleaner.prototype._hasGradientColor = function _hasGradientColor(colors) {
    return colors._colorStops != null && colors._direction != null;
  }; // Gets an object containing the gradient color properties of a given node
  //
  // @param node {Object} the node to get the gradient colors from
  // @return {Object} an object containing the direction and colors for gradient


  SceneCleaner.prototype._gradientColorsFromNode = function _gradientColorsFromNode(node) {
    var this$1 = this;
    return {
      direction: node._direction,
      // It's possible for a colorStop to be another gradient object and not a simple css color
      // we handle this here.
      colors: node._colorStops.map(function (spec) {
        return spec[0];
      }).map(function (color) {
        return this$1._colorsFromNode(color);
      })
    };
  }; // Checks if the given colors object has a css rgba color properties
  //
  // @param colors {Object} the node to check
  // @return {Boolean} true if the colors object has css rgba color properties, false otherwise


  SceneCleaner.prototype._hasCssColor = function _hasCssColor(colors) {
    return colors._colorRGBA != null;
  }; // Gets a formatted string containing the css rgba color properties of a given node
  //
  // @param colorInfo {Object} the node to get the css rgba colors from
  // @return {String} a formatted string containing the css rgba


  SceneCleaner.prototype._cssColorFromRGBA = function _cssColorFromRGBA(colorInfo) {
    var color = colorInfo._colorRGBA;
    return "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
  };

  SceneCleaner._validKeys = dataUtils.setFromValues(["props", "tweens", "type", "_children", "size", "position", "fullSize", "scrollOffset", "key", "tx", "ty", "scrollX", "scrollY", "viewport", "text", "NumberText", "x", "y", "r", "fill", "stroke", "bg", "w", "h", "dx", "dy", "opacity", "rotation", "textRotation", "angle", "fillOpacity", "startAngle", "r1", "r2", "barText", "texture", "url", "fit", "shade", "textX", "textY", "textR", "textColor", "color", "bb", "maxWidth", "number", "format", "compact", "points_x", "points_y", "cornerRadius", "lineWidth", "roundedCornerStart", "roundedCornerEnd", "dashed", "box", "fontSize", "Rect", "canScroll", "vertical", "baseX", "baseY", "formattedNumber", "closePath", "lineJoin", "curve"]);
  SceneCleaner._colorKeys = dataUtils.setFromValues(["fill", "stroke", "textColor", "color"]); //
  //@flow-ignore

  var ANIM_DURATION = constants$1.ANIM_DURATION;
  var UPDATE_STATE = constants$1.UPDATE_STATE;
  /**
   * SceneProcessor is a layer on top of renderer (which is platform dependant).
   * It takes care of processing model, issuing the render call or relay the rendering-related calls to the renderer.
   */

  /*::(x: SceneRenderer) => (x: ISceneRenderer & IAnimationDelegate)*/

  var SceneRenderer = function SceneRenderer(sceneInteractionDelegate, ref) {
    var rendererConfig = ref.rendererConfig;
    var tooltip = ref.tooltip;
    var padding = ref.padding;
    var name = ref.name;
    var isLegend = ref.isLegend;
    this._removed = false;
    this._padding = padding;
    this._isLegend = isLegend;
    this._renderer = ServiceProvider$1.getDelegate().getRenderer({
      processor: sceneInteractionDelegate,
      config: rendererConfig,
      padding: padding,
      tooltip: tooltip,
      name: name,
      isLegend: isLegend
    }); // set the cleaner if the native renderer has requested to serialize scene graph renderer models

    if (typeof this._renderer.requestSerializedModels === 'function' && this._renderer.requestSerializedModels()) {
      this._cleaner = new SceneCleaner();
    }
  };

  SceneRenderer.prototype.createCustomDOM = function createCustomDOM() {
    return this._renderer.createCustomDOM();
  };

  SceneRenderer.prototype.removeCustomDOM = function removeCustomDOM(el) {
    return this._renderer.removeCustomDOM(el);
  };
  /**
  	 * Animate the scene to screen with the options given
  	 */


  SceneRenderer.prototype.render = function render(scene, options) {
    var this$1 = this;
    if (options === void 0) options = {
      duration: 0,
      forcedFullRender: false,
      disableMorphing: false
    };
    var model = this._model;
    var _scene = scene;

    if (this.isRemoved()) {
      return es6Promise.Promise.resolve(new Perf({
        name: 'scene'
      }).start());
    }

    return new es6Promise.Promise(function (resolve, reject) {
      var ref = options || {};
      var duration = ref.duration;
      if (duration === void 0) duration = ANIM_DURATION.DEFAULT;
      var forcedFullRender = ref.forcedFullRender;
      if (forcedFullRender === void 0) forcedFullRender = false;
      var disableMorphing = ref.disableMorphing;
      if (disableMorphing === void 0) disableMorphing = false;
      var perf = new Perf({
        name: 'scene'
      }).start(); // empty to empty

      if (!forcedFullRender && (_scene && _scene.getUpdateState() === UPDATE_STATE.UPDATED || !_scene && !model)) {
        return resolve(perf);
      }

      this$1.reset(this$1._model);
      perf.mark('diffToModel');
      this$1._model = this$1._updateModel(this$1._model, _scene, forcedFullRender, disableMorphing);
      perf.endMark('diffToModel'); // render animation with config
      // - use callback instead of Promise since renderer does not implement Promise

      if (log$1.animation) {
        console.log((this$1._isLegend ? "legend" : "chart") + " renderer.update");
      }

      if (this$1._model) {
        var ref$1 = this$1._processModel(this$1._model, options);

        var renderModel = ref$1.renderModel;
        var renderOptions = ref$1.renderOptions;

        this$1._renderer.update(renderModel, renderOptions, function (renderingPerf) {
          perf.end();

          if (renderingPerf) {
            perf.merge(renderingPerf.toJson());
          }

          resolve(perf);
        });
      } else {
        perf.end();
        resolve(perf);
      }
    });
  };
  /**
  	 * Used by mobile only. This method, updates the scroll offset without re-render
  	 */


  SceneRenderer.prototype.updateScrollPosition = function updateScrollPosition(x, y) {
    var model = this._model;

    if (model) {
      model.props.scrollOffset = [x, y];
    }

    return this;
  };
  /**
  	 * @param forcedFullRender If we want to force rendering every shape regardless of their visibility
  	 */


  SceneRenderer.prototype._updateModel = function _updateModel(model, scene, forcedFullRender, disableMorphing) {
    if (disableMorphing === void 0) disableMorphing = false;
    return NodeModel.update(this._model, scene, undefined, {
      disableMorphing: disableMorphing
    });
  };
  /**
  	 * Set the cursor type for the scene
  	 * Available cursor types are in constants.CURSOR_TYPE
  	 */


  SceneRenderer.prototype.setCursorType = function setCursorType(type) {
    if (this.isRemoved()) {
      return this;
    }

    this._renderer.setCursorType(type);

    return this;
  };
  /**
  	 * Get the HTML element where the scene will be rendered to
  	 */


  SceneRenderer.prototype.getElement = function getElement() {
    return this._renderer.getElement();
  };
  /**
  	 * Get the padding of the chart
  	 */


  SceneRenderer.prototype.getPadding = function getPadding() {
    return this._padding;
  };
  /**
  	 * Compute chart offset on page
  	 * This info should be kept in the client. Please do not use it
  	 * @deprecated
  	 */


  SceneRenderer.prototype.getChartOffsetXY = function getChartOffsetXY() {
    return this._renderer.chartOffsetXY();
  };
  /**
  	 * Given the new size, return if the scene (with the new size) will be in the viewport
  	 * Ex. for web platform, it will detect the HTMLCanvas element when applied the new dimension
  	 * will be in the window or not
  	 */


  SceneRenderer.prototype.isInViewport = function isInViewport(size) {
    return this._renderer.isInViewport(size);
  };
  /**
  	 * Get a screenshot in an encoded string form
  	 */


  SceneRenderer.prototype.screenshot = function screenshot() {
    if (this.isRemoved()) {
      return;
    }

    var imgData = this._renderer.screenshot();

    var ref = this._renderer.getElementOffset();

    var left = ref[0];
    var top = ref[1];

    if (imgData === "data:,") {
      return undefined;
    } else {
      return {
        left: left,
        top: top,
        src: imgData
      };
    }
  };
  /**
  	 * Reset the scene processor to the initial state
  	 */


  SceneRenderer.prototype.reset = function reset(model) {
    if (model) {
      this._resetModel(model);
    }

    this._renderer.reset();

    return this;
  };

  SceneRenderer.prototype._resetModel = function _resetModel(model) {
    var this$1 = this;

    if (model) {
      if (model.props) {
        var ref = model.props;
        var opacity = ref.opacity;
        delete model.props.animate_points_x;
        delete model.props.animate_points_y;

        if (opacity === 0) {
          model.removeFromParent();
        }

        this._toEndProps(model);
      }

      var children = model.getChildren();

      for (var len = children.length, i = len - 1; i >= 0; --i) {
        this$1._resetModel(children[i]);
      }

      delete model.tweens;
      delete model.rendererCache;
    }

    return true;
  };
  /**
  	 * Reset the model to the end property if there's a tween property.
  	 * @param {*} model
  	 */


  SceneRenderer.prototype._toEndProps = function _toEndProps(model) {
    var props = model.props;
    var tweens = model.tweens;

    if (tweens) {
      Object.keys(tweens).forEach(function (key) {
        props[key] = tweens[key][1];
      });
      delete model.tweens;
    }

    return model;
  }; //--------------------------------------------------------------------------------
  // interaction
  //--------------------------------------------------------------------------------

  /**
  	 * Show the scene (the rendering)
  	 */


  SceneRenderer.prototype.show = function show() {
    this._renderer.show();

    return this;
  };
  /**
  	 * Hide the scene (the rendering)
  	 */


  SceneRenderer.prototype.hide = function hide() {
    this._renderer.hide();

    return this;
  };
  /**
  	 * Remove the rendering (the canvas)
  	 */


  SceneRenderer.prototype.remove = function remove() {
    if (this.isRemoved()) {
      return this;
    } // cleanup tooltip when programmatically removing chart


    this.hideTooltip();

    if (typeof this._renderer.remove === 'function') {
      this._renderer.remove();
    }

    this._removed = true;
    return this;
  };
  /**
  	 * Return if the scene has been removed
  	 */


  SceneRenderer.prototype.isRemoved = function isRemoved() {
    return this._removed;
  };
  /**
  	 * Render the table which contains the rows as the entries
  	 */


  SceneRenderer.prototype.renderAccessibilityTable = function renderAccessibilityTable(table) {
    this._renderer.renderAccessibilityTable(table);

    return this;
  };
  /**
  	 * Render the accessibility items that can be tabbed on
  	 */


  SceneRenderer.prototype.renderAccessibilityDataItems = function renderAccessibilityDataItems() {
    this._renderer.renderAccessibilityDataItems();

    return this;
  };
  /**
  	 * Get an annotation element
  	 */


  SceneRenderer.prototype.getAnnotation = function getAnnotation() {
    return this._renderer.getAnnotation();
  };
  /**
  	 * Enable interaction
  	 */


  SceneRenderer.prototype.startInteraction = function startInteraction() {
    typeof this._renderer.startMouseInteraction === 'function' ? this._renderer.startMouseInteraction() : undefined;
    return this;
  };
  /**
  	 * Disable interaction
  	 */


  SceneRenderer.prototype.stopInteraction = function stopInteraction() {
    typeof this._renderer.stopMouseInteraction === 'function' ? this._renderer.stopMouseInteraction() : undefined;
    return this;
  }; //--------------------------------------------------------------------------------
  // tooltip
  //--------------------------------------------------------------------------------

  /**
  	 * Show the tooltip at the given shape
  	 */


  SceneRenderer.prototype.showTooltip = function showTooltip(lines) {
    if (this.isRemoved()) {
      return this;
    }

    this._renderer.showTooltip(lines);

    return this;
  };
  /**
  	 * Show the truncation tooltip at the given shape
  	 */


  SceneRenderer.prototype.showTruncationTooltip = function showTruncationTooltip(text, angle, positions, totalTranslation) {
    if (this.isRemoved()) {
      return this;
    }

    this._renderer.showTruncationTooltip(text, angle, positions, totalTranslation);

    return this;
  };
  /**
  	 * Hide the tooltip
  	 */


  SceneRenderer.prototype.hideTooltip = function hideTooltip() {
    if (this.isRemoved()) {
      return this;
    }

    this._renderer.hideTooltip();

    return this;
  };
  /**
  	 * Move the tooltip (Tooltip is stateful of positions, this is just triggering to reposition to the right position)
  	 */


  SceneRenderer.prototype.moveTooltip = function moveTooltip() {
    this._renderer.moveTooltip();

    return this;
  }; //--------------------------------------------------------------------------------
  // animation delegate
  //--------------------------------------------------------------------------------


  SceneRenderer.prototype.runAnimation = function runAnimation(animation) {
    var scene = animation.getScene();
    var options = animation.getOptions();
    animation.start();
    this.render(scene, options).then(function (perf) {
      return animation.end(perf);
    });
    return this;
  };

  SceneRenderer.prototype.cancelAnimation = function cancelAnimation(animation) {
    // current renderer implementation will end current animation
    // at the first frame drawing the next animation when interrupted
    // so do not need to end animation for already started ones
    if (!animation.isRunning()) {
      animation.end();
    }

    return this;
  };

  SceneRenderer.prototype.deferAnimation = function deferAnimation(animation) {
    animation.defer();
    return this;
  }; // Notifies the renderer to be updated with the provided parameters.
  // If the native renderer has requested to serialize models, the rendererModel will be serialized
  // to a stringified JSON and provided to the native renderer
  //
  // @param rendererModel {Object} the scene graph renderer model
  // @param options {Object} the scene graph renderer options
  // @param callback {Function} a callback function to invoke after the renderer has finished updating


  SceneRenderer.prototype._processModel = function _processModel(renderModel, renderOptions) {
    if (this._cleaner) {
      return {
        renderModel: this._cleaner.cleanModel(renderModel),
        renderOptions: this._cleaner.cleanOptions(renderOptions)
      };
    } else {
      return {
        renderModel: renderModel,
        renderOptions: renderOptions
      };
    }
  }; //

  /**
   * SceneProcessor is a layer on top of renderer (which is platform dependant).
   * It takes care of processing model, issuing the render call or relay the rendering-related calls to the renderer.
   */

  /*::(x: VisibleSceneRenderer) => (x: ISceneRenderer & IAnimationDelegate)*/


  var VisibleSceneRenderer = function (SceneRendere____1) {
    function VisibleSceneRenderer() {
      SceneRendere____1.apply(this, arguments);
    }

    if (SceneRendere____1) VisibleSceneRenderer.__proto__ = SceneRendere____1;
    VisibleSceneRenderer.prototype = Object.create(SceneRendere____1 && SceneRendere____1.prototype);
    VisibleSceneRenderer.prototype.constructor = VisibleSceneRenderer;

    VisibleSceneRenderer.prototype._updateModel = function _updateModel(model, scene, forcedFullRender, disableMorphing) {
      if (forcedFullRender === void 0) forcedFullRender = false;
      if (disableMorphing === void 0) disableMorphing = false;
      var size = scene && scene.get('size');
      var scrollOffset = scene && scene.get('scrollOffset');

      if (size && scrollOffset && !forcedFullRender) {
        var w = size[0];
        var h = size[1];
        var scrollX = scrollOffset[0];
        var scrollY = scrollOffset[1];
        return NodeModel.update(this._model, scene, new Box({
          x: 0,
          y: 0,
          w: w,
          h: h
        }), {
          disableMorphing: disableMorphing
        });
      }

      return NodeModel.update(this._model, scene, undefined, {
        disableMorphing: disableMorphing
      });
    };

    VisibleSceneRenderer.prototype._toEndProps = function _toEndProps(model) {
      // This logic is implemented in renderer
      return model;
    };

    return VisibleSceneRenderer;
  }(SceneRenderer); //


  var SceneRendererFactory = function SceneRendererFactory() {};

  SceneRendererFactory.makeSceneRenderer = function makeSceneRenderer(sceneInteractionDelegate, options) {
    var classDef = envUtils.inBrowser() ? VisibleSceneRenderer : SceneRenderer;
    return new classDef(sceneInteractionDelegate, options);
  }; //
  //@flow-ignore
  //@flow-ignore

  /*::(x: SceneProcessor) => (x: ISceneProcessor & ISceneInteractionDelegate & IRenderingDelegate)*/


  var SceneProcessor = function SceneProcessor(options) {
    this._name = options.name;
    this._isLegend = !!options.isLegend;
    this._sceneRenderer = SceneRendererFactory.makeSceneRenderer(this, lodash__default.extend({}, options, {
      isLegend: this._isLegend
    }));
    this._animationQueue = new AnimationQueue(this._sceneRenderer);
    this._sceneInteractionManager = new AccessibleSceneInteractionManager(this, options);
  };

  SceneProcessor.prototype.createCustomDOM = function createCustomDOM() {
    return this._sceneRenderer.createCustomDOM();
  };

  SceneProcessor.prototype.removeCustomDOM = function removeCustomDOM(el) {
    return this._sceneRenderer.removeCustomDOM(el);
  };
  /**
  	 * Assign a scene to the manager. All the interaction will based on the scene assigned.
  	 * SceneInteractionManager is statefull and will keep the scene until the next one comes.
  	 */


  SceneProcessor.prototype.setScene = function setScene(scene) {
    this._sceneInteractionManager.setScene(scene);

    return this;
  };
  /**
  	 * Set a delegate to bubble up the events
  	 */


  SceneProcessor.prototype.setChartDelegate = function setChartDelegate(delegate) {
    this._chartInteractionDelegate = delegate;
    return this;
  };
  /**
  	 * render current scene with duration
  	 * - if there is a current animation happening
  	 *  render isnt interruptive: defer the render till after current animation finishes
  	 *  render is interruptive: end current animation, cancel all deferred render and start render immediately
  	 */


  SceneProcessor.prototype.render = function render(options, interrupt, type) {
    return this._sceneInteractionManager.render(options, interrupt, type);
  };
  /**
  	 * Get the HTML element where the scene will be rendered to
  	 */


  SceneProcessor.prototype.getElement = function getElement() {
    return this._sceneRenderer.getElement();
  };

  SceneProcessor.prototype.getName = function getName() {
    return this._name;
  };
  /**
  	 * Compute chart offset on page
  	 */


  SceneProcessor.prototype.getChartOffsetXY = function getChartOffsetXY() {
    return this._sceneRenderer.getChartOffsetXY();
  };
  /**
  	 * Given the new size, return if the scene (with the new size) will be in the viewport
  	 * Ex. for web platform, it will detect the HTMLCanvas element when applied the new dimension
  	 * will be in the window or not
  	 */


  SceneProcessor.prototype.isInViewport = function isInViewport(size) {
    return this._sceneRenderer.isInViewport(size);
  };
  /**
  	 * Get a screenshot in an encoded string form
  	 */


  SceneProcessor.prototype.screenshot = function screenshot() {
    return this._sceneRenderer.screenshot();
  };
  /**
  	 * Reset the scene processor to the initial state
  	 */


  SceneProcessor.prototype.reset = function reset() {
    this._animationQueue.reset();

    return this;
  };
  /**
  	 * S1 requires this information. This returns the auto fit ratio of the scene
  	 */


  SceneProcessor.prototype.getAutoFitRatio = function getAutoFitRatio() {
    return this._sceneInteractionManager.getAutoFitRatio();
  }; //--------------------------------------------------------------------------------
  // interaction
  //--------------------------------------------------------------------------------

  /**
  	 * Start the interaction. It is enabled by default so no need to call this initially
  	 */


  SceneProcessor.prototype.startInteraction = function startInteraction() {
    this._sceneRenderer.startInteraction();

    return this;
  };
  /**
  	 * Stop the interaction.
  	 */


  SceneProcessor.prototype.stopInteraction = function stopInteraction() {
    this._sceneRenderer.stopInteraction();

    return this;
  };
  /**
  	 * Show the scene (the rendering)
  	 */


  SceneProcessor.prototype.show = function show() {
    this._sceneRenderer.show();

    return this;
  };
  /**
  	 * Hide the scene (the rendering)
  	 */


  SceneProcessor.prototype.hide = function hide() {
    this._sceneRenderer.hide();

    return this;
  };
  /**
  	 * Remove the scene (the rendering)
  	 */


  SceneProcessor.prototype.remove = function remove() {
    this._sceneRenderer.remove();

    return this;
  };
  /**
  	 * Return if the scene has been removed
  	 */


  SceneProcessor.prototype.isRemoved = function isRemoved() {
    return this._sceneRenderer.isRemoved();
  };
  /**
  	 * Scroll the scene to the given position
  	 */


  SceneProcessor.prototype.scrollTo = function scrollTo(x, y, duration) {
    if (duration === void 0) duration = 0;
    return this._sceneInteractionManager.scrollTo(x, y, duration);
  };
  /**
  	 * Render the table which contains the rows as the entries
  	 */


  SceneProcessor.prototype.renderAccessibilityTable = function renderAccessibilityTable(rows) {
    this._sceneInteractionManager.renderAccessibilityTable(rows);

    return this;
  }; //--------------------------------------------------------------------------------
  // selection
  //--------------------------------------------------------------------------------

  /**
  	 * Get the current selection of the scene
  	 */


  SceneProcessor.prototype.getSelection = function getSelection() {
    return this._sceneInteractionManager.getSelection();
  };
  /**
  	 * Override the current selection state of the chart
  	 * - for all layers associated, select all shapes with keys present in
  	 * selection array passed in, unselect all others. if selection is empty
  	 * array, reset selection for all layers. Unless options.skipLegendUpdate,
  	 * update legend selection.
  	 * - re-render chart to reflect visual changes for selection unless options.skipRender
  	 */


  SceneProcessor.prototype.setSelection = function setSelection(keys, options) {
    if (options === void 0) options = {};

    this._sceneInteractionManager.setSelection(keys, options);

    return this;
  };
  /**
  	 * Select new rows with the keys given (this will not overwrite the exisiting selected ones)
  	 */


  SceneProcessor.prototype.select = function select(keys, options) {
    if (options === void 0) options = {};

    this._sceneInteractionManager.select(keys, options);

    return this;
  };
  /**
  	 * Unselect new rows with the keys given (this will not overwrite the exisiting selected ones)
  	 */


  SceneProcessor.prototype.unselect = function unselect(keys, options) {
    if (options === void 0) options = {};

    this._sceneInteractionManager.unselect(keys, options);

    return this;
  }; //--------------------------------------------------------------------------------
  // annotation
  //--------------------------------------------------------------------------------

  /**
  	 * Set the annotation to the scene (they will be delegated to the interaction instance)
  	 */


  SceneProcessor.prototype.setAnnotations = function setAnnotations(annotations) {
    if (annotations === void 0) annotations = [];

    this._sceneInteractionManager.setAnnotations(annotations);

    return this;
  };
  /**
  	 * Get the annotation of the scene
  	 */


  SceneProcessor.prototype.getAnnotations = function getAnnotations() {
    return this._sceneInteractionManager.getAnnotations();
  }; //--------------------------------------------------------------------------------
  // tooltip
  //--------------------------------------------------------------------------------


  SceneProcessor.prototype.hideTooltip = function hideTooltip() {
    this._sceneInteractionManager.hideTooltip();

    return this;
  }; //--------------------------------------------------------------------------------
  // ISceneInteractionDelegate
  //--------------------------------------------------------------------------------

  /**
  	 * Get the padding of the chart
  	 */


  SceneProcessor.prototype.getPadding = function getPadding() {
    return this._sceneRenderer.getPadding();
  };
  /**
  	 * Get a annotation element
  	 */


  SceneProcessor.prototype.getAnnotation = function getAnnotation() {
    return this._sceneRenderer.getAnnotation();
  };
  /**
  	 * A callback to notify the scene processor that there is a render needs to be issued
  	 */


  SceneProcessor.prototype.onRender = function onRender(scene, options, interrupt, type) {
    var this$1 = this;
    var animation = new Animation({
      scene: scene,
      options: options,
      interrupt: interrupt,
      name: type
    });

    this._chartInteractionDelegate.onEvent(constants$1.EVENT_NAME.RENDER_BEGIN, {
      type: type
    });

    this._animationQueue.run(animation);

    return animation.getPromise().then(function (perf) {
      this$1._chartInteractionDelegate.onEvent(constants$1.EVENT_NAME.RENDER_END, {
        type: type
      });

      return perf;
    });
  };
  /**
  	 * Render the accessibility table
  	 */


  SceneProcessor.prototype.onRenderAccessibilityTable = function onRenderAccessibilityTable(table) {
    this._sceneRenderer.renderAccessibilityTable(table);
  };

  SceneProcessor.prototype.onRenderAccessibilityDataItems = function onRenderAccessibilityDataItems() {
    return this._sceneRenderer.renderAccessibilityDataItems();
  };
  /**
  	 * A callback to notify the scene processor that there is a general event happened
  	 */


  SceneProcessor.prototype.onEvent = function onEvent(evtName, evtData) {
    this._chartInteractionDelegate.onEvent(evtName, evtData);
  };
  /**
  	 * A callback to notify the scene processor that there is a selection haapend
  	 */


  SceneProcessor.prototype.onSelect = function onSelect(action, key, keys) {
    this._chartInteractionDelegate.onSelect(action, key, keys);
  };
  /**
  	 * A callback to notify the scene processor that the cursor style has changed
  	 */


  SceneProcessor.prototype.onCursorChange = function onCursorChange(cursorType) {
    this._sceneRenderer.setCursorType(cursorType);
  };
  /**
  	 * A callback to notify the scene processor that the tooltip needs to be updated
  	 */


  SceneProcessor.prototype.onTooltipStateChange = function onTooltipStateChange(showTooltip, lines) {
    if (showTooltip) {
      this._sceneRenderer.showTooltip(lines);
    } else {
      this._sceneRenderer.hideTooltip();
    }
  };
  /**
  	 * A callback to notify the scene processor that the tooltip has moved
  	 */


  SceneProcessor.prototype.onTooltipMove = function onTooltipMove() {
    this._sceneRenderer.moveTooltip();
  };
  /**
  	 * A callback to notify the scene processor that the tooltip has moved
  	 */


  SceneProcessor.prototype.onShowTruncationTooltip = function onShowTruncationTooltip(text, angle, positions, totalTranslation) {
    this._sceneRenderer.showTruncationTooltip(text, angle, positions, totalTranslation);
  }; //--------------------------------------------------------------------------------
  // IRenderingDelegate
  //--------------------------------------------------------------------------------


  SceneProcessor.prototype.getTooltipWithPath = function getTooltipWithPath(path) {
    return this._sceneInteractionManager.getTooltipWithPath(path);
  };

  SceneProcessor.prototype.onScroll = function onScroll(x, y, e) {
    this._sceneInteractionManager.scrollTo(x, y);
  };
  /**
  	 * This is for mobile only
  	 * Mobile renderer is in charge of its scrolling. This api is used to communicate a scroll happened to (x, y)
  	 * @param {*} x
  	 * @param {*} y
  	 */


  SceneProcessor.prototype.didScroll = function didScroll(x, y) {
    this._sceneRenderer.updateScrollPosition(x, y);

    this._sceneInteractionManager.updateScrollPosition(x, y);
  };

  SceneProcessor.prototype.onShowTable = function onShowTable() {
    this._chartInteractionDelegate.onShowTable();
  };

  SceneProcessor.prototype.onShowAccessibilityDataItems = function onShowAccessibilityDataItems() {
    return this._sceneInteractionManager.renderAccessibilityDataItems();
  };

  SceneProcessor.prototype.onMouseMove = function onMouseMove(x, y, e) {
    this._sceneInteractionManager.mouseMove(x, y, e);
  };

  SceneProcessor.prototype.onMouseDown = function onMouseDown(x, y, e) {
    this._sceneInteractionManager.mouseDown(x, y, e);
  };

  SceneProcessor.prototype.onMouseUp = function onMouseUp(x, y, e) {
    this._sceneInteractionManager.mouseUp(x, y, e);
  };

  SceneProcessor.prototype.onMouseClick = function onMouseClick(x, y) {
    this._sceneInteractionManager.mouseClick(x, y);
  };

  SceneProcessor.prototype.onMouseLeave = function onMouseLeave(x, y, e) {
    this._sceneInteractionManager.mouseLeave(x, y, e);
  };

  SceneProcessor.prototype.onTabOnShape = function onTabOnShape(keyPath) {
    this._sceneInteractionManager.tabOnShape(keyPath);
  };

  SceneProcessor.prototype.onTabOffShape = function onTabOffShape(keyPath) {
    this._sceneInteractionManager.tabOffShape(keyPath);
  };

  SceneProcessor.prototype.onKeyDown = function onKeyDown(key, e) {
    this._sceneInteractionManager.keyDown(key, e);
  };

  SceneProcessor.prototype.onKeyUp = function onKeyUp(key, e) {
    this._sceneInteractionManager.keyUp(key, e);
  }; // Dispatch event on chart, if cursor coordinates are part of
  // the params, convert the coords to include scene translation.
  // e.g. when interacting with legend, input (x, y) is relative to
  // legend scene, which has a translation relative to main chart, we
  // need to add this translation so the final event params provided
  // are all relative to main chart.


  SceneProcessor.prototype._trigger = function _trigger(name, params) {
    this._chartInteractionDelegate.onEvent(name, params);
  }; //
  //@flow-ignore
  //@flow-ignore


  var Legend = function (SceneProcesso____1) {
    function Legend(options) {
      options.rendererConfig.accessible = false;
      SceneProcesso____1.call(this, lodash__default.extend({}, options, {
        isLegend: true
      }));

      this._sceneRenderer.hide(); // keep track of legend visibility
      // note: can not rely on @scene0 for visibility since @scene0 only gets assigned when
      // animation is run. animation could be deferred when multiple ones are queued.


      this._isShowing = false;
    }

    if (SceneProcesso____1) Legend.__proto__ = SceneProcesso____1;
    Legend.prototype = Object.create(SceneProcesso____1 && SceneProcesso____1.prototype);
    Legend.prototype.constructor = Legend;

    Legend.prototype.render = function render(options, interrupt, type) {
      var this$1 = this;
      if (options === void 0) options = {
        duration: 0
      };
      if (interrupt === void 0) interrupt = false;

      if (this.isRemoved()) {
        return es6Promise.Promise.resolve();
      }

      if (this._sceneInteractionManager.hasScene()) {
        // hide -> show
        if (!this._isShowing) {
          this._sceneRenderer.show();

          this._isShowing = true;
        } // show -> show


        return SceneProcesso____1.prototype.render.call(this, options, true, type);
      } else {
        if (this._isShowing) {
          // show -> hide
          this._isShowing = false;
          return SceneProcesso____1.prototype.render.call(this, options, true, type).then(function (perf) {
            // only hide if at the end of the animation current
            // chart does not have legend. there could be a following
            // transition overriding legend visibility
            if (!this$1._isShowing) {
              this$1._sceneRenderer.hide();
            }

            return perf;
          });
        } else {
          // hide -> hide
          return es6Promise.Promise.resolve();
        }
      }
    };

    return Legend;
  }(SceneProcessor);

  var ChartContext = function ChartContext() {
    this._items = {};
    this._cellCtx = {};
    this._isResize = false;
  };

  ChartContext.prototype.remove = function remove() {
    this._items = {};
    this._cellCtx = {};
    return this;
  };

  ChartContext.prototype.setIsResize = function setIsResize(isResize) {
    this._isResize = isResize;
  };

  ChartContext.prototype.isResize = function isResize() {
    return this._isResize;
  };

  ChartContext.prototype.setItem = function setItem(name, value) {
    this._items[name] = value;
    return this;
  };

  ChartContext.prototype.getItem = function getItem(name) {
    return this._items[name];
  };

  ChartContext.prototype.getItems = function getItems() {
    return this._items;
  };

  ChartContext.prototype.removeItem = function removeItem(name) {
    delete this._items[name];
    return this;
  };

  ChartContext.prototype.getCellKeys = function getCellKeys() {
    return Object.keys(this._cellCtx);
  };

  ChartContext.prototype.setCellContext = function setCellContext(key, cellCtx) {
    this._cellCtx[key] = cellCtx;
    return this;
  };

  ChartContext.prototype.removeCellContext = function removeCellContext(key) {
    delete this._cellCtx[key];
    return this;
  };

  ChartContext.prototype.getCellContext = function getCellContext(key) {
    return this._cellCtx[key];
  };

  ChartContext.prototype.forEachCell = function forEachCell(callback) {
    var this$1 = this;
    this.getCellKeys().forEach(function (key) {
      callback(key, this$1.getCellContext(key));
    });
    return this;
  }; //-ignore
  //@flow-ignore
  //@flow-ignore


  var chartCounter = counter$1.init('Chart');
  var renderCounter = counter$1.init('Render');

  var Chart$1 = function Char____1(options, chartCache, tooltip, scriptRunFct) {
    // if a base default duration is specified, use this as the base for all the other durations
    var swipePropagation, tooltipCSSClass, wheelPropagation;

    if (options == null) {
      options = {};
    }

    options.chartCache = chartCache;
    options.tooltip = tooltip;
    options.scriptRunFct = scriptRunFct;
    var baseDuration;

    if (options.durations != null && options.durations['default'] != null) {
      baseDuration = options.durations['default'];
    } else {
      baseDuration = constants$1.ANIM_DURATION.DEFAULT;
    }

    var defaultDurations = {
      "default": baseDuration,
      select: baseDuration / 2,
      scroll: baseDuration / 2,
      firstRender: baseDuration / 2,
      resize: baseDuration / 2,
      resizeDebounce: constants$1.ANIM_DURATION.RESIZE_DEBOUNCE
    };
    this._durations = lodash__default.extend(defaultDurations, options.durations);
    this._forceOutOfViewport = false;
    this._firstRender = true;
    this._skippedRender = false;
    this.renderOnDemand = true;
    this._lastRenderParams = null;
    this._currentRenderId = renderCounter.next();
    this._currentRenderPromise = null;
    this._runtimeChart = null;
    this._context = new ChartContext();
    options.name = options.name || "chart_" + chartCounter.next();
    lodash__default.extend(this, options); // conver to fully qualified padding

    this.padding = Math.max(this.padding != null ? this.padding : 0, 0);
    this.padding = {
      top: this.padding,
      bottom: this.padding,
      left: this.padding,
      right: this.padding
    }; // ideally we would just extend Events.Dispatcher but we are already extending SceneProcessor
    // the mixin method allows us to simulate multiple inheritance here...

    Events.Dispatcher.prototype.mixin(this, this.name);

    if (this.rendererConfig != null) {
      var assign;
      assign = this.rendererConfig, tooltipCSSClass = assign.tooltipCSSClass, wheelPropagation = assign.wheelPropagation, swipePropagation = assign.swipePropagation;
    }

    this._sceneProcessors = {
      main: new SceneProcessor({
        rendererConfig: this.rendererConfig,
        padding: this.padding,
        name: this.name,
        tooltip: this.tooltip,
        durations: this._durations
      }),
      legend: new Legend({
        rendererConfig: {
          tooltipCSSClass: tooltipCSSClass,
          wheelPropagation: wheelPropagation,
          swipePropagation: swipePropagation
        },
        name: "legend_" + this.name,
        tooltip: this.tooltip,
        durations: this._durations
      })
    }; // append legend DOM to main chart DOM

    if (envUtils.inBrowser()) {
      this._sceneProcessors.main.getElement().appendChild(this._sceneProcessors.legend.getElement());

      this.annotationsContainerEl = document.createElement("div");
      this.annotationsContainerEl.className = "ng-annotations-container";
      utils$3.setStyles(this.annotationsContainerEl, {
        marginTop: this.padding.top + "px",
        marginBottom: this.padding.bottom + "px",
        marginLeft: this.padding.left + "px",
        marginRight: this.padding.right + "px"
      });

      var chartEl = this._sceneProcessors.main.getElement();

      chartEl.appendChild(this.annotationsContainerEl);
    }

    this._chartInteractionManager = new ChartInteractionManager(this._sceneProcessors, this);
    this.chartCache.add(this.name, this);
    this._moduleDelegate = this._getModuleDelegate();
  };

  Chart$1.prototype._getModuleDelegate = function _getModuleDelegate() {
    var this$1 = this;

    var chartDelegate = this._chartInteractionManager._getChartDelegate("main");

    return lodash__default.extend({
      createCustomDOM: function createCustomDOM() {
        return this$1._sceneProcessors.main.createCustomDOM();
      },
      removeCustomDOM: function removeCustomDOM(el) {
        return this$1._sceneProcessors.main.removeCustomDOM(el);
      },
      showTooltip: function showTooltip(row, color, columns) {
        this$1._sceneProcessors.main._sceneInteractionManager.showTooltip(null, row, color, columns);
      },
      moveTooltip: function moveTooltip() {
        this$1._sceneProcessors.main._sceneRenderer.moveTooltip();
      },
      hideTooltip: function hideTooltip() {
        this$1._sceneProcessors.main._sceneInteractionManager.hideTooltip();
      },
      renderEnd: function renderEnd() {
        this$1.trigger(constants$1.EVENT_NAME.RENDER_END, {
          type: constants$1.RENDER_TYPE.UPDATE
        });
      }
    }, chartDelegate);
  };

  Chart$1.prototype.getContext = function getContext() {
    return this._context;
  };

  Chart$1.prototype.remove = function remove() {
    this._removeRuntimeChart();

    this._chartInteractionManager.setAnnotations([]);

    this._sceneProcessors.main.remove();

    this._sceneProcessors.legend.remove();

    if (this.annotationsContainerEl) {
      this.annotationsContainerEl.parentElement.removeChild(this.annotationsContainerEl);
    }

    this.off();
    this.chartCache.remove(this.name);
  };

  Chart$1.prototype.isRemoved = function isRemoved() {
    return this._chartInteractionManager.isRemoved();
  };

  Chart$1.prototype.getSceneProcessors = function getSceneProcessors() {
    return this._sceneProcessors;
  };

  Chart$1.prototype.resize = function resize(width, height, duration) {
    if (width === (this.size != null ? this.size[0] : undefined) && height === (this.size != null ? this.size[1] : undefined)) {
      return es6Promise.Promise.resolve();
    }

    this.size = [width, height];

    if (this.scriptPath) {
      var options = {
        duration: duration != null ? duration : this._durations.resize,
        // resize should keep current selection
        selection: this.getSelection(),
        annotations: this.getAnnotations(),
        version: this.options.version
      };
      return this.render(this.scriptPath, this.config, this.rows, this.rowsMetadata, options, null, true);
    }

    return es6Promise.Promise.resolve();
  }; // render a promise, resolved when chart finish animating,rejects
  // if size is not set properly or any error is caught
  //
  // @param scriptPath {String} path of script previously registered
  // @param config {Object} chart config
  // @param rows {Array<Object>} array of rows
  // @param rowsMetadata {Array} metadata for rows
  // @param options {Object} rendering options (see renderScene)
  // @param force {Boolean} force rendering
  // @param isResize {Boolean} whether render is resize
  // @return {Promise} resolve when render completes


  Chart$1.prototype.render = function render(scriptPath, config, rows, rowsMetadata, options, force, isResize) {
    var this$1 = this;
    this.scriptPath = scriptPath;
    this.config = config;
    this.rows = rows;
    this.rowsMetadata = rowsMetadata;

    if (options == null) {
      options = {};
    }

    this.options = options;

    if (force == null) {
      force = false;
    }

    if (this.isRemoved()) {
      return es6Promise.Promise.resolve();
    } // if size hasn't been set (either in the constructor or by calling resize) then don't draw anything


    if (!this.size) {
      return es6Promise.Promise.resolve();
    } // to be backward compatible with lightning dashboard
    // will remove after updating lighting dashboard code


    if (dataUtils.isPlainObject(this.rowsMetadata)) {
      this.options = this.rowsMetadata;
      this.rowsMetadata = undefined;
    } // validate size


    if (!this._isSizeValid(this.size)) {
      var error = this.name + " (" + this.scriptPath + ") -> invalid size: " + this.size;
      this.trigger(constants$1.EVENT_NAME.ERROR, error);
      console.error(error);
      return es6Promise.Promise.reject(error);
    } // only render when size is not [0, 0]


    if (!this._shouldRenderWithSize(this.size)) {
      return es6Promise.Promise.resolve();
    } // perf transaction instance for profiling render


    var mainPerf = this._perfStart({
      chartScript: this.scriptPath,
      numRows: this.rows.length,
      isTrellis: configUtils.isTrellis(this.config),
      renderStatus: constants$1.RENDER_STATUS.OK
    }); // check if chart is visible in viewport
    // if not, don't render (yet). Let's wait until the chart is visible to invoke the render code


    this._skippedRender = this.renderOnDemand && !this.isInViewport() && !force;

    if (this._skippedRender) {
      if (log$1.rendering) {
        console.debug("Not in view -> skipped rendering " + this.name);
      }

      this._renderSkipped(mainPerf);

      return es6Promise.Promise.resolve();
    }

    if (this._firstRender) {
      // first render/resize: we don't delay the animation
      // we also start throttling the next resizes...
      this._firstRender = false;
      this.resize = debounce(this.resize, this._durations.resizeDebounce);
      this.options.duration = this._durations.firstRender;
      this.options.disableMorphing = this.options.disableMorphingOnFirstRender;
    } else {
      if (this.options.duration == null) {
        this.options.duration = this._durations['default'];
      }

      this.options.disableMorphing = false;
    }

    this.config.size = this.size;
    this.config.padding = this.padding; // sometimes there is a delay in updation of div size, so the annotations think they are out of the viewport
    // to avaoid such a case, we explicitely set the size on the annotation container div

    if (this.annotationsContainerEl) {
      utils$3.setStyles(this.annotationsContainerEl, {
        width: this.size[0] - this.padding.left - this.padding.right + "px",
        height: this.size[1] - this.padding.top - this.padding.bottom + "px"
      });
    }

    if (this.config.transforms == null) {
      this.config.transforms = {};
    }

    if (!this.rows) {
      this.rows = [];
    }

    if (force) {
      if (log$1.rendering) {
        console.debug("Force rendering " + this.name);
      }
    } else if (this._hasChartStructureChanged()) {
      if (log$1.rendering) {
        console.debug("Some params changed -> rendering " + this.name);
      }
    } else if (this._hasDecorationChanged()) {
      if (log$1.rendering) {
        console.debug("Decorations changed -> setting decorations for " + this.name);
      }

      this.setAnnotations(this.options.annotations);
      this.setSelection(this.options.selection, {
        silent: true
      });

      this._renderSkipped(mainPerf);

      return es6Promise.Promise.resolve();
    } else {
      if (log$1.rendering) {
        console.debug("No params changed -> skipped rendering " + this.name);
      }

      this._renderSkipped(mainPerf);

      return es6Promise.Promise.resolve();
    }

    this._saveRenderParams();

    if (log$1.debugParams) {
      console.log(new Date().toLocaleTimeString() + "|rendering " + this.name, this._lastRenderParams);
    }

    this.hideTooltip();
    var _config = null;
    var _rows = null;
    var _rowsMetadata = null;
    var currentRenderId = this._currentRenderId = renderCounter.next();

    var currentRenderPromise = this._currentRenderPromise = this._chartInteractionManager.scrollTo(0, 0, this._durations.scroll).then(function (ref) {
      var mainScrollPerf = ref[0];
      var legendScrollPerf = ref[1];

      if (mainScrollPerf) {
        mainPerf.merge(mainScrollPerf.toJson(), 'resetScroll');
      }

      if (legendScrollPerf) {
        mainPerf.merge(legendScrollPerf.toJson(), 'resetScroll');
      }

      if (currentRenderId !== this$1._currentRenderId) {
        throw new RenderingException();
      }

      _config = dataUtils.deepCopy(config);
      _rows = dataUtils.deepCopy(rows);
      _rowsMetadata = dataUtils.deepCopy(rowsMetadata);
      mainPerf.endMark('resetScroll');
      var state; // @patrice please take a look

      if (this$1._sceneProcessors.main && this$1._sceneProcessors.main.scene) {
        state = this$1._sceneProcessors.main.scene.state;
      }

      this$1._context && this$1._context.setIsResize(isResize); // this._removeRuntimeChart(chart);

      return this$1.scriptRunFct({
        moduleName: scriptPath,
        moduleVersion: options.version,
        config: _config,
        rows: _rows,
        rowsMetadata: _rowsMetadata,
        perf: mainPerf,
        props: state,
        delegate: this$1._moduleDelegate,
        context: this$1._context,
        runtimeChart: this$1._runtimeChart
      });
    }).then(function (ref) {
      var chart = ref.chart;
      var scene = ref.scene;
      var scriptPerf = ref.scriptPerf;
      var moduleLoader = ref.moduleLoader; // merge perf report from script execution to current transaction

      mainPerf.merge(scriptPerf);

      if (currentRenderId !== this$1._currentRenderId) {
        // current render is interrupted, chart instance is created anyways, needs to remove and cleanup
        chart.remove();
        throw new RenderingException();
      } // keep track of current runtime chart


      this$1._setRuntimeChart(chart);

      if (moduleLoader && (!moduleLoader.isTrusted() || options.version && options.version != apiVersion.version)) {
        // if the scene is not trusted or if the chart is not using  the latest sdk version
        // we must serialize and recreate it from its serialized representation
        var sceneJson = moduleLoader.evaluate(JSON.stringify(scene.toJson()));
        scene = NodeFactory$1.getInstance().fromJson(sceneJson, true); // XXX: need to find a way to serialize/deserialize the dataFormatter

        scene._props.dataFormatter = null;
      }

      if (scene.legend) {
        scene.legend.postProcess();
      }

      scene.postProcess();
      var selection = options.selection;
      var annotations = options.annotations;

      this$1._chartInteractionManager.onNewScenes({
        main: scene,
        legend: scene.legend
      }, _config, _rows, chart).setSelection(selection, {
        silent: true,
        skipRender: true
      }).setAnnotations(annotations);

      return es6Promise.Promise.all([this$1._sceneProcessors.main.render(options, false, constants$1.RENDER_TYPE.UPDATE), this$1._sceneProcessors.legend.render(options, false, constants$1.RENDER_TYPE.UPDATE)]);
    }).then(function (ref) {
      var scenePerf = ref[0];
      var legendPerf = ref[1];

      if (scenePerf) {
        mainPerf.merge(scenePerf.toJson());
      }

      if (legendPerf) {
        mainPerf.merge(legendPerf.toJson(), "legend");
      }

      currentRenderPromise = null;
      return this$1._perfEnd(mainPerf);
    }).catch(function (error) {
      currentRenderPromise = null;

      if (error instanceof RenderingException) {
        if (log$1.rendering) {
          console.debug(this$1.name + " (" + scriptPath + ") -> rendering is outdated: skipped rendering");
        }

        mainPerf.updateInfo({
          renderStatus: constants$1.RENDER_STATUS.SKIPPED
        }); // trigger skipped render immediately, do not chain it on current render promise,
        // which is a later render call

        return this$1._renderSkipped(mainPerf, true);
      } else {
        this$1.trigger(constants$1.EVENT_NAME.ERROR, error);
        console.error(this$1.name + " (" + scriptPath + ") ->", error);
        console.error(error.stack);
        throw error;
      }
    });

    return currentRenderPromise;
  }; // Processes the main and legend views onto a canvas in the correct positions
  // and returns that canvas and its size in a Promise
  //
  // @param inputCanvas {Object} optional canvas onto which to compose the screenshot
  // @return {Promise} that resolves when the screenshot is finished drawing, returns the screenshot and its size


  Chart$1.prototype.getScreenShot = function getScreenShot(inputCanvas) {
    if (this.isRemoved()) {
      return;
    }

    return this._chartInteractionManager.screenshot(inputCanvas, this.size);
  }; // Stop all mouse interaction with chart. Any mouse event will not trigger chart
  // changes(hover, click). This will freeze the chart at the state when this method
  // is called. Note setSelection will still work since it is not mouse interaction


  Chart$1.prototype.stopMouseInteraction = function stopMouseInteraction() {
    if (this.isRemoved()) {
      return;
    }

    return this._chartInteractionManager.stopInteraction();
  }; // Start mouse interaction with chart. If stopInteraction was previously called,
  // this method will restart mouse interaction with chart.


  Chart$1.prototype.startMouseInteraction = function startMouseInteraction() {
    if (this.isRemoved()) {
      return;
    }

    return this._chartInteractionManager.startInteraction();
  };

  Chart$1.prototype.hideTooltip = function hideTooltip() {
    if (this.isRemoved()) {
      return;
    }

    return this._chartInteractionManager.hideTooltip();
  };

  Chart$1.prototype.onMouseLeave = function onMouseLeave() {
    if (this.isRemoved()) {
      return;
    }

    return this._chartInteractionManager.onMouseLeave();
  };

  Chart$1.prototype.onShowTable = function onShowTable() {
    this._chartInteractionManager.renderAccessibilityTable(this.rows);
  }; // TODO alice - expose a proper way to export information from script runtime
  // autoFitRatio is used by S1


  Chart$1.prototype.getAutoFitRatio = function getAutoFitRatio() {
    return this._chartInteractionManager.getAutoFitRatio();
  };

  Chart$1.prototype.getEvents = function getEvents() {
    return Chart.EVENTS;
  }; //--------------------------------------------------------------------------------
  // on demand rendering
  //--------------------------------------------------------------------------------
  // This method allows you to force a chart out of the viewport
  // This enables the chart to not participate in the viewport monitoring sequence anymore
  // (say if you want to hide the chart, but not fully remove it, so you can bring it back quickly if needed)
  //
  // @param forceOutOfViewport {Boolean}
  //   true: the chart is considered to be out of the viewport (the chart won't render anymore)
  //   false: the regular (real) viewport is used (the chart renders if it is inside the visible window...)


  Chart$1.prototype.forceOutOfViewport = function forceOutOfViewport(_forceOutOfViewport) {
    this._forceOutOfViewport = _forceOutOfViewport;
  }; // @return {Boolean} true if any of the params relevant to drawing the chart has changed


  Chart$1.prototype._hasChartStructureChanged = function _hasChartStructureChanged() {
    if (!this._lastRenderParams) {
      return true;
    } // note that we don't do a full isEqual: we are trying the fields one by one,
    // except for rows, where we do a simple pointer comparison (for optimization)


    var ref = this._getRenderParams();

    var scriptPath = ref.scriptPath;
    var size = ref.size;
    var config = ref.config;
    var rows = ref.rows;
    var rowsMetadata = ref.rowsMetadata;
    return !(scriptPath === this._lastRenderParams.scriptPath && dataUtils.deepEqual(size, this._lastRenderParams.size) && dataUtils.deepEqual(config, this._lastRenderParams.config) && dataUtils.deepEqual(rowsMetadata, this._lastRenderParams.rowsMetadata) && dataUtils.deepEqual(rows, this._lastRenderParams.rows));
  }; // @return {Boolean} true if any of the params relevant to decorations have changed


  Chart$1.prototype._hasDecorationChanged = function _hasDecorationChanged() {
    if (!this._lastRenderParams) {
      return true;
    } // check of the selection or annotations changed


    var ref = this._getRenderParams();

    var selection = ref.selection;
    var annotations = ref.annotations;
    return !dataUtils.deepEqual(annotations, this._lastRenderParams.annotations) || !dataUtils.deepEqual(selection, this._lastRenderParams.selection);
  };

  Chart$1.prototype._getRenderParams = function _getRenderParams() {
    return {
      scriptPath: this.scriptPath,
      config: this.config,
      rows: this.rows,
      rowsMetadata: this.rowsMetadata,
      selection: this.options.selection,
      size: this.size,
      annotations: this.options.annotations
    };
  };

  Chart$1.prototype._saveRenderParams = function _saveRenderParams() {
    // note that we don't do a full deepCopy: we are doing a deepCopy for all the fields,
    // except for rows, where we do a simple pointer assignment (for optimization)
    var ref = this._getRenderParams();

    var scriptPath = ref.scriptPath;
    var size = ref.size;
    var config = ref.config;
    var selection = ref.selection;
    var rows = ref.rows;
    var rowsMetadata = ref.rowsMetadata;
    var annotations = ref.annotations;
    this._lastRenderParams = dataUtils.deepCopy({
      scriptPath: scriptPath,
      size: size,
      config: config,
      selection: selection,
      rowsMetadata: rowsMetadata,
      annotations: annotations
    });
    this._lastRenderParams.rows = rows;
    return this._lastRenderParams;
  }; // @return {Boolean} true if chart is currently visible in viewport


  Chart$1.prototype.isInViewport = function isInViewport() {
    if (this._forceOutOfViewport) {
      return false;
    }

    if (this.isRemoved()) {
      return false;
    }

    if (!this.size) {
      return false;
    }

    if (!this._shouldRenderWithSize(this.size)) {
      return false;
    }

    return this._chartInteractionManager.isInViewport(this.size);
  }; // @return {Boolean} true if the preview call to render was skipped
  // (because the chart was not in the viewport)


  Chart$1.prototype.hasSkippedRender = function hasSkippedRender() {
    return this._skippedRender;
  }; // force a render of the chart, regardless of whether it is in the viewport or not


  Chart$1.prototype.forceRender = function forceRender() {
    return this.render(this.scriptPath, this.config, this.rows, this.rowsMetadata, this.options, true);
  }; //--------------------------------------------------------------------------------
  // selection
  //--------------------------------------------------------------------------------
  // Set the selection programmatically on chart. It will override the current selection.
  //
  // @param {Array<String>} selection list of shape keys to select
  // @param {Object} options
  //        - skipRender {Boolean} whether to skip rendering


  Chart$1.prototype.setSelection = function setSelection(selection, options) {
    if (this.isRemoved()) {
      return this;
    }

    lodash__default.extend(this._lastRenderParams, dataUtils.deepCopy({
      selection: selection
    }));

    this._chartInteractionManager.setSelection(selection, options);

    return this;
  }; // Get the current selection on chart


  Chart$1.prototype.getSelection = function getSelection() {
    if (this.isRemoved()) {
      return [];
    }

    return this._chartInteractionManager.getSelection();
  }; //--------------------------------------------------------------------------------
  // annotations
  //--------------------------------------------------------------------------------


  Chart$1.prototype.setAnnotations = function setAnnotations(annotations) {
    if (this.isRemoved()) {
      return this;
    }

    lodash__default.extend(this._lastRenderParams, dataUtils.deepCopy({
      annotations: annotations
    }));

    this._chartInteractionManager.setAnnotations(annotations);

    return this;
  };

  Chart$1.prototype.getAnnotations = function getAnnotations() {
    if (this.isRemoved()) {
      return [];
    }

    return this._chartInteractionManager.getAnnotations();
  }; //--------------------------------------------------------------------------------
  // misc
  //--------------------------------------------------------------------------------


  Chart$1.prototype.getRuntimeChart = function getRuntimeChart() {
    return this._runtimeChart;
  };

  Chart$1.prototype._setRuntimeChart = function _setRuntimeChart(runtimeChart) {
    this._runtimeChart = runtimeChart;
    return this;
  };

  Chart$1.prototype._removeRuntimeChart = function _removeRuntimeChart(nextChart) {
    if (this._runtimeChart) {
      this._runtimeChart.remove(this._context, nextChart);

      this._runtimeChart = null;
    }
  }; // Validate chart size, valid only when it is array of two non-negative numbers
  //
  // @param size {Array} [width, height]


  Chart$1.prototype._isSizeValid = function _isSizeValid(size) {
    return lodash__default.isArray(size) && size.length === 2 && size[0] >= 0 && size[1] >= 0;
  }; // If a valid chart size should trigger render
  //
  // @param size {Array} [width, height]


  Chart$1.prototype._shouldRenderWithSize = function _shouldRenderWithSize(size) {
    return size[0] > 0 && size[1] > 0;
  };

  Chart$1.prototype._perfStart = function _perfStart(info) {
    return new Perf({
      name: 'render'
    }).start(info);
  }; // Due to legacy behavior, we have several markers that measure async operations
  // This function sum up all the sync operations and produce a number reflecting the actual time spend on this library


  Chart$1.prototype._syncDuration = function _syncDuration(perf) {
    if (!perf || perf.marks["animate-defer"]) {
      return;
    }

    var marks = perf.marks;
    var sceneProcessingCost = ['animate-scene-diff', 'animate-scene-toModel', 'animate-scene-rendering'].reduce(function (sum, x) {
      var mainChartTime = marks[x] && marks[x].duration || 0;
      var legendTime = marks["legend-" + x] && marks["legend-" + x].duration || 0;
      return sum + mainChartTime + legendTime;
    }, 0);
    return sceneProcessingCost + this._getDuration(perf, 'script') + this._getDuration(perf, 'resetScroll-rendering');
  };

  Chart$1.prototype._getDuration = function _getDuration(perf, name) {
    return perf.marks[name] && perf.marks[name].duration || 0;
  };

  Chart$1.prototype._perfEnd = function _perfEnd(perf) {
    perf.end();
    var json = perf.toJson();
    json.syncDuration = this._syncDuration(json);
    this.trigger(constants$1.UNDOCUMENTED_EVENTS.PERF_READY, json);

    if (log$1.perf) {
      return Perf.prettyPrint(json);
    }
  };

  Chart$1.prototype._renderSkipped = function _renderSkipped(mainPerf, instant) {
    var this$1 = this;

    var renderSkipCallback = function renderSkipCallback() {
      this$1.trigger(constants$1.EVENT_NAME.RENDER_SKIPPED, {
        type: constants$1.RENDER_TYPE.UPDATE
      });

      this$1._perfEnd(mainPerf);
    }; // end perf metric immediately and update status, though perfReady may be triggered later, chained to
    // current inflight render's promise


    mainPerf.end().updateInfo({
      renderStatus: constants$1.RENDER_STATUS.SKIPPED
    });

    if (this._currentRenderPromise && !instant) {
      this._currentRenderPromise.finally(renderSkipCallback);
    } else {
      // trigger event async
      setTimeout(renderSkipCallback, 1);
    }
  };

  var RenderingException = function RenderingException() {};

  var name$2 = "wave-charts";
  var version$1 = "0.1.0";
  var description = "WaveCharts Library and Components";
  var main = "index.js";
  var scripts = {
    "test": "echo \"Error: no test specified\" && exit 1"
  };
  var author = "Salesforce";
  var license = "SEE LICENSE IN README.md";
  var peerDependencies = {
    "react": "^15.6.2",
    "react-dom": "^15.6.2",
    "prop-types": ">=15.6.0"
  };
  var dependencies = {
    "ajv": "6.5.0",
    "ajv-merge-patch": "3.0.0",
    "lodash": "4.17.4",
    "es6-promise": "4.2.4",
    "luxon": "1.2.0",
    "css-element-queries": "0.4.0",
    "classnames": "2.2.5",
    "react-image-crop": "3.0.9",
    "perfect-scrollbar": "git+ssh://git@git.soma.salesforce.com/insights/perfect-scrollbar.git#v0.6.7.942dd45"
  };
  var packageJson = {
    name: name$2,
    version: version$1,
    description: description,
    main: main,
    scripts: scripts,
    author: author,
    license: license,
    peerDependencies: peerDependencies,
    dependencies: dependencies
  }; //
  //@flow-ignore
  // @bug W-3909853: closure was renaming register so we can't just do "eval(source)" here
  //@flow-ignore

  var defaultScriptEvaluator = function defaultScriptEvaluator(source, register) {
    return new Function("register", source)(register);
  };

  var defaultResourceLoader = function defaultResourceLoader(url) {
    return ServiceProvider$1.getDelegate().require(url);
  };
  /**
   *  Abstract Module Loader for EclairNG
   */


  var AbstractModuleLoader = function AbstractModuleLoader() {
    // in-flight and failed module promises
    this._pending = {}; // the resource loader to use to load a module from its url

    this._resourceLoader = defaultResourceLoader; // prefix for relative module paths

    this._prefix = ""; // evaluator for script source code

    this._scriptEvaluator = defaultScriptEvaluator; // default is not trusted

    this._isTrusted = false;
  };
  /**
  	 * Configures the module loader
  	 *
  	 * @param prefix The prefix to append to relative module urls
  	 *        The prefix allows us to build an absolute url for the modules
  	 * @param resourceLoader The loader to use to load urls
  	 *        The loader is a function that takes a url and returns a Promise
  	 *        for the module's source
  	 * @param scriptEvaluator An evaluator to 'eval' the script source code
  	 *        The scriptEvaluator is a function that can eval source code
  	 * @param isTrusted whether this module loader loads trusted modules
  	 *
  	 */


  AbstractModuleLoader.prototype.configure = function configure(ref) {
    var prefix = ref.prefix;
    var resourceLoader = ref.resourceLoader;
    var scriptEvaluator = ref.scriptEvaluator;
    var isTrusted = ref.isTrusted;

    if (prefix != null) {
      this._prefix = prefix;
    }

    if (resourceLoader != null) {
      this._resourceLoader = resourceLoader;
    }

    if (scriptEvaluator != null) {
      this._scriptEvaluator = scriptEvaluator;
    }

    if (isTrusted != null) {
      this._isTrusted = isTrusted;
    }

    return this;
  };
  /**
  	 *  Check if a module has already (succesfully) been loaded
  	 *
  	 *  @param moduleName the name of the module
  	 *  @param moduleVersion the version of the module
  	 *  @return true iff the module has been succesfully loaded
  	 */


  AbstractModuleLoader.prototype.hasModule = function hasModule(moduleName, moduleVersion) {
    throw "Not Implemented";
  };
  /**
  	 *  Dynamically loads a module by name
  	 *
  	 *  @param moduleName the module to load
  	 *  @param moduleVersion the version to load
  	 *  @param perf the perf to use to track performance
  	 *  @return a Promise for the module
  */


  AbstractModuleLoader.prototype.require = function require(moduleName, moduleVersion, perf) {
    throw "Not Implemented";
  };

  AbstractModuleLoader.prototype.isTrusted = function isTrusted() {
    return this._isTrusted;
  };

  AbstractModuleLoader.prototype.getScriptEvaluator = function getScriptEvaluator() {
    return this._scriptEvaluator;
  };

  AbstractModuleLoader.prototype.evaluate = function evaluate(expression) {
    return this._scriptEvaluator("return " + expression + ";");
  };

  AbstractModuleLoader.prototype.getResourceLoader = function getResourceLoader() {
    return this._resourceLoader;
  };

  AbstractModuleLoader.prototype._log = function _log(moduleKey, message) {
    if (log$1.moduleLoader) {
      console.log("%cModuleLoader: [" + moduleKey + "] " + message, 'color: green');
    }
  };

  AbstractModuleLoader.prototype._getModuleKey = function _getModuleKey(moduleName, moduleVersion) {
    return moduleVersion + "/" + moduleName;
  };
  /**
   Interface for CellRenderers.
   Cell renderers are responsible for rendering the contents of a scene cell.
  */


  var CellRenderer = function CellRenderer() {};

  CellRenderer.prototype.render = function render(chart, cell, cellRendererConfig, renderingContext) {};

  CellRenderer.prototype.getCellRendererConfig = function getCellRendererConfig() {
    return {
      // should we display the cell
      display: true,
      // should we create a layer for the cell
      createLayer: true,
      adjustRowToFit: false,
      adjustColumnToFit: false,
      // offset the layer created
      offsetX: 0,
      offsetY: 0
    };
  }; // apply offsets to a layer within cell
  // @param key {stirng} layer key


  CellRenderer.prototype._applyOffsets = function _applyOffsets(cell, key, cellRendererConfig) {
    var offsetX = cellRendererConfig.offsetX;
    var offsetY = cellRendererConfig.offsetY;
    var layer = cell.getChildByKey(key);

    if (layer) {
      layer.offsetX(offsetX);
      layer.offsetY(offsetY);
    }
  };

  var rowsFormatter$2 = RowsFormatter$1.getInstance();
  var defaultTheme$1 = ThemeFactory.getInstance().getDefaultTheme();
  var ICON_SIZE = constants$1.ICON.SIZE; // icon size (assuming the icon fits in a square box)

  var ICON_TEXT_PADDING = constants$1.ICON.TEXT_PADDING; // distance between the text and the icon

  function _majorTicks(scale, formatter, desiredTickDistance) {
    var range = scale.range();
    var fullRange = Math.abs(range[1] - range[0]);
    var numTicks = Math.round(fullRange / desiredTickDistance); // make sure we don't have duplicate tick values after applying the formatter

    var majorTicks = []; // array of major ticks

    var tickTexts = []; // array of formatted tick texts

    var uniqueTicks = false;
    var minTick;
    var maxTick;
    majorTicks = scale.ticks(numTicks);
    numTicks = majorTicks.length;

    while (numTicks >= 1) {
      if (majorTicks.length <= 1) {
        var domain = scale.domain();
        minTick = domain[0];
        maxTick = domain[1];

        if (minTick < 0 && maxTick > 0) {
          if (maxTick === -minTick) {
            majorTicks = [minTick, 0, maxTick];
          } else if (maxTick > -minTick) {
            majorTicks = [0, maxTick];
          } else {
            majorTicks = [minTick, 0];
          }
        } else {
          majorTicks = [minTick, maxTick];
        }
      }

      tickTexts = majorTicks.map(formatter); // if the ticks texts are unique, we are good to go, otherwise, we try with one less tick...

      var uniqueTickTexts = dataUtils.uniq(tickTexts);

      if (uniqueTickTexts.length === tickTexts.length) {
        uniqueTicks = true;
        break;
      }

      numTicks--;
      majorTicks = scale.ticks(numTicks, true);
    }

    if (!uniqueTicks && majorTicks.length > 1) {
      // we are in trouble... the tick function couldn't produce separate ticks...
      // (sometimes scale.ticks(1) returns 2 ticks...)
      minTick = majorTicks[0];
      maxTick = lodash__default.last(majorTicks);

      if (minTick < 0 && maxTick > 0) {
        // zero is in there
        majorTicks = [0];
      } else if (minTick === 0 || maxTick === 0) {
        if (tickTexts[0] === lodash__default.last(tickTexts)) {
          majorTicks = [0];
        } else {
          majorTicks = [minTick, maxTick];
        }
      } else {
        majorTicks = [majorTicks[0]];
      }
    }

    return majorTicks;
  }

  function xNumbers(params) {
    var CONSTANTS = constants$1.AXIS.NUM;
    var defaultParams = {
      key: "axis",
      gridLineLength: 0,
      drawAxisLine: false,
      drawGridLines: true,
      drawAxis: true,
      drawLabels: true
    };
    lodash__default.defaults(params, defaultParams);
    var theme = params.theme || defaultTheme$1;
    var cell = params.cell;
    var scale = params.scale;
    var format = params.format;
    var gridLineLength = params.gridLineLength;
    var drawAxisLine = params.drawAxisLine;
    var drawGridLines = params.drawGridLines;
    var drawAxis = params.drawAxis;
    var key = params.key;
    var drawLabels = params.drawLabels;
    var layer = params.layer || new Layer({
      cell: cell,
      key: key,
      staggerAnim: false,
      canSelect: false
    });
    var domain = scale.domain();
    var range = scale.range();

    if (drawAxis) {
      var formatter = formatNumber(format, true, true);
      var rotated = cell.getScene().get("transforms").rotate;
      drawGridLines = drawGridLines && gridLineLength; // we actually do not want the text rotated when we rotate the chart so we do something special here

      var baseTextConfig = rotated ? {
        halign: "left",
        valign: "middle",
        vertical: true
      } : {
        halign: "center",
        valign: "bottom"
      }; // roughly try to have 1 tickmark every 100 mixels

      var fullRange = Math.abs(range[1] - range[0]);
      var ref = CONSTANTS.TICKMARK;
      var HORI_DISTANCE = ref.HORI_DISTANCE;
      var VERTI_DISTANCE = ref.VERTI_DISTANCE;

      var majorTicks = _majorTicks(scale, formatter, rotated ? VERTI_DISTANCE : HORI_DISTANCE);

      var tickTexts = majorTicks.map(formatter);
      majorTicks.forEach(function (tick, index) {
        // tickmark text (only for major ticks)
        if (drawLabels) {
          new Text$1(lodash__default.extend({
            layer: layer,
            x: tick,
            y: -8,
            stroke: theme.getMeasureAxisTickLabelColor(),
            text: tickTexts[index],
            key: "text" + tick
          }, baseTextConfig));
        } // small marker with axis line


        if (drawAxisLine) {
          new Line$2({
            layer: layer,
            x0: tick,
            y0: -3,
            x1: tick,
            y1: 4,
            stroke: theme.getMeasureAxisTickMarkColor(),
            key: "marker" + tick
          });
        } // long vertical line


        if (drawGridLines) {
          new Line$2({
            layer: layer,
            x0: tick,
            y0: -3,
            x1: tick,
            y1: 3 + gridLineLength,
            stroke: theme.getMeasureAxisGridLineColor(),
            key: "line" + tick
          });
        }
      }); // long horizontal axis line

      if (drawAxisLine) {
        new Line$2({
          layer: layer,
          x0: domain[0],
          y0: 0,
          x1: domain[1],
          y1: 0,
          stroke: theme.getMeasureAxisLineColor(),
          key: "longline"
        });
      }
    } // keep scale on layer


    layer.set({
      scales: {
        x: scale
      },
      y: cell.get("h")
    });

    if (drawAxis) {
      // adjust the first and last tick label to ensure they are fully visible within the range
      var tickShapes = layer.find({
        key: /^text/
      });
      var nbTicks = tickShapes.length;

      if (nbTicks > 0) {
        // first tick
        var firstTick = tickShapes[0];
        var firstTickBb = firstTick.boundingBox();
        var firstTickLeft = firstTickBb.x; // make sure it doesn't go too much to the left

        if (firstTickLeft < range[0]) {
          firstTick.offsetX(range[0] - firstTickLeft);

          if (nbTicks > 1) {
            // now that we have shifted the tick, it might overlap with the next tick...
            firstTickBb = firstTick.boundingBox(); // need to recompute since we justs changed offset

            var firstTickRight = firstTickBb.x + firstTickBb.w;
            var secondTick = tickShapes[1];
            var secondTickBb = secondTick.boundingBox();
            var secondTickLeft = secondTickBb.x;

            if (firstTickRight > secondTickLeft - CONSTANTS.TICKLABEL.PADDING) {
              var overflow = firstTickRight - (secondTickLeft - CONSTANTS.TICKLABEL.PADDING);
              var hideTick = true;

              if (nbTicks > 2) {
                var thirdTick = tickShapes[2];
                var thirdTickBb = thirdTick.boundingBox();
                var secondTickRight = secondTickBb.x + secondTickBb.w;

                if (secondTickRight + overflow < thirdTickBb.x - CONSTANTS.TICKLABEL.PADDING) {
                  secondTick.offsetX(overflow);
                  hideTick = false;
                }
              } // we hide the 2nd tick...


              if (hideTick) {
                secondTick.set({
                  "text": ""
                });
              }
            }
          }
        } // last tick


        var lastTick = lodash__default.last(tickShapes);
        var lastTickBb = lastTick.boundingBox();
        var lastTickRight = lastTickBb.x + lastTickBb.w; // make sure it doesn't go too much to the right

        if (lastTickRight > range[1]) {
          lastTick.offsetX(range[1] - lastTickRight);

          if (nbTicks > 1) {
            // now that we have shifted the tick, it might overlap with the previous tick...
            lastTickBb = lastTick.boundingBox(); // need to recompute since we justs changed offset

            var lastTickLeft = lastTickBb.x;
            var secondLastTick = tickShapes[tickShapes.length - 2];
            var i = tickShapes.length - 3;

            while (i >= 0 && !secondLastTick.get("text")) {
              secondLastTick = tickShapes[i];
              i--;
            }

            var secondLastTickBb = secondLastTick.boundingBox();
            var secondLastTickRight = secondLastTickBb.x + secondLastTickBb.w;

            if (secondLastTick.get("text") && secondLastTickRight > lastTickLeft - CONSTANTS.TICKLABEL.PADDING) {
              var overflow$1 = secondLastTickRight - (lastTickLeft - CONSTANTS.TICKLABEL.PADDING);
              var hideTick$1 = true;

              if (i >= 0) {
                var thirdLastTick = tickShapes[i];
                var thirdLastTickBb = thirdLastTick.boundingBox();
                var thirdLastTickRight = thirdLastTickBb.x + thirdLastTickBb.w;

                if (thirdLastTickRight + CONSTANTS.TICKLABEL.PADDING < secondLastTickBb.x - overflow$1) {
                  secondLastTick.offsetX(-overflow$1);
                  hideTick$1 = false;
                }
              } // we hide the secondLast tick...


              if (hideTick$1) {
                secondLastTick.set({
                  "text": ""
                });
              }
            }
          }
        }
      }
    }

    return layer;
  }

  function yTitle(options) {
    var ref = options.axis;
    var column = ref.column;
    var sorting = ref.sorting;
    if (sorting === void 0) sorting = {
      enabled: false
    };
    var titleMaxLines = ref.titleMaxLines;
    var theme = options.theme;
    var cell = options.cell;
    var key = options.key || "title";
    var size = options.size || cell.get("h");
    var layer = options.layer;
    var titleOffset = options.titleOffset || 0;
    var isDimension = !!options.isDimension;
    var titleColor = options.titleColor || defaultTheme$1.getDimensionAxisTitleColor();
    var sortingEnum = SortingEnum.fromValue(sorting.order) || SortingEnum.NONE;

    if (options.titles) {
      var normalize = options.normalize;
      var titles = (Array.isArray(options.titles) ? options.titles : [options.titles]).map(function (t) {
        return t + (normalize ? " (%)" : "");
      });

      if (!lodash__default.every(titles, lodash__default.isEmpty)) {
        var canHover = sorting.enabled;
        layer = layer || new Layer({
          key: key,
          cell: cell,
          canHover: canHover,
          staggerAnim: false
        });
        var isVertical = cell.getScene().get("transforms").rotate;
        var isFlipY = cell.getScene().get("transforms").flipY;
        var nTitles = titles.length;
        var separator = constants$1.AXIS.LABELS.TITLE.SEPARATOR;
        var separatorWidth = new Text$1({
          key: "measuringText",
          text: separator,
          stroke: titleColor,
          halign: "right",
          valign: "middle",
          vertical: true
        }).getTextW();
        var paddingH = constants$1.AXIS.LABELS.TITLE.PADDING.HORIZONTAL;
        var paddingV = constants$1.AXIS.LABELS.TITLE.PADDING.VERTICAL;
        var maxWidthPerTitle = (size - ((nTitles - 1) * separatorWidth + paddingH * 2)) / nTitles;
        var shapeGroup = new ShapeGroup$2({
          layer: layer,
          key: "titleGroup"
        });
        var titleText = "";
        var padding = new Padding({
          top: paddingV,
          right: paddingH,
          bottom: paddingV,
          left: paddingH
        });
        var titleParts = reverseTitleWhenVertical(interleave(titles, separator), isVertical);

        if (titleMaxLines > 1) {
          var ref$1 = textUtils.getInstance().wrap(splitWords(titleParts), titleMaxLines, size);
          var lines = ref$1.lines;
          var rest = ref$1.rest;
          var sortingSuffix = sorting.enabled && sortingEnum.sortChar && rest === "" ? " " + sortingEnum.sortChar : "";
          var orderedLines = lines.slice(0, -1).concat(lines[lines.length - 1] + rest + sortingSuffix);
          var texts = orderedLines.map(function (line, i) {
            return new Text$1({
              shapeGroup: shapeGroup,
              key: "title-line-" + i,
              x: 0,
              y: 0,
              text: line,
              stroke: titleColor,
              halign: "center",
              valign: "top",
              vertical: true,
              maxWidth: i === lines.length - 1 ? size : null,
              padding: padding,
              size: constants$1.TEXT_SIZE
            });
          });
          shapeGroup.applyLayout({
            type: "hbox"
          });

          if (shapeGroup.getChildren().length > 0) {
            shapeGroup.offsetY(0.5 * size);
          }
        } else {
          titleParts.forEach(function (title, i) {
            var paddingLeft = i == 0 ? paddingH : undefined;
            var paddingRight = i == titleParts.length - 1 ? paddingH : undefined;
            padding.left = isVertical ? paddingLeft : paddingRight;
            padding.right = isVertical ? paddingRight : paddingLeft;
            titleText += title;
            var truncatedText = textUtils.getInstance().getTruncatedText(title, maxWidthPerTitle);

            if (truncatedText) {
              var y = 0;
              var sortingSuffix;
              var isTruncated = truncatedText != title;

              if (sorting.enabled) {
                if (sortingEnum.sortChar) {
                  sortingSuffix = sortingEnum.sortChar;

                  if (!isTruncated) {
                    sortingSuffix = " " + sortingSuffix;
                  }
                } // center the title


                y = size / 2;
              }

              var maxWidth;

              if (canHover) {
                maxWidth = size;
              } else if (title === separator) {
                maxWidth = null;
              } else {
                maxWidth = maxWidthPerTitle;
              }

              var text = new Text$1({
                shapeGroup: shapeGroup,
                key: "title-" + i,
                x: 0,
                y: y,
                text: title,
                stroke: titleColor,
                halign: canHover ? "center" : "right",
                valign: "top",
                vertical: true,
                hoverBgColor: canHover ? theme.getAxisTitleTextBackgroundColor() : undefined,
                maxWidth: maxWidth,
                padding: padding
              });

              if (sorting.enabled) {
                if (sortingSuffix != null) {
                  var actualText = isTruncated ? truncatedText : title;

                  if (isVertical || !isDimension) {
                    y += textUtils.getInstance().getTextWidth(actualText) / 2 - paddingH;
                  } else {
                    y -= textUtils.getInstance().getTextWidth(actualText) / 2;
                    y -= textUtils.getInstance().getTextWidth(sortingSuffix) + paddingH;
                  }

                  new Text$1({
                    layer: layer,
                    key: "title-" + i + "-sorting-suffix",
                    x: 0,
                    y: y,
                    text: sortingSuffix,
                    stroke: titleColor,
                    valign: "top",
                    halign: "right",
                    vertical: true,
                    padding: padding,
                    zIndex: -1
                  });
                }
              }
            }
          });
          shapeGroup.applyLayout({
            type: "vbox"
          });

          if (shapeGroup.getChildren().length > 0) {
            shapeGroup.offsetY(0.5 * (size - shapeGroup.boundingBox().h));
          }
        } // @bug W-5109431 When isVertical = true and isFlipY = true, we cannot use offsetX to add addtional margin.
        // Because we would need a negative offsetX to do so. However, a negative offsetX would reduce the size
        // of title cell, means "offset" would fail. Another bad thing is that offset out of title cell may result in
        // cut off for text. Thus, We choose to add a new Point here.


        if (isVertical && isFlipY) {
          new Point({
            layer: layer,
            key: "padding",
            x: shapeGroup.boundingBox().w + titleOffset,
            y: size / 2,
            r: 0
          });
        } else {
          shapeGroup.offsetX(titleOffset);
        }

        if (sorting.enabled) {
          var nextOrder = SortingEnum.fromOrdinal((sortingEnum.ordinal + 1) % SortingEnum.values().length).value;
          var chartEvent = {
            eventName: constants$1.EVENT_NAME.SORT,
            eventData: {
              column: [column[0].getName()],
              order: nextOrder
            }
          };
          shapeGroup.forEach(function (shape) {
            shape.set("cursorType", "pointer");
            shape.set('onClick', chartEvent);
          });
        } // Accessibility caption


        layer.set({
          accessibility: {
            type: constants$1.ACCESSIBILITY.TYPE.CAPTION,
            key: isDimension ? constants$1.ACCESSIBILITY.CAPTION_KEY.DIMENSION_AXIS_TITLE : constants$1.ACCESSIBILITY.CAPTION_KEY.MEASURE_AXIS_TITLE,
            value: titleText
          }
        });
      }
    }

    return layer;

    function reverseTitleWhenVertical(titles, isVertical) {
      return isVertical ? titles : titles.reverse();
    }

    function interleave(items, separator) {
      var buffer = [];
      var nItems = items.length;

      for (var i = 0; i < nItems; ++i) {
        buffer.push(items[i]);

        if (nItems - 1 !== i) {
          buffer.push(separator);
        }
      }

      return buffer;
    }

    function splitWords(listOfLines) {
      if (listOfLines.length === 0) {
        return [];
      }

      return listOfLines[0].split(" ").concat(splitWords(listOfLines.slice(1)));
    }
  } // **** rotated: false *******
  //
  // - layout: "normal"
  //	 numColumns: 1
  //
  // <--- size ---->
  // _______________
  // |United States|
  // |        China|
  // |       Russia|
  // |        India|
  // |       France|
  // |      Germany|
  // |        Italy|
  // |    Australia|
  // |_____________|
  // |    labels   |
  //
  // - layout: "normal"
  //	  numColumns: 2
  //
  // <------ size -------->
  // ______________________
  // |United States     Q1|
  // |                  Q2|
  // |        China     Q1|
  // |                  Q3|
  // |       Russia     Q1|
  // |                  Q2|
  // |        India     Q1|
  // |                  Q2|
  //  --------------------
  //
  // **** rotated: true *******
  //
  // - layout: "orthogonal"
  // 	  numColumns: 1
  //
  // ________________________________
  //|   China   Russia  India  | size
  //|--------------------------|-----
  // - layout: "orthogonal"
  // 	  numColumns: 2
  //__________________________________
  //|  Q1   Q2  Q1   Q2  Q1   Q2 |
  //|   China    Russia   India  | size
  //|----------------------------|-----
  //
  // - layout: "normal"
  // 	 numColumns: 1
  // _____________________________
  //|     C       R       I    |
  //|     h       u       n    |
  //|     i       s       d    | size
  //|     n       s       i    |
  //|     a       i       a    |
  //|_____________a____________|___
  //
  // note: illustration of how maxWidth is calculated for layout: LAYOUT.SLANTED
  // - smaller box inside bb is text border-box
  // - columnWidth/rowHeight is the available space, which is also the maximum
  //   for text's projection on horizontal/vertical dimension
  // - vertical/horizontal are equivalent, +a/-a are equivalent
  //
  // vertical: false
  //  _______________
  // |        ⟋⟍    |
  // |      ⟋    ⟍  |
  // |    ⟋      h ⟍|
  // |  ⟋          ⟋|
  // |⟋          ⟋  |
  // |⟍      mW⟋    | <- text's Axis Aligned BoundingBox
  // |  ⟍    ⟋      |
  // |____⟍⟋_a______|
  //
  // |<------------->|
  //    columnWidth
  //
  // vertical: true
  //  _______________   ___
  // |        ⟋⟍    |   |
  // |      ⟋    ⟍  |   |
  // |    ⟋      h ⟍|   |
  // |  ⟋          ⟋|   |
  // |⟋          ⟋ a|   | rowHeight
  // |⟍      mW⟋    |   |
  // |  ⟍    ⟋      |   |
  // |____⟍⟋________|  _|_
  //           |
  //           |
  //   text's Axis Aligned BoundingBox

  /**
   * Calculate text maxWidth
   *
   * similar to above illustration, rowHeight/columnWidth -> width, a -> rotation
   *
   * @param {Number} width
   * @param {Number} h - text height
   * @param {Number} angle - text rotation angle
   */


  function calculateTextMaxWidth(width, h, angle) {
    var r = Math.abs(angle) % Math.PI;
    r = r > Math.PI / 2 ? Math.PI - r : r;
    var s = Math.cos(r);
    return s ? (width - h * Math.sin(r)) / s : 1000;
  }

  function textColumnMaxWidth(columnGroup) {
    var texts = columnGroup.getChildren().slice(0);
    var numSamples = Math.min(constants$1.OPTIMIZATION.MEASURE_LABEL_SIZE, texts.length);
    texts.sort(function (text0, text1) {
      return text1.get('text').length - text0.get('text').length;
    });
    var maxTextWidth = 0;

    for (var i = 0; i < numSamples; ++i) {
      var text = texts[i];
      var width = text.trueBoundingBox().w;

      if (width > maxTextWidth) {
        maxTextWidth = width;
      }
    }

    return maxTextWidth;
  }

  function yLabels(params) {
    var theme = params.theme || defaultTheme$1;
    var CONSTANTS = constants$1.AXIS.LABELS;
    var rows = params.rows;
    var fields = columnUtils$1.uniqueColumns(rows.getFields());
    var defaultParams = {
      key: "labels",
      color: theme.getDimensionAxisTextColor(),
      halign: CONSTANTS.TEXT.HALIGN,
      layout: CONSTANTS.LAYOUT.HIDDEN,
      numColumns: fields.length,
      showSeparationLines: true,
      floating: false,
      overflowForSlanted: 0
    };
    lodash__default.defaults(params, defaultParams);
    var cell = params.cell;
    var layout = params.layout;
    var icon = params.icon;
    var numColumns = params.numColumns;
    var halign = params.halign;
    var color = params.color;
    var floating = params.floating;
    var overflowForSlanted = params.overflowForSlanted;
    var key = params.key;
    var LAYOUT = CONSTANTS.LAYOUT; // default rotating angle 45 degree

    var angle = Math.PI / 4; //sanitize number of columns to draw

    numColumns = Math.min(numColumns, fields.length); // whether drawing all columns

    var drawAllColumns = numColumns === fields.length; // hide labels

    if (!numColumns || layout === LAYOUT.HIDDEN) {
      return;
    }

    var layer = new Layer({
      key: key,
      cell: cell,
      canHover: true
    }); // will be used for estimation

    var baseRowHeight = rows.getRowHeight();
    var rowLayout = rows.getLayout(); // do we have an icon?
    // - we need to show all the columns (only show icons on 1st row)
    // - we need the 1st column to have an icon
    // - we need to have enough space for the base row

    var showIcon = drawAllColumns && fields.length === 1 && icon && baseRowHeight + rowLayout.spacer >= ICON_SIZE;
    var iconType, iconColumnName, iconStroke, iconFill, iconFit;

    if (showIcon) {
      var column = icon.column;
      iconType = icon.type || "round";
      iconColumnName = column && column.getName();
      iconStroke = icon.stroke; // note: the stroke is not coming from the theme since our current themes don't need a stroke (and themes don't support null colors...)

      iconFill = icon.fill || theme.getIconFillColor();
      iconFit = icon.fit || constants$1.TEXTURE.FIT.COVER;
    }

    var labelTextH = new Text$1({
      size: CONSTANTS.TEXT.SIZE
    }).getH(); // labels padding

    var VPAD, HPAD;

    if (layout === LAYOUT.ORTHOGONAL) {
      VPAD = CONSTANTS.PADDING.WIDE;
      HPAD = CONSTANTS.PADDING.SMALL;
    } else {
      // when all columns are shown, the vertial padding can afford to expand since
      // the summary level labels are not the constraint
      if (drawAllColumns) {
        var maxLabelH = layout === LAYOUT.SLANTED ? baseRowHeight * Math.sin(angle) : baseRowHeight;
        var maxVPAD = (maxLabelH - labelTextH) / 2;
        VPAD = Math.min(maxVPAD, CONSTANTS.PADDING.WIDE);
      } else {
        VPAD = CONSTANTS.PADDING.SMALL;
      }

      HPAD = CONSTANTS.PADDING.WIDE;
    }

    if (showIcon) {
      var baseLabelH = new Text$1({
        size: CONSTANTS.TEXT.SIZE
      }).getH(); // total height will be baseLabelH + 2 * VPAD = ICON_SIZE

      VPAD = (ICON_SIZE - baseLabelH) / 2;
    }

    var labelH = new Text$1({
      size: CONSTANTS.TEXT.SIZE,
      padding: {
        top: VPAD,
        bottom: VPAD
      }
    }).getH(); // group label texts by column

    var columnsMap = {}; // prepare hotSpot

    var hotSpotsMap = {};
    var hotSpotColors = theme.getHotspotColors();
    fields.forEach(function (field, i) {
      if (i + 1 > numColumns) {
        return;
      }

      columnsMap[field.getName()] = new ShapeGroup$2({
        key: field.getName()
      }).prependTo(layer);
      var hotSpots = field.getHotSpots();

      if (hotSpots) {
        hotSpotsMap[field.getName()] = hotSpots.map(function (hotSpot) {
          hotSpot.size = labelH;
          hotSpot.colors = lodash__default.defaults(hotSpot.colors, hotSpotColors);
          return hotSpot;
        });
      }
    }); // draw labels
    // when tabular rows are flattened, always middle align in all columns

    var hasHierarchy = rows.hasHierarchy();
    var paddingForText = {
      left: HPAD,
      right: HPAD,
      top: VPAD,
      bottom: VPAD
    };
    var paddingForTextWithIcon = {
      left: HPAD,
      right: HPAD + ICON_SIZE + ICON_TEXT_PADDING,
      top: VPAD,
      bottom: VPAD
    };
    var iconUrlForTextKey = {}; // map text-key -> icon url

    rows.traverse(function (key, field, columnInfo, rowInfo, rowKeys, displayRowKeys, row, fields) {
      var isLastColumn = columnInfo.index === numColumns - 1;
      var y = rowInfo.layout.y;
      var h = rowInfo.layout.h;
      var baseTextConfig;

      switch (layout) {
        case LAYOUT.ORTHOGONAL:
          var centerAlign = isLastColumn || !hasHierarchy || !floating;
          baseTextConfig = {
            valign: "middle",
            halign: centerAlign ? "center" : "right",
            y: centerAlign ? y + h / 2 : y,
            vertical: true,
            maxWidth: h
          };
          break;

        case LAYOUT.SLANTED:
          var textY = y + h / 2;
          baseTextConfig = {
            valign: "bottom",
            halign: "left",
            y: textY,
            vertical: true,
            angle: -angle
          };
          break;

        default:
          // NORMAL layout:
          // 1) floating, labels are top aligned, left aligned when rotated
          // - showing all columns, align with the first grainest label in the category which is in the middle of baseRowHeight
          // - otherwise align on the top of the category
          // 2) not floating, labels always align middle
          baseTextConfig = {
            halign: halign,
            valign: "middle",
            y: y + (!floating ? h / 2 : drawAllColumns ? baseRowHeight / 2 : labelH / 2) + 1
          };
          break;
      } // for each label, attach all columns of data beyond current column's hierarchy
      // e.g.
      // Region Year
      // US     2000
      //        2001
      // AP     2002
      //
      // US label's data: { Region: US }
      // 2001 label's data: { Region: US, Year: 2001 }
      // 2002 label's data: { Region: AP, Year: 2002 }


      var text = rowsFormatter$2.formatColumnValue(key, field);
      var data = {};
      fields.forEach(function (f, i) {
        return data[f.getName()] = displayRowKeys[i];
      });
      var textKey = 'label-' + rowKeys.join("|");

      if (showIcon) {
        var baseRow = row.getBaseRows()[0]; // the first row containg the data for this label. We will use it to project the icon url

        iconUrlForTextKey[textKey] = baseRow[iconColumnName];
      }

      new Text$1(lodash__default.extend({
        key: textKey,
        shapeGroup: columnsMap[field.getName()],
        x: 0,
        text: text,
        size: CONSTANTS.TEXT.SIZE,
        stroke: color,
        hoverStroke: theme.getDimensionAxisTextHoverColor(),
        hotSpots: hotSpotsMap[field.getName()],
        padding: showIcon ? paddingForTextWithIcon : paddingForText,
        data: {
          row: data,
          column: lodash__default.last(fields).getName()
        },
        hoverBgColor: theme.getDimensionAxisTextBGColor()
      }, baseTextConfig));
    }, numColumns); // under NORMAL layout, truncate columns depending on total width

    var maxWidthPerCol = layer.getChildren().map(textColumnMaxWidth);

    if (layout === LAYOUT.NORMAL) {
      var truncatedWidths = plotUtils.truncateColumns(maxWidthPerCol, cell.get("w"));
      maxWidthPerCol.forEach(function (maxWidh, i) {
        var truncatedWidth = truncatedWidths && truncatedWidths[i];
        var width = truncatedWidth || maxWidh;
        layer.getChildren()[i].forEach(function (text) {
          text.set('maxWidth', width);
        });
      });
    } else if (layout === LAYOUT.SLANTED) {
      maxWidthPerCol.forEach(function (maxWidh, i) {
        layer.getChildren()[i].forEach(function (text, j) {
          var textAngle = text.get('angle');
          var maxLayoutWidth = calculateTextMaxWidth(Math.min(text.get('y') + overflowForSlanted + labelH * Math.sin(-textAngle), cell.get("w")), labelH, textAngle);
          text.set('maxWidth', Math.min(maxLayoutWidth, maxWidh));
        });
      });
    }

    layer.applyLayout({
      type: "hbox",
      reverse: true
    });
    var bb = layer.boundingBox(); // horizontal stack layout each column

    var columnX = [];
    var rotated = cell.getScene().get("transforms").rotate; // a little hlper function which will create the icon for a given Text shape

    var getIconForText = function getIconForText(text) {
      // first, determine exact position of icon wrt text
      var ref = text.get();
      var x = ref.x;
      var y = ref.y;
      var iconX, iconY;

      switch (layout) {
        case LAYOUT.ORTHOGONAL:
          iconX = x;
          iconY = y + text.getTextW() / 2 + ICON_TEXT_PADDING / 2;
          break;

        case LAYOUT.SLANTED:
          iconX = x - HPAD - ICON_SIZE / 2;
          iconY = y - 2;
          break;

        default:
          if (halign === "center") {
            iconX = x + text.getTextW() / 2 + ICON_TEXT_PADDING / 2;
          } else {
            iconX = x - HPAD - ICON_SIZE / 2;
          }

          iconY = y;
      } // now create icon


      var baseIconConfig = {
        fill: iconFill,
        stroke: iconStroke,
        lineWidth: 1,
        skipInFind: true,
        texture: {
          url: iconUrlForTextKey[text.get("key")],
          fit: iconFit
        }
      };

      switch (iconType) {
        case "square":
          return new Rect$3(lodash__default.extend({
            key: text.get("key") + "_icon_square",
            x: iconX - ICON_SIZE / 2,
            y: iconY - ICON_SIZE / 2,
            w: ICON_SIZE,
            h: ICON_SIZE,
            cornerRadius: Math.round(ICON_SIZE / 6),
            vertical: rotated // note: it's not 100% ideal. For slanted, it might be preferable to rotate by 45 degree...

          }, baseIconConfig));
        //			case "round":

        default:
          return new Point(lodash__default.extend({
            key: text.get("key") + "_icon_point",
            x: iconX,
            y: iconY,
            r: ICON_SIZE / 2
          }, baseIconConfig));
      }
    };

    layer.reverse().offsetX(bb.w).forEach(function (columnShapeGroup, index) {
      if (index >= numColumns) {
        return;
      }

      columnShapeGroup.offsetX(-(bb.w + bb.x));
      var groupBb = columnShapeGroup.boundingBox();
      columnX.push(groupBb.x);
      var icons = []; // list of icons we (might) need to add to the ShapeGroup

      columnShapeGroup.forEach(function (text) {
        // set correct maxWidth(will serve as background width) for texts after layout all columns
        switch (layout) {
          case LAYOUT.SLANTED:
            text.set({
              maxWidth: Math.min(calculateTextMaxWidth(groupBb.w, labelH, -angle), text.get("maxWidth"))
            });
            break;

          case LAYOUT.NORMAL:
            text.set({
              maxWidth: groupBb.w
            });
        }

        if (showIcon) {
          // note: we are iterating over the list of children so we can't really append to the layer
          // at the same time. For now, let's save the icon and we'll append all the icons at once at the end
          var icon = getIconForText(text);
          icons.push(icon);
        }
      });

      if (icons) {
        columnShapeGroup.appendAll(icons);
      }
    }).flatten();

    if (params.showSeparationLines) {
      // draw labels separation lines
      rows.traverse(function (key, field, columnInfo, rowInfo, rowKeys) {
        if (columnInfo.isLast || rowInfo.isLast) {
          return;
        }

        var y = rowInfo.layout.y;
        var h = rowInfo.layout.h;
        var lineY = y + h + columnInfo.layout.spacer / 2;
        new Line$2({
          layer: layer,
          x0: columnX[columnInfo.index],
          x1: 0,
          y0: lineY,
          y1: lineY,
          stroke: theme.getDimensionAxisSeparatorColor(),
          key: "line-" + rowKeys.join("|"),
          canHover: false,
          canSelect: false
        });
      }, numColumns);
    }

    return layer;
  }

  function yTime(params) {
    var theme = params.theme || defaultTheme$1;
    var CONSTANTS = constants$1.AXIS.TIME;
    var defaultParams = {
      key: "time",
      granularity: "month",
      drawAxisLine: true,
      drawAxis: true
    };
    lodash__default.defaults(params, defaultParams);
    var cell = params.cell;
    var scale = params.scale;
    var formats = params.formats;
    var drawAxis = params.drawAxis;
    var drawAxisLine = params.drawAxisLine;
    var granularity = params.granularity;
    var referenceLines = params.referenceLines;
    var key = params.key;
    var isDiscrete = params.isDiscrete;
    var firstDayOfWeek = params.firstDayOfWeek;
    var layer = new Layer({
      cell: cell,
      key: key,
      staggerAnim: false
    });
    var domain = scale.domain();
    var range = scale.range();
    var rotated = cell.getScene().get("transforms").rotate;

    if (drawAxis) {
      // we actually do not want the text rotated when we rotate the chart so we do something special here
      var baseTextConfig = rotated ? {
        halign: "center",
        valign: "middle",
        vertical: true
      } : {
        halign: "right",
        valign: "middle"
      }; // tick formats

      formats = lodash__default.extend({}, CONSTANTS.FORMATS, formats); // calculate time ticks

      var ticks = time.ticks(scale, granularity, formats, rotated, isDiscrete, firstDayOfWeek);
      ticks.forEach(function (tick) {
        var tim____1 = tick.time;
        var text = tick.text; // tickmark text

        new Text$1(lodash__default.extend({
          layer: layer,
          y: tim____1,
          x: -12,
          stroke: theme.getTimeAxisTickLabelColor(),
          text: text,
          key: "text-" + tim____1
        }, baseTextConfig));
      }); // long horizontal axis line

      if (drawAxisLine) {
        new Line$2({
          layer: layer,
          x0: 0,
          y0: domain[0],
          x1: 0,
          y1: domain[1],
          stroke: theme.getTimeAxisLineColor(),
          key: "longline"
        });
      } // make sure all labels and title are visible


      layer.set({
        x: layer.boundingBox().w
      });
      cell.adjustColumnToFit(); // draw tick mark and gridline

      var labels = layer.find({
        key: /^text/
      });
      labels.forEach(function (label, idx) {
        var y = label.get("y");
        var tick = ticks[idx]; // small marker

        new Line$2({
          layer: layer,
          x0: -3,
          y0: y,
          x1: 4,
          y1: y,
          stroke: theme.getTimeAxisTickMarkColor(),
          key: "marker-" + tick.time
        });
      }); // apply scale on layer, it has to be done before adjusting last tick

      layer.set({
        scales: {
          y: scale
        }
      }); // adjust last tick label
      // - ensure full visibility of the last tick

      var lastTick = lodash__default.last(labels);
      var bb;

      if (lastTick) {
        bb = lastTick.boundingBox();
        var maxY = bb.y + bb.h;

        if (maxY > range[1]) {
          lastTick.offsetY(range[1] - maxY);
        }
      }

      if (!params.showMeasure) {
        var firstTick = lodash__default.first(labels);

        if (firstTick) {
          bb = firstTick.boundingBox();
          var minY = bb.y;

          if (minY < range[0]) {
            firstTick.offsetY(range[0] - minY);
          }
        }
      }
    } else {
      cell.adjustColumnToFit();
    }

    return layer;
  }

  var axisUtils = {
    /**
     * Builds and retuns a layer containing a horizontal number axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   scale - [REQUIRED] numerical Scale instance to visualize.
     *   key - axis key (optional, default "axis")
     *   gridLineLength - length of gridline.
     *   drawGridLines - whether to draw grid lines
     *   drawAxisLine - whether to draw axis line
     *   drawAxis - whether to draw all axis components 1)tick labels 2)tick marks 3)grid lines 4) axis line
     *   format - format for numbers
     *   title - axis title.
     */
    xNumbers: xNumbers,

    /**
     * Builds and retuns a layer containing a vertical number axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   scale - [REQUIRED] numerical Scale instance to visualize.
     *   key - axis key (optional, default "axis")
     *   gridLineLength - length of gridline.
     *   drawGridLines - whether to draw grid lines
     *   drawAxisLine - whether to draw axis line
     *   drawAxis - whether to draw all axis components 1)tick labels 2)tick marks 3)grid lines 4) axis line
     *   format - format for numbers
     *   title - axis title.
     */
    yNumbers: plotUtils.rotateBuilderFct(xNumbers),

    /**
     * Builds and retuns a layer containing a horizontal labels axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   rows - [REQUIRED] tabular rows
     *   key - axis key
     *   halign - label text halign.
     *   color - label text color.
     *   layout - horizontal|vertical|hidden labels layout
     *   numColumns - number of columns to display
     *   showSeparationLines - if to show separation lines between rows
     *   floating - whether labels on non-grain level float top/left or fixed at middle
     *   overflowForSlanted - overflow space for the first few slanted labels on left
     */
    xLabels: plotUtils.rotateBuilderFct(yLabels),

    /**
     * Builds and retuns a layer containing a vertical labels axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   rows - [REQUIRED] tabular rows
     *   key - axis key (optional, default "labels")
     *   halign - label text halign.
     *   color - label text color.
     *   layout - horizontal|vertical|hidden labels layout
     *   numColumns - number of columns to display
     *   showSeparationLines - if to show separation lines between rows
     *   floating - whether labels on non-grain level float top/left or fixed at middle
     *   overflowForSlanted - overflow space for the first few slanted labels on left(if rotated)
     */
    yLabels: yLabels,

    /**
     * Builds and retuns a layer containing a vertical time axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   key - axis key (optional, default "labels")
     *   scale - [REQUIRED] Scale instance for .
     *   granularity - level of time granularity on axis
     *   formats - a set of formats for each time granularity for tick labels
     */
    yTime: yTime,

    /**
     * Builds and retuns a layer containing a horizontal time axis.
     * Params:
     *   cell - [REQUIRED] cell to render into.
     *   scale - [REQUIRED] Scale instance for .
     *   key - axis key (optional, default "time")
     *   granularity - level of time granularity on axis
     *   formats - a set of formats for each time granularity for tick labels
     */
    xTime: plotUtils.rotateBuilderFct(yTime),

    /**
     * Builds and retuns a layer containing a vertical title.
     * @param {{
     *  cell: Cell # titleCell
     *  key: axis key (optional, default "title")
     *  size: available size to draw the title (optional, default: cell height)
     *  titles: [string] # titles The titles of the dimension labels
     *  normalize: [boolean] # true if the chart is normalized (a (%) text will be appended to each title in this case)
     *  }
     */
    yTitle: yTitle,

    /**
     * Builds and retuns a layer containing a horizontal title.
     * @param {{
     *  cell: Cell # titleCell
     *  key: axis key (optional, default "title")
     *  size: available size to draw the title (optional, default: cell width)
     *  titles: [string] # titles The titles of the dimension labels
     *  }
     */
    xTitle: plotUtils.rotateBuilderFct(yTitle)
  }; //
  //@flow-ignore

  var layoutUtils = {
    adjustLayoutForAxis: function adjustLayoutForAxis(type, axis, axisCell, axisTitleCell) {
      if (!axis.showTitle && axisTitleCell) {
        if (type === "x") {
          axisTitleCell.adjustRowToFit();
        } else {
          axisTitleCell.adjustColumnToFit();
        }
      }

      if (!axis.showAxis && axisCell) {
        if (type === "x") {
          axisCell.adjustRowToFit();
        } else {
          axisCell.adjustColumnToFit();
        }
      }
    },
    adjustLayout: function adjustLayout(scene, config) {
      var axisX = configUtils.getXAxisDefinition(config);

      if (axisX) {
        this.adjustLayoutForAxis("x", axisX, scene.cellByKey("axis-x"), scene.cellByKey("axis-x-title"));
      }

      var axisY = configUtils.getYAxisDefinition(config);

      if (axisY) {
        this.adjustLayoutForAxis("y", axisY, scene.cellByKey("axis-y"), scene.cellByKey("axis-y-title"));
      }
    },
    getTitleCellRendererConfig: function getTitleCellRendererConfig(config, title, measure, titleMaxLines) {
      var axis = {
        showTitle: config.showMeasureTitle,
        title: title,
        column: [measure],
        titleMaxLines: titleMaxLines || [1]
      };
      configUtils.addSortingInfoToAxis(axis, config.sorting, config);
      return {
        axis: axis,
        isDimension: false,
        cellRenderer: new AxisTitleCellRenderer("x")
      };
    },
    adjustXTitleHeightToFit: function adjustXTitleHeightToFit(cell) {
      var bbox = cell.boundingBox();

      if (bbox && cell.get('h') !== bbox.h) {
        var diff = cell.get('h') - bbox.h;
        cell.getChildren().forEach(function (layer) {
          layer.set({
            y: layer.get('y') - diff
          });
        });
      }

      cell.adjustRowToFit();
    },
    adjustYTitleWidthToFit: function adjustYTitleWidthToFit(cell) {
      cell.adjustColumnToFit();
    }
  };
  /**
   A cell renderer for axis titles
  */

  var AxisTitleCellRenderer = function (CellRendere____1) {
    function AxisTitleCellRenderer(type) {
      CellRendere____1.call(this);
      this.type = type;
    }

    if (CellRendere____1) AxisTitleCellRenderer.__proto__ = CellRendere____1;
    AxisTitleCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    AxisTitleCellRenderer.prototype.constructor = AxisTitleCellRenderer;

    AxisTitleCellRenderer.prototype.render = function render(chart, cell, cellRendererConfig, renderingContext) {
      cellRendererConfig = lodash__default.defaults(cellRendererConfig, this.getCellRendererConfig());
      var axis = cellRendererConfig.axis;
      var size = cellRendererConfig.size;
      var isDimension = cellRendererConfig.isDimension;
      var titleColor = cellRendererConfig.titleColor;
      var normalize = cellRendererConfig.normalize;
      var key = cellRendererConfig.key;
      var titleOffset = cellRendererConfig.titleOffset;
      var scene = renderingContext.scene;
      var isRotate = !!scene.get("transforms").rotate;
      var isFlipX = !!scene.get("transforms").flipX;
      var isFlipY = !!scene.get("transforms").flipY;

      if (!axis.showTitle) {
        return;
      }

      var titles = axis.title;

      if (!titleColor) {
        titleColor = isDimension ? chart.config.theme.getDimensionAxisTitleColor() : chart.config.theme.getMeasureAxisTitleColor();
      }

      var methodName = this.type === "x" ? "xTitle" : "yTitle";
      key = key || sceneUtils.getLayerKey(cell);
      axisUtils[methodName]({
        cell: cell,
        key: key,
        titles: titles,
        titleColor: titleColor,
        normalize: normalize,
        size: size,
        isDimension: isDimension,
        axis: axis,
        theme: chart.config.theme,
        titleOffset: titleOffset
      });

      this._applyOffsets(cell, key, cellRendererConfig);

      var adjustToFit = cellRendererConfig.adjustToFit != null ? cellRendererConfig.adjustToFit : true;

      if (adjustToFit) {
        if (this.type === "x") {
          layoutUtils.adjustXTitleHeightToFit(cell);

          if (isRotate && !isFlipX || !isRotate && !isFlipY) {
            cell.flipY();
          }
        } else {
          layoutUtils.adjustYTitleWidthToFit(cell);

          if (isRotate && !isFlipY || !isRotate && isFlipX) {
            cell.flipX();
          }
        }
      }
    };

    return AxisTitleCellRenderer;
  }(CellRenderer);
  /**
   A cell renderer for cells that have a rendering method defiend in the chart
  */


  var MethodCellRenderer = function (CellRendere____1) {
    function MethodCellRenderer(cellMethod) {
      CellRendere____1.call(this);
      this.cellMethod = cellMethod;
    }

    if (CellRendere____1) MethodCellRenderer.__proto__ = CellRendere____1;
    MethodCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    MethodCellRenderer.prototype.constructor = MethodCellRenderer;

    MethodCellRenderer.prototype.render = function render(chart, cell, cellRendererConfig, renderingContext) {
      cellRendererConfig = lodash__default.defaults(cellRendererConfig, this.getCellRendererConfig());

      if (cellRendererConfig.adjustRowToFit) {
        cell.adjustRowToFit();
      }

      if (cellRendererConfig.adjustColumnToFit) {
        cell.adjustColumnToFit();
      }

      if (!cellRendererConfig.display) {
        return;
      }

      renderingContext.layer = cellRendererConfig.createLayer && sceneUtils.newLayer(cell);
      renderingContext.cell = cell; // delegate rendring the cellMethod

      return this.cellMethod.call(chart, renderingContext);
    };

    return MethodCellRenderer;
  }(CellRenderer);
  /**
   A cell renderer for axises.
  */


  var AxisCellRenderer = function (CellRendere____1) {
    function AxisCellRenderer(type) {
      CellRendere____1.call(this);
      this.type = type;
    }

    if (CellRendere____1) AxisCellRenderer.__proto__ = CellRendere____1;
    AxisCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    AxisCellRenderer.prototype.constructor = AxisCellRenderer;

    AxisCellRenderer.prototype.render = function render(chart, cell, cellRendererConfig, renderingContext) {
      cellRendererConfig = lodash__default.defaults(cellRendererConfig, this.getCellRendererConfig());
      var axis = cellRendererConfig.axis;
      var gridLineLength = cellRendererConfig.gridLineLength;
      var drawAxisLine = cellRendererConfig.drawAxisLine;
      var drawGridLines = cellRendererConfig.drawGridLines;
      var normalize = cellRendererConfig.normalize;
      var key = cellRendererConfig.key;
      var scale = cellRendererConfig.scale;
      var createLayer = cellRendererConfig.createLayer;
      key = key || sceneUtils.getLayerKey(cell);
      scale = lodash__default.isFunction(scale) ? scale() : scale;
      var methodName = this.type === "x" ? "xNumbers" : "yNumbers";
      axisUtils[methodName]({
        key: key,
        cell: cell,
        scale: scale,
        gridLineLength: gridLineLength,
        drawGridLines: drawGridLines,
        drawAxisLine: drawAxisLine,
        drawAxis: axis.showAxis,
        format: normalize ? constants$1.FORMAT.PERCENT.AXIS : axis.format,
        theme: chart.config.theme
      });

      this._applyOffsets(cell, key, cellRendererConfig);
    };

    return AxisCellRenderer;
  }(CellRenderer);

  var rowsFormatter$3 = RowsFormatter$1.getInstance();
  /**
   A cell renderer for labels.
  */

  var LabelsCellRenderer = function (CellRendere____1) {
    function LabelsCellRenderer(type) {
      CellRendere____1.call(this);
      this.type = type;
    }

    if (CellRendere____1) LabelsCellRenderer.__proto__ = CellRendere____1;
    LabelsCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    LabelsCellRenderer.prototype.constructor = LabelsCellRenderer;

    LabelsCellRenderer.prototype.render = function render(chart, cell, cellRendererConfig, renderingContext) {
      cellRendererConfig = lodash__default.defaults(cellRendererConfig, this.getCellRendererConfig());
      var layout = cellRendererConfig.layout;
      var icon = cellRendererConfig.icon;
      var numColumns = cellRendererConfig.numColumns;
      var rows = cellRendererConfig.rows;
      var showSeparationLines = cellRendererConfig.showSeparationLines;
      var floating = cellRendererConfig.floating;
      var overflowForSlanted = cellRendererConfig.overflowForSlanted;
      var key = cellRendererConfig.key;
      var resizeCell = cellRendererConfig.resizeCell;
      var scale = cellRendererConfig.scale;
      var showCrosshair = cellRendererConfig.showCrosshair;
      var methodName = this.type === "x" ? "xLabels" : "yLabels";
      var layer = axisUtils[methodName]({
        key: key || sceneUtils.getLayerKey(cell),
        cell: cell,
        layout: layout,
        numColumns: numColumns,
        rows: rows,
        floating: floating,
        overflowForSlanted: overflowForSlanted,
        showSeparationLines: showSeparationLines,
        icon: icon,
        theme: chart.config.theme
      });

      if (!resizeCell) {
        if (layer) {
          // if we have a layer (we are showing the labels) and we have a fixed size,
          // let's align the layer properly within its cell
          // note: for now, we don't pass 'halign' to the x/yLabels
          // this currenlty align things to the right
          layer.offsetX(cell.get("w") - layer.boundingBox().w);
        }
      } else {
        if (this.type === "x") {
          cell.adjustRowToFit();
        } else {
          cell.adjustColumnToFit();
        }
      }

      if (showCrosshair) {
        var isHiddenLayout = layout === constants$1.AXIS.LABELS.LAYOUT.HIDDEN;
        var cellMap = sceneUtils.cellMap(cell.getScene());
        var plotCell = cellMap['plot'];
        var range = scale.range();
        var theme = chart.config.theme;
        var fields = columnUtils$1.uniqueColumns(rows.getFields());

        if (plotCell) {
          cell.append(new DecorationLayer({
            x: cell.get('w') + (isHiddenLayout ? 0 : constants$1.PADDING),
            key: 'crosshair-layer',
            decorationType: constants$1.DECORATION_LAYER_TYPE.DISCRETE_CROSSHAIR,
            w: plotCell.get('w'),
            h: range[range.length - 1]
          }).append(new Crosshair({
            key: 'crosshair',
            stroke: theme.getCrosshairStrokeColor(),
            fill: theme.getCrosshairFillColor(),
            length: plotCell.get('w'),
            labelWidth: cell.get('w'),
            textHAlign: isHiddenLayout ? 'left' : 'right',
            scale: scale,
            formatter: function formatter(value) {
              return sceneUtils.toShapeKeys(value).slice(0, fields.length).map(function (v, i) {
                return rowsFormatter$3.formatColumnValue(v, fields[i]);
              }).join("/");
            }
          })));
        }
      }
    };

    return LabelsCellRenderer;
  }(CellRenderer);
  /**
   A cell renderer for time axis.
  */


  var TimeAxisCellRenderer = function (CellRendere____1) {
    function TimeAxisCellRenderer(type) {
      CellRendere____1.call(this);
      this.type = type;
    }

    if (CellRendere____1) TimeAxisCellRenderer.__proto__ = CellRendere____1;
    TimeAxisCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    TimeAxisCellRenderer.prototype.constructor = TimeAxisCellRenderer;

    TimeAxisCellRenderer.prototype.render = function render(chart, cell, cellRendererConfig) {
      cellRendererConfig = lodash__default.defaults(cellRendererConfig, this.getCellRendererConfig());
      var key = cellRendererConfig.key;
      var drawAxis = cellRendererConfig.drawAxis;
      var drawAxisLine = cellRendererConfig.drawAxisLine;
      var granularity = cellRendererConfig.granularity;
      var scale = cellRendererConfig.scale;
      var formats = cellRendererConfig.formats;
      var isDiscrete = cellRendererConfig.isDiscrete;
      var firstDayOfWeek = cellRendererConfig.firstDayOfWeek;
      var formatter = cellRendererConfig.formatter;
      var showCrosshair = cellRendererConfig.showCrosshair;
      key = key || sceneUtils.getLayerKey(cell);
      scale = lodash__default.isFunction(scale) ? scale() : scale;
      var methodName = this.type === "x" ? "xTime" : "yTime";
      axisUtils[methodName]({
        key: key,
        cell: cell,
        scale: scale,
        drawAxis: drawAxis,
        granularity: granularity,
        drawAxisLine: drawAxisLine,
        showMeasure: true,
        formats: formats,
        isDiscrete: isDiscrete,
        firstDayOfWeek: firstDayOfWeek,
        theme: chart.config.theme
      });

      this._applyOffsets(cell, key, cellRendererConfig);

      if (showCrosshair) {
        var cellMap = sceneUtils.cellMap(cell.getScene());
        var plotCell = cellMap['plot'];
        var theme = chart.config.theme;

        if (plotCell && formatter) {
          cell.append(new DecorationLayer({
            x: cell.get('w'),
            key: 'crosshair-layer',
            decorationType: constants$1.DECORATION_LAYER_TYPE.TIME_CROSSHAIR,
            w: plotCell.get('w'),
            h: cell.get('h')
          }).append(new Crosshair({
            key: 'crosshair',
            stroke: theme.getCrosshairStrokeColor(),
            fill: theme.getCrosshairFillColor(),
            length: plotCell.get('w'),
            labelWidth: cell.get('w'),
            textHAlign: drawAxis ? 'right' : 'left',
            formatter: formatter,
            scale: scale,
            dataGranularity: granularity,
            firstDayOfWeek: firstDayOfWeek
          })));
        }
      }
    };

    return TimeAxisCellRenderer;
  }(CellRenderer);

  var EmptyCellRenderer = function (CellRendere____1) {
    function EmptyCellRenderer() {
      CellRendere____1.apply(this, arguments);
    }

    if (CellRendere____1) EmptyCellRenderer.__proto__ = CellRendere____1;
    EmptyCellRenderer.prototype = Object.create(CellRendere____1 && CellRendere____1.prototype);
    EmptyCellRenderer.prototype.constructor = EmptyCellRenderer;
    return EmptyCellRenderer;
  }(CellRenderer);

  var CellRendererFactory = function CellRendererFactory() {};

  CellRendererFactory.get = function get() {
    return new CellRendererFactory();
  };

  CellRendererFactory.prototype.getCellRenderer = function getCellRenderer(chart, cell, cellRendererConfig) {
    var key = cell.key;
    var type = cellRendererConfig.type;
    var orientation = cellRendererConfig.orientation;
    var methodKey = dataUtils.camelCase(key);
    var cellMethod = chart[methodKey + "Cell"];

    if (type === constants$1.CELL_RENDERER_TYPE.TITLE) {
      return new AxisTitleCellRenderer(orientation);
    } else if (type === constants$1.CELL_RENDERER_TYPE.TIME) {
      return new TimeAxisCellRenderer(orientation);
    } else if (type === constants$1.CELL_RENDERER_TYPE.DIMENSION) {
      return new LabelsCellRenderer(orientation);
    } else if (type === constants$1.CELL_RENDERER_TYPE.MEASURE) {
      return new AxisCellRenderer(orientation);
    } else if (cellMethod) {
      return new MethodCellRenderer(cellMethod);
    } else {
      return new EmptyCellRenderer();
    }
  }; // weak

  /**
   * Base class for color layout
   *
   * @author alice.chen
   */


  var ColorLayout = function ColorLayout(ref) {
    var type = ref.type;
    var field = ref.field;
    var theme = ref.theme;
    var legendSwatchType = ref.legendSwatchType;
    this._type = type;
    this._field = field;
    this._theme = theme || ThemeFactory.getInstance().getDefaultTheme();
    this._legendSwatchType = legendSwatchType || constants$1.MARK_TYPE.BAR;
  };

  ColorLayout.prototype.getLegendSwatchType = function getLegendSwatchType() {
    return this._legendSwatchType;
  };

  ColorLayout.prototype.isConstant = function isConstant() {
    return false;
  };

  ColorLayout.prototype.hasField = function hasField() {
    return this._field != undefined;
  };

  ColorLayout.prototype.getField = function getField() {
    return this._field;
  };

  ColorLayout.prototype.getColumn = function getColumn() {
    return this._field && this._field.getName();
  };

  ColorLayout.prototype.getType = function getType() {
    return this._type;
  };

  ColorLayout.prototype._getColorsForDomainFromPalette = function _getColorsForDomainFromPalette(domain, colors, respectPaletteColorOrder) {
    var this$1 = this;
    if (respectPaletteColorOrder === void 0) respectPaletteColorOrder = false;

    if (!domain) {
      return colors;
    }

    var field = this._field;

    if (!domain.length) {
      return [];
    } else {
      colors = domain.map(function (v, i) {
        return configUtils.getPaletteColor(this$1._theme, i, domain.length, colors, respectPaletteColorOrder);
      });
      var valueColors = field && field.getValueColors();

      if (valueColors) {
        for (var key in valueColors) {
          colors[domain.indexOf(key)] = valueColors[key];
        }
      }

      return colors;
    }
  }; // Corrects breakpoints assuring they always increase or decrease and don't flutter.


  function correctBreakpoints(breakpoints, values, addExtremas, adjustExtremas) {
    var min, max;

    if (Array.isArray(values)) {
      min = lodash__default.min(values);
      max = lodash__default.max(values);
    } else {
      min = max = values;
    }

    var adjustExtremas = adjustExtremas !== false;
    breakpoints = [].concat(breakpoints); // copy breakpoints

    var isNegativeDirection = breakpoints.every(function (breakpoint, index) {
      // First index doesn't count, nothing to compare with.
      return index === 0 || breakpoints[index - 1] > breakpoint;
    });

    if (addExtremas) {
      breakpoints.push(isNegativeDirection ? -Infinity : Infinity);
      breakpoints.unshift(isNegativeDirection ? Infinity : -Infinity);
    } // If the first breakpoint is surpassed by the value being indicated, use the surpassing value:


    if (adjustExtremas && (isNegativeDirection && min > breakpoints[0] || !isNegativeDirection && min < breakpoints[0])) {
      breakpoints[0] = min;
    }

    var result = [breakpoints[0]],
        lastIndex = breakpoints.length - 1,
        i;

    for (i = 1; i < breakpoints.length; i++) {
      var current = breakpoints[i],
          previous = result[i - 1];

      if (isNegativeDirection) {
        // The next breakpoint is more than the current, default to the current - 1.
        result.push(current >= previous ? previous - 1 : current);
      } else {
        // The next breakpoint is less than the current, default to the current + 1.
        result.push(current <= previous ? previous + 1 : current);
      }
    } // If the last breakpoint is surpassed by the value being indicated, use the surpassing value:


    if (adjustExtremas && (isNegativeDirection && max < result[lastIndex] || !isNegativeDirection && max > result[lastIndex])) {
      result[lastIndex] = max;
    }

    return result;
  } // Gets the band that the measure value falls under. Call this AFTER correcting breakpoints.


  function getBandDataOfValue(bands, breakpoints, value) {
    var i;
    var isNegativeDirection = breakpoints.length > 1 && breakpoints[0] > breakpoints[1];

    for (i = 0; i < breakpoints.length - 1; i++) {
      if (!isNegativeDirection && value >= breakpoints[i] && value < breakpoints[i + 1] || isNegativeDirection && value <= breakpoints[i] && value > breakpoints[i + 1]) {
        return {
          band: bands[i],
          min: breakpoints[i],
          max: breakpoints[i + 1]
        };
      }
    }

    return {
      band: bands[bands.length - 1],
      min: breakpoints[breakpoints.length - 2],
      max: breakpoints[breakpoints.length - 1]
    };
  } // Builds a generic label for a band


  function formatBandLabel(value, bands, breakpoints, showRange, showLabel) {
    if (showRange === void 0) showRange = true;
    if (showLabel === void 0) showLabel = true;
    var upperBoundIndex = breakpoints.length - 1;

    for (var i = 1; i < breakpoints.length; i++) {
      if (value < breakpoints[i]) {
        upperBoundIndex = i;
        break;
      }
    }

    var bandData = {
      band: bands[upperBoundIndex - 1],
      min: breakpoints[upperBoundIndex - 1],
      max: breakpoints[upperBoundIndex]
    };
    var parts = [];

    if (showLabel) {
      parts.push(bandData.band.label && bandData.band.label + " ");
    } // Handle unbounded ranges:


    if (showRange) {
      if (bandData.min === -Infinity) {
        parts.push("< " + formatNumber(null, true)(bandData.max));
      } else if (bandData.min === Infinity) {
        parts.push("≥ " + formatNumber(null, true)(bandData.max));
      } else if (bandData.max === Infinity) {
        parts.push("≥ " + formatNumber(null, true)(bandData.min));
      } else if (bandData.max === -Infinity) {
        parts.push("< " + formatNumber(null, true)(bandData.min));
      } else {
        // handle bounded ranges:
        var label = LOC.getLabel("wave-charts", "range", [formatNumber(null, true)(bandData.min), formatNumber(null, true)(bandData.max)]);
        parts.push(showLabel ? "(" + label + ")" : label);
      }
    }

    return parts.join("");
  } // make sure the ranges passed are somewhat valid
  // for now it enforces:
  // - minimum set of breakpoints (2)
  // - minimum set of bands (1)
  // - number of breakpoints == number of bands + 1
  //
  // if any of these conditions is not met, the defaultRanges is being returns


  function cleanupRanges(ranges, defaultRanges) {
    lodash__default.defaults(ranges, defaultRanges);

    if (ranges.breakpoints.length < 2 || ranges.bands.length < 1 || ranges.breakpoints.length != ranges.bands.length + 1) {
      ranges.breakpoints = defaultRanges.breakpoints;
      ranges.bands = defaultRanges.bands;
    }

    ranges.breakpoints.sort(function (a, b) {
      return a - b;
    });
  }

  function estimateBreakpoints(range, n) {
    if (n === void 0) n = 1;
    var dMin = range[0];
    var dMax = range[1];
    var breakpoints = [];
    var min, max;

    if (dMin === dMax) {
      min = dMin < 0 ? Math.floor(dMin * 4) : 0;
      max = dMax < 0 ? 0 : Math.ceil(dMax * 1.2);
    } else {
      min = dMin < 0 ? mathUtils.roundUp(dMin) : 0;
      max = dMax > 0 ? mathUtils.roundUp(dMax) : 0;
    }

    breakpoints.push(min);

    if (n > 0) {
      var inter = (max - min) / (n + 1);

      for (var i = 1; i <= n; i++) {
        breakpoints.push(min + inter * i);
      }
    }

    breakpoints.push(max);
    return breakpoints;
  }

  var rangeUtils = {
    correctBreakpoints: correctBreakpoints,
    getBandDataOfValue: getBandDataOfValue,
    formatBandLabel: formatBandLabel,
    cleanupRanges: cleanupRanges,
    estimateBreakpoints: estimateBreakpoints
  }; // weak
  //@flow-ignore

  /**
   * Immutable class for Bins Color Layout
   *
   * - coloring by dividing measure values into bins an associate each
   * bin with a color
   *
   * e.g.
   * let colorLayout = new BinsColorLayout({
   * 	field: { column: "Region" },
   *  rows: [{ Region: AP }, { Region: EU}, { Region: US}],
   *  numBins: 5
   * });
   *
   * @author alice.chen, yoshita
   */

  var BinsColorLayout = function (ColorLayou____1) {
    function BinsColorLayout(ref) {
      var field = ref.field;
      var theme = ref.theme;
      var legendSwatchType = ref.legendSwatchType;
      var numBins = ref.numBins;
      var palette = ref.palette;
      var breakpoints = ref.breakpoints;
      var bands = ref.bands;
      var rows = ref.rows;
      var binsColumn = ref.binsColumn;
      ColorLayou____1.call(this, {
        type: constants$1.CHART_LAYOUT.COLOR_TYPE.BINS,
        field: field,
        theme: theme,
        legendSwatchType: legendSwatchType
      });
      this._numBins = numBins;
      this._palette = palette;

      this._setBreakpoints(breakpoints);

      this._bands = bands;
      this._rows = rows || [];
      this._binsColumn = binsColumn;
    }

    if (ColorLayou____1) BinsColorLayout.__proto__ = ColorLayou____1;
    BinsColorLayout.prototype = Object.create(ColorLayou____1 && ColorLayou____1.prototype);
    BinsColorLayout.prototype.constructor = BinsColorLayout;

    BinsColorLayout.prototype.getBinsColumns = function getBinsColumns() {
      return this._binsColumn;
    };

    BinsColorLayout.prototype.getDomain = function getDomain() {
      return this.getBinsInfo().domain;
    };

    BinsColorLayout.prototype.getUnsortedDomain = function getUnsortedDomain() {
      // bins are sorted (0, 1, 2...) already.  sorted and unsorted are the same.
      return this.getDomain();
    };

    BinsColorLayout.prototype.getLabels = function getLabels() {
      return this.getBinsInfo().labels;
    };

    BinsColorLayout.prototype.getScale = function getScale() {
      var this$1 = this;
      var binsInfo = this.getBinsInfo();
      var colors = binsInfo.colors;
      var _domain2 = binsInfo.domain;
      var colorScale = scales.ordinal().domain(_domain2).range(colors);
      return {
        scale: function scale(value) {
          return colorScale.scale(this$1.getBinIndex(value, binsInfo));
        },
        domain: function domain() {
          return _domain2;
        },
        range: function range() {
          return colors;
        }
      };
    };

    BinsColorLayout.prototype.getBins = function getBins() {
      return this.getBinsInfo().bins;
    };

    BinsColorLayout.prototype.getBinsInfo = function getBinsInfo() {
      if (!this._binsInfo) {
        this._binsInfo = this._computeBinsInfo();
      }

      return this._binsInfo;
    };

    BinsColorLayout.prototype._computeBinsInfo = function _computeBinsInfo() {
      var formattedLabels, max, min, colors;
      var numBins = this._numBins;
      var breakpoints = this._breakpoints || [];
      var bands = this._bands || []; //@flow-ignore

      var format = this._field.getFormat();

      var column = this.getColumn();
      var rows = this._rows;
      var cols = rowsUtils$1.rows2cols(rows);
      var formatter = formatNumber(format, true);
      var bins = undefined;

      if (numBins) {
        var i = 0;
        formattedLabels = {};
        var values = dataUtils.uniq(cols[column]).sort(function (a, b) {
          return a - b;
        });
        values.forEach(function (value) {
          var name;
          return formattedLabels[name = formatter(value)] != null ? formattedLabels[name] : formattedLabels[name] = value;
        });
        var formattedValues = lodash__default.values(formattedLabels);
        numBins = Math.min(formattedValues.length, numBins);
        var binIntervals = Math.floor(formattedValues.length / numBins);
        var binOverflow = formattedValues.length - binIntervals * numBins;
        var minIndex = 0;
        var maxIndex = binIntervals;

        if (binOverflow) {
          maxIndex++;
          binOverflow--;
        }

        bins = [];

        while (i < numBins && minIndex < formattedValues.length) {
          min = i === 0 ? -Infinity : formattedValues[minIndex];
          max = i === numBins - 1 ? Infinity : formattedValues[maxIndex] || formattedValues[minIndex];
          minIndex = maxIndex;
          maxIndex = minIndex + binIntervals;

          if (binOverflow) {
            maxIndex++;
            binOverflow--;
          }

          i++;
          bins.push({
            min: min,
            max: max
          });
        }
      } else {
        var sanitizedBin = this._sanitizeBins(breakpoints, bands, this._theme);

        bins = sanitizedBin.bins;
        colors = sanitizedBin.colors;
      }

      var labels = [];
      var domain = [];
      bins.forEach(function (bin, i) {
        var min = bin.min;
        var max = bin.max;
        var label = bin.label;
        label = label ? label : min === -Infinity ? "< " + formatter(max) : max === Infinity ? "≥ " + formatter(min) : (min = formatter(min), max = formatter(max), min === max ? min : min + "-" + max);
        labels.push(label);
        domain.push(i);
      });

      if (!colors) {
        colors = this._getColorsForDomainFromPalette(domain, this._palette);
      }

      return {
        bins: bins,
        colors: colors,
        labels: labels,
        domain: domain,
        formattedLabels: formattedLabels,
        formatter: formatter
      };
    }; // Divide breakpoints into bins each defined by min, max, label
    // Create an array of colors corresponding to valid bins
    //
    // defaultColor = "#b2d8b2"
    // breakpoints: [3000, 90000]
    // bands: [
    // 	{
    // 		label: "low",
    // 		color: "#cc0000"
    // 	,
    // 		color: "#e5e500"
    // 	,
    // 		label: "high",
    // 	}
    // ]
    // Output:
    // bins =
    //	[
    //		 {
    //			"min": -Infinity,
    //			"max": 3000,
    //			"label": "low",
    //		}
    //	 ,
    //		 {
    //			"min": 3000,
    //			"max": 90000,
    //			"label": undefined,
    //		}
    //	 ,
    // 		{
    //			"min": 90000,
    //			"max": Infinity,
    //			"label": high,
    //		}
    // ]
    // colors = ["#cc0000", "#e5e500", "#b2d8b2"]
    //
    // @param breakpoints {Array} Array of values
    // @param bands {Array} Array of objects each defining label and color for the bins
    // @param palette {Array} default color palette
    // return {Object}
    //	bins {Array} array of sanitized bin objects
    //	colors {Array} array of colors


    BinsColorLayout.prototype._sanitizeBins = function _sanitizeBins(breakpoints, bands, theme) {
      var colors = [];
      var bins = [];
      var i = 0;
      var numBins = breakpoints.length - 1;

      while (i < numBins) {
        bins.push({
          min: breakpoints[i],
          max: breakpoints[i + 1],
          label: bands[i] && bands[i].label
        });
        colors.push(bands[i] && bands[i].color || configUtils.getPaletteColor(theme, i, numBins));
        i++;
      }

      return {
        bins: bins,
        colors: colors
      };
    }; // given a value, calculate which bin it should fall in and return it's index
    // @param value {Number} value to be binned
    // @param bucket {Object} contains the bins and labels informations


    BinsColorLayout.prototype.getBinIndex = function getBinIndex(value, bucket) {
      var bins = bucket.bins;
      var labels = bucket.labels;
      var formattedLabels = bucket.formattedLabels;
      var formatter = bucket.formatter;
      var formattedValue = formatter(value);

      if (formattedLabels && formattedLabels[formattedValue]) {
        value = formattedLabels && formattedLabels[formattedValue];
      }

      for (var i = 0; i < bins.length; i++) {
        var bin = bins[i];
        var min = bin.min;
        var max = bin.max;

        if (min <= value && max > value || min === value && max === value) {
          return i;
        }
      }
    };

    BinsColorLayout.prototype._setBreakpoints = function _setBreakpoints(breakpoints) {
      if (breakpoints === void 0) breakpoints = [];
      breakpoints = lodash__default.filter(breakpoints.map(function (val) {
        return val * 1;
      }), function (val) {
        return val != null;
      });

      var _breakpoints = rangeUtils.correctBreakpoints(breakpoints.sort(function (a, b) {
        return a - b;
      }), [], true, false);

      if (breakpoints.length === 1) {
        // if breakpoints has just one value eg [ 0 ], the corrected value is in negative direction i.e [Infinity, 0, -Infinity]
        _breakpoints.sort(function (a, b) {
          return a - b;
        });
      }

      this._breakpoints = _breakpoints;
      return this;
    };

    return BinsColorLayout;
  }(ColorLayout); // weak


  var rowsFormatter$4 = RowsFormatter$1.getInstance();
  /**
   * Immutable class for Categorical Color Layout
   *
   * - use color to represent discrete dimension values. e.g. color all shapes for
   * dimValue1 to be red, all shapes for dimValue2 to be blue.
   * - can specify a domain and a list of colors to customize the color assignment,
   * otherwise will just use the palette from theme.
   * - use sortColor(true/false) to sort domain before assigning colors
   *
   * e.g.
   * let colorLayout = new CategoricalColorLayout({
   * 	field: { column: "Region" },
   *  domain: [ "AP", "EU", "US" ],
   *  palette: [ "#f00", "#0f0", "#00f" ]
   *  });
   *
   * will create a colorLayout maps the Region values to the color palette passed in.
   *
   * let colorScale = colorLayout.getScale();
   *
   * colorScale.scale("AP") // "#f00"
   * colorScale.scale("EU") // "#0f0"
   * colorScale.scale("US") // "#00f"
   *
   * @author alice.chen
   */

  var CategoricalColorLayout = function (ColorLayou____1) {
    function CategoricalColorLayout(ref) {
      var field = ref.field;
      var theme = ref.theme;
      var legendSwatchType = ref.legendSwatchType;
      var sortColor = ref.sortColor;
      var domain = ref.domain;
      var palette = ref.palette;
      var respectPaletteColorOrder = ref.respectPaletteColorOrder;
      ColorLayou____1.call(this, {
        type: constants$1.CHART_LAYOUT.COLOR_TYPE.CATEGORICAL,
        field: field,
        theme: theme,
        legendSwatchType: legendSwatchType
      });

      if (domain) {
        // the dimension can also be a number, so always convert it back to string
        domain = domain.map(function (value) {
          return value ? value + "" : value;
        });
      }

      this._sortColor = sortColor != null ? sortColor : true;
      this._domain = domain;
      this._unsortedDomain = domain;
      this._palette = palette;
      this._respectPaletteColorOrder = respectPaletteColorOrder != null ? respectPaletteColorOrder : false;
    }

    if (ColorLayou____1) CategoricalColorLayout.__proto__ = ColorLayou____1;
    CategoricalColorLayout.prototype = Object.create(ColorLayou____1 && ColorLayou____1.prototype);
    CategoricalColorLayout.prototype.constructor = CategoricalColorLayout;

    CategoricalColorLayout.prototype.shouldSortColor = function shouldSortColor() {
      return this._sortColor;
    };

    CategoricalColorLayout.prototype.getDomain = function getDomain() {
      if (this._domain && this.shouldSortColor()) {
        return this._domain.slice().sort();
      }

      return this._domain;
    };

    CategoricalColorLayout.prototype.getUnsortedDomain = function getUnsortedDomain() {
      return this._unsortedDomain;
    };

    CategoricalColorLayout.prototype.getColors = function getColors() {
      return this._getColorsForDomainFromPalette(this.getDomain(), this._palette, this._respectPaletteColorOrder);
    };

    CategoricalColorLayout.prototype.getLabels = function getLabels() {
      var this$1 = this;
      var domain = this.getDomain();

      if (this.hasField() && domain) {
        return domain.map(function (value) {
          return rowsFormatter$4.formatColumnValue(value, this$1._field);
        });
      } else {
        return domain;
      }
    };

    CategoricalColorLayout.prototype.getScale = function getScale() {
      var domain = this.getDomain();

      if (!domain) {
        return undefined;
      }

      var colors = this._getColorsForDomainFromPalette(domain, this._palette);

      return scales.ordinal().domain(domain).range(colors);
    };

    return CategoricalColorLayout;
  }(ColorLayout); // weak

  /**
   * Constant Layout
   *
   * - a layout which always maps to a constant value, instead of
   * depending on a numeric value or dimension value. e.g. all shapes
   * use color red is a constant layout with value red, while a layout
   * where all shapes use color red when shape's associated data has
   * region as China, use blue when data has region as US, is a
   * categorical color layout.
   *
   * e.g.
   * let constantLayout = new ConstantLayout({ value: 10 });
   *
   * will create a constant layout always mapping to value 10
   *
   * let constantScale = constantLayout.getScale();
   *
   * constantScale.scale(0) // 10
   * constantScale.scale("US") // 10
   *
   * @author alice.chen
   */


  var ConstantLayout = function ConstantLayout(ref) {
    if (ref === void 0) ref = {};
    var value = ref.value;
    this._type = constants$1.CHART_LAYOUT.CONSTANT;
    this._value = value;
  }; // TODO: this class should be immutable


  ConstantLayout.prototype.setValue = function setValue(value) {
    this._value = value;
    return this;
  };

  ConstantLayout.prototype.isConstant = function isConstant() {
    return true;
  };

  ConstantLayout.prototype.getType = function getType() {
    return this._type;
  };

  ConstantLayout.prototype.getValue = function getValue() {
    return this._value;
  };

  ConstantLayout.prototype.getScale = function getScale() {
    return scales.constant().range(this.getValue());
  }; // weak

  /**
   * Immutable class for Gradient Color Layout
   *
   * - use color to represent numeric value. associate the smallest
   * and biggest value to both ends of a gradient and interpolate value
   * in between.
   *
   * e.g.
   * let colorLayout = new GradientColorLayout({
   * 	field: { column: "value" },
   * 	domain: [0, 100],
   *  gradient: LinearGradient(["red", "green"]),
   *  });
   *
   * will create a colorLayout maps value between 0 and 100 to a color
   * between red and green.
   *
   * let colorScale = colorLayout.getScale();
   *
   * colorScale.scale(0) // "red"
   * colorScale.scale(50) // color between red and green
   * colorScale.scale(100) // "green"
   *
   * @author alice.chen
   *
   */


  var GradientColorLayout = function (ColorLayou____1) {
    function GradientColorLayout(ref) {
      var field = ref.field;
      var theme = ref.theme;
      var legendSwatchType = ref.legendSwatchType;
      var domain = ref.domain;
      var gradient = ref.gradient;
      ColorLayou____1.call(this, {
        type: constants$1.CHART_LAYOUT.COLOR_TYPE.GRADIENT,
        field: field,
        theme: theme,
        legendSwatchType: legendSwatchType
      });
      this._domain = domain;
      this._unsortedDomain = domain;
      this._gradient = gradient;
    }

    if (ColorLayou____1) GradientColorLayout.__proto__ = ColorLayou____1;
    GradientColorLayout.prototype = Object.create(ColorLayou____1 && ColorLayou____1.prototype);
    GradientColorLayout.prototype.constructor = GradientColorLayout;

    GradientColorLayout.prototype.getDomain = function getDomain() {
      return this._domain;
    };

    GradientColorLayout.prototype.getUnsortedDomain = function getUnsortedDomain() {
      return this._unsortedDomain;
    };

    GradientColorLayout.prototype.getGradient = function getGradient() {
      if (this._gradient) {
        return this._gradient;
      } else {
        return this._theme.getPrimaryGradientColors();
      }
    };

    GradientColorLayout.prototype.getScale = function getScale() {
      var domain = this.getDomain();

      if (!domain) {
        return undefined;
      }

      var gradient = this.getGradient();
      return scales.gradient().domain(domain).range(gradient);
    };

    return GradientColorLayout;
  }(ColorLayout); //@fix-flow

  /**
   * Factory class for ColorLayout
   *
   * @author alice.chen
   */


  var ColorLayoutFactory = function ColorLayoutFactory() {};

  ColorLayoutFactory.prototype.make = function make(type, params) {
    switch (type) {
      case constants$1.CHART_LAYOUT.COLOR_TYPE.CATEGORICAL:
        return new CategoricalColorLayout(params);

      case constants$1.CHART_LAYOUT.COLOR_TYPE.GRADIENT:
        return new GradientColorLayout(params);

      case constants$1.CHART_LAYOUT.COLOR_TYPE.BINS:
        return new BinsColorLayout(params);

      case constants$1.CHART_LAYOUT.CONSTANT:
        return new ConstantLayout(params);

      default:
        throw new Error("invalid colorLayout type " + type);
    }
  };

  var ColorLayoutFactory$1 = singleton(ColorLayoutFactory); // weak

  var ConstantRadiusLayout = function (ConstantLayou____1) {
    function ConstantRadiusLayout() {
      ConstantLayou____1.apply(this, arguments);
    }

    if (ConstantLayou____1) ConstantRadiusLayout.__proto__ = ConstantLayou____1;
    ConstantRadiusLayout.prototype = Object.create(ConstantLayou____1 && ConstantLayou____1.prototype);
    ConstantRadiusLayout.prototype.constructor = ConstantRadiusLayout;

    ConstantRadiusLayout.prototype.setRelativeSize = function setRelativeSize(relativeSize) {
      if (relativeSize != null) {
        this._relativeSize = relativeSize;
      }

      return this;
    };

    ConstantRadiusLayout.prototype.setRatio = function setRatio(ratio) {
      if (ratio != null) {
        this._ratio = ratio;
      }

      return this;
    };

    ConstantRadiusLayout.prototype.getRelativeSize = function getRelativeSize() {
      return this._relativeSize;
    };

    ConstantRadiusLayout.prototype.getRatio = function getRatio() {
      return this._ratio;
    };

    ConstantRadiusLayout.prototype.getValue = function getValue() {
      if (this._ratio != null && this._relativeSize != null) {
        return this._relativeSize * this._ratio / 100;
      }

      return this._value;
    };

    return ConstantRadiusLayout;
  }(ConstantLayout); // weak

  /**
   * Radius Layout
   *
   * - use radius of a circle to represent a numeric value. Radius
   * follows a square root scale of the value represented, and area
   * of the circle will be almost proportional to the value.
   *
   * e.g.
   * let radiusLayout = new SqrtRadiusLayout()
   * 	.setField({ column: "value" })
   * 	.setMaxValue(100)
   * 	.setMaxRadius(10)
   *
   * will create a radiusLayout maps value between 0 and 100 to a
   * radius value between 2 and 10.
   *
   * let radiusScale = radiusLayout.getScale();
   *
   * radiusScale.scale(0) // 0
   * radiusScale.scale(100) // 10
   *
   * - use the radius to be relative to its container size
   * e.g.
   * let radiusLayout = new SqrtRadiusLayout()
   * 	.setField({ column: "value" })
   * 	.setMaxValue(100)
   * 	.setRatio(5)
   * 	.setRelativeSize(50)
   *
   * radiusScale.scale(0) // 0
   * radiusScale.scale(100) // 2.5
   * @author alice.chen
   */


  var SqrtRadiusLayout = function SqrtRadiusLayout() {
    this._type = constants$1.CHART_LAYOUT.RADIUS_TYPE.SQRT;
    this._radius = constants$1.MARK.POINT.MAX_RADIUS;
  };

  SqrtRadiusLayout.prototype.setField = function setField(field) {
    this._field = field;
    return this;
  };

  SqrtRadiusLayout.prototype.isConstant = function isConstant() {
    return false;
  };

  SqrtRadiusLayout.prototype.hasField = function hasField() {
    return this._field != undefined;
  };

  SqrtRadiusLayout.prototype.getField = function getField() {
    return this._field;
  };

  SqrtRadiusLayout.prototype.getColumn = function getColumn() {
    return this._field && this._field.getName();
  };

  SqrtRadiusLayout.prototype.setMaxValue = function setMaxValue(value) {
    if (value != null) {
      this._value = value;
    }

    return this;
  };

  SqrtRadiusLayout.prototype.setMaxRadius = function setMaxRadius(radius) {
    if (radius != null) {
      this._radius = radius;
    }

    return this;
  };

  SqrtRadiusLayout.prototype.setRatio = function setRatio(ratio) {
    if (ratio != null) {
      this._ratio = ratio;
    }

    return this;
  };

  SqrtRadiusLayout.prototype.setRelativeSize = function setRelativeSize(relativeSize) {
    if (relativeSize != null) {
      this._relativeSize = relativeSize;
    }

    return this;
  };

  SqrtRadiusLayout.prototype.getRelativeSize = function getRelativeSize() {
    return this._relativeSize;
  };

  SqrtRadiusLayout.prototype.getRatio = function getRatio() {
    return this._ratio;
  };

  SqrtRadiusLayout.prototype.getMaxRadius = function getMaxRadius() {
    if (this._ratio != null && this._relativeSize != null) {
      return this._relativeSize * this._ratio / 100;
    }

    return this._radius;
  };

  SqrtRadiusLayout.prototype.getMaxValue = function getMaxValue() {
    return this._value;
  };

  SqrtRadiusLayout.prototype.getScale = function getScale() {
    var value = this.getMaxValue();

    if (value == null) {
      return undefined;
    }

    var _scale = scales.sqrt().domain([0, value]).range([0, this.getMaxRadius()]);

    return {
      scale: function scale(x) {
        return Math.max(_scale.scale(Math.abs(x)), constants$1.MARK.POINT.MIN_RADIUS);
      }
    };
  }; //@fix-flow


  var RadiusLayoutFactory = function RadiusLayoutFactory() {};

  RadiusLayoutFactory.prototype.make = function make(type) {
    switch (type) {
      case constants$1.CHART_LAYOUT.RADIUS_TYPE.SQRT:
        return new SqrtRadiusLayout();

      case constants$1.CHART_LAYOUT.CONSTANT:
        return new ConstantRadiusLayout();

      default:
        throw new Error("invalid radiusLayout type " + type);
    }
  };

  var RadiusLayoutFactory$1 = singleton(RadiusLayoutFactory); //
  //@flow-ignore

  var AxisLayout = function AxisLayout() {
    this._isX = true;
    this._showAxis = true;
    this._autoFitMode = constants$1.AUTOFIT_MODE.SCROLL;
    this._maxBarSize = constants$1.MARK.BAR.MAX_WIDTH;
    this._width = 0;
    this._size = 0;
  };

  AxisLayout.prototype._set = function _set(key, value) {
    //@flow-ignore
    var oldValue = this[key];

    if (value != undefined && value !== oldValue) {
      //@flow-ignore
      this[key] = value;

      this._recomputeLayout();
    }

    return this;
  };

  AxisLayout.prototype.isX = function isX() {
    return this._isX;
  };

  AxisLayout.prototype.setIsX = function setIsX(isX) {
    return this._set("_isX", isX);
  };

  AxisLayout.prototype.setSize = function setSize(size) {
    return this._set("_size", size);
  };

  AxisLayout.prototype.setWidth = function setWidth(width) {
    return this._set("_width", width);
  };

  AxisLayout.prototype.setAutoFitMode = function setAutoFitMode(autoFitMode) {
    return this._set("_autoFitMode", autoFitMode);
  };

  AxisLayout.prototype.setMinSpacer = function setMinSpacer(minSpacer) {
    return this._set("_minSpacer", minSpacer);
  };

  AxisLayout.prototype.setMaxBarSize = function setMaxBarSize(maxBarSize) {
    return this._set("_maxBarSize", maxBarSize);
  };

  AxisLayout.prototype.setShowAxis = function setShowAxis(showAxis) {
    return this._set("_showAxis", showAxis);
  };

  AxisLayout.prototype.showAxis = function showAxis() {
    return this._showAxis;
  };

  AxisLayout.prototype.setPlotOptions = function setPlotOptions(plotOptions) {
    lodash__default.defaults(plotOptions, {
      barSize: constants$1.MARK.BAR.SIZE,
      barSpacer: constants$1.MARK.BAR.SPACER,
      labelSize: constants$1.MARK.LINE.LABEL_SIZE,
      pointRadius: constants$1.MARK.LINE.POINT_RADIUS,
      marks: [],
      isAxisModeMulti: false
    });
    this._plotOptions = plotOptions;
    return this._recomputeLayout();
  };

  AxisLayout.prototype._recomputeLayout = function _recomputeLayout() {
    this._layoutInfo = undefined;
    return this;
  };

  AxisLayout.prototype._getNumMarks = function _getNumMarks(marks, mark, isAxisModeMulti) {
    var countByMarkType = dataUtils.countBy(marks);
    var num = countByMarkType[mark] || 0;

    if (mark === constants$1.MARK_TYPE.BAR && num > 1 && isAxisModeMulti) {
      num = 1;
    }

    return num;
  };

  AxisLayout.prototype._computePlotOffsets = function _computePlotOffsets(marks, isAxisModeMulti, barTotalSize, barSize, barSpacer) {
    var barIndex = 0;
    return marks.map(function (markType) {
      if (markType === constants$1.MARK_TYPE.BAR) {
        if (isAxisModeMulti) {
          return -barTotalSize / 2;
        } else {
          return barIndex++ * (barSize + barSpacer) - barTotalSize / 2;
        }
      } else {
        return 0;
      }
    });
  };

  AxisLayout.prototype._computeFirstSpacer = function _computeFirstSpacer(distance, minSpacer) {
    // - spacer between bars is a portion of each cluster's distance
    //   portion is a linear function of distance with following key point(clamp at both ends)
    //
    //   distance   portion
    //      25        4%  - default style with 25px bar width and 1px spacing ( 1 / (1 + 25) = 4% )
    //      40       20%  - bar/space = 4 / 1 when bar is fat
    var spacer1 = minSpacer ? minSpacer : mathUtils.interpolate([constants$1.MARK.BAR.SIZE + 1, 1 / constants$1.MARK.BAR.SIZE], [40, 0.2])(distance, true) * distance; // - spacer1 is first level spacing
    //   note: need to sanitize first level spacer
    //      spacer1      ->  sanitized value
    //   [ 0 , 0.15 )    ->         0        - render as an area trend chart
    //   [ 0.15 , 1 )    ->         1
    //   [ 1, Infinity ) ->      spacer1
    //   because spacer between 0 and 1 result in uneven blurring spacing between bars on canvas rendering

    return spacer1 = spacer1 < 0.15 ? 0 : spacer1 < 1 ? 1 : spacer1;
  }; // Compute spacers between groups
  //
  // 2nd level spacer
  // - at least 2px even when 1st level spacer is 0, at least an indication of different clusters
  // - at least twice the 1st level spacer
  // - at least 40% of baseRowHeight
  // 3rd level spacer
  // - 1.5 times the 2nd level spacer
  //
  // @param spacer1 {Number} 1st level spacer
  // @param baseRowHeight {Number} baseRowHeight of layout
  // @return {Array} spacers


  AxisLayout.prototype._computeSpacers = function _computeSpacers(spacer1, baseRowHeight) {
    var spacer2 = Math.max(spacer1 * 2, 2, baseRowHeight * 2 / 5);
    return [spacer1, spacer2, spacer2 * 1.5];
  }; //-ignore
  //@fix-flow
  //@flow-ignore
  //@flow-ignore


  var BOUND_TYPE = {
    REFLINE: "refline",
    DATA: "data",
    CUSTOM: "custom"
  }; // the default domain to fall back if there is no refline, custom domain, data plot,
  // showZero properties that can help define a domain

  var DEFAULT_DOMAIN = [0, 100]; // relax custom domain, if low is higher than data high or vice versa, instead
  // of having a singular domain with one number, relax the other end

  var CUSTOM_DOMAIN_RELAX_RANGE = 100; // maximum zoom factor custom domain would support

  var MAX_ZOOM_FACTOR = 10000;
  var REFLINE_MARGIN = 12; // if a margin is required for data shape, always relax the margin by 1.5px
  // to accomodate rounding error in shape rotation, viewport, point stroke
  // so that the point doesn't appear to be cut off at the edge of chart

  var DATA_MARGIN_RELAX = 1.5;
  var DATA_MARGIN_TOLERANCE = 0.01;

  var NumericAxisLayout = function (AxisLayou____1) {
    function NumericAxisLayout() {
      AxisLayou____1.call(this);
      this._scaleType = constants$1.SCALE.LINEAR;
      this._referenceLineMargin = REFLINE_MARGIN;
      this._format = ["###,##", 1];
      this._showZero = true;
      this._axisMargin = [0, 0];
      this._plots = [];
      this._isX = true;
      this._hasNiceTicks = true;
      this._hasHorizontalTicks = true;
      this._step = 0;
      this._isNormalized = false;
      this._adjustMin = false;
    }

    if (AxisLayou____1) NumericAxisLayout.__proto__ = AxisLayou____1;
    NumericAxisLayout.prototype = Object.create(AxisLayou____1 && AxisLayou____1.prototype);
    NumericAxisLayout.prototype.constructor = NumericAxisLayout;

    NumericAxisLayout.prototype.setStep = function setStep(step) {
      this._step = step;
      return this;
    };

    NumericAxisLayout.prototype.getStep = function getStep(step) {
      return this._step;
    };

    NumericAxisLayout.prototype.setAdjustMin = function setAdjustMin(adjustMin) {
      this._adjustMin = adjustMin;
      return this;
    };

    NumericAxisLayout.prototype._getAdjustMin = function _getAdjustMin() {
      return this._adjustMin;
    };

    NumericAxisLayout.prototype.setIsNormalized = function setIsNormalized(isNormalized) {
      this._isNormalized = isNormalized;
      return this;
    };

    NumericAxisLayout.prototype.isNormalized = function isNormalized() {
      return this._isNormalized;
    };

    NumericAxisLayout.prototype.setHasNiceTicks = function setHasNiceTicks(hasNiceTicks) {
      if (hasNiceTicks === void 0) hasNiceTicks = true;

      if (!hasNiceTicks) {
        this.setStep(0);
      }

      this._hasNiceTicks = hasNiceTicks;
      return this;
    };

    NumericAxisLayout.prototype.hasNiceTicks = function hasNiceTicks() {
      return this._hasNiceTicks;
    };

    NumericAxisLayout.prototype.setHasHorizontalTicks = function setHasHorizontalTicks(hasHorizontalTicks) {
      if (hasHorizontalTicks === void 0) hasHorizontalTicks = true;
      this._hasHorizontalTicks = hasHorizontalTicks;
      return this;
    };

    NumericAxisLayout.prototype.hasHorizontalTicks = function hasHorizontalTicks() {
      return this._hasHorizontalTicks;
    };

    NumericAxisLayout.prototype.setFormat = function setFormat(format) {
      if (format) {
        this._format = format;
      }

      return this;
    };

    NumericAxisLayout.prototype.getFormat = function getFormat() {
      return this._format;
    };

    NumericAxisLayout.prototype.getFormatMultiplier = function getFormatMultiplier() {
      return this._format && this._format[1] || 1;
    };

    NumericAxisLayout.prototype.setShowZero = function setShowZero(showZero) {
      this._showZero = showZero;
      return this;
    };

    NumericAxisLayout.prototype.showZero = function showZero() {
      return !!this._showZero;
    };

    NumericAxisLayout.prototype.setCustomDomain = function setCustomDomain(customDomain) {
      if (customDomain && customDomain.length === 2 && (customDomain[0] !== undefined || customDomain[1] !== undefined)) {
        this._customDomain = customDomain;
      }

      return this;
    };

    NumericAxisLayout.prototype.hasCustomDomain = function hasCustomDomain() {
      return !!this._customDomain;
    };

    NumericAxisLayout.prototype.setDataDomain = function setDataDomain(dataDomain) {
      if (dataDomain) {
        this._dataDomain = dataDomain;
      }

      return this;
    };

    NumericAxisLayout.prototype.setDataMargin = function setDataMargin(dataMargin) {
      if (dataMargin) {
        this._dataMargin = dataMargin;
      }

      return this;
    };

    NumericAxisLayout.prototype.setAxisDomain = function setAxisDomain(axisDomain) {
      if (axisDomain) {
        this._axisDomain = axisDomain;
      }

      return this;
    };

    NumericAxisLayout.prototype.setAxisMargin = function setAxisMargin(axisMargin) {
      if (axisMargin) {
        this._axisMargin = axisMargin;
      }

      return this;
    };

    NumericAxisLayout.prototype.setSize = function setSize(size) {
      this._size = size;
      return this;
    };

    NumericAxisLayout.prototype.setReferenceLines = function setReferenceLines(refLines) {
      this._referenceLines = refLines;
      return this;
    };

    NumericAxisLayout.prototype.getReferenceLines = function getReferenceLines() {
      return this._referenceLines;
    };

    NumericAxisLayout.prototype.setScaleType = function setScaleType(scaleType) {
      this._scaleType = scaleType;
      return this;
    };

    NumericAxisLayout.prototype.getScaleType = function getScaleType() {
      return this._scaleType;
    };

    NumericAxisLayout.prototype.setReferenceLineMargin = function setReferenceLineMargin(referenceLineMargin) {
      this._referenceLineMargin = referenceLineMargin;
      return this;
    };

    NumericAxisLayout.prototype.hasReferenceLines = function hasReferenceLines() {
      return this._referenceLines && this._referenceLines.length;
    };

    NumericAxisLayout.prototype.addPlot = function addPlot(shapes) {
      this._plots = this._plots.concat(shapes);
      return this;
    };

    NumericAxisLayout.prototype.resetPlot = function resetPlot() {
      this._plots = [];
      return this;
    };

    NumericAxisLayout.prototype._adjustForCustomDomain = function _adjustForCustomDomain(domain, lowBound, highBound) {
      var customDomain = this._customDomain;

      if (customDomain) {
        var customLow = customDomain[0];
        var customHigh = customDomain[1];

        if (!domain) {
          domain = [customLow != undefined ? customLow : customHigh, customHigh != undefined ? customHigh : customLow];
        }

        var domainBeforeZoom = domain.slice();

        if (customLow != undefined && customHigh != undefined) {
          // [ n, m ] - custom domain has both ends defined
          domain = customDomain;
          lowBound = BOUND_TYPE.CUSTOM;
          highBound = BOUND_TYPE.CUSTOM;
        } else if (customLow != undefined) {
          // [n, null ] - custom domain has only low value
          domain[0] = customLow;
          lowBound = BOUND_TYPE.CUSTOM;

          if (domain[0] > domain[1]) {
            // custom domain low is even higher than high domain
            domain[1] = domain[0] + CUSTOM_DOMAIN_RELAX_RANGE;
            highBound = undefined;
          }
        } else if (customHigh != undefined) {
          // [ null, m ] - custom domain has only high value
          domain[1] = customHigh;
          highBound = BOUND_TYPE.CUSTOM;

          if (domain[0] > domain[1]) {
            // custom domain high is even lower than low domain
            domain[0] = domain[1] - CUSTOM_DOMAIN_RELAX_RANGE;
            lowBound = undefined;
          }
        } // adjust result domain considering zoom factor no larger than 10k since
        // canvas would not support drawing a rect with a huge width


        var maxDomainRange = (domainBeforeZoom[1] - domainBeforeZoom[0]) / MAX_ZOOM_FACTOR;
        var overflow = maxDomainRange - (domain[1] - domain[0]);

        if (overflow > 0) {
          var resetBoundType = function resetBoundType(type) {
            return type === BOUND_TYPE.CUSTOM ? type : undefined;
          }; // the custom domain is too small, so the shape magnification is going to be larger than 10K
          // so expand the domain to reduce the magnification


          if (domain[0] < 0 && domain[1] <= 0) {
            // if the custom domain is only negative, then expand only on the negative side. eg [-20, 0] => [-10000, 0]
            domain = [domain[0] - overflow, domain[1]];
            lowBound = resetBoundType(lowBound);
          } else if (domain[0] >= 0 && domain[1] > 0) {
            // if the custom domain is only positive, then expand only on the positive side. eg [0, 20] => [0, 10000]
            domain = [domain[0], domain[1] + overflow];
            highBound = resetBoundType(highBound);
          } else {
            // expand on both sides. eg [-10, 10] => [-5000, 5000]
            domain = [domain[0] - overflow / 2, domain[1] + overflow / 2];
            lowBound = resetBoundType(lowBound);
            highBound = resetBoundType(highBound);
          }
        }

        return {
          domain: domain,
          lowBound: lowBound,
          highBound: highBound
        };
      }
    };

    NumericAxisLayout.prototype.getAxisDomainInfo = function getAxisDomainInfo() {
      return this._getAxisDomainInfo();
    }; // expand the domain to have fully divisible ticks


    NumericAxisLayout.prototype._getNicedDomainInfo = function _getNicedDomainInfo(domain, margin) {
      var this$1 = this;
      var step = 0;
      var adjustedDomain = domain; // dont nice the axis if the margin is overwhelming the size

      if (margin[0] + margin[1] < this._size / 2 && this.hasNiceTicks() && !this.hasCustomDomain()) {
        var ref = constants$1.AXIS.NUM.TICKMARK;
        var HORI_DISTANCE = ref.HORI_DISTANCE;
        var VERTI_DISTANCE = ref.VERTI_DISTANCE;
        var MIN_DISTANCE = ref.MIN_DISTANCE;
        var DISTANCE = this.hasHorizontalTicks() ? HORI_DISTANCE : VERTI_DISTANCE;
        var count = Math.round(this._size / DISTANCE);
        var origCount = count; // due to mathematical error, when normalized, the domain could be [0, 100.0000001]. So just to be sure cap the domain at [-100, 100]

        if (this.isNormalized()) {
          adjustedDomain = [Math.max(domain[0], -100), Math.min(domain[1], 100)];
        }

        var scale; // the ticks function doesnt always return the same number of ticks as expected. It could return more or less than expected ticks
        // so sometimes the ticks could either be too further apart or too close to each other
        // if the distance between two ticks is greater than the desired distance, try again with more ticks
        // as added safety against infinte loops cap the count at 1000

        while ((!step || scale.scale(scale.domain()[0] + step) - scale.scale(scale.domain()[0]) > DISTANCE) && count < 1000) {
          scale = scales.linear().domain(adjustedDomain).range([0, this$1._size]).nice(count++);
          step = scale.step();
        } // if while increasing the ticks, we got to a point where the ticks are too close, we need to relax it.


        while (scale.scale(scale.domain()[0] + step) - scale.scale(scale.domain()[0]) < MIN_DISTANCE && count >= origCount) {
          scale = scales.linear().domain(adjustedDomain).range([0, this$1._size]).nice(count--);
          step = scale.step();
        }

        margin = domainUtils.adjustMargin(domain, margin, scale);
        domain = scale.domain();
      }

      return {
        domain: domain,
        margin: margin,
        step: step
      };
    }; // domain after applying formatMultiplier, in the same scale as custom domain and ref lines


    NumericAxisLayout.prototype._getAxisDomainInfo = function _getAxisDomainInfo(dataDomain, dataMargin, niced) {
      if (niced === void 0) niced = true;

      if (this._axisDomain && this._axisMargin) {
        return {
          domain: this._axisDomain,
          margin: this._axisMargin,
          step: this.getStep()
        };
      }

      if (!dataDomain || !dataMargin) {
        var info = this._getDataDomainMargin();

        dataDomain = info.domain;
        dataMargin = info.margin;
      }

      var domain;

      if (dataDomain) {
        var formatMultiplier = this.getFormatMultiplier();
        domain = [dataDomain[0] * formatMultiplier, dataDomain[1] * formatMultiplier];
      }

      var lowBound = BOUND_TYPE.DATA;
      var highBound = BOUND_TYPE.DATA;

      if (this.hasReferenceLines()) {
        var refLineDomain = mathUtils.getMinMax(lodash__default.map(this._referenceLines, "value"));

        if (!domain) {
          domain = refLineDomain;
          lowBound = BOUND_TYPE.REFLINE;
          highBound = BOUND_TYPE.REFLINE;
        } // bound by lower refline


        if (refLineDomain[0] < domain[0]) {
          domain[0] = refLineDomain[0];
          lowBound = BOUND_TYPE.REFLINE;
        } // bound by higher refline


        if (refLineDomain[1] > domain[1]) {
          domain[1] = refLineDomain[1];
          highBound = BOUND_TYPE.REFLINE;
        }
      }

      if (this._customDomain) {
        var adjustedInfo = this._adjustForCustomDomain(domain, lowBound, highBound);

        domain = adjustedInfo.domain;
        lowBound = adjustedInfo.lowBound;
        highBound = adjustedInfo.highBound;
      }

      if (!domain) {
        // fall back to a default domain
        domain = DEFAULT_DOMAIN;
      } else if (domain[0] === domain[1]) {
        domain = domainUtils.adjustDomain(domain);
        lowBound = undefined;
        highBound = undefined;
      }

      var margin = [this._getMarginByBoundType(lowBound, domain[0], dataMargin[0]), this._getMarginByBoundType(highBound, domain[1], dataMargin[1])];
      var step = this.getStep();

      if (niced) {
        var nicedDomainMargin = this._getNicedDomainInfo(domain, margin);

        domain = nicedDomainMargin.domain;
        margin = nicedDomainMargin.margin;
        step = nicedDomainMargin.step;
      }

      return {
        domain: domain,
        margin: margin,
        step: step
      };
    };
    /**
     * Compute data domain and margin
     *
     * According to all plot shapes assigned to this axis, calculate the domain of all plots
     * and estimate the margins(in pixel values) of the highest and lowest positioned plot
     * shape would create.
     *
     *
     * /|\    ___                 _ _ _ _ _ _ _ _ _
     *  |    /   \                                  } <- dataMargin[1]
     *  |   |  +  |               - - dataDomain[1]
     *  |    \___/_______
     *  |        /       \
     *  |       /         \
     *  |      |    _|_    |
     *  |      |     |     |
     *  |       \         /    +  - - dataDomain[0]
     *  |        \_______/        _ _ _ _ _ _ _ _ _  } <- dataMargin[0]
     *  |
     */


    NumericAxisLayout.prototype._getDataDomainMargin = function _getDataDomainMargin() {
      var showZero = this.showZero();

      if (this._dataDomain && this._dataMargin) {
        var domain$1 = this._dataDomain;

        if (showZero) {
          domain$1 = [Math.min(0, domain$1[0]), Math.max(0, domain$1[1])];
        }

        return {
          domain: domain$1,
          margin: this._dataMargin
        };
      }

      var isX = this.isX();
      var getBoxRange = isX ? function (box) {
        return [box.x, box.x + box.w];
      } : function (box) {
        return [box.y, box.y + box.h];
      };
      var shapes = this._plots;
      var domain = shapes.length ? getBoxRange(boxUtils.domainBox(shapes)) : undefined;

      if (domain) {
        if (showZero) {
          domain = [Math.min(0, domain[0]), Math.max(0, domain[1])];
        }
      } else {
        domain = showZero ? [0, 0] : undefined;
        return {
          domain: domain,
          margin: [0, 0]
        };
      } // no plot associated with axis yet
      // Get test scale, configure data domain to be the domain range of all plot shapes, but
      // margin to be zero. The scale also considers reflines, custom domain. It is as
      // close as possible to the eventual scale, with the only difference on margin. We would
      // like to estimate the margin based on this test scale.
      //
      //  1) bounded by shape which is also at the lowest position
      //
      //  |
      //  |         _______     +
      //  |        /       \
      //  |       /         \
      //  |      |    _|_    |      ___ dataRange[0]
      //  |      |     |     |
      //  |       \         /
      //  |        \_______/        ___ shapeRange[0]
      //  |
      //
      //  2) cross over, bounded by shape which is not at lowest position
      //
      //  |
      //  |         _______
      //  |        /       \
      //  |       /         \
      //  |      |    _|_    |
      //  |      |     |     |
      //  |       \         /    +  --- dataRange[0]
      //  |        \_______/        ___ shapeRange[0]
      //  |
      //


      var testScale = this._getScale(domain, [0, 0], false);

      var testScaleInv = {
        scale: function scale(n) {
          return testScale.invert(n);
        }
      };

      for (var i = 0; i < shapes.length; i++) {
        shapes[i].applyScales(isX ? {
          x: testScale
        } : {
          y: testScale
        });
      }

      var shapeRange = getBoxRange(boxUtils.boundingBox(shapes));

      for (var i$1 = 0; i$1 < shapes.length; i$1++) {
        shapes[i$1].applyScales(isX ? {
          x: testScaleInv
        } : {
          y: testScaleInv
        });
      }

      var dataRange = [testScale.scale(domain[0]), testScale.scale(domain[1])];
      var margin = [Math.max(dataRange[0] - shapeRange[0], 0), Math.max(shapeRange[1] - dataRange[1], 0)]; // if margin is too small, probably a rounding error from the shape
      // scaling above, just regard it as zero.

      margin[0] = margin[0] < DATA_MARGIN_TOLERANCE ? 0 : margin[0];
      margin[1] = margin[1] < DATA_MARGIN_TOLERANCE ? 0 : margin[1]; // magic margin increment, because we seem to have some rounding error. if using the
      // exact margin calculated, and the chart is rotated afterwards, and a viewport
      // defined, the top of the shape bounding the upper limit is always cut off by 1.5px.

      if (margin[1]) {
        margin[1] += DATA_MARGIN_RELAX;
      }

      if (margin[0]) {
        margin[0] += DATA_MARGIN_RELAX;
      }

      return {
        domain: domain,
        margin: margin
      };
    };

    NumericAxisLayout.prototype._getMarginByBoundType = function _getMarginByBoundType(boundType, value, dataShapeMargin) {
      switch (boundType) {
        case BOUND_TYPE.REFLINE:
          return Math.max(this._referenceLineMargin, dataShapeMargin);

        case BOUND_TYPE.DATA:
          return dataShapeMargin;

        default:
          return 0;
      }
    };

    NumericAxisLayout.prototype._getScale = function _getScale(dataDomain, dataMargin, niced) {
      if (niced === void 0) niced = true;
      var numericScale = (scales[this._scaleType] || scales.linear)();

      var ref = this._getAxisDomainInfo(dataDomain, dataMargin, niced);

      var domain = ref.domain;
      var margin = ref.margin;
      var step = ref.step;

      if (!domain) {
        return undefined;
      }

      var formatMultiplier = this.getFormatMultiplier();

      if (formatMultiplier !== 1) {
        domain = [domain[0] / formatMultiplier, domain[1] / formatMultiplier];
        step = step / formatMultiplier;
      }

      var adjustMin = this._getAdjustMin();

      var scale = numericScale.domain(domain) // @bug W-510395, On timeline chart, we don't want margin, because it may cause two horizontal axes exist.
      // Thus, we remove it from range in that case. And in adjustRange, we use -margin[0] to extend the viewport
      // in chart, so the point lies on axis would not be cut off.
      .range([adjustMin ? 0 : margin[0], this._size - margin[1]]).adjustRange([adjustMin ? -margin[0] : 0, this._size]).step(step);
      return scale;
    };

    NumericAxisLayout.prototype.settleAxisDomainInfo = function settleAxisDomainInfo() {
      var ref = this.getAxisDomainInfo();
      var domain = ref.domain;
      var margin = ref.margin;
      var step = ref.step;
      this.setAxisDomain(domain).setAxisMargin(margin).setStep(step);
      return this;
    };

    NumericAxisLayout.prototype.getScale = function getScale() {
      return this._getScale();
    };

    return NumericAxisLayout;
  }(AxisLayout); //


  var TimeAxisLayout = function (AxisLayou____1) {
    function TimeAxisLayout() {
      AxisLayou____1.call(this);
      this._granularity = constants$1.TIME_GRANULARITY.MONTH;
      this._isDiscrete = false;
    }

    if (AxisLayou____1) TimeAxisLayout.__proto__ = AxisLayou____1;
    TimeAxisLayout.prototype = Object.create(AxisLayou____1 && AxisLayou____1.prototype);
    TimeAxisLayout.prototype.constructor = TimeAxisLayout;

    TimeAxisLayout.prototype.setFormats = function setFormats(formats) {
      this._formats = formats;
      return this;
    };

    TimeAxisLayout.prototype.getFormats = function getFormats() {
      return this._formats;
    };

    TimeAxisLayout.prototype.setGranularity = function setGranularity(granularity) {
      return this._set("_granularity", granularity);
    };

    TimeAxisLayout.prototype.getGranularity = function getGranularity() {
      return this._granularity;
    };

    TimeAxisLayout.prototype.setDataGranularity = function setDataGranularity(granularity) {
      return this._set("_dataGranularity", granularity);
    };

    TimeAxisLayout.prototype.getDataGranularity = function getDataGranularity() {
      return this._dataGranularity;
    };

    TimeAxisLayout.prototype.setFirstDayOfWeek = function setFirstDayOfWeek(firstDayOfWeek) {
      return this._set("_firstDayOfWeek", firstDayOfWeek);
    };

    TimeAxisLayout.prototype.getFirstDayOfWeek = function getFirstDayOfWeek() {
      return this._firstDayOfWeek;
    };

    TimeAxisLayout.prototype.setIsDiscrete = function setIsDiscrete(isDiscrete) {
      return this._set("_isDiscrete", isDiscrete);
    };

    TimeAxisLayout.prototype.isDiscrete = function isDiscrete() {
      return this._isDiscrete;
    };

    TimeAxisLayout.prototype.setDomain = function setDomain(domain) {
      return this._set("_domain", domain);
    };

    TimeAxisLayout.prototype.needsScroll = function needsScroll() {
      if (!this._size) {
        return false;
      }

      var layoutInfo = this.getLayoutInfo();
      return layoutInfo != undefined && layoutInfo.plot.plotSize > this._size + 0.1;
    };

    TimeAxisLayout.prototype.getLayoutInfo = function getLayoutInfo() {
      if (!this._layoutInfo) {
        this._computeLayoutInfo();
      }

      return this._layoutInfo;
    };

    TimeAxisLayout.prototype._computeLayoutInfo = function _computeLayoutInfo() {
      //@flow-ignore
      var ref = this._plotOptions;
      var barSize = ref.barSize;
      var barSpacer = ref.barSpacer;
      var labelSize = ref.labelSize;
      var pointRadius = ref.pointRadius;
      var marks = ref.marks;
      var isAxisModeMulti = ref.isAxisModeMulti;
      var autoFitMode = this._autoFitMode;
      var minSpacer = this._minSpacer;
      var totalSize = this._size;
      var granularity = this._dataGranularity;
      var firstDayOfWeek = this._firstDayOfWeek;
      var domain = this._domain;

      var numBars = this._getNumMarks(marks, constants$1.MARK_TYPE.BAR, isAxisModeMulti);

      var numLines = this._getNumMarks(marks, constants$1.MARK_TYPE.LINE, isAxisModeMulti);

      var isFit = autoFitMode === constants$1.AUTOFIT_MODE.FIT;
      var min, max, totalUnits, distance, rangeOffset, plotSize, scale;
      var barTotalSize = 0;

      if (domain && domain[0] !== undefined) {
        min = domain[0];
        max = domain[1]; // get total units of grains (number of months)
        // - time range / milliseconds in one grain

        totalUnits = time.diff(min, max, granularity, firstDayOfWeek) + 1;
      } else {
        // when field is missing, pretend it's a time scale around a constant date
        min = max = time.getConstantEpoch();
        totalUnits = 1;
      }

      if (isFit) {
        distance = totalSize / totalUnits;
        rangeOffset = distance / 2; // shrink the time axis a bit to just fit the first and last point
        // - only lines, no bars, we always want to fit the start and end point tight at
        // the axis, instead of leaving a half interval distance
        // - lines and, but when point radius is so big that it will extends
        // out of plot into axis area

        if (numLines && totalUnits > 1) {
          if (!numBars || rangeOffset < pointRadius) {
            rangeOffset = Math.min(pointRadius, totalSize / 2);
            distance = (totalSize - 2 * pointRadius) / (totalUnits - 1);
          }
        }

        if (numBars) {
          var spacer1 = this._computeFirstSpacer(distance, minSpacer);

          if (numBars === 1 && granularity === "month") {
            // each month varies in duration, which may cause a noticeable difference in spacer
            // make spacer at least 20% of bar so it's not that obvious
            spacer1 = Math.max(spacer1, distance * 0.45);
          }

          barTotalSize = Math.min(distance - spacer1, this._maxBarSize);

          if (numBars > 1) {
            // - for multimetric bar chart
            // - calculate spacing between multi-metric bars
            barSpacer = barTotalSize / numBars < 12 ? 0 : 1; // - calculate each bar size

            barSize = (barTotalSize - barSpacer * (numBars - 1)) / numBars;
          } else {
            barSize = barTotalSize;
          }
        }

        plotSize = totalSize;
      } else {
        if (numBars === 1 && granularity === "month") {
          // each month varies in duration, which may cause a noticeable difference in spacer
          // make spacer at least 20% of bar so it's not that obvious
          barSpacer = Math.max(barSpacer, barSize * 0.45);
        }

        if (numBars) {
          barTotalSize = numBars * (barSize + barSpacer) - barSpacer;
          var spacerBetweenUnits = numBars === 1 ? barSpacer : this._computeSpacers(barSpacer, barTotalSize)[1];
          plotSize = totalUnits * (barTotalSize + spacerBetweenUnits) - spacerBetweenUnits;
          rangeOffset = barTotalSize / 2;
        } else {
          plotSize = totalUnits * labelSize;
          rangeOffset = labelSize / 2;
        }
      }

      if (totalUnits === 1) {
        // single data point
        // - fit mode:
        //   - continuous time: expand the time domain by +- 2 granularities so axis always show more context of the time point
        //   - discrete time: we don't want to expand by +- granularities because when the single data
        //     point is the first or last one, e.g. day 1, month Dec, we don't want to display day 31 prior
        //     to day 1.
        // - scroll mode: expand the time domain by +- millisecond so axis never show any other tick labels
        if (isFit && !this.isDiscrete()) {
          min = time.offset(min, -2, granularity, firstDayOfWeek).valueOf();
          max = time.offset(max, 2, granularity, firstDayOfWeek).valueOf();
        } else {
          min--;
          max++;
        }

        scale = scales.linear().domain([min, max]).range([0, plotSize]);
      } else {
        scale = scales.linear().domain([min, max]).range([rangeOffset, plotSize - rangeOffset]).adjustRange([0, plotSize]);
      }

      var offsets = this._computePlotOffsets(marks, isAxisModeMulti, barTotalSize, barSize, barSpacer); // only calculate categories when there are lines


      var categories = numLines ? time.getCategories(scale, granularity, firstDayOfWeek) : undefined;
      this._layoutInfo = {
        plot: {
          barSize: barSize,
          plotSize: plotSize,
          offsets: offsets,
          labelSize: distance || labelSize
        },
        categories: categories,
        scale: scale
      };
    };

    TimeAxisLayout.prototype.getScale = function getScale() {
      if (!this._layoutInfo) {
        this._computeLayoutInfo();
      }

      return this._layoutInfo && this._layoutInfo.scale;
    };

    return TimeAxisLayout;
  }(AxisLayout); //
  //@flow-ignore


  var rowsFormatter$5 = RowsFormatter$1.getInstance();
  var MARK_TYPE = constants$1.MARK_TYPE;
  var LABEL_HEIGHT$1;

  var CategoricalAxisLayout = function (AxisLayou____1) {
    function CategoricalAxisLayout() {
      AxisLayou____1.call(this);
      this._hasIcon = false;
      this._hasSeries = false;
    }

    if (AxisLayou____1) CategoricalAxisLayout.__proto__ = AxisLayou____1;
    CategoricalAxisLayout.prototype = Object.create(AxisLayou____1 && AxisLayou____1.prototype);
    CategoricalAxisLayout.prototype.constructor = CategoricalAxisLayout;

    CategoricalAxisLayout.prototype.hasHierarchy = function hasHierarchy() {
      if (!this._rows) {
        return false;
      }

      return this._rows.hasHierarchy();
    };

    CategoricalAxisLayout.prototype.setHasIcon = function setHasIcon(hasIcon) {
      return this._set("_hasIcon", hasIcon);
    };

    CategoricalAxisLayout.prototype.setRows = function setRows(rows) {
      return this._set("_rows", rows);
    };

    CategoricalAxisLayout.prototype.getRows = function getRows() {
      return this._rows;
    };

    CategoricalAxisLayout.prototype.setLabelsDepth = function setLabelsDepth(labelsDepth) {
      return this._set("_labelsDepth", labelsDepth);
    };

    CategoricalAxisLayout.prototype.getLabelsDepth = function getLabelsDepth() {
      return this._labelsDepth;
    };

    CategoricalAxisLayout.prototype.setHasSeries = function setHasSeries(hasSeries) {
      return this._set("_hasSeries", hasSeries);
    };
    /**
     * Whether current total size of axis exceeds allocated size, which requires scolling to
     * view all the axis labels
     */


    CategoricalAxisLayout.prototype.needsScroll = function needsScroll() {
      if (!this._rows || !this._size) {
        return false;
      }

      return this._rows.getLayout().h > this._size + 0.1;
    };

    CategoricalAxisLayout.prototype.getLayoutInfo = function getLayoutInfo() {
      if (!this._layoutInfo) {
        this._computeLayoutInfo();
      }

      return this._layoutInfo;
    };

    CategoricalAxisLayout.prototype.setRowsLayout = function setRowsLayout(rowHeight, spacers) {
      if (this._rows) {
        this._rowHeight = rowHeight;
        this._rowSpacers = spacers;

        this._rows.setLayout({
          rowHeight: rowHeight,
          spacers: spacers
        });
      }

      return this._recomputeLayout();
    };

    CategoricalAxisLayout.prototype._computeLayoutInfo = function _computeLayoutInfo() {
      if (this._rows) {
        this._layoutInfo = {
          plot: this._computePlotLayoutInfo(),
          axis: this._computeAxisLayoutInfo(),
          //@flow-ignore
          scale: this._rows.getScale(),
          //@flow-ignore
          categories: this._rows.getCategories()
        };
      }
    };

    CategoricalAxisLayout.prototype._getLabelHeight = function _getLabelHeight() {
      if (!LABEL_HEIGHT$1) {
        var Delegate = WaveChartsRuntime.getDelegate();
        var REAL_LABEL_TEXT_SIZE = Delegate.getRealFontSize(constants$1.AXIS.LABELS.TEXT.SIZE);
        LABEL_HEIGHT$1 = {
          WIDE: REAL_LABEL_TEXT_SIZE + constants$1.AXIS.LABELS.PADDING.WIDE * 2,
          SMALL: REAL_LABEL_TEXT_SIZE + constants$1.AXIS.LABELS.PADDING.SMALL * 2,
          WITH_ICON: constants$1.ICON.SIZE
        };
      }

      return LABEL_HEIGHT$1;
    }; // Compute layout info for plot layers depending on autoFit options and data rows represented
    // by tabularRows. It will also assign a layout to tabularRows accordingly.
    //
    // @return {Object}
    //         {Number} barSize after autoFit logic
    //         {Number} labelSize after autoFit logic
    //         {Array} offsets of each plot series(one plot series per mark)
    //         {Number} plotSize total space taken by all plots


    CategoricalAxisLayout.prototype._computePlotLayoutInfo = function _computePlotLayoutInfo() {
      var this$1 = this;

      if (!this._plotOptions) {
        return;
      }

      var rows = this._rows;

      if (!rows) {
        return;
      }

      var LABEL_HEIGHT = this._getLabelHeight();

      var rowHeight = 0;
      var spacers = [];
      var barTotalSize = 0; //@flow-ignore

      var ref = this._plotOptions;
      var barSize = ref.barSize;
      var barSpacer = ref.barSpacer;
      var labelSize = ref.labelSize;
      var marks = ref.marks;
      var isAxisModeMulti = ref.isAxisModeMulti;
      var autoFitMode = this._autoFitMode;
      var minSpacer = this._minSpacer;
      var hasIcon = this._hasIcon;
      var totalSize = this._size;
      var keepLabels = autoFitMode === constants$1.AUTOFIT_MODE.KEEP_LABELS;
      var minRowHeight = hasIcon ? LABEL_HEIGHT.WITH_ICON + 1 : LABEL_HEIGHT.SMALL;

      var numBars = this._getNumMarks(marks, MARK_TYPE.BAR, isAxisModeMulti);

      var computeFallBackSpacingForIcons = function computeFallBackSpacingForIcons() {
        // When icons are present and we are reached the minimal size (in keepLabels)
        // or we are in scroll mode, we don't want to do the regular '1' pixel spacer.
        // Instead we want to get the same spacer as keepLabels when the rowHeight is
        // exactly the minRowHeight.
        //
        // With an icon size of 30 pixels, this will give us a spacer of around 2.7px
        // and bars of about 27 pixels
        // This makes the chart a little cleaner (bars are not that fat...)
        //
        // Note that we could hardcode all these numbers, but it's probably better
        // to go through the regular utils methods...
        var spacer1 = this$1._computeFirstSpacer(minRowHeight, minSpacer) + 1; // adding 1 since it does look at a little better with more space...

        spacers = this$1._computeSpacers(spacer1, minRowHeight - spacer1);
        barTotalSize = barSize = rowHeight = minRowHeight - spacer1;
      };

      if (autoFitMode !== constants$1.AUTOFIT_MODE.SCROLL) {
        // needs some autoFit logic
        if (numBars) {
          // when bars present, fit bar size and spacing, the result will dictate layout(line follows)
          // - distance is the space between bars center, bars evenly distributed
          var distance = totalSize / rows.numBaseRows();

          if (keepLabels && distance < minRowHeight) {
            // KEEP_LABELS mode, do not allow rowHeight to go below label height
            if (hasIcon) {
              computeFallBackSpacingForIcons();
            } else {
              rowHeight = minRowHeight;
              spacers = this._computeSpacers(1, rowHeight);
            }
          } else {
            var spacer1 = this._computeFirstSpacer(distance, minSpacer);

            spacers = this._computeSpacers(spacer1, distance - spacer1); // - rest is for bar area

            rowHeight = Math.max(distance - spacer1, 1);
            var minScalingFactor = keepLabels ? LABEL_HEIGHT.SMALL / rowHeight : 0; // - calculate total size after adding spacings

            rows.setLayout({
              rowHeight: rowHeight,
              spacers: spacers
            }); // - scale up/down bar size/spacing to occupy all space

            var currentSize = rows.getLayout().h;
            var scalingFactor = Math.max(totalSize / currentSize, minScalingFactor);
            rowHeight *= scalingFactor;
            spacers = spacers.map(function (s) {
              return s *= scalingFactor;
            });
          } // - calculate final bar size
          //   note: increase barsize for minor overlap when they are rendered with 0 spacing
          //   otherwise misterious white space between bars show up because of antialiasing


          barTotalSize = Math.min(rowHeight, this._maxBarSize);

          if (numBars > 1) {
            // - for multimetric bar chart
            // - calculate spacing between multi-metric bars
            barSpacer = barTotalSize / numBars < 12 ? 0 : 1; // - calculate each bar size

            barSize = (barTotalSize - barSpacer * (numBars - 1)) / numBars;
          } else {
            barSize = barTotalSize;

            if (!spacers[0]) {
              barSize += 1;
            }

            barSpacer = 0;
          }
        } else {
          rowHeight = totalSize / rows.numBaseRows();

          if (autoFitMode === constants$1.AUTOFIT_MODE.KEEP_LABELS) {
            rowHeight = Math.max(rowHeight, minRowHeight);
          }

          spacers = [0, 0, 0];
        }
      } else {
        spacers = this._computeSpacers(barSpacer, barSize);
        barTotalSize = numBars * barSize + (numBars - 1) * barSpacer;

        switch (numBars) {
          case 0:
            rowHeight = labelSize;
            spacers = [0];
            break;

          case 1:
            if (hasIcon) {
              computeFallBackSpacingForIcons();
            } else {
              rowHeight = barSize;
            }

            break;

          default:
            rowHeight = barTotalSize;
            spacers.shift();
        }
      }

      rows.setLayout({
        rowHeight: rowHeight,
        spacers: spacers
      });

      var offsets = this._computePlotOffsets(marks, isAxisModeMulti, barTotalSize, barSize, barSpacer);

      return {
        barSize: barSize,
        offsets: offsets,
        labelSize: rowHeight,
        plotSize: rows.getLayout().h
      };
    }; // Compute layout info for labels
    // @return {Object} { layout, numColumns }
    //                 {String} layout of labels axis
    //                 {Number} numColumns to show on labels axis


    CategoricalAxisLayout.prototype._computeAxisLayoutInfo = function _computeAxisLayoutInfo() {
      if (!this._rows) {
        return;
      }

      var LABEL_HEIGHT = this._getLabelHeight();

      var Delegate = WaveChartsRuntime.getDelegate();
      var layout;
      var showAxis = this._showAxis;
      var angle = Math.PI / 4;
      var size = this._width;
      var hasIcon = this._hasIcon;
      var rows = this._rows;

      if (!rows) {
        return;
      }

      var ref = constants$1.AXIS.LABELS.LAYOUT;
      var NORMAL = ref.NORMAL;
      var ORTHOGONAL = ref.ORTHOGONAL;
      var SLANTED = ref.SLANTED;
      var HIDDEN = ref.HIDDEN;
      var ref$1 = constants$1.AXIS.LABELS;
      var PADDING = ref$1.PADDING;
      var totalNumColumns = rows.getFields().length; // - hide dimension labels
      // - no fields

      if (!showAxis || !totalNumColumns) {
        return {
          layout: HIDDEN,
          numColumns: this._getNumColumns(0)
        };
      }

      var rowHeight = rows.getRowHeight();
      var hasHierarchy = rows.hasHierarchy(); // label heights and fitting dimension are different when x-horizontal
      // so separate out this orientation
      // max number of columns constrained by orientation
      // label width: y-horizontal, x-vertical, x-slanted
      // label height: x-horizontal

      var minColumnWidth = hasIcon ? constants$1.AXIS.LABELS.MIN_COLUMN_SIZE + constants$1.ICON.SIZE + constants$1.ICON.TEXT_PADDING : constants$1.AXIS.LABELS.MIN_COLUMN_SIZE;
      var maxNumColumns = {
        ORTHOGONAL: Math.floor(size / LABEL_HEIGHT.WIDE),
        OTHER: Math.floor(size / minColumnWidth)
      };
      var measureText = {
        ORTHOGONAL: function ORTHOGONAL(key, field) {
          // **Note** 1 here is to make truncation more robust
          // problem is that if w = getWidth(text), and we set text's max width to be w
          // sometimes text will end up truncated, this is especially bad when text is short
          // the truncation will end up being "..."
          return Delegate.getTextWidth(rowsFormatter$5.formatColumnValue(key, field), constants$1.AXIS.LABELS.TEXT.SIZE) + 1 + PADDING.SMALL * 2;
        },
        OTHER: function OTHER(key, field) {
          return LABEL_HEIGHT.SMALL;
        }
      };

      var getColumnFits = function getColumnFits(measureFct, numColumns) {
        var n = rows.numColumns();
        var res = dataUtils.range(0, n).map(function (i) {
          return i < numColumns;
        });
        rows.traverse(function (key, field, columnInfo, rowInfo) {
          var colIndex = columnInfo.index;

          if (res[colIndex] && measureFct(key, field) > rowInfo.layout.h + 0.1) {
            return res[colIndex] = false;
          }
        }); // max number of columns under this level, all columns can fit

        var max = res.indexOf(false);
        max = max < 0 ? n : max; // whether the last column can fit

        var isLastFit = lodash__default.last(res); // find the grainest level of column which can fit

        var grainest = res.lastIndexOf(true) + 1;
        return {
          isLastFit: isLastFit,
          max: max,
          grainest: grainest
        };
      }; // x axis - NORMAL, ORTHOGONAL, SLANTED


      if (this.isX()) {
        // first try x-horizontal fitting
        var horizontalFits = getColumnFits(measureText.ORTHOGONAL, maxNumColumns.ORTHOGONAL);

        if (totalNumColumns > 1) {
          // multi level group
          // - (show all levels horizontal) Hierarchical(non flat) - if last(grainest) column fit, show all
          //    and tolerate truncation in other columns
          if (hasHierarchy && horizontalFits.isLastFit) {
            return {
              layout: ORTHOGONAL,
              numColumns: this._getNumColumns(totalNumColumns)
            };
          } // - (show all levels horizontal) Flat rows - only show all when all columns fit


          if (!hasHierarchy && horizontalFits.max === totalNumColumns) {
            return {
              layout: ORTHOGONAL,
              numColumns: this._getNumColumns(totalNumColumns)
            };
          } // then try other orientation fitting
          // - (show all levels vertical) columns fit at all levels vertically


          var verticalFits = getColumnFits(measureText.OTHER, maxNumColumns.OTHER);

          if (verticalFits.max === totalNumColumns) {
            return {
              layout: NORMAL,
              numColumns: this._getNumColumns(totalNumColumns)
            };
          } // - (show some levels) pick horizontal/vertical whichever fits the most grainest column


          if (verticalFits.grainest > 0 || horizontalFits.grainest > 0) {
            if (horizontalFits.grainest >= verticalFits.grainest) {
              return {
                layout: ORTHOGONAL,
                numColumns: this._getNumColumns(horizontalFits.grainest)
              };
            } else {
              return {
                layout: NORMAL,
                numColumns: this._getNumColumns(verticalFits.grainest)
              };
            }
          } else {
            // (hide) - not fit in all cases
            return {
              layout: HIDDEN,
              numColumns: this._getNumColumns(0)
            };
          }
        } else {
          // 1 level group
          layout = horizontalFits.max ? // - fit horizontally
          ORTHOGONAL : maxNumColumns.OTHER && rowHeight >= LABEL_HEIGHT.SMALL ? // - try slanted when fit, then vertical
          rowHeight > LABEL_HEIGHT.SMALL / Math.cos(angle) && !this.needsScroll() ? SLANTED : NORMAL : HIDDEN;
          return {
            layout: layout,
            numColumns: this._getNumColumns(layout === HIDDEN ? 0 : 1)
          };
        }
      } else {
        // y axis - NORMAL
        var ref$2 = getColumnFits(measureText.OTHER, maxNumColumns.OTHER);
        var max = ref$2.max;
        layout = max > 0 ? NORMAL : HIDDEN;
        return {
          layout: layout,
          numColumns: this._getNumColumns(max)
        };
      }
    };

    CategoricalAxisLayout.prototype.getScale = function getScale(columnIndex) {
      if (columnIndex == undefined) {
        if (!this._layoutInfo) {
          this._computeLayoutInfo();
        }

        return this._layoutInfo && this._layoutInfo.scale;
      } else {
        return this._rows && this._rows.getScale(columnIndex);
      }
    };

    CategoricalAxisLayout.prototype.getCategories = function getCategories(columnIndex) {
      if (columnIndex == undefined) {
        if (!this._layoutInfo) {
          this._computeLayoutInfo();
        }

        return this._layoutInfo && this._layoutInfo.categories;
      } else {
        return this._rows && this._rows.getCategories(columnIndex);
      }
    };

    CategoricalAxisLayout.prototype._getNumColumns = function _getNumColumns(numColumns) {
      if (this._labelsDepth != null) {
        return Math.min(numColumns, this._labelsDepth);
      } else {
        return numColumns;
      }
    };

    return CategoricalAxisLayout;
  }(AxisLayout); //


  var AxisLayoutFactory = function AxisLayoutFactory() {};

  AxisLayoutFactory.prototype.make = function make(type) {
    switch (type) {
      case constants$1.CHART_LAYOUT.AXIS_TYPE.NUMERIC:
        return new NumericAxisLayout();

      case constants$1.CHART_LAYOUT.AXIS_TYPE.TIME:
        return new TimeAxisLayout();

      case constants$1.CHART_LAYOUT.AXIS_TYPE.CATEGORICAL:
        return new CategoricalAxisLayout();

      default:
        throw new Error("invalid radiusLayout type " + type);
    }
  };

  var AxisLayoutFactory$1 = singleton(AxisLayoutFactory);
  var colorLayoutFactory = ColorLayoutFactory$1.getInstance();
  var radiusLayoutFactory = RadiusLayoutFactory$1.getInstance();
  var axisLayoutFactory = AxisLayoutFactory$1.getInstance();
  var CHART_LAYOUT = constants$1.CHART_LAYOUT;
  var layoutsUtils = {
    getChartColorLayout: function getChartColorLayout(colorConfig, value, rows, theme, legendSwatchType) {
      if (colorConfig === void 0) colorConfig = {};
      var colorLayout;
      var colorField = colorConfig.column && colorConfig.column[0];

      if (colorField) {
        var colorLayoutType = colorConfig.type ? colorConfig.type : CHART_LAYOUT.COLOR_TYPE.CATEGORICAL;
        var layoutParams = {
          field: colorField,
          theme: theme,
          legendSwatchType: legendSwatchType
        };

        switch (colorLayoutType) {
          case CHART_LAYOUT.COLOR_TYPE.CATEGORICAL:
            {
              // calculate dimension domain
              var domain = colorConfig.domain || domainUtils.getOrdinalDomain(rows, colorField);
              var palette = colorConfig.range ? colorConfig.range.getPaletteColors(domain.length) : colorConfig.colors;
              lodash__default.extend(layoutParams, {
                domain: domain,
                palette: palette,
                respectPaletteColorOrder: colorConfig.range != null,
                // TODO legacy behavior of defaulting sortColor to true, should move into
                // application specific logic
                sortColor: colorConfig.sortColor != undefined ? colorConfig.sortColor : true
              });
              colorLayout = colorLayoutFactory.make(CHART_LAYOUT.COLOR_TYPE.CATEGORICAL, layoutParams);
              break;
            }

          case CHART_LAYOUT.COLOR_TYPE.BINS:
            {
              lodash__default.extend(layoutParams, {
                rows: rows,
                palette: colorConfig.colors,
                numBins: colorConfig.numBins,
                breakpoints: colorConfig.breakpoints,
                bands: colorConfig.bands
              });
              colorLayout = colorLayoutFactory.make(CHART_LAYOUT.COLOR_TYPE.BINS, layoutParams);
              break;
            }

          case CHART_LAYOUT.COLOR_TYPE.GRADIENT:
            {
              // calculate measure domain
              lodash__default.extend(layoutParams, {
                domain: colorConfig.domain || domainUtils.getNumericDomain(rows, colorField),
                gradient: colorConfig.range
              });
              colorLayout = colorLayoutFactory.make(CHART_LAYOUT.COLOR_TYPE.GRADIENT, layoutParams);
              break;
            }
        }
      } else if (colorUtils.isColor(colorConfig)) {
        colorLayout = colorLayoutFactory.make(CHART_LAYOUT.COLOR_TYPE.CONSTANT, {
          value: colorConfig
        });
      } else if (value !== undefined || colorConfig.range) {
        value = colorConfig.range ? colorConfig.range : value;
        colorLayout = colorLayoutFactory.make(CHART_LAYOUT.COLOR_TYPE.CONSTANT, {
          value: value
        });
      }

      return colorLayout;
    },
    getChartRadiusLayout: function getChartRadiusLayout(radiusConfig, size, padding, rows) {
      if (radiusConfig === void 0) radiusConfig = {};
      var maxRadius = radiusConfig.maxRadius;
      var radiusRatio = radiusConfig.radiusRatio;
      var domain = radiusConfig.domain;
      var column = radiusConfig.column;
      var radiusColumn = column && column[0];
      var radiusLayout;
      var chartRelativeSize = Math.min(size[0] - padding.left - padding.right, size[1] - padding.top - padding.bottom);

      if (radiusColumn) {
        domain = domain || domainUtils.getNumericDomain(rows, radiusColumn);
        radiusLayout = radiusLayoutFactory.make(CHART_LAYOUT.RADIUS_TYPE.SQRT).setField(radiusColumn).setRelativeSize(chartRelativeSize).setMaxValue(Math.max(Math.abs(domain[0]), Math.abs(domain[1]))).setMaxRadius(maxRadius).setRatio(radiusRatio);
      } else {
        radiusLayout = radiusLayoutFactory.make(CHART_LAYOUT.CONSTANT).setRelativeSize(chartRelativeSize).setValue(maxRadius).setRatio(radiusRatio);
      }

      return radiusLayout;
    },
    updateRadiusLayout: function updateRadiusLayout(radiusLayout, size, padding) {
      // Now config.size, config.padding has been settled after estimating legend size
      // We need to update radiusLayout's relative size, and also legend
      var chartEffectiveSize = [size[0] - padding.left - padding.right, size[1] - padding.top - padding.bottom];
      radiusLayout.setRelativeSize(Math.min(chartEffectiveSize[0], chartEffectiveSize[1]));
    },
    getChartNumericAxisLayout: function getChartNumericAxisLayout(axis) {
      if (!axis) {
        return undefined;
      }

      var domain = axis.domain;
      var referenceLines = axis.referenceLines;
      var scale = axis.scale;
      var showZero = axis.showZero;
      var format = axis.format;
      var axisLayout = axisLayoutFactory.make(CHART_LAYOUT.AXIS_TYPE.NUMERIC).setShowZero(showZero).setFormat(format).setCustomDomain(domain).setScaleType(scale).setReferenceLines(referenceLines);
      return axisLayout;
    },
    getChartCategoricalAxisLayout: function getChartCategoricalAxisLayout(axis, rows, plotOptions, autoFitMode) {
      if (!axis) {
        return undefined;
      }

      var showAxis = axis.showAxis;
      var labelsDepth = axis.labelsDepth;
      var hasIcon = configUtils.hasIcon(axis);
      return axisLayoutFactory.make(CHART_LAYOUT.AXIS_TYPE.CATEGORICAL).setRows(rows).setPlotOptions(plotOptions).setAutoFitMode(autoFitMode).setShowAxis(showAxis).setHasIcon(hasIcon).setLabelsDepth(labelsDepth);
    },
    getChartTimeAxisLayout: function getChartTimeAxisLayout(axis, rows, plotOptions, autoFitMode) {
      if (!axis) {
        return undefined;
      }

      var formats = axis.formats;
      var granularity = axis.granularity;
      var showAxis = axis.showAxis;
      var column = axis.column[0];
      var domain = domainUtils.getNumericDomain(rows, column, true);
      var dataGranularity = column.getGranularity();
      return axisLayoutFactory.make(CHART_LAYOUT.AXIS_TYPE.TIME).setGranularity(granularity || dataGranularity).setDataGranularity(dataGranularity).setIsDiscrete(column.isDiscrete()).setFirstDayOfWeek(column.getFirstDayOfWeek()).setFormats(formats).setDomain(domain).setPlotOptions(plotOptions).setShowAxis(showAxis).setAutoFitMode(autoFitMode);
    },
    alignNumericAxisLayouts: function alignNumericAxisLayouts(layouts, alignTicks) {
      if (alignTicks === void 0) alignTicks = false;

      if (layouts.length === 0) {
        return;
      }

      if (layouts.length === 1) {
        layouts[0].settleAxisDomainInfo();
        return;
      }

      var domains = [];
      var lowMargins = [];
      var highMargins = [];
      var refDomains = [];
      var steps = [];
      var scaleType = layouts[0].getScaleType();
      layouts.map(function (layout) {
        var ref = layout.getAxisDomainInfo();
        var domain = ref.domain;
        var margin = ref.margin;
        var step = ref.step;

        if (layout.hasCustomDomain()) {
          // custom domain is defined on this axis
          refDomains.push(domain);
          alignTicks = false;
        }

        domains.push(domain);
        lowMargins.push(margin[0]);
        highMargins.push(margin[1]);
        steps.push(step);
        alignTicks = alignTicks && !!step && scaleType === layout.getScaleType();
      });
      var aligned = false;
      var alignedMargin;
      var alignedDomains = domains;

      if (refDomains.length < 2) {
        // 0 - no axis has custom domain to align to
        // 1 - one axis has custom domain
        // 1+ - more than one axis has custom domain (do not align)
        var alignResults = domainUtils.alignZerosForDomain(domains, alignTicks ? steps : undefined, refDomains.length === 1 ? refDomains[0] : undefined);
        aligned = alignResults.aligned;
        steps = alignResults.steps || steps;

        if (aligned) {
          alignedDomains = alignResults.domains;
          layouts.forEach(function (layout, i) {
            var domain = domains[i];
            var alignedDomain = alignedDomains[i];

            var scale = layout._getScale(alignedDomain, [0, 0], false);

            var margin = [lowMargins[i], highMargins[i]];
            var assign;
            assign = domainUtils.adjustMargin(domain, margin, scale), lowMargins[i] = assign[0], highMargins[i] = assign[1];
          });
          alignedMargin = [Math.max.apply(Math, lowMargins), Math.max.apply(Math, highMargins)];
        }
      } // assume it aligned


      layouts.forEach(function (layout, i) {
        var domain = domains[i];
        var alignedDomain = alignedDomains[i];
        var step = alignTicks || domain[0] === alignedDomain[0] && domain[1] === alignedDomain[1] ? steps[i] : 0;
        layout.setAxisDomain(alignedDomains[i]).setAxisMargin(aligned ? alignedMargin : [lowMargins[i], highMargins[i]]).setStep(step);
      });
    }
  }; // 
  //@flow-ignore

  var ref$7 = constants$1.CHART_LAYOUT;
  var COLOR_TYPE$6 = ref$7.COLOR_TYPE;
  var COLUMN_TYPE$10 = constants$1.COLUMN_TYPE;
  var rowsFormatter$6 = RowsFormatter$1.getInstance();

  var DataFormatter = function DataFormatter() {
    this._tooltipColumns = [];
    this._colorInfo = {
      scale: function scale(x) {
        return x;
      },
      field: null,
      type: null,
      isMultimetric: false
    };
    this._showPercentage = true;
    this._showBinLabel = false;
    this._showNullValues = true;
    this._rowsMetadata = null;
    this._text = {
      template: "",
      color: null
    };
    this._theme = {};
  };

  DataFormatter.prototype.setTooltipColumns = function setTooltipColumns(columns) {
    if (columns) {
      this._tooltipColumns = columns;
    }

    return this;
  };

  DataFormatter.prototype.setText = function setText(text) {
    if (text && text.template) {
      this._text = text;
    }

    return this;
  };

  DataFormatter.prototype.setShowPercentage = function setShowPercentage(showPercentage) {
    if (showPercentage != null) {
      this._showPercentage = showPercentage;
    }

    return this;
  };

  DataFormatter.prototype.setShowBinLabel = function setShowBinLabel(showBinLabel) {
    if (showBinLabel != null) {
      this._showBinLabel = showBinLabel;
    }

    return this;
  };

  DataFormatter.prototype.setShowNullValues = function setShowNullValues(showNullValues) {
    if (showNullValues != null) {
      this._showNullValues = showNullValues;
    }

    return this;
  };

  DataFormatter.prototype.setColorInfo = function setColorInfo(colorInfo) {
    if (colorInfo != null) {
      this._colorInfo = colorInfo;
    }

    return this;
  };

  DataFormatter.prototype.setRowsMetadata = function setRowsMetadata(rowsMetadata) {
    if (rowsMetadata != null) {
      this._rowsMetadata = rowsMetadata;
    }

    return this;
  };

  DataFormatter.prototype.setTheme = function setTheme(theme) {
    if (theme != null) {
      this._theme = theme;
    }

    return this;
  }; // set a formatter function to format custom rows which do not exist in the rowsmetadata
  // for eg. the gauges set fake tooltip for the breakpoint arcs
  // the function should take in a row and return an object with an array for formatted dimensions/measures
  // eg function(row) {
  //	return [ {value: row.range} ];
  // }


  DataFormatter.prototype.setFormatterFunction = function setFormatterFunction(formatterFunction) {
    this._formatterFunction = formatterFunction;
    return this;
  };

  DataFormatter.prototype.setDataFunction = function setDataFunction(dataFunction) {
    this._dataFunction = dataFunction;
    return this;
  };

  DataFormatter.prototype.getTheme = function getTheme() {
    return this._theme;
  };

  DataFormatter.prototype.getTooltipColumns = function getTooltipColumns() {
    return this._tooltipColumns;
  };

  DataFormatter.prototype.getRowsMetadata = function getRowsMetadata() {
    return this._rowsMetadata;
  };

  DataFormatter.prototype.hasTooltip = function hasTooltip() {
    return this._tooltipColumns.length || this._text.template;
  };

  DataFormatter.prototype._formatColumnColor = function _formatColumnColor(columnName, formattedColumn, color) {
    if (!color) {
      return;
    }

    var ref = this._colorInfo;
    var field = ref.field;

    if (field && !lodash__default.isArray(field)) {
      field = [field];
    }

    if (field && lodash__default.find(field, function (field) {
      return field.getName() === columnName;
    })) {
      // if the column is the colorby column
      formattedColumn.color = color instanceof LinearGradient ? color.interpolate() : color;
    }
  }; // there could be 2 types of measure scale:
  // 1: multimetric chart - in this case we color all the multimetric measures by the measure name
  // 2: binned/gradient color chart - in this case we only want to color only one measure which was used for binning/bucketing. We need to use the value of the measure in this case


  DataFormatter.prototype._formatMeasureColumn = function _formatMeasureColumn(columnName, formattedColumn, row, color) {
    var ref = this._colorInfo;
    var scale = ref.scale;
    var type = ref.type;
    var field = ref.field;
    var isMultimetric = ref.isMultimetric;

    if (isMultimetric) {
      // if multimetric, there could be some extra measures in the tooltip which dont map to any color
      if (scale.domain().indexOf(columnName) >= 0) {
        formattedColumn.color = scale.scale(columnName);
      }
    } else {
      this._formatColumnColor(columnName, formattedColumn, color);

      if (type === COLOR_TYPE$6.BINS && this._showBinLabel && columnName == field.getName()) {
        var valueFct = valueFctUtils.getValueFct({
          field: field
        }, true);
        var binInfo = valueFct(row);

        if (binInfo) {
          formattedColumn.label += " (" + binInfo.label + ")";
        }
      }
    }
  }; // format dimension column with color


  DataFormatter.prototype._formatDimensionColumn = function _formatDimensionColumn(columnName, formattedColumn, row, color) {
    this._formatColumnColor(columnName, formattedColumn, color);
  }; // using the colorInfo, augments the formattedRows with more information
  // regarding the scale
  // @param row {object}
  // @return [
  //		{ label: "formattedlabel", value: "formattedValue", type: "dimension" },
  // 		{ label: "formattedlabel", value: "formattedValue", type: "dimension" },
  //		{ label: "formattedlabel", value: "formattedValue", percentData: { percent: "45%", total: "1672", group: "AP - Q2" }, type: "measure" },
  // 		{ label: "formattedlabel", value: "formattedValue", type: "measure" }
  // 	]
  // }


  DataFormatter.prototype.formatTooltip = function formatTooltip(row, color) {
    return this.formatTooltipWithColumns(row, color, this._tooltipColumns);
  };

  DataFormatter.prototype.formatTooltipWithColumns = function formatTooltipWithColumns(row, color, columns) {
    var this$1 = this;

    if (color) {
      color = lodash__default.isArray(color) ? color.map(function (color) {
        return color.toOpaque();
      }) : color.toOpaque();
    }

    if (!columns) {
      columns = this._tooltipColumns;
    } else {
      columns = lodash__default.filter(columns, function (column) {
        return lodash__default.find(this$1._tooltipColumns, function (tooltipColumn) {
          return tooltipColumn.getName() == column.getName();
        });
      });

      if (columns.length == 0) {
        return;
      }
    }

    return this._formatColumns(row, columns, color, this._text);
  };

  DataFormatter.prototype.formatAnnotation = function formatAnnotation(row, columns, text) {
    if (columns === void 0) columns = [];
    return this._formatColumns(row, columns, null, text);
  };

  DataFormatter.prototype._formatColumns = function _formatColumns(row, columns, color, text) {
    var this$1 = this;
    if (columns === void 0) columns = [];
    if (text === void 0) text = {
      template: "",
      color: null
    };
    var ref = this;
    var _showPercentage = ref._showPercentage;
    var _rowsMetadata = ref._rowsMetadata;
    var _formatterFunction = ref._formatterFunction;
    var _dataFunction = ref._dataFunction;
    var _showNullValues = ref._showNullValues;

    if (_formatterFunction) {
      return _formatterFunction(row);
    }

    if (_dataFunction) {
      row = _dataFunction(row);
    }

    var lines = [];
    var percentData;

    if (!lodash__default.isEmpty(text.template)) {
      lines.push(this._formatText(row, text));
    }

    if (_showPercentage) {
      percentData = rowsFormatter$6.formatPercentData(row, _rowsMetadata);
    }

    columns.forEach(function (column, i) {
      if (!column || !_showNullValues && row[column.getName()] == null) {
        return;
      }

      var columnName = column.getName();
      var formattedColumn = rowsFormatter$6.formatColumn(columnName, row[columnName], _rowsMetadata, percentData);
      lines.push(formattedColumn);
      var label = formattedColumn.label;
      var type = formattedColumn.type;
      var value = formattedColumn.value;

      if (type === COLUMN_TYPE$10.MEASURE) {
        this$1._formatMeasureColumn(columnName, formattedColumn, row, lodash__default.isArray(color) ? color[i] : color);
      } else {
        this$1._formatDimensionColumn(columnName, formattedColumn, row, lodash__default.isArray(color) ? color[i] : color);
      }
    });
    return lines;
  };

  DataFormatter.prototype._formatText = function _formatText(row, text) {
    var displayLabel = rowsFormatter$6.formatText(row, text.template, this._rowsMetadata);
    return {
      label: displayLabel,
      color: text.color,
      type: "text"
    };
  }; //


  var COLUMN_TYPE$11 = constants$1.COLUMN_TYPE;

  function enrichTimeColumn(column, rows) {
    var domain = domainUtils.getOrdinalDomain(rows, column);
    var cardinality = domain.length;
    column.setCardinality(cardinality);

    if (cardinality === 0 || cardinality === 1 && domain[0] == null) {
      column.setIsAllNull(true);
    }

    return column;
  }

  function enrichDimensionColumn(column, rows, geoMaps) {
    var domain = domainUtils.getOrdinalDomain(rows, column);
    var cardinality = domain.length;

    if (cardinality === 0 || cardinality === 1 && domain[0] == null) {
      column.setIsAllNull(true);
    } else {
      var matchedGeoMap;
      geoMaps.some(function (geoMap) {
        if (matchGeoMap(domain, geoMap)) {
          matchedGeoMap = geoMap;
          return true;
        }

        return false;
      });

      if (matchedGeoMap) {
        column = new GeoColumn(column.getName(), column.getLabel()).setHotSpots(column.getHotSpots()).setValueColors(column.getValueColors()).setGeoKey(column.getGeoKey()).setValueLabels(column.getValueLabels()).setGeoMap(matchedGeoMap.name);
      }
    }

    column.setCardinality(cardinality);
    return column;
  }

  function enrichMeasureColumn(column, rows) {
    var domain = domainUtils.getNumericDomain(rows, column);
    column.setDomain(domain);

    if (domain[0] == null) {
      column.setIsAllNull(true);
    }

    return column;
  }
  /**
   * Returns whether a set of values match(case insensitive) to a geoMap
   *
   * by sampling up to 5 values and check they exist in the geoMap's feature key
   *
   * @param  {Array<string>} domain
   * @param  {GeoMap} geoMap
   * @return {Boolean}
   */


  function matchGeoMap(domain, geoMap) {
    var geoMetry;

    try {
      geoMetry = geoMap.getGeometry();
    } catch (e) {
      return false;
    }

    var featureKeys = geoMetry.getFeatureKeys();
    var samples = dataUtils.uniq([0, 0.2, 0.4, 0.6, 0.8, 1].map(function (n) {
      return Math.round(n * (domain.length - 1));
    })).map(function (n) {
      return domain[n];
    }).filter(function (s) {
      return s;
    }); // 1/1, 2/2, 3/3, 3/4, 3/5

    var target = samples.length <= 3 ? samples.length : 3;
    var count = 0;
    var matched = false;
    samples.some(function (sample) {
      if (featureKeys.indexOf(('' + sample).toLowerCase()) > -1) {
        count++;
      }

      if (count === target) {
        matched = true;
        return true;
      }

      return false;
    });
    return matched;
  }

  function enrichRowsMetadata(rowsMetadata, rows, geoMaps) {
    var columns = rowsMetadata.getColumns();
    var richColumns = columns.map(function (column) {
      switch (column.getType()) {
        case COLUMN_TYPE$11.TIME:
          //@flow-ignore
          return enrichTimeColumn(column, rows);

        case COLUMN_TYPE$11.MEASURE:
          //@flow-ignore
          return enrichMeasureColumn(column, rows);

        case COLUMN_TYPE$11.DIMENSION:
          //@flow-ignore
          return enrichDimensionColumn(column, rows, geoMaps);

        default:
          return column;
      }
    });
    rowsMetadata.setColumns(richColumns);
  }

  var richRowsMetadataUtils = {
    enrichRowsMetadata: enrichRowsMetadata
  };

  var draw = function draw(ref) {
    var w = ref.w;
    var h = ref.h;
    var numRows = ref.numRows;
    var numColumns = ref.numColumns;
    var lineWidth = ref.lineWidth;
    var stroke = ref.stroke;
    var xKey = ref.xKey;
    var yKey = ref.yKey;
    var layer = new Layer({
      staggerAnim: false
    }); // offset to compensate the antialiasing half pixel offset at creme.Line draw

    var offset = -(lineWidth % 2) / 2;

    if (!yKey) {
      yKey = "y";
    }

    if (!xKey) {
      xKey = "x";
    }

    var width = numColumns * w + (numColumns + 1) * lineWidth + offset;
    var height = numRows * h + (numRows + 1) * lineWidth + offset;

    for (var i = 0; i <= numRows; i++) {
      var y = i * (h + lineWidth) + lineWidth / 2;
      new Line$2({
        layer: layer,
        key: xKey + i,
        x0: 0,
        x1: width,
        y0: y,
        y1: y,
        stroke: stroke,
        lineWidth: lineWidth
      }).offsetX(offset).offsetY(offset);
    }

    for (var j = 0; j <= numColumns; j++) {
      var x = j * (w + lineWidth) + lineWidth / 2;
      new Line$2({
        layer: layer,
        key: yKey + j,
        x0: x,
        x1: x,
        y0: 0,
        y1: height,
        stroke: stroke,
        lineWidth: lineWidth
      }).offsetX(offset).offsetY(offset);
    }

    return layer;
  };

  var gridUtils = {
    draw: draw
  }; //-ignore

  var tooltipUtils = {
    getColorInfoFromLayout: function getColorInfoFromLayout(layout) {
      if (!layout) {
        return {};
      }

      var field;
      var type = layout.getType();

      if (layout && type !== constants$1.CHART_LAYOUT.COLOR_TYPE.CONSTANT) {
        field = layout.getField();
      }

      return {
        field: field,
        type: type,
        isMultimetric: false
      };
    },
    getColorInfoFromPlots: function getColorInfoFromPlots(plots) {
      var scale = scales.ordinal().domain(plots.map(function (plot) {
        return plot.column != null && plot.column.length > 0 ? plot.column[0].getName() : "";
      })).range(plots.map(function (plot) {
        return plot.color;
      }));
      var field = null;
      var isMultimetric = true;

      if (scale.domain().length <= 1) {
        field = plots[0].column != null ? plots[0].column[0] : null;
        isMultimetric = false;
      }

      return {
        scale: scale,
        field: field,
        isMultimetric: isMultimetric
      };
    }
  };
  var trellisUtils;
  var trellisUtils$1 = trellisUtils = {
    //--------------------------------------------------------------------------------
    //
    // api
    //
    //--------------------------------------------------------------------------------
    // truncate the w/h to make sure w*h doesn't exceed maxNumberCells
    // @param {Number} w: the initial width (number of columns)
    // @param {Number} h: the initial height (number of rows)
    // @param {Number} maxNumCells: the maximum number of cells
    // @return {[w, h]|null}:
    //   - if truncation is needed: return [newWidth, newHeight]
    //   - otherwise: return null
    //--------------------------------------------------------------------------------
    truncateMatrix: function truncateMatrix(w, h, maxNumCells) {
      if (w * h <= maxNumCells) {
        return null;
      }

      if (w > maxNumCells && h > maxNumCells) {
        // if both dimensions are larger than maxNumCells,
        // then reduce both dimensions
        w = h = Math.floor(Math.sqrt(maxNumCells));
      } else if (w >= h) {
        // h is < maxNumCells
        w = Math.max(Math.floor(maxNumCells / h), 1);
      } else {
        // w is < maxNumCells
        h = Math.max(Math.floor(maxNumCells / w), 1);
      }

      return [w, h];
    },
    // Takes a set of rows and a tellis config
    // and returns a structure which can be used for drawing
    // the trellis table.
    //
    // @return an object with:
    // - colHeaders: array of string column headers (we use [""] for y, wrap trellis)
    // - rowHeaders: array of string row headers (we use [""] if x trellis)
    // - data: an map col + "/" + row -> rows relevant for this col/row
    // - colFields: field for the column dim (if any)
    // - rowFields: field for the row dim (if any)
    // - getKeyPrefix: function(colHeader, rowHeader) -> key for the cell
    // - getExtraData: function(colHeader, rowHeader) -> hashmap of extra data for each selectable/highlightable shape
    // - rows: the rows used in the trellis matrix (they could potentially be truncated if the initial matrix is too big)
    computeDataMatrix: function computeDataMatrix(trellisConfig, rows) {
      var colDims, colFields, colHeader, colHeaderStr, getExtraData, getKeyPrefix, rowDims, rowFields, rowHeader, rowHeaderStr;
      var type = trellisConfig.type;
      var columns = trellisConfig.column;
      var dims = lodash__default.map(columns, function (c) {
        return c.getName();
      });
      var dimStr = dims.join("-"); // we are going to initialize a few columns for each trellis type:
      // - colFields, rowFields: the columns to use for column/row
      // - colDim, rowDim: the dimension names to use for column/row
      // - getKeyPrefix, getExtraData: see function-level comments

      switch (type) {
        case "x":
        case "wrap":
          colFields = columns;
          colDims = dims;

          getKeyPrefix = function getKeyPrefix(colHeader, rowHeader) {
            return dimStr + ":" + colHeader.join("-");
          };

          getExtraData = function getExtraData(colHeader, rowHeader) {
            var res = {};

            for (var i = 0; i < dims.length; i++) {
              var colDim = dims[i];
              res[colDim] = colHeader[i];
            }

            return res;
          };

          break;

        case "y":
          rowFields = columns;
          rowDims = dims;

          getKeyPrefix = function getKeyPrefix(colHeader, rowHeader) {
            return dimStr + ":" + rowHeader.join("-");
          };

          getExtraData = function getExtraData(colHeader, rowHeader) {
            var res = {};

            for (var i = 0; i < dims.length; i++) {
              var rowDim = dims[i];
              res[rowDim] = rowHeader[i];
            }

            return res;
          };

          break;

        case "xy":
          colFields = columns[0] ? [columns[0]] : [];
          rowFields = columns[1] ? [columns[1]] : [];
          colDims = lodash__default.map(colFields, function (c) {
            return c.getName();
          });
          var colDimStr = colDims.join("-");
          rowDims = lodash__default.map(rowFields, function (c) {
            return c.getName();
          });
          var rowDimStr = rowDims.join("-");

          if (colDimStr < rowDimStr) {
            getKeyPrefix = function getKeyPrefix(colHeader, rowHeader) {
              return colDimStr + ":" + colHeader.join("-") + "*" + rowDimStr + ":" + rowHeader.join("-");
            };
          } else {
            getKeyPrefix = function getKeyPrefix(colHeader, rowHeader) {
              return rowDimStr + ":" + rowHeader.join("-") + "*" + colDimStr + ":" + colHeader.join("-");
            };
          }

          getExtraData = function getExtraData(colHeader, rowHeader) {
            var i;
            var res = {};

            for (i = 0; i < colDims.length; i++) {
              var colDim = colDims[i];
              res[colDim] = colHeader[i];
            }

            for (i = 0; i < rowDims.length; i++) {
              var rowDim = rowDims[i];
              res[rowDim] = rowHeader[i];
            }

            return res;
          };

          break;

        default:
          throw new Error("invalid trellis type " + type);
      }

      var colHeaders = []; // list of column headers

      var colHeadersMap = {}; // map of colHeader strings, used for lookup

      var rowHeaders = []; // list of row headers

      var rowHeadersMap = {}; // map of rowHeader strings, used for lookup

      var data = {}; // the data matrix

      var colHeaderStrList = []; // save list of colHeaderStr (will be needed if we need to truncate matrix)

      var rowHeaderStrList = []; // save list of rowHeaderStr (will be needed if we need to truncate matrix)

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        colHeader = colDims ? colDims.map(function (colDim) {
          return row[colDim];
        }) : [];
        rowHeader = rowDims ? rowDims.map(function (rowDim) {
          return row[rowDim];
        }) : [];
        colHeaderStr = colHeader.join("-");
        rowHeaderStr = rowHeader.join("-");

        if (!colHeadersMap[colHeaderStr]) {
          colHeaders.push(colHeader);
        }

        if (!rowHeadersMap[rowHeaderStr]) {
          rowHeaders.push(rowHeader);
        }

        colHeadersMap[colHeaderStr] = true;
        rowHeadersMap[rowHeaderStr] = true;
        colHeaderStrList.push(colHeaderStr);
        rowHeaderStrList.push(rowHeaderStr);
        var key = getKeyPrefix(colHeader, rowHeader);

        if (data[key] == null) {
          data[key] = [];
        }

        data[key].push(row);
      }

      if (colHeaders.length * rowHeaders.length > trellisConfig.maxNumCells) {
        var ref = trellisUtils.truncateMatrix(colHeaders.length, rowHeaders.length, trellisConfig.maxNumCells);
        var nbCols = ref[0];
        var nbRows = ref[1];
        colHeaders = colHeaders.slice(0, nbCols);
        rowHeaders = rowHeaders.slice(0, nbRows); // we now have the list of colHeaders and rowHeaders we want to keep
        // let's go over each row and figure out which row we want to keep
        // let's recompute colHeadersMap for quick check

        colHeadersMap = {};
        colHeaders.forEach(function (colHeader) {
          colHeaderStr = colHeader.join("-");
          colHeadersMap[colHeaderStr] = true;
        });
        rowHeadersMap = {};
        rowHeaders.forEach(function (rowHeader) {
          rowHeaderStr = rowHeader.join("-");
          rowHeadersMap[rowHeaderStr] = true;
        });
        rows = lodash__default.filter(rows, function (row, i) {
          return colHeadersMap[colHeaderStrList[i]] && rowHeadersMap[rowHeaderStrList[i]];
        });
      }

      return {
        colHeaders: colHeaders,
        rowHeaders: rowHeaders,
        data: data,
        colFields: colFields,
        rowFields: rowFields,
        getKeyPrefix: getKeyPrefix,
        getExtraData: getExtraData,
        rows: rows
      };
    }
  };
  /**
   * lib functions for building out-of-box scene template
   *
   * @param {Object} params
   * @return {Scene} scene
   *
   */

  /**
   * It calculates axis height as follow
   * 1. Show measure and header => default axis height
   * 2. Show header only => default header text height
   * 3. Hide measure and header => 0
   * @param {boolean} vertical if chart is rotated
   * @param {boolean} showMeasure option
   * @param {boolean} showMeasureTitle option
   * @returns {number}
   */

  function calcAxisHeight(vertical, showMeasure, showMeasureTitle) {
    var axisPadding = showMeasureTitle ? 0 : constants$1.AXIS.NUM.Y.PADDING;
    return !showMeasure ? 0 : (vertical ? constants$1.AXIS.NUM.Y.WIDTH : constants$1.AXIS.NUM.X.HEIGHT) + axisPadding;
  }
  /**
   * It calculates the padding between plot cell and the dimension labels
   * If either there's the header or the labels visible, use the constant padding or no padding at all
   * @param {{showDimension: boolean}} options
   * @returns {object}
   */


  function calcPadding(options) {
    return options.showDimension ? constants$1.CELL_PADDING : 0;
  }
  /**
   * Provide with basic layout templates
   * @param {{showDimension: boolean, showMeasure: boolean, showDimensionTitle: boolean}} options
   * @returns {number}
   */


  function layouts(options) {
    var vertical = options.vertical;
    var showMeasure = options.showMeasure;
    var showMeasure1 = options.showMeasure1;
    var showMeasure2 = options.showMeasure2;
    var showMeasureTitle = options.showMeasureTitle;
    var showMeasureTitle1 = options.showMeasureTitle1;
    var showMeasureTitle2 = options.showMeasureTitle2;
    var showDimensionTitle = options.showDimensionTitle;
    var showTimeTitle = options.showTimeTitle;
    var hasTrellisColHeaders = options.hasTrellisColHeaders;
    var hasTrellisRowHeaders = options.hasTrellisRowHeaders;
    var axisTitleMaxLines = options.axisTitleMaxLines;
    if (axisTitleMaxLines === void 0) axisTitleMaxLines = [1, 1, 1];
    var axisHeight = calcAxisHeight(vertical, showMeasure, showMeasureTitle);
    var axis1Height = calcAxisHeight(vertical, showMeasure1, showMeasureTitle1);
    var axis2Height = calcAxisHeight(vertical, showMeasure2, showMeasureTitle2);
    var paddingSize = calcPadding(options);
    var labelsWidthPct = vertical ? "80%" : "40%";
    var plotWidthPct = vertical ? "20%" : "60%";
    var measureAxisTitleHeight = showMeasureTitle ? constants$1.AXIS.NUM.TITLE.HEIGHT * axisTitleMaxLines[0] : 0;
    var measureAxisTitle1Height = showMeasureTitle1 ? constants$1.AXIS.NUM.TITLE.HEIGHT * axisTitleMaxLines[1] : 0;
    var measureAxisTitle2Height = showMeasureTitle2 ? constants$1.AXIS.NUM.TITLE.HEIGHT * axisTitleMaxLines[2] : 0;
    var dimensionAxisTitleHeight = showDimensionTitle ? constants$1.AXIS.LABELS.TITLE.HEIGHT * axisTitleMaxLines[0] : 0;
    var timeAxisTitleHeight = showTimeTitle ? constants$1.AXIS.TIME.TITLE.HEIGHT * axisTitleMaxLines[0] : 0;
    var trellisHeaderHeight = hasTrellisColHeaders ? constants$1.TRELLIS.HEADER.HEIGHT : 0;
    var trellisHeaderWidth = hasTrellisRowHeaders ? constants$1.TRELLIS.HEADER.WIDTH : 0;
    var cellSizes = options.cellSizes || {};

    var getSize = function getSize(cellName, defaultSize) {
      return cellSizes[cellName] || defaultSize;
    };

    return {
      FlatWithHeader: {
        cells: [["title"], ["*padding"], ["plot"]],
        rows: [options.showMeasureTitle ? constants$1.AXIS.NUM.X.HEIGHT * axisTitleMaxLines[0] : 0, constants$1.CELL_PADDING, "100%"],
        columns: ["100%"]
      },
      ParallelCoords: {
        cells: [["title", "*padding", "plot"]],
        rows: ["100%"],
        columns: [options.showMeasureTitle ? constants$1.AXIS.NUM.X.HEIGHT : 0, constants$1.CELL_PADDING, "100%"]
      },
      Cartesian: {
        cells: [["*padding", "*padding", "*padding", "measureAxis1Title"], ["*padding", "*padding", "*padding", "measureAxis1"], ["axisYTitle", "axisY", "padding", "plot"], ["*padding", "*padding", "*padding", "measureAxis2"], ["*padding", "*padding", "*padding", "measureAxis2Title"]],
        rows: [measureAxisTitle1Height, axis1Height, "100%", axis2Height, measureAxisTitle2Height],
        columns: [constants$1.AXIS.TIME.TITLE.HEIGHT, getSize("axisY", "40%"), paddingSize, getSize("plot", "60%")],
        scrollY: ["axisY", "plot"],
        zIndex: {
          1: ["measureAxis1", "measureAxis2", "axisY"],
          2: ["plot"]
        }
      },
      LabelsLabels: {
        cells: [["*padding", "*padding", "*padding", "axis-x-title"], ["*padding", "*padding", "*padding", "axis-x"], ["*padding", "*padding", "*padding", "padding-x"], ["axis-y-title", "axis-y", "padding-y", "plot"]],
        rows: [constants$1.AXIS.LABELS.TITLE.HEIGHT * axisTitleMaxLines[1], "40%", constants$1.CELL_PADDING, "60%"],
        columns: [constants$1.AXIS.LABELS.TITLE.HEIGHT * axisTitleMaxLines[0], "40%", constants$1.CELL_PADDING, "60%"],
        scrollY: ["axis-y", "plot"],
        scrollX: ["axis-x", "plot"],
        zIndex: {
          1: ["axis-x", "axis-y"],
          2: ["plot"]
        }
      },
      AxisAxis: {
        cells: [["axis-y-title", "axis-y", "plot"], ["*padding", "*padding", "axis-x"], ["*padding", "*padding", "axis-x-title"]],
        rows: ["100%", constants$1.AXIS.NUM.X.HEIGHT, constants$1.AXIS.NUM.TITLE.HEIGHT * axisTitleMaxLines[1]],
        columns: [constants$1.AXIS.NUM.TITLE.HEIGHT * axisTitleMaxLines[0], constants$1.AXIS.NUM.Y.WIDTH, "100%"],
        zIndex: {
          1: ["axis-x", "axis-y"],
          2: ["plot"]
        }
      },
      Waterfall: {
        cells: [["*padding", "*padding", "*padding", "measureAxis1Title"], ["*padding", "*padding", "*padding", "axis"], ["dimensionTitle", "labels", "padding", "plot"]],
        rows: [measureAxisTitle1Height, axis1Height, "100%"],
        columns: [dimensionAxisTitleHeight, labelsWidthPct, paddingSize, plotWidthPct],
        zIndex: {
          1: ["axis"],
          2: ["labels", "plot"]
        }
      },
      Pyramid: {
        cells: [["axis1-title", "*padding", "*padding", "*padding", "axis2-title"], ["axis1", "*padding", "title", "*padding", "axis2"], ["plot1", "leftpadding", "labels", "rightpadding", "plot2"]],
        rows: [measureAxisTitleHeight, axisHeight, "100%"],
        columns: [getSize("plot1", "40%"), paddingSize, getSize("labels", "20%"), paddingSize, getSize("plot2", "40%")],
        scrollY: ["labels", "plot1", "plot2"],
        zIndex: {
          1: ["axis1", "axis2"],
          2: ["plot1", "plot2"]
        }
      },
      Flat: {
        cells: [["plot"]],
        rows: ["100%"],
        columns: ["100%"]
      },
      Empty: {
        cells: [["empty"]],
        rows: ["100%"],
        columns: ["100%"]
      },
      SparkLine: {
        cells: [["first_val", "*padding", "spark", "*padding", "last_val"]],
        rows: ["100%"],
        columns: [constants$1.MARK.SPARKLINE.LABEL_WIDTH, constants$1.CELL_PADDING, "100%", constants$1.CELL_PADDING, constants$1.MARK.SPARKLINE.LABEL_WIDTH] // name | high | spark | low

      },
      Trellis: {
        cells: [["corner", "colHeaders"], ["rowHeaders", "content"]],
        rows: [trellisHeaderHeight, "100%"],
        columns: [trellisHeaderWidth, "100%"],
        scrollX: ["content", "colHeaders"],
        scrollY: ["content", "rowHeaders"],
        zIndex: {
          1: ["colHeaders", "rowHeaders"],
          2: ["corner"]
        }
      },
      Legend: {
        cells: [["header"], ["plot"]],
        rows: ["80%", "20%"],
        columns: ["100%"],
        scrollY: ["plot"],
        scrollX: ["plot"]
      },
      ComboLegend: {
        cells: [["topLegend"], ["bottomHeader"], ["bottomLegend"]],
        rows: ["80%", "40%", "10%"],
        columns: ["100%"],
        scrollY: ["bottomLegend"]
      }
    };
  }

  function build(params) {
    var defaultParams = {
      selectMode: constants$1.SELECTMODE.NONE,
      position: [0, 0],
      layout: {},
      configLayout: {},
      transforms: {}
    };
    lodash__default.defaults(params, defaultParams);
    var size = params.size;
    var position = params.position;
    var padding = params.padding;
    var selectMode = params.selectMode;
    var selectionKeyFct = params.selectionKeyFct;
    var configLayout = params.configLayout;
    var transforms = params.transforms;
    var axisTitleMaxLines = params.axisTitleMaxLines;

    if (!padding) {
      padding = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      };
    }

    var layout = layouts({
      vertical: transforms.rotate,
      showTimeTitle: configLayout.showTimeTitle,
      showMeasure: configLayout.showMeasure,
      showMeasure1: configLayout.showMeasure1,
      showMeasure2: configLayout.showMeasure2,
      showMeasureTitle: configLayout.showMeasureTitle,
      showMeasureTitle1: configLayout.showMeasureTitle1,
      showMeasureTitle2: configLayout.showMeasureTitle2,
      showDimension: configLayout.showDimension,
      showDimensionTitle: configLayout.showDimensionTitle,
      hasTrellisColHeaders: params.hasTrellisColHeaders,
      hasTrellisRowHeaders: params.hasTrellisRowHeaders,
      cellSizes: params.cellSizes,
      axisTitleMaxLines: params.axisTitleMaxLines
    })[params.layout];
    var cells = layout.cells;
    var rows = layout.rows;
    var columns = layout.columns;
    var scrollX = layout.scrollX;
    var scrollY = layout.scrollY;
    var zIndex = layout.zIndex; // initialize scene

    var scene = new Scene$2({
      size: size,
      transforms: transforms,
      padding: padding,
      position: position,
      selectMode: selectMode,
      selectionKeyFct: selectionKeyFct
    }); // buildScene cells in scene

    scene.buildCells({
      rows: rows,
      columns: columns
    }); // assign key to cell

    cells.forEach(function (row, rowIndex) {
      row.forEach(function (key, colIndex) {
        if (!key.match(constants$1.CELL.IGNORED_PATTERN)) {
          scene.getCell(colIndex, rowIndex).set({
            key: key
          });
        }
      });
    }); // assign scroll property

    if (scrollX) {
      scrollX.forEach(function (key) {
        scene.cellByKey(key).set({
          scrollX: true
        });
      });
    }

    if (scrollY) {
      scrollY.forEach(function (key) {
        scene.cellByKey(key).set({
          scrollY: true
        });
      });
    } // adjust z-index


    var loop = function loop(index) {
      var keys = zIndex[index];
      keys.forEach(function (key) {
        scene.cellByKey(key).set({
          zIndex: parseInt(index, 10)
        });
      });
    };

    for (var index in zIndex) {
      loop(index);
    }

    return scene;
  }

  var layoutBuilder = {
    build: build
  }; //

  var SelectManagerFactory = function SelectManagerFactory() {};

  SelectManagerFactory.make = function make(mode, layer) {
    switch (mode) {
      case constants$1.SELECTMODE.RANGE:
      case constants$1.SELECTMODE.SINGLE:
        return new SingleSelectManager(layer);

      case constants$1.SELECTMODE.SINGLE_REQUIRED:
        return new SingleRequiredSelectManager(layer);

      case constants$1.SELECTMODE.MULTI:
        return new MultiSelectManager(layer);

      case constants$1.SELECTMODE.MULTI_REQUIRED:
        return new MultiRequiredSelectManager(layer);

      default:
        return undefined;
    }
  }; //


  var Recommendation = function Recommendation(config) {
    this._config = config;
    this._features = {};
    this._score = 0;
    this._scoreDetails = [];
  };

  Recommendation.prototype.setConfig = function setConfig(config) {
    this._config = config;
    return this;
  };

  Recommendation.prototype.getConfig = function getConfig() {
    return this._config;
  };

  Recommendation.prototype.setModuleName = function setModuleName(moduleName) {
    this._moduleName = moduleName;
    return this;
  };

  Recommendation.prototype.getModuleName = function getModuleName() {
    return this._moduleName;
  };

  Recommendation.prototype.setFeature = function setFeature(name, feature) {
    if (name === void 0) name = "";
    if (feature === void 0) feature = {};
    this._features[name] = feature;
    return this;
  };

  Recommendation.prototype.getFeature = function getFeature(name) {
    return this._features[name];
  };

  Recommendation.prototype.hasFeature = function hasFeature(name) {
    return !!this.getFeature(name);
  };

  Recommendation.prototype.setScore = function setScore(score) {
    this._score = score;
    return this;
  };

  Recommendation.prototype.getScore = function getScore() {
    return this._score;
  };

  Recommendation.prototype.setScoreDetails = function setScoreDetails(details) {
    this._scoreDetails = details;
    return this;
  };

  Recommendation.prototype.getScoreDetails = function getScoreDetails() {
    return this._scoreDetails;
  }; //


  var Scorer = function Scorer() {};

  Scorer.prototype.featurize = function featurize(recommendation) {
    return this;
  };

  Scorer.prototype.getScore = function getScore(recommendation, rowsMetadata, options) {
    var scoreDetails = this.getScoreDetails(recommendation, rowsMetadata, options);
    return mathUtils.sum(dataUtils.zip(scoreDetails)[0]);
  };

  Scorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
    return [];
  };

  Scorer.prototype._makeScoreDetail = function _makeScoreDetail(score, message) {
    if (message === void 0) message = "";
    return [score, message];
  };

  Scorer.prototype._filterScoreDetails = function _filterScoreDetails(scoreDetails) {
    return scoreDetails.filter(function (detail) {
      return detail[0] !== 0;
    });
  };

  Scorer.prototype._areColumnsOfTypes = function _areColumnsOfTypes(columns, types) {
    return columns.every(function (column) {
      return types.indexOf(column.getType()) > -1;
    });
  };

  Scorer.prototype._hasFeature = function _hasFeature(recommendation, name) {
    return !!recommendation.getFeature(name);
  };

  Scorer.SCORE_DETAIL = {
    INVALID_CONFIG: [[-Infinity, ""]]
  };
  Scorer.SCORES = {
    CRITICAL: 5,
    GREAT: 2,
    GOOD: 1,
    FAIR: 0,
    BAD: -2,
    SEVERE: -5
  }; //

  var FEATURE_NAME = constants$1.FEATURE_NAME;
  var COLUMN_TYPE$12 = constants$1.COLUMN_TYPE;

  var AxisScorer = function (Score____1) {
    function AxisScorer() {
      Score____1.apply(this, arguments);
    }

    if (Score____1) AxisScorer.__proto__ = Score____1;
    AxisScorer.prototype = Object.create(Score____1 && Score____1.prototype);
    AxisScorer.prototype.constructor = AxisScorer;

    AxisScorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
      var scoreDetails = [];

      if (this._isCartesian(recommendation)) {
        scoreDetails = this._scoreCartesian(recommendation, options);
      } else if (recommendation.hasFeature(FEATURE_NAME.MULTI_METRIC)) {
        scoreDetails = this._scoreMultiMetric(recommendation);
      } else if (recommendation.hasFeature(FEATURE_NAME.SINGLE_METRIC)) {
        scoreDetails = this._scoreSingleMetric(recommendation);
      }

      return this._filterScoreDetails(scoreDetails);
    };

    AxisScorer.prototype._isCartesian = function _isCartesian(recommendation) {
      var hasXAxis = recommendation.hasFeature(FEATURE_NAME.X_DIMENSION_AXIS) || recommendation.hasFeature(FEATURE_NAME.X_MEASURE_AXIS) || recommendation.hasFeature(FEATURE_NAME.X_TIME_AXIS);
      var hasYAxis = recommendation.hasFeature(FEATURE_NAME.Y_DIMENSION_AXIS) || recommendation.hasFeature(FEATURE_NAME.Y_MEASURE_AXIS) || recommendation.hasFeature(FEATURE_NAME.Y_TIME_AXIS);
      return hasXAxis && hasYAxis;
    };

    AxisScorer.prototype._scoreCartesian = function _scoreCartesian(recommendation, options) {
      var xDimFeature = recommendation.getFeature(FEATURE_NAME.X_DIMENSION_AXIS);
      var xMeaFeature = recommendation.getFeature(FEATURE_NAME.X_MEASURE_AXIS);
      var xTimeFeature = recommendation.getFeature(FEATURE_NAME.X_TIME_AXIS);
      var yDimFeature = recommendation.getFeature(FEATURE_NAME.Y_DIMENSION_AXIS);
      var yMeaFeature = recommendation.getFeature(FEATURE_NAME.Y_MEASURE_AXIS);
      var yTimeFeature = recommendation.getFeature(FEATURE_NAME.Y_TIME_AXIS);
      var ref = xDimFeature ? [xDimFeature, COLUMN_TYPE$12.DIMENSION] : xMeaFeature ? [xMeaFeature, COLUMN_TYPE$12.MEASURE] : [xTimeFeature, COLUMN_TYPE$12.TIME];
      var xFeature = ref[0];
      var xType = ref[1];
      var ref$1 = yDimFeature ? [yDimFeature, COLUMN_TYPE$12.DIMENSION] : yMeaFeature ? [yMeaFeature, COLUMN_TYPE$12.MEASURE] : [yTimeFeature, COLUMN_TYPE$12.TIME];
      var yFeature = ref$1[0];
      var yType = ref$1[1];
      var scoreDetails = []; // score each axis

      scoreDetails.push(this._scoreAxis(xType, xFeature, true, options));
      scoreDetails.push(this._scoreAxis(yType, yFeature, false, options)); // score effectiveness

      scoreDetails.push(this._getEffectivenessScore(xFeature, xType, yFeature, yType)); // score if there is reduncancy

      scoreDetails.push(this._getRedundancyScore(xFeature, yFeature));
      return scoreDetails;
    };
    /**
     * Score an individual axis
     *
     * - dimension axis, with the same number of columns, y is always better. with the same orientation,
     * fewer columns is better.
     * - measure axis, can not represent more than maxNumMeasuresCartesian number of measures
     * - for all axis type, missing column is strongly penalized
     *
     * @type {[type]}
     */


    AxisScorer.prototype._scoreAxis = function _scoreAxis(type, feature, isX, options) {
      var numCols = feature.column.length;

      if (type === COLUMN_TYPE$12.DIMENSION) {
        var maxNumColumnsXDimensionAxis = options.maxNumColumnsXDimensionAxis;
        var maxNumColumnsYDimensionAxis = options.maxNumColumnsYDimensionAxis;
        var maxNumCols = isX ? maxNumColumnsXDimensionAxis : maxNumColumnsYDimensionAxis;

        if (!numCols) {
          // empty dim axis
          return this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisDimNoColumn"));
        } else if (numCols === 1) {
          // single dim column
          return isX ? this._makeScoreDetail(Score____1.SCORES.GOOD * 0.75, LOC.getLabel("wave-charts", "axisXDimOneColumn")) : this._makeScoreDetail(Score____1.SCORES.GOOD, LOC.getLabel("wave-charts", "axisYDimOneColumn"));
        } else if (numCols === 2) {
          // 2 dim columns
          return isX ? this._makeScoreDetail(Score____1.SCORES.FAIR, LOC.getLabel("wave-charts", "axisXDim2Columns")) : this._makeScoreDetail(Score____1.SCORES.GOOD * 0.75, LOC.getLabel("wave-charts", "axisYDim2Columns"));
        } else if (numCols > maxNumCols) {
          // too many
          return this._makeScoreDetail(Score____1.SCORES.BAD, LOC.getLabel("wave-charts", "axisDimMaxColumn", [maxNumCols]));
        } else {
          return this._makeScoreDetail(Score____1.SCORES.FAIR);
        }
      } else if (type === COLUMN_TYPE$12.MEASURE) {
        var maxNumMeasuresCartesian = options.maxNumMeasuresCartesian;
        return numCols === 0 ? this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisMeaNoColumns")) : numCols > maxNumMeasuresCartesian ? this._makeScoreDetail(Score____1.SCORES.BAD, LOC.getLabel("wave-charts", "axisMeaMaxColumn", [maxNumMeasuresCartesian])) : this._makeScoreDetail(Score____1.SCORES.FAIR);
      } else {
        return numCols === 0 ? this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisTimeNoColumn")) : this._makeScoreDetail(Score____1.SCORES.FAIR);
      }
    };
    /**
     * Penalize both x, and y axis representing the same data column
     */


    AxisScorer.prototype._getRedundancyScore = function _getRedundancyScore(xFeature, yFeature) {
      var xColumns = xFeature && xFeature.column;
      var yColumns = yFeature && yFeature.column;

      if (xColumns && yColumns && dataUtils.intersection(xColumns, yColumns).length) {
        return this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisRedundancy"));
      }

      return this._makeScoreDetail(Score____1.SCORES.FAIR);
    };
    /**
     * Evaluate the effectiveness of a cartesian chart, measure vs measure and dim vs dim is better then
     * the regular dim vs measure
     */


    AxisScorer.prototype._getEffectivenessScore = function _getEffectivenessScore(xFeature, xType, yFeature, yType) {
      if (xType === yType && xType === COLUMN_TYPE$12.MEASURE) {
        // M vs M
        return this._makeScoreDetail(Score____1.SCORES.GREAT, LOC.getLabel("wave-charts", "axisMvM"));
      } else if (xType === yType && xType === COLUMN_TYPE$12.DIMENSION) {
        // D vs D
        return this._makeScoreDetail(Score____1.SCORES.GOOD, LOC.getLabel("wave-charts", "axisDvD"));
      } else {
        return this._makeScoreDetail(Score____1.SCORES.FAIR);
      }
    };
    /**
     * Charts with multi metrics feature, prefer to use it when there are more than 2 metrics
     * for 1 or 2 metrics, there is almost always another chart type which does a better job
     */


    AxisScorer.prototype._scoreMultiMetric = function _scoreMultiMetric(recommendation) {
      var feature = recommendation.getFeature(FEATURE_NAME.MULTI_METRIC);
      return feature.column.length > 3 ? [this._makeScoreDetail(Score____1.SCORES.GREAT, LOC.getLabel("wave-charts", "axisMultiMetricManyMeasure", [3]))] : feature.column.length === 3 ? [this._makeScoreDetail(Score____1.SCORES.GOOD, LOC.getLabel("wave-charts", "axisMultiMetricManyMeasure", [2]))] : [this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisMvDMultiMetric", [2]))];
    };
    /**
     * Charts with single metric feature, and when its used to represent a single metric, always
     * reward it because compared to other charts which are more versatile(can represent more metrics)
     * it is more tailored to single metric data.
     */


    AxisScorer.prototype._scoreSingleMetric = function _scoreSingleMetric(recommendation) {
      var feature = recommendation.getFeature(FEATURE_NAME.SINGLE_METRIC);
      return feature.column.length === 1 ? [this._makeScoreDetail(Score____1.SCORES.GOOD * 0.5, LOC.getLabel("wave-charts", "axisSingleMetricSingleMeasure"))] : [this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "axisSingleMetricFewMeasure"))];
    };

    return AxisScorer;
  }(Scorer); //


  var COLUMN_TYPE$13 = constants$1.COLUMN_TYPE;
  var COLOR_TYPE$7 = constants$1.CHART_LAYOUT.COLOR_TYPE;

  var ColorScorer = function (Score____1) {
    function ColorScorer() {
      Score____1.apply(this, arguments);
    }

    if (Score____1) ColorScorer.__proto__ = Score____1;
    ColorScorer.prototype = Object.create(Score____1 && Score____1.prototype);
    ColorScorer.prototype.constructor = ColorScorer;

    ColorScorer.prototype.featurize = function featurize(recommendation) {
      var config = recommendation.getConfig();
      var color = config.color;

      if (color && color.column) {
        var column = color.column;
        var type = color.type;
        var featureName;

        switch (type) {
          case COLOR_TYPE$7.CATEGORICAL:
            featureName = constants$1.FEATURE_NAME.CATEGORICAL_COLOR;
            break;

          case COLOR_TYPE$7.GRADIENT:
            featureName = constants$1.FEATURE_NAME.GRADIENT_COLOR;
            break;

          case COLOR_TYPE$7.BINS:
            featureName = constants$1.FEATURE_NAME.BIN_COLOR;
            break;

          case COLOR_TYPE$7.CONSTANT:
            featureName = constants$1.FEATURE_NAME.BIN_COLOR;
            break;
        }

        recommendation.setFeature(featureName, {
          column: column
        });
      }

      return this;
    };

    ColorScorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
      var maxCardinalityCategoricalColor = options.maxCardinalityCategoricalColor;
      var catColorfeature = recommendation.getFeature(constants$1.FEATURE_NAME.CATEGORICAL_COLOR);
      var graColorfeature = recommendation.getFeature(constants$1.FEATURE_NAME.GRADIENT_COLOR);
      var scores = [];

      if (catColorfeature) {
        var columns = rowsMetadata.getColumns(catColorfeature.column);

        if (!this._areColumnsOfTypes(columns, [COLUMN_TYPE$13.DIMENSION, COLUMN_TYPE$13.TIME, COLUMN_TYPE$13.GEO])) {
          return Score____1.SCORE_DETAIL.INVALID_CONFIG;
        } //@flow-ignore


        var cardinality = columns[0] && columns[0].getCardinality();

        if (!columns.length) {
          // no coloring dimension
          scores.push(this._makeScoreDetail(Score____1.SCORES.FAIR));
        } else if (cardinality > maxCardinalityCategoricalColor) {
          // too many color categories
          scores.push(this._makeScoreDetail(Score____1.SCORES.SEVERE, LOC.getLabel("wave-charts", "colorHighCardinality")));
        } else {
          // coloring by low cardinality dimension
          scores.push(this._makeScoreDetail(Score____1.SCORES.GOOD, LOC.getLabel("wave-charts", "colorLowCardinality")));
        }
      }

      if (graColorfeature) {
        var columns$1 = rowsMetadata.getColumns(graColorfeature.column);

        if (!this._areColumnsOfTypes(columns$1, [COLUMN_TYPE$13.MEASURE])) {
          return Score____1.SCORE_DETAIL.INVALID_CONFIG;
        }
      }

      return this._filterScoreDetails(scores);
    };

    return ColorScorer;
  }(Scorer); //
  //@flow-ignore


  var FEATURE_NAME$1 = constants$1.FEATURE_NAME;
  var COLUMN_TYPE$14 = constants$1.COLUMN_TYPE;

  var ContextScorer = function (Score____1) {
    function ContextScorer() {
      Score____1.apply(this, arguments);
    }

    if (Score____1) ContextScorer.__proto__ = Score____1;
    ContextScorer.prototype = Object.create(Score____1 && Score____1.prototype);
    ContextScorer.prototype.constructor = ContextScorer;

    ContextScorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
      var timeColumns = rowsMetadata.getColumnsByType(COLUMN_TYPE$14.TIME);
      var geoColumns = rowsMetadata.getColumnsByType(COLUMN_TYPE$14.GEO);
      var scores = [];

      if (geoColumns.length) {
        var geoFeature = recommendation.getFeature(FEATURE_NAME$1.GEO_DATA); // has geo columns

        if (geoFeature && lodash__default.map(geoColumns, function (c) {
          return c.getName();
        }).indexOf(geoFeature.column[0]) > -1) {
          scores.push(this._makeScoreDetail(Score____1.SCORES.CRITICAL, LOC.getLabel("wave-charts", "contextGeo")));
        }
      }

      if (timeColumns.length) {
        var xTimeFeature = recommendation.getFeature(FEATURE_NAME$1.X_TIME_AXIS);
        var yTimeFeature = recommendation.getFeature(FEATURE_NAME$1.Y_TIME_AXIS);
        var timeFeature = xTimeFeature || yTimeFeature; // has time columns

        if (timeFeature && lodash__default.map(timeColumns, function (c) {
          return c.getName();
        }).indexOf(timeFeature.column[0]) > -1) {
          scores.push(this._makeScoreDetail(Score____1.SCORES.CRITICAL, LOC.getLabel("wave-charts", "contextTime")));
        }
      }

      var latlngFeature = recommendation.getFeature(FEATURE_NAME$1.LAT_LNG);

      if (latlngFeature) {
        // has lat lng feature
        var latlngColumns = rowsMetadata.getColumns(latlngFeature.column); // lat lng columns need to be measure

        if (latlngColumns.length !== 2 || !this._areColumnsOfTypes(latlngColumns, [COLUMN_TYPE$14.MEASURE])) {
          return Score____1.SCORE_DETAIL.INVALID_CONFIG;
        } // lat range should be (-90, 90), lng range should be (-180, 180)
        // @flow-ignore


        if (this._isInRange(latlngColumns[0].getDomain(), [-90, 90]) && this._isInRange(latlngColumns[1].getDomain(), [-180, 180])) {
          scores.push(this._makeScoreDetail(Score____1.SCORES.CRITICAL, LOC.getLabel("wave-charts", "contextLatlng")));
        } else {
          return Score____1.SCORE_DETAIL.INVALID_CONFIG;
        }
      }

      var flowDiagramFeature = recommendation.getFeature(FEATURE_NAME$1.FLOW_DIAGRAM);

      if (flowDiagramFeature) {
        // chart is flow diagram
        var flowDiagramColumns = rowsMetadata.getColumns(flowDiagramFeature.column);

        if (!this._areColumnsOfTypes(flowDiagramColumns, [COLUMN_TYPE$14.DIMENSION])) {
          return Score____1.SCORE_DETAIL.INVALID_CONFIG;
        }

        var maxCardinalityFlowDiagram = options.maxCardinalityFlowDiagram; // @flow-ignore

        var cardinalities = flowDiagramColumns.map(function (column) {
          return column.getCardinality();
        });

        if (cardinalities.some(function (c) {
          return c > maxCardinalityFlowDiagram;
        })) {
          // not suitable for high cardinality data
          scores.push(this._makeScoreDetail(Score____1.SCORES.BAD, LOC.getLabel("wave-charts", "contextFlowHighCard")));
        } else {
          scores.push(this._makeScoreDetail(Score____1.SCORES.GREAT, LOC.getLabel("wave-charts", "contextFlowLowCard")));
        }
      }

      return scores;
    };

    ContextScorer.prototype._isInRange = function _isInRange(range, validRange) {
      return range[0] >= validRange[0] && range[1] <= validRange[1];
    };

    return ContextScorer;
  }(Scorer); //


  var COLUMN_TYPE$15 = constants$1.COLUMN_TYPE;

  var TrellisScorer = function (Score____1) {
    function TrellisScorer() {
      Score____1.apply(this, arguments);
    }

    if (Score____1) TrellisScorer.__proto__ = Score____1;
    TrellisScorer.prototype = Object.create(Score____1 && Score____1.prototype);
    TrellisScorer.prototype.constructor = TrellisScorer;

    TrellisScorer.prototype.featurize = function featurize(recommendation) {
      var config = recommendation.getConfig();
      var trellis = config.trellis;

      if (trellis && trellis.column.length) {
        var column = trellis.column;
        var type = trellis.type;
        recommendation.setFeature(constants$1.SCORER_TYPE.TRELLIS, {
          type: type,
          column: column
        });
      }

      return this;
    };

    TrellisScorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
      var maxCardinalityTrellis = options.maxCardinalityTrellis;
      var feature = recommendation.getFeature(constants$1.SCORER_TYPE.TRELLIS);

      if (!feature) {
        return [];
      }

      var columns = rowsMetadata.getColumns(feature.column);

      if (!this._areColumnsOfTypes(columns, [COLUMN_TYPE$15.DIMENSION, COLUMN_TYPE$15.TIME, COLUMN_TYPE$15.GEO])) {
        return Score____1.SCORE_DETAIL.INVALID_CONFIG;
      } // already checked columns are of dimension/time/geo type
      //@flow-ignore


      var cardinalities = columns.map(function (column) {
        return column.getCardinality();
      });

      if (!cardinalities.length) {
        return [];
      } else if (cardinalities.length === 2) {
        return cardinalities[0] * cardinalities[1] > maxCardinalityTrellis ? [this._makeScoreDetail(Score____1.SCORES.BAD, LOC.getLabel("wave-charts", "trellisHighCardinality"))] : [];
      } else if (cardinalities.length === 1) {
        return cardinalities[0] > maxCardinalityTrellis ? [this._makeScoreDetail(Score____1.SCORES.BAD, LOC.getLabel("wave-charts", "trellisHighCardinality"))] : [];
      } else {
        return Score____1.SCORE_DETAIL.INVALID_CONFIG;
      }
    };

    return TrellisScorer;
  }(Scorer); //
  //@flow-ignore


  var FEATURE_NAME$2 = constants$1.FEATURE_NAME;

  var PopularityScorer = function (Score____1) {
    function PopularityScorer() {
      Score____1.apply(this, arguments);
    }

    if (Score____1) PopularityScorer.__proto__ = Score____1;
    PopularityScorer.prototype = Object.create(Score____1 && Score____1.prototype);
    PopularityScorer.prototype.constructor = PopularityScorer;

    PopularityScorer.prototype.getScoreDetails = function getScoreDetails(recommendation, rowsMetadata, options) {
      var popularity = recommendation.getFeature(FEATURE_NAME$2.POPULARITY);

      if (popularity && lodash__default.isNumber(popularity) && lodash__default.isFinite(popularity)) {
        // non-zero popularity score
        var originalScore = recommendation.getScore(); // adjust with popularity score in [-1, 1] range

        var boundP = Math.max(Math.min(popularity, 1), -1);
        var adjustScore = originalScore + boundP; // make sure if orignal score
        // - positive: final score is at least 0
        // - negative: final score is at most 0
        // because we do not want popularity to impact chart's validity

        var fianlScore = originalScore > 0 ? Math.max(adjustScore, 0) : Math.min(adjustScore, 0);
        var label = LOC.getLabel("wave-charts", boundP > 0 ? "popularChart" : "unpopularChart");
        return [this._makeScoreDetail(fianlScore - originalScore, label)];
      }

      return [];
    };

    return PopularityScorer;
  }(Scorer); //


  var ScorerFactory = function ScorerFactory() {};

  ScorerFactory.prototype.getScorer = function getScorer(type) {
    switch (type) {
      case constants$1.SCORER_TYPE.TRELLIS:
        return new TrellisScorer();

      case constants$1.SCORER_TYPE.COLOR:
        return new ColorScorer();

      case constants$1.SCORER_TYPE.AXIS:
        return new AxisScorer();

      case constants$1.SCORER_TYPE.CONTEXT:
        return new ContextScorer();

      case constants$1.SCORER_TYPE.POPULARITY:
        return new PopularityScorer();

      default:
        return new ColorScorer();
    }
  };

  var ScorerFactory$1 = singleton(ScorerFactory); //
  //@flow-ignore

  var COLUMN_TYPE$16 = constants$1.COLUMN_TYPE;
  var COLUMN_TYPE_SEPARATOR = "|";
  var LENGTH = {
    ALL: "all",
    FIRST: "first",
    PREV: "prev",
    LAST: -1
  };
  var CONSTRAINT_TYPE = {
    SECTION: "section",
    ARRAY: "array"
  };
  var DEFAULT_OPTS$1 = {
    useAllNonMeasure: true,
    useAllMeasure: false
  };
  /**
   * Generate recommendations for one constraints set
   *
   * @param  {RowsMetadata} rowsMetadata
   * @param  {Array} constraintsSets, array of constraints
   * @param  {TRecommendOptions} opts options for recommendation
   * @param  {Function} customizer to modify the recommended config
   * @return {Array<Recommendation>}
   */

  function _generate(rowsMetadata, constraints, opts, customizer) {
    if (constraints === void 0) constraints = []; // construct columns map by the type of columns used, so no need to search for columns
    // with right type at each step

    if (!constraints.length) {
      return [];
    }

    var steps = constraints.map(function (constraintStep) {
      return _getStep(constraintStep, opts);
    });
    var configs = []; // each step will keep adding qualified config to configs array

    steps[0]({}, configs, steps.slice(1), rowsMetadata.getColumns(), []);
    return configs.map(function (config) {
      // call customizer
      customizer && customizer(config); // set feature

      var recommendation = new Recommendation(config);

      _setFeature(recommendation, constraints);

      return recommendation;
    });
  }
  /**
   * Set feature on the recommendation
   * @param {[type]} recommendation [description]
   * @param {[type]} constraints    [description]
   */


  function _setFeature(recommendation, constraints) {
    constraints.forEach(function (constraint) {
      var feature = constraint.feature;

      if (!feature) {
        return;
      }

      var type = constraint.type;
      var key = constraint.key;
      var config = recommendation.getConfig();
      var columns = type === CONSTRAINT_TYPE.ARRAY ? lodash__default.flatten(config[key].map(function (section) {
        return section.column;
      })) : config[key].column;
      var features = lodash__default.isArray(feature) ? feature : [feature];
      features.forEach(function (f) {
        if (recommendation.hasFeature(f)) {
          recommendation.setFeature(f, {
            column: recommendation.getFeature(f).column.concat(columns)
          });
        } else {
          recommendation.setFeature(f, {
            column: columns
          });
        }
      });
    });
  }
  /**
   * Returns a function which represents one step in computing qualified config corresponding to a constraint
   * @param  {Object} constraintStep
   */


  function _getStep(constraintStep, opts) {
    var key = constraintStep.key;
    var type = constraintStep.type;
    var columnType = constraintStep.columnType;
    var length = constraintStep.length;
    var properties = constraintStep.properties;
    return function (currentConfig, configs, nextSteps, allColumns, lastUsedColumns) {
      // get all columns specified by constraint's columnType
      // const allColumns = columnsByType[columnType];
      // compute combinations of columns from all columns
      // e.g. allColumns: [a, b, c ]
      // if length is 2, combinations are [ [a,b], [a, c], [b, c] ]
      var columns = _getColumnsByType(columnType, allColumns);

      var columnsCombinations = _getColumnsCombinations(columns, lastUsedColumns, length); // for each combination, assign columns to corresponding config section, and continue to
      // next steps


      columnsCombinations.forEach(function (columns) {
        var config = dataUtils.deepCopy(currentConfig);

        _addToConfig(config, key, type, properties, columns);

        var nextStep = nextSteps[0];

        var restColumns = _withoutCollumns(allColumns, columns);

        if (nextStep) {
          nextStep(config, configs, nextSteps.slice(1), restColumns, columns);
        } else {
          // at the last step
          // - when useAllNonMeasure is true, only add config if
          // all non-measure columns in rowsMetadata are used(unused columns are all
          // measures). This is true by default since our current assumption is all
          // non-measure columns are grouping, when we can deal with duplicate dimension
          // values we don't need this assumption any more.
          // - when useAllMeasure is true, we have to use up all measure columns, this option
          // should be true for Wave, but false for EclairNG itself.
          var useAllNonMeasure = opts.useAllNonMeasure;
          var useAllMeasure = opts.useAllMeasure;
          var validConfig = true;

          if (useAllMeasure && useAllMeasure) {
            validConfig = restColumns.length == 0;
          } else if (useAllMeasure) {
            validConfig = restColumns.every(function (column) {
              return column.getType() !== COLUMN_TYPE$16.MEASURE;
            });
          } else if (useAllNonMeasure) {
            validConfig = restColumns.every(function (column) {
              return column.getType() == COLUMN_TYPE$16.MEASURE;
            });
          }

          if (validConfig) {
            configs.push(config);
          }
        }
      });
    };
  }

  function _withoutCollumns(allColumns, withoutCols) {
    var withoutColNames = withoutCols.map(function (col) {
      return col.getName();
    });
    return allColumns.filter(function (column) {
      return withoutColNames.indexOf(column.getName()) === -1;
    });
  }

  function _addToConfig(config, key, type, properties, columns) {
    if (type === void 0) type = CONSTRAINT_TYPE.SECTION;

    if (type === CONSTRAINT_TYPE.SECTION) {
      config[key] = properties ? dataUtils.deepCopy(properties) : {};
      config[key].column = columns.map(function (column) {
        return column.getName();
      });
    } else if (type === CONSTRAINT_TYPE.ARRAY) {
      config[key] = columns.map(function (column) {
        return lodash__default.extend({}, properties, {
          column: [column.getName()]
        });
      });
    }
  }

  function _getColumnsByType(type, allColumns) {
    if (!type) {
      return [];
    }

    var columns = [];
    var types = type.indexOf(COLUMN_TYPE_SEPARATOR) > -1 ? type.split(COLUMN_TYPE_SEPARATOR) : [type];
    allColumns.forEach(function (column) {
      if (!column.isAllNull() && types.indexOf(column.getType()) > -1) {
        columns.push(column);
      }
    });
    return columns;
  }

  function _getColumnsCombinations(columns, lastUsedColumns, length) {
    if (lodash__default.isArray(length)) {
      //@flow-ignore
      return lodash__default.flatten(length.map(function (l) {
        return __getColumnsCombinations(columns, lastUsedColumns, l);
      }));
    } else {
      return __getColumnsCombinations(columns, lastUsedColumns, length);
    }
  }

  function __getColumnsCombinations(columns, lastUsedColumns, length) {
    var slicedColumns = [];

    if (length === LENGTH.ALL) {
      // all columns
      slicedColumns = [columns];
    } else if (lodash__default.isString(length)) {
      // string length expression
      //@flow-ignore
      if (length.slice(0, LENGTH.FIRST.length) === LENGTH.FIRST) {
        // first few columns
        //@flow-ignore
        var l = parseInt(length.slice(LENGTH.FIRST.length));
        slicedColumns = _sliceColumns(columns, l); //@flow-ignore
      } else if (length.slice(0, LENGTH.PREV.length) === LENGTH.PREV) {
        // previous used columns
        //@flow-ignore
        var l$1 = parseInt(length.slice(LENGTH.PREV.length));
        slicedColumns = l$1 === -1 ? lastUsedColumns.length ? [lastUsedColumns.slice(-1)] : [] : _sliceColumns(lastUsedColumns, l$1);
      }
    } else {
      // n columns
      if (length) {
        //@flow-ignore
        slicedColumns = dataUtils.k_combinations(columns, length);
      } else {
        // zero length should be a valid assignment as well
        slicedColumns = [[]];
      }
    }

    return slicedColumns;
  }

  function _sliceColumns(columns, length) {
    return length >= 0 && length <= columns.length ? [columns.slice(0, length)] : [];
  }
  /**
   * Recommendation generator based on constraints
   *
   * - generate config for recommedation
   * - take a set of constraints, each constraints set is an array of constraint steps, describing how
   * to assign columns to config section. All recommendations generated by each constraints set will be
   * combined together
   * - take a customizer to customize config
   * - can specify feature at each constraint step, the columns picked will be assigned to the feature
   *
   * Usage on each constraint parameter:
   * - key(string): the step is going to add a property in the config object, key will be the property name
   * - columnType(string): type of columns to choose from to assign to the new section
   * - length(number|string|Array<number|string>): how many columns to choose
   *     - number: choose n number of columns out of all columns
   *     - string: "firstN" choose the first N columns, "prevN" choose first N columns from columns used from previous step
   *     - Array: for each element in the array, generate columns assignment combinations and combine them together
   * - type(string):
   *     - section: will add to config object, key: { column: [...]}
   *     - array: will add to config object, key: [{ column: [..]}, { column: [..] }]
   * - feature(string): will add a feature to the recommendation and associate the feature with the columns
   *   in the step
   *
   * Example:
   *
   * const constraintsSets = [
   * 	[
   * 		{ key: "axis", columnType: "dimension|geo", length: 2 },
   * 		{ key: "color", length: "prev-1", feature: "color" },
   * 		{ key: "plot", columnType: "measure", length: "all", type: "array" }
   * 	]
   * ];
   *
   * const rowsMetadata = new RowsMetadata([
   * 	{ column: "dim1", type: "dimension"},
   * 	{ column: "dim2", type: "dimension"},
   * 	{ column: "geo", type: "geo"},
   * 	{ column: "mea1", type: "measure"},
   * 	{ column: "mea2", type: "measure"}
   * ])
   * const recommendations = recommender.generateRecommendations(rowsMetadata, constraintsSets, (config) => {
   * 	config.autoFitMode = "keepLabels";
   * });
   *
   * will generate 3 recommendations:
   * 1)
   * config: { axis: {column: [ "dim1", "dim2"]}, color: {column: ["dim2"], plot: [{ column: ["mea1"]}, { column: ["mea2"]}], autoFitMode: "keepLabels" }
   * features: { color: { column: ["dim2"] } }
   * 2)
   * config: { axis: {column: [ "dim1", "geo"]}, color: {column: ["geo"], plot: [{ column: ["mea1"]}, { column: ["mea2"]}], autoFitMode: "keepLabels" }
   * features: { color: { column: ["geo"] } }
   * 3)
   * config: { axis: {column: [ "dim2", "geo"]}, color: {column: ["geo"], plot: [{ column: ["mea1"]}, { column: ["mea2"]}], autoFitMode: "keepLabels" }
   * features: { color: { column: ["geo"] } }
   *
   * - step1: for section "axis", take all columns which are dimension or geo type, choose 2 of them.
   * - step2: for section "color", take the last column used in previous step, also set feature on recommendation
   * - steo3: for array section "plot", take all columns which are measure, use all of them.
   */

  /**
   * Generate recommendations with configs based on constraints passed in
   *
   * constraintsSets is an array of constrains, will generate recommendations
   * based on each constraints set, and concat them together
   *
   * @param  {RowsMetadata} rowsMetadata
   * @param  {Array} constraintsSets, array of constraints
   * @param  {Function} customizer to modify the recommended config
   * @param  {Boolean} useAllNonMeasureCols, if we have to use all the non-measure columns in rowsMetadata
   *         in order for a config to be valid
   * @return {Array<Recommendation>}
   */


  function generateRecommendations(rowsMetadata, constraintsSets, opts, customizer) {
    lodash__default.defaults(opts, DEFAULT_OPTS$1);
    var recommendations = lodash__default.flatten(constraintsSets.map(function (constraints) {
      return _generate(rowsMetadata, constraints, opts, customizer);
    }));
    return lodash__default.filter(recommendations);
  } //
  //@flow-ignore
  //@flow-ignore


  var DEFAULT_OPTS = {
    maxCardinalityTrellis: 20,
    maxNumColumnsXDimensionAxis: 2,
    maxNumColumnsYDimensionAxis: 3,
    maxNumMeasuresCartesian: 3,
    maxCardinalityCategoricalColor: 10,
    maxCardinalityFlowDiagram: 10
  };
  var DEFAULT_TOP_N = 10;
  var SCORERS = null;

  var Recommender = function Recommender(opts, moduleGetter, geoMaps) {
    if (opts === void 0) opts = {};
    lodash__default.defaults(opts, DEFAULT_OPTS);
    this._didInit = false;
    this._opts = opts;
    this._moduleList = [];
    this._moduleGetter = moduleGetter;
    this._geoMaps = geoMaps;
  };

  Recommender.prototype._init = function _init() {
    if (this._didInit) {
      return es6Promise.Promise.resolve();
    }

    return this._processGeoMaps();
  };
  /**
  	 * pre-load all default maps' geojson
  	 */


  Recommender.prototype._processGeoMaps = function _processGeoMaps() {
    var this$1 = this;
    var mapByGeojson = {}; // only load the maps with unique geoJsons

    this._geoMaps.forEach(function (geoMap) {
      var url = geoMap.getGeoJson() && geoMap.getGeoJson().url;

      if (url && !mapByGeojson[url]) {
        mapByGeojson[url] = geoMap;
      }
    });

    var geoMaps = lodash__default.values(mapByGeojson);
    return es6Promise.Promise.all(geoMaps.map(function (geoMap) {
      return geoMap.load();
    })).then(function () {
      this$1._geoMaps = geoMaps;
    });
  };
  /**
  	 * register candidate modules
  	 * @param  {Array<any>} moduleList list of candidate module names
  	 * @return {this}
  	 */


  Recommender.prototype.registerChartList = function registerChartList(moduleList) {
    this._moduleList = moduleList;
    return this;
  };
  /**
  	 * Recommend chart modules and configs to use
  	 *
  	 * @param  {Array<TRow>} rows of data
  	 * @param  {Array<TColumn>} rowsMetadataJson
  	 * @param  {TRecommendOptions} opts, options to customize recommendation results
  	 * @return {Array<Recommendation>}
  	 */


  Recommender.prototype.recommend = function recommend(rows, rowsMetadataJson, opts) {
    var this$1 = this;
    if (opts === void 0) opts = {};
    return this._init().then(function () {
      var rowsMetadata;

      if (rowsMetadataJson instanceof RowsMetadata) {
        rowsMetadata = rowsMetadataJson;
      } else {
        // Enrich rowsMetadata with cardinality, context information
        rowsMetadata = new RowsMetadata(rowsMetadataJson);
        richRowsMetadataUtils.enrichRowsMetadata(rowsMetadata, rows, this$1._geoMaps);
      }

      return es6Promise.Promise.all(this$1._moduleList.map(function (module) {
        return this$1._recommendForModule(module, rows, rowsMetadata, opts);
      }));
    }).then(function () {
      var recommendationsList = [],
          len = arguments.length;

      while (len--) {
        recommendationsList[len] = arguments[len];
      }

      var recommendations = lodash__default.flatten(recommendationsList[0]); // sort recommendations descending

      return recommendations.sort(function (a, b) {
        return b.getScore() - a.getScore();
      }).slice(0, opts.n || DEFAULT_TOP_N);
    });
  };
  /**
  	 * Recommend configs for a chart module
  	 *
  	 * @param  {string} moduleName
  	 * @param  {Array<TRow>} rows of data
  	 * @param  {RowsMetadata} rowsMetadata
  	 * @param  {TRecommendOptions} opts
  	 * @return {Array<Recommendation>}
  	 */


  Recommender.prototype._recommendForModule = function _recommendForModule(moduleName, rows, rowsMetadata, opts) {
    var this$1 = this;
    return this._getModule(moduleName).then(function (chartModule) {
      var ChartClass = chartModule.default;

      if (ChartClass.getRecommendations && lodash__default.isFunction(ChartClass.getRecommendations)) {
        // Chart generates a list of recommendations
        var recommendationsSafe = ChartClass.getRecommendations(rows, rowsMetadata, opts); // Featurize and score recommendations

        recommendationsSafe.forEach(function (recommendationSafe) {
          recommendationSafe.setModuleName(moduleName);

          this$1._scoreRecommendation(recommendationSafe, ChartClass, rows, rowsMetadata);
        }); // filter out recommendations with negative scores

        return lodash__default.filter(recommendationsSafe, function (recommendation) {
          return recommendation.getScore() > -Infinity;
        });
      } else {
        return [];
      }
    });
  };
  /**
  	 * Calculate scores for a recommendation
  	 *
  	 * @param  {Recommendation} recommendation
  	 * @param  {ChartClass} ChartClass
  	 * @param  {Array<TRow>} rows of data
  	 * @param  {RowsMetadata} rowsMetadata
  	 */


  Recommender.prototype._scoreRecommendation = function _scoreRecommendation(recommendation, ChartClass, rows, rowsMetadata) {
    var this$1 = this;

    var scorers = this._getScorers(); // let the chart module set features


    if (ChartClass.featurize && lodash__default.isFunction(ChartClass.featurize)) {
      ChartClass.featurize(recommendation);
    }

    scorers.forEach(function (scorer) {
      var allScoreDetails = recommendation.getScoreDetails();
      var score = recommendation.getScore() || 0; // generic features

      scorer.featurize(recommendation);
      var scoreDetails = scorer.getScoreDetails(recommendation, rowsMetadata, this$1._opts); // sum up the scores

      if (scoreDetails.length) {
        var s = dataUtils.zip.apply(dataUtils, scoreDetails);
        score += mathUtils.sum(s[0]);
      }

      recommendation.setScoreDetails(allScoreDetails.concat(scoreDetails)).setScore(score);
    });
  };
  /**
  	 * Get all scorers
  	 *
  	 * @return {Array<Scorer>}
  	 */


  Recommender.prototype._getScorers = function _getScorers() {
    if (!SCORERS) {
      var scorerFactory = ScorerFactory$1.getInstance();
      SCORERS = [scorerFactory.getScorer(constants$1.SCORER_TYPE.TRELLIS), scorerFactory.getScorer(constants$1.SCORER_TYPE.COLOR), scorerFactory.getScorer(constants$1.SCORER_TYPE.AXIS), scorerFactory.getScorer(constants$1.SCORER_TYPE.CONTEXT), scorerFactory.getScorer(constants$1.SCORER_TYPE.POPULARITY)];
    }

    return SCORERS;
  };

  Recommender.prototype._getModule = function _getModule(name) {
    return this._moduleGetter(name);
  };

  Recommender.generateRecommendations = generateRecommendations; // chart layouts
  //tooltip
  //rowsMetadata
  // utils
  // recommender

  var VERSION = apiVersion.version;
  ShapeContainer$1.setShapeGroup(ShapeGroup$2); // initialize the sdk with runtime objects

  function init(ref) {
    var Perf = ref.Perf;
    var delegate = ref.delegate;
    var scriptEvaluatorFct = ref.scriptEvaluatorFct;
    SecureDelegate.init({
      delegate: delegate,
      scriptEvaluatorFct: scriptEvaluatorFct
    });
    SecurePerf.init({
      Perf: Perf,
      scriptEvaluatorFct: scriptEvaluatorFct
    });
  }
  /**
   *  EclairNG SDK
   */


  var sdk = {
    VERSION: VERSION,
    Promise: es6Promise.Promise,
    defaultTheme: ThemeFactory.getInstance().getDefaultTheme(),
    log: log$1,
    LOC: LOC,
    IntervalSearchTree: IntervalSearchTree,
    ThemeFactory: ThemeFactory,
    layoutBuilder: layoutBuilder,
    SelectManagerFactory: SelectManagerFactory,
    counter: counter$1,
    singleton: singleton,
    ChartContext: ChartContext,
    runtime: WaveChartsRuntime,
    renderers: {
      AxisTitleCellRenderer: AxisTitleCellRenderer,
      CellRendererFactory: CellRendererFactory
    },
    scene: {
      model: {
        Scene: Scene$2,
        Cell: Cell$2
      },
      effects: {
        ShapeEffectFactory: ShapeEffectFactory,
        DefaultHoverShapeEffect: DefaultHoverShapeEffect,
        CompositeShapeEffect: CompositeShapeEffect,
        DefaultSelectionShapeEffect: DefaultSelectionShapeEffect,
        HaloSelectionShapeEffect: HaloSelectionShapeEffect,
        RadiusScalingSelectionShapeEffect: RadiusScalingSelectionShapeEffect,
        HighlightHoverShapeEffect: HighlightHoverShapeEffect
      }
    },
    shapes: {
      Arc: Arc$3,
      NumberText: NumberText$2,
      Text: Text$1,
      Line: Line$2,
      Path: Path$2,
      Polygon: Polygon,
      Point: Point,
      Rect: Rect$3,
      Layer: Layer,
      ShapeGroup: ShapeGroup$2
    },
    geo: {
      GeoMap: GeoMap
    },
    rowsMetadata: {
      RowsMetadata: RowsMetadata,
      rowsFormatter: RowsFormatter$1.getInstance(),
      rowsMetadataUtils: rowsMetadataUtils,
      richRowsMetadataUtils: richRowsMetadataUtils,
      Column: Column,
      TimeColumn: TimeColumn,
      DimensionColumn: DimensionColumn,
      MeasureColumn: MeasureColumn
    },
    utils: {
      axisUtils: axisUtils,
      Box: Box,
      Padding: Padding,
      configUtils: configUtils,
      constants: constants$1,
      convertConfigUtils: convertConfigUtils$1,
      dataUtils: dataUtils,
      domainUtils: domainUtils,
      envUtils: envUtils,
      columnUtils: columnUtils$1,
      gridUtils: gridUtils,
      layoutUtils: layoutUtils,
      mathUtils: mathUtils,
      percentageUtils: percentageUtils,
      plotUtils: plotUtils,
      rangeUtils: rangeUtils,
      referenceLineUtils: referenceLineUtils,
      rowsUtils: rowsUtils$1,
      scales: scales,
      sceneUtils: sceneUtils,
      trellisUtils: trellisUtils$1,
      valueFctUtils: valueFctUtils,
      tooltipUtils: tooltipUtils
    },
    formatNumber: formatNumber,
    time: time,
    DataFormatter: DataFormatter,
    color: {
      colorUtils: colorUtils,
      LinearGradient: LinearGradient
    },
    chartLayouts: {
      layoutsUtils: layoutsUtils,
      colorLayout: ColorLayoutFactory$1.getInstance(),
      radiusLayout: RadiusLayoutFactory$1.getInstance(),
      axisLayout: AxisLayoutFactory$1.getInstance()
    },
    recommender: {
      Recommender: Recommender
    },
    enums: {
      SortingEnum: SortingEnum
    }
  }; //
  //@flow-ignore
  //@flow-ignore

  /**
   *  Production Module Loader for EclairNG that loads statically compiled
   *  modules.
   *
   *  The compiled modules must be in the defined in the following format:
   *
   *  register("module-name", ["42.0/module-dep1", "42.0/module-dep2"], function (context) {
   *		let dep1 = context["42.0/module-dep1"];
   *    ...
   *  });
   *
   *
   */

  var ModuleLoader = function (AbstractModuleLoade____1) {
    function ModuleLoader() {
      AbstractModuleLoade____1.call(this); // loaded modules

      this._modules = {}; // module definitions

      this._moduleDefinitions = {}; // version of the EclairNG build

      this._buildVersion = "dev"; //@flow-ignore

      this._register = this._register.bind(this);
    }

    if (AbstractModuleLoade____1) ModuleLoader.__proto__ = AbstractModuleLoade____1;
    ModuleLoader.prototype = Object.create(AbstractModuleLoade____1 && AbstractModuleLoade____1.prototype);
    ModuleLoader.prototype.constructor = ModuleLoader;
    /**
     * Configures the module loader
     *
     *
     * @param prefix The prefix to append to relative module urls
     *        The prefix allows us to build an absolute url for the modules
     * @param resourceLoader The loader to use to load urls
     *        The loader is a function that takes a url and returns a Promise
     *        for the module's source
     * @param scriptEvaluator An evaluator to 'eval' the script source code
     *        The scriptEvaluator is a function that can eval source code
     * @param buildVersion the git build version of that will be appended to
     *        urls to avoid caching issues
     */

    ModuleLoader.prototype.configure = function configure(ref) {
      var prefix = ref.prefix;
      var resourceLoader = ref.resourceLoader;
      var scriptEvaluator = ref.scriptEvaluator;
      var buildVersion = ref.buildVersion;
      var isTrusted = ref.isTrusted;
      AbstractModuleLoade____1.prototype.configure.call(this, {
        prefix: prefix,
        resourceLoader: resourceLoader,
        scriptEvaluator: scriptEvaluator,
        isTrusted: isTrusted
      });

      if (buildVersion) {
        this._buildVersion = buildVersion;
      } // if trusted, create modules for the latest version of lodash and the wave-charts-sdk
      // so that they don't need to be fetched and loaded


      if (this.isTrusted()) {
        this._modules[this._getModuleKey("lodash/core", lodash__default.VERSION)] = lodash__default;
        this._modules[this._getModuleKey("es6-promise", packageJson.dependencies['es6-promise'])] = {
          Promise: es6Promise.Promise
        };
        this._modules[this._getModuleKey("wave-charts/sdk", sdk.VERSION)] = sdk;
      }

      return this;
    };

    ModuleLoader.prototype.hasModule = function hasModule(moduleName, moduleVersion) {
      var moduleKey = this._getModuleKey(moduleName, moduleVersion);

      return this._modules[moduleKey] != null;
    };

    ModuleLoader.prototype.require = function require(moduleName, moduleVersion, perf) {
      var this$1 = this;

      var moduleKey = this._getModuleKey(moduleName, moduleVersion);

      this._log(moduleKey, "Module required");

      if (this._pending[moduleKey]) {
        this._log(moduleKey, "Module load already in-flight");

        return this._pending[moduleKey];
      }

      if (this.hasModule(moduleName, moduleVersion)) {
        this._log(moduleKey, "Module already loaded");

        return es6Promise.Promise.resolve(this._modules[moduleKey]);
      }

      var moduleUrl = this._getModuleUrl(moduleName, moduleVersion);

      this._log(moduleKey, "Loading module");

      var moduleInfo = new ModuleInfo(moduleKey, moduleUrl, perf);
      return this._pending[moduleKey] = this._fetch(moduleInfo).then(function () {
        return this$1._instantiate(moduleInfo);
      }).then(function () {
        this$1._log(moduleInfo.key, "Successfully loaded module");

        return this$1._modules[moduleInfo.key];
      }).catch(function (error) {
        console.error("Failed to load module: " + moduleKey);
        console.error("Have you run 'make platform_modules'?");
        throw error;
      }).finally(function () {
        delete this$1._pending[moduleKey];
      });
    };
    /**
     *  Maps a module name to its url
     */


    ModuleLoader.prototype._getModuleUrl = function _getModuleUrl(moduleName, moduleVersion) {
      var url;

      if (moduleName == "lodash/core") {
        url = this._prefix + "/" + moduleName + "/" + moduleVersion + "/index.js";
      } else {
        url = this._prefix + "/runtime-modules/" + moduleName + "/index.bundle.js";
      } // append buildVersion to the url to prevent module caching across builds


      url = url + "?v=" + this._buildVersion;
      return url;
    };
    /**
     * Fetches the module source
     */


    ModuleLoader.prototype._fetch = function _fetch(moduleInfo) {
      if (moduleInfo.source) {
        return;
      }

      var perf = moduleInfo.perf;

      if (perf) {
        perf.mark("moduleLoad");
      } // use Promise.All here to bypass an issue with the mobile Promise implementation


      return es6Promise.Promise.all([this._resourceLoader(moduleInfo.url)]).then(function (values) {
        if (perf) {
          perf.endMark("moduleLoad");
        }

        moduleInfo.source = values[0];
      });
    };
    /**
     * Evaluates and creates a module instance from the module source
     */


    ModuleLoader.prototype._instantiate = function _instantiate(moduleInfo) {
      var perf = moduleInfo.perf; // Run the evaluator on the source.
      // This will create an entry in this._moduleDefinitions for each of the modules
      // defined in the source text.

      if (perf) {
        perf.mark("moduleEval");
      }

      var source = moduleInfo.source;
      var ref = moduleInfo.key.split('/');
      var moduleVersion = ref[0];
      var moduleName = ref[1];

      if (moduleName == "lodash/core") {
        source = "\n\t\t\tregister('" + moduleInfo.key + "', [], function() {\n\t\t\t\tvar exports = {};\n\t\t\t\tvar module = {exports: exports};\n\t\t\t\t" + source + "\n\t\t\t\treturn module.exports;\n\t\t\t});\n\t\t\t";
      }

      this._scriptEvaluator(source, this._register);

      if (perf) {
        perf.endMark("moduleEval");
      } // instantate the module


      return this._instantiateHelper(moduleInfo.key, perf);
    }; // Instantiates a module after resolving all its dependencies
    // Circular dependencies have CommonJS semantics.


    ModuleLoader.prototype._instantiateHelper = function _instantiateHelper(moduleKey, perf) {
      var this$1 = this;
      var moduleDefinition = this._moduleDefinitions[moduleKey];
      moduleDefinition.isInstantiating = true; // first get promises for all the modules' dependencies

      var dependenciesPromises = moduleDefinition.dependencies // circular dependency: filter out the dependency if it is already being instantiated
      .filter(function (dependency) {
        return !this$1._moduleDefinitions[dependency] || !this$1._moduleDefinitions[dependency].isInstantiating;
      }).map(function (dependency) {
        if (this$1._modules[dependency]) {
          // the dependency is already loaded, just return it
          return es6Promise.Promise.resolve(this$1._modules[dependency]);
        } else if (this$1._moduleDefinitions[dependency]) {
          // the dependency has been defined, but not instantiated, instantiate it
          return this$1._instantiateHelper(dependency, perf);
        } else {
          // the dependency needs to be loaded
          var ref = dependency.split('/');
          var moduleVersion = ref[0];
          var moduleName = ref[1];
          return this$1.require(moduleName, moduleVersion, perf);
        }
      }); // once all the module's dependencies are resolved, instantiate it

      return es6Promise.Promise.all(dependenciesPromises).then(function () {
        this$1._modules[moduleKey] = this$1._moduleDefinitions[moduleKey].defineFunction.call(window, this$1._modules);
        var ref = moduleKey.split('/');
        var moduleVersion = ref[0];
        var moduleName = ref[1]; // initialize the wave-charts/sdk with the runtime Delegate, and Perf instance

        if (moduleName == 'wave-charts/sdk') {
          var sd____1 = this$1._modules[moduleKey];
          sd____1.init({
            Perf: Perf,
            delegate: ServiceProvider$1.getDelegate(),
            scriptEvaluatorFct: this$1._scriptEvaluator
          });
          this$1._modules[moduleKey] = sd____1['default'];
        }

        this$1._modules[moduleKey].moduleLoader = this$1;
        delete this$1._moduleDefinitions[moduleKey];
      });
    }; // registers a module's definition


    ModuleLoader.prototype._register = function _register(moduleKey, dependencie____1, defineFunction) {
      this._moduleDefinitions[moduleKey] = {
        dependencies: dependencie____1,
        defineFunction: defineFunction,
        isInstantiating: false
      };
    };

    return ModuleLoader;
  }(AbstractModuleLoader);

  var ModuleInfo = function ModuleInfo(key, url, perf) {
    this.key = key;
    this.url = url;
    this.perf = perf;
    this.source = "";
  }; //
  //@flow-ignore
  //@flow-ignore
  //@flow-ignore
  //@flow-ignore
  // ensure we don't replace the global env's lodash


  lodash__default.noConflict(); // break the Shape / ShapeGroup / HotSpotManager cycle

  Shape.setHotSpotManagerImpl(HotSpotManager); // break NodeFactory / Group cycle

  Group$1.setNodeFactoryImpl(NodeFactory$1.getInstance()); //break NodeModelFactory / GroupModel cycle

  GroupModel.setNodeModelFactoryImpl(NodeModelFactory.getInstance());
  var themeDataFactory = ThemeDataFactory.getInstance();
  var imageCache = ImageCache$1.getInstance(); // ===================================================================================
  // EclairNG - Library instance definition
  // The singleton instance of  EclairNG is constructed and returned by this module.
  //
  // The singleton instance is the API entry point for the engine.
  // ===================================================================================

  var EclairNG = function EclairNG() {
    this.sdk = sdk;
    this.constants = constants$1;
    this._renderChartsIfVisible = this._renderChartsIfVisible.bind(this); // @flow-ignore

    this._protected_renderChart = this._protected_renderChart.bind(this); // binding here since it seemed to be causing some issues on mobile

    this.ready = this.ready.bind(this);
    this.registerDefaultMaps = this.registerDefaultMaps.bind(this);
    this._didInit = false;
    this.log = log$1;
    this._extensions = {};
    this._bundledModulesMap = {};
  }; // ==================================================================================
  // Public API
  // ==================================================================================


  EclairNG.prototype.registerDefaultMaps = function registerDefaultMaps(config) {
    if (config == null) {
      config = {};
    }

    this._defaultMaps = EclairNGBootstrap.registerDefaultMaps(this, config);
    return this._defaultMaps;
  };

  EclairNG.prototype.registerImageValidator = function registerImageValidator(imageValidator) {
    imageCache.setImageValidator(imageValidator);
    return this;
  };

  EclairNG.prototype.registerSchemaValidator = function registerSchemaValidator(schemaValidator) {
    this._schemaValidator = schemaValidator;
    return this;
  };

  EclairNG.prototype.registerModule = function registerModule(module) {
    this._bundledModulesMap[module.getMetadata().moduleName] = module;
  };

  EclairNG.prototype.configureModuleLoader = function configureModuleLoader(ref) {
    var prefix = ref.prefix;
    var resourceLoader = ref.resourceLoader;
    var scriptEvaluator = ref.scriptEvaluator; // for now

    var secureScriptEvaluator = scriptEvaluator;
    this._moduleLoader = new ModuleLoader().configure({
      isTrusted: true,
      prefix: prefix,
      resourceLoader: resourceLoader,
      scriptEvaluator: scriptEvaluator,
      buildVersion: BUILD.commit
    });
    this._customModuleLoader = new ModuleLoader().configure({
      isTrusted: false,
      prefix: prefix,
      resourceLoader: resourceLoader,
      scriptEvaluator: secureScriptEvaluator,
      buildVersion: BUILD.commit
    });
    return this;
  };

  EclairNG.prototype.chart = function chart(chartConfig) {
    chartConfig = chartConfig || {
      name: null,
      size: null,
      renderOnDemand: true,
      rendererConfig: null,
      durations: null,
      padding: null
    };

    this._init();

    return new Chart$1(chartConfig, this._chartCache, this._tooltip, this._protected_renderChart);
  };

  EclairNG.prototype.ready = function ready(callback) {
    if (!this._readyPromise) {
      this._readyPromise = es6Promise.Promise.resolve().then(ServiceProvider$1.getDelegate().ready);
    }

    init({
      Perf: Perf,
      delegate: ServiceProvider$1.getDelegate()
    });
    return this._readyPromise.then(callback);
  };

  EclairNG.prototype.setLabels = function setLabels(labels) {
    LOC.setCustomLabels(labels);
    return this;
  };

  EclairNG.prototype.setLocale = function setLocale(locale) {
    luxon.Settings.defaultLocale = locale;
    return this;
  };

  EclairNG.prototype.registerMap = function registerMap(params) {
    return params.zoomable ? new ZoomableGeoMap(params) : new GeoMap(params);
  };

  EclairNG.prototype.unregisterMap = function unregisterMap(name) {
    return GeoMap.delete(name);
  };

  EclairNG.prototype.getMaps = function getMaps() {
    return GeoMap.getMaps();
  };

  EclairNG.prototype.getMap = function getMap(mapName) {
    return lodash__default.find(this.getMaps(), function (map) {
      return map.name == mapName;
    });
  };

  EclairNG.prototype.getDefaultMaps = function getDefaultMaps() {
    return this._defaultMaps;
  };

  EclairNG.prototype.registerTheme = function registerTheme(params) {
    themeDataFactory.registerData(params);
    return this;
  };

  EclairNG.prototype.getAllThemeNames = function getAllThemeNames() {
    return themeDataFactory.getAllThemeNames();
  };

  EclairNG.prototype.getThemeByName = function getThemeByName(name) {
    return themeDataFactory.fetchByName(name);
  };

  EclairNG.prototype.getAllChartNames = function getAllChartNames() {
    return (this._chartCache != null ? this._chartCache.keys() : undefined) || [];
  };

  EclairNG.prototype.getChartByName = function getChartByName(name) {
    return this._chartCache != null ? this._chartCache.get(name) : undefined;
  };

  EclairNG.prototype.getSdk = function getSdk() {
    return this.sdk;
  };

  EclairNG.prototype.setDelegate = function setDelegate(delegate) {
    if (this._readyPromise) {
      throw "Can't set delegate after ready() has been called";
    }

    ServiceProvider$1.setDelegate(delegate);
  }; // ==================================================================================
  //  Private API
  // ==================================================================================
  // ===================================================================================
  // Text cache helpers
  // ===================================================================================


  EclairNG.prototype.resetTextCache = function resetTextCache() {
    return textUtils.getInstance().reset();
  }; // ===================================================================================
  // Get a Wave Charts Module
  // @param moduleName the name of the module to retrieve
  // @return the module instance
  // ===================================================================================


  EclairNG.prototype.getModule = function getModule(moduleName, moduleVersion, perf) {
    var this$1 = this;
    if (moduleVersion === void 0) moduleVersion = apiVersion.version;

    this._init();

    return this.ready().then(function () {
      var bundledModulesMap = this$1._bundledModulesMap;
      var bundledModule = bundledModulesMap[moduleName];

      if (moduleVersion === apiVersion.version) {
        bundledModule = bundledModulesMap[moduleName];
      }

      if (bundledModule != null) {
        return es6Promise.Promise.resolve(bundledModule);
      } else {
        var moduleLoader = this$1._getModuleLoader(moduleName, moduleVersion);

        return moduleLoader.require(moduleName, moduleVersion, perf);
      }
    });
  };

  EclairNG.prototype._getModuleLoader = function _getModuleLoader(moduleName, moduleVersion) {
    var isTrusted = moduleName.indexOf('wave-') == 0 || moduleName.indexOf('lightning-') == 0 || moduleName.indexOf('sfdc-') == 0;
    return isTrusted ? this._moduleLoader : this._customModuleLoader;
  };

  EclairNG.prototype.getRecommender = function getRecommender(opts) {
    return new Recommender(opts, this.getModule.bind(this), this._defaultMaps);
  }; // ==================================================================================
  //  Helpers
  // ==================================================================================
  // ===================================================================================
  // On demand rendering of charts
  // we are going to constantly monitor whether the current charts are visible
  // and render them if they moved into the viewport
  // ===================================================================================


  EclairNG.prototype._renderChartsIfVisible = function _renderChartsIfVisible() {
    this._chartCache.values().forEach(function (chart) {
      if (chart.hasSkippedRender() && chart.isInViewport()) {
        chart.forceRender();
      }
    });
  };

  EclairNG.prototype._setupOnDemandRendering = function _setupOnDemandRendering() {
    var this$1 = this; // The result of a setInterval(_renderChartsIfVisible)
    // We are keeping this as a variable so we can cancel
    // this if no chart is visible

    var onDemandRenderInterval = undefined;

    this._chartCache.on("addFirst", function () {
      if (log$1.rendering) {
        console.debug("enabling on demand monitoring");
      }

      onDemandRenderInterval = setInterval(this$1._renderChartsIfVisible, constants$1.ANIM_DURATION.ONDEMAND_RENDER);

      if (log$1.rendering) {
        console.debug("enabling tooltip events");
      }

      this$1._tooltip.addGlobalEventListeners();
    });

    this._chartCache.on("removeLast", function () {
      if (log$1.rendering) {
        console.debug("removing on demand monitoring");
      }

      clearInterval(onDemandRenderInterval);
      onDemandRenderInterval = undefined;

      if (log$1.rendering) {
        console.debug("removing tooltip events");
      }

      this$1._tooltip.removeGlobalEventListeners();
    });
  }; // ===================================================================================
  // Renders the chart implemented by the specified module
  // -- This should only be called in other files within the engine. --
  // @param moduleName {String} name of a registered module that implements a chart
  // @param config {Object} the chart config
  // @param rows {Object} the data rows
  // @param rowsMetadata {RowsMetadata} rowsMetadata
  // @param perf {Object} the perf transaction object
  // @return a Promise which will get resolved with a {Scene}
  // ===================================================================================


  EclairNG.prototype._protected_renderChart = function _protected_renderChart(params) {
    var this$1 = this;
    var moduleName = params.moduleName;
    var moduleVersion = params.moduleVersion;
    var config = params.config;
    var rows = params.rows;
    var rowsMetadata = params.rowsMetadata;
    var perf = params.perf;
    var props = params.props;
    var delegate = params.delegate;
    var context = params.context;
    var runtimeChart = params.runtimeChart;

    this._init();

    if (perf != null) {
      perf.mark("moduleImport");
    }

    moduleVersion = moduleVersion || apiVersion.version;
    return this.getModule(moduleName, moduleVersion, perf).then(function (module) {
      if (perf != null) {
        perf.endMark("moduleImport");
      }

      if (log$1.scripts) {
        console.info("EclairNG:: running chart script " + moduleName + " with args", config, rows, rowsMetadata);
      }

      this$1._validateConfig(module, config);

      return this$1._chartModuleRunner.renderChart({
        module: module,
        config: config,
        rows: rows,
        rowsMetadata: rowsMetadata,
        props: props,
        delegate: delegate,
        context: context,
        runtimeChart: runtimeChart
      });
    });
  };

  EclairNG.prototype._validateConfig = function _validateConfig(module, config) {
    if (this._schemaValidator) {
      var schema = module.getMetadata().schema;

      if (schema) {
        var configToValidate = dataUtils.deepCopy(config);
        delete configToValidate.size;
        delete configToValidate.padding;

        var errors = this._schemaValidator.validate(schema, configToValidate);

        if (errors.length > 0) {
          console.log("Schema Validation Errors:");
          console.log(errors);
          throw "Schema validation failed";
        }
      }
    }
  };

  EclairNG.prototype._init = function _init() {
    if (this._didInit) {
      return;
    }

    this._didInit = true;
    this._chartCache = new Cache("ChartCache"); // too bad we can't take advantage of flow's generics here...

    this._chartModuleRunner = new ChartModuleRunner();

    if (envUtils.inBrowser()) {
      this._setupOnDemandRendering();

      return this._tooltip = new Tooltip();
    }
  }; // TODO alice temporarily expose this util for Wave mobile to merge data from shapes on multi metrics(combo)
  // chart for combined tooltip:
  //     EclairNG._mergeRows(shape1.data, shape2.data)


  EclairNG.prototype._mergeRows = function _mergeRows() {
    var rows = [],
        len = arguments.length;

    while (len--) {
      rows[len] = arguments[len];
    }

    return lodash__default.extend.apply(lodash__default, [{}].concat(rows));
  };

  var WaveCharts$1 = new EclairNG(); //

  /**
   * Public API for WaveCharts Library
   */

  var WaveCharts = function WaveCharts() {};

  WaveCharts.prototype.chart = function chart(ref) {
    var name = ref.name;
    var size = ref.size;
    var renderOnDemand = ref.renderOnDemand;
    var rendererConfig = ref.rendererConfig;
    var durations = ref.durations;
    var padding = ref.padding;
    return new Chart(WaveCharts$1.chart({
      name: name,
      size: size,
      renderOnDemand: renderOnDemand,
      rendererConfig: rendererConfig,
      durations: durations,
      padding: padding
    }));
  };
  /**
  	 * Promise that resolves when the libary is initialized and ready for usage
  	 *
  	 * @example
  	 * WaveCharts.ready().then(() => {
  	 *   console.log("WaveCharts is ready for usage");
  	 * });
  	 */


  WaveCharts.prototype.ready = function ready() {
    var this$1 = this;
    return WaveCharts$1.ready().then(function () {
      return this$1;
    });
  };
  /**
  	 * Configures the runtime module loader. The runtime module loader is used to
  	 * dynamically load chart modules at runtime.
  	 *
  	 * @param {Object} options
  	 * @param {string} options.prefix prefix relative to the url to specify where the
  	 *runtime module files are located
  	 * @param {Function} options.resourceLoader a function
  	 *that given a url will return the text response of the request wrapped in a Promise
  	 *
  	 * @example
  	 * const chart = WaveCharts.configureModuleLoader({
  	 *   prefix: "../node_modules/wave-charts/runtime-modules",
  	 *   resourceLoader: url => Ajax.get(url)
  	 * });
  	 */


  WaveCharts.prototype.configureModuleLoader = function configureModuleLoader(ref) {
    var prefix = ref.prefix;
    var resourceLoader = ref.resourceLoader;
    var scriptEvaluator = ref.scriptEvaluator;
    WaveCharts$1.configureModuleLoader({
      prefix: prefix,
      resourceLoader: resourceLoader,
      scriptEvaluator: scriptEvaluator
    });
    return this;
  };
  /**
  	 * Registers a theme. A theme lets you configure the color
  	 * scheme used by charts.
  	 *
  	 * @param name the name of the theme
  	 * @param data a json object with the theme data
  	 *
  	 * @example
  	 *  import WaveTheme from 'wave-charts/themes/WaveTheme.json';
  	 *
  	 *const chart = WaveCharts.registerTheme("wave", WaveTheme);
  	 */


  WaveCharts.prototype.registerTheme = function registerTheme(name, data) {
    WaveCharts$1.registerTheme({
      name: name,
      data: data
    });
    return this;
  };
  /**
  	 * Specify labels used by the wave-charts library and modules. The labels specified are
  	 * merged with the default system labels and with any other labels registered with this api.
  	 * Labels should be namespaced with their respective npm module or equivalent to avoid collisions.
  	 *
  	 * @param labelMap of labelName -> labelValue grouped by sections
  	 *
  	 * @example
  	 *WaveCharts.setLabels({
  	 *	"wave-charts": {
  	 *		"noData": "Nothing to show here",
  	 *		},
  	 *	"some-other-module": {
  	 *		"someKey": "someValue"
  	 *	}
  	 *});
  	 */


  WaveCharts.prototype.setLabels = function setLabels(labelMap) {
    WaveCharts$1.setLabels(labelMap);
    return this;
  };
  /**
  	 * Set a BCP 47 locale for internationalization
  	 *
  	 * @example
  	 * WaveCharts.setLocale("fr");
  	 */


  WaveCharts.prototype.setLocale = function setLocale(locale) {
    WaveCharts$1.setLocale(locale);
    return this;
  };
  /**
  	 * Used to access WaveCharts functionality that has not yet been released
  	 * as part of the public api.
  	 *
  	 * @private
  	 */


  WaveCharts.prototype.__getPrivateApi = function __getPrivateApi() {
    return WaveCharts$1;
  };

  var instance = new WaveCharts();
  window.EclairNG = instance;
  return instance;
}(lodash, luxon, lodash_debounce, es6_promise, perfect_scrollbar);

module.exports = EclairNG;